var B3 = Object.defineProperty;
var O3 = (r, t, n) => t in r ? B3(r, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[t] = n;
var Le = (r, t, n) => (O3(r, typeof t != "symbol" ? t + "" : t, n), n);
import { colors as v } from "@mqd/volt-toolbox";
import { colors as Hh } from "@mqd/volt-toolbox";
import e, { PureComponent as N, isValidElement as a0, useState as z, forwardRef as zt, useEffect as ee, useRef as xe, useImperativeHandle as S3, Component as j1, useMemo as Y, Fragment as Wt, createContext as jt, useContext as Xt, memo as Yt, useCallback as E1, useReducer as I3, useLayoutEffect as P0 } from "react";
import i from "prop-types";
import P3 from "react-dom";
import { isEmpty as Qt, isNil as Ze, map as N3, pick as R3, includes as T3, reject as U3, equals as o1, has as r0, differenceWith as N0, symmetricDifference as R0, difference as G3, slice as z3, is as W3 } from "ramda";
const j3 = "_container_1qwwt_10", X3 = "_sections_1qwwt_17", Y3 = "_section_1qwwt_17", Q3 = "_sectionTitle_1qwwt_25", K3 = "_isExpanded_1qwwt_37", J3 = "_text_1qwwt_45", q3 = "_hideContent_1qwwt_49", $3 = "_caret_1qwwt_53", _3 = "_sectionContent_1qwwt_72", ea = "_isColumn_1qwwt_89", Ce = {
  container: j3,
  sections: X3,
  section: Y3,
  sectionTitle: Q3,
  isExpanded: K3,
  text: J3,
  hideContent: q3,
  caret: $3,
  sectionContent: _3,
  isColumn: ea
};
function M(...r) {
  try {
    return r.map((n) => {
      if ([null, void 0, ""].includes(n))
        return null;
      if (n && typeof n == "string")
        return n;
      if (typeof n == "object" && !(n instanceof Array))
        return Object.keys(n).filter((l) => n[l]).join(" ");
    }).filter((n) => n).join(" ");
  } catch (t) {
    console.error(`ERROR: classUtil error: ${t}`);
  }
}
class T0 extends N {
  constructor(t) {
    super(t), this.state = this.initializeState(t), this.toggleSectionExpansion = this.toggleSectionExpansion.bind(this);
  }
  getSnapshotBeforeUpdate(t) {
    var n, a;
    return {
      propsChanged: ((n = t.sections[0]) == null ? void 0 : n.key) !== ((a = this.props.sections[0]) == null ? void 0 : a.key)
    };
  }
  /**
   * When Accordion is re-rendered with same state but with different props,
   * there is a need to reset the sections collapsed/expanded state.
   * If a props.resetSectionsState is passed and sections changed and
   * this.state is the same - let's reset the sections state
   */
  shouldResetSectionsState(t) {
    return this.props.resetSectionsState && t.propsChanged;
  }
  componentDidUpdate(t, n, a) {
    if (this.shouldResetSectionsState(a)) {
      this.setState(this.initializeState(this.props));
      return;
    }
    this.props.sections.filter((o, s) => {
      const d = t.sections[s];
      return d ? d.expand !== o.expand : o.expand;
    }).forEach((o) => {
      this.toggleSectionExpansion(o.key, o.title);
    });
  }
  initializeState(t) {
    return {
      // Capture the section identifiers for sections expanded by default
      expandedSections: t.sections.reduce(
        (n, a, l) => {
          const { defaultExpanded: o, key: s, title: d } = a, c = t.sections.length - 1 === l, m = t.expandLast && c;
          if (o || m) {
            const h = s || d;
            n.push(h);
          }
          return n;
        },
        []
      )
    };
  }
  // If a section has a defined key, we'll use that to track its expansion state
  // Otherwise, the title will be used, which is less reliable as a section's
  // title may change. Intentionally not using a section's index since that may
  // change, which may cause two different sections to both be in opposite
  // expansion states (versus using a title, in which case, only one section's
  // expansion state would become out of sync if its title changed)
  toggleSectionExpansion(t, n, a) {
    const { expandedSections: l } = this.state, o = t || n;
    if (l.includes(o)) {
      const s = ({ expandedSections: d }) => ({
        expandedSections: d.filter(
          (c) => c !== o
        )
      });
      a ? a({ sectionIsExpanded: !1 }) : this.setState(s);
      return;
    }
    a ? a({ sectionIsExpanded: !0 }) : this.setState(({ expandedSections: s }) => ({
      expandedSections: [...s, o]
    }));
  }
  renderSections() {
    const { sections: t = [] } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: Ce.sections }, t.map((n, a) => this.renderSection(n, a)));
  }
  renderSection(t, n) {
    const { expandedSections: a } = this.state, {
      content: l = [],
      iconType: o = "",
      hideContent: s,
      key: d,
      onToggleExpansion: c,
      title: m = "",
      titleBold: h,
      titleColor: p,
      overrideDivider: u
    } = t, { spaceBetween: C, divideSections: E } = this.props, g = d || m, L = a.includes(g) ? Ce.isExpanded : null;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: Ce.section,
        key: d || n,
        style: { marginBottom: C }
      },
      this.renderSectionTitle({
        title: m,
        iconType: o,
        hideContent: s,
        isExpanded: L,
        key: d,
        onToggleExpansion: c,
        titleColor: p,
        titleBold: h
      }),
      this.renderSectionContent(l, L, s),
      E && !u && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement(C9, null))
    );
  }
  renderSectionTitle({
    iconType: t,
    hideContent: n,
    isExpanded: a,
    key: l,
    onToggleExpansion: o,
    title: s
  }) {
    const { iconPosition: d } = this.props, c = M(Ce.sectionTitle, a, {
      [Ce.hideContent]: n
    });
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: c,
        onClick: () => this.toggleSectionExpansion(l, s, o)
      },
      d === "left" ? /* @__PURE__ */ e.createElement(e.Fragment, null, n ? /* @__PURE__ */ e.createElement(B, { factor: 2 }) : /* @__PURE__ */ e.createElement("div", { className: `${Ce.caret} ${a}` }, /* @__PURE__ */ e.createElement(V, { type: "caret-right", factor: 0.8333 })), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement("div", { className: Ce.text }, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", alignItems: "center" }, t ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: t, noHoverEffects: !0 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 })) : null, a0(s) ? s : /* @__PURE__ */ e.createElement(y, null, s)))) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: Ce.text }, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", alignItems: "center" }, t ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: t, noHoverEffects: !0 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 })) : null, a0(s) ? s : /* @__PURE__ */ e.createElement(y, null, s))), n ? /* @__PURE__ */ e.createElement(B, { factor: 2 }) : /* @__PURE__ */ e.createElement("div", { className: `${Ce.caret} ${a}` }, /* @__PURE__ */ e.createElement(V, { type: "caret-right", factor: 0.5 })))
    );
  }
  renderSectionContent(t, n, a) {
    if (!n || a)
      return null;
    const { contentInset: l, isColumn: o } = this.props;
    let s = {};
    l && (s = { marginLeft: l });
    const d = M(Ce.sectionContent, n, {
      [Ce.isColumn]: o
    });
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: s,
        className: d,
        "data-testid": n ? "expanded-content" : "hidden-content"
      },
      t
    );
  }
  render() {
    const { width: t, testId: n, id: a } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: Ce.container,
        style: { width: t },
        "data-testid": n,
        key: a,
        id: a
      },
      this.renderSections()
    );
  }
}
T0.propTypes = {
  sections: i.arrayOf(i.object).isRequired,
  onToggleExpansion: i.func,
  width: i.string,
  spaceBetween: i.any,
  contentInset: i.any,
  testId: i.string,
  iconPosition: i.string,
  divideSections: i.bool,
  isColumn: i.bool,
  id: i.string,
  expandLast: i.bool,
  // in case we need to reset expanded sections after re-render
  resetSectionsState: i.bool
};
T0.defaultProps = {
  sections: [],
  width: null,
  spaceBetween: "28px",
  contentInset: null,
  testId: "volt-accordion",
  iconPosition: "left",
  divideSections: !1,
  isColumn: !1,
  expandLast: !1,
  resetSectionsState: !1
};
function Kt({ cardType: r, onClick: t, icon: n, testId: a }) {
  return (
    // TODO: replace Link with Button when the ticket below is done
    //  https://marqeta.atlassian.net/browse/VOLTENG-45
    /* @__PURE__ */ e.createElement(Ne, { testId: a, onClick: t, inheritParentFont: !0 }, /* @__PURE__ */ e.createElement(V, { overrideColor: v.actionColor, type: n, noHoverEffects: !0 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, `Add ${r}`))
  );
}
Kt.propTypes = {
  cardType: i.string.isRequired,
  onClick: i.func,
  icon: i.string,
  testId: i.string
};
Kt.defaultProps = {
  icon: "plus",
  onClick: null,
  testId: null
};
const Se = {
  EDIT: "EDIT",
  PREVIEW: "PREVIEW"
};
function Jt({
  datum: r,
  previewTemplate: t,
  editTemplate: n,
  defaultMode: a
}) {
  const [l, o] = z(a), s = () => o(Se.EDIT), d = () => o(Se.PREVIEW);
  return l === Se.PREVIEW ? /* @__PURE__ */ e.createElement(t, { datum: r, switchToEdit: s, mode: l }) : /* @__PURE__ */ e.createElement(n, { datum: r, switchToPreview: d, mode: l });
}
Jt.propTypes = {
  previewTemplate: i.func.isRequired,
  editTemplate: i.func.isRequired,
  defaultMode: i.oneOf(Object.values(Se)),
  datum: i.any
};
Jt.defaultProps = {
  defaultMode: Se.PREVIEW
};
const ta = "_card_10ipp_1", na = "_edit_10ipp_18", aa = "_preview_10ipp_24", ra = "_fixedWidth_10ipp_29", M1 = {
  card: ta,
  edit: na,
  preview: aa,
  fixedWidth: ra
};
function ia({ mode: r, dynamicWidth: t, testId: n, ...a }, l) {
  const o = M(M1.card, {
    [M1.edit]: r === Se.EDIT,
    [M1.preview]: r === Se.PREVIEW,
    [M1.fixedWidth]: !t
  });
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: l,
      role: "button",
      tabIndex: 0,
      className: o,
      "data-testid": n,
      ...a
    }
  );
}
const X1 = zt(ia);
X1.propTypes = {
  mode: i.oneOf(Object.values(Se)).isRequired,
  // TODO: replace with the `fixedWidth` property
  dynamicWidth: i.bool,
  testId: i.string
};
X1.defaultProps = {
  dynamicWidth: !1,
  testId: null
};
X1.displayName = "TemplateWrapper";
const fh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddButton: Kt,
  Card: Jt,
  MODE: Se,
  TemplateWrapper: X1
}, Symbol.toStringTag, { value: "Module" })), qt = {
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  Escape: "Escape",
  Space: " ",
  Tab: "Tab"
}, W = {
  button: "volt-button",
  checkbox: "volt-checkbox",
  dayControl: "volt-day-control",
  input: "volt-input",
  multiselect: "volt-multiselect",
  radio: "volt-radio",
  select: "volt-select",
  textarea: "volt-textarea",
  toggle: "volt-toggle"
}, O1 = {
  error: {
    color: v.statusErrorColor,
    icon: "clear"
  },
  pending: {
    color: v.statusPendingColor,
    icon: "clock"
  },
  success: {
    color: v.statusSuccessColor,
    icon: "confirmed"
  },
  warning: {
    color: v.statusWarningColor,
    icon: "infoUpsideDown"
  },
  draft: {
    color: v.statusDraftColor,
    icon: "doc"
  }
}, U0 = 50, $t = `
  a:not([disabled]),
  a[href]:not([disabled]),
  button:not([disabled]),
  textarea:not([disabled]),
  input[type="text"]:not([disabled]),
  input[type="radio"]:not([disabled]),
  input[type="checkbox"]:not([disabled]),
  input[type="password"]:not([disabled]),
  input[type="date"]:not([disabled]),
  input[type="datetime-local"]:not([disabled]),
  select:not([disabled])
`;
function la(r) {
  const [t, n] = z([null, null]);
  return ee(() => {
    if (r.current) {
      const a = r.current.querySelectorAll($t);
      n([a[0], a[a.length - 1]]);
    }
  }, [r.current]), t;
}
const i0 = (r) => r && r.outerHTML === document.activeElement.outerHTML, Y1 = zt(({ children: r, ...t }, n) => {
  const a = xe();
  S3(n, () => a.current);
  const l = la(a), o = (s) => {
    if (s.key !== qt.Tab)
      return;
    const [d, c] = l;
    s.shiftKey ? i0(d) && (c.focus(), s.preventDefault()) : i0(c) && (d.focus(), s.preventDefault());
  };
  return ee(() => (a.current.addEventListener("keydown", o), () => a.current.removeEventListener("keydown", o)), [a, l]), /* @__PURE__ */ e.createElement("div", { tabIndex: 0, ref: a, ...t }, r);
});
Y1.displayName = "FocusTrap";
class b1 extends N {
  constructor(t) {
    super(t), typeof document < "u" && (this.portalRoot = document.body, this.portalElement = document.createElement("div"));
  }
  componentDidMount() {
    this.portalRoot.appendChild(this.portalElement);
  }
  componentWillUnmount() {
    this.portalRoot.removeChild(this.portalElement);
  }
  render() {
    const { children: t } = this.props;
    return this.portalRoot ? P3.createPortal(t, this.portalElement) : null;
  }
}
function G0(r, t, n = z0) {
  for (const a in r)
    if (n(r, t, a))
      return !1;
  return !0;
}
const z0 = (r, t, n) => r[n] !== t[n];
function oa(r, t, n) {
  if (n === "children") {
    const a = e.Children.toArray(r[n]), l = e.Children.toArray(t[n]);
    if (a.length !== l.length)
      return !0;
    for (const o in a) {
      const s = a[o], d = l[o];
      if (s !== d)
        return !0;
    }
    return !1;
  } else
    return z0(r, t, n);
}
function _t(r) {
  const t = this.props;
  return !G0(t, r, oa);
}
const sa = "_text_1jf6l_2", da = "_inline_1jf6l_10", ca = "_h1_1jf6l_17", ma = "_h2_1jf6l_18", ha = "_h3_1jf6l_19", pa = "_h4_1jf6l_20", ua = "_splash_1jf6l_21", Ca = "_xlg_1jf6l_22", ga = "_lg_1jf6l_23", fa = "_med_1jf6l_24", Ea = "_h5_1jf6l_58", La = "_heading_1jf6l_59", wa = "_h6_1jf6l_66", va = "_p_1jf6l_74", ya = "_body_1jf6l_75", ba = "_sm_1jf6l_87", Aa = "_small_1jf6l_88", Ha = "_footnote_1jf6l_89", xa = "_pre_1jf6l_90", Ma = "_label_1jf6l_96", Va = "_code_1jf6l_106", Da = "_active_1jf6l_134", Fa = "_disabled_1jf6l_141", ka = "_error_1jf6l_145", Za = "_success_1jf6l_149", Ba = "_transparent_1jf6l_153", Oa = "_link_1jf6l_157", V1 = {
  text: sa,
  inline: da,
  h1: ca,
  h2: ma,
  h3: ha,
  h4: pa,
  splash: ua,
  xlg: Ca,
  lg: ga,
  med: fa,
  h5: Ea,
  heading: La,
  h6: wa,
  "p-lg": "_p-lg_1jf6l_74",
  "body-lg": "_body-lg_1jf6l_75",
  p: va,
  body: ya,
  "body-sm": "_body-sm_1jf6l_82",
  sm: ba,
  small: Aa,
  footnote: Ha,
  pre: xa,
  label: Ma,
  code: Va,
  active: Da,
  disabled: Fa,
  error: ka,
  success: Za,
  transparent: Ba,
  link: Oa
};
class e2 extends j1 {
  constructor(t) {
    super(t), this.validateV3Props, this.shouldComponentUpdate = _t.bind(this);
  }
  get invalidV3Type() {
    const { type: t } = this.props;
    return t && ![
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "body-lg",
      "body-sm",
      "label",
      "footnote",
      "code",
      "pre"
    ].includes(t) ? t : !1;
  }
  get validateV3Props() {
    const { mod: t, type: n } = this.props;
    this.invalidV3Type && console.warn(`WARNING: Text component type ${this.invalidV3Type} is deprecated.`), t && console.warn(
      "WARNING: the mods props will be deprecated; please avoid usage (try color props instead)."
    );
  }
  get classNames() {
    const { type: t, mod: n, inline: a, className: l } = this.props, o = n.split(" ").map((s) => V1[s.trim()]).join(" ");
    return M(V1.text, V1[t] || "", o, { [V1.inline]: a }, l);
  }
  generateLabelContent(t, n, a) {
    return n ? /* @__PURE__ */ e.createElement("label", { htmlFor: n }, t) : a ? /* @__PURE__ */ e.createElement("span", { "aria-labelledby": a }, t) : t;
  }
  render() {
    const {
      children: t,
      type: n,
      onClick: a,
      testId: l,
      labelFor: o,
      labelledBy: s,
      color: d,
      id: c,
      ariaLevel: m,
      role: h,
      inline: p
    } = this.props, u = {
      className: this.classNames,
      "data-testid": l,
      onClick: a,
      role: h,
      "aria-level": m
    };
    d && (u.style = { color: d }), c && (u.id = c);
    const C = this.generateLabelContent(t, o, s);
    switch (!0) {
      case ["h1", "splash"].includes(n):
        return /* @__PURE__ */ e.createElement("h1", { ...u }, C);
      case ["h2", "xlg"].includes(n):
        return /* @__PURE__ */ e.createElement("h2", { ...u }, C);
      case ["h3", "lg"].includes(n):
        return /* @__PURE__ */ e.createElement("h3", { ...u }, C);
      case ["h4", "med"].includes(n):
        return /* @__PURE__ */ e.createElement("h4", { ...u }, C);
      case ["h5", "heading"].includes(n):
        return /* @__PURE__ */ e.createElement("h5", { ...u }, C);
      case ["h6"].includes(n):
        return /* @__PURE__ */ e.createElement("h6", { ...u }, C);
      case ["body-lg", "p-lg"].includes(n):
        return /* @__PURE__ */ e.createElement("p", { ...u }, C);
      case ["body-sm", "body", "p"].includes(n):
        return /* @__PURE__ */ e.createElement("p", { ...u }, C);
      case (["code"].includes(n) && p):
        return /* @__PURE__ */ e.createElement("code", { ...u }, C);
      case ["pre"].includes(n):
        return /* @__PURE__ */ e.createElement("pre", { ...u }, C);
      case ["code", "label", "footnote", "sm", "small"].includes(n):
        return /* @__PURE__ */ e.createElement("div", { ...u }, C);
      default:
        return process.env.NODE_ENV === "development" && console.warn("WARNING: you are using a type which is not defined."), /* @__PURE__ */ e.createElement("div", { ...u }, t);
    }
  }
}
e2.propTypes = {
  ariaLevel: i.number,
  className: i.string,
  color: i.string,
  id: i.string,
  inline: i.bool,
  labelFor: i.string,
  // If you must modify Text please try to leverage color only!
  // mod will soon be deprecated. It is still minimally supported but STRONGLY discouraged.
  role: i.string,
  mod: i.string,
  testId: i.string,
  type: i.string
};
e2.defaultProps = {
  ariaLevel: null,
  className: "",
  color: "",
  id: "",
  inline: !1,
  labelFor: null,
  role: null,
  mod: "",
  testId: "volt-text",
  type: "body-sm"
};
const y = e2, l0 = (r) => {
  if (r && r.current && typeof r.current.getBoundingClientRect == "function")
    return r.current.getBoundingClientRect();
}, Sa = (r, t) => {
  switch (r) {
    case "top":
    case "bottom":
      return -(t / 2);
    case "topLeft":
    case "bottomLeft":
      return -t;
    case "topRight":
    case "bottomRight":
      return 0;
    default:
      return;
  }
}, o0 = (r) => typeof r == "number" && !isNaN(r), s0 = (r, t) => o0(r) && o0(t) && r !== t, Ia = (r, t) => {
  const n = {};
  return s0(r.width, t.width) && (n.width = t.width), s0(r.height, t.height) && (n.height = t.height), Qt(n) ? null : n;
}, Pa = "_wrap_139ok_1", Na = "_portalWrap_139ok_6", Ra = "_layoutBoundary_139ok_10", Ta = "_label_139ok_20", Ua = "_content_139ok_24", Ga = "_textWrap_139ok_48", za = "_innerContent_139ok_52", Wa = "_caret_139ok_56", ja = "_measureDummy_139ok_73", Xa = "_top_139ok_89", Ya = "_topLeft_139ok_90", Qa = "_topRight_139ok_91", Ka = "_active_139ok_109", Ja = "_bottom_139ok_116", qa = "_bottomLeft_139ok_117", $a = "_bottomRight_139ok_118", _a = "_left_139ok_141", er = "_right_139ok_147", tr = "_portal_139ok_6", nr = "_hitSlopTop_139ok_272", ar = "_hitSlopBottom_139ok_281", rr = "_hitSlopLeft_139ok_290", ir = "_hitSlopRight_139ok_299", Q = {
  wrap: Pa,
  portalWrap: Na,
  layoutBoundary: Ra,
  label: Ta,
  content: Ua,
  textWrap: Ga,
  innerContent: za,
  caret: Wa,
  measureDummy: ja,
  top: Xa,
  topLeft: Ya,
  topRight: Qa,
  active: Ka,
  bottom: Ja,
  bottomLeft: qa,
  bottomRight: $a,
  left: _a,
  right: er,
  portal: tr,
  hitSlopTop: nr,
  hitSlopBottom: ar,
  hitSlopLeft: rr,
  hitSlopRight: ir
}, mt = 352;
class Q1 extends N {
  constructor(t) {
    super(t), this.state = {
      active: t.defaultActive,
      width: null,
      height: null,
      left: null,
      top: null
    }, this.dummyComponent = e.createRef(), this.floatingContent = e.createRef(), this.eventListenersAreSet = !1, this.updatePosition = this.updatePosition.bind(this);
  }
  componentDidMount() {
    this.setState(this.getDummyComponentDimensions()), this.setupEventListeners();
  }
  componentDidUpdate(t, n) {
    const { fixOverflow: a } = this.props;
    a && (this.updatePosition(), this.state.active ? (setTimeout(this.updatePosition, 25), this.setupEventListeners()) : this.teardownEventListeners());
    const l = Ia(n, this.getDummyComponentDimensions());
    l && this.setState(l, () => a && this.updatePosition()), this.props.disabled !== t.disabled && this.props.disabled && this.setState({ active: !1 });
  }
  componentWillUnmount() {
    this.teardownEventListeners();
  }
  // event listeners
  setupEventListeners() {
    const { fixOverflow: t } = this.props, { active: n } = this.state;
    !t || !n || this.eventListenersAreSet || (typeof window < "u" && (window.addEventListener("resize", this.updatePosition), window.addEventListener("scroll", this.updatePosition)), this.eventListenersAreSet = !0);
  }
  teardownEventListeners() {
    typeof window < "u" && (window.removeEventListener("resize", this.updatePosition), window.removeEventListener("scroll", this.updatePosition)), this.eventListenersAreSet = !1;
  }
  updatePosition() {
    const { left: t, top: n } = this.state;
    try {
      const a = l0(this.floatingContent);
      a && (t !== a.left || n !== a.top) && this.setState({ left: a.left, top: a.top });
    } catch (a) {
      console.error(a);
    }
  }
  // helpers
  getDummyComponentDimensions() {
    const { width: t } = this.props, n = { width: t ? null : mt, height: 0 };
    try {
      const a = l0(this.dummyComponent);
      return a ? {
        width: t ? null : mt < a.width ? mt : a.width,
        height: a.height
      } : n;
    } catch (a) {
      return console.error(a), n;
    }
  }
  getStyle() {
    const { width: t, direction: n, pointerEvents: a, preventAnimation: l } = this.props, { width: o, height: s, active: d } = this.state, c = t || o;
    return {
      width: (c || 0) + "px",
      pointerEvents: a ? "all" : "none",
      transition: l ? "none" : void 0,
      // use margins to center the component to the middle of the content
      marginLeft: Sa(n, c),
      // set opacity directly on style so we can use .toBeVisible() in tests
      opacity: d ? 1 : 0,
      visibility: d ? "visible" : "hidden"
    };
  }
  getClasses(t) {
    const { direction: n, textWrap: a, contentClassName: l, fixOverflow: o } = this.props, { active: s } = this.state;
    return M(
      {
        [Q.active]: s || o && !t,
        [Q.textWrap]: a,
        [Q[n]]: !!Q[n],
        [Q.portal]: !!t
      },
      Q.content,
      l
    );
  }
  getEventHandlers() {
    const { hasActionableContent: t, clickOnly: n, disabled: a } = this.props;
    return t ? {} : {
      onMouseEnter: () => !n && this.setState({ active: !a }),
      onClick: () => !!n && this.setState({ active: !a }),
      onMouseLeave: () => this.setState({ active: !1 })
    };
  }
  // rendering
  renderInnerContent() {
    const { content: t, hasActionableContent: n } = this.props;
    return n ? /* @__PURE__ */ e.createElement(Y1, { className: Q.innerContent }, t) : /* @__PURE__ */ e.createElement("div", { className: Q.innerContent }, t);
  }
  renderContent() {
    const { fixOverflow: t, zIndex: n, caretClassName: a } = this.props, { active: l } = this.state, o = this.getStyle();
    l && typeof n < "u" && (o.zIndex = n), t && (o.opacity = 0, o.pointerEvents = "none");
    const s = this.getClasses();
    return /* @__PURE__ */ e.createElement("div", { className: t ? Q.layoutBoundary : "" }, /* @__PURE__ */ e.createElement("div", { style: o, className: s, ref: this.floatingContent }, this.renderInnerContent(), /* @__PURE__ */ e.createElement("div", { className: M(Q.caret, a) })));
  }
  renderPortalContent() {
    const { fixOverflow: t, portalZIndex: n, caretClassName: a } = this.props, { left: l, top: o } = this.state;
    if (!t)
      return null;
    const s = this.getStyle();
    s.left = l, s.top = o, typeof n < "u" && (s.zIndex = n);
    const d = this.getClasses(!0);
    return /* @__PURE__ */ e.createElement(b1, null, /* @__PURE__ */ e.createElement("div", { className: Q.portalWrap }, /* @__PURE__ */ e.createElement("div", { style: s, className: d }, this.renderInnerContent(), /* @__PURE__ */ e.createElement("div", { className: M(Q.caret, a) }))));
  }
  render() {
    const { className: t, content: n, testId: a, width: l, activateOnHover: o, children: s, hasActionableContent: d } = this.props;
    return /* @__PURE__ */ e.createElement("div", { "data-testid": a, className: t }, /* @__PURE__ */ e.createElement("div", { className: Q.wrap, ...this.getEventHandlers() }, /* @__PURE__ */ e.createElement("div", { className: Q.label }, typeof s == "string" && !d ? /* @__PURE__ */ e.createElement(y, null, s) : s), this.renderContent(), this.renderPortalContent(), o && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: Q.hitSlopTop }), /* @__PURE__ */ e.createElement("div", { className: Q.hitSlopBottom }), /* @__PURE__ */ e.createElement("div", { className: Q.hitSlopLeft }), /* @__PURE__ */ e.createElement("div", { className: Q.hitSlopRight }))), !l && /* @__PURE__ */ e.createElement("div", { className: Q.measureDummy, ref: this.dummyComponent }, n));
  }
}
Q1.propTypes = {
  className: i.string,
  caretClassName: i.string,
  contentClassName: i.string,
  hasActionableContent: i.bool,
  activateOnHover: i.bool,
  content: i.any,
  direction: i.string,
  width: i.number,
  defaultActive: i.bool,
  pointerEvents: i.bool,
  fixOverflow: i.bool,
  textWrap: i.bool,
  disabled: i.bool,
  testId: i.string,
  clickOnly: i.bool,
  portalZIndex: i.number,
  zIndex: i.number,
  preventAnimation: i.bool
};
Q1.defaultProps = {
  content: "Content",
  direction: "bottom",
  textWrap: !0,
  testId: "volt-floating-content"
};
const lr = "_tooltipContent_15zdg_1", or = {
  tooltipContent: lr
}, Me = ({ children: r, ...t }) => /* @__PURE__ */ e.createElement(Q1, { activateOnHover: !0, contentClassName: or.tooltipContent, ...t }, r);
Me.propTypes = {
  content: i.any,
  direction: i.string,
  width: i.number,
  defaultActive: i.bool,
  pointerEvents: i.bool,
  fixOverflow: i.bool,
  textWrap: i.bool,
  disabled: i.bool,
  testId: i.string,
  clickOnly: i.bool,
  portalZIndex: i.number,
  zIndex: i.number,
  className: i.string,
  preventAnimation: i.bool
};
Me.defaultProps = {
  content: "Content",
  direction: "bottom",
  width: null,
  defaultActive: !1,
  pointerEvents: !1,
  fixOverflow: !1,
  textWrap: !0,
  disabled: !1,
  testId: "volt-tooltip",
  clickOnly: !1,
  portalZIndex: void 0,
  zIndex: void 0,
  className: "",
  preventAnimation: !1,
  kind: "tooltip"
};
const sr = "_container_pcsiu_1", dr = "_noHoverEffects_pcsiu_15", cr = "_customIcon_pcsiu_15", mr = "_voltIconStroke_pcsiu_27", hr = "_voltIconFill_pcsiu_31", pr = "_svgStroke_pcsiu_39", ur = "_svgFill_pcsiu_43", we = {
  container: sr,
  default: "_default_pcsiu_11",
  noHoverEffects: dr,
  customIcon: cr,
  voltIconStroke: mr,
  voltIconFill: hr,
  svgStroke: pr,
  svgFill: ur
}, g1 = {
  alert: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.5 7C3.5 4.85841 4.99601 3.06624 7 2.61151V2C7 1.44772 7.44772 1 8 1C8.55228 1 9 1.44772 9 2V2.61151C11.004 3.06624 12.5 4.85841 12.5 7V10L13.3536 10.8536C13.4473 10.9473 13.5 11.0745 13.5 11.2071V11.5C13.5 11.7761 13.2761 12 13 12H3C2.72386 12 2.5 11.7761 2.5 11.5V11.2071C2.5 11.0745 2.55268 10.9473 2.64645 10.8536L3.5 10V7Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8 15C9.10457 15 10 14.1046 10 13H6C6 14.1046 6.89543 15 8 15Z", fill: "#666679" })),
  "alert-24": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 2C10.8954 2 10 2.89543 10 4V5C7.79086 5 5 7 5 11V15L4.20711 16.7929C4.0745 16.9255 4 17.1054 4 17.2929C4 17.6834 4.31658 18 4.70711 18H19.2929C19.6834 18 20 17.6834 20 17.2929C20 17.1054 19.9255 16.9255 19.7929 16.7929L19 15V11C19 7 16.2091 5 14 5V4C14 2.89543 13.1046 2 12 2Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M15 19C15 20.1046 15 22 12 22C9 22 9 20.1046 9 19H15Z", fill: "#666679" })),
  "arrow-curved": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.7071 9.29999L10.7071 5.29999L9.29291 6.7142L11.5858 9.00708L11.5858 11.0071L9.29291 13.3L10.7071 14.7142L14.7071 10.7142C15.0976 10.3237 15.0976 9.69051 14.7071 9.29999Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 7V2H4V7C4 8.10457 4.89543 9 6 9H13V11H6C3.79086 11 2 9.20914 2 7Z",
      fill: "#666679"
    }
  )),
  "arrow-down": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.70712 14.7071L13.7071 9.70712L12.2929 8.29291L9.00003 11.5858L9.00003 1L7.00003 1L7.00003 11.5858L3.70712 8.29291L2.29291 9.70712L7.29291 14.7071C7.68343 15.0976 8.3166 15.0976 8.70712 14.7071Z",
      fill: "#666679"
    }
  )),
  "arrow-left": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1.29288 7.29291L6.29288 2.29291L7.70709 3.70712L4.41421 7H15V9H4.41418L7.70709 12.2929L6.29288 13.7071L1.29288 8.70712C0.902355 8.3166 0.902355 7.68343 1.29288 7.29291Z",
      fill: "#666679"
    }
  )),
  "arrow-right": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.7071 7.29291L9.70712 2.29291L8.29291 3.70712L11.5858 7H1V9H11.5858L8.29291 12.2929L9.70712 13.7071L14.7071 8.70712C15.0976 8.3166 15.0976 7.68343 14.7071 7.29291Z",
      fill: "#666679"
    }
  )),
  "arrow-up": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.29291 1.29289L2.29291 6.29289L3.70712 7.70711L7 4.41423L7 15L9 15L9 4.4142L12.2929 7.70711L13.7071 6.29289L8.70712 1.29289C8.3166 0.90237 7.68343 0.90237 7.29291 1.29289Z",
      fill: "#666679"
    }
  )),
  attach: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.2715 2.97855C11.7073 2.41442 10.7927 2.41442 10.2286 2.97855L4.10451 9.1026C3.18084 10.0263 3.15826 11.5167 4.05353 12.4679C4.98799 13.4608 6.5583 13.4846 7.5224 12.5205L11.3965 8.64644L12.1036 9.35355L8.22951 13.2276C6.86649 14.5906 4.64644 14.557 3.32533 13.1533C2.05963 11.8085 2.09155 9.70135 3.3974 8.39549L9.52146 2.27144C10.4761 1.31679 12.0239 1.31679 12.9786 2.27144C13.9332 3.22609 13.9332 4.77389 12.9786 5.72855L7.4814 11.2257C6.94296 11.7641 6.08279 11.8032 5.49782 11.3157C4.83274 10.7615 4.78712 9.75578 5.39929 9.14361L9.89645 4.64644L10.6036 5.35355L6.1064 9.85071C5.91003 10.0471 5.92466 10.3697 6.138 10.5475C6.32565 10.7038 6.60157 10.6913 6.77429 10.5186L12.2715 5.02144C12.8356 4.45731 12.8356 3.54268 12.2715 2.97855Z",
      fill: "#666679"
    }
  )),
  "bar-graph": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M3 3H5V19H21V21H3V3Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 5.5C7 5.22386 7.22386 5 7.5 5H9.5C9.77614 5 10 5.22386 10 5.5V17H7V5.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 11.5C16 11.2239 16.2239 11 16.5 11H18.5C18.7761 11 19 11.2239 19 11.5V17H16V11.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 8C11.7239 8 11.5 8.22386 11.5 8.5V17H14.5V8.5C14.5 8.22386 14.2761 8 14 8H12Z",
      fill: "#666679"
    }
  )),
  bookmark: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "20", viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM2 2H7V10L4.5 8.5L2 10V2Z",
      fill: "#666679"
    }
  )),
  calendar: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M12 10H7V15H12V10Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 4H19C20.1 4 21 4.9 21 6V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V6C3 4.9 3.9 4 5 4H6V2H8V4H16V2H18V4ZM5 8V19H19V8H5Z",
      fill: "#666679"
    }
  )),
  "caret-down": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.9387 6C12.1551 6 12.2693 6.25636 12.1245 6.41724L8.18582 10.7935C8.08651 10.9039 7.91349 10.9039 7.81418 10.7935L3.87552 6.41724C3.73073 6.25636 3.8449 6 4.06134 6L11.9387 6Z",
      fill: "#666679"
    }
  )),
  "caret-left": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 4.56134C10 4.3449 9.74364 4.23072 9.58276 4.37552L5.20647 8.31418C5.09612 8.41349 5.09612 8.58651 5.20647 8.68582L9.58276 12.6245C9.74364 12.7693 10 12.6551 10 12.4387L10 4.56134Z",
      fill: "#666679"
    }
  )),
  "caret-right": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 12.4387C6 12.6551 6.25636 12.7693 6.41724 12.6245L10.7935 8.68582C10.9039 8.58651 10.9039 8.41349 10.7935 8.31418L6.41724 4.37552C6.25636 4.23073 6 4.3449 6 4.56134L6 12.4387Z",
      fill: "#666679"
    }
  )),
  "caret-up": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.9387 10C12.1551 10 12.2693 9.74364 12.1245 9.58276L8.18582 5.20647C8.08651 5.09612 7.91349 5.09612 7.81418 5.20647L3.87552 9.58276C3.73073 9.74364 3.8449 10 4.06134 10L11.9387 10Z",
      fill: "#666679"
    }
  )),
  carrier: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 1H12C12.5523 1 13 1.44772 13 2V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V5L7 1ZM7 13H5L5 11H7V13ZM11 6L9 6L9 8L11 8V6ZM7 10H5L5 6H7L7 10ZM11 9H9L9 13H11L11 9Z",
      fill: "#666679"
    }
  )),
  caution: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 0.999999C4.13401 0.999999 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 0.999999ZM7 10L7 12L9 12L9 10L7 10ZM7 4L7 8L9 8L9 4L7 4Z",
      fill: "#666679"
    }
  )),
  cellphone: /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.45 6.87778C8.76667 6.87778 8.10556 6.76667 7.48889 6.56667C7.29444 6.5 7.07778 6.55 6.92778 6.7L6.05556 7.79445C4.48333 7.04445 3.01111 5.62778 2.22778 4L3.31111 3.07778C3.46111 2.92222 3.50556 2.70556 3.44444 2.51111C3.23889 1.89444 3.13333 1.23333 3.13333 0.55C3.13333 0.25 2.88333 0 2.58333 0H0.661111C0.361111 0 0 0.133333 0 0.55C0 5.71111 4.29445 10 9.45 10C9.84445 10 10 9.65 10 9.34444V7.42778C10 7.12778 9.75 6.87778 9.45 6.87778Z",
      fill: "#6A6A72"
    }
  )),
  check: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7071 4.70712L6 13.4142L1.29289 8.70712L2.70711 7.29291L6 10.5858L13.2929 3.29291L14.7071 4.70712Z",
      fill: "#666679"
    }
  )),
  clear: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM11.7071 5.70709L9.4142 8L11.7071 10.2929L10.2929 11.7071L7.99998 9.41421L5.70711 11.7071L4.29289 10.2929L6.58577 8L4.29289 5.70712L5.70711 4.29291L7.99998 6.58578L10.2929 4.29288L11.7071 5.70709Z",
      fill: "#666679"
    }
  )),
  close: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.58579 8.00001L2.29289 12.2929L3.70711 13.7071L8 9.41423L12.2929 13.7071L13.7071 12.2929L9.41421 8.00001L13.7071 3.70712L12.2929 2.29291L8 6.5858L3.70711 2.29291L2.29289 3.70712L6.58579 8.00001Z",
      fill: "#666679"
    }
  )),
  "color-toggle": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM13 8C13 10.7614 10.7614 13 8 13V3C10.7614 3 13 5.23858 13 8Z",
      fill: "#666679"
    }
  )),
  columns: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4 4.125C4 3.50368 4.44772 3 5 3H7C7.55228 3 8 3.50368 8 4.125V19.875C8 20.4963 7.55228 21 7 21H5C4.44772 21 4 20.4963 4 19.875V4.125Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 4.125C10 3.50368 10.4477 3 11 3H13C13.5523 3 14 3.50368 14 4.125V19.875C14 20.4963 13.5523 21 13 21H11C10.4477 21 10 20.4963 10 19.875V4.125Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 3C16.4477 3 16 3.50368 16 4.125V19.875C16 20.4963 16.4477 21 17 21H19C19.5523 21 20 20.4963 20 19.875V4.125C20 3.50368 19.5523 3 19 3H17Z",
      fill: "#666679"
    }
  )),
  confirmed: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.50001 11.9142L12.7071 5.70712L11.2929 4.29291L6.50001 9.0858L4.70712 7.29291L3.29291 8.70712L6.50001 11.9142Z",
      fill: "#666679"
    }
  )),
  copy: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 5C2 4.44772 2.44772 4 3 4H10C10.5523 4 11 4.44772 11 5V14C11 14.5523 10.5523 15 10 15H3C2.44772 15 2 14.5523 2 14V5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.25 2.5H6V1H12.25C13.2165 1 14 1.7835 14 2.75V11H12.5V2.75C12.5 2.61193 12.3881 2.5 12.25 2.5Z",
      fill: "#666679"
    }
  )),
  copy24: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "20", viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 6C0 4.89543 0.895431 4 2 4H10C11.1046 4 12 4.89543 12 6V18C12 19.1046 11.1046 20 10 20H2C0.895431 20 0 19.1046 0 18V6Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 2H6V0H13C14.6569 0 16 1.34315 16 3V14H14V3C14 2.44772 13.5523 2 13 2Z",
      fill: "#666679"
    }
  )),
  "copy-large": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4 8C4 6.89543 4.89543 6 6 6H14C15.1046 6 16 6.89543 16 8V20C16 21.1046 15.1046 22 14 22H6C4.89543 22 4 21.1046 4 20V8Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 4H10V2H17C18.6569 2 20 3.34315 20 5V16H18V5C18 4.44772 17.5523 4 17 4Z",
      fill: "#666679"
    }
  )),
  "credit-card": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5 3H2.5C1.67157 3 1 3.67157 1 4.5V11.5C1 12.3284 1.67157 13 2.5 13H13.5C14.3284 13 15 12.3284 15 11.5V4.5C15 3.67157 14.3284 3 13.5 3ZM14 6V4.5C14 4.22386 13.7761 4 13.5 4H2.5C2.22386 4 2 4.22386 2 4.5V6H14ZM2 8V11.5C2 11.7761 2.22386 12 2.5 12H13.5C13.7761 12 14 11.7761 14 11.5V8H2Z",
      fill: "#666679"
    }
  )),
  "curved-arrow16": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.7071 9.29999L10.7071 5.29999L9.29291 6.7142L11.5858 9.00708L11.5858 11.0071L9.29291 13.3L10.7071 14.7142L14.7071 10.7142C15.0976 10.3237 15.0976 9.69051 14.7071 9.29999Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 7V2H4V7C4 8.10457 4.89543 9 6 9H13V11H6C3.79086 11 2 9.20914 2 7Z",
      fill: "#666679"
    }
  )),
  doc: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 1H9L13 5V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2C3 1.44772 3.44772 1 4 1ZM8 6V2L12 6H8Z",
      fill: "#666679"
    }
  )),
  docs: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 14.4159C7.78069 14.4159 7.56139 14.3389 7.42445 14.185C6.93214 13.6317 6.12399 13 5 13H2C1.44772 13 1 12.5523 1 12V4C1 3.44772 1.44764 3 1.99992 3H5C7 3 8 5 8 5C8 5 9 3 11 3H14.0001C14.5524 3 15 3.44772 15 4V12C15 12.5523 14.5523 13 14 13H11C9.87601 13 9.06786 13.6317 8.57555 14.185C8.43861 14.3389 8.21931 14.4159 8 14.4159ZM9 12.5482V5.27186L9.01955 5.2422C9.11745 5.09535 9.26432 4.8999 9.45711 4.70711C9.84811 4.3161 10.3588 4 11 4H14V12H11C10.2065 12 9.5397 12.2325 9 12.5482Z",
      fill: "#666679"
    }
  )),
  "docs-24": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 3C2.44772 3 2 3.44772 2 4V19C2 19.5523 2.44772 20 3 20H8.58579C8.851 20 9.10536 20.1054 9.29289 20.2929L12 22L14.7071 20.2929C14.8946 20.1054 15.149 20 15.4142 20H21C21.5523 20 22 19.5523 22 19V4C22 3.44771 21.5526 3 21.0003 3L15 3C13 3.00001 12 5 12 5C12 5 11 3 9 3H3ZM15.1 5C13.7 5.00001 13 6.55556 13 6.55556V18H20V5H15.1Z",
      fill: "#666679"
    }
  )),
  "double-chevron": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.5858 8L2.29291 4.70711L3.70712 3.29289L8.41423 8L3.70712 12.7071L2.29291 11.2929L5.5858 8Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.5858 8L8.29291 4.70711L9.70712 3.29289L14.4142 8L9.70712 12.7071L8.29291 11.2929L11.5858 8Z",
      fill: "#666679"
    }
  )),
  "double-chevron-right": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.58579 8.00001L2.29289 4.70712L3.70711 3.29291L8.41421 8.00001L3.70711 12.7071L2.29289 11.2929L5.58579 8.00001Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5858 8.00001L8.29289 4.70712L9.70711 3.29291L14.4142 8.00001L9.70711 12.7071L8.29289 11.2929L11.5858 8.00001Z",
      fill: "#666679"
    }
  )),
  download: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M3 13H13V15H3V13Z", fill: "#666679" }), /* @__PURE__ */ e.createElement("path", { d: "M9 1H7V8H4L8 12L12 8H9V1Z", fill: "#666679" })),
  "download-big": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M4.5 19.5H19.5V22.5H4.5V19.5Z", fill: "#666679" }), /* @__PURE__ */ e.createElement("path", { d: "M13.5 1.5H10.5V12H6L12 18L18 12H13.5V1.5Z", fill: "#666679" })),
  edit: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M9 3.99999L12 6.99999L5 14H2V11L9 3.99999Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.3536 1.35354L14.6464 3.64643C14.8417 3.84169 14.8417 4.15828 14.6464 4.35354L13 5.99999L10 2.99999L11.6464 1.35354C11.8417 1.15828 12.1583 1.15828 12.3536 1.35354Z",
      fill: "#666679"
    }
  )),
  envelope: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 3C1.44772 3 1 3.44772 1 4V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V4C15 3.44772 14.5523 3 14 3H2ZM2 4V6L8 10L14 6V4L8 8L2 4Z",
      fill: "#666679"
    }
  )),
  expand: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 12L17 7L12 7L13.7929 8.79289L11.2929 11.2929L12.7071 12.7071L15.2071 10.2071L17 12Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.96548 21 3.93137 20.9983 3.89776 20.9948C3.3935 20.9436 3 20.5178 3 20V4ZM5 13V5H19V19H11V14C11 13.4477 10.5523 13 10 13H5Z",
      fill: "#666679"
    }
  )),
  feedback16: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 3C1 2.44771 1.44772 2 2 2H14C14.5523 2 15 2.44772 15 3V16L11.4 13H2C1.44772 13 1 12.5523 1 12V3ZM5 8C5.55228 8 6 7.55228 6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8ZM9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7ZM11 8C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8Z",
      fill: "#666679"
    }
  )),
  filter: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.20001 5.6C6.20001 8.2 10 13 10 13V19C10 19.5 10.4 20 11 20H13C13.6 20 14 19.5 14 19V13C14 13 17.7 8.2 19.7 5.6C20.2 4.9 19.7 4 18.9 4H5.00001C4.20001 4 3.70001 4.9 4.20001 5.6Z",
      fill: "#666679"
    }
  )),
  "filter-row": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 4H21.5C21.7761 4 22 4.22386 22 4.5V5.5C22 5.77614 21.7761 6 21.5 6H12V4Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 11H21.5C21.7761 11 22 11.2239 22 11.5V12.5C22 12.7761 21.7761 13 21.5 13H12V11Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 18H21.5C21.7761 18 22 18.2239 22 18.5V19.5C22 19.7761 21.7761 20 21.5 20H14V18Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8 15L13 19L8 23V15Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 6C6.68629 6 4 8.68629 4 12C4 15.3137 6.68629 18 10 18V20C5.58172 20 2 16.4183 2 12C2 7.58172 5.58172 4 10 4V6Z",
      fill: "#666679"
    }
  )),
  "graph-line": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.8137 3.58124L10.1276 11.5418L6.12762 7.54182L1.81375 13.5812L0.186279 12.4188L5.87241 4.45818L9.87241 8.45818L14.1863 2.41876L15.8137 3.58124Z",
      fill: "#666679"
    }
  )),
  help: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 3C6.5314 3 5 4.11759 5 6H7C7 5.38241 7.4686 5 8 5C8.5314 5 9 5.38241 9 6C9 6.28887 8.84524 6.48141 8.25259 7.14814C7.72953 7.73658 7 8.60497 7 10H9C9 9.39503 9.27047 9.01342 9.74741 8.47686C9.78375 8.43598 9.82358 8.39232 9.86597 8.34584C10.2989 7.87127 11 7 11 6C11 4.11759 9.4686 3 8 3ZM9 13V11H7V13H9Z",
      fill: "#666679"
    }
  )),
  "help-24": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 5C10.0314 5 8 6.49259 8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9C10 7.75741 10.9686 7 12 7C13.0314 7 14 7.75741 14 9C14 9.23163 13.9183 9.47596 13.6992 9.80468C13.5136 10.0831 13.2836 10.3479 12.9949 10.6803C12.9148 10.7724 12.8301 10.8699 12.7407 10.9742C11.965 11.8793 11 13.1181 11 15H13C13 13.8819 13.535 13.1207 14.2593 12.2758C14.3232 12.2012 14.3908 12.1236 14.4606 12.0434C14.7598 11.6998 15.0995 11.3098 15.3633 10.9141C15.7067 10.399 16 9.76837 16 9C16 6.49259 13.9686 5 12 5ZM13 19V17H11V19H13Z",
      fill: "#666679"
    }
  )),
  hide: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.70644 1.29352L1.29285 2.70711L3.54275 4.95701C1.76823 6.27148 1 7.99999 1 7.99999C1 7.99999 3 12.5 8 12.5C8.99044 12.5 9.86317 12.3234 10.626 12.0402L13.2928 14.7071L14.7064 13.2935L2.70644 1.29352ZM5 7.99999C5 7.53686 5.10495 7.09824 5.29236 6.70662L9.29338 10.7076C8.90175 10.895 8.46313 11 8 11C6.34315 11 5 9.65685 5 7.99999Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.2242 10.3971C14.4554 9.22527 15 8 15 8C15 8 13 3.49997 8 3.49999C7.45666 3.49999 6.94876 3.55313 6.47499 3.64786L7.83176 5.00463C7.88745 5.00155 7.94355 4.99999 8 4.99999C9.65686 4.99999 11 6.34314 11 7.99999C11 8.05645 10.9984 8.11255 10.9954 8.16823L13.2242 10.3971Z",
      fill: "#666679"
    }
  )),
  hyperlink18: /* @__PURE__ */ e.createElement("svg", { width: "18", height: "17", viewBox: "0 0 18 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.87873 10.1213C6.48821 9.7308 6.48821 9.09763 6.87873 8.70711L9.70716 5.87868C10.0977 5.48816 10.7308 5.48816 11.1214 5.87868C11.5119 6.26921 11.5119 6.90237 11.1214 7.2929L8.29294 10.1213C7.90242 10.5118 7.26926 10.5118 6.87873 10.1213Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4143 3.75736L8.29294 5.87868L6.87873 4.46447L9.00005 2.34315C10.5621 0.781052 13.0948 0.781052 14.6569 2.34315C16.219 3.90525 16.219 6.43791 14.6569 8L12.5356 10.1213L11.1214 8.70711L13.2427 6.58579C14.0237 5.80474 14.0237 4.53841 13.2427 3.75736C12.4616 2.97631 11.1953 2.97631 10.4143 3.75736Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.75741 9.41422L6.87873 7.2929L5.46452 5.87868L3.3432 8C1.7811 9.5621 1.7811 12.0948 3.3432 13.6569C4.90529 15.219 7.43795 15.219 9.00005 13.6569L11.1214 11.5355L9.70716 10.1213L7.58584 12.2426C6.80479 13.0237 5.53846 13.0237 4.75741 12.2426C3.97636 11.4616 3.97636 10.1953 4.75741 9.41422Z",
      fill: "#666679"
    }
  )),
  home: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M8 2L1 8H3V14H7V10H9V14H13V8H15L8 2Z", fill: "#666679" })),
  "home-24": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2L2 12H5V21H10V16H14V21H19V12H22L12 2Z", fill: "#666679" })),
  info: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 6.07089V4.07089H7V6.07089H9ZM9 12.0709V8.07089H7V12.0709H9Z",
      fill: "#666679"
    }
  )),
  infoUpsideDown: /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 -6.11959e-07C3.13401 -9.49935e-07 9.49935e-07 3.13401 6.11959e-07 7C2.73984e-07 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 -2.73984e-07 7 -6.11959e-07ZM6 9L6 11L8 11L8 9L6 9ZM6 3L6 7L8 7L8 3L6 3Z",
      fill: "#B4CCFC"
    }
  )),
  label: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1 4C1 3.44772 1.44772 3 2 3H10.5194C10.8232 3 11.1105 3.13809 11.3002 3.3753L15 8L11.3002 12.6247C11.1105 12.8619 10.8232 13 10.5194 13H2C1.44772 13 1 12.5523 1 12V4Z",
      fill: "#666679"
    }
  )),
  "lightning-bolt": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.0155 6.71991L8.28015 14.8133C8.23346 14.9223 8.12446 15 8.00005 15H7.93784C7.79779 14.9688 7.68879 14.8443 7.68879 14.6887L7.68868 9.70822H4.26457C4.15557 9.70822 4.0622 9.66154 3.99999 9.56817C3.93778 9.4748 3.93778 9.3658 3.98447 9.27242L7.71986 1.17907C7.78207 1.03902 7.92223 0.976707 8.06227 1.00786C8.20232 1.03902 8.31132 1.16355 8.31132 1.31912V6.29964H11.7354C11.8444 6.29964 11.9378 6.34633 12 6.43969C12.0622 6.51754 12.0622 6.62643 12.0155 6.71979L12.0155 6.71991Z",
      fill: "#3751FF"
    }
  )),
  "line-graph": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M3 3H5V19H21V21H3V3Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.1276 15.5418L20.8137 7.58124L19.1863 6.41876L14.8724 12.4582L10.8724 8.45818L5.18628 16.4188L6.81375 17.5812L11.1276 11.5418L15.1276 15.5418Z",
      fill: "#666679"
    }
  )),
  location: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1C5.23571 1 3 3.191 3 5.9C3 9.575 8 15 8 15C8 15 13 9.575 13 5.9C13 3.191 10.7643 1 8 1ZM8 7.65C7.01429 7.65 6.21429 6.866 6.21429 5.9C6.21429 4.934 7.01429 4.15 8 4.15C8.98571 4.15 9.78571 4.934 9.78571 5.9C9.78571 6.866 8.98571 7.65 8 7.65Z",
      fill: "#666679"
    }
  )),
  lock: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 4V5H12C12.5523 5 13 5.44772 13 6V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V6C3 5.44772 3.44772 5 4 5H5V4C5 2 6.075 1 8 1C9.925 1 11 2 11 4ZM6 5H10V4C10 2.78571 9.16875 2 8 2C6.83125 2 6 2.78571 6 4V5Z",
      fill: "#666679"
    }
  )),
  "metric-graph": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 3H3V21H21V19H5V3ZM9.7 9.048V14.744H8.66V10.168L7.5 11.176V10.056L8.67599 9L9.7 9.048ZM13.964 13.808V14.744H10.5V13.808L12.628 11.336C12.836 11.088 12.924 10.912 12.924 10.648C12.924 10.224 12.676 9.936 12.236 9.936C11.892 9.936 11.54 10.112 11.54 10.664H10.5C10.5 9.624 11.26 9 12.236 9C13.244 9 13.964 9.632 13.964 10.656C13.964 11.208 13.748 11.504 13.356 11.96L11.764 13.808H13.964ZM18.024 13.096C18.024 12.408 17.696 12.016 17.288 11.8C17.664 11.6 17.944 11.248 17.944 10.632C17.944 9.672 17.216 9 16.208 9C15.248 9 14.488 9.608 14.464 10.624H15.504C15.528 10.192 15.816 9.936 16.208 9.936C16.584 9.936 16.904 10.184 16.904 10.664C16.904 11.064 16.688 11.376 16.184 11.376H16.032V12.28H16.184C16.696 12.28 16.984 12.592 16.984 13.064C16.984 13.576 16.664 13.856 16.216 13.856C15.808 13.856 15.456 13.624 15.44 13.112H14.4C14.416 14.304 15.288 14.792 16.216 14.792C17.192 14.792 18.024 14.232 18.024 13.096Z",
      fill: "#666679"
    }
  )),
  minus: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("rect", { x: "3", y: "10.5", width: "18", height: "3" })),
  minus16: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM4 9L12 9V7L4 7V9Z",
      fill: "#666679"
    }
  )),
  minimize: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.7049 7.70934L15.1992 10.1992L17 12L12 12V7L13.785 8.78499L16.2951 6.29066L17.7049 7.70934Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4V20C3 20.5178 3.3935 20.9436 3.89776 20.9948C3.93137 20.9983 3.96548 21 4 21H20C20.5523 21 21 20.5523 21 20V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4ZM5 5V13H10C10.5523 13 11 13.4477 11 14V19H19V5H5Z",
      fill: "#666679"
    }
  )),
  "more-vertical": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15C10.7574 15 9.75 13.9926 9.75 12.75C9.75 11.5074 10.7574 10.5 12 10.5C13.2426 10.5 14.25 11.5074 14.25 12.75C14.25 13.9926 13.2426 15 12 15Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 22.5C10.7574 22.5 9.75 21.4926 9.75 20.25C9.75 19.0074 10.7574 18 12 18C13.2426 18 14.25 19.0074 14.25 20.25C14.25 21.4926 13.2426 22.5 12 22.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.5C10.7574 7.5 9.75 6.49264 9.75 5.25C9.75 4.00736 10.7574 3 12 3C13.2426 3 14.25 4.00736 14.25 5.25C14.25 6.49264 13.2426 7.5 12 7.5Z",
      fill: "#666679"
    }
  )),
  move16: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1L5 4H7L7 7H4V5L1 8L4 11V9H7V12H5L8 15L11 12H9L9 9L12 9V11L15 8L12 5V7L9 7L9 4H11L8 1Z",
      fill: "#666679"
    }
  )),
  "new-layer": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 5.33333V4C6 3.44772 6.44772 3 7 3H12C12.5523 3 13 3.44772 13 4V9C13 9.55228 12.5523 10 12 10H10.6667",
      stroke: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("rect", { x: "3.5", y: "5.5", width: "7", height: "7", rx: "1", stroke: "#666679" })),
  "new-tab": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M2 2H5V4H4V12L12 12V11H14V14H3C2.44772 14 2 13.5523 2 13V2Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 2V4L10.5858 4L5.79289 8.79289L7.20711 10.2071L12 5.41421V9H14V2H7Z",
      fill: "#666679"
    }
  )),
  notifications: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 2C10.8954 2 10 2.89543 10 4V5C7.79086 5 5 7 5 11V15L4.20711 16.7929C4.0745 16.9255 4 17.1054 4 17.2929C4 17.6834 4.31658 18 4.70711 18H19.2929C19.6834 18 20 17.6834 20 17.2929C20 17.1054 19.9255 16.9255 19.7929 16.7929L19 15V11C19 7 16.2091 5 14 5V4C14 2.89543 13.1046 2 12 2Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M15 19C15 20.1046 15 22 12 22C9 22 9 20.1046 9 19H15Z", fill: "#666679" })),
  photo: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3ZM3 12L5 9L7 11L10 7L13 12H3Z",
      fill: "#666679"
    }
  )),
  phone16: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.45 9.87778C11.7667 9.87778 11.1056 9.76667 10.4889 9.56667C10.2944 9.5 10.0778 9.55 9.92778 9.7L9.05556 10.7944C7.48333 10.0444 6.01111 8.62778 5.22778 7L6.31111 6.07778C6.46111 5.92222 6.50556 5.70556 6.44444 5.51111C6.23889 4.89444 6.13333 4.23333 6.13333 3.55C6.13333 3.25 5.88333 3 5.58333 3H3.66111C3.36111 3 3 3.13333 3 3.55C3 8.71111 7.29445 13 12.45 13C12.8444 13 13 12.65 13 12.3444V10.4278C13 10.1278 12.75 9.87778 12.45 9.87778Z",
      fill: "#6A6A72"
    }
  )),
  plus: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M9 2H7V7H2V9H7V14H9V9H14V7H9V2Z", fill: "#666679" })),
  plus24: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M13 3H11V11H3V13H11V21H13V13H21V11H13V3Z", fill: "#666679" })),
  profile: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 19C3 15.6863 5.68629 13 9 13H15C18.3137 13 21 15.6863 21 19V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V19Z",
      fill: "#666679"
    }
  )),
  refresh: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13 11L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.171 19 17.8496 16.8915 18.7101 14H20.777C19.8675 18.008 16.2832 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604L21 3V11H13Z",
      fill: "#666679"
    }
  )),
  refresh12: /* @__PURE__ */ e.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.66667 5.33333L9.29983 2.70017C8.45533 1.85567 7.28866 1.33333 6 1.33333C3.42267 1.33333 1.33333 3.42267 1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667C8.11401 10.6667 9.89972 9.26099 10.4734 7.33333H11.8513C11.245 10.0053 8.85545 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C7.65685 0 9.15685 0.671573 10.2426 1.75736L12 0V5.33333H6.66667Z",
      fill: "#666679"
    }
  )),
  reorder: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.5 3C2.22386 3 2 3.22386 2 3.5C2 3.77614 2.22386 4 2.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H2.5ZM2.5 6C2.22386 6 2 6.22386 2 6.5C2 6.77614 2.22386 7 2.5 7H13.5C13.7761 7 14 6.77614 14 6.5C14 6.22386 13.7761 6 13.5 6H2.5ZM2 9.5C2 9.22386 2.22386 9 2.5 9H13.5C13.7761 9 14 9.22386 14 9.5C14 9.77614 13.7761 10 13.5 10H2.5C2.22386 10 2 9.77614 2 9.5ZM2.5 12C2.22386 12 2 12.2239 2 12.5C2 12.7761 2.22386 13 2.5 13H13.5C13.7761 13 14 12.7761 14 12.5C14 12.2239 13.7761 12 13.5 12H2.5Z",
      fill: "#666679"
    }
  )),
  reports: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H4.5C4.77614 2 5 2.22386 5 2.5V14H2V2.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11 8.5C11 8.22386 11.2239 8 11.5 8H13.5C13.7761 8 14 8.22386 14 8.5V14H11V8.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.5 5.5C6.5 5.22386 6.72386 5 7 5H9C9.27614 5 9.5 5.22386 9.5 5.5V14H6.5V5.5Z",
      fill: "#666679"
    }
  )),
  save: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM15 9H5V5H15V9Z",
      fill: "#666679"
    }
  )),
  "scatter-graph": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M3 3H5V19H21V21H3V3Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 12C10.1046 12 11 11.1046 11 10C11 8.89543 10.1046 8 9 8C7.89543 8 7 8.89543 7 10C7 11.1046 7.89543 12 9 12Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 15C16 16.1046 15.1046 17 14 17C12.8954 17 12 16.1046 12 15C12 13.8954 12.8954 13 14 13C15.1046 13 16 13.8954 16 15Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 10C18.1046 10 19 9.10457 19 8C19 6.89543 18.1046 6 17 6C15.8954 6 15 6.89543 15 8C15 9.10457 15.8954 10 17 10Z",
      fill: "#666679"
    }
  )),
  search: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.61752 11.0317C8.73148 11.6424 7.6575 12 6.5 12C3.46243 12 1 9.53757 1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5C12 7.6575 11.6424 8.73148 11.0317 9.61752L15.4142 14L14 15.4142L9.61752 11.0317ZM10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5Z",
      fill: "#666679"
    }
  )),
  settings: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9848 3.98828C10.6759 3.75811 10.3396 3.56276 9.98159 3.40805L9.58037 1.40194C9.53363 1.16823 9.32842 1 9.09008 1H6.90988C6.67154 1 6.46634 1.16823 6.41959 1.40194L6.01837 3.40805C5.66036 3.56276 5.32401 3.75811 5.01515 3.98828L3.07609 3.33232C2.85032 3.25594 2.60202 3.34954 2.48285 3.55595L1.39275 5.44406C1.27358 5.65047 1.31667 5.9123 1.4957 6.06963L3.03317 7.4208C3.01125 7.61083 2.99998 7.8041 2.99998 8C2.99998 8.1959 3.01125 8.38918 3.03317 8.57921L1.4957 9.93038C1.31667 10.0877 1.27358 10.3495 1.39275 10.556L2.48285 12.4441C2.60202 12.6505 2.85032 12.7441 3.07609 12.6677L5.01516 12.0117C5.32402 12.2419 5.66036 12.4372 6.01837 12.5919L6.41959 14.5981C6.46634 14.8318 6.67154 15 6.90988 15H9.09008C9.32842 15 9.53363 14.8318 9.58037 14.5981L9.98159 12.5919C10.3396 12.4372 10.6759 12.2419 10.9848 12.0117L12.9239 12.6677C13.1496 12.7441 13.3979 12.6505 13.5171 12.4441L14.6072 10.556C14.7264 10.3495 14.6833 10.0877 14.5043 9.93038L12.9668 8.57921C12.9887 8.38918 13 8.19591 13 8C13 7.8041 12.9887 7.61083 12.9668 7.4208L14.5043 6.06963C14.6833 5.9123 14.7264 5.65047 14.6072 5.44406L13.5171 3.55595C13.3979 3.34954 13.1496 3.25594 12.9239 3.33232L10.9848 3.98828ZM7.99998 10.5C9.38069 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38069 5.5 7.99998 5.5C6.61927 5.5 5.49998 6.61929 5.49998 8C5.49998 9.38071 6.61927 10.5 7.99998 10.5Z",
      fill: "#666679"
    }
  )),
  shield: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.80102 3.3702C3.69159 2.98484 6.35387 1.82306 8 1C9.65025 1.82512 12.3217 3.03151 13.2056 3.42822C13.3857 3.50905 13.5 3.68821 13.5 3.88562V6C13.5 11 8 14 8 14C8 14 2.5 11 2.5 6V3.83011C2.5 3.6301 2.61746 3.44963 2.80102 3.3702Z",
      fill: "#666679"
    }
  )),
  show: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 8.00002C15 8.00002 13 3.49998 8 3.5C3 3.50002 1 8 1 8C1 8 3 12.5 8 12.5C13 12.5 15 8.00002 15 8.00002ZM8 11C9.65686 11 11 9.65686 11 8.00001C11 6.34315 9.65686 5.00001 8 5.00001C6.34315 5.00001 5 6.34315 5 8.00001C5 9.65686 6.34315 11 8 11Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 8.00001C9 8.55229 8.55229 9.00001 8 9.00001C7.44772 9.00001 7 8.55229 7 8.00001C7 7.44772 7.44772 7.00001 8 7.00001C8.55229 7.00001 9 7.44772 9 8.00001Z",
      fill: "#666679"
    }
  )),
  support: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 5C10.0314 5 8 6.49259 8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9C10 7.75741 10.9686 7 12 7C13.0314 7 14 7.75741 14 9C14 9.23163 13.9183 9.47596 13.6992 9.80468C13.5136 10.0831 13.2836 10.3479 12.9949 10.6803C12.9148 10.7724 12.8301 10.8699 12.7407 10.9742C11.965 11.8793 11 13.1181 11 15H13C13 13.8819 13.535 13.1207 14.2593 12.2758C14.3232 12.2012 14.3908 12.1236 14.4606 12.0434C14.7598 11.6998 15.0995 11.3098 15.3633 10.9141C15.7067 10.399 16 9.76837 16 9C16 6.49259 13.9686 5 12 5ZM13 19V17H11V19H13Z",
      fill: "#666679"
    }
  )),
  revert: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("path", { d: "M2 17V7L12 17H2Z", fill: "#666679" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.6184 15.2545C21.4252 11.0665 17.5707 8 13 8C9.61043 8 6.61477 9.68638 4.80624 12.2659L6.61994 13.1728C8.08068 11.2451 10.3949 10 13 10C16.8828 10 20.1195 12.7662 20.847 16.4354L22.6184 15.2545Z",
      fill: "#666679"
    }
  )),
  revert16: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.45854 7.61333C4.7561 6.45185 6.39512 5.72593 8.17073 5.72593C11.3805 5.72593 14.0439 7.9037 15 10.9526L13.361 11.5333C12.678 9.21037 10.561 7.54074 8.17073 7.54074C6.87317 7.54074 5.6439 8.04889 4.6878 8.92L7.14634 11.5333H1V5L3.45854 7.61333Z",
      fill: "#666679"
    }
  )),
  sandbox: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.69528 11.2497L7.11005 9.66446L13.1446 3.62992L14.0813 4.56666C14.2975 4.78278 14.6218 4.78278 14.8379 4.56666C15.054 4.35053 15.054 4.02622 14.8379 3.81009L12.1899 1.16209C11.9738 0.945969 11.6495 0.945969 11.4333 1.16209C11.2172 1.37822 11.2172 1.70253 11.4333 1.91866L12.3701 2.8554L6.35355 8.88994L4.76832 7.30472C4.5522 7.08859 4.22788 7.08859 4.01175 7.30472L2.1203 9.19618C0.931369 10.3851 0.661229 12.1683 1.45383 13.7356C1.54392 13.9337 1.68804 14.0779 1.81407 14.1859C1.92213 14.294 2.06625 14.4381 2.26441 14.5282C3.77751 15.3569 5.61493 15.0687 6.82184 13.8618L8.69531 12.0062C8.91144 11.7901 8.9114 11.4479 8.69528 11.2497Z",
      fill: "#B0480E"
    }
  )),
  task: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 1C6.69378 1 5.58254 1.83481 5.17071 3H3C2.44772 3 2 3.44772 2 4V14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V4C14 3.44772 13.5523 3 13 3H10.8293C10.4175 1.83481 9.30622 1 8 1ZM4 7V6H12V7H4ZM12 9V10H4V9H12ZM9 12H4V13H9V12ZM8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5Z",
      fill: "#666679"
    }
  )),
  thumbnail: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1 0a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1H1zm1 20l4-6 4 4 6-8 6 10H2z",
      fill: "#A7A8BD"
    }
  )),
  trash: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V8H6V19ZM19 5C19 4.44772 18.5523 4 18 4H15.5L14.5 3H9.5L8.5 4H6C5.44772 4 5 4.44772 5 5C5 5.55228 5.44772 6 6 6H18C18.5523 6 19 5.55228 19 5Z",
      fill: "#666679"
    }
  )),
  upload: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 11H7L7 5L4 5L8 1L12 5L9 5L9 11ZM15 9H13V13H3V9H1V15H3H13H15V9Z",
      fill: "#666679"
    }
  )),
  user: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14 14C14 14 14 9 8 9C2 9 2 14 2 14H14Z", fill: "#666679" })),
  "user-24": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 19C3 15.6863 5.68629 13 9 13H15C18.3137 13 21 15.6863 21 19V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V19Z",
      fill: "#666679"
    }
  )),
  "view-more-horizontal": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.5 8.5C9.5 9.32843 8.82843 10 8 10C7.17157 10 6.5 9.32843 6.5 8.5C6.5 7.67157 7.17157 7 8 7C8.82843 7 9.5 7.67157 9.5 8.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5 8.5C14.5 9.32843 13.8284 10 13 10C12.1716 10 11.5 9.32843 11.5 8.5C11.5 7.67157 12.1716 7 13 7C13.8284 7 14.5 7.67157 14.5 8.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.5 8.5C4.5 9.32843 3.82843 10 3 10C2.17157 10 1.5 9.32843 1.5 8.5C1.5 7.67157 2.17157 7 3 7C3.82843 7 4.5 7.67157 4.5 8.5Z",
      fill: "#666679"
    }
  )),
  "view-more-vertical": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 10C7.17157 10 6.5 9.32843 6.5 8.5C6.5 7.67157 7.17157 7 8 7C8.82843 7 9.5 7.67157 9.5 8.5C9.5 9.32843 8.82843 10 8 10Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 15C7.17157 15 6.5 14.3284 6.5 13.5C6.5 12.6716 7.17157 12 8 12C8.82843 12 9.5 12.6716 9.5 13.5C9.5 14.3284 8.82843 15 8 15Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 5C7.17157 5 6.5 4.32843 6.5 3.5C6.5 2.67157 7.17157 2 8 2C8.82843 2 9.5 2.67157 9.5 3.5C9.5 4.32843 8.82843 5 8 5Z",
      fill: "#666679"
    }
  )),
  "view-more-vertical-big": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15C10.7574 15 9.75 13.9926 9.75 12.75C9.75 11.5074 10.7574 10.5 12 10.5C13.2426 10.5 14.25 11.5074 14.25 12.75C14.25 13.9926 13.2426 15 12 15Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 22.5C10.7574 22.5 9.75 21.4926 9.75 20.25C9.75 19.0074 10.7574 18 12 18C13.2426 18 14.25 19.0074 14.25 20.25C14.25 21.4926 13.2426 22.5 12 22.5Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.5C10.7574 7.5 9.75 6.49264 9.75 5.25C9.75 4.00736 10.7574 3 12 3C13.2426 3 14.25 4.00736 14.25 5.25C14.25 6.49264 13.2426 7.5 12 7.5Z",
      fill: "#666679"
    }
  )),
  danger: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.55751 1.82179C7.74675 1.47033 8.25126 1.47142 8.43899 1.82368L14.5364 13.2648C14.7139 13.5979 14.4725 14 14.0952 14H1.83712C1.45879 14 1.21752 13.5961 1.39689 13.2629L7.55751 1.82179ZM7 6H9V10H7V6ZM9 11H7V13H9V11Z",
      fill: "#666679"
    }
  )),
  warning: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.55751 1.82179C7.74675 1.47033 8.25126 1.47142 8.43899 1.82368L14.5364 13.2648C14.7139 13.5979 14.4725 14 14.0952 14H1.83712C1.45879 14 1.21752 13.5961 1.39689 13.2629L7.55751 1.82179ZM7 6H9V10H7V6ZM9 11H7V13H9V11Z",
      fill: "#666679"
    }
  )),
  "zoom-in": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.45712 3.04291L2.70712 1.29291L1.29291 2.70712L3.04291 4.45712L1.50001 6.00001H6.00001L6.00001 1.50001L4.45712 3.04291Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M1.50001 10L6.00001 10L6.00002 14.5L4.45712 12.9571L2.70712 14.7071L1.29291 13.2929L3.04291 11.5429L1.50001 10Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5 6.00002L10 6.00001L10 1.50001L11.5429 3.04291L13.2929 1.29291L14.7071 2.70712L12.9571 4.45712L14.5 6.00002Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 14.5V10H14.5L12.9571 11.5429L14.7071 13.2929L13.2929 14.7071L11.5429 12.9571L10 14.5Z",
      fill: "#666679"
    }
  )),
  "zoom-out": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 2V6.5L3.54289 4.95711L5.29291 6.70712L6.70712 5.29291L4.95711 3.54289L6.5 2H2Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 2H9.5L11.0429 3.54289L9.29288 5.29291L10.7071 6.70712L12.4571 4.95711L14 6.5V2Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.5 14H2V9.5L3.54289 11.0429L5.29291 9.29288L6.70712 10.7071L4.95711 12.4571L6.5 14Z",
      fill: "#666679"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14 14V9.5L12.4571 11.0429L10.7071 9.29288L9.29288 10.7071L11.0429 12.4571L9.5 14H14Z",
      fill: "#666679"
    }
  )),
  "stacked-graph": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 3V21H21V19H7.9432L11.1276 14.5418L15.1276 18.5418L17.4743 15.2564C17.6855 15.6316 17.896 16.0281 18.1056 16.4472L19.8944 15.5528C19.5195 14.803 19.1366 14.1114 18.7469 13.4749L20.8137 10.5812L19.1863 9.41876L17.5474 11.7133C15.4802 8.99818 13.2618 7.65116 11.0441 7.24162C8.77402 6.82242 6.67999 7.42119 5 8.26152V3H3ZM5 10.5474V19H5.4854L10.8724 11.4582L14.8724 15.4582L16.3244 13.4255C14.3642 10.6472 12.398 9.52546 10.6809 9.20837C8.59338 8.82288 6.5972 9.57063 5 10.5474Z",
      fill: "#666679"
    }
  )),
  star: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 12.5L13 15L11.5 10L15 6.5L10 6L8 1L6 6L1 6.5L4.5 10L3 15L8 12.5Z",
      fill: "#666679"
    }
  )),
  "star-full": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 12.5L13 15L11.5 10L15 6.5L10 6L8 1L6 6L1 6.5L4.5 10L3 15L8 12.5Z",
      fill: "#666679"
    }
  )),
  "star-empty": /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 11.382L11.3771 13.0705L10.3705 9.71524L12.8007 7.28506L9.29684 6.93467L8 3.69258L6.70316 6.93467L3.19927 7.28506L5.62946 9.71524L4.62287 13.0705L8 11.382ZM3 15L4.5 10L1 6.5L6 6L8 1L10 6L15 6.5L11.5 10L13 15L8 12.5L3 15Z",
      fill: "#666679"
    }
  )),
  clock: /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 7.58579V3.5H7V8.41421L10.2929 11.7071L11.7071 10.2929L9 7.58579Z",
      fill: "#666679"
    }
  )),
  "empty-state-folder": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "124",
      height: "120",
      viewBox: "0 0 124 120",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "62", cy: "60", r: "60", fill: "#F8F9F9" }),
    /* @__PURE__ */ e.createElement("g", { filter: "url(#filter0_ddd)" }, /* @__PURE__ */ e.createElement("g", { filter: "url(#filter1_i)" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M56.164 34.1411C55.5951 33.4204 54.7275 33 53.8094 33H33C31.3431 33 30 34.3431 30 36V37V39V84C30 85.6569 31.3431 87 33 87H91C92.6569 87 94 85.6569 94 84V40C94 38.3431 92.6569 37 91 37H59.8749C58.9567 37 58.0891 36.5796 57.5202 35.8589L56.164 34.1411Z",
        fill: "#DEDFE6"
      }
    ))),
    /* @__PURE__ */ e.createElement("g", { filter: "url(#filter2_ii)" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30 46C30 44.3431 31.3431 43 33 43H91C92.6569 43 94 44.3431 94 46V84C94 85.6569 92.6569 87 91 87H33C31.3431 87 30 85.6569 30 84V46Z",
        fill: "#F8F9F9"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "filter",
      {
        id: "filter0_ddd",
        x: "0",
        y: "18",
        width: "124",
        height: "114",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      },
      /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", { dy: "15" }),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "15" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          type: "matrix",
          values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.12 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", { dy: "5" }),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "7.5" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          type: "matrix",
          values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.18 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow", result: "effect2_dropShadow" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", null),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          type: "matrix",
          values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.2 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow", result: "effect3_dropShadow" }),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow", result: "shape" })
    ), /* @__PURE__ */ e.createElement(
      "filter",
      {
        id: "filter1_i",
        x: "30",
        y: "33",
        width: "64",
        height: "54",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      },
      /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", null),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "12.5" }),
      /* @__PURE__ */ e.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          type: "matrix",
          values: "0 0 0 0 0.680439 0 0 0 0 0.673021 0 0 0 0 0.758333 0 0 0 1 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow" })
    ), /* @__PURE__ */ e.createElement(
      "filter",
      {
        id: "filter2_ii",
        x: "30",
        y: "43",
        width: "79",
        height: "69",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      },
      /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", null),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "15" }),
      /* @__PURE__ */ e.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          type: "matrix",
          values: "0 0 0 0 0.803922 0 0 0 0 0.807843 0 0 0 0 0.85098 0 0 0 0.6 0"
        }
      ),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow" }),
      /* @__PURE__ */ e.createElement(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }
      ),
      /* @__PURE__ */ e.createElement("feOffset", { dx: "15", dy: "25" }),
      /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "12.5" }),
      /* @__PURE__ */ e.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }),
      /* @__PURE__ */ e.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0" }),
      /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "effect1_innerShadow", result: "effect2_innerShadow" })
    ))
  )
}, Ft = {
  "present-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#present-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.80176 5.09503C7.74734 4.54539 10.6118 6.54266 11.167 6.94165C10.773 7.19229 10.5103 7.63009 10.5049 8.13022L6.55552 7.28387C6.55552 7.28387 6.32553 5.37167 6.80176 5.09503Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.7148 6.95217C13.2319 6.57975 16.1406 4.54023 17.0949 5.09503C17.5712 5.37167 17.3414 7.28387 17.3414 7.28387L13.3596 8.13692C13.3568 7.64137 13.1012 7.20586 12.7148 6.95217Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.4336 8.14716C11.4336 7.87103 11.6575 7.64716 11.9336 7.64716C12.2097 7.64716 12.4336 7.87103 12.4336 8.14716H11.4336Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5 9H6C5.44772 9 5 9.44772 5 10V11H11.5V9ZM11.5 12H5V17C5 17.5523 5.44772 18 6 18H11.5V12ZM12.5 18V12H19V17C19 17.5523 18.5523 18 18 18H12.5ZM12.5 11V9H18C18.5523 9 19 9.44772 19 10V11H12.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "present-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "present-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#present-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.80176 5.09503C7.74734 4.54539 10.6118 6.54266 11.167 6.94165C10.773 7.19229 10.5103 7.63009 10.5049 8.13022L6.55552 7.28387C6.55552 7.28387 6.32553 5.37167 6.80176 5.09503Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.7148 6.95217C13.2319 6.57975 16.1406 4.54023 17.0949 5.09503C17.5712 5.37167 17.3414 7.28387 17.3414 7.28387L13.3596 8.13692C13.3568 7.64137 13.1012 7.20586 12.7148 6.95217Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.4336 8.14716C11.4336 7.87103 11.6575 7.64716 11.9336 7.64716C12.2097 7.64716 12.4336 7.87103 12.4336 8.14716H11.4336Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5 9H6C5.44772 9 5 9.44772 5 10V11H11.5V9ZM11.5 12H5V17C5 17.5523 5.44772 18 6 18H11.5V12ZM12.5 18V12H19V17C19 17.5523 18.5523 18 18 18H12.5ZM12.5 11V9H18C18.5523 9 19 9.44772 19 10V11H12.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "present-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "dollar-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#dollar-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.29 19.5H12.6234C12.9262 19.5 13.1775 19.2525 13.1775 18.9459V17.6643L13.4545 17.5903C15.7149 17.0215 16.5165 15.4666 16.5165 14.3105C16.5165 12.1682 14.6696 11.2781 12.8597 10.6871C11.1607 10.1257 10.6178 9.78577 10.6178 9.28344C10.6178 8.83288 11.1385 8.38214 12.3058 8.38214C13.5912 8.38214 14.3964 8.74777 14.7398 8.90664C14.8138 8.9398 14.8912 8.95842 14.9687 8.95842C15.1829 8.95842 15.3787 8.83288 15.4711 8.64067L15.9993 7.52146C16.0621 7.39219 16.0695 7.23704 16.0177 7.10033C15.9697 6.9599 15.8663 6.84908 15.7333 6.78631C15.098 6.48717 14.4073 6.29496 13.6279 6.20276L13.3028 6.16216V5.05039C13.3028 4.74753 13.0553 4.5 12.7487 4.5H11.4375C11.1346 4.5 10.8834 4.74753 10.8834 5.05039V6.28769L10.6064 6.35791C8.78166 6.81964 7.69206 7.99046 7.69206 9.48647C7.69206 11.4589 9.64607 12.3379 11.563 12.94C13.3323 13.5163 13.5724 14.0149 13.5724 14.4286C13.5724 15.0676 12.745 15.5329 11.6074 15.5329C10.6396 15.5329 9.59802 15.2854 8.82227 14.8717C8.74105 14.8274 8.6524 14.8052 8.56002 14.8052C8.50097 14.8052 8.44175 14.8164 8.3827 14.8348C8.23872 14.8866 8.12045 14.9937 8.05768 15.134L7.5479 16.2679C7.43335 16.5301 7.52946 16.833 7.78054 16.9734C8.42685 17.3465 9.38719 17.6235 10.4068 17.738L10.7355 17.7714V18.9459C10.7359 19.2525 10.9834 19.5 11.29 19.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "dollar-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "dollar-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#dollar-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.29 19.5H12.6234C12.9262 19.5 13.1775 19.2525 13.1775 18.9459V17.6643L13.4545 17.5903C15.7149 17.0215 16.5165 15.4666 16.5165 14.3105C16.5165 12.1682 14.6696 11.2781 12.8597 10.6871C11.1607 10.1257 10.6178 9.78577 10.6178 9.28344C10.6178 8.83288 11.1385 8.38214 12.3058 8.38214C13.5912 8.38214 14.3964 8.74777 14.7398 8.90664C14.8138 8.9398 14.8912 8.95842 14.9687 8.95842C15.1829 8.95842 15.3787 8.83288 15.4711 8.64067L15.9993 7.52146C16.0621 7.39219 16.0695 7.23704 16.0177 7.10033C15.9697 6.9599 15.8663 6.84908 15.7333 6.78631C15.098 6.48717 14.4073 6.29496 13.6279 6.20276L13.3028 6.16216V5.05039C13.3028 4.74753 13.0553 4.5 12.7487 4.5H11.4375C11.1346 4.5 10.8834 4.74753 10.8834 5.05039V6.28769L10.6064 6.35791C8.78166 6.81964 7.69206 7.99046 7.69206 9.48647C7.69206 11.4589 9.64607 12.3379 11.563 12.94C13.3323 13.5163 13.5724 14.0149 13.5724 14.4286C13.5724 15.0676 12.745 15.5329 11.6074 15.5329C10.6396 15.5329 9.59802 15.2854 8.82227 14.8717C8.74105 14.8274 8.6524 14.8052 8.56002 14.8052C8.50097 14.8052 8.44175 14.8164 8.3827 14.8348C8.23872 14.8866 8.12045 14.9937 8.05768 15.134L7.5479 16.2679C7.43335 16.5301 7.52946 16.833 7.78054 16.9734C8.42685 17.3465 9.38719 17.6235 10.4068 17.738L10.7355 17.7714V18.9459C10.7359 19.2525 10.9834 19.5 11.29 19.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "dollar-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "business-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#business-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 6V8H6C5.44772 8 5 8.44772 5 9V10H19V9C19 8.44772 18.5523 8 18 8H15V6C15 5.44772 14.5523 5 14 5H10C9.44772 5 9 5.44772 9 6ZM14 6H10V8H14V6Z",
        fill: "url(#business-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19 12H5V16C5 16.5523 5.44772 17 6 17H18C18.5523 17 19 16.5523 19 16V12Z",
        fill: "url(#business-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-active-1",
        x1: "18.4171",
        y1: "19.7579",
        x2: "18.4171",
        y2: "28.992",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-active-2",
        x1: "18.4171",
        y1: "19.7579",
        x2: "18.4171",
        y2: "28.992",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "business-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#business-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 6V8H6C5.44772 8 5 8.44772 5 9V10H19V9C19 8.44772 18.5523 8 18 8H15V6C15 5.44772 14.5523 5 14 5H10C9.44772 5 9 5.44772 9 6ZM14 6H10V8H14V6Z",
        fill: "url(#business-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19 12H5V16C5 16.5523 5.44772 17 6 17H18C18.5523 17 19 16.5523 19 16V12Z",
        fill: "url(#business-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-inactive-1",
        x1: "12",
        y1: "2.38509e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "business-inactive-2",
        x1: "12",
        y1: "2.38509e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "credit-empty": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#credit-empty)" }),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        x: "5.39999",
        y: "5.4",
        width: "12.9996",
        height: "12.9996",
        rx: "0.974971",
        fill: "url(#credit-empty-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.70001 7.5122C6.70001 7.42246 6.77276 7.34971 6.86251 7.34971H15.6372C15.727 7.34971 15.7997 7.42246 15.7997 7.5122V8.48717C15.7997 8.57692 15.727 8.64967 15.6372 8.64967H6.86251C6.77276 8.64967 6.70001 8.57692 6.70001 8.48717V7.5122Z",
        fill: "url(#credit-empty-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.70001 10.1121C6.70001 10.0224 6.77276 9.94963 6.86251 9.94963H13.0373C13.1271 9.94963 13.1998 10.0224 13.1998 10.1121V11.0871C13.1998 11.1768 13.1271 11.2496 13.0373 11.2496H6.86251C6.77276 11.2496 6.70001 11.1768 6.70001 11.0871V10.1121Z",
        fill: "url(#credit-empty-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.9756 12.9267C14.9212 12.7905 14.7284 12.7905 14.6739 12.9267L14.2127 14.0798C14.1895 14.1377 14.1353 14.1773 14.0731 14.1816L12.9283 14.2611C12.7857 14.271 12.7245 14.4469 12.83 14.5432L13.777 15.408C13.8218 15.4489 13.8401 15.5112 13.8245 15.5697L13.532 16.6726C13.4932 16.8187 13.6575 16.9339 13.7817 16.8478L14.7322 16.1887C14.7879 16.15 14.8617 16.15 14.9174 16.1887L15.8679 16.8478C15.9921 16.9339 16.1563 16.8187 16.1175 16.6726L15.825 15.5697C15.8095 15.5112 15.8278 15.4489 15.8725 15.408L16.8196 14.5432C16.9251 14.4469 16.8638 14.271 16.7213 14.2611L15.5765 14.1816C15.5143 14.1773 15.46 14.1377 15.4369 14.0798L14.9756 12.9267Z",
        fill: "url(#credit-empty-4)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-empty",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-empty-1",
        x1: "12",
        y1: "1.53773e-06",
        x2: "12",
        y2: "24.15",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-empty-2",
        x1: "11.8999",
        y1: "5.72476",
        x2: "11.8999",
        y2: "17.0994",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-empty-3",
        x1: "11.8999",
        y1: "5.72476",
        x2: "11.8999",
        y2: "17.0994",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-empty-4",
        x1: "11.8999",
        y1: "5.72476",
        x2: "11.8999",
        y2: "17.0994",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "code-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#code-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.9353 5.24148C12.971 5.10811 13.1081 5.02897 13.2415 5.0647L14.6904 5.45293C14.8237 5.48867 14.9029 5.62575 14.8671 5.75912L11.3731 18.7991C11.3374 18.9325 11.2003 19.0116 11.0669 18.9759L9.61801 18.5877C9.48465 18.5519 9.4055 18.4148 9.44124 18.2815L12.9353 5.24148Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.48008 14.6443C8.57772 14.7419 8.57772 14.9002 8.48009 14.9978L7.41943 16.0585C7.32179 16.1561 7.1635 16.1561 7.06587 16.0585L3.17678 12.1694C3.07915 12.0718 3.07915 11.9135 3.17678 11.8159L4.23744 10.7552C4.33508 10.6576 4.49337 10.6576 4.591 10.7552L8.48008 14.6443Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4.59099 13.2301C4.49336 13.3277 4.33507 13.3277 4.23744 13.2301L3.17678 12.1694C3.07915 12.0718 3.07915 11.9135 3.17678 11.8159L7.06587 7.92678C7.1635 7.82914 7.32179 7.82914 7.41942 7.92678L8.48008 8.98744C8.57771 9.08507 8.57771 9.24336 8.48008 9.34099L4.59099 13.2301Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.5199 9.34099C15.4223 9.24336 15.4223 9.08507 15.5199 8.98744L16.5806 7.92678C16.6782 7.82914 16.8365 7.82914 16.9341 7.92678L20.8232 11.8159C20.9209 11.9135 20.9209 12.0718 20.8232 12.1694L19.7626 13.2301C19.6649 13.3277 19.5066 13.3277 19.409 13.2301L15.5199 9.34099Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19.409 10.7552C19.5066 10.6576 19.6649 10.6576 19.7626 10.7552L20.8232 11.8159C20.9209 11.9135 20.9209 12.0718 20.8232 12.1694L16.9341 16.0585C16.8365 16.1561 16.6782 16.1561 16.5806 16.0585L15.5199 14.9978C15.4223 14.9002 15.4223 14.7419 15.5199 14.6443L19.409 10.7552Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "code-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "code-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#code-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.9353 5.24148C12.971 5.10811 13.1081 5.02897 13.2415 5.0647L14.6904 5.45293C14.8237 5.48867 14.9029 5.62575 14.8671 5.75912L11.3731 18.7991C11.3373 18.9325 11.2003 19.0116 11.0669 18.9759L9.618 18.5877C9.48464 18.5519 9.40549 18.4148 9.44123 18.2815L12.9353 5.24148Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.48008 14.6443C8.57772 14.7419 8.57772 14.9002 8.48009 14.9978L7.41943 16.0585C7.32179 16.1561 7.1635 16.1561 7.06587 16.0585L3.17678 12.1694C3.07915 12.0718 3.07915 11.9135 3.17678 11.8159L4.23744 10.7552C4.33508 10.6576 4.49337 10.6576 4.591 10.7552L8.48008 14.6443Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4.59099 13.2301C4.49336 13.3277 4.33507 13.3277 4.23744 13.2301L3.17678 12.1694C3.07915 12.0718 3.07915 11.9135 3.17678 11.8159L7.06587 7.92678C7.1635 7.82915 7.32179 7.82915 7.41942 7.92678L8.48008 8.98744C8.57771 9.08507 8.57771 9.24336 8.48008 9.34099L4.59099 13.2301Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.5199 9.34099C15.4223 9.24336 15.4223 9.08507 15.5199 8.98744L16.5806 7.92678C16.6782 7.82915 16.8365 7.82915 16.9341 7.92678L20.8232 11.8159C20.9209 11.9135 20.9209 12.0718 20.8232 12.1694L19.7626 13.2301C19.6649 13.3277 19.5066 13.3277 19.409 13.2301L15.5199 9.34099Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19.409 10.7552C19.5066 10.6576 19.6649 10.6576 19.7626 10.7552L20.8232 11.8159C20.9209 11.9135 20.9209 12.0718 20.8232 12.1694L16.9341 16.0585C16.8365 16.1561 16.6782 16.1561 16.5806 16.0585L15.5199 14.9978C15.4223 14.9002 15.4223 14.7419 15.5199 14.6443L19.409 10.7552Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "code-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12",
        y1: "1.90651e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12",
        y1: "1.90651e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "12",
        y1: "1.90651e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "12",
        y1: "1.90651e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "12",
        y1: "1.90651e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "express-sb-setup-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#express-sb-setup-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.5305 3.8607L7.20166 13.6303C7.11079 13.7969 7.23137 14 7.42114 14H10.75C10.8881 14 11 14.1119 11 14.25V20.0196C11 20.2786 11.3455 20.3667 11.4695 20.1393L16.7983 10.3697C16.8892 10.2031 16.7686 10 16.5789 10H13.25C13.1119 10 13 9.88807 13 9.75V3.98042C13 3.72141 12.6545 3.63333 12.5305 3.8607Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "express-sb-setup-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "express-sb-setup-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#express-sb-setup-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.5305 3.8607L7.20166 13.6303C7.11079 13.7969 7.23137 14 7.42114 14H10.75C10.8881 14 11 14.1119 11 14.25V20.0196C11 20.2786 11.3455 20.3667 11.4695 20.1393L16.7983 10.3697C16.8892 10.2031 16.7686 10 16.5789 10H13.25C13.1119 10 13 9.88807 13 9.75V3.98042C13 3.72141 12.6545 3.63333 12.5305 3.8607Z",
        fill: "url(#express-sb-setup-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "express-sb-setup-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "express-sb-setup-inactive-1",
        x1: "12",
        y1: "1.83331e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "feedback-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#feedback-active)" }),
    /* @__PURE__ */ e.createElement("path", { d: "M12 19L10 17H14L12 19Z", fill: "white" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 6C5.44772 6 5 6.44772 5 7V16C5 16.5523 5.44772 17 6 17H18C18.5523 17 19 16.5523 19 16V7C19 6.44772 18.5523 6 18 6H6ZM9 12.5C9.55228 12.5 10 12.0523 10 11.5C10 10.9477 9.55228 10.5 9 10.5C8.44772 10.5 8 10.9477 8 11.5C8 12.0523 8.44772 12.5 9 12.5ZM13 11.5C13 12.0523 12.5523 12.5 12 12.5C11.4477 12.5 11 12.0523 11 11.5C11 10.9477 11.4477 10.5 12 10.5C12.5523 10.5 13 10.9477 13 11.5ZM15 12.5C15.5523 12.5 16 12.0523 16 11.5C16 10.9477 15.5523 10.5 15 10.5C14.4477 10.5 14 10.9477 14 11.5C14 12.0523 14.4477 12.5 15 12.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "feedback-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "feedback-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#feedback-inactive)" }),
    /* @__PURE__ */ e.createElement("path", { d: "M12 19L10 17H14L12 19Z", fill: "url(#feedback-inactive-1)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 6C5.44772 6 5 6.44772 5 7V16C5 16.5523 5.44772 17 6 17H18C18.5523 17 19 16.5523 19 16V7C19 6.44772 18.5523 6 18 6H6ZM9 12.5C9.55228 12.5 10 12.0523 10 11.5C10 10.9477 9.55228 10.5 9 10.5C8.44772 10.5 8 10.9477 8 11.5C8 12.0523 8.44772 12.5 9 12.5ZM13 11.5C13 12.0523 12.5523 12.5 12 12.5C11.4477 12.5 11 12.0523 11 11.5C11 10.9477 11.4477 10.5 12 10.5C12.5523 10.5 13 10.9477 13 11.5ZM15 12.5C15.5523 12.5 16 12.0523 16 11.5C16 10.9477 15.5523 10.5 15 10.5C14.4477 10.5 14 10.9477 14 11.5C14 12.0523 14.4477 12.5 15 12.5Z",
        fill: "url(#feedback-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "feedback-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "feedback-inactive-1",
        x1: "12",
        y1: "3.15441e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "feedback-inactive-2",
        x1: "12",
        y1: "3.15441e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "gateway-approval-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#gateway-approval-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4.17805 9.47642L11.7969 6.09025C11.9262 6.03279 12.0738 6.03279 12.2031 6.09025L19.8219 9.47642C20.2391 9.66182 20.2101 10.2633 19.777 10.4077L12.1581 12.9473C12.0555 12.9815 11.9445 12.9815 11.8419 12.9473L4.22301 10.4077C3.78994 10.2633 3.76091 9.66182 4.17805 9.47642Z",
        fill: "url(#gateway-approval-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.80431 13.4413C6.68981 13.407 6.5668 13.4148 6.45756 13.4633L4.17805 14.4764C3.7609 14.6618 3.78994 15.2633 4.223 15.4077L11.8419 17.9473C11.9445 17.9815 12.0555 17.9815 12.1581 17.9473L19.777 15.4077C20.21 15.2633 20.2391 14.6618 19.8219 14.4764L17.5424 13.4633C17.4332 13.4148 17.3102 13.407 17.1957 13.4413L12.1437 14.9569C12.0499 14.985 11.95 14.985 11.8563 14.9569L6.80431 13.4413Z",
        fill: "url(#gateway-approval-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-active-1",
        x1: "18.5928",
        y1: "20.6433",
        x2: "18.5928",
        y2: "26.4428",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-active-2",
        x1: "18.5928",
        y1: "20.6433",
        x2: "18.5928",
        y2: "26.4428",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "gateway-approval-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#gateway-approval-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4.17805 9.47642L11.7969 6.09025C11.9262 6.03279 12.0738 6.03279 12.2031 6.09025L19.8219 9.47642C20.2391 9.66182 20.2101 10.2633 19.777 10.4077L12.1581 12.9473C12.0555 12.9815 11.9445 12.9815 11.8419 12.9473L4.22301 10.4077C3.78994 10.2633 3.76091 9.66182 4.17805 9.47642Z",
        fill: "url(#gateway-approval-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.80431 13.4413C6.68981 13.407 6.5668 13.4148 6.45756 13.4633L4.17805 14.4764C3.7609 14.6618 3.78994 15.2633 4.223 15.4077L11.8419 17.9473C11.9445 17.9815 12.0555 17.9815 12.1581 17.9473L19.777 15.4077C20.21 15.2633 20.2391 14.6618 19.8219 14.4764L17.5424 13.4633C17.4332 13.4148 17.3102 13.407 17.1957 13.4413L12.1437 14.9569C12.0499 14.985 11.95 14.985 11.8563 14.9569L6.80431 13.4413Z",
        fill: "url(#gateway-approval-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-inactive-1",
        x1: "12",
        y1: "-4.82353e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "gateway-approval-inactive-2",
        x1: "12",
        y1: "-4.82353e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "guided-sb-setup-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#guided-sb-setup-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.4166 5.25428L9.97026 8.93604C9.50731 9.13784 9.13784 9.50731 8.93604 9.97026L5.25428 18.4166C5.1635 18.6249 5.37509 18.8365 5.58335 18.7457L14.0297 15.064C14.4927 14.8622 14.8622 14.4927 15.064 14.0297L18.7457 5.58335C18.8365 5.37509 18.6249 5.1635 18.4166 5.25428ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "guided-sb-setup-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "guided-sb-setup-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#guided-sb-setup-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.4166 5.25428L9.97026 8.93604C9.50731 9.13784 9.13784 9.50731 8.93604 9.97026L5.25428 18.4166C5.1635 18.6249 5.37509 18.8365 5.58335 18.7457L14.0297 15.064C14.4927 14.8622 14.8622 14.4927 15.064 14.0297L18.7457 5.58335C18.8365 5.37509 18.6249 5.1635 18.4166 5.25428ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
        fill: "url(#guided-sb-setup-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "guided-sb-setup-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "guided-sb-setup-inactive-1",
        x1: "12",
        y1: "-5.88274e-08",
        x2: "11.5511",
        y2: "23.9916",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "fingerprint-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "url(#fingerprint-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 10L11.4265 9.18077C10.9741 9.49748 10.8641 10.121 11.1808 10.5735C11.4974 11.0258 12.1206 11.1359 12.573 10.8196L12.5794 10.8151L12.6138 10.7919C12.646 10.7704 12.6968 10.7369 12.7654 10.6933C12.9026 10.606 13.1108 10.478 13.3842 10.3228C13.9315 10.0122 14.7374 9.59398 15.7558 9.17468C17.7959 8.33462 20.6646 7.5 24 7.5C27.3355 7.5 30.2041 8.33462 32.2443 9.17468C33.2626 9.59398 34.0686 10.0122 34.6158 10.3228C34.8892 10.478 35.0974 10.606 35.2346 10.6933C35.3032 10.7369 35.354 10.7704 35.3862 10.7919L35.4206 10.8151L35.4265 10.8192C35.8789 11.1352 36.5027 11.0256 36.8192 10.5735C37.136 10.121 37.0259 9.49748 36.5735 9.18077L36 10C36.5735 9.18077 36.5735 9.18077 36.5735 9.18077L36.5704 9.17865L36.5656 9.17527L36.5503 9.16478L36.4981 9.12946C36.4537 9.09975 36.3902 9.05801 36.3084 9.00595C36.1448 8.90185 35.9077 8.75638 35.603 8.58344C34.994 8.23777 34.1124 7.78102 33.0058 7.32532C30.7959 6.41538 27.6646 5.5 24 5.5C20.3355 5.5 17.2041 6.41538 14.9943 7.32532C13.8876 7.78102 13.0061 8.23777 12.397 8.58344C12.0923 8.75638 11.8552 8.90185 11.6917 9.00595C11.6098 9.05801 11.5464 9.09975 11.502 9.12946L11.4497 9.16478L11.4345 9.17527L11.4296 9.17865L11.4265 9.18077C11.4265 9.18077 11.4265 9.18077 12 10Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.0001 28.5C24.5523 28.5 25.0001 28.9477 25.0001 29.5C25.0001 32.7361 26.1415 34.8075 27.7498 36.0941C29.3943 37.4098 31.6482 38 34.0001 38C34.5523 38 35.0001 38.4477 35.0001 39C35.0001 39.5523 34.5523 40 34.0001 40C31.3519 40 28.6058 39.3402 26.5004 37.6559C24.3587 35.9425 23.0001 33.2639 23.0001 29.5C23.0001 28.9477 23.4478 28.5 24.0001 28.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.7349 20.2888C31.7761 21.905 34.1914 25.0663 34.9863 29.8356C35.0771 30.3804 34.7091 30.8956 34.1643 30.9864C33.6196 31.0772 33.1043 30.7092 33.0135 30.1644C32.3084 25.9337 30.2238 23.345 27.7963 22.0549C25.3439 20.7516 22.4477 20.721 20.0291 21.7897C17.6267 22.8512 15.7038 24.9921 15.1564 28.0659C14.6061 31.1563 15.4244 35.3338 18.8321 40.4453C19.1385 40.9049 19.0143 41.5257 18.5548 41.8321C18.0953 42.1384 17.4744 42.0143 17.168 41.5547C13.5757 36.1663 12.519 31.4688 13.1874 27.7153C13.8587 23.9454 16.2483 21.2737 19.2208 19.9603C22.1772 18.654 25.7185 18.6858 28.7349 20.2888Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5286 19.0574C15.7721 15.6788 20.3188 14.4999 24 14.4999H24.0257L24.0514 14.5013C33.4942 14.988 38.8643 21.3344 39.9701 25.7574C40.5103 27.9183 40.4653 30.4059 39.5733 32.407C38.6512 34.4758 36.8186 35.9999 34 35.9999C30.6964 35.9999 28.8508 33.7083 28.0484 31.3499C27.8676 30.8186 27.7331 30.2684 27.6118 29.762C27.6023 29.722 27.5928 29.6824 27.5834 29.6431C27.47 29.1684 27.3663 28.7348 27.2382 28.3236C26.9612 27.4341 26.6205 26.829 26.0577 26.4528C24.8859 25.6696 23.3623 25.5969 22.1386 26.1952C20.9576 26.7727 20.0001 28.0058 20.0001 29.9999C20.0001 32.8281 20.7043 35.1055 22.0501 36.8999C23.3993 38.6988 25.4581 40.0985 28.3163 41.0513C28.8402 41.2259 29.1234 41.7922 28.9487 42.3162C28.7741 42.8401 28.2078 43.1233 27.6838 42.9486C24.5421 41.9014 22.101 40.3011 20.4501 38.0999C18.7959 35.8943 18.0001 33.1718 18.0001 29.9999C18.0001 27.2645 19.3726 25.3214 21.2601 24.3985C23.1047 23.4966 25.3878 23.5994 27.1691 24.79C28.2985 25.5449 28.8209 26.6795 29.1477 27.7287C29.297 28.2079 29.416 28.7066 29.5261 29.1678C29.5365 29.2109 29.5467 29.2538 29.5569 29.2963C29.6793 29.8075 29.7948 30.2735 29.9418 30.7057C30.5855 32.5976 31.8672 33.9999 34 33.9999C35.9413 33.9999 37.1087 33.024 37.7466 31.5928C38.4146 30.094 38.4896 28.0816 38.0298 26.2425C37.1365 22.6692 32.5149 16.9512 23.9743 16.5C20.6608 16.5055 16.7208 17.5785 13.9714 20.4425C11.2537 23.2734 9.5249 28.0394 10.9829 35.8157C11.0847 36.3585 10.7272 36.881 10.1843 36.9828C9.64152 37.0846 9.11897 36.7271 9.01719 36.1842C7.47524 27.9605 9.24639 22.4764 12.5286 19.0574Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 12.0066C17.9123 12.0066 11.9494 14.5678 8.84801 19.53C8.5553 19.9983 7.93835 20.1407 7.47001 19.848C7.00168 19.5553 6.8593 18.9383 7.15201 18.47C10.7118 12.7744 17.4183 10.0066 24 10.0066C30.5817 10.0066 37.2882 12.7744 40.848 18.47C41.1407 18.9383 40.9983 19.5553 40.53 19.848C40.0617 20.1407 39.4447 19.9983 39.152 19.53C36.0506 14.5678 30.0878 12.0066 24 12.0066Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "fingerprint-active",
        x1: "24",
        y1: "0",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "inbox-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#inbox-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.72361 6.55279C6.893 6.214 7.23926 6 7.61803 6H16.382C16.7607 6 17.107 6.214 17.2764 6.55279L19.8944 11.7889C19.9639 11.9277 20 12.0808 20 12.2361V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V12.2361C4 12.0808 4.03615 11.9277 4.10557 11.7889L6.72361 6.55279ZM7.9309 7.1382L5.6809 11.6382C5.59779 11.8044 5.71866 12 5.90451 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H18.0955C18.2813 12 18.4022 11.8044 18.3191 11.6382L16.0691 7.1382C16.0268 7.0535 15.9402 7 15.8455 7H8.15451C8.05982 7 7.97325 7.0535 7.9309 7.1382Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "inbox-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "inbox-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#inbox-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 6H17L20 12V17H4V12L7 6ZM7.9309 7.1382L5.6809 11.6382C5.59779 11.8044 5.71866 12 5.90451 12H9C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12H18.0955C18.2813 12 18.4022 11.8044 18.3191 11.6382L16.0691 7.1382C16.0268 7.0535 15.9402 7 15.8455 7H8.15451C8.05982 7 7.97325 7.0535 7.9309 7.1382Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "inbox-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "individual-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#individual-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 12C8.12698 12 7.61732 12.2666 7 13C6.38268 13.7334 6 15.9628 6 17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17C18 15.9628 17.6173 13.7334 17 13C16.3827 12.2666 15.873 12 15 12H9Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "individual-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "individual-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#individual-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z",
        fill: "url(#individual-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 12C8.12698 12 7.61732 12.2666 7 13C6.38268 13.7334 6 15.9628 6 17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17C18 15.9628 17.6173 13.7334 17 13C16.3827 12.2666 15.873 12 15 12H9Z",
        fill: "url(#individual-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "individual-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "individual-inactive-1",
        x1: "12",
        y1: "3.15322e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "individual-inactive-2",
        x1: "12",
        y1: "3.15322e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "marqeta-platform-approval-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "url(#marqeta-platform-approval-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.7919 7H5.52016C5.31053 7 5.19399 7.24248 5.32494 7.40617L8.87506 11.8438C8.94811 11.9351 8.94811 12.0649 8.87506 12.1562L5.32494 16.5938C5.19399 16.7575 5.31053 17 5.52016 17H8.7919C8.86785 17 8.93968 16.9655 8.98712 16.9062L12.7871 12.1562C12.8602 12.0649 12.8602 11.9351 12.7871 11.8438L8.98712 7.09383C8.93968 7.03452 8.86785 7 8.7919 7Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.7919 7H11.5202C11.3105 7 11.194 7.24248 11.3249 7.40617L14.8751 11.8438C14.9481 11.9351 14.9481 12.0649 14.8751 12.1562L11.3249 16.5938C11.194 16.7575 11.3105 17 11.5202 17H15.7919C15.8678 17 15.9397 16.9655 15.9871 16.9062L19.7871 12.1562C19.8602 12.0649 19.8602 11.9351 19.7871 11.8438L15.9871 7.09383C15.9397 7.03452 15.8678 7 15.7919 7Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "marqeta-platform-approval-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "marqeta-platform-approval-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "url(#marqeta-platform-approval-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.7919 7H5.52016C5.31053 7 5.19399 7.24248 5.32494 7.40617L8.87506 11.8438C8.94811 11.9351 8.94811 12.0649 8.87506 12.1562L5.32494 16.5938C5.19399 16.7575 5.31053 17 5.52016 17H8.7919C8.86785 17 8.93968 16.9655 8.98712 16.9062L12.7871 12.1562C12.8602 12.0649 12.8602 11.9351 12.7871 11.8438L8.98712 7.09383C8.93968 7.03452 8.86785 7 8.7919 7Z",
        fill: "url(#marqeta-platform-approval-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.7919 7H11.5202C11.3105 7 11.194 7.24248 11.3249 7.40617L14.8751 11.8438C14.9481 11.9351 14.9481 12.0649 14.8751 12.1562L11.3249 16.5938C11.194 16.7575 11.3105 17 11.5202 17H15.7919C15.8678 17 15.9397 16.9655 15.9871 16.9062L19.7871 12.1562C19.8602 12.0649 19.8602 11.9351 19.7871 11.8438L15.9871 7.09383C15.9397 7.03452 15.8678 7 15.7919 7Z",
        fill: "url(#marqeta-platform-approval-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "marqeta-platform-approval-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "marqeta-platform-approval-inactive-1",
        x1: "12",
        y1: "4.49771e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "marqeta-platform-approval-inactive-2",
        x1: "12",
        y1: "4.49771e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "percentage-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#percentage-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.15023 17.8716C8.38517 18.0793 8.76898 18.0297 9.0071 17.7598L17.3508 8.32549C17.5891 8.05605 17.5919 7.66905 17.3568 7.46112L15.8497 6.12819C15.6147 5.92044 15.2309 5.9705 14.9926 6.23994L6.64912 15.6745C6.41081 15.9443 6.408 16.3309 6.64312 16.5387L8.15023 17.8716Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.0938 10.1881C9.25017 10.1881 10.1876 9.25066 10.1876 8.09428C10.1876 6.93791 9.25017 6.00049 8.0938 6.00049C6.93742 6.00049 6 6.93791 6 8.09428C6 9.25066 6.93742 10.1881 8.0938 10.1881Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.9061 18C17.0625 18 17.9999 17.0625 17.9999 15.9062C17.9999 14.7498 17.0625 13.8124 15.9061 13.8124C14.7497 13.8124 13.8123 14.7498 13.8123 15.9062C13.8123 17.0625 14.7497 18 15.9061 18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "percentage-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "percentage-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#percentage-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.15023 17.8716C8.38517 18.0793 8.76898 18.0297 9.0071 17.7598L17.3508 8.32549C17.5891 8.05605 17.5919 7.66905 17.3568 7.46112L15.8497 6.12819C15.6147 5.92044 15.2309 5.9705 14.9926 6.23994L6.64912 15.6745C6.41081 15.9443 6.408 16.3309 6.64312 16.5387L8.15023 17.8716Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.0938 10.1881C9.25017 10.1881 10.1876 9.25066 10.1876 8.09428C10.1876 6.93791 9.25017 6.00049 8.0938 6.00049C6.93742 6.00049 6 6.93791 6 8.09428C6 9.25066 6.93742 10.1881 8.0938 10.1881Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.9061 18C17.0625 18 17.9999 17.0625 17.9999 15.9062C17.9999 14.7498 17.0625 13.8124 15.9061 13.8124C14.7497 13.8124 13.8123 14.7498 13.8123 15.9062C13.8123 17.0625 14.7497 18 15.9061 18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "percentage-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "reusable-reloadable-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#reusable-reloadable-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.5355 13.9718C11.145 13.5813 10.5118 13.5813 10.1213 13.9718L7.29511 16.798L7.2929 16.8002C7.19527 16.8979 7.12204 17.0107 7.07323 17.1311C6.98893 17.3389 6.97742 17.5694 7.03869 17.7835C7.08387 17.9413 7.1686 18.0902 7.2929 18.2145L7.29543 18.217L10.1213 21.0429C10.5118 21.4334 11.145 21.4334 11.5355 21.0429C11.9261 20.6524 11.9261 20.0192 11.5355 19.6287L9.41422 17.5074L11.5355 15.386C11.9261 14.9955 11.9261 14.3623 11.5355 13.9718Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0711 18.5L8.57107 18.5L8.57107 16.5L15.0711 16.5L15.0711 13L17.0711 11L17.0711 16.5C17.0711 17.6046 16.1756 18.5 15.0711 18.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.5355 10.364C12.9261 10.7545 13.5592 10.7545 13.9497 10.364L16.776 7.53774L16.7782 7.53553C16.8758 7.4379 16.949 7.3251 16.9978 7.20472C17.0821 6.99684 17.0937 6.76635 17.0324 6.55229C16.9872 6.39448 16.9025 6.24561 16.7782 6.12131L16.7756 6.11879L13.9497 3.29289C13.5592 2.90237 12.9261 2.90237 12.5355 3.29289C12.145 3.68342 12.145 4.31658 12.5355 4.70711L14.6568 6.82842L12.5355 8.94974C12.145 9.34026 12.145 9.97343 12.5355 10.364Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5.83578L15.5 5.83578V7.83578L9 7.83578L9 11.3358L7 13.3358L7 7.83578C7 6.73121 7.89543 5.83578 9 5.83578Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "reusable-reloadable-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "reusable-reloadable-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "url(#reusable-reloadable-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.5355 13.9718C11.145 13.5813 10.5118 13.5813 10.1213 13.9718L7.2951 16.798L7.29289 16.8002C7.19526 16.8979 7.12204 17.0107 7.07322 17.1311C6.98892 17.3389 6.97741 17.5694 7.03869 17.7835C7.08386 17.9413 7.1686 18.0902 7.29289 18.2145L7.29543 18.217L10.1213 21.0429C10.5118 21.4334 11.145 21.4334 11.5355 21.0429C11.9261 20.6524 11.9261 20.0192 11.5355 19.6287L9.41422 17.5074L11.5355 15.386C11.9261 14.9955 11.9261 14.3624 11.5355 13.9718Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0711 18.5L8.57106 18.5L8.57106 16.5L15.0711 16.5L15.0711 13L17.0711 11L17.0711 16.5C17.0711 17.6046 16.1756 18.5 15.0711 18.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.5355 10.364C12.9261 10.7545 13.5592 10.7545 13.9497 10.364L16.776 7.53774L16.7782 7.53553C16.8758 7.4379 16.949 7.3251 16.9978 7.20472C17.0821 6.99684 17.0937 6.76635 17.0324 6.55229C16.9872 6.39448 16.9025 6.24561 16.7782 6.12131L16.7756 6.11879L13.9497 3.29289C13.5592 2.90237 12.9261 2.90237 12.5355 3.29289C12.145 3.68342 12.145 4.31658 12.5355 4.70711L14.6568 6.82842L12.5355 8.94974C12.145 9.34026 12.145 9.97343 12.5355 10.364Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 5.83578L15.5 5.83578V7.83578L9 7.83578L9 11.3358L7 13.3358L7 7.83578C7 6.73121 7.89543 5.83578 9 5.83578Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "reusable-reloadable-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12.0355",
        y1: "1.25037e-07",
        x2: "12.0355",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12.0355",
        y1: "1.25037e-07",
        x2: "12.0355",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "12.0355",
        y1: "1.25037e-07",
        x2: "12.0355",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "12.0355",
        y1: "1.25037e-07",
        x2: "12.0355",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "card-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "40", cy: "40", r: "40", fill: "url(#card-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6666 38.3346H63.3333V55.0013C63.3333 56.8423 61.8409 58.3346 60 58.3346H20C18.159 58.3346 16.6666 56.8423 16.6666 55.0013V38.3346Z",
        fill: "url(#card-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6666 25.0013C16.6666 23.1604 18.159 21.668 20 21.668H60C61.8409 21.668 63.3333 23.1604 63.3333 25.0013V31.668H16.6666V25.0013Z",
        fill: "url(#card-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-inactive",
        x1: "40",
        y1: "0",
        x2: "40",
        y2: "80",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-inactive-1",
        x1: "40",
        y1: "0.00130109",
        x2: "40",
        y2: "80.0013",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-inactive-2",
        x1: "40",
        y1: "0.00130109",
        x2: "40",
        y2: "80.0013",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "card-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "40", cy: "40", r: "40", fill: "url(#card-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6666 38.3346H63.3333V55.0013C63.3333 56.8423 61.8409 58.3346 60 58.3346H20C18.159 58.3346 16.6666 56.8423 16.6666 55.0013V38.3346Z",
        fill: "url(#card-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6666 25.0013C16.6666 23.1604 18.159 21.668 20 21.668H60C61.8409 21.668 63.3333 23.1604 63.3333 25.0013V31.668H16.6666V25.0013Z",
        fill: "url(#card-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-active",
        x1: "40",
        y1: "0",
        x2: "40",
        y2: "80",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-active-1",
        x1: "40",
        y1: "0.00130109",
        x2: "40",
        y2: "80.0013",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "card-active-2",
        x1: "40",
        y1: "0.00130109",
        x2: "40",
        y2: "80.0013",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "phone-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "url(#phone-inactive-0)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6667 13.3333C18.6667 11.8605 19.8607 10.6666 21.3334 10.6666H42.6667C44.1395 10.6666 45.3334 11.8605 45.3334 13.3333V50.6666C45.3334 52.1394 44.1395 53.3333 42.6667 53.3333H21.3334C19.8607 53.3333 18.6667 52.1394 18.6667 50.6666V13.3333ZM34.6667 48C34.6667 49.4727 33.4728 50.6666 32.0001 50.6666C30.5273 50.6666 29.3334 49.4727 29.3334 48C29.3334 46.5272 30.5273 45.3333 32.0001 45.3333C33.4728 45.3333 34.6667 46.5272 34.6667 48ZM22.6667 13.3333C21.9304 13.3333 21.3334 13.9302 21.3334 14.6666V41.3333C21.3334 42.0697 21.9304 42.6666 22.6667 42.6666H41.3334C42.0698 42.6666 42.6667 42.0697 42.6667 41.3333V14.6666C42.6667 13.9302 42.0698 13.3333 41.3334 13.3333H22.6667Z",
        fill: "url(#phone-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M24.0001 17.3333C24.0001 16.5969 24.597 16 25.3334 16H38.6667C39.4031 16 40.0001 16.5969 40.0001 17.3333V25.3333C40.0001 26.0697 39.4031 26.6666 38.6667 26.6666H25.3334C24.597 26.6666 24.0001 26.0697 24.0001 25.3333V17.3333Z",
        fill: "url(#phone-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-inactive-0",
        x1: "32",
        y1: "0",
        x2: "32",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-inactive-1",
        x1: "32.0001",
        y1: "-3.98619e-05",
        x2: "32.0001",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-inactive-2",
        x1: "32.0001",
        y1: "-3.98619e-05",
        x2: "32.0001",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "phone-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "url(#phone-active-0)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6667 13.3333C18.6667 11.8605 19.8607 10.6666 21.3334 10.6666H42.6667C44.1395 10.6666 45.3334 11.8605 45.3334 13.3333V50.6666C45.3334 52.1394 44.1395 53.3333 42.6667 53.3333H21.3334C19.8607 53.3333 18.6667 52.1394 18.6667 50.6666V13.3333ZM34.6667 48C34.6667 49.4727 33.4728 50.6666 32.0001 50.6666C30.5273 50.6666 29.3334 49.4727 29.3334 48C29.3334 46.5272 30.5273 45.3333 32.0001 45.3333C33.4728 45.3333 34.6667 46.5272 34.6667 48ZM22.6667 13.3333C21.9304 13.3333 21.3334 13.9302 21.3334 14.6666V41.3333C21.3334 42.0697 21.9304 42.6666 22.6667 42.6666H41.3334C42.0698 42.6666 42.6667 42.0697 42.6667 41.3333V14.6666C42.6667 13.9302 42.0698 13.3333 41.3334 13.3333H22.6667Z",
        fill: "url(#phone-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M24.0001 17.3333C24.0001 16.5969 24.597 16 25.3334 16H38.6667C39.4031 16 40.0001 16.5969 40.0001 17.3333V25.3333C40.0001 26.0697 39.4031 26.6666 38.6667 26.6666H25.3334C24.597 26.6666 24.0001 26.0697 24.0001 25.3333V17.3333Z",
        fill: "url(#phone-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-active-0",
        x1: "32",
        y1: "0",
        x2: "32",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-active-1",
        x1: "32.0001",
        y1: "-3.98619e-05",
        x2: "32.0001",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "phone-active-2",
        x1: "32.0001",
        y1: "-3.98619e-05",
        x2: "32.0001",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "list-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "40", cy: "40", r: "40", fill: "url(#list-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 20.8343C30.0003 20.3741 30.3734 20.001 30.8337 20.001H62.5003C62.9606 20.001 63.3337 20.3741 63.3337 20.8343V25.8343C63.3337 26.2945 62.9606 26.6676 62.5003 26.6676H30.8337C30.3734 26.6676 30.0003 26.2945 30.0003 25.8343V20.8343Z",
        fill: "url(#list-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 37.501C30.0003 37.0407 30.3734 36.6676 30.8337 36.6676H62.5003C62.9606 36.6676 63.3337 37.0407 63.3337 37.501V42.501C63.3337 42.9612 62.9606 43.3343 62.5003 43.3343H30.8337C30.3734 43.3343 30.0003 42.9612 30.0003 42.501V37.501Z",
        fill: "url(#list-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 54.1676C30.0003 53.7074 30.3734 53.3343 30.8337 53.3343H62.5003C62.9606 53.3343 63.3337 53.7074 63.3337 54.1676V59.1676C63.3337 59.6279 62.9606 60.001 62.5003 60.001H30.8337C30.3734 60.001 30.0003 59.6279 30.0003 59.1676V54.1676Z",
        fill: "url(#list-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 23.3343C16.667 21.4934 18.1594 20.001 20.0003 20.001C21.8413 20.001 23.3337 21.4934 23.3337 23.3343C23.3337 25.1753 21.8413 26.6676 20.0003 26.6676C18.1594 26.6676 16.667 25.1753 16.667 23.3343Z",
        fill: "url(#list-inactive-4)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 40.001C16.667 38.16 18.1594 36.6676 20.0003 36.6676C21.8413 36.6676 23.3337 38.16 23.3337 40.001C23.3337 41.8419 21.8413 43.3343 20.0003 43.3343C18.1594 43.3343 16.667 41.8419 16.667 40.001Z",
        fill: "url(#list-inactive-5)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 56.6676C16.667 54.8267 18.1594 53.3343 20.0003 53.3343C21.8413 53.3343 23.3337 54.8267 23.3337 56.6676C23.3337 58.5086 21.8413 60.001 20.0003 60.001C18.1594 60.001 16.667 58.5086 16.667 56.6676Z",
        fill: "url(#list-inactive-6)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive",
        x1: "40",
        y1: "0",
        x2: "40",
        y2: "80",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-1",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-2",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-3",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-4",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-5",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-inactive-6",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "list-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "40", cy: "40", r: "40", fill: "url(#list-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 20.8343C30.0003 20.3741 30.3734 20.001 30.8337 20.001H62.5003C62.9606 20.001 63.3337 20.3741 63.3337 20.8343V25.8343C63.3337 26.2945 62.9606 26.6676 62.5003 26.6676H30.8337C30.3734 26.6676 30.0003 26.2945 30.0003 25.8343V20.8343Z",
        fill: "url(#list-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 37.501C30.0003 37.0407 30.3734 36.6676 30.8337 36.6676H62.5003C62.9606 36.6676 63.3337 37.0407 63.3337 37.501V42.501C63.3337 42.9612 62.9606 43.3343 62.5003 43.3343H30.8337C30.3734 43.3343 30.0003 42.9612 30.0003 42.501V37.501Z",
        fill: "url(#list-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.0003 54.1676C30.0003 53.7074 30.3734 53.3343 30.8337 53.3343H62.5003C62.9606 53.3343 63.3337 53.7074 63.3337 54.1676V59.1676C63.3337 59.6279 62.9606 60.001 62.5003 60.001H30.8337C30.3734 60.001 30.0003 59.6279 30.0003 59.1676V54.1676Z",
        fill: "url(#list-active-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 23.3343C16.667 21.4934 18.1594 20.001 20.0003 20.001C21.8413 20.001 23.3337 21.4934 23.3337 23.3343C23.3337 25.1753 21.8413 26.6676 20.0003 26.6676C18.1594 26.6676 16.667 25.1753 16.667 23.3343Z",
        fill: "url(#list-active-4)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 40.001C16.667 38.16 18.1594 36.6676 20.0003 36.6676C21.8413 36.6676 23.3337 38.16 23.3337 40.001C23.3337 41.8419 21.8413 43.3343 20.0003 43.3343C18.1594 43.3343 16.667 41.8419 16.667 40.001Z",
        fill: "url(#list-active-5)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.667 56.6676C16.667 54.8267 18.1594 53.3343 20.0003 53.3343C21.8413 53.3343 23.3337 54.8267 23.3337 56.6676C23.3337 58.5086 21.8413 60.001 20.0003 60.001C18.1594 60.001 16.667 58.5086 16.667 56.6676Z",
        fill: "url(#list-active-6)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active",
        x1: "40",
        y1: "0",
        x2: "40",
        y2: "80",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-1",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-2",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-3",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-4",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-5",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "list-active-6",
        x1: "40.0003",
        y1: "0.000976651",
        x2: "40.0003",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "paper-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "url(#paper-inactive-0)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.6667 13.3333C19.1145 13.3333 18.6667 13.781 18.6667 14.3333V49.6667C18.6667 50.2189 19.1145 50.6667 19.6667 50.6667H44.3334C44.8857 50.6667 45.3334 50.219 45.3334 49.6667V14.3333C45.3334 13.781 44.8857 13.3333 44.3334 13.3333H19.6667ZM24.2501 24C24.112 24 24.0001 24.1119 24.0001 24.25V26.4167C24.0001 26.5547 24.112 26.6667 24.2501 26.6667H39.7501C39.8882 26.6667 40.0001 26.5547 40.0001 26.4167V24.25C40.0001 24.1119 39.8882 24 39.7501 24H24.2501ZM24.0001 29.5833C24.0001 29.4453 24.112 29.3333 24.2501 29.3333H39.7501C39.8882 29.3333 40.0001 29.4453 40.0001 29.5833V31.75C40.0001 31.8881 39.8882 32 39.7501 32H24.2501C24.112 32 24.0001 31.8881 24.0001 31.75V29.5833ZM24.2501 34.6667C24.112 34.6667 24.0001 34.7786 24.0001 34.9167V37.0833C24.0001 37.2214 24.112 37.3333 24.2501 37.3333H34.4167C34.5548 37.3333 34.6667 37.2214 34.6667 37.0833V34.9167C34.6667 34.7786 34.5548 34.6667 34.4167 34.6667H24.2501Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paper-inactive-0",
        x1: "32",
        y1: "0",
        x2: "32",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "paper-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "url(#paper-active-0)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.6667 13.3333C19.1145 13.3333 18.6667 13.781 18.6667 14.3333V49.6667C18.6667 50.2189 19.1145 50.6667 19.6667 50.6667H44.3334C44.8857 50.6667 45.3334 50.219 45.3334 49.6667V14.3333C45.3334 13.781 44.8857 13.3333 44.3334 13.3333H19.6667ZM24.2501 24C24.112 24 24.0001 24.1119 24.0001 24.25V26.4167C24.0001 26.5547 24.112 26.6667 24.2501 26.6667H39.7501C39.8882 26.6667 40.0001 26.5547 40.0001 26.4167V24.25C40.0001 24.1119 39.8882 24 39.7501 24H24.2501ZM24.0001 29.5833C24.0001 29.4453 24.112 29.3333 24.2501 29.3333H39.7501C39.8882 29.3333 40.0001 29.4453 40.0001 29.5833V31.75C40.0001 31.8881 39.8882 32 39.7501 32H24.2501C24.112 32 24.0001 31.8881 24.0001 31.75V29.5833ZM24.2501 34.6667C24.112 34.6667 24.0001 34.7786 24.0001 34.9167V37.0833C24.0001 37.2214 24.112 37.3333 24.2501 37.3333H34.4167C34.5548 37.3333 34.6667 37.2214 34.6667 37.0833V34.9167C34.6667 34.7786 34.5548 34.6667 34.4167 34.6667H24.2501Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paper-active-0",
        x1: "32",
        y1: "0",
        x2: "32",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "search-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#search-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15ZM11 17C14.3137 17 17 14.3137 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L14.2929 15.7071L15.7071 14.2929L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "search-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12",
        y1: "-2.78183e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12",
        y1: "-2.78183e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "search-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#search-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15ZM11 17C14.3137 17 17 14.3137 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11C5 14.3137 7.68629 17 11 17Z",
        fill: "url(#search-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L14.2929 15.7071L15.7071 14.2929L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071Z",
        fill: "url(#search-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "search-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "search-active-1",
        x1: "12",
        y1: "-2.78183e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "search-active-2",
        x1: "12",
        y1: "-2.78183e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "envelope-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "url(#envelope-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.75 15.25C12.1977 15.25 11.75 15.6977 11.75 16.25V31.75C11.75 32.3023 12.1977 32.75 12.75 32.75H35.25C35.8023 32.75 36.25 32.3023 36.25 31.75V16.25C36.25 15.6977 35.8023 15.25 35.25 15.25H12.75ZM13.5 17V20.5L24 27.5L34.5 20.5V17L24 24L13.5 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "envelope-active",
        x1: "24",
        y1: "0",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "envelope-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "url(#envelope-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.75 15.25C12.1977 15.25 11.75 15.6977 11.75 16.25V31.75C11.75 32.3023 12.1977 32.75 12.75 32.75H35.25C35.8023 32.75 36.25 32.3023 36.25 31.75V16.25C36.25 15.6977 35.8023 15.25 35.25 15.25H12.75ZM13.5 17V20.5L24 27.5L34.5 20.5V17L24 24L13.5 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "envelope-inactive",
        x1: "24",
        y1: "0",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "single-load-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#single-load-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.99999 17C5.99999 16.4477 6.4477 16 6.99999 16L17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L6.99999 18C6.4477 18 5.99999 17.5523 5.99999 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.99999 17C5.99999 16.4477 6.4477 16 6.99999 16L17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L6.99999 18C6.4477 18 5.99999 17.5523 5.99999 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.00001C11 4.44772 11.4477 4.00001 12 4.00001C12.5523 4.00001 13 4.44772 13 5.00001L13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12L11 5.00001Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.00001C11 4.44772 11.4477 4.00001 12 4.00001C12.5523 4.00001 13 4.44772 13 5.00001L13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12L11 5.00001Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.1287 10.0429C14.5192 9.65237 15.1524 9.65237 15.5429 10.0429C15.9334 10.4334 15.9334 11.0666 15.5429 11.4571L12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855C10.9097 13.895 10.9097 13.2618 11.3002 12.8713L14.1287 10.0429Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.1287 10.0429C14.5192 9.65237 15.1524 9.65237 15.5429 10.0429C15.9334 10.4334 15.9334 11.0666 15.5429 11.4571L12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855C10.9097 13.895 10.9097 13.2618 11.3002 12.8713L14.1287 10.0429Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.47182 11.4571C8.08129 11.0666 8.08129 10.4334 8.47182 10.0429C8.86234 9.65237 9.4955 9.65237 9.88603 10.0429L12.7145 12.8713C13.105 13.2618 13.105 13.895 12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855L8.47182 11.4571Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.47182 11.4571C8.08129 11.0666 8.08129 10.4334 8.47182 10.0429C8.86234 9.65237 9.4955 9.65237 9.88603 10.0429L12.7145 12.8713C13.105 13.2618 13.105 13.895 12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855L8.47182 11.4571Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "single-load-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint6_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint7_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint8_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ))
  ),
  "single-load-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#single-load-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.99999 17C5.99999 16.4477 6.4477 16 6.99999 16L17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L6.99999 18C6.4477 18 5.99999 17.5523 5.99999 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.99999 17C5.99999 16.4477 6.4477 16 6.99999 16L17 16C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18L6.99999 18C6.4477 18 5.99999 17.5523 5.99999 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.00001C11 4.44772 11.4477 4.00001 12 4.00001C12.5523 4.00001 13 4.44772 13 5.00001L13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12L11 5.00001Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.00001C11 4.44772 11.4477 4.00001 12 4.00001C12.5523 4.00001 13 4.44772 13 5.00001L13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12L11 5.00001Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.1287 10.0429C14.5192 9.65237 15.1524 9.65237 15.5429 10.0429C15.9334 10.4334 15.9334 11.0666 15.5429 11.4571L12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855C10.9097 13.895 10.9097 13.2618 11.3002 12.8713L14.1287 10.0429Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.1287 10.0429C14.5192 9.65237 15.1524 9.65237 15.5429 10.0429C15.9334 10.4334 15.9334 11.0666 15.5429 11.4571L12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855C10.9097 13.895 10.9097 13.2618 11.3002 12.8713L14.1287 10.0429Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.47182 11.4571C8.08129 11.0666 8.08129 10.4334 8.47182 10.0429C8.86234 9.65237 9.4955 9.65237 9.88603 10.0429L12.7145 12.8713C13.105 13.2618 13.105 13.895 12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855L8.47182 11.4571Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.47182 11.4571C8.08129 11.0666 8.08129 10.4334 8.47182 10.0429C8.86234 9.65237 9.4955 9.65237 9.88603 10.0429L12.7145 12.8713C13.105 13.2618 13.105 13.895 12.7144 14.2855C12.3239 14.6761 11.6908 14.6761 11.3002 14.2855L8.47182 11.4571Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "single-load-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint6_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint7_linear",
        x1: "15.7854",
        y1: "23.4637",
        x2: "22.1939",
        y2: "29.8721",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint8_linear",
        x1: "3.73814",
        y1: "14.1844",
        x2: "13.6524",
        y2: "24.0987",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ))
  ),
  "single-use-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#single-use-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 18C16.4477 18 16 17.5523 16 17V7C16 6.44771 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 18C16.4477 18 16 17.5523 16 17V7C16 6.44771 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L5 13Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L5 13Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.0429 15.5282C10.4334 15.9187 11.0666 15.9187 11.4571 15.5282L14.2834 12.7018L14.2855 12.6997C14.3344 12.6509 14.3771 12.5983 14.4137 12.5429C14.5767 12.2959 14.6188 11.9925 14.5397 11.7165C14.4946 11.5587 14.4098 11.4098 14.2855 11.2855L14.283 11.283L11.4571 8.45711C11.0666 8.06658 10.4334 8.06658 10.0429 8.45711C9.65237 8.84763 9.65237 9.4808 10.0429 9.87132L12.1642 11.9926L10.0429 14.114C9.65237 14.5045 9.65237 15.1376 10.0429 15.5282Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.0429 15.5282C10.4334 15.9187 11.0666 15.9187 11.4571 15.5282L14.2834 12.7018L14.2855 12.6997C14.3344 12.6509 14.3771 12.5983 14.4137 12.5429C14.5767 12.2959 14.6188 11.9925 14.5397 11.7165C14.4946 11.5587 14.4098 11.4098 14.2855 11.2855L14.283 11.283L11.4571 8.45711C11.0666 8.06658 10.4334 8.06658 10.0429 8.45711C9.65237 8.84763 9.65237 9.4808 10.0429 9.87132L12.1642 11.9926L10.0429 14.114C9.65237 14.5045 9.65237 15.1376 10.0429 15.5282Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "single-use-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "15.0138",
        y1: "10.3727",
        x2: "17.7562",
        y2: "7.63032",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "11.0429",
        y1: "15.5282",
        x2: "15.2855",
        y2: "11.2855",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "15.0138",
        y1: "10.3727",
        x2: "17.7562",
        y2: "7.63032",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "11.0429",
        y1: "15.5282",
        x2: "15.2855",
        y2: "11.2855",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "15.0138",
        y1: "10.3727",
        x2: "17.7562",
        y2: "7.63032",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint6_linear",
        x1: "11.0429",
        y1: "15.5282",
        x2: "15.2855",
        y2: "11.2855",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ))
  ),
  "single-use-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#single-use-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 18C16.4477 18 16 17.5523 16 17V7C16 6.44771 16.4477 6 17 6C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5 13C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L5 13Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.0429 15.5282C10.4334 15.9187 11.0666 15.9187 11.4571 15.5282L14.2834 12.7018L14.2855 12.6997C14.3344 12.6509 14.3771 12.5983 14.4137 12.5429C14.5767 12.2959 14.6188 11.9925 14.5397 11.7165C14.4946 11.5587 14.4098 11.4098 14.2855 11.2855L14.283 11.283L11.4571 8.45711C11.0666 8.06658 10.4334 8.06658 10.0429 8.45711C9.65237 8.84763 9.65237 9.4808 10.0429 9.87132L12.1642 11.9926L10.0429 14.114C9.65237 14.5045 9.65237 15.1376 10.0429 15.5282Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "single-use-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12",
        y1: "-2.75858e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12",
        y1: "-2.75858e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "12",
        y1: "-2.75858e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "transitions-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "40", cy: "40", r: "40", fill: "url(#paint0_linear)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M56.6663 60.001C54.8254 60.001 53.333 58.5086 53.333 56.6676V23.3343C53.333 21.4934 54.8254 20.001 56.6663 20.001C58.5073 20.001 59.9997 21.4934 59.9997 23.3343V56.6676C59.9997 58.5086 58.5073 60.001 56.6663 60.001Z",
        fill: "url(#paint1_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6663 43.3343C14.8254 43.3343 13.333 41.8419 13.333 40.001C13.333 38.16 14.8254 36.6676 16.6663 36.6676L39.9997 36.6676C41.8406 36.6676 43.333 38.16 43.333 40.001C43.333 41.8419 41.8406 43.3343 39.9997 43.3343H16.6663Z",
        fill: "url(#paint2_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M33.476 51.7615C34.7777 53.0633 36.8883 53.0633 38.19 51.7615L47.6111 42.3404L47.6181 42.3335C47.7808 42.1707 47.9232 41.9954 48.0453 41.8105C48.5888 40.9873 48.7289 39.9761 48.4655 39.056C48.3149 38.53 48.0324 38.0337 47.6181 37.6194L47.6097 37.611L38.19 28.1913C36.8883 26.8896 34.7777 26.8896 33.476 28.1913C32.1742 29.4931 32.1742 31.6036 33.476 32.9054L40.547 39.9764L33.476 47.0475C32.1742 48.3492 32.1742 50.4598 33.476 51.7615Z",
        fill: "url(#paint3_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear",
        x1: "40",
        y1: "0",
        x2: "40",
        y2: "80",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "39.9997",
        y1: "0.000976471",
        x2: "39.9997",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "39.9997",
        y1: "0.000976471",
        x2: "39.9997",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear",
        x1: "39.9997",
        y1: "0.000976471",
        x2: "39.9997",
        y2: "80.001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  // side bar icons
  "side-bar-balances-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-balances-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.89233 7.25C6.89233 7.11193 7.00426 7 7.14233 7H8.64233C8.78041 7 8.89233 7.11193 8.89233 7.25V14.4549L10.2861 13.1695C10.3876 13.0759 10.5521 13.0759 10.6536 13.1695L11.7086 14.1424C11.8101 14.236 11.8101 14.3878 11.7086 14.4814L8.6028 17.3458L8.60065 17.3438L8.07289 17.8305C7.9714 17.9241 7.80684 17.9241 7.70534 17.8305L4.07612 14.4834C3.97463 14.3898 3.97463 14.238 4.07612 14.1444L5.13324 13.1695C5.23473 13.0759 5.39929 13.0759 5.50079 13.1695L6.89233 14.4529V7.25Z",
        fill: "url(#side-bar-balances-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.9 17.6507C16.9 17.7888 16.7881 17.9007 16.65 17.9007H15.15C15.012 17.9007 14.9 17.7888 14.9 17.6507L14.9 10.4458L13.5063 11.7312C13.4048 11.8248 13.2402 11.8248 13.1387 11.7312L12.0838 10.7583C11.9823 10.6646 11.9823 10.5129 12.0838 10.4193L15.1896 7.55492L15.1917 7.55691L15.7195 7.07018C15.821 6.97658 15.9855 6.97658 16.087 7.07018L19.7162 10.4173C19.8177 10.5109 19.8177 10.6626 19.7162 10.7562L18.6591 11.7312C18.5576 11.8248 18.3931 11.8248 18.2916 11.7312L16.9 10.4478L16.9 17.6507Z",
        fill: "url(#side-bar-balances-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-active-1",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-active-2",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-balances-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-balances-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.89233 7.25C6.89233 7.11193 7.00426 7 7.14233 7H8.64233C8.78041 7 8.89233 7.11193 8.89233 7.25V14.4549L10.2861 13.1695C10.3876 13.0759 10.5521 13.0759 10.6536 13.1695L11.7086 14.1424C11.8101 14.236 11.8101 14.3878 11.7086 14.4814L8.6028 17.3458L8.60065 17.3438L8.07289 17.8305C7.9714 17.9241 7.80684 17.9241 7.70534 17.8305L4.07612 14.4834C3.97463 14.3898 3.97463 14.2381 4.07612 14.1444L5.13324 13.1695C5.23473 13.0759 5.39929 13.0759 5.50079 13.1695L6.89233 14.4529V7.25Z",
        fill: "url(#side-bar-balances-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.9 17.6507C16.9 17.7888 16.7881 17.9007 16.65 17.9007H15.15C15.012 17.9007 14.9 17.7888 14.9 17.6507L14.9 10.4458L13.5063 11.7312C13.4048 11.8248 13.2402 11.8248 13.1387 11.7312L12.0838 10.7583C11.9823 10.6647 11.9823 10.5129 12.0838 10.4193L15.1896 7.55493L15.1917 7.55691L15.7195 7.07019C15.821 6.97658 15.9855 6.97658 16.087 7.07019L19.7162 10.4173C19.8177 10.5109 19.8177 10.6626 19.7162 10.7562L18.6591 11.7312C18.5576 11.8248 18.3931 11.8248 18.2916 11.7312L16.9 10.4478L16.9 17.6507Z",
        fill: "url(#side-bar-balances-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-inactive-1",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-balances-inactive-2",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ))
  ),
  "side-bar-card-management-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "3",
        width: "24",
        height: "18",
        rx: "0.5",
        fill: "url(#side-bar-card-management-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        x: "17",
        y: "16",
        width: "5",
        height: "3",
        rx: "0.25",
        fill: "url(#side-bar-card-management-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "6",
        width: "24",
        height: "3",
        fill: "url(#side-bar-card-management-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-active",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-active-1",
        x1: "19.5",
        y1: "16",
        x2: "19.5",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-active-2",
        x1: "12",
        y1: "6",
        x2: "12",
        y2: "9",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-card-management-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "3",
        width: "24",
        height: "18",
        rx: "0.5",
        fill: "url(#side-bar-card-management-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        x: "17",
        y: "16",
        width: "5",
        height: "3",
        rx: "0.25",
        fill: "url(#side-bar-card-management-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "6",
        width: "24",
        height: "3",
        fill: "url(#side-bar-card-management-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-inactive",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-inactive-1",
        x1: "19.5",
        y1: "16",
        x2: "19.5",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-card-management-inactive-2",
        x1: "12",
        y1: "6",
        x2: "12",
        y2: "9",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-credit-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "0.5",
        fill: "url(#side-bar-credit-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4 5.25C4 5.11193 4.11193 5 4.25 5H17.75C17.8881 5 18 5.11193 18 5.25V6.75C18 6.88807 17.8881 7 17.75 7H4.25C4.11193 7 4 6.88807 4 6.75V5.25Z",
        fill: "url(#side-bar-credit-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4 9.25C4 9.11193 4.11193 9 4.25 9H13.75C13.8881 9 14 9.11193 14 9.25V10.75C14 10.8881 13.8881 11 13.75 11H4.25C4.11193 11 4 10.8881 4 10.75V9.25Z",
        fill: "url(#side-bar-credit-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.7321 13.5803C16.6483 13.3708 16.3517 13.3708 16.2679 13.5803L15.5583 15.3543C15.5226 15.4434 15.4392 15.5042 15.3435 15.5109L13.5822 15.6333C13.3629 15.6485 13.2686 15.9191 13.431 16.0673L14.8881 17.3978C14.9569 17.4606 14.985 17.5565 14.9611 17.6465L14.5111 19.3433C14.4514 19.5681 14.7041 19.7454 14.8952 19.6129L16.3575 18.5988C16.4432 18.5394 16.5568 18.5394 16.6425 18.5988L18.1048 19.6129C18.2959 19.7454 18.5486 19.5681 18.4889 19.3433L18.0389 17.6465C18.015 17.5565 18.0431 17.4606 18.1119 17.3978L19.569 16.0673C19.7314 15.9191 19.6371 15.6485 19.4178 15.6333L17.6565 15.5109C17.5608 15.5042 17.4774 15.4434 17.4417 15.3543L16.7321 13.5803Z",
        fill: "url(#side-bar-credit-active-3)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-active",
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-active-1",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-active-2",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-active-3",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-credit-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "0.5",
        fill: "url(#side-bar-credit-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4 5.25C4 5.11193 4.11193 5 4.25 5H17.75C17.8881 5 18 5.11193 18 5.25V6.75C18 6.88807 17.8881 7 17.75 7H4.25C4.11193 7 4 6.88807 4 6.75V5.25Z",
        fill: "url(#side-bar-credit-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4 9.25C4 9.11193 4.11193 9 4.25 9H13.75C13.8881 9 14 9.11193 14 9.25V10.75C14 10.8881 13.8881 11 13.75 11H4.25C4.11193 11 4 10.8881 4 10.75V9.25Z",
        fill: "url(#side-bar-credit-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.7321 13.5803C16.6483 13.3708 16.3517 13.3708 16.2679 13.5803L15.5583 15.3543C15.5226 15.4434 15.4392 15.5042 15.3435 15.5109L13.5822 15.6333C13.3629 15.6485 13.2686 15.9191 13.431 16.0673L14.8881 17.3978C14.9569 17.4606 14.985 17.5565 14.9611 17.6465L14.5111 19.3433C14.4514 19.5681 14.7041 19.7454 14.8952 19.6129L16.3575 18.5988C16.4432 18.5394 16.5568 18.5394 16.6425 18.5988L18.1048 19.6129C18.2959 19.7454 18.5486 19.5681 18.4889 19.3433L18.0389 17.6465C18.015 17.5565 18.0431 17.4606 18.1119 17.3978L19.569 16.0673C19.7314 15.9191 19.6371 15.6485 19.4178 15.6333L17.6565 15.5109C17.5608 15.5042 17.4774 15.4434 17.4417 15.3543L16.7321 13.5803Z",
        fill: "url(#side-bar-credit-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-inactive",
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-inactive-1",
        x1: "12",
        y1: "2.5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-inactive-2",
        x1: "12",
        y1: "2.5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-credit-inactive-3",
        x1: "12",
        y1: "2.5",
        x2: "12",
        y2: "20",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-control-plane-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.3311 0.0379362C12.2717 0.0135843 12.2052 0.0130368 12.1454 0.0364073L2.13483 3.94732C2.05143 3.97991 1.99169 4.05496 1.97884 4.14357C0.757574 12.566 3.10969 20.6852 12.1532 23.9692C12.2076 23.989 12.2696 23.989 12.324 23.9692C21.3735 20.686 23.6987 13.0484 22.0254 4.13374C22.0098 4.05076 21.9529 3.9807 21.8748 3.94869L12.3311 0.0379362Z",
        fill: "url(#paint0_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 5C13.8558 5 15 6.46667 15 8.11111V9L16 9C16.5523 9 17 9.44772 17 10V15C17 15.5523 16.5523 16 16 16H8C7.44772 16 7 15.5523 7 15V10C7 9.44772 7.44772 9 8 9L9 9V8.11111C9 6.46667 10.193 5 12 5ZM14 8.11111V9L10 9V8C10 7.06667 10.9744 6 12 6C13.0256 6 14 7.17778 14 8.11111ZM13 12C13 12.3701 12.7989 12.6933 12.5 12.8662V14.25C12.5 14.3881 12.3881 14.5 12.25 14.5H11.75C11.6119 14.5 11.5 14.3881 11.5 14.25V12.8662C11.2011 12.6933 11 12.3701 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
        fill: "url(#paint1_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear",
        x1: "12.2386",
        y1: "0",
        x2: "12.2386",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-control-plane-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.3311 0.0379362C12.2717 0.0135843 12.2052 0.0130368 12.1454 0.0364073L2.13483 3.94732C2.05143 3.97991 1.99169 4.05496 1.97884 4.14357C0.757574 12.566 3.10969 20.6852 12.1532 23.9692C12.2076 23.989 12.2696 23.989 12.324 23.9692C21.3735 20.686 23.6987 13.0484 22.0254 4.13374C22.0098 4.05076 21.9529 3.9807 21.8748 3.94869L12.3311 0.0379362Z",
        fill: "url(#side-bar-fraud-prevention-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 5C13.8558 5 15 6.46667 15 8.11111V9L16 9C16.5523 9 17 9.44772 17 10V15C17 15.5523 16.5523 16 16 16H8C7.44772 16 7 15.5523 7 15V10C7 9.44772 7.44772 9 8 9L9 9V8.11111C9 6.46667 10.193 5 12 5ZM14 8.11111V9L10 9V8C10 7.06667 10.9744 6 12 6C13.0256 6 14 7.17778 14 8.11111ZM13 12C13 12.3701 12.7989 12.6933 12.5 12.8662V14.25C12.5 14.3881 12.3881 14.5 12.25 14.5H11.75C11.6119 14.5 11.5 14.3881 11.5 14.25V12.8662C11.2011 12.6933 11 12.3701 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
        fill: "url(#side-bar-fraud-prevention-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-inactive",
        x1: "12.2386",
        y1: "0",
        x2: "12.2386",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-inactive-1",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-customers-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-customers-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z",
        fill: "url(#side-bar-customers-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 12C8.12698 12 7.61732 12.2666 7 13C6.38268 13.7334 6 15.9628 6 17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17C18 15.9628 17.6173 13.7334 17 13C16.3827 12.2666 15.873 12 15 12H9Z",
        fill: "url(#side-bar-customers-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-active-1",
        x1: "12",
        y1: "5.5",
        x2: "12",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-active-2",
        x1: "12",
        y1: "5.5",
        x2: "12",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-customers-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-customers-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z",
        fill: "url(#side-bar-customers-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9 12C8.12698 12 7.61732 12.2666 7 13C6.38268 13.7334 6 15.9628 6 17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17C18 15.9628 17.6173 13.7334 17 13C16.3827 12.2666 15.873 12 15 12H9Z",
        fill: "url(#side-bar-customers-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-inactive-1",
        x1: "12",
        y1: "5.5",
        x2: "12",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-customers-inactive-2",
        x1: "12",
        y1: "5.5",
        x2: "12",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-development-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "3",
        width: "24",
        height: "18",
        rx: "0.5",
        fill: "url(#side-bar-development-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.07067 11.1718C5.97645 11.2727 5.97645 11.4363 6.07067 11.5373L8.37082 14.001L6.07067 16.4646C5.97644 16.5656 5.97644 16.7292 6.07067 16.8301L7.09402 17.9262C7.18824 18.0271 7.34101 18.0271 7.43523 17.9262L10.9293 14.1838C11.0235 14.0828 11.0235 13.9192 10.9293 13.8183L7.43524 10.0757C7.34101 9.97477 7.18824 9.97477 7.09402 10.0757L6.07067 11.1718Z",
        fill: "url(#side-bar-development-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 16.25C12 16.112 12.1119 16 12.25 16H17.75C17.888 16 18 16.112 18 16.25V17.75C18 17.8881 17.888 18 17.75 18H12.25C12.1119 18 12 17.8881 12 17.75V16.25Z",
        fill: "url(#side-bar-development-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 3.5C0 3.22386 0.223858 3 0.5 3H23.5C23.7761 3 24 3.22386 24 3.5V7H0V3.5Z",
        fill: "url(#side-bar-development-active-3)"
      }
    ),
    /* @__PURE__ */ e.createElement("circle", { cx: "2", cy: "5", r: "1", fill: "url(#paint4_linear)" }),
    /* @__PURE__ */ e.createElement("circle", { cx: "5", cy: "5", r: "1", fill: "url(#paint5_linear)" }),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-active",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-active-1",
        x1: "15",
        y1: "10",
        x2: "15",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-active-2",
        x1: "15",
        y1: "10",
        x2: "15",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-active-3",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "7",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "2",
        y1: "4",
        x2: "2",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "5",
        y1: "4",
        x2: "5",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ))
  ),
  "side-bar-development-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "rect",
      {
        y: "3",
        width: "24",
        height: "18",
        rx: "0.5",
        fill: "url(#side-bar-development-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.07067 11.1718C5.97645 11.2727 5.97645 11.4363 6.07067 11.5373L8.37082 14.001L6.07067 16.4646C5.97644 16.5656 5.97644 16.7292 6.07067 16.8301L7.09402 17.9262C7.18824 18.0271 7.34101 18.0271 7.43523 17.9262L10.9293 14.1838C11.0235 14.0828 11.0235 13.9192 10.9293 13.8183L7.43524 10.0757C7.34101 9.97477 7.18824 9.97477 7.09402 10.0757L6.07067 11.1718Z",
        fill: "url(#side-bar-development-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 16.25C12 16.112 12.1119 16 12.25 16H17.75C17.888 16 18 16.112 18 16.25V17.75C18 17.8881 17.888 18 17.75 18H12.25C12.1119 18 12 17.8881 12 17.75V16.25Z",
        fill: "url(#side-bar-development-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 3.5C0 3.22386 0.223858 3 0.5 3H23.5C23.7761 3 24 3.22386 24 3.5V7H0V3.5Z",
        fill: "url(#side-bar-development-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement("circle", { cx: "2", cy: "5", r: "1", fill: "url(#paint4_linear)" }),
    /* @__PURE__ */ e.createElement("circle", { cx: "5", cy: "5", r: "1", fill: "url(#paint5_linear)" }),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-inactive",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-inactive-1",
        x1: "15",
        y1: "10",
        x2: "15",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-inactive-2",
        x1: "15",
        y1: "10",
        x2: "15",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-development-inactive-3",
        x1: "12",
        y1: "3",
        x2: "12",
        y2: "7",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear",
        x1: "2",
        y1: "4",
        x2: "2",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint5_linear",
        x1: "5",
        y1: "4",
        x2: "5",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ))
  ),
  "side-bar-fraud-prevention-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.3311 0.0379362C12.2717 0.0135843 12.2052 0.0130368 12.1454 0.0364073L2.13483 3.94732C2.05143 3.97991 1.99169 4.05496 1.97884 4.14357C0.757574 12.566 3.10969 20.6852 12.1532 23.9692C12.2076 23.989 12.2696 23.989 12.324 23.9692C21.3735 20.686 23.6987 13.0484 22.0254 4.13374C22.0098 4.05076 21.9529 3.9807 21.8748 3.94869L12.3311 0.0379362Z",
        fill: "url(#side-bar-fraud-prevention-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 5C13.8558 5 15 6.46667 15 8.11111V9L16 9C16.5523 9 17 9.44772 17 10V15C17 15.5523 16.5523 16 16 16H8C7.44772 16 7 15.5523 7 15V10C7 9.44772 7.44772 9 8 9L9 9V8.11111C9 6.46667 10.193 5 12 5ZM14 8.11111V9L10 9V8C10 7.06667 10.9744 6 12 6C13.0256 6 14 7.17778 14 8.11111ZM13 12C13 12.3701 12.7989 12.6933 12.5 12.8662V14.25C12.5 14.3881 12.3881 14.5 12.25 14.5H11.75C11.6119 14.5 11.5 14.3881 11.5 14.25V12.8662C11.2011 12.6933 11 12.3701 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
        fill: "url(#side-bar-fraud-prevention-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-active",
        x1: "12.2386",
        y1: "0",
        x2: "12.2386",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-active-1",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-fraud-prevention-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.3311 0.0379362C12.2717 0.0135843 12.2052 0.0130368 12.1454 0.0364073L2.13483 3.94732C2.05143 3.97991 1.99169 4.05496 1.97884 4.14357C0.757574 12.566 3.10969 20.6852 12.1532 23.9692C12.2076 23.989 12.2696 23.989 12.324 23.9692C21.3735 20.686 23.6987 13.0484 22.0254 4.13374C22.0098 4.05076 21.9529 3.9807 21.8748 3.94869L12.3311 0.0379362Z",
        fill: "url(#side-bar-fraud-prevention-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 5C13.8558 5 15 6.46667 15 8.11111V9L16 9C16.5523 9 17 9.44772 17 10V15C17 15.5523 16.5523 16 16 16H8C7.44772 16 7 15.5523 7 15V10C7 9.44772 7.44772 9 8 9L9 9V8.11111C9 6.46667 10.193 5 12 5ZM14 8.11111V9L10 9V8C10 7.06667 10.9744 6 12 6C13.0256 6 14 7.17778 14 8.11111ZM13 12C13 12.3701 12.7989 12.6933 12.5 12.8662V14.25C12.5 14.3881 12.3881 14.5 12.25 14.5H11.75C11.6119 14.5 11.5 14.3881 11.5 14.25V12.8662C11.2011 12.6933 11 12.3701 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z",
        fill: "url(#side-bar-fraud-prevention-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-inactive",
        x1: "12.2386",
        y1: "0",
        x2: "12.2386",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-fraud-prevention-inactive-1",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-home-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.6163 0.153132L0.833519 11.1499C0.523303 11.4663 0.747401 12 1.19049 12C1.71859 12 2.27173 12 2.5 12C2.80118 12 3 12.2193 3 12.5V21.5217C3 21.8025 3.19882 22 3.5 22H8.99997C8.99997 20.625 8.99997 21.8025 8.99997 21.5217V16.2609C9.50799 16.2609 9.66213 16.5 9.9633 16.5H14.0274C14.3286 16.5 14.492 16.5 15 16.5V21.5217C15 21.8025 15 22 15 22H20.5C20.8012 22 21 21.7807 21 21.5V12.5C21 12.2193 21.1988 12 21.5 12H22.7929C23.2383 12 23.4621 11.4604 23.1488 11.1438C22.6181 10.6076 22.2423 10.2259 22 10L12.3829 0.153132C12.1639 -0.0510441 11.8353 -0.0510441 11.6163 0.153132Z",
        fill: "url(#side-bar-home-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.99997 15.25C8.99997 15.1119 9.1119 15 9.24997 15H14.75C14.888 15 15 15.1119 15 15.25V22H8.99997V15.25Z",
        fill: "url(#side-bar-home-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-home-active",
        x1: "11.9954",
        y1: "0",
        x2: "11.9954",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-home-active-1",
        x1: "12",
        y1: "15",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-home-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.6163 0.153132L0.833519 11.1499C0.523303 11.4663 0.747401 12 1.19049 12C1.71859 12 2.27173 12 2.5 12C2.80118 12 3 12.2193 3 12.5V21.5217C3 21.8025 3.19882 22 3.5 22H8.99997C8.99997 20.625 8.99997 21.8025 8.99997 21.5217V16.2609C9.50799 16.2609 9.66213 16.5 9.9633 16.5H14.0274C14.3286 16.5 14.492 16.5 15 16.5V21.5217C15 21.8025 15 22 15 22H20.5C20.8012 22 21 21.7807 21 21.5V12.5C21 12.2193 21.1988 12 21.5 12H22.7929C23.2383 12 23.4621 11.4604 23.1488 11.1438C22.6181 10.6076 22.2423 10.2259 22 10L12.3829 0.153132C12.1639 -0.0510441 11.8353 -0.0510441 11.6163 0.153132Z",
        fill: "url(#side-bar-home-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.99997 15.25C8.99997 15.1119 9.1119 15 9.24997 15H14.75C14.888 15 15 15.1119 15 15.25V22H8.99997V15.25Z",
        fill: "url(#side-bar-home-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-home-inactive",
        x1: "11.9954",
        y1: "0",
        x2: "11.9954",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-home-inactive-1",
        x1: "12",
        y1: "15",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-reports-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.5 4.5L7.85355 2.14645C7.94732 2.05268 8.0745 2 8.20711 2H20.5C20.7761 2 21 2.22386 21 2.5V21.5C21 21.7761 20.7761 22 20.5 22H3.5C3.22386 22 3 21.7761 3 21.5V7.20711C3 7.0745 3.05268 6.94732 3.14645 6.85355L5.5 4.5Z",
        fill: "url(#side-bar-reports-active)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M3 7L8 2V6.5C8 6.77614 7.77614 7 7.5 7H3Z",
        fill: "url(#side-bar-reports-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 13.25C7 13.1119 7.11193 13 7.25 13H8.75C8.88807 13 9 13.1119 9 13.25V17.75C9 17.8881 8.88807 18 8.75 18H7.25C7.11193 18 7 17.8881 7 17.75V13.25Z",
        fill: "url(#side-bar-reports-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 10.25C11 10.1119 11.1119 10 11.25 10H12.75C12.8881 10 13 10.1119 13 10.25V17.75C13 17.8881 12.8881 18 12.75 18H11.25C11.1119 18 11 17.8881 11 17.75V10.25Z",
        fill: "url(#side-bar-reports-active-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 7.25C15 7.11193 15.1119 7 15.25 7H16.75C16.8881 7 17 7.11193 17 7.25V17.75C17 17.8881 16.8881 18 16.75 18H15.25C15.1119 18 15 17.8881 15 17.75V7.25Z",
        fill: "url(#side-bar-reports-active-4)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-active",
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-active-1",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-active-2",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-active-3",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-active-4",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-reports-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M5.5 4.5L7.85355 2.14645C7.94732 2.05268 8.0745 2 8.20711 2H20.5C20.7761 2 21 2.22386 21 2.5V21.5C21 21.7761 20.7761 22 20.5 22H3.5C3.22386 22 3 21.7761 3 21.5V7.20711C3 7.0745 3.05268 6.94732 3.14645 6.85355L5.5 4.5Z",
        fill: "url(#side-bar-reports-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M3 7L8 2V6.5C8 6.77614 7.77614 7 7.5 7H3Z",
        fill: "url(#side-bar-reports-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 13.25C7 13.1119 7.11193 13 7.25 13H8.75C8.88807 13 9 13.1119 9 13.25V17.75C9 17.8881 8.88807 18 8.75 18H7.25C7.11193 18 7 17.8881 7 17.75V13.25Z",
        fill: "url(#side-bar-reports-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 10.25C11 10.1119 11.1119 10 11.25 10H12.75C12.8881 10 13 10.1119 13 10.25V17.75C13 17.8881 12.8881 18 12.75 18H11.25C11.1119 18 11 17.8881 11 17.75V10.25Z",
        fill: "url(#side-bar-reports-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15 7.25C15 7.11193 15.1119 7 15.25 7H16.75C16.8881 7 17 7.11193 17 7.25V17.75C17 17.8881 16.8881 18 16.75 18H15.25C15.1119 18 15 17.8881 15 17.75V7.25Z",
        fill: "url(#side-bar-reports-inactive-4)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-inactive",
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-inactive-1",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-inactive-2",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-inactive-3",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-reports-inactive-4",
        x1: "16",
        y1: "7",
        x2: "16",
        y2: "18",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-reports-inactive-empty": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "32", cy: "32", r: "32", fill: "url(#paint0_linear)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M23.3333 22L26.4714 18.8619C26.5964 18.7369 26.766 18.6666 26.9428 18.6666H43.3333C43.7015 18.6666 44 18.9651 44 19.3333V44.6666C44 45.0348 43.7015 45.3333 43.3333 45.3333H20.6667C20.2985 45.3333 20 45.0348 20 44.6666V25.6094C20 25.4326 20.0702 25.2631 20.1953 25.138L23.3333 22Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20 25.3333L26.6667 18.6666V24.6666C26.6667 25.0348 26.3682 25.3333 26 25.3333H20Z",
        fill: "#DEDFE6"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M25.3333 33.6666C25.3333 33.4825 25.4826 33.3333 25.6667 33.3333H27.6667C27.8508 33.3333 28 33.4825 28 33.6666V39.6666C28 39.8507 27.8508 40 27.6667 40H25.6667C25.4826 40 25.3333 39.8507 25.3333 39.6666V33.6666Z",
        fill: "#DEDFE6"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M30.6667 29.6666C30.6667 29.4825 30.8159 29.3333 31 29.3333H33C33.1841 29.3333 33.3333 29.4825 33.3333 29.6666V39.6666C33.3333 39.8507 33.1841 40 33 40H31C30.8159 40 30.6667 39.8507 30.6667 39.6666V29.6666Z",
        fill: "#DEDFE6"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M36 25.6666C36 25.4825 36.1492 25.3333 36.3333 25.3333H38.3333C38.5174 25.3333 38.6667 25.4825 38.6667 25.6666V39.6666C38.6667 39.8507 38.5174 40 38.3333 40H36.3333C36.1492 40 36 39.8507 36 39.6666V25.6666Z",
        fill: "#DEDFE6"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear",
        x1: "32",
        y1: "0",
        x2: "32",
        y2: "64",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "side-bar-settings-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-settings-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.52886 7.86428L9.97825 7.12135C10.0424 7.08847 10.0892 7.0295 10.1067 6.95957L10.5497 5.18931C10.5776 5.07805 10.6776 5 10.7923 5H13.2192C13.3294 5 13.4265 5.0721 13.4585 5.17752L14.0012 6.969C14.0207 7.03334 14.0652 7.08713 14.1249 7.11821L15.5528 7.86255C15.6088 7.89172 15.6737 7.89865 15.7346 7.88193L17.3763 7.43113C17.479 7.40291 17.5884 7.44293 17.6487 7.53081L19.0101 9.5161C19.0788 9.61627 19.0656 9.75133 18.9787 9.83625L17.6232 11.1615C17.5751 11.2085 17.548 11.273 17.548 11.3402V12.7999C17.548 12.871 17.5783 12.9388 17.6313 12.9862L18.9786 14.1918C19.0663 14.2703 19.0874 14.3994 19.0293 14.5017L17.781 16.6973C17.7242 16.7973 17.6065 16.8456 17.4958 16.8144L15.7344 16.3178C15.6736 16.3007 15.6087 16.3072 15.5525 16.336L13.7315 17.2694C13.648 17.3122 13.5955 17.3981 13.5955 17.4919V18.7657C13.5955 18.9038 13.4836 19.0157 13.3455 19.0157H10.7108C10.5727 19.0157 10.4608 18.9038 10.4608 18.7657V17.4421C10.4608 17.3469 10.4068 17.26 10.3215 17.2179L8.5307 16.3341C8.47473 16.3065 8.41046 16.3008 8.35051 16.3182L6.63266 16.8157C6.52654 16.8465 6.41284 16.8039 6.35298 16.711L5.00973 14.6274C4.94581 14.5282 4.9599 14.3979 5.04354 14.3147L6.38016 12.985C6.42733 12.9381 6.45385 12.8743 6.45385 12.8077V11.339C6.45385 11.2724 6.42733 11.2086 6.38016 11.1617L5.04656 9.83504C4.96156 9.75049 4.94856 9.61751 5.01556 9.51809L6.3546 7.53124C6.41403 7.44306 6.52274 7.40212 6.62557 7.4292L8.35116 7.88357C8.41075 7.89926 8.47403 7.89239 8.52886 7.86428ZM12.0146 14.1978C13.2425 14.1978 14.2379 13.2173 14.2379 12.0079C14.2379 10.7984 13.2425 9.8179 12.0146 9.8179C10.7868 9.8179 9.79138 10.7984 9.79138 12.0079C9.79138 13.2173 10.7868 14.1978 12.0146 14.1978Z",
        fill: "url(#side-bar-settings-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settings-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settings-active-1",
        x1: "12.0159",
        y1: "5",
        x2: "12.0159",
        y2: "19.0157",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-settings-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-settings-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.52886 7.86428L9.97825 7.12135C10.0424 7.08847 10.0892 7.0295 10.1067 6.95957L10.5497 5.18931C10.5776 5.07805 10.6776 5 10.7923 5H13.2192C13.3294 5 13.4265 5.0721 13.4585 5.17752L14.0012 6.969C14.0207 7.03334 14.0652 7.08713 14.1249 7.11821L15.5528 7.86255C15.6088 7.89172 15.6737 7.89865 15.7346 7.88193L17.3763 7.43113C17.479 7.40291 17.5884 7.44293 17.6487 7.53081L19.0101 9.5161C19.0788 9.61627 19.0656 9.75133 18.9787 9.83625L17.6232 11.1615C17.5751 11.2085 17.548 11.273 17.548 11.3402V12.7999C17.548 12.871 17.5783 12.9388 17.6313 12.9862L18.9786 14.1918C19.0663 14.2703 19.0874 14.3994 19.0293 14.5017L17.781 16.6973C17.7242 16.7973 17.6065 16.8456 17.4958 16.8144L15.7344 16.3178C15.6736 16.3007 15.6087 16.3072 15.5525 16.336L13.7315 17.2694C13.648 17.3122 13.5955 17.3981 13.5955 17.4919V18.7657C13.5955 18.9038 13.4836 19.0157 13.3455 19.0157H10.7108C10.5727 19.0157 10.4608 18.9038 10.4608 18.7657V17.4421C10.4608 17.3469 10.4068 17.26 10.3215 17.2179L8.5307 16.3341C8.47473 16.3065 8.41046 16.3008 8.35051 16.3182L6.63266 16.8157C6.52654 16.8465 6.41284 16.8039 6.35298 16.711L5.00973 14.6274C4.94581 14.5282 4.9599 14.3979 5.04354 14.3147L6.38016 12.985C6.42733 12.9381 6.45385 12.8743 6.45385 12.8077V11.339C6.45385 11.2724 6.42733 11.2086 6.38016 11.1617L5.04656 9.83504C4.96156 9.75049 4.94856 9.61751 5.01556 9.51809L6.3546 7.53124C6.41403 7.44306 6.52274 7.40212 6.62557 7.4292L8.35116 7.88357C8.41075 7.89926 8.47403 7.89239 8.52886 7.86428ZM12.0146 14.1978C13.2425 14.1978 14.2379 13.2173 14.2379 12.0079C14.2379 10.7984 13.2425 9.8179 12.0146 9.8179C10.7868 9.8179 9.79138 10.7984 9.79138 12.0079C9.79138 13.2173 10.7868 14.1978 12.0146 14.1978Z",
        fill: "url(#side-bar-settings-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settings-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settings-inactive-1",
        x1: "12.0159",
        y1: "5",
        x2: "12.0159",
        y2: "19.0157",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ))
  ),
  "side-bar-settlements-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#side-bar-settlements-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.25C11 5.11193 11.1119 5 11.25 5H12.75C12.8881 5 13 5.11193 13 5.25V18.75C13 18.8881 12.8881 19 12.75 19H11.25C11.1119 19 11 18.8881 11 18.75V5.25Z",
        fill: "url(#side-bar-settlements-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 17.25C7 17.1119 7.11193 17 7.25 17H16.75C16.8881 17 17 17.1119 17 17.25V18.75C17 18.8881 16.8881 19 16.75 19H7.25C7.11193 19 7 18.8881 7 18.75V17.25Z",
        fill: "url(#side-bar-settlements-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 6.25C6 6.11193 6.11193 6 6.25 6H17.75C17.8881 6 18 6.11193 18 6.25V7.75C18 7.88807 17.8881 8 17.75 8H6.25C6.11193 8 6 7.88807 6 7.75V6.25Z",
        fill: "url(#side-bar-settlements-active-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.32516 7.02817L8.75391 7.74275C9.26567 8.59569 9.9029 9.90911 10.0933 11.0422C10.1871 11.6006 10.1892 12.2097 9.91397 12.6984C9.61094 13.2366 9.05131 13.5 8.32516 13.5C7.59902 13.5 7.03939 13.2366 6.73636 12.6984C6.46114 12.2097 6.46326 11.6006 6.55707 11.0422C6.74743 9.90911 7.38465 8.59569 7.89642 7.74275L8.32516 7.02817ZM7.60772 12.2078C7.68594 12.3467 7.85131 12.5 8.32516 12.5C8.79902 12.5 8.96439 12.3467 9.04261 12.2078C9.14864 12.0195 9.18826 11.6911 9.10707 11.2078C8.99338 10.5311 8.67524 9.7345 8.32516 9.03808C7.97509 9.7345 7.65695 10.5311 7.54325 11.2078C7.46207 11.6911 7.50168 12.0195 7.60772 12.2078Z",
        fill: "url(#side-bar-settlements-active-4)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6751 7.02817L16.1039 7.74275C16.6156 8.59569 17.2529 9.90911 17.4432 11.0422C17.537 11.6006 17.5392 12.2097 17.2639 12.6984C16.9609 13.2366 16.4013 13.5 15.6751 13.5C14.949 13.5 14.3894 13.2366 14.0863 12.6984C13.8111 12.2097 13.8132 11.6006 13.907 11.0422C14.0974 9.90911 14.7346 8.59569 15.2464 7.74275L15.6751 7.02817ZM14.9577 12.2078C15.0359 12.3467 15.2013 12.5 15.6751 12.5C16.149 12.5 16.3144 12.3467 16.3926 12.2078C16.4986 12.0195 16.5382 11.6911 16.457 11.2078C16.3434 10.5311 16.0252 9.7345 15.6751 9.03808C15.3251 9.7345 15.0069 10.5311 14.8932 11.2078C14.812 11.6911 14.8517 12.0195 14.9577 12.2078Z",
        fill: "url(#side-bar-settlements-active-5)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.5 11C9.5 9.8 8.5 8.83333 8 8.5L7.5 10C7.33333 10.5 7 11.6 7 12C7 12.4 8.33333 12.8333 9 13C9.16667 12.8333 9.5 12.2 9.5 11Z",
        fill: "url(#side-bar-settlements-active-6)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 12L16 8.5L14.5 9.5V11.5L15 12.5L16.5 13L17 12Z",
        fill: "url(#side-bar-settlements-active-7)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-1",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-2",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-3",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-4",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-5",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-6",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-active-7",
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "side-bar-settlements-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "url(#side-bar-settlements-inactive)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 5.25C11 5.11193 11.1119 5 11.25 5H12.75C12.8881 5 13 5.11193 13 5.25V18.75C13 18.8881 12.8881 19 12.75 19H11.25C11.1119 19 11 18.8881 11 18.75V5.25Z",
        fill: "url(#side-bar-settlements-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 17.25C7 17.1119 7.11193 17 7.25 17H16.75C16.8881 17 17 17.1119 17 17.25V18.75C17 18.8881 16.8881 19 16.75 19H7.25C7.11193 19 7 18.8881 7 18.75V17.25Z",
        fill: "url(#side-bar-settlements-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 6.25C6 6.11193 6.11193 6 6.25 6H17.75C17.8881 6 18 6.11193 18 6.25V7.75C18 7.88807 17.8881 8 17.75 8H6.25C6.11193 8 6 7.88807 6 7.75V6.25Z",
        fill: "url(#side-bar-settlements-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.32516 7.02817L8.75391 7.74275C9.26567 8.59569 9.9029 9.90911 10.0933 11.0422C10.1871 11.6006 10.1892 12.2097 9.91397 12.6984C9.61094 13.2366 9.05131 13.5 8.32516 13.5C7.59902 13.5 7.03939 13.2366 6.73636 12.6984C6.46114 12.2097 6.46326 11.6006 6.55707 11.0422C6.74743 9.90911 7.38465 8.59569 7.89642 7.74275L8.32516 7.02817ZM7.60772 12.2078C7.68594 12.3467 7.85131 12.5 8.32516 12.5C8.79902 12.5 8.96439 12.3467 9.04261 12.2078C9.14864 12.0195 9.18826 11.6911 9.10707 11.2078C8.99338 10.5311 8.67524 9.7345 8.32516 9.03808C7.97509 9.7345 7.65695 10.5311 7.54325 11.2078C7.46207 11.6911 7.50168 12.0195 7.60772 12.2078Z",
        fill: "url(#side-bar-settlements-inactive-4)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6751 7.02817L16.1039 7.74275C16.6156 8.59569 17.2529 9.90911 17.4432 11.0422C17.537 11.6006 17.5392 12.2097 17.2639 12.6984C16.9609 13.2366 16.4013 13.5 15.6751 13.5C14.949 13.5 14.3894 13.2366 14.0863 12.6984C13.8111 12.2097 13.8132 11.6006 13.907 11.0422C14.0974 9.90911 14.7346 8.59569 15.2464 7.74275L15.6751 7.02817ZM14.9577 12.2078C15.0359 12.3467 15.2013 12.5 15.6751 12.5C16.149 12.5 16.3144 12.3467 16.3926 12.2078C16.4986 12.0195 16.5382 11.6911 16.457 11.2078C16.3434 10.5311 16.0252 9.7345 15.6751 9.03808C15.3251 9.7345 15.0069 10.5311 14.8932 11.2078C14.812 11.6911 14.8517 12.0195 14.9577 12.2078Z",
        fill: "url(#side-bar-settlements-inactive-5)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M9.5 11C9.5 9.8 8.5 8.83333 8 8.5L7.5 10C7.33333 10.5 7 11.6 7 12C7 12.4 8.33333 12.8333 9 13C9.16667 12.8333 9.5 12.2 9.5 11Z",
        fill: "url(#side-bar-settlements-inactive-6)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 12L16 8.5L14.5 9.5V11.5L15 12.5L16.5 13L17 12Z",
        fill: "url(#side-bar-settlements-inactive-7)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-1",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-2",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-3",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-4",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-5",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-6",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "side-bar-settlements-inactive-7",
        x1: "14.9233",
        y1: "19.3661",
        x2: "14.9233",
        y2: "6.66928",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ))
  ),
  "side-bar-digital-wallet-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5955 10.9802C14.3022 11.6868 15.3765 10.6125 14.6699 9.90584C13.1293 8.36532 10.6312 8.36506 9.09064 9.90558C8.38398 10.6122 9.45832 11.6866 10.165 10.9799C11.1124 10.0325 12.6481 10.0328 13.5955 10.9802ZM17.2007 7.15113C17.9073 7.85778 18.9817 6.78345 18.275 6.0768C14.7436 2.54537 9.01742 2.54511 5.48573 6.0768C4.77908 6.78345 5.85341 7.85778 6.56006 7.15113C9.49835 4.21284 14.2624 4.21284 17.2007 7.15113ZM15.3328 9.01903C16.0394 9.72569 17.1138 8.65135 16.4071 7.9447C13.9074 5.44494 9.85339 5.44494 7.35363 7.9447C6.64698 8.65135 7.72131 9.72569 8.42797 9.01903C10.3346 7.11241 13.4262 7.11241 15.3328 9.01903ZM6.00007 14V22.3946C7.76511 23.4156 9.81434 24 12.0001 24C14.1858 24 16.235 23.4156 18.0001 22.3946V14C18.0001 13.4477 17.5524 13 17.0001 13H7.00007C6.44778 13 6.00007 13.4477 6.00007 14Z",
        fill: "url(#paint1_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8 14H16C16 14.8284 15.3284 15.5 14.5 15.5H9.5C8.67157 15.5 8 14.8284 8 14Z",
        fill: "url(#paint2_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12.0992",
        y1: "5",
        x2: "12.0001",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12",
        y1: "-7",
        x2: "12",
        y2: "29",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ))
  ),
  "side-bar-digital-wallet-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5955 10.9803C14.3022 11.6869 15.3765 10.6126 14.6699 9.90593C13.1293 8.36541 10.6312 8.36515 9.09064 9.90567C8.38398 10.6123 9.45832 11.6867 10.165 10.98C11.1124 10.0326 12.6481 10.0329 13.5955 10.9803ZM17.2007 7.15122C17.9073 7.85788 18.9817 6.78354 18.275 6.07689C14.7436 2.54546 9.01742 2.5452 5.48573 6.07689C4.77908 6.78354 5.85341 7.85788 6.56006 7.15122C9.49835 4.21294 14.2624 4.21294 17.2007 7.15122ZM15.3328 9.01913C16.0394 9.72578 17.1138 8.65144 16.4071 7.94479C13.9074 5.44503 9.85339 5.44504 7.35363 7.94479C6.64698 8.65145 7.72131 9.72578 8.42797 9.01913C10.3346 7.11251 13.4262 7.1125 15.3328 9.01913ZM6.00007 14.0001V22.3947C7.76511 23.4157 9.81434 24.0001 12.0001 24.0001C14.1858 24.0001 16.235 23.4157 18.0001 22.3947V14.0001C18.0001 13.4478 17.5524 13.0001 17.0001 13.0001H7.00007C6.44778 13.0001 6.00007 13.4478 6.00007 14.0001Z",
        fill: "url(#paint1_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8 14H16C16 14.8284 15.3284 15.5 14.5 15.5H9.5C8.67157 15.5 8 14.8284 8 14Z",
        fill: "url(#paint2_linear)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear",
        x1: "12.0992",
        y1: "5.00009",
        x2: "12.0001",
        y2: "24.0001",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#909090" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#555555" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear",
        x1: "12",
        y1: "-7",
        x2: "12",
        y2: "29",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ))
  ),
  "usa-flag": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "mask",
      {
        id: "mask0",
        "mask-type": "alpha",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "-1",
        width: "20",
        height: "15"
      },
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          y: "-0.000244141",
          width: "20",
          height: "13.3333",
          rx: "0.5",
          fill: "#C4C4C4"
        }
      )
    ),
    /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M20 -0.000244141H0V13.3333H20V-0.000244141Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M20 1.66626H0V3.33276H20V1.66626Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M20 4.99976H0V6.66626H20V4.99976Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M20 8.33276H0V9.99927H20V8.33276Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M20 11.6663H0V13.3328H20V11.6663Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10 -0.000244141H0V7.17944H10V-0.000244141Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M3.89941 2.94067L3.73828 3.43628H3.21729L3.63867 3.74243L3.47754 4.23804L3.89893 3.93188L4.31982 4.23804L4.15869 3.74243L4.58008 3.43628H4.06006L3.89941 2.94067Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M4.06006 5.22437L3.89941 4.72876L3.73828 5.22437H3.21729L3.63867 5.53052L3.47754 6.02564L3.89893 5.71948L4.31982 6.02564L4.15869 5.53052L4.58008 5.22437H4.06006Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M1.8584 5.22437L1.69775 4.72876L1.53662 5.22437H1.01562L1.43701 5.53052L1.27588 6.02564L1.69727 5.71948L2.11816 6.02564L1.95703 5.53052L2.37842 5.22437H1.8584Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M1.69775 2.94067L1.53662 3.43628H1.01562L1.43701 3.74243L1.27588 4.23804L1.69727 3.93188L2.11816 4.23804L1.95703 3.74243L2.37842 3.43628H1.8584L1.69775 2.94067Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M3.89941 1.15259L3.73828 1.64819H3.21729L3.63867 1.95435L3.47754 2.44995L3.89893 2.1438L4.31982 2.44995L4.15869 1.95435L4.58008 1.64819H4.06006L3.89941 1.15259Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M1.69775 1.15259L1.53662 1.64819H1.01562L1.43701 1.95435L1.27588 2.44995L1.69727 2.1438L2.11816 2.44995L1.95703 1.95435L2.37842 1.64819H1.8584L1.69775 1.15259Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.10059 2.94067L5.93945 3.43628H5.41846L5.83984 3.74243L5.67871 4.23804L6.1001 3.93188L6.52148 4.23804L6.36035 3.74243L6.78174 3.43628H6.26074L6.10059 2.94067Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.26172 5.22437L6.10059 4.72876L5.93945 5.22437H5.41846L5.83984 5.53052L5.67871 6.02564L6.1001 5.71948L6.52148 6.02564L6.36035 5.53052L6.78174 5.22437H6.26172Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.46338 5.22437L8.30225 4.72876L8.14111 5.22437H7.62012L8.0415 5.53052L7.88037 6.02564L8.30176 5.71948L8.72314 6.02564L8.56201 5.53052L8.98438 5.22437H8.46338Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.30225 2.94067L8.14111 3.43628H7.62012L8.0415 3.74243L7.88037 4.23804L8.30176 3.93188L8.72314 4.23804L8.56201 3.74243L8.9834 3.43628H8.4624L8.30225 2.94067Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.10059 1.15259L5.93945 1.64819H5.41846L5.83984 1.95435L5.67871 2.44995L6.1001 2.1438L6.52148 2.44995L6.36035 1.95435L6.78174 1.64819H6.26074L6.10059 1.15259Z",
        fill: "#F0F0F0"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M8.30225 1.15259L8.14111 1.64819H7.62012L8.0415 1.95435L7.88037 2.44995L8.30176 2.1438L8.72314 2.44995L8.56201 1.95435L8.9834 1.64819H8.4624L8.30225 1.15259Z",
        fill: "#F0F0F0"
      }
    ))
  ),
  "balances-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#balances-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.89233 7.25C6.89233 7.11193 7.00426 7 7.14233 7H8.64233C8.78041 7 8.89233 7.11193 8.89233 7.25V14.4549L10.2861 13.1695C10.3876 13.0759 10.5521 13.0759 10.6536 13.1695L11.7086 14.1424C11.8101 14.236 11.8101 14.3878 11.7086 14.4814L8.6028 17.3458L8.60065 17.3438L8.07289 17.8305C7.9714 17.9241 7.80684 17.9241 7.70534 17.8305L4.07612 14.4834C3.97463 14.3898 3.97463 14.238 4.07612 14.1444L5.13324 13.1695C5.23473 13.0759 5.39929 13.0759 5.50079 13.1695L6.89233 14.4529V7.25Z",
        fill: "url(#balances-active-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.9 17.6507C16.9 17.7888 16.7881 17.9007 16.65 17.9007H15.15C15.012 17.9007 14.9 17.7888 14.9 17.6507L14.9 10.4458L13.5063 11.7312C13.4048 11.8248 13.2402 11.8248 13.1387 11.7312L12.0838 10.7583C11.9823 10.6646 11.9823 10.5129 12.0838 10.4193L15.1896 7.55492L15.1917 7.55691L15.7195 7.07018C15.821 6.97658 15.9855 6.97658 16.087 7.07018L19.7162 10.4173C19.8177 10.5109 19.8177 10.6626 19.7162 10.7562L18.6591 11.7312C18.5576 11.8248 18.3931 11.8248 18.2916 11.7312L16.9 10.4478L16.9 17.6507Z",
        fill: "url(#balances-active-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E5E8FB" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-active-1",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-active-2",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29972",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#7A92F1" })
    ))
  ),
  "balances-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#balances-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.89233 7.25C6.89233 7.11193 7.00426 7 7.14233 7H8.64233C8.78041 7 8.89233 7.11193 8.89233 7.25V14.4549L10.2861 13.1695C10.3876 13.0759 10.5521 13.0759 10.6536 13.1695L11.7086 14.1424C11.8101 14.236 11.8101 14.3878 11.7086 14.4814L8.6028 17.3458L8.60065 17.3438L8.07289 17.8305C7.9714 17.9241 7.80684 17.9241 7.70534 17.8305L4.07612 14.4834C3.97463 14.3898 3.97463 14.2381 4.07612 14.1445L5.13324 13.1695C5.23473 13.0759 5.39929 13.0759 5.50079 13.1695L6.89233 14.4529V7.25Z",
        fill: "url(#balances-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.9 17.6507C16.9 17.7888 16.7881 17.9007 16.65 17.9007H15.15C15.012 17.9007 14.9 17.7888 14.9 17.6507L14.9 10.4458L13.5063 11.7312C13.4048 11.8248 13.2402 11.8248 13.1387 11.7312L12.0838 10.7583C11.9823 10.6647 11.9823 10.5129 12.0838 10.4193L15.1896 7.55493L15.1917 7.55691L15.7195 7.07019C15.821 6.97658 15.9855 6.97658 16.087 7.07019L19.7162 10.4173C19.8177 10.5109 19.8177 10.6626 19.7162 10.7563L18.6591 11.7312C18.5576 11.8248 18.3931 11.8248 18.2916 11.7312L16.9 10.4478L16.9 17.6507Z",
        fill: "url(#balances-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#CECECE" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#A4A4A4" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-inactive-1",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29973",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "balances-inactive-2",
        x1: "15.7434",
        y1: "18.1858",
        x2: "15.7434",
        y2: "8.29973",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#555555" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#909090" })
    ))
  ),
  "credit-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#credit-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.37496 5.4C5.8365 5.4 5.39999 5.83651 5.39999 6.37497V17.4246C5.39999 17.9631 5.8365 18.3996 6.37497 18.3996H17.4246C17.9631 18.3996 18.3996 17.9631 18.3996 17.4246V6.37497C18.3996 5.83651 17.9631 5.4 17.4246 5.4H6.37496ZM6.70001 7.5122C6.70001 7.42246 6.77276 7.34971 6.86251 7.34971H15.6372C15.727 7.34971 15.7997 7.42246 15.7997 7.5122V8.48717C15.7997 8.57692 15.727 8.64967 15.6372 8.64967H6.86251C6.77276 8.64967 6.70001 8.57692 6.70001 8.48717V7.5122ZM6.70001 10.1121C6.70001 10.0224 6.77276 9.94963 6.86251 9.94963H13.0373C13.1271 9.94963 13.1998 10.0224 13.1998 10.1121V11.0871C13.1998 11.1768 13.1271 11.2496 13.0373 11.2496H6.86251C6.77276 11.2496 6.70001 11.1768 6.70001 11.0871V10.1121ZM14.6739 12.9267C14.7284 12.7905 14.9212 12.7905 14.9756 12.9267L15.4369 14.0798C15.46 14.1377 15.5143 14.1773 15.5765 14.1816L16.7213 14.2611C16.8638 14.271 16.9251 14.4469 16.8196 14.5432L15.8725 15.408C15.8278 15.4489 15.8095 15.5112 15.825 15.5697L16.1175 16.6726C16.1563 16.8187 15.9921 16.9339 15.8679 16.8478L14.9174 16.1887C14.8617 16.15 14.7879 16.15 14.7322 16.1887L13.7817 16.8478C13.6575 16.9339 13.4932 16.8187 13.532 16.6726L13.8245 15.5697C13.8401 15.5112 13.8218 15.4489 13.777 15.408L12.83 14.5432C12.7245 14.4469 12.7857 14.271 12.9283 14.2611L14.0731 14.1816C14.1353 14.1773 14.1895 14.1377 14.2127 14.0798L14.6739 12.9267Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "credit-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#credit-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.37496 5.4C5.8365 5.4 5.39999 5.83651 5.39999 6.37497V17.4246C5.39999 17.9631 5.8365 18.3996 6.37497 18.3996H17.4246C17.9631 18.3996 18.3996 17.9631 18.3996 17.4246V6.37497C18.3996 5.83651 17.9631 5.4 17.4246 5.4H6.37496ZM6.70001 7.5122C6.70001 7.42246 6.77276 7.34971 6.86251 7.34971H15.6372C15.727 7.34971 15.7997 7.42246 15.7997 7.5122V8.48717C15.7997 8.57692 15.727 8.64967 15.6372 8.64967H6.86251C6.77276 8.64967 6.70001 8.57692 6.70001 8.48717V7.5122ZM6.70001 10.1121C6.70001 10.0224 6.77276 9.94963 6.86251 9.94963H13.0373C13.1271 9.94963 13.1998 10.0224 13.1998 10.1121V11.0871C13.1998 11.1768 13.1271 11.2496 13.0373 11.2496H6.86251C6.77276 11.2496 6.70001 11.1768 6.70001 11.0871V10.1121ZM14.6739 12.9267C14.7284 12.7905 14.9212 12.7905 14.9756 12.9267L15.4369 14.0798C15.46 14.1377 15.5143 14.1773 15.5765 14.1816L16.7213 14.2611C16.8638 14.271 16.9251 14.4469 16.8196 14.5432L15.8725 15.408C15.8278 15.4489 15.8095 15.5112 15.825 15.5697L16.1175 16.6726C16.1563 16.8187 15.9921 16.9339 15.8679 16.8478L14.9174 16.1887C14.8617 16.15 14.7879 16.15 14.7322 16.1887L13.7817 16.8478C13.6575 16.9339 13.4932 16.8187 13.532 16.6726L13.8245 15.5697C13.8401 15.5112 13.8218 15.4489 13.777 15.408L12.83 14.5432C12.7245 14.4469 12.7857 14.271 12.9283 14.2611L14.0731 14.1816C14.1353 14.1773 14.1895 14.1377 14.2127 14.0798L14.6739 12.9267Z",
        fill: "url(#credit-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "credit-inactive-1",
        x1: "12",
        y1: "1.53773e-06",
        x2: "12",
        y2: "24.15",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "document-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#document-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5C7.44772 5 7 5.44772 7 6V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V6C17 5.44772 16.5523 5 16 5H8ZM9.25 9C9.11193 9 9 9.11193 9 9.25V9.75C9 9.88807 9.11193 10 9.25 10H14.75C14.8881 10 15 9.88807 15 9.75V9.25C15 9.11193 14.8881 9 14.75 9H9.25ZM9 11.25C9 11.1119 9.11193 11 9.25 11H14.75C14.8881 11 15 11.1119 15 11.25V11.75C15 11.8881 14.8881 12 14.75 12H9.25C9.11193 12 9 11.8881 9 11.75V11.25ZM9.25 13C9.11193 13 9 13.1119 9 13.25V13.75C9 13.8881 9.11193 14 9.25 14H12.75C12.8881 14 13 13.8881 13 13.75V13.25C13 13.1119 12.8881 13 12.75 13H9.25Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "document-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "document-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#document-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5C7.44772 5 7 5.44772 7 6V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V6C17 5.44772 16.5523 5 16 5H8ZM9.25 9C9.11193 9 9 9.11193 9 9.25V9.75C9 9.88807 9.11193 10 9.25 10H14.75C14.8881 10 15 9.88807 15 9.75V9.25C15 9.11193 14.8881 9 14.75 9H9.25ZM9 11.25C9 11.1119 9.11193 11 9.25 11H14.75C14.8881 11 15 11.1119 15 11.25V11.75C15 11.8881 14.8881 12 14.75 12H9.25C9.11193 12 9 11.8881 9 11.75V11.25ZM9.25 13C9.11193 13 9 13.1119 9 13.25V13.75C9 13.8881 9.11193 14 9.25 14H12.75C12.8881 14 13 13.8881 13 13.75V13.25C13 13.1119 12.8881 13 12.75 13H9.25Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "document-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ))
  ),
  "globe-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#globe-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 17V18L11 19.5V17H10C9.44772 17 9 16.5523 9 16V14L5 10L8 5L15 4V7C15 7.55228 14.5523 8 14 8H11V9C11 9.55228 10.5523 10 10 10H9V12H13C13.5523 12 14 12.4477 14 13V16H16C16.5523 16 17 16.4477 17 17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "globe-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "globe-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#globe-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
        fill: "url(#globe-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17 17V18L11 19.5V17H10C9.44772 17 9 16.5523 9 16V14L5 10L8 5L15 4V7C15 7.55228 14.5523 8 14 8H11V9C11 9.55228 10.5523 10 10 10H9V12H13C13.5523 12 14 12.4477 14 13V16H16C16.5523 16 17 16.4477 17 17Z",
        fill: "url(#globe-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "globe-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "globe-inactive-1",
        x1: "12",
        y1: "4.00267e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "globe-inactive-2",
        x1: "12",
        y1: "4.00267e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "mouse-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#mouse-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 4.10002C8.71776 4.56329 7 6.58104 7 9H11V4.10002Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13 4.10002V9H17C17 6.58104 15.2822 4.56329 13 4.10002Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 11H17V15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15V11Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "mouse-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "mouse-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#mouse-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 4.10002C8.71776 4.56329 7 6.58105 7 9H11V4.10002Z",
        fill: "url(#mouse-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13 4.10002V9H17C17 6.58105 15.2822 4.56329 13 4.10002Z",
        fill: "url(#mouse-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 11H17V15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15V11Z",
        fill: "url(#mouse-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "mouse-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "mouse-inactive-1",
        x1: "12",
        y1: "-1.4698e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "mouse-inactive-2",
        x1: "12",
        y1: "-1.4698e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "mouse-inactive-3",
        x1: "12",
        y1: "-1.4698e-08",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "thumbprint-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#thumbprint-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.99994 5L5.71321 4.59038C5.48699 4.74874 5.43197 5.06051 5.59033 5.28673C5.74863 5.51288 6.06024 5.56793 6.28644 5.40978L6.28966 5.40757L6.30684 5.39596C6.32296 5.38518 6.34835 5.36846 6.38264 5.34664C6.45124 5.30298 6.55535 5.239 6.69206 5.16141C6.96566 5.00612 7.36866 4.79699 7.87782 4.58734C8.89789 4.16731 10.3322 3.75 11.9999 3.75C13.6677 3.75 15.102 4.16731 16.1221 4.58734C16.6312 4.79699 17.0342 5.00612 17.3078 5.16141C17.4445 5.239 17.5486 5.30298 17.6172 5.34664C17.6515 5.36846 17.6769 5.38518 17.6931 5.39596L17.7102 5.40757L17.7132 5.40962C17.9394 5.5676 18.2513 5.51281 18.4096 5.28673C18.5679 5.06051 18.5129 4.74874 18.2867 4.59038L17.9999 5C18.2867 4.59038 18.2867 4.59038 18.2867 4.59038L18.2852 4.58933L18.2827 4.58764L18.2751 4.58239L18.249 4.56473C18.2268 4.54988 18.195 4.529 18.1541 4.50297C18.0723 4.45093 17.9538 4.37819 17.8014 4.29172C17.4969 4.11888 17.0562 3.89051 16.5028 3.66266C15.3979 3.20769 13.8322 2.75 11.9999 2.75C10.1677 2.75 8.602 3.20769 7.49707 3.66266C6.94373 3.89051 6.50297 4.11888 6.19845 4.29172C6.0461 4.37819 5.92755 4.45093 5.84577 4.50297C5.80486 4.529 5.77312 4.54988 5.75091 4.56473L5.72479 4.58239L5.71717 4.58764L5.71473 4.58933L5.71321 4.59038C5.71321 4.59038 5.71321 4.59038 5.99994 5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 14.25C12.2761 14.25 12.5 14.4739 12.5 14.75C12.5 16.368 13.0707 17.4037 13.8748 18.0471C14.6971 18.7049 15.824 19 17 19C17.2761 19 17.5 19.2239 17.5 19.5C17.5 19.7761 17.2761 20 17 20C15.6759 20 14.3028 19.6701 13.2501 18.8279C12.1793 17.9713 11.5 16.632 11.5 14.75C11.5 14.4739 11.7238 14.25 12 14.25Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3674 10.1444C15.888 10.9525 17.0957 12.5331 17.4931 14.9178C17.5385 15.1902 17.3545 15.4478 17.0821 15.4932C16.8097 15.5386 16.5521 15.3546 16.5067 15.0822C16.1542 12.9669 15.1119 11.6725 13.8981 11.0275C12.6719 10.3758 11.2238 10.3605 10.0145 10.8948C8.81327 11.4256 7.85183 12.4961 7.57815 14.033C7.30299 15.5781 7.71215 17.6669 9.416 20.2227C9.56918 20.4524 9.50709 20.7629 9.27733 20.916C9.04756 21.0692 8.73713 21.0071 8.58395 20.7774C6.78779 18.0831 6.25943 15.7344 6.59363 13.8577C6.9293 11.9727 8.12411 10.6369 9.61035 9.98015C11.0885 9.32699 12.8592 9.34292 14.3674 10.1444Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.26426 9.52871C7.886 7.83938 10.1593 7.24997 11.9999 7.24997H12.0128L12.0257 7.25063C16.7471 7.49398 19.4321 10.6672 19.985 12.8787C20.2551 13.9591 20.2326 15.2029 19.7866 16.2035C19.3256 17.2379 18.4092 18 16.9999 18C15.3482 18 14.4254 16.8541 14.0241 15.6749C13.9338 15.4093 13.8665 15.1342 13.8059 14.881C13.8011 14.861 13.7963 14.8412 13.7916 14.8215C13.7349 14.5842 13.6831 14.3674 13.6191 14.1618C13.4805 13.7171 13.3102 13.4145 13.0288 13.2264C12.4429 12.8348 11.6811 12.7984 11.0692 13.0976C10.4787 13.3863 9.99997 14.0029 9.99997 15C9.99997 16.414 10.3521 17.5528 11.025 18.45C11.6996 19.3494 12.729 20.0493 14.1581 20.5256C14.4201 20.613 14.5616 20.8961 14.4743 21.1581C14.387 21.4201 14.1038 21.5616 13.8419 21.4743C12.271 20.9507 11.0504 20.1505 10.225 19.05C9.39789 17.9472 8.99997 16.5859 8.99997 15C8.99997 13.6323 9.68626 12.6607 10.63 12.1993C11.5523 11.7483 12.6938 11.7997 13.5845 12.395C14.1492 12.7725 14.4104 13.3398 14.5738 13.8644C14.6484 14.1039 14.708 14.3533 14.763 14.5839C14.7682 14.6055 14.7733 14.6269 14.7784 14.6482C14.8396 14.9038 14.8973 15.1367 14.9708 15.3528C15.2927 16.2988 15.9336 17 16.9999 17C17.9706 17 18.5543 16.512 18.8732 15.7964C19.2073 15.047 19.2447 14.0408 19.0148 13.1212C18.5682 11.3346 16.2574 8.47559 11.9871 8.24998C10.3303 8.25274 8.36033 8.78926 6.98565 10.2212C5.6268 11.6367 4.76239 14.0197 5.49141 17.9078C5.54229 18.1792 5.36353 18.4405 5.09211 18.4914C4.8207 18.5423 4.55942 18.3635 4.50853 18.0921C3.73756 13.9802 4.62313 11.2382 6.26426 9.52871Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9999 6.00331C8.95607 6.00331 5.97464 7.28389 4.42394 9.765C4.27759 9.99917 3.96911 10.0704 3.73495 9.924C3.50078 9.77764 3.42959 9.46917 3.57595 9.235C5.35583 6.38719 8.70911 5.00331 11.9999 5.00331C15.2908 5.00331 18.6441 6.38719 20.4239 9.235C20.5703 9.46917 20.4991 9.77764 20.2649 9.924C20.0308 10.0704 19.7223 9.99917 19.5759 9.765C18.0253 7.28389 15.0438 6.00331 11.9999 6.00331Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-active",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "thumbprint-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#thumbprint-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.99994 5L5.71321 4.59038C5.48699 4.74874 5.43197 5.06051 5.59033 5.28673C5.74863 5.51288 6.06024 5.56793 6.28644 5.40978L6.28966 5.40757L6.30684 5.39596C6.32296 5.38518 6.34835 5.36846 6.38264 5.34664C6.45124 5.30298 6.55535 5.239 6.69206 5.16141C6.96566 5.00612 7.36866 4.79699 7.87782 4.58734C8.89789 4.16731 10.3322 3.75 11.9999 3.75C13.6677 3.75 15.102 4.16731 16.1221 4.58734C16.6312 4.79699 17.0342 5.00612 17.3078 5.16141C17.4445 5.239 17.5486 5.30298 17.6172 5.34664C17.6515 5.36846 17.6769 5.38518 17.6931 5.39596L17.7102 5.40757L17.7132 5.40962C17.9394 5.5676 18.2513 5.51281 18.4096 5.28673C18.5679 5.06051 18.5129 4.74874 18.2867 4.59038L17.9999 5C18.2867 4.59038 18.2867 4.59038 18.2867 4.59038L18.2852 4.58933L18.2827 4.58764L18.2751 4.58239L18.249 4.56473C18.2268 4.54988 18.195 4.529 18.1541 4.50297C18.0723 4.45093 17.9538 4.37819 17.8014 4.29172C17.4969 4.11888 17.0562 3.89051 16.5028 3.66266C15.3979 3.20769 13.8322 2.75 11.9999 2.75C10.1677 2.75 8.602 3.20769 7.49707 3.66266C6.94373 3.89051 6.50297 4.11888 6.19845 4.29172C6.0461 4.37819 5.92755 4.45093 5.84577 4.50297C5.80486 4.529 5.77312 4.54988 5.75091 4.56473L5.72479 4.58239L5.71717 4.58764L5.71473 4.58933L5.71321 4.59038C5.71321 4.59038 5.71321 4.59038 5.99994 5Z",
        fill: "url(#thumbprint-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 14.25C12.2761 14.25 12.5 14.4739 12.5 14.75C12.5 16.368 13.0707 17.4037 13.8748 18.0471C14.6971 18.7049 15.824 19 17 19C17.2761 19 17.5 19.2239 17.5 19.5C17.5 19.7761 17.2761 20 17 20C15.6759 20 14.3028 19.6701 13.2501 18.8279C12.1793 17.9713 11.5 16.632 11.5 14.75C11.5 14.4739 11.7238 14.25 12 14.25Z",
        fill: "url(#thumbprint-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.3674 10.1444C15.888 10.9525 17.0957 12.5331 17.4931 14.9178C17.5385 15.1902 17.3545 15.4478 17.0821 15.4932C16.8097 15.5386 16.5521 15.3546 16.5067 15.0822C16.1542 12.9669 15.1119 11.6725 13.8981 11.0275C12.6719 10.3758 11.2238 10.3605 10.0145 10.8948C8.81327 11.4256 7.85183 12.4961 7.57815 14.033C7.30299 15.5781 7.71215 17.6669 9.416 20.2227C9.56918 20.4524 9.50709 20.7629 9.27733 20.916C9.04756 21.0692 8.73713 21.0071 8.58395 20.7774C6.78779 18.0831 6.25943 15.7344 6.59363 13.8577C6.9293 11.9727 8.12411 10.6369 9.61035 9.98015C11.0885 9.32699 12.8592 9.34292 14.3674 10.1444Z",
        fill: "url(#thumbprint-inactive-3)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.26426 9.52871C7.886 7.83938 10.1593 7.24997 11.9999 7.24997H12.0128L12.0257 7.25063C16.7471 7.49398 19.4321 10.6672 19.985 12.8787C20.2551 13.9591 20.2326 15.2029 19.7866 16.2035C19.3256 17.2379 18.4092 18 16.9999 18C15.3482 18 14.4254 16.8541 14.0241 15.6749C13.9338 15.4093 13.8665 15.1342 13.8059 14.881C13.8011 14.861 13.7963 14.8412 13.7916 14.8215C13.7349 14.5842 13.6831 14.3674 13.6191 14.1618C13.4805 13.7171 13.3102 13.4145 13.0288 13.2264C12.4429 12.8348 11.6811 12.7984 11.0692 13.0976C10.4787 13.3863 9.99997 14.0029 9.99997 15C9.99997 16.414 10.3521 17.5528 11.025 18.45C11.6996 19.3494 12.729 20.0493 14.1581 20.5256C14.4201 20.613 14.5616 20.8961 14.4743 21.1581C14.387 21.4201 14.1038 21.5616 13.8419 21.4743C12.271 20.9507 11.0504 20.1505 10.225 19.05C9.39789 17.9472 8.99997 16.5859 8.99997 15C8.99997 13.6323 9.68626 12.6607 10.63 12.1993C11.5523 11.7483 12.6938 11.7997 13.5845 12.395C14.1492 12.7725 14.4104 13.3398 14.5738 13.8644C14.6484 14.1039 14.708 14.3533 14.763 14.5839C14.7682 14.6055 14.7733 14.6269 14.7784 14.6482C14.8396 14.9038 14.8973 15.1367 14.9708 15.3528C15.2927 16.2988 15.9336 17 16.9999 17C17.9706 17 18.5543 16.512 18.8732 15.7964C19.2073 15.047 19.2447 14.0408 19.0148 13.1212C18.5682 11.3346 16.2574 8.47559 11.9871 8.24998C10.3303 8.25274 8.36033 8.78926 6.98565 10.2212C5.6268 11.6367 4.76239 14.0197 5.49141 17.9078C5.54229 18.1792 5.36353 18.4405 5.09211 18.4914C4.8207 18.5423 4.55942 18.3635 4.50853 18.0921C3.73756 13.9802 4.62313 11.2382 6.26426 9.52871Z",
        fill: "url(#thumbprint-inactive-4)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9999 6.00331C8.95607 6.00331 5.97464 7.28389 4.42394 9.765C4.27759 9.99917 3.96911 10.0704 3.73495 9.924C3.50078 9.77764 3.42959 9.46917 3.57595 9.235C5.35583 6.38719 8.70911 5.00331 11.9999 5.00331C15.2908 5.00331 18.6441 6.38719 20.4239 9.235C20.5703 9.46917 20.4991 9.77764 20.2649 9.924C20.0308 10.0704 19.7223 9.99917 19.5759 9.765C18.0253 7.28389 15.0438 6.00331 11.9999 6.00331Z",
        fill: "url(#thumbprint-inactive-5)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive-1",
        x1: "12",
        y1: "-1.83118e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive-2",
        x1: "12",
        y1: "-1.83118e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive-3",
        x1: "12",
        y1: "-1.83118e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive-4",
        x1: "12",
        y1: "-1.83118e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "thumbprint-inactive-5",
        x1: "12",
        y1: "-1.83118e-07",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ))
  ),
  "virtual-card-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "url(#virtual-active)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 10C14 8.89543 14.8954 8 16 8H32C33.1046 8 34 8.89543 34 10V38C34 39.1046 33.1046 40 32 40H16C14.8954 40 14 39.1046 14 38V10ZM26 36C26 37.1046 25.1046 38 24 38C22.8954 38 22 37.1046 22 36C22 34.8954 22.8954 34 24 34C25.1046 34 26 34.8954 26 36ZM17 10C16.4477 10 16 10.4477 16 11V31C16 31.5523 16.4477 32 17 32H31C31.5523 32 32 31.5523 32 31V11C32 10.4477 31.5523 10 31 10H17Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 13C18 12.4477 18.4477 12 19 12H29C29.5523 12 30 12.4477 30 13V19C30 19.5523 29.5523 20 29 20H19C18.4477 20 18 19.5523 18 19V13Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "virtual-active",
        x1: "24",
        y1: "0",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ))
  ),
  "virtual-card-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "url(#virtual-inactive)" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 10C14 8.89543 14.8954 8 16 8H32C33.1046 8 34 8.89543 34 10V38C34 39.1046 33.1046 40 32 40H16C14.8954 40 14 39.1046 14 38V10ZM26 36C26 37.1046 25.1046 38 24 38C22.8954 38 22 37.1046 22 36C22 34.8954 22.8954 34 24 34C25.1046 34 26 34.8954 26 36ZM17 10C16.4477 10 16 10.4477 16 11V31C16 31.5523 16.4477 32 17 32H31C31.5523 32 32 31.5523 32 31V11C32 10.4477 31.5523 10 31 10H17Z",
        fill: "url(#virtual-inactive-1)"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 13C18 12.4477 18.4477 12 19 12H29C29.5523 12 30 12.4477 30 13V19C30 19.5523 29.5523 20 29 20H19C18.4477 20 18 19.5523 18 19V13Z",
        fill: "url(#virtual-inactive-2)"
      }
    ),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "virtual-inactive",
        x1: "24",
        y1: "0",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#999999" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "virtual-inactive-1",
        x1: "24",
        y1: "1.44301e-07",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "virtual-inactive-2",
        x1: "24",
        y1: "1.44301e-07",
        x2: "24",
        y2: "48",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#F5F5F5" })
    ))
  ),
  "arrow-up-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_1581_1302)" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear_1581_1302)" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13.3156 16.7711C13.3156 17.4498 12.7309 18 12.0096 18C11.2883 18 10.7036 17.4498 10.7036 16.7711L10.7036 8.16867C10.7036 7.48996 11.2883 6.93975 12.0096 6.93975C12.7309 6.93975 13.3156 7.48996 13.3156 8.16867L13.3156 16.7711Z",
        fill: "url(#paint1_linear_1581_1302)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13.3156 16.7711C13.3156 17.4498 12.7309 18 12.0096 18C11.2883 18 10.7036 17.4498 10.7036 16.7711L10.7036 8.16867C10.7036 7.48996 11.2883 6.93975 12.0096 6.93975C12.7309 6.93975 13.3156 7.48996 13.3156 8.16867L13.3156 16.7711Z",
        fill: "url(#paint2_linear_1581_1302)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6175 10.5738C17.1275 10.0939 17.1275 9.31576 16.6175 8.83584L12.9262 5.36252L12.9235 5.35994C12.8597 5.29995 12.791 5.24746 12.7186 5.20247C12.3961 5.00208 11.9999 4.95044 11.6394 5.04754C11.4333 5.10306 11.2388 5.20719 11.0765 5.35994L11.0732 5.36305L7.38252 8.83584C6.87249 9.31576 6.87249 10.0939 7.38252 10.5738C7.89256 11.0537 8.71948 11.0537 9.22952 10.5738L12 7.96687L14.7705 10.5738C15.2805 11.0537 16.1074 11.0537 16.6175 10.5738Z",
        fill: "url(#paint3_linear_1581_1302)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6175 10.5738C17.1275 10.0939 17.1275 9.31576 16.6175 8.83584L12.9262 5.36252L12.9235 5.35994C12.8597 5.29995 12.791 5.24746 12.7186 5.20247C12.3961 5.00208 11.9999 4.95044 11.6394 5.04754C11.4333 5.10306 11.2388 5.20719 11.0765 5.35994L11.0732 5.36305L7.38252 8.83584C6.87249 9.31576 6.87249 10.0939 7.38252 10.5738C7.89256 11.0537 8.71948 11.0537 9.22952 10.5738L12 7.96687L14.7705 10.5738C15.2805 11.0537 16.1074 11.0537 16.6175 10.5738Z",
        fill: "url(#paint4_linear_1581_1302)"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1581_1302",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1581_1302",
        x1: "9.88456",
        y1: "4.46496",
        x2: "6.5206",
        y2: "0.889944",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear_1581_1302",
        x1: "16.6177",
        y1: "9.34487",
        x2: "11.4135",
        y2: "3.81414",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear_1581_1302",
        x1: "9.88456",
        y1: "4.46496",
        x2: "6.5206",
        y2: "0.889944",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear_1581_1302",
        x1: "16.6177",
        y1: "9.34487",
        x2: "11.4135",
        y2: "3.81414",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_1581_1302" }, /* @__PURE__ */ e.createElement("rect", { width: "24", height: "24", fill: "white" })))
  ),
  "arrow-up-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_1581_4380)" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear_1581_4380)" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13.3156 16.7711C13.3156 17.4498 12.7309 18 12.0096 18C11.2883 18 10.7036 17.4498 10.7036 16.7711L10.7036 8.16867C10.7036 7.48996 11.2883 6.93975 12.0096 6.93975C12.7309 6.93975 13.3156 7.48996 13.3156 8.16867L13.3156 16.7711Z",
        fill: "url(#paint1_linear_1581_4380)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13.3156 16.7711C13.3156 17.4498 12.7309 18 12.0096 18C11.2883 18 10.7036 17.4498 10.7036 16.7711L10.7036 8.16867C10.7036 7.48996 11.2883 6.93975 12.0096 6.93975C12.7309 6.93975 13.3156 7.48996 13.3156 8.16867L13.3156 16.7711Z",
        fill: "url(#paint2_linear_1581_4380)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6175 10.5738C17.1275 10.0939 17.1275 9.31576 16.6175 8.83584L12.9262 5.36252L12.9235 5.35994C12.8597 5.29995 12.791 5.24746 12.7186 5.20247C12.3961 5.00208 11.9999 4.95044 11.6394 5.04754C11.4333 5.10306 11.2388 5.20719 11.0765 5.35994L11.0732 5.36305L7.38252 8.83584C6.87249 9.31576 6.87249 10.0939 7.38252 10.5738C7.89256 11.0537 8.71948 11.0537 9.22952 10.5738L12 7.96687L14.7705 10.5738C15.2805 11.0537 16.1074 11.0537 16.6175 10.5738Z",
        fill: "url(#paint3_linear_1581_4380)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.6175 10.5738C17.1275 10.0939 17.1275 9.31576 16.6175 8.83584L12.9262 5.36252L12.9235 5.35994C12.8597 5.29995 12.791 5.24746 12.7186 5.20247C12.3961 5.00208 11.9999 4.95044 11.6394 5.04754C11.4333 5.10306 11.2388 5.20719 11.0765 5.35994L11.0732 5.36305L7.38252 8.83584C6.87249 9.31576 6.87249 10.0939 7.38252 10.5738C7.89256 11.0537 8.71948 11.0537 9.22952 10.5738L12 7.96687L14.7705 10.5738C15.2805 11.0537 16.1074 11.0537 16.6175 10.5738Z",
        fill: "url(#paint4_linear_1581_4380)"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1581_4380",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#9A9A9A" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1581_4380",
        x1: "9.88456",
        y1: "4.46496",
        x2: "6.5206",
        y2: "0.889944",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear_1581_4380",
        x1: "16.6177",
        y1: "9.34487",
        x2: "11.4135",
        y2: "3.81414",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear_1581_4380",
        x1: "9.88456",
        y1: "4.46496",
        x2: "6.5206",
        y2: "0.889944",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear_1581_4380",
        x1: "16.6177",
        y1: "9.34487",
        x2: "11.4135",
        y2: "3.81414",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_1581_4380" }, /* @__PURE__ */ e.createElement("rect", { width: "24", height: "24", fill: "white" })))
  ),
  "arrow-down-active": /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_1391_23955)" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear_1391_23955)" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.6844 6.22892C10.6844 5.5502 11.2691 5 11.9904 5C12.7117 5 13.2964 5.5502 13.2964 6.22892L13.2964 14.8313C13.2964 15.51 12.7117 16.0602 11.9904 16.0602C11.2691 16.0602 10.6844 15.51 10.6844 14.8313L10.6844 6.22892Z",
        fill: "url(#paint1_linear_1391_23955)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.6844 6.22892C10.6844 5.5502 11.2691 5 11.9904 5C12.7117 5 13.2964 5.5502 13.2964 6.22892L13.2964 14.8313C13.2964 15.51 12.7117 16.0602 11.9904 16.0602C11.2691 16.0602 10.6844 15.51 10.6844 14.8313L10.6844 6.22892Z",
        fill: "url(#paint2_linear_1391_23955)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.38252 12.4262C6.87249 12.9061 6.87249 13.6842 7.38252 14.1642L11.0738 17.6375L11.0765 17.6401C11.1403 17.7 11.209 17.7525 11.2814 17.7975C11.6039 17.9979 12.0001 18.0496 12.3606 17.9525C12.5667 17.8969 12.7612 17.7928 12.9235 17.6401L12.9268 17.6369L16.6175 14.1642C17.1275 13.6842 17.1275 12.9061 16.6175 12.4262C16.1074 11.9463 15.2805 11.9463 14.7705 12.4262L12 15.0331L9.22952 12.4262C8.71948 11.9463 7.89256 11.9463 7.38252 12.4262Z",
        fill: "url(#paint3_linear_1391_23955)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.38252 12.4262C6.87249 12.9061 6.87249 13.6842 7.38252 14.1642L11.0738 17.6375L11.0765 17.6401C11.1403 17.7 11.209 17.7525 11.2814 17.7975C11.6039 17.9979 12.0001 18.0496 12.3606 17.9525C12.5667 17.8969 12.7612 17.7928 12.9235 17.6401L12.9268 17.6369L16.6175 14.1642C17.1275 13.6842 17.1275 12.9061 16.6175 12.4262C16.1074 11.9463 15.2805 11.9463 14.7705 12.4262L12 15.0331L9.22952 12.4262C8.71948 11.9463 7.89256 11.9463 7.38252 12.4262Z",
        fill: "url(#paint4_linear_1391_23955)"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1391_23955",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#9AAEFD" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#6256E9" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1391_23955",
        x1: "14.1154",
        y1: "18.535",
        x2: "17.4794",
        y2: "22.1101",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear_1391_23955",
        x1: "7.38232",
        y1: "13.6551",
        x2: "12.5865",
        y2: "19.1859",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear_1391_23955",
        x1: "14.1154",
        y1: "18.535",
        x2: "17.4794",
        y2: "22.1101",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear_1391_23955",
        x1: "7.38232",
        y1: "13.6551",
        x2: "12.5865",
        y2: "19.1859",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_1391_23955" }, /* @__PURE__ */ e.createElement("rect", { width: "24", height: "24", fill: "white" })))
  ),
  "arrow-down-inactive": /* @__PURE__ */ e.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    },
    /* @__PURE__ */ e.createElement("g", { clipPath: "url(#clip0_1391_24006)" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear_1391_24006)" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.6844 6.22892C10.6844 5.5502 11.2691 5 11.9904 5C12.7117 5 13.2964 5.5502 13.2964 6.22892L13.2964 14.8313C13.2964 15.51 12.7117 16.0602 11.9904 16.0602C11.2691 16.0602 10.6844 15.51 10.6844 14.8313L10.6844 6.22892Z",
        fill: "url(#paint1_linear_1391_24006)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.6844 6.22892C10.6844 5.5502 11.2691 5 11.9904 5C12.7117 5 13.2964 5.5502 13.2964 6.22892L13.2964 14.8313C13.2964 15.51 12.7117 16.0602 11.9904 16.0602C11.2691 16.0602 10.6844 15.51 10.6844 14.8313L10.6844 6.22892Z",
        fill: "url(#paint2_linear_1391_24006)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.38252 12.4262C6.87249 12.9061 6.87249 13.6842 7.38252 14.1642L11.0738 17.6375L11.0765 17.6401C11.1403 17.7 11.209 17.7525 11.2814 17.7975C11.6039 17.9979 12.0001 18.0496 12.3606 17.9525C12.5667 17.8969 12.7612 17.7928 12.9235 17.6401L12.9268 17.6369L16.6175 14.1642C17.1275 13.6842 17.1275 12.9061 16.6175 12.4262C16.1074 11.9463 15.2805 11.9463 14.7705 12.4262L12 15.0331L9.22952 12.4262C8.71948 11.9463 7.89256 11.9463 7.38252 12.4262Z",
        fill: "url(#paint3_linear_1391_24006)"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.38252 12.4262C6.87249 12.9061 6.87249 13.6842 7.38252 14.1642L11.0738 17.6375L11.0765 17.6401C11.1403 17.7 11.209 17.7525 11.2814 17.7975C11.6039 17.9979 12.0001 18.0496 12.3606 17.9525C12.5667 17.8969 12.7612 17.7928 12.9235 17.6401L12.9268 17.6369L16.6175 14.1642C17.1275 13.6842 17.1275 12.9061 16.6175 12.4262C16.1074 11.9463 15.2805 11.9463 14.7705 12.4262L12 15.0331L9.22952 12.4262C8.71948 11.9463 7.89256 11.9463 7.38252 12.4262Z",
        fill: "url(#paint4_linear_1391_24006)"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint0_linear_1391_24006",
        x1: "12",
        y1: "0",
        x2: "12",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "#C0C0C0" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#9A9A9A" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint1_linear_1391_24006",
        x1: "14.1154",
        y1: "18.535",
        x2: "17.4794",
        y2: "22.1101",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint2_linear_1391_24006",
        x1: "7.38232",
        y1: "13.6551",
        x2: "12.5865",
        y2: "19.1859",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint3_linear_1391_24006",
        x1: "14.1154",
        y1: "18.535",
        x2: "17.4794",
        y2: "22.1101",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "#E8E8ED" })
    ), /* @__PURE__ */ e.createElement(
      "linearGradient",
      {
        id: "paint4_linear_1391_24006",
        x1: "7.38232",
        y1: "13.6551",
        x2: "12.5865",
        y2: "19.1859",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ e.createElement("stop", { stopColor: "white" }),
      /* @__PURE__ */ e.createElement("stop", { offset: "1", stopColor: "white", stopOpacity: "0" })
    ), /* @__PURE__ */ e.createElement("clipPath", { id: "clip0_1391_24006" }, /* @__PURE__ */ e.createElement("rect", { width: "24", height: "24", fill: "white" })))
  ),
  // data marketplace icons
  "bank-files": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", fill: "white" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.0002 19.7894L18.7896 19.7894L18.7896 7C15.3976 7 12.1446 8.34745 9.74611 10.7459C7.34764 13.1444 6.0002 16.3974 6.0002 19.7894Z",
        fill: "#6AABC9"
      }
    ),
    /* @__PURE__ */ e.createElement("circle", { cx: "24.6849", cy: "24.8851", r: "7.89343", fill: "#D98A65" }),
    /* @__PURE__ */ e.createElement("circle", { cx: "29.3808", cy: "18.9902", r: "3.79684", fill: "#F3D151" }),
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", stroke: "#F0F0F3" })
  ),
  "pin-interchange": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", fill: "white" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M31.1774 31.1774V8H8C8 14.147 10.4419 20.0423 14.7885 24.3889C19.1351 28.7355 25.0304 31.1774 31.1774 31.1774Z",
        fill: "#EFB4B4"
      }
    ),
    /* @__PURE__ */ e.createElement("circle", { cx: "17.1744", cy: "26.1073", r: "6.51866", fill: "#CB5A57" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.698 29.5705C23.3284 28.5671 23.693 27.3798 23.693 26.1073C23.693 22.5071 20.7745 19.5886 17.1744 19.5886C15.3065 19.5886 13.6221 20.3743 12.4336 21.6331C13.141 22.6057 13.9274 23.5277 14.7886 24.3888C17.063 26.6632 19.7613 28.4161 22.698 29.5705Z",
        fill: "#5D2C19"
      }
    ),
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", stroke: "#F0F0F3" })
  ),
  "quarterly-network-reports": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", fill: "white" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.0004 20.4553C17.7582 20.4553 15.6078 19.5645 14.0223 17.9791C12.4368 16.3936 11.5461 14.2432 11.5461 12.001H3C2.99851 14.4081 3.50937 16.7879 4.49862 18.9823C5.48788 21.1767 6.93287 23.1355 8.73756 24.7283C11.843 21.971 15.8533 20.4508 20.0061 20.4567L20.0004 20.4553Z",
        fill: "#B4D0B3"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.0005 20.4557C24.153 20.4493 28.1631 21.9695 31.2676 24.7273C33.0723 23.1345 34.5173 21.1758 35.5066 18.9813C36.4958 16.7869 37.0067 14.4071 37.0052 12H28.4548C28.455 13.1104 28.2364 14.2099 27.8116 15.2358C27.3869 16.2616 26.7642 17.1938 25.9791 17.979C25.194 18.7642 24.262 19.3871 23.2361 19.812C22.2103 20.237 21.1108 20.4557 20.0005 20.4557Z",
        fill: "#6AABC9"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.0005 20.4566C15.8476 20.4507 11.8374 21.9709 8.73193 24.7282C11.8374 27.4855 15.8476 29.0057 20.0005 28.9998V20.4566Z",
        fill: "#2E4A3F"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M20.0005 28.9998C24.153 29.0063 28.1631 27.486 31.2676 24.7282C28.1631 21.9704 24.153 20.4501 20.0005 20.4566V28.9998Z",
        fill: "#0E0C2E"
      }
    ),
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", stroke: "#F0F0F3" })
  ),
  "sig-interchange": /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", fill: "white" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.7806 11.8488C11.5821 12.9844 10.6313 14.333 9.98261 15.8174C9.3339 17.3019 9 18.893 9 20.5C9 22.107 9.3339 23.6981 9.98261 25.1826C10.6313 26.667 11.5821 28.0156 12.7806 29.1512L20 36V5L12.7806 11.8488Z",
        fill: "#6AABC9"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M26.5631 11.8488L20 5V36L26.5631 29.1512C27.6526 28.0156 28.517 26.667 29.1067 25.1826C29.6965 23.6981 30 22.107 30 20.5C30 18.893 29.6965 17.3019 29.1067 15.8174C28.517 14.333 27.6526 12.9844 26.5631 11.8488Z",
        fill: "#2E4A3F"
      }
    ),
    /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "0.5", width: "39", height: "39", rx: "5.5", stroke: "#F0F0F3" })
  )
}, Cr = {
  afghanistan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.333H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H14.8984V18.3335H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10107 5H2V18.3335H9.10107V5Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.34764C10.7192 9.34764 9.68115 10.3857 9.68115 11.6665C9.68115 12.9473 10.7192 13.9853 12 13.9853C13.2808 13.9853 14.3188 12.9473 14.3188 11.6665C14.3188 10.3857 13.2808 9.34764 12 9.34764ZM12 13.1157C11.1997 13.1157 10.5508 12.4668 10.5508 11.6665C10.5508 10.8657 11.1997 10.2173 12 10.2173C12.8003 10.2173 13.4492 10.8662 13.4492 11.6665C13.4492 12.4668 12.8003 13.1157 12 13.1157Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.7969C11.6797 10.7969 11.4204 11.0566 11.4204 11.3765V12.2461H12.5796V11.3765C12.5796 11.0566 12.3198 10.7969 12 10.7969Z",
      fill: "#FFDA44"
    }
  ))),
  albania: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.7681 9.94824H13.3535C13.5024 9.79199 13.5942 9.58105 13.5942 9.34766C13.5942 8.86768 13.2051 8.47803 12.7246 8.47803C12.4219 8.47803 12.1558 8.63281 12 8.86719C11.8442 8.63281 11.5776 8.47803 11.2754 8.47803C10.7949 8.47803 10.4058 8.86719 10.4058 9.34766C10.4058 9.58057 10.4976 9.79199 10.6465 9.94824H8.23193C8.23193 10.5884 8.78955 11.1074 9.43018 11.1074H9.3916C9.3916 11.748 9.91064 12.2671 10.5513 12.2671C10.5513 12.4746 10.606 12.6689 10.7012 12.8374L9.73926 13.7993L10.4771 14.5371L11.5234 13.4902C11.5645 13.5054 11.6069 13.5171 11.6504 13.5254L11.0181 14.9536L12 16.0151L12.9814 14.9536L12.3491 13.5254C12.3931 13.5171 12.4355 13.5054 12.4766 13.4902L13.5229 14.5371L14.2607 13.7993L13.2988 12.8374C13.394 12.6689 13.4487 12.4746 13.4487 12.2671C14.0889 12.2671 14.6084 11.748 14.6084 11.1074H14.5698C15.2104 11.1074 15.7681 10.5884 15.7681 9.94824Z",
      fill: "black"
    }
  ))),
  algeria: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.333H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H12V18.3335H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.4326 10.3877L12.8857 11.1411L12 10.854L12.5479 11.6074L12.001 12.3613L12.8867 12.0728L13.4346 12.8262L13.4341 11.895L14.3193 11.6064L13.4336 11.3193L13.4326 10.3877Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.5527 13.5508C11.5122 13.5508 10.6685 12.707 10.6685 11.6665C10.6685 10.626 11.5122 9.78223 12.5527 9.78223C12.877 9.78223 13.1826 9.86426 13.4487 10.0088C13.0308 9.59961 12.459 9.34766 11.8281 9.34766C10.5474 9.34766 9.50928 10.3857 9.50928 11.6665C9.50928 12.9473 10.5474 13.9854 11.8281 13.9854C12.459 13.9854 13.0308 13.7329 13.4487 13.3242C13.1826 13.4687 12.8774 13.5508 12.5527 13.5508Z",
      fill: "#D80027"
    }
  ))),
  andorra: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M8.6665 5H2V18.3335H8.6665V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.3335V18.3335H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.9854V11.6665H13.7393V12.5361C13.7393 12.687 13.4492 13.2407 12.7339 13.6958C12.4629 13.8677 12.1821 13.9233 12 13.9854Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12 9.92725H10.2607V11.6665H12V9.92725Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8697 9.34766C12.8697 9.02783 12.6099 8.76807 12.2901 8.76807C12.1841 8.76807 12.0855 8.79687 12 8.84619C11.9146 8.79687 11.8159 8.76807 11.71 8.76807C11.3902 8.76807 11.1304 9.02783 11.1304 9.34766H9.68118V12.2461C9.68118 13.3252 10.5381 13.9492 11.21 14.2725C11.1597 14.3584 11.1304 14.458 11.1304 14.5649C11.1304 14.8848 11.3902 15.1445 11.71 15.1445C11.8155 15.1445 11.9146 15.1157 12 15.0664C12.0855 15.1157 12.1841 15.1445 12.2901 15.1445C12.6099 15.1445 12.8697 14.8848 12.8697 14.5649C12.8697 14.458 12.8404 14.3584 12.7901 14.2725C13.4619 13.9487 14.3189 13.3247 14.3189 12.2461V9.34766H12.8697ZM13.4492 12.2461C13.4492 12.397 13.4492 12.8569 12.7339 13.3115C12.4629 13.4839 12.1826 13.5957 12 13.6577C11.8174 13.5957 11.5371 13.4839 11.2661 13.3115C10.5508 12.8564 10.5508 12.397 10.5508 12.2461V10.2173H13.4492V12.2461Z",
      fill: "#FF9811"
    }
  ))),
  angola: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.6665H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.0859 10.3022L11.6509 10.7124L11.4355 11.3765L12.0005 10.9658L12.5654 11.376L12.3491 10.7119L12.9141 10.3013L12.2158 10.3018L11.9995 9.6377L11.7842 10.3018L11.0859 10.3022Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.6665 8.7798C13.1411 8.47657 12.5669 8.33302 12 8.33448V9.20362C12.4189 9.20314 12.8432 9.3086 13.2319 9.53273C14.4087 10.2119 14.813 11.7217 14.1338 12.8984C13.4546 14.0752 11.9448 14.4795 10.768 13.8003C10.4253 13.6021 10.1489 13.3335 9.94479 13.0234L9.21872 13.5029C9.4946 13.9224 9.8696 14.2857 10.3335 14.5532C11.9253 15.4722 13.9677 14.9248 14.8867 13.333C15.8056 11.7417 15.2583 9.69874 13.6665 8.7798Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.0776 11.0869C9.84718 11.5083 10.002 12.0366 10.4233 12.2671L13.2476 13.8101C13.0557 14.1611 13.1577 14.5884 13.5088 14.7808L14.2715 15.1982C14.6226 15.3901 15.063 15.2612 15.2549 14.9102L15.6724 14.1475L10.0776 11.0869Z",
      fill: "#FFDA44"
    }
  ))),
  anguilla: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.7109 13.2227C18.9023 12.957 19.0312 12.6367 19.0312 12.2461V9.34766C18.7891 9.53125 18.4883 9.63672 18.1602 9.63672C17.6875 9.63672 17.2656 9.41016 17 9.05859C16.7344 9.41016 16.3164 9.63672 15.8398 9.63672C15.5117 9.63672 15.2109 9.52734 14.9688 9.34766V12.2461C14.9688 12.6367 15.0977 12.957 15.2891 13.2227H18.7109Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.1055 11.707C18.1992 11.4805 18.2695 11.1523 18.2695 10.9883C18.2695 10.7266 17.9258 10.5117 17.9258 10.5117C17.9258 10.5117 17.582 10.7266 17.582 10.9883C17.582 11.1523 17.6523 11.4805 17.7461 11.707L17.5469 12.1524C17.6641 12.1992 17.7891 12.2266 17.9258 12.2266C18.0586 12.2266 18.1875 12.1992 18.3047 12.1524L18.1055 11.707Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.7656 10.2617C16.5234 10.293 16.2031 10.3984 16.0625 10.4805C15.8359 10.6133 15.8203 11.0156 15.8203 11.0156C15.8203 11.0156 16.1758 11.207 16.4063 11.0742C16.5469 10.9922 16.7969 10.7656 16.9453 10.5742L17.4336 10.5234C17.418 10.3984 17.375 10.2773 17.3086 10.1602C17.2422 10.043 17.1563 9.94922 17.0547 9.87109L16.7656 10.2617Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.1836 12.1445C16.332 12.3359 16.582 12.5625 16.7227 12.6445C16.9492 12.7773 17.3086 12.5859 17.3086 12.5859C17.3086 12.5859 17.2969 12.1836 17.0664 12.0508C16.9258 11.9687 16.6055 11.8672 16.3633 11.832L16.0742 11.4375C15.9766 11.5156 15.8867 11.6133 15.8203 11.7266C15.7539 11.8437 15.7109 11.9648 15.6953 12.0898L16.1836 12.1445Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2188 13.1172C15.7617 13.9844 17 14.2773 17 14.2773C17 14.2773 18.2383 13.9883 18.7813 13.1172H15.2188Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 8.95703H7.625V11.6641H8.25V9.7539L11.1172 11.6641H12L8.875 9.58203H9.75781L12 11.0781V10.7852L10.1992 9.58594H12V8.95703Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.875 7.08203L12 5H11.1172L8.25 6.91016V5H7.625V7.70703H12V7.08203H10.1992L12 5.88281V5.58984L9.75781 7.08203H8.875Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.75 5V6.91016L2.88281 5H2L5.125 7.08203H4.24219L2 5.58984V5.88281L3.80078 7.08203H2V7.70703H6.375V5H5.75Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 8.95703V9.58203H3.80078L2 10.7852V11.0781L4.24219 9.58203H5.125L2 11.668H2.88281L5.75 9.7539V11.6641H6.375V8.95703H2Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M5.125 7.08203L2 5V5.58984L4.24219 7.08203H5.125Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.875 7.08203H9.75781L12 5.58984V5L8.875 7.08203Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.24219 9.58203L2 11.0781V11.668L5.125 9.58203H4.24219Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.875 9.58203L12 11.668V11.0781L9.75781 9.58203H8.875Z", fill: "#D80027" }))),
  "antigua & barbuda": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.46875 10.332C5.38281 10.7617 5.33594 11.207 5.33594 11.6641C5.33594 12.1211 5.38281 12.5664 5.46875 12.9961L12 13.4062L18.5313 13C18.6172 12.5703 18.6641 12.125 18.6641 11.668C18.6641 11.2109 18.6172 10.7656 18.5313 10.3359",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.5313 13H5.46875C6.08594 16.043 8.77734 18.332 12 18.332C15.2227 18.332 17.9141 16.043 18.5313 13Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.8984 10.332H9.10156L10.2852 9.77734L9.65625 8.62891L10.9414 8.875L11.1055 7.57422L12 8.53125L12.8945 7.57422L13.0586 8.875L14.3438 8.62891L13.7148 9.77734L14.8984 10.332Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12 18.332L2 5V18.332H12Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 18.332V5L12 18.332H22Z", fill: "#A2001D" }))),
  argentina: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.333H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44434H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8887H2V18.333H22V13.8887Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.5943 11.6665L12.9429 11.9727L13.2901 12.6035L12.583 12.4683L12.4932 13.1826L12.0005 12.6572L11.5078 13.1826L11.418 12.4683L10.711 12.6035L11.0576 11.9727L10.4063 11.6665L11.0576 11.3599L10.711 10.729L11.418 10.8643L11.5078 10.1499L12.0005 10.6753L12.4932 10.1499L12.583 10.8643L13.2901 10.729L12.9429 11.3599L13.5943 11.6665Z",
      fill: "#FFDA44"
    }
  ))),
  armenia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#FF9811" }))),
  aruba: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3326H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.8956 8.19038L2.5932 7.61583L3.8956 7.04129L4.47014 5.73889L5.04469 7.04129L6.34709 7.61583L5.04538 8.19038L4.47083 9.49278L3.8956 8.19038Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.47015 6.45639L4.8251 7.26089L5.6296 7.61584L4.8251 7.97079L4.47015 8.77529L4.1152 7.97079L3.3107 7.61584L4.1152 7.26089L4.47015 6.45639Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 13.4055H2V14.2756H22V13.4055Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.145H2V16.0144H22V15.145Z", fill: "#FFDA44" }))),
  australia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.7266 11.6665C10.7373 11.6548 10.7476 11.6431 10.7583 11.6309C10.7476 11.6431 10.7368 11.6548 10.7266 11.6665Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.39114 13.3042L9.81936 14.1992L10.7862 13.9761L10.3531 14.8687L11.1304 15.4849L10.1626 15.7031L10.1651 16.6953L9.39114 16.0747L8.61721 16.6953L8.62014 15.7031L7.65237 15.4849L8.42971 14.8687L7.9966 13.9761L8.9634 14.1992L9.39114 13.3042Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1201 14.416L17.3242 14.8433L17.7852 14.7368L17.5786 15.1626L17.9492 15.4565L17.4878 15.5605L17.4893 16.0337L17.1201 15.7378L16.751 16.0337L16.752 15.5605L16.2905 15.4565L16.6611 15.1626L16.4546 14.7368L16.9155 14.8433L17.1201 14.416Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2207 9.88721L15.4248 10.3145L15.8857 10.208L15.6792 10.6338L16.0498 10.9277L15.5884 11.0317L15.5899 11.5054L15.2207 11.209L14.8516 11.5054L14.8525 11.0317L14.3911 10.9277L14.7617 10.6338L14.5552 10.208L15.0161 10.3145L15.2207 9.88721Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1201 7.29932L17.3242 7.72656L17.7852 7.62012L17.5786 8.0459L17.9492 8.33984L17.4878 8.44385L17.4893 8.91699L17.1201 8.62109L16.751 8.91699L16.752 8.44385L16.2905 8.33984L16.6611 8.0459L16.4546 7.62012L16.9155 7.72656L17.1201 7.29932Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.7793 9.24023L18.9834 9.66748L19.4443 9.56104L19.2378 9.98682L19.6084 10.2808L19.147 10.3848L19.1484 10.8579L18.7793 10.562L18.4102 10.8579L18.4111 10.3848L17.9497 10.2808L18.3203 9.98682L18.1138 9.56104L18.5752 9.66748L18.7793 9.24023Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.5928 11.5049L17.7534 11.999H18.273L17.8526 12.3042L18.0132 12.7983L17.5928 12.4932L17.1724 12.7983L17.333 12.3042L16.9126 11.999H17.4322L17.5928 11.5049Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19336L10.2358 7.17383H12V9.49268H9.69141L12 10.7749V11.666H10.958L8.08691 10.0713V11.666H5.91309V9.76953L2.49756 11.6665H2V10.4731L3.76416 9.49268H2V7.17383H4.30859L2 5.89111V5H3.04199L5.91309 6.59473V5H8.08691V6.89697L11.502 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.7085H2V8.9585H6.375V11.6665H7.625V8.9585H12V7.7085H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08694 9.49268L12 11.6665V11.0518L9.19338 9.49268H8.08694Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08694 9.49268L12 11.6665V11.0518L9.19338 9.49268H8.08694Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08694 9.49268L12 11.6665V11.0518L9.19338 9.49268H8.08694Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80664 9.49268L2 11.0518V11.6665L5.91309 9.49268H4.80664Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91309 7.17383L2 5V5.61475L4.80664 7.17383H5.91309Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91309 7.17383L2 5V5.61475L4.80664 7.17383H5.91309Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91309 7.17383L2 5V5.61475L4.80664 7.17383H5.91309Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19338 7.17383L12 5.61475V5L8.08694 7.17383H9.19338Z", fill: "#D80027" }))),
  austria: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }))),
  azerbaijan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.125 13.293C11.2266 13.293 10.5 12.5664 10.5 11.668C10.5 10.7695 11.2266 10.043 12.125 10.043C12.4063 10.043 12.668 10.1133 12.8984 10.2383C12.5391 9.88672 12.043 9.66797 11.5 9.66797C10.3945 9.66797 9.5 10.5625 9.5 11.668C9.5 12.7734 10.3945 13.668 11.5 13.668C12.043 13.668 12.5391 13.4492 12.8984 13.0977C12.668 13.2227 12.4063 13.293 12.125 13.293Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.375 10.543L13.5898 11.1484L14.1719 10.8711L13.8945 11.4531L14.5 11.668L13.8945 11.8828L14.1719 12.4609L13.5898 12.1875L13.375 12.793L13.1602 12.1875L12.5781 12.4609L12.8555 11.8828L12.25 11.668L12.8555 11.4531L12.5781 10.8711L13.1602 11.1484L13.375 10.543Z",
      fill: "#F0F0F0"
    }
  ))),
  bahamas: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "black" }))),
  bahrain: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2.08594V18.2734H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.1836 7.69141L8.21875 8.67969L10.1836 9.66406L8.21875 10.6523L10.1836 11.6367L8.21875 12.625L10.1836 13.6133L8.21875 14.5977L10.1836 15.5859L8.21875 16.5742L10.1836 17.5586L8.75781 18.2773H2V5H8.75391L10.1836 5.71875L8.21875 6.70312L10.1836 7.69141Z",
      fill: "#F0F0F0"
    }
  ))),
  bangladesh: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5508 14.5664C12.1515 14.5664 13.4492 13.2687 13.4492 11.668C13.4492 10.0672 12.1515 8.76953 10.5508 8.76953C8.95002 8.76953 7.65234 10.0672 7.65234 11.668C7.65234 13.2687 8.95002 14.5664 10.5508 14.5664Z",
      fill: "#D80027"
    }
  ))),
  barbados: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M8.6665 5H2V18.3335H8.6665V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.3335V18.3335H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0288 9.05811L14.4175 9.25244L14.0288 9.05811L13.6401 8.86328C13.6167 8.91016 13.1089 9.94336 13.0259 11.5215H12.4346V9.05811L12 8.47852L11.5649 9.05811V11.522H10.9736C10.8906 9.94385 10.3828 8.91064 10.3594 8.86377L9.58155 9.25244C9.58692 9.26318 10.1152 10.3389 10.1152 11.9565V12.3911H11.5645V14.855H12.4341V12.3911H13.8833V11.9565C13.8833 11.1201 14.0278 10.4307 14.1494 9.99902C14.2817 9.52881 14.416 9.25439 14.4175 9.25146L14.0288 9.05811Z",
      fill: "black"
    }
  ))),
  belarus: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22.0234 5H2.02344V18.33H22.0234V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M2 13.9766H21.9766V5H2", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91016 13.9766V13.3984V5H2V18.3203H21.9766H5.91016V13.9766Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.67969 11.1758L3.95312 9.86328L4.67969 8.57031L5.40234 9.86328L4.67969 11.1758Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.23047 11.1758L2.50781 9.86328L3.23047 8.57031L3.95312 9.86328L3.23047 11.1758Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.67969 14.7461L3.95312 13.4336L4.67969 12.1406L5.40234 13.4336L4.67969 14.7461Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.23047 14.7461L2.50781 13.4336L3.23047 12.1406L3.95312 13.4336L3.23047 14.7461Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.67969 18.3203L3.95312 17.0039L4.67969 15.7148L5.40234 17.0039L4.67969 18.3203Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.23047 18.3203L2.50781 17.0039L3.23047 15.7148L3.95312 17.0039L3.23047 18.3203Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.67969 7.60547L3.95312 6.29297L4.67969 5L5.40234 6.29297L4.67969 7.60547Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.23047 7.60547L2.50781 6.29297L3.23047 5L3.95312 6.29297L3.23047 7.60547Z",
      fill: "#A2001D"
    }
  ))),
  belgium: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  belize: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.8555C13.7604 14.8555 15.1875 13.4284 15.1875 11.668C15.1875 9.90756 13.7604 8.48047 12 8.48047C10.2396 8.48047 8.8125 9.90756 8.8125 11.668C8.8125 13.4284 10.2396 14.8555 12 14.8555Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.2773C13.4411 14.2773 14.6094 13.1091 14.6094 11.668C14.6094 10.2268 13.4411 9.05859 12 9.05859C10.5589 9.05859 9.39062 10.2268 9.39062 11.668C9.39062 13.1091 10.5589 14.2773 12 14.2773Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.4063C12.96 13.4063 13.7383 12.628 13.7383 11.668C13.7383 10.7079 12.96 9.92969 12 9.92969C11.04 9.92969 10.2617 10.7079 10.2617 11.668C10.2617 12.628 11.04 13.4063 12 13.4063Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 11.2305L11.0586 11.668V12.3906L12 12.9727L12.9414 12.3906V11.668L12 11.2305Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.9414 10.7969H11.0586V11.668H12.9414V10.7969Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V6.16015H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 17.1758H2V18.3359H22V17.1758Z", fill: "#A2001D" }))),
  benin: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H9.67969V11.668H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H9.67969V18.3359H22V11.668Z", fill: "#D80027" }))),
  bermuda: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 10.7812V9.58203H3.80078L2 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 11.668V9.75781L2.88281 11.668H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 10.7812V9.58203H10.1992L12 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 11.668V9.75781L11.1172 11.668H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 9.05859V12.2461C14.9727 13.8008 19.0312 13.8008 19.0312 12.2461V9.05859H14.9727Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 12.2461C14.9727 13.8008 17 14.2734 17 14.2734C17 14.2734 19.0273 13.7969 19.0273 12.2461H14.9727Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 10.9727L16.0586 11.375V12.2461L17 12.8242L17.9414 12.2461V11.375L17 10.9727Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M17.9414 10.5078H16.0586V11.3789H17.9414V10.5078Z", fill: "#338AF3" }))),
  bhutan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.7695 8.76953V7.60938H13.5469L13.3789 7.77734C12.7734 8.38281 12.875 9.08594 12.9492 9.60156C13.0195 10.0781 13.0273 10.2617 12.8477 10.4375C12.6719 10.6133 12.4883 10.6055 12.0117 10.5391C11.4961 10.4648 10.793 10.3633 10.1875 10.9688C9.58203 11.5742 9.68359 12.2773 9.75781 12.793C9.82813 13.2695 9.83594 13.4531 9.65625 13.6289C9.48047 13.8047 9.29688 13.7969 8.82031 13.7305C8.63281 13.7031 8.44141 13.6758 8.23828 13.6719L8.22656 14.832C8.35547 14.832 8.5 14.8555 8.65625 14.8789C8.83984 14.9063 9.04688 14.9375 9.26953 14.9375C9.49609 14.9375 9.73438 14.9063 9.97266 14.8047V15.7305H11.7109V14.8594H10.8398V14.2813H11.418V13.4102H10.9531C10.9766 13.1289 10.9375 12.8594 10.9023 12.6289C10.832 12.1523 10.8242 11.9688 11.0039 11.793C11.1797 11.6172 11.3633 11.625 11.8398 11.6914C12.2148 11.7461 12.6914 11.8125 13.1563 11.6133V12.543H14.8945V11.6719H14.0312V11.0938H14.6094V10.2227H14.1484C14.1719 9.94141 14.1328 9.67188 14.0977 9.44141C14.0508 9.10937 14.0312 8.91797 14.0859 8.77344L15.7695 8.76953Z",
      fill: "#F0F0F0"
    }
  ))),
  bolivia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44531H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }))),
  "bosnia herzegovina": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.90234 5H19.2344V18.332", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.42969 5.59766L4.00781 5.17578L4.58984 5.59766L4.39453 5H3.62109L3.42969 5.59766Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.44922 5.71485L5.22656 5.03125L5.00781 5.71485H4.28906L4.87109 6.13672L4.64844 6.82032L5.23047 6.39844L5.80859 6.82032L5.58594 6.13672L6.16797 5.71485H5.44922Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.67188 6.9375L6.44922 6.25391L6.22657 6.9375H5.51172L6.08985 7.35938L5.8711 8.03906L6.44922 7.61719L7.03126 8.03906L6.8086 7.35547L7.39063 6.93359L6.67188 6.9375Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.89062 8.15625L7.67187 7.47266L7.44922 8.15625H6.73047L7.3125 8.57813L7.08984 9.26172L7.67187 8.83985L8.24999 9.26172L8.03124 8.57813L8.60937 8.15625H7.89062Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.11328 9.37889L8.89062 8.6953L8.66797 9.37889H7.95312L8.53125 9.80077L8.3125 10.4805L8.89062 10.0586L9.47266 10.4805L9.25 9.80077L9.83203 9.37889H9.11328Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.3359 10.5977L10.1133 9.91797L9.89062 10.5977H9.17188L9.75391 11.0195L9.53125 11.7031L10.1133 11.2813L10.6953 11.7031L10.4727 11.0195L11.0508 10.5977H10.3359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.5547 11.8203L11.332 11.1367L11.1133 11.8203H10.3945L10.9766 12.2422L10.7539 12.9258L11.332 12.5L11.9141 12.9219L11.6914 12.2422L12.2734 11.8203H11.5547Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7774 13.0391L12.5547 12.3594L12.332 13.0391L11.6172 13.043L12.1953 13.4648L11.9766 14.1445L12.5547 13.7227L13.1367 14.1445L12.9141 13.4609L13.4922 13.0391H12.7774Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9961 14.2617L13.7734 13.5781L13.5547 14.2617H12.8359L13.418 14.6836L13.1953 15.3672L13.7773 14.9453L14.3555 15.3672L14.1328 14.6836L14.7148 14.2617H13.9961Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2187 15.4844L14.9961 14.8008L14.7734 15.4844H14.0586L14.6367 15.9063L14.418 16.5859L14.9961 16.1641L15.5781 16.5859L15.3555 15.9024L15.9375 15.4805L15.2187 15.4844Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.4375 16.7031L16.2188 16.0195L15.9961 16.7031H15.2773L15.8594 17.125L15.6367 17.8086L16.2188 17.3867L16.7969 17.8086L16.5781 17.125L17.1562 16.7031H16.4375Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.4375 17.2422L17.2148 17.9258H16.5L17.0625 18.332H17.8164L18.3789 17.9258H17.6602L17.4375 17.2422Z",
      fill: "#F0F0F0"
    }
  ))),
  botswana: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.2734H2V18.332H22V14.2734Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.08203H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.90234H2V13.4062H22V9.90234Z", fill: "black" }))),
  brazil: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7.98047L17 11.668L12 15.3516L7 11.668L12 7.98047Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.7734C13.1628 13.7734 14.1055 12.8308 14.1055 11.668C14.1055 10.5052 13.1628 9.5625 12 9.5625C10.8372 9.5625 9.89453 10.5052 9.89453 11.668C9.89453 12.8308 10.8372 13.7734 12 13.7734Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.9492 11.5352C10.582 11.5352 10.2305 11.5898 9.89844 11.6953C9.91406 12.8438 10.8477 13.7734 12.0039 13.7734C12.7188 13.7734 13.3477 13.418 13.7266 12.875C13.0742 12.0586 12.0703 11.5352 10.9492 11.5352Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0664 12.0703C14.0898 11.9414 14.1055 11.8047 14.1055 11.668C14.1055 10.5039 13.1641 9.5625 12 9.5625C11.1328 9.5625 10.3867 10.0859 10.0664 10.8359C10.3516 10.7773 10.6445 10.7461 10.9492 10.7461C12.1719 10.7461 13.2773 11.2539 14.0664 12.0703Z",
      fill: "#0052B4"
    }
  ))),
  "british indian ocean territory": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.0351 12.7344C19.8789 12.7344 19.5117 12.5273 19.2461 12.375C18.8164 12.1328 18.414 11.9023 18.0273 11.9023C17.6406 11.9023 17.2383 12.1328 16.8086 12.375C16.543 12.5273 16.1758 12.7344 16.0195 12.7344C15.8633 12.7344 15.4961 12.5273 15.2305 12.375C14.8008 12.1328 14.3984 11.9023 14.0117 11.9023C13.625 11.9023 13.2226 12.1328 12.793 12.375C12.5273 12.5273 12.1601 12.7344 12.0039 12.7344C11.8476 12.7344 11.4805 12.5273 11.2148 12.375C10.7851 12.1328 10.3828 11.9023 9.99609 11.9023C9.60937 11.9023 9.20703 12.1328 8.77734 12.375C8.51171 12.5273 8.14453 12.7344 7.98828 12.7344C7.83203 12.7344 7.46484 12.5273 7.19921 12.375C6.76953 12.1328 6.36718 11.9023 5.98047 11.9023C5.59375 11.9023 5.1914 12.1328 4.76172 12.375C4.49609 12.5273 4.1289 12.7344 3.97265 12.7344C3.8164 12.7344 3.44922 12.5273 3.18359 12.375C2.76953 12.1406 2.37891 11.918 2.00781 11.9023V12.7734C2.17969 12.8008 2.50781 12.9883 2.75391 13.1289C3.18359 13.3711 3.58594 13.6016 3.97265 13.6016C4.35937 13.6016 4.76172 13.3711 5.1914 13.1289C5.45703 12.9766 5.82422 12.7695 5.98047 12.7695C6.13672 12.7695 6.5039 12.9766 6.76953 13.1289C7.19921 13.3711 7.60156 13.6016 7.98828 13.6016C8.375 13.6016 8.77734 13.3711 9.20703 13.1289C9.47265 12.9766 9.83984 12.7695 9.99609 12.7695C10.1523 12.7695 10.5195 12.9766 10.7851 13.1289C11.2148 13.3711 11.6172 13.6016 12.0039 13.6016C12.3906 13.6016 12.793 13.3711 13.2226 13.1289C13.4883 12.9766 13.8555 12.7695 14.0117 12.7695C14.168 12.7695 14.5351 12.9766 14.8008 13.1289C15.2305 13.3711 15.6328 13.6016 16.0195 13.6016C16.4062 13.6016 16.8086 13.3711 17.2383 13.1289C17.5039 12.9766 17.8711 12.7695 18.0273 12.7695C18.1836 12.7695 18.5508 12.9766 18.8164 13.1289C19.2461 13.3711 19.6484 13.6016 20.0351 13.6016C20.4219 13.6016 20.8242 13.3711 21.2539 13.1289C21.5 12.9883 21.8281 12.8047 22 12.7734V11.9023C21.625 11.918 21.2344 12.1406 20.8242 12.375C20.5547 12.5273 20.1914 12.7344 20.0351 12.7344Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 6.25391C2.17188 6.28125 2.5 6.46875 2.74609 6.60938C3.17578 6.85156 3.57812 7.08203 3.96484 7.08203C4.35156 7.08203 4.75391 6.85156 5.18359 6.60938C5.44922 6.45703 5.81641 6.25 5.97266 6.25C6.12891 6.25 6.49609 6.45703 6.76172 6.60938C7.19141 6.85156 7.59375 7.08203 7.98047 7.08203C8.36719 7.08203 8.76953 6.85156 9.19922 6.60938C9.46484 6.45703 9.83203 6.25 9.98828 6.25C10.1445 6.25 10.5117 6.45703 10.7773 6.60938C11.207 6.85156 11.6094 7.08203 11.9961 7.08203C12.3828 7.08203 12.7852 6.85156 13.2148 6.60938C13.4805 6.45703 13.8477 6.25 14.0039 6.25C14.1602 6.25 14.5273 6.45703 14.793 6.60938C15.2227 6.85156 15.625 7.08203 16.0117 7.08203C16.3984 7.08203 16.8008 6.85156 17.2305 6.60938C17.4961 6.45703 17.8633 6.25 18.0195 6.25C18.1758 6.25 18.543 6.45703 18.8086 6.60938C19.2383 6.85156 19.6406 7.08203 20.0273 7.08203C20.4141 7.08203 20.8164 6.85156 21.2461 6.60938C21.4922 6.46875 21.8203 6.28516 21.9922 6.25391V5.38281C21.6172 5.39844 21.2266 5.62109 20.8164 5.85547C20.5508 6.00781 20.1836 6.21484 20.0273 6.21484C19.8711 6.21484 19.5039 6.00781 19.2383 5.85547C18.8086 5.61328 18.4062 5.38281 18.0195 5.38281C17.6328 5.38281 17.2344 5.60937 16.8047 5.85547C16.5391 6.00781 16.1719 6.21484 16.0156 6.21484C15.8594 6.21484 15.4922 6.00781 15.2266 5.85547C14.7969 5.61328 14.3945 5.38281 14.0078 5.38281C13.6211 5.38281 13.2188 5.61328 12.7891 5.85547C12.5234 6.00781 12.1562 6.21484 12 6.21484C11.8438 6.21484 11.4766 6.00781 11.2109 5.85547C10.7812 5.61328 10.3789 5.38281 9.99219 5.38281C9.60547 5.38281 9.20312 5.61328 8.77344 5.85547C8.50781 6.00781 8.14062 6.21484 7.98438 6.21484C7.82812 6.21484 7.46094 6.00781 7.19531 5.85547C6.76562 5.61328 6.36328 5.38281 5.97656 5.38281C5.58984 5.38281 5.1875 5.61328 4.75781 5.85547C4.49219 6.00781 4.125 6.21484 3.96875 6.21484C3.8125 6.21484 3.44531 6.00391 3.17578 5.85547C2.76562 5.62109 2.375 5.39844 2 5.38281V6.25391Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.0352 8.38672C19.8789 8.38672 19.5117 8.17969 19.2461 8.02735C18.8164 7.78516 18.4141 7.55469 18.0273 7.55469C17.6406 7.55469 17.2344 7.78516 16.8047 8.02735C16.5391 8.17969 16.1719 8.38672 16.0156 8.38672C15.8594 8.38672 15.4922 8.17969 15.2266 8.02735C14.7969 7.78516 14.3945 7.55469 14.0078 7.55469C13.6211 7.55469 13.2188 7.78516 12.7891 8.02735C12.5234 8.17969 12.1562 8.38672 12 8.38672C11.8438 8.38672 11.4766 8.17969 11.2109 8.02735C10.7812 7.78516 10.3789 7.55469 9.99219 7.55469C9.60547 7.55469 9.20312 7.78516 8.77344 8.02735C8.50781 8.17969 8.14062 8.38672 7.98438 8.38672C7.82812 8.38672 7.46094 8.17969 7.19531 8.02735C6.76562 7.78516 6.36328 7.55469 5.97656 7.55469C5.58984 7.55469 5.1875 7.78516 4.75781 8.02735C4.49219 8.17969 4.125 8.38672 3.96875 8.38672C3.8125 8.38672 3.44531 8.17969 3.17578 8.02735C2.76562 7.79297 2.375 7.57422 2 7.55469V8.42579C2.17188 8.45313 2.5 8.64063 2.74609 8.78126C3.17578 9.02344 3.57812 9.25391 3.96484 9.25391C4.35156 9.25391 4.75391 9.02344 5.18359 8.78126C5.44922 8.62891 5.81641 8.42188 5.97266 8.42188C6.12891 8.42188 6.49609 8.62891 6.76172 8.78126C7.19141 9.02344 7.59375 9.25391 7.98047 9.25391C8.36719 9.25391 8.76953 9.02344 9.19922 8.78126C9.46484 8.62891 9.83203 8.42188 9.98828 8.42188C10.1445 8.42188 10.5117 8.62891 10.7773 8.78126C11.207 9.02344 11.6094 9.25391 11.9961 9.25391C12.3828 9.25391 12.7852 9.02344 13.2148 8.78126C13.4805 8.62891 13.8477 8.42188 14.0039 8.42188C14.1602 8.42188 14.5273 8.62891 14.793 8.78126C15.2227 9.02344 15.625 9.25391 16.0117 9.25391C16.3984 9.25391 16.8008 9.02344 17.2305 8.78126C17.4961 8.62891 17.8633 8.42188 18.0195 8.42188C18.1758 8.42188 18.543 8.62891 18.8086 8.78126C19.2383 9.02344 19.6406 9.25391 20.0273 9.25391C20.4141 9.25391 20.8164 9.02344 21.2461 8.78126C21.4922 8.64063 21.8203 8.45704 21.9922 8.42579V7.55469C21.6172 7.57031 21.2266 7.79297 20.8164 8.02735C20.5547 8.17969 20.1914 8.38672 20.0352 8.38672Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 9.73047C21.625 9.74609 21.2344 9.96875 20.8242 10.2031C20.5586 10.3555 20.1914 10.5625 20.0352 10.5625C19.8789 10.5625 19.5117 10.3555 19.2461 10.2031C18.8164 9.96094 18.4141 9.73047 18.0273 9.73047C17.6406 9.73047 17.2383 9.96094 16.8086 10.2031C16.543 10.3555 16.1758 10.5625 16.0195 10.5625C15.8633 10.5625 15.4961 10.3555 15.2305 10.2031C14.8008 9.96094 14.3984 9.73047 14.0117 9.73047C13.625 9.73047 13.2227 9.96094 12.793 10.2031C12.5273 10.3555 12.1602 10.5625 12.0039 10.5625C11.8477 10.5625 11.4805 10.3555 11.2148 10.2031C10.7852 9.96094 10.3828 9.73047 9.99609 9.73047C9.60938 9.73047 9.20703 9.96094 8.77734 10.2031C8.51172 10.3555 8.14453 10.5625 7.98828 10.5625C7.83203 10.5625 7.46484 10.3555 7.19922 10.2031C6.76953 9.96094 6.36719 9.73047 5.98047 9.73047C5.59375 9.73047 5.19141 9.96094 4.76172 10.2031C4.49609 10.3555 4.12891 10.5625 3.97266 10.5625C3.81641 10.5625 3.44531 10.3516 3.17578 10.2031C2.76172 9.96875 2.37109 9.74609 2 9.73047V10.6016C2.17188 10.6289 2.5 10.8164 2.74609 10.957C3.17578 11.1992 3.57812 11.4297 3.96484 11.4297C4.35156 11.4297 4.75391 11.1992 5.18359 10.957C5.44922 10.8047 5.81641 10.5977 5.97266 10.5977C6.12891 10.5977 6.49609 10.8047 6.76172 10.957C7.19141 11.1992 7.59375 11.4297 7.98047 11.4297C8.36719 11.4297 8.76953 11.1992 9.19922 10.957C9.46484 10.8047 9.83203 10.5977 9.98828 10.5977C10.1445 10.5977 10.5117 10.8047 10.7773 10.957C11.207 11.1992 11.6094 11.4297 11.9961 11.4297C12.3828 11.4297 12.7852 11.1992 13.2148 10.957C13.4805 10.8047 13.8477 10.5977 14.0039 10.5977C14.1602 10.5977 14.5273 10.8047 14.793 10.957C15.2227 11.1992 15.625 11.4297 16.0117 11.4297C16.3984 11.4297 16.8008 11.1992 17.2305 10.957C17.4961 10.8047 17.8633 10.5977 18.0195 10.5977C18.1758 10.5977 18.543 10.8047 18.8086 10.957C19.2383 11.1992 19.6406 11.4297 20.0273 11.4297C20.4141 11.4297 20.8164 11.1992 21.2461 10.957C21.4922 10.8164 21.8203 10.6328 21.9922 10.6016L22 9.73047Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.0351 14.9101C19.8789 14.9101 19.5117 14.7031 19.2461 14.5508C18.8164 14.3086 18.414 14.0781 18.0273 14.0781C17.6406 14.0781 17.2383 14.3086 16.8086 14.5508C16.543 14.7031 16.1758 14.9101 16.0195 14.9101C15.8633 14.9101 15.4961 14.7031 15.2305 14.5508C14.8008 14.3086 14.3984 14.0781 14.0117 14.0781C13.625 14.0781 13.2226 14.3086 12.793 14.5508C12.5273 14.7031 12.1601 14.9101 12.0039 14.9101C11.8476 14.9101 11.4805 14.7031 11.2148 14.5508C10.7851 14.3086 10.3828 14.0781 9.99609 14.0781C9.60937 14.0781 9.20703 14.3086 8.77734 14.5508C8.51171 14.7031 8.14453 14.9101 7.98828 14.9101C7.83203 14.9101 7.46484 14.7031 7.19921 14.5508C6.76953 14.3086 6.36718 14.0781 5.98047 14.0781C5.59375 14.0781 5.1914 14.3086 4.76172 14.5508C4.49609 14.7031 4.1289 14.9101 3.97265 14.9101C3.8164 14.9101 3.44922 14.7031 3.18359 14.5508C2.76953 14.3164 2.37891 14.0937 2.00781 14.0781V14.9492C2.17969 14.9766 2.50781 15.1641 2.75391 15.3047C3.18359 15.5469 3.58594 15.7773 3.97265 15.7773C4.35937 15.7773 4.76172 15.5469 5.1914 15.3047C5.45703 15.1523 5.82422 14.9453 5.98047 14.9453C6.13672 14.9453 6.5039 15.1523 6.76953 15.3047C7.19921 15.5469 7.60156 15.7773 7.98828 15.7773C8.375 15.7773 8.77734 15.5469 9.20703 15.3047C9.47265 15.1523 9.83984 14.9453 9.99609 14.9453C10.1523 14.9453 10.5195 15.1523 10.7851 15.3047C11.2148 15.5469 11.6172 15.7773 12.0039 15.7773C12.3906 15.7773 12.793 15.5469 13.2226 15.3047C13.4883 15.1523 13.8555 14.9453 14.0117 14.9453C14.168 14.9453 14.5351 15.1523 14.8008 15.3047C15.2305 15.5469 15.6328 15.7773 16.0195 15.7773C16.4062 15.7773 16.8086 15.5469 17.2383 15.3047C17.5039 15.1523 17.8711 14.9453 18.0273 14.9453C18.1836 14.9453 18.5508 15.1523 18.8164 15.3047C19.2461 15.5469 19.6484 15.7773 20.0351 15.7773C20.4219 15.7773 20.8242 15.5469 21.2539 15.3047C21.5 15.1641 21.8281 14.9805 22 14.9492V14.0781C21.625 14.0937 21.2344 14.3164 20.8242 14.5508C20.5547 14.6992 20.1914 14.9101 20.0351 14.9101Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 16.2539C21.625 16.2695 21.2344 16.4922 20.8242 16.7266C20.5586 16.8789 20.1914 17.086 20.0352 17.086C19.8789 17.086 19.5117 16.8789 19.2461 16.7266C18.8164 16.4844 18.4141 16.2539 18.0273 16.2539C17.6406 16.2539 17.2383 16.4844 16.8086 16.7266C16.543 16.8789 16.1758 17.086 16.0195 17.086C15.8633 17.086 15.4961 16.8789 15.2305 16.7266C14.8008 16.4844 14.3984 16.2539 14.0117 16.2539C13.625 16.2539 13.2227 16.4844 12.793 16.7266C12.5273 16.8789 12.1602 17.086 12.0039 17.086C11.8477 17.086 11.4805 16.8789 11.2148 16.7266C10.7852 16.4844 10.3828 16.2539 9.99609 16.2539C9.60938 16.2539 9.20703 16.4844 8.77734 16.7266C8.51172 16.8789 8.14453 17.086 7.98828 17.086C7.83203 17.086 7.46484 16.8789 7.19922 16.7266C6.76953 16.4844 6.36719 16.2539 5.98047 16.2539C5.59375 16.2539 5.19141 16.4844 4.76172 16.7266C4.49609 16.8789 4.12891 17.086 3.97266 17.086C3.81641 17.086 3.44531 16.875 3.17578 16.7227C2.76172 16.4883 2.37109 16.2656 2 16.25V17.1211C2.17188 17.1485 2.5 17.336 2.74609 17.4766C3.17578 17.7188 3.57812 17.9492 3.96484 17.9492C4.35156 17.9492 4.75391 17.7188 5.18359 17.4766C5.44922 17.3242 5.81641 17.1172 5.97266 17.1172C6.12891 17.1172 6.49609 17.3242 6.76172 17.4766C7.19141 17.7188 7.59375 17.9492 7.98047 17.9492C8.36719 17.9492 8.76953 17.7188 9.19922 17.4766C9.46484 17.3242 9.83203 17.1172 9.98828 17.1172C10.1445 17.1172 10.5117 17.3242 10.7773 17.4766C11.207 17.7188 11.6094 17.9492 11.9961 17.9492C12.3828 17.9492 12.7852 17.7188 13.2148 17.4766C13.4805 17.3242 13.8477 17.1172 14.0039 17.1172C14.1602 17.1172 14.5273 17.3242 14.793 17.4766C15.2227 17.7188 15.625 17.9492 16.0117 17.9492C16.3984 17.9492 16.8008 17.7188 17.2305 17.4766C17.4961 17.3242 17.8633 17.1172 18.0195 17.1172C18.1758 17.1172 18.543 17.3242 18.8086 17.4766C19.2383 17.7188 19.6406 17.9492 20.0273 17.9492C20.4141 17.9492 20.8164 17.7188 21.2461 17.4766C21.4922 17.336 21.8203 17.1524 21.9922 17.1211L22 16.2539Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.9805 11.668H12C12 11.6602 12 11.6562 12 11.6484C11.9922 11.6562 11.9883 11.6602 11.9805 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M15.6953 8.26172H18.3047L17 9.5664L15.6953 8.26172Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M17.2891 9.27734H16.711V10.8711H17.2891V9.27734Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M17.2891 13.4766H16.711V15.0703H17.2891V13.4766Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.7383 12.6094C18.7383 12.1289 18.3477 11.7383 17.8672 11.7383C17.6445 11.7383 17.4414 11.8203 17.2891 11.9609V11.4492H17.5781V10.8711H17.2891V10.582H16.7109V10.8711H16.4219V11.4492H16.7109V11.9609C16.5586 11.8242 16.3555 11.7383 16.1328 11.7383C15.6523 11.7383 15.2617 12.1289 15.2617 12.6094C15.2617 12.8672 15.375 13.0977 15.5508 13.2578V13.7695H18.4492V13.2578C18.6289 13.0977 18.7383 12.8672 18.7383 12.6094Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.8711 12.3203C17.7812 12.3203 17.7148 12.3594 17.6797 12.3945L17.293 12.7422H16.7148L16.3281 12.3945C16.2891 12.3594 16.2266 12.3203 16.1367 12.3203C15.9766 12.3203 15.8477 12.4492 15.8477 12.6094C15.8477 12.7227 15.9102 12.793 15.9453 12.8242L16.1367 12.9961V13.1875H17.875V12.9961L18.0664 12.8242C18.1016 12.793 18.1641 12.7188 18.1641 12.6094C18.1602 12.4492 18.0312 12.3203 17.8711 12.3203Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 10.7812V9.58203H3.80078L2 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 11.668V9.75781L2.88281 11.668H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 10.7812V9.58203H10.1992L12 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 11.668V9.75781L11.1172 11.668H8.25Z", fill: "#2E52B2" }))),
  brunei: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M2 9.44141L22 17.5352V15.7148L12.6719 12.0273L2 7.62109V9.44141Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.7149V13.8906L2 5.79688V7.6211", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.8828 10.9414C13.8828 11.9805 13.0391 12.8242 12 12.8242C10.9609 12.8242 10.1172 11.9805 10.1172 10.9414C10.1172 10.6172 10.1992 10.3125 10.3438 10.0469C9.93359 10.4648 9.68359 11.0352 9.68359 11.668C9.68359 12.9492 10.7227 13.9883 12.0039 13.9883C13.2852 13.9883 14.3242 12.9492 14.3242 11.668C14.3242 11.0391 14.0703 10.4648 13.6641 10.0469C13.8008 10.3125 13.8828 10.6172 13.8828 10.9414Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.4375 8.76953H11.5664V13.1172H12.4375V8.76953Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.4492 9.6367H10.5508C10.5508 9.83592 10.7266 9.99999 10.9258 9.99999H10.9141C10.9141 10.1992 11.0781 10.3633 11.2773 10.3633C11.2773 10.5625 11.4414 10.7266 11.6406 10.7266H12.3633C12.5625 10.7266 12.7266 10.5625 12.7266 10.3633C12.9258 10.3633 13.0898 10.1992 13.0898 9.99999H13.0781C13.2734 9.99999 13.4492 9.83983 13.4492 9.6367Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.0312 13.4062H9.97266V14.2773H14.0312V13.4062Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M14.6094 13.6953H12.8711V14.5664H14.6094V13.6953Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M11.1289 13.6953H9.39062V14.5664H11.1289V13.6953Z", fill: "#D80027" }))),
  bulgaria: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "3", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M23 5H3V18.332H23V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M23 5H3V9.44532H23V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M23 13.8906H3V18.3359H23V13.8906Z", fill: "#D80027" }))),
  "burkina faso": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.34766L12.5039 10.8984H14.1328L12.8164 11.8555L13.3203 13.4062L12 12.4492L10.6797 13.4062L11.1836 11.8555L9.86719 10.8984H11.4961L12 9.34766Z",
      fill: "#FFDA44"
    }
  ))),
  burundi: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.4336 11.668L2 17.2891V6.04688L10.4336 11.668Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.04688V17.2891L13.5664 11.668L22 6.04688Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 6.04688L13.5664 11.668L22 17.2891V18.332H20.4336L12 12.7109L3.56641 18.332H2V17.2891L10.4336 11.668L2 6.04688V5H3.56641L12 10.6211L20.4336 5H22V6.04688Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 6.04688L13.5664 11.668L22 17.2891V18.332H20.4336L12 12.7109L3.56641 18.332H2V17.2891L10.4336 11.668L2 6.04688V5H3.56641L12 10.6211L20.4336 5H22V6.04688Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.5664C13.6008 14.5664 14.8984 13.2687 14.8984 11.668C14.8984 10.0672 13.6008 8.76953 12 8.76953C10.3992 8.76953 9.10156 10.0672 9.10156 11.668C9.10156 13.2687 10.3992 14.5664 12 14.5664Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.63672L12.25 10.0742H12.7539L12.5039 10.5078L12.7539 10.9414H12.25L12 11.375L11.75 10.9414H11.2461L11.4961 10.5078L11.2461 10.0742H11.75L12 9.63672Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.7227 11.668L10.9766 12.1016H11.4766L11.2266 12.5352L11.4766 12.9727H10.9766L10.7227 13.4062L10.4727 12.9727H9.97266L10.2227 12.5352L9.97266 12.1016H10.4727L10.7227 11.668Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.2773 11.668L13.5273 12.1016H14.0273L13.7773 12.5352L14.0273 12.9727H13.5273L13.2773 13.4062L13.0234 12.9727H12.5234L12.7734 12.5352L12.5234 12.1016H13.0234L13.2773 11.668Z",
      fill: "#D80027"
    }
  ))),
  cambodia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.8555 12.6797V11.9844H13.3906V11.0586L12.9258 10.5937L12.4648 11.0586V10.1289L12 9.66797L11.5352 10.1289V11.0586L11.0742 10.5937L10.6094 11.0586V11.9844H10.1445V12.6797H9.67969V13.375H14.3203V12.6797H13.8555Z",
      fill: "#F0F0F0"
    }
  ))),
  cameroon: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.8125L12.4609 11.2305H13.9492L12.7461 12.1055L13.207 13.5234L12 12.6445L10.793 13.5234L11.2539 12.1055L10.0508 11.2305H11.5391L12 9.8125Z",
      fill: "#FFDA44"
    }
  ))),
  canada: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.333H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.6665 5H2V18.3335H8.6665V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.3335V18.3335H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.25 12.5928L14.5 11.9678L13.875 11.6553V11.0303L12.625 11.6553L13.25 10.4053H12.625L12 9.46777L11.375 10.4053H10.75L11.375 11.6553L10.125 11.0303V11.6553L9.5 11.9678L10.75 12.5928L10.4375 13.2178H11.6875V14.1553H12.3125V13.2178H13.5625L13.25 12.5928Z",
      fill: "#D80027"
    }
  ))),
  "cape verde islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.2734H2V15.1445H22V14.2734Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.4062H2V14.2773H22V13.4062Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.1445H2V16.0156H22V15.1445Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.04687 11.8711L9.16406 12.2344H9.54297L9.23438 12.457L9.35547 12.8203L9.04687 12.5938L8.73828 12.8203L8.85547 12.457L8.55078 12.2344H8.92969L9.04687 11.8711Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.04687 16.6016L9.16406 16.9609H9.54297L9.23438 17.1875L9.35547 17.5469L9.04687 17.3242L8.73828 17.5469L8.85547 17.1875L8.55078 16.9609H8.92969L9.04687 16.6016Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.84375 15.0039L6.96094 15.3633H7.34375L7.03516 15.5859L7.15234 15.9492L6.84375 15.7266L6.53906 15.9492L6.65625 15.5859L6.34766 15.3633H6.72656L6.84375 15.0039Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.6875 12.3438L7.80469 12.707H8.18359L7.875 12.9297L7.99219 13.293L7.6875 13.0664L7.37891 13.293L7.49609 12.9297L7.1875 12.707H7.57031L7.6875 12.3438Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.34766 13.832H6.72656L6.84375 13.4727L6.96094 13.832H7.34375L7.03516 14.0547L7.15234 14.418L6.84375 14.1953L6.53906 14.418L6.65625 14.0547L6.34766 13.832Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.37891 17.0039L7.49609 16.6445L7.1875 16.4219H7.57031L7.6875 16.0586L7.80469 16.4219H8.18359L7.875 16.6445L7.99219 17.0039L7.6875 16.7812L7.37891 17.0039Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.2461 15.0039L11.1289 15.3633H10.75L11.0586 15.5859L10.9375 15.9492L11.2461 15.7266L11.5547 15.9492L11.4375 15.5859L11.7422 15.3633H11.3633L11.2461 15.0039Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.4063 12.3438L10.2891 12.707H9.91016L10.2148 12.9297L10.0977 13.293L10.4063 13.0664L10.7148 13.293L10.5977 12.9297L10.9023 12.707H10.5234L10.4063 12.3438Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.7422 13.832H11.3633L11.2461 13.4727L11.1289 13.832H10.75L11.0586 14.0547L10.9375 14.418L11.2461 14.1953L11.5547 14.418L11.4375 14.0547L11.7422 13.832Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.7148 17.0039L10.5977 16.6445L10.9023 16.4219H10.5234L10.4063 16.0586L10.2891 16.4219H9.91016L10.2148 16.6445L10.0977 17.0039L10.4063 16.7812L10.7148 17.0039Z",
      fill: "#FFDA44"
    }
  ))),
  "cayman islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 9.92968C17.6407 9.92968 18.1602 9.41026 18.1602 8.76953C18.1602 8.12879 17.6407 7.60938 17 7.60938C16.3593 7.60938 15.8398 8.12879 15.8398 8.76953C15.8398 9.41026 16.3593 9.92968 17 9.92968Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M19.0312 8.47656H14.9727V10.2148H19.0312V8.47656Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 12.8242V13.9844H15.582C15.9492 14.3438 16.4492 14.5625 17 14.5625C17.5508 14.5625 18.0547 14.3398 18.418 13.9844H18.4492H19.0273V12.8242H14.9727Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 9.92578V11.6641C14.9727 13.2187 17 13.6914 17 13.6914C17 13.6914 19.0273 13.2148 19.0273 11.6641V9.92578H14.9727Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 10.8555C16.4922 10.8555 16.4922 11.3203 15.9844 11.3203C15.4766 11.3203 15.4766 10.8555 14.9688 10.8555V11.668C15.4766 11.668 15.4766 12.1328 15.9844 12.1328C16.4922 12.1328 16.4922 11.668 17 11.668C17.5078 11.668 17.5078 12.1328 18.0156 12.1328C18.5234 12.1328 18.5234 11.668 19.0312 11.668V10.8555C18.5234 10.8555 18.5234 11.3203 18.0156 11.3203C17.5078 11.3203 17.5078 10.8555 17 10.8555Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 9.23047C16.4922 9.23047 16.4922 9.69531 15.9844 9.69531C15.4766 9.69531 15.4766 9.23047 14.9688 9.23047V10.043C15.4766 10.043 15.4766 10.5078 15.9844 10.5078C16.4922 10.5078 16.4922 10.043 17 10.043C17.5078 10.043 17.5078 10.5078 18.0156 10.5078C18.5234 10.5078 18.5234 10.043 19.0312 10.043V9.23047C18.5234 9.23047 18.5234 9.69531 18.0156 9.69531C17.5078 9.69531 17.5078 9.23047 17 9.23047Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V5.88281L10.1992 7.08203H12V9.58203H10.1992L12 10.7852V11.668H11.1172L8.25 9.75391V11.668H5.75V9.75391L2.88281 11.668H2V10.7852L3.80078 9.58203H2V7.08203H3.80078L2 5.88281V5H2.88281L5.75 6.91016V5H8.25V6.91016L11.1172 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }))),
  "central african republic": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.2617 11.668H2V15H10.2617V11.668Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H13.7383V15H22V11.668Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V8.33203H10.2617V5H13.7383V8.33203H22V5H2Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.33203H13.7383V11.6641H22V8.33203Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M10.2617 8.33203H2V11.6641H10.2617V8.33203Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M13.7383 18.332H10.2617V15H2V18.332H22V15H13.7383V18.332Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.67578 6.01562L6.85547 6.5664H7.4375L6.96484 6.91015L7.14453 7.46484L6.67578 7.12109L6.20313 7.46484L6.38281 6.91015L5.91406 6.5664H6.49609L6.67578 6.01562Z",
      fill: "#FFDA44"
    }
  ))),
  chile: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H12V11.668H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 5.95703L7.58984 7.77344H9.5L7.95312 8.89453L8.54688 10.7109L7 9.58984L5.45313 10.7109L6.04688 8.89453L4.5 7.77344H6.41016L7 5.95703Z",
      fill: "#F0F0F0"
    }
  ))),
  china: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.98828 9.0703L9.5625 10.832H11.4141L9.91406 11.9219L10.4883 13.6836L8.98828 12.5976L7.49219 13.6836L8.0625 11.9219L6.5625 10.832H8.41797L8.98828 9.0703Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.5977 14.9336L12.0352 14.5234L11.4727 14.9336L11.6875 14.2695L11.125 13.8633H11.8203L12.0352 13.2031L12.25 13.8633H12.9453L12.3828 14.2695L12.5977 14.9336Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0625 12.914H13.3711L13.1563 13.5742L12.9414 12.914H12.2461L12.8086 12.5039L12.5938 11.8437L13.1563 12.2539L13.7148 11.8437L13.5 12.5039L14.0625 12.914Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0625 10.418L13.5 10.8281L13.7148 11.4883L13.1563 11.0781L12.5938 11.4883L12.8086 10.8281L12.2461 10.418H12.9414L13.1563 9.7578L13.3711 10.418H14.0625Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.5977 8.40233L12.3828 9.06248L12.9453 9.46873H12.25L12.0352 10.1328L11.8203 9.46873H11.125L11.6875 9.06248L11.4727 8.40233L12.0352 8.80858L12.5977 8.40233Z",
      fill: "#FFDA44"
    }
  ))),
  colombia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.0703H2V18.3359H22V15.0703Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H2V15.0703H22V11.668Z", fill: "#0052B4" }))),
  comoros: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V8.33203H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.33205H2V11.6641H22V8.33205Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H2V15H22V11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.67969 11.668C4.67969 10.6953 5.36328 9.88673 6.27344 9.68752C6.13281 9.65627 5.98828 9.64064 5.83984 9.64064C4.71875 9.64064 3.8125 10.5508 3.8125 11.668C3.8125 12.7852 4.72266 13.6953 5.83984 13.6953C5.98828 13.6953 6.13281 13.6797 6.27344 13.6485C5.36328 13.4492 4.67969 12.6367 4.67969 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.25391 9.9258L6.35938 10.2578H6.71094L6.42578 10.4649L6.53516 10.7969L6.25391 10.5938L5.96875 10.7969L6.07813 10.4649L5.79688 10.2578H6.14453L6.25391 9.9258Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.25391 10.7969L6.35938 11.1289H6.71094L6.42578 11.336L6.53516 11.668L6.25391 11.461L5.96875 11.668L6.07813 11.336L5.79688 11.1289H6.14453L6.25391 10.7969Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.25391 11.668L6.35938 12H6.71094L6.42578 12.2031L6.53516 12.5352L6.25391 12.332L5.96875 12.5352L6.07813 12.2031L5.79688 12H6.14453L6.25391 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.25391 12.5352L6.35938 12.8672H6.71094L6.42578 13.0742L6.53516 13.4063L6.25391 13.1992L5.96875 13.4063L6.07813 13.0742L5.79688 12.8672H6.14453L6.25391 12.5352Z",
      fill: "#F0F0F0"
    }
  ))),
  congo: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 7.61328V5H18.082L2 15.7188V18.332H5.91797L22 7.61328Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V6.56641L4.35156 18.332H2V16.7656L19.6484 5H22Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.88672 7.02734L9.24609 8.13672H10.4102L9.46875 8.82031L9.82812 9.92577L8.88672 9.24218L7.94531 9.92577L8.30469 8.82031L7.36328 8.13672H8.52734L8.88672 7.02734Z",
      fill: "#FFDA44"
    }
  ))),
  "cook islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 7.78906L17.207 8.42187H17.875L17.332 8.81641L17.5391 9.44922L17 9.05859L16.4609 9.44922L16.668 8.81641L16.125 8.42187H16.793L17 7.78906Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.2578 8.92578L14.8516 9.22656L15.3242 8.75391L15.2187 9.41406L15.8164 9.71875L15.1562 9.82031L15.0508 10.4805L14.7461 9.88671L14.0898 9.99218L14.5625 9.51953L14.2578 8.92578Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.1212 11.668L13.7579 11.461V10.793L14.1485 11.332L14.7852 11.125L14.3907 11.668L14.7852 12.207L14.1485 12L13.7579 12.5391V11.8711L13.1212 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.2578 14.4102L14.5586 13.8125L14.0898 13.3438L14.7461 13.4453L15.0508 12.8516L15.1562 13.5117L15.8164 13.6172L15.2187 13.918L15.3242 14.5781L14.8516 14.1055L14.2578 14.4102Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 15.5469L16.793 14.9102H16.125L16.668 14.5195L16.4609 13.8828L17 14.2734L17.5391 13.8828L17.332 14.5195L17.875 14.9102H17.207L17 15.5469Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.7421 14.4102L19.1484 14.1055L18.6757 14.5781L18.7812 13.918L18.1835 13.6172L18.8437 13.5117L18.9492 12.8516L19.2538 13.4453L19.9101 13.3438L19.4374 13.8125L19.7421 14.4102Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.879 11.668L20.2422 11.8711V12.5391L19.8516 12L19.2149 12.207L19.6094 11.668L19.2149 11.125L19.8516 11.332L20.2422 10.793V11.461L20.879 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.7421 8.92578L19.4413 9.51953L19.9101 9.99218L19.2538 9.88671L18.9492 10.4805L18.8437 9.82031L18.1835 9.71875L18.7812 9.41406L18.6757 8.75391L19.1484 9.22656L19.7421 8.92578Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 8.95705V9.58205H3.80078L2 10.7813V11.0742L4.24219 9.57814H5.125L2 11.668H6.375V8.96095L2 8.95705ZM5.75 11.668H2.88281L5.75 9.75783V11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.875 7.08203L12 5H7.625V7.70703H12V7.08203H10.1992L12 5.88281V5.58984L9.75781 7.08594L8.875 7.08203ZM8.25 5H11.1172L8.25 6.91016V5Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 11.668H12L8.875 9.58595H9.75781L12 11.082V10.7813L10.1992 9.58205H12V8.95705H7.625V11.668ZM8.25 9.75783L11.1172 11.668H8.25V9.75783Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.375 5H2L5.125 7.08203H4.24219L2 5.58984V5.88281L3.80078 7.08203H2V7.70703H6.375V5ZM5.75 6.91016L2.88281 5H5.75V6.91016Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M5.125 7.08203L2 5V5.58984L4.24219 7.08203H5.125Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.875 7.08203H9.75781L12 5.58984V5L8.875 7.08203Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.24219 9.58203L2 11.0781V11.668L5.125 9.58203H4.24219Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.875 9.58203L12 11.668V11.0781L9.75781 9.58203H8.875Z", fill: "#D80027" }))),
  "costa rica": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.92578H2V13.4023H22V9.92578Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.4336H2V18.332H22V15.4336Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.89844H22V5Z", fill: "#0052B4" }))),
  croatia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7383 9.63671H12.5781L12.7734 8.1875L13.5469 7.60938L14.3203 8.1875V9.34765L13.7383 9.63671Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.2617 9.63671H11.4219L11.2266 8.1875L10.4531 7.60938L9.67969 8.1875V9.34765L10.2617 9.63671Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7735 9.63671H11.2266V8.1875L12 7.60938L12.7735 8.1875V9.63671Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.67969 9.34766V12.5352C9.67969 13.293 10.0469 13.9687 10.6133 14.3945L11.0195 14.293L11.5312 14.8086C11.6836 14.8398 11.8398 14.8555 12 14.8555C12.1602 14.8555 12.3164 14.8398 12.4648 14.8086L13.0508 14.3203L13.3867 14.3906C13.9531 13.9687 14.3203 13.293 14.3203 12.5352V9.34766H9.67969Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M10.6055 9.34766H9.67969V10.2734H10.6055V9.34766Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12.4609 9.34766H11.5352V10.2734H12.4609V9.34766Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M14.3164 9.34766H13.3906V10.2734H14.3164V9.34766Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5352 10.2734H10.6094V11.1992H11.5352V10.2734Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M13.3906 10.2734H12.4648V11.1992H13.3906V10.2734Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.6055 11.2031H9.67969V12.1289H10.6055V11.2031Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5352 12.1289H10.6094V13.0547H11.5352V12.1289Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12.4609 11.2031H11.5352V12.1289H12.4609V11.2031Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M14.3164 11.2031H13.3906V12.1289H14.3164V11.2031Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M13.3906 12.1289H12.4648V13.0547H13.3906V12.1289Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12.4609 13.0586H11.5352V13.9844H12.4609V13.0586Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.6094 13.0586H9.74219C9.82031 13.4023 9.97656 13.7187 10.1914 13.9844H10.6094V13.0586Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.3906 13.9844H13.8086C14.0234 13.7187 14.1797 13.4023 14.2578 13.0586H13.3906V13.9844Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.6094 13.9844V14.3906C10.8789 14.5937 11.1953 14.7383 11.5352 14.8086V13.9844H10.6094Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.4648 13.9844V14.8086C12.8086 14.7383 13.1211 14.5937 13.3906 14.3906V13.9844H12.4648Z",
      fill: "#D80027"
    }
  ))),
  cuba: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "white" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.66797H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 10.3359H2V13.0039H22V10.3359Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.668H2V18.3359H22V15.668Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.2617L2 17.9258V4.59375L12 11.2617Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.26172 9.52344L5.69141 10.8516H7.08984L5.96094 11.6719L6.39063 13L5.26172 12.1797L4.12891 13L4.5625 11.6719L3.43359 10.8516H4.82813L5.26172 9.52344Z",
      fill: "#F0F0F0"
    }
  ))),
  "cyprus - north": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1484 10.3008L11.6953 11.0547L12.5781 10.7695L12.0312 11.5234L12.5781 12.2773L11.6914 11.9883L11.1445 12.7422V11.8086L10.2617 11.5195L11.1445 11.2344L11.1484 10.3008Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.65235 13.4063C8.61328 13.4063 7.76953 12.5625 7.76953 11.5234C7.76953 10.4844 8.61328 9.64063 9.65235 9.64063C9.97657 9.64063 10.2813 9.72266 10.5469 9.86719C10.1289 9.45703 9.5586 9.20703 8.92579 9.20703C7.64453 9.20703 6.60547 10.2461 6.60547 11.5273C6.60547 12.8086 7.64453 13.8477 8.92579 13.8477C9.5586 13.8477 10.1289 13.5938 10.5469 13.1875C10.2852 13.3242 9.97657 13.4063 9.65235 13.4063Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 7.17578H2V8.04687H22V7.17578Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15H2V15.8711H22V15Z", fill: "#D80027" }))),
  "cyprus - south": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FCFCFC" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.75 10.8008C15.5469 10.8008 15.2969 10.8008 14.8828 10.8008C14.8828 12.3945 13.5898 13.6836 12 13.6836C10.4062 13.6836 9.11719 12.3906 9.11719 10.8008C8.83984 10.8008 8.53125 10.8008 8.25 10.8008C8.25 12.5156 9.40234 13.9648 10.9766 14.4102C10.8047 14.7383 10.832 15.1523 11.0781 15.457C11.4023 15.1992 11.7383 14.9297 12.0195 14.7031C12.3047 14.9297 12.6406 15.1992 12.9609 15.457C13.2109 15.1445 13.2344 14.7305 13.0547 14.3984C14.6133 13.9453 15.75 12.5078 15.75 10.8008Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.69141 10.5156C9.69141 10.5156 9.69141 11.957 11.1328 11.957L11.4219 12.2461H12C12 12.2461 12.2891 11.3789 12.8672 11.3789C12.8672 11.3789 12.8672 10.8008 13.4453 10.8008C14.0234 10.8008 14.3125 10.8008 14.3125 10.8008C14.3125 10.8008 14.0234 9.64844 15.4648 8.78125L14.8867 8.49219C14.8867 8.49219 12.8672 9.9336 11.4258 9.64453V10.2227H10.8477L10.5586 9.9336L9.69141 10.5156Z",
      fill: "#FFDA44"
    }
  ))),
  "czech republic": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668V18.332H2L10.4062 11.668H22Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.668H10.4062L2 5H22Z", fill: "#F0F0F0" }))),
  denmark: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.5 5H7V10.418H2V12.918H7V18.332H9.5V12.918H22V10.418H9.5V5Z", fill: "#F0F0F0" }))),
  djibouti: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.69531 9.92578L6.12891 11.2578H7.52344L6.39453 12.0781L6.82422 13.4063L5.69531 12.5859L4.56641 13.4063L4.99609 12.0781L3.86719 11.2578H5.26563L5.69531 9.92578Z",
      fill: "#D80027"
    }
  ))),
  dominica: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M2 10.3H22V11.3H2V10.3Z", fill: "#FCD116" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.3H22V12.3H2V11.3Z", fill: "white" }), /* @__PURE__ */ e.createElement("path", { d: "M2 12.3H22V13.3H2V12.3Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M10.5 21.5L10.5 1.5L11.5 1.5L11.5 21.5L10.5 21.5Z", fill: "#FCD116" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5 21.5L11.5 1.5L12.5 1.5L12.5 21.5L11.5 21.5Z", fill: "white" }), /* @__PURE__ */ e.createElement("path", { d: "M12.5 21.5L12.5 1.5L13.5 1.5L13.5 21.5L12.5 21.5Z", fill: "black" }), /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "3", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.1875L12.1263 9.57618H12.535L12.2043 9.81639L12.3306 10.2051L12 9.96486L11.6694 10.2051L11.7957 9.81639L11.465 9.57618H11.8737L12 9.1875Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.5 9.9375L13.6263 10.3262H14.035L13.7043 10.5664L13.8306 10.9551L13.5 10.7149L13.1694 10.9551L13.2957 10.5664L12.965 10.3262H13.3737L13.5 9.9375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.25 11.4375L14.3763 11.8262H14.785L14.4543 12.0664L14.5806 12.4551L14.25 12.2149L13.9194 12.4551L14.0457 12.0664L13.715 11.8262H14.1237L14.25 11.4375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.5 12.9375L13.6263 13.3262H14.035L13.7043 13.5664L13.8306 13.9551L13.5 13.7149L13.1694 13.9551L13.2957 13.5664L12.965 13.3262H13.3737L13.5 12.9375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5 12.9375L10.6263 13.3262H11.035L10.7043 13.5664L10.8306 13.9551L10.5 13.7149L10.1694 13.9551L10.2957 13.5664L9.96503 13.3262H10.3737L10.5 12.9375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.6875L12.1263 14.0762H12.535L12.2043 14.3164L12.3306 14.7051L12 14.4649L11.6694 14.7051L11.7957 14.3164L11.465 14.0762H11.8737L12 13.6875Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.75 11.4375L9.87629 11.8262H10.285L9.95434 12.0664L10.0806 12.4551L9.75 12.2149L9.41937 12.4551L9.54566 12.0664L9.21503 11.8262H9.62371L9.75 11.4375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5 9.9375L10.6263 10.3262H11.035L10.7043 10.5664L10.8306 10.9551L10.5 10.7149L10.1694 10.9551L10.2957 10.5664L9.96503 10.3262H10.3737L10.5 9.9375Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7359 12.9426C12.7461 12.8646 12.758 12.7782 12.7309 12.6748C12.7359 12.6172 12.7325 12.5528 12.7122 12.4816C12.758 12.3443 12.7139 12.0697 12.5868 11.7765C12.5139 11.607 12.4258 11.4596 12.3393 11.3511C12.4292 11.3985 12.5376 11.4155 12.6275 11.3019C12.5919 11.3019 12.5495 11.2799 12.5037 11.2494C12.5359 11.2375 12.5681 11.2138 12.5987 11.1765C12.5648 11.1765 12.5224 11.1545 12.4766 11.1257C12.5054 11.1121 12.5342 11.0901 12.5614 11.0562C12.519 11.0562 12.4631 11.0223 12.4054 10.9816C12.4309 10.968 12.4546 10.9477 12.4783 10.9189C12.4342 10.9189 12.3766 10.8833 12.3173 10.8409C12.3563 10.8511 12.402 10.8545 12.4614 10.8443C12.3325 10.7951 12.1614 10.5901 12.0597 10.5409C11.9342 10.4765 11.7749 10.4951 11.6885 10.5596C11.6478 10.5918 11.6241 10.6426 11.6173 10.6951C11.6054 10.6968 11.5919 10.7019 11.5766 10.7053C11.4885 10.7257 11.4376 10.8053 11.519 10.9951C11.5292 10.9613 11.541 10.9341 11.5563 10.9104C11.5766 10.9324 11.6224 10.9392 11.6681 10.9206C11.6851 10.9138 11.7003 10.9053 11.7139 10.8951C11.7224 10.9002 11.7292 10.9036 11.7376 10.907C11.7258 10.9206 11.719 10.9375 11.719 10.9562C11.719 10.9579 11.719 10.9579 11.719 10.9596C11.6987 10.9731 11.6851 10.9968 11.6834 11.0223C11.6664 11.0375 11.6546 11.0579 11.6546 11.0816C11.6546 11.085 11.6546 11.0867 11.6546 11.0901C11.5868 11.2104 11.5122 11.4257 11.5275 11.7613C11.5427 12.0511 11.6783 12.2663 11.8105 12.4087C11.8156 12.4307 11.8224 12.4494 11.8309 12.4663C11.8258 12.4935 11.8241 12.5257 11.8275 12.5579C11.8376 12.646 11.8766 12.7121 11.9156 12.7087C11.9156 12.7121 11.9156 12.7138 11.9156 12.7172C11.9207 12.7714 11.9393 12.8189 11.9614 12.8443C11.9275 12.8613 11.8953 12.8867 11.8715 12.9206C11.7325 12.9257 11.6275 12.929 11.6156 12.929C11.58 12.929 11.602 12.8833 11.5732 12.8375C11.5444 12.7918 11.4512 12.7663 11.3868 12.8036C11.3207 12.8409 11.3783 12.9104 11.2478 12.9155C11.2478 12.924 11.3105 13.0545 11.3529 13.085C11.3715 13.0985 11.6054 13.1036 11.8698 13.1019C11.9241 13.1782 12.0309 13.2155 12.0698 13.1884C12.1088 13.2019 12.1444 13.2019 12.1614 13.185C12.197 13.1968 12.2292 13.1985 12.2478 13.1867C12.2766 13.1968 12.3037 13.2002 12.3224 13.1935C12.3478 13.2477 12.3749 13.2765 12.4003 13.2748C12.402 13.2748 12.4037 13.2748 12.4071 13.2731C12.4325 13.3511 12.458 13.3951 12.4834 13.3918C12.5071 13.3901 12.5258 13.346 12.5393 13.2731C12.5427 13.2731 12.5461 13.2748 12.5495 13.2731C12.5902 13.2697 12.6207 13.1951 12.641 13.0782C12.658 13.0765 12.6681 13.0731 12.6715 13.0714C12.7088 13.0426 12.702 12.9663 12.6664 12.9274C12.6648 12.9257 12.6631 12.924 12.658 12.924C12.6614 12.8816 12.6631 12.8358 12.6631 12.7867C12.6902 12.8375 12.7122 12.8867 12.7359 12.9426ZM12.058 12.8002C12.0631 12.8138 12.0681 12.8257 12.0732 12.8358C12.0664 12.8307 12.058 12.8274 12.0495 12.8257C12.0529 12.8172 12.0563 12.8087 12.058 12.8002Z",
      fill: "black"
    }
  ))),
  "dominican republic": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M10.2617 13.4062H2V18.332H10.2617V13.4062Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.2617 5H2V9.92968H10.2617V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H13.7383V9.92968H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.4062H13.7383V18.332H22V13.4062Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7383 11.668C13.7383 12.6289 12.9609 13.4062 12 13.4062C11.0391 13.4062 10.2617 12.6289 10.2617 11.668C10.2617 10.707 12 9.92967 12 9.92967C12 9.92967 13.7383 10.707 13.7383 11.668Z",
      fill: "#496E2D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.2617 11.668C10.2617 10.707 11.0391 9.92967 12 9.92967C12.9609 9.92967 13.7383 10.707 13.7383 11.668",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.0234 10.7969V11.8828C11.0234 12.4219 11.4609 12.8594 12 12.8594C12.5391 12.8594 12.9766 12.4219 12.9766 11.8828V10.7969H11.0234Z",
      fill: "#D80027"
    }
  ))),
  ecuador: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H2V15H22V11.668Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15H2V18.332H22V15Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.9883C13.2815 13.9883 14.3203 12.9495 14.3203 11.668C14.3203 10.3865 13.2815 9.34767 12 9.34767C10.7185 9.34767 9.67969 10.3865 9.67969 11.668C9.67969 12.9495 10.7185 13.9883 12 13.9883Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.2031C11.1758 13.2031 10.5039 12.5313 10.5039 11.707V10.8086C10.5039 9.98438 11.1758 9.3125 12 9.3125C12.8242 9.3125 13.4961 9.98438 13.4961 10.8086V11.707C13.4961 12.5313 12.8242 13.2031 12 13.2031Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.3906 8.1211H12.5976C12.5976 7.78906 12.3281 7.52344 12 7.52344C11.6719 7.52344 11.4023 7.79297 11.4023 8.1211H9.60938C9.60938 8.45313 9.89844 8.71875 10.2266 8.71875H10.207C10.207 9.05079 10.4766 9.31641 10.8047 9.31641C10.8047 9.64844 11.0742 9.91407 11.4023 9.91407H12.5976C12.9297 9.91407 13.1953 9.64454 13.1953 9.31641C13.5273 9.31641 13.793 9.04688 13.793 8.71875H13.7734C14.1055 8.71875 14.3906 8.44922 14.3906 8.1211Z",
      fill: "black"
    }
  ))),
  egypt: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5 10.8984H12.625C12.625 10.5547 12.3438 10.2734 12 10.2734C11.6562 10.2734 11.375 10.5547 11.375 10.8984H9.5C9.5 11.2422 9.80078 11.5234 10.1445 11.5234H10.125C10.125 11.8672 10.4062 12.1484 10.75 12.1484C10.75 12.4922 11.0312 12.7734 11.375 12.7734H12.625C12.9688 12.7734 13.25 12.4922 13.25 12.1484C13.5938 12.1484 13.875 11.8672 13.875 11.5234H13.8555C14.1992 11.5234 14.5 11.2422 14.5 10.8984Z",
      fill: "#FF9811"
    }
  ))),
  "el salvador": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M10.9297 11.8984L12 10.043L13.0703 11.8984H10.9297Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.3906 12.5117L12 13.207L10.6094 12.5117V11.582H13.3906V12.5117Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.3125 10.1211L12.8203 10.6133C13.0312 10.8242 13.1602 11.1133 13.1602 11.4336C13.1602 12.0742 12.6406 12.5937 12 12.5937C11.3594 12.5937 10.8398 12.0742 10.8398 11.4336C10.8398 11.1133 10.9688 10.8242 11.1797 10.6133L10.6875 10.1211C10.3516 10.457 10.1445 10.9219 10.1445 11.4336C10.1445 12.457 10.9766 13.2891 12 13.2891C13.0234 13.2891 13.8555 12.457 13.8555 11.4336C13.8555 10.9219 13.6484 10.457 13.3125 10.1211Z",
      fill: "#FFDA44"
    }
  ))),
  "equatorial guinea": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9297 10.25V11.9844C12.9297 13.0469 14.3203 13.375 14.3203 13.375C14.3203 13.375 15.7109 13.0508 15.7109 11.9844V10.25H12.9297Z",
      fill: "#DEDDE0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.668 11.6719H13.9727V12.6797H14.668V11.6719Z", fill: "#786145" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.0117 11.2891C15.0117 10.9063 14.6992 10.5938 14.3164 10.5938C13.9336 10.5938 13.6211 10.9063 13.6211 11.2891C13.4297 11.2891 13.2734 11.4453 13.2734 11.6367C13.2734 11.8281 13.4297 11.9844 13.6211 11.9844C13.7344 11.9844 14.8945 11.9844 15.0117 11.9844C15.2031 11.9844 15.3594 11.8281 15.3594 11.6367C15.3594 11.4453 15.2031 11.2891 15.0117 11.2891Z",
      fill: "#6DA544"
    }
  ))),
  eritrea: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332L22 11.6641L2 5V18.332Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.50782 9.16797C6.34766 9.16797 5.40234 10.1133 5.40234 11.2734V12.0625C5.40234 13.2227 6.34766 14.168 7.50782 14.168C8.66797 14.168 9.61329 13.2227 9.61329 12.0625V11.2734C9.61329 10.1094 8.66797 9.16797 7.50782 9.16797ZM8.82422 12.0625C8.82422 12.6523 8.43751 13.1484 7.90235 13.3164V12.457L8.46094 11.8984L7.90235 11.3398V11.1406V10.8789H7.11328V11.668L6.55469 12.2266L7.11328 12.7852V13.3203C6.57813 13.1523 6.19141 12.6523 6.19141 12.0664V11.2773C6.19141 10.5508 6.78125 9.96094 7.50782 9.96094C8.23438 9.96094 8.82422 10.5508 8.82422 11.2773V12.0625Z",
      fill: "#FFDA44"
    }
  ))),
  estonia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#F0F0F0" }))),
  ethiopia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.8555C13.7604 14.8555 15.1875 13.4284 15.1875 11.668C15.1875 9.90756 13.7604 8.48047 12 8.48047C10.2396 8.48047 8.8125 9.90756 8.8125 11.668C8.8125 13.4284 10.2396 14.8555 12 14.8555Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.19922L12.5742 10.9688H14.4414L12.9297 12.0625L13.5117 13.8399L12 12.7422L10.4922 13.8399L11.0664 12.0625L9.55859 10.9688H11.4219L12 9.19922Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.293 12.1055L12.4687 11.5156L13.5976 9.96094L13.1289 9.62109L12 11.1719L10.8711 9.62109L10.4023 9.96094L11.5312 11.5156L9.70703 12.1055L9.88281 12.6601L11.7109 12.0664V13.9844H12.2891V12.0664L14.1172 12.6601L14.293 12.1055Z",
      fill: "#FFDA44"
    }
  ))),
  "european union.svg": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.9165L12.1997 8.53027H12.8452L12.3232 8.90967L12.5229 9.52344L12.001 9.14404L11.4785 9.52344L11.6782 8.90967L11.1553 8.53027H11.8008L12 7.9165Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.34863 9.01514L9.92383 9.30811L10.3804 8.85156L10.2793 9.48877L10.8545 9.78174L10.2163 9.88281L10.1152 10.5205L9.82227 9.94531L9.18457 10.0464L9.6416 9.58984L9.34863 9.01514Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.25 11.6665L8.86377 11.4668V10.8213L9.24316 11.3437L9.85693 11.144L9.47754 11.6665L9.85693 12.1885L9.24316 11.9888L8.86377 12.5112V11.8657L8.25 11.6665Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.34863 14.3184L9.6416 13.7432L9.18506 13.2866L9.82275 13.3877L10.1157 12.8125L10.2168 13.4502L10.8545 13.5513L10.2793 13.8442L10.3804 14.4819L9.92383 14.0259L9.34863 14.3184Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15.4165L11.8003 14.8027H11.1553L11.6772 14.4233L11.4775 13.8096L12 14.189L12.522 13.8096L12.3223 14.4233L12.8442 14.8027H12.1987L12 15.4165Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6514 14.3184L14.0762 14.0254L13.6196 14.4819L13.7207 13.8442L13.1455 13.5513L13.7827 13.4502L13.8838 12.8125L14.1768 13.3877L14.8145 13.2866L14.3579 13.7432L14.6514 14.3184Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.75 11.6665L15.1362 11.8662V12.5117L14.7568 11.9893L14.1431 12.189L14.5225 11.667L14.1431 11.1445L14.7568 11.3442L15.1362 10.8218V11.4673L15.75 11.6665Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6514 9.01514L14.3584 9.59033L14.8149 10.0469L14.1772 9.9458L13.8843 10.521L13.7832 9.88281L13.146 9.78174L13.7212 9.48877L13.6201 8.85156L14.0767 9.30811L14.6514 9.01514Z",
      fill: "#FFDA44"
    }
  ))),
  "falkland islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.1602 13.1172V13.4063H15.8398V13.1172H14.9727V14.2735H15.5508V14.5664H18.4492V14.2735H19.0273V13.1172H18.1602Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 8.76953V11.957C14.9727 13.5117 17 13.9844 17 13.9844C17 13.9844 19.0273 13.5078 19.0273 11.957V8.76953H14.9727Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 11.1445C16.4922 11.1445 16.4922 11.6094 15.9844 11.6094C15.4766 11.6094 15.4766 11.1445 14.9688 11.1445V11.957C15.4766 11.957 15.4766 12.4219 15.9844 12.4219C16.4922 12.4219 16.4922 11.957 17 11.957C17.5078 11.957 17.5078 12.4219 18.0156 12.4219C18.5234 12.4219 18.5234 11.957 19.0312 11.957V11.1445C18.5234 11.1445 18.5234 11.6094 18.0156 11.6094C17.5078 11.6094 17.5078 11.1445 17 11.1445Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 9.52344C16.4922 9.52344 16.4922 9.98828 15.9844 9.98828C15.4766 9.98828 15.4766 9.52344 14.9688 9.52344V10.3359C15.4766 10.3359 15.4766 10.8008 15.9844 10.8008C16.4922 10.8008 16.4922 10.3359 17 10.3359C17.5078 10.3359 17.5078 10.8008 18.0156 10.8008C18.5234 10.8008 18.5234 10.3359 19.0312 10.3359V9.52344C18.5234 9.52344 18.5234 9.98828 18.0156 9.98828C17.5078 9.98437 17.5078 9.52344 17 9.52344Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7734V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }))),
  "faroe islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 13.2266H9.89844V18.332H9.17578H7.50781H6.78125V13.2266H2V12.5V10.832V10.1094H6.78125V5H7.50781H9.17578H9.89844V10.1094H22V10.832V12.5V13.2266Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 10.832V12.5H9.17578V18.332H7.50781V12.5H2V10.832H7.50781V5H9.17578V10.832H22Z",
      fill: "#D80027"
    }
  ))),
  fiji: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V5.88281L10.1992 7.08203H12V9.58203H10.1992L12 10.7852V11.668H11.1172L8.25 9.75391V11.668H5.75V9.75391L2.88281 11.668H2V10.7852L3.80078 9.58203H2V7.08203H3.80078L2 5.88281V5H2.88281L5.75 6.91016V5H8.25V6.91016L11.1172 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 9.78125V12.1016C14.9727 13.6562 17 14.1289 17 14.1289C17 14.1289 19.0273 13.6523 19.0273 12.1016V9.78125L17 9.20312L14.9727 9.78125Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.0273 9.92578V9.05469H14.9727V9.92578H16.7109V11.6641H14.9727V12.2422H16.7109V14.1836C16.8867 14.2461 17 14.2734 17 14.2734C17 14.2734 17.1133 14.2461 17.2891 14.1836V12.2422H19.0273V11.6641H17.2891V9.92578H19.0273Z",
      fill: "#D80027"
    }
  ))),
  finland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 10.832V12.5H9.17578V18.332H7.50781V12.5H2V10.832H7.50781V5H9.17578V10.832H22Z",
      fill: "#2E52B2"
    }
  ))),
  france: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  "french guiana": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2L10 10.332L22 18.332V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9L12.6735 11.0729H14.8532L13.0898 12.3541L13.7634 14.4271L12 13.1459L10.2366 14.4271L10.9102 12.3541L9.14683 11.0729H11.3265L12 9Z",
      fill: "#D80027"
    }
  ))),
  "french polynesia": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.4844 11.668C13.4844 12.4883 12.8203 12.9648 12 12.9648C11.1797 12.9648 10.5156 12.4844 10.5156 11.668C10.5156 10.8516 11.1797 10.1836 12 10.1836C12.8203 10.1836 13.4844 10.8477 13.4844 11.668Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.4844 11.668C13.4844 12.4883 12.8203 13.1524 12 13.1524C11.1797 13.1524 10.5156 12.4883 10.5156 11.668",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M11.4453 11.2969H11.0742V12.039H11.4453V11.2969Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12.9258 11.2969H12.5547V12.039H12.9258V11.2969Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12.1836 10.7383H11.8125V12.0352H12.1836V10.7383Z", fill: "#D80027" }))),
  gabon: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }))),
  gambia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.2734H2V18.332H22V14.2734Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.08203H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.90234H2V13.4062H22V9.90234Z", fill: "#0052B4" }))),
  georgia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.25 5H10.75V10.418H2V12.918H10.75V18.332H13.25V12.918H22V10.418H13.25V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.8086 7.27344V6.40234H5.94141V7.27344H5.07031V8.14453H5.94141V9.01172H6.8086V8.14453H7.67969V7.27344H6.8086Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.0586 7.27344V6.40234H17.1914V7.27344H16.3203V8.14453H17.1914V9.01172H18.0586V8.14453H18.9297V7.27344H18.0586Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.8086 15.1914V14.3203H5.94141V15.1914H5.07031V16.0586H5.94141V16.9297H6.8086V16.0586H7.67969V15.1914H6.8086Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.0586 15.1914V14.3203H17.1914V15.1914H16.3203V16.0586H17.1914V16.9297H18.0586V16.0586H18.9297V15.1914H18.0586Z",
      fill: "#D80027"
    }
  ))),
  germany: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#FFDA44" }))),
  ghana: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9L12.6735 11.0729H14.8532L13.0898 12.3541L13.7634 14.4271L12 13.1459L10.2366 14.4271L10.9102 12.3541L9.14683 11.0729H11.3265L12 9Z",
      fill: "black"
    }
  ))),
  gibraltar: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6095 10.5078V9.63671H14.8986V9.05858H14.3204V9.34765H13.7384V9.05858H13.1603V9.63671H13.4493V10.5078H12.8712V8.47655H13.1603V7.89842H12.5782V8.18749H12.2892V7.89842H11.7111V8.18749H11.422V7.89842H10.84V8.47655H11.129V10.5078H10.5509V9.63671H10.84V9.05858H10.2618V9.34765H9.67981V9.05858H9.10168V9.63671H9.39075V10.5078H8.81262V12.8242H15.1876V10.5078H14.6095Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12.5352C11.5195 12.5352 11.1289 12.9258 11.1289 13.4063C11.1289 13.7852 11.3711 14.1055 11.707 14.2266V15.4375H10.8359V16.5977H12.2852V14.2305C12.6211 14.1094 12.8633 13.7891 12.8633 13.4102C12.8711 12.9258 12.4805 12.5352 12 12.5352ZM12 13.6953C11.8398 13.6953 11.7109 13.5664 11.7109 13.4063C11.7109 13.2461 11.8398 13.1172 12 13.1172C12.1602 13.1172 12.2891 13.2461 12.2891 13.4063C12.2891 13.5664 12.1602 13.6953 12 13.6953Z",
      fill: "#FFDA44"
    }
  ))),
  greece: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3315H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V6.66851H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.33148H2V9.99999H22V8.33148Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.6685H2V13.337H22V11.6685Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15H2V16.6685H22V15Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M9.39227 5H2V11.6685H9.39227V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M9.39227 7.59117H2V9.07183H9.39227V7.59117Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M6.43647 5H4.95581V11.6685H6.43647V5Z", fill: "#F0F0F0" }))),
  greenland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.97266 14.8555C11.7331 14.8555 13.1602 13.4284 13.1602 11.668C13.1602 9.90756 11.7331 8.48047 9.97266 8.48047C8.21225 8.48047 6.78516 9.90756 6.78516 11.668C6.78516 13.4284 8.21225 14.8555 9.97266 14.8555Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.78125 11.668C6.78125 9.90625 8.20703 8.48047 9.96875 8.48047C11.7305 8.48047 13.1563 9.90625 13.1563 11.668",
      fill: "#D80027"
    }
  ))),
  grenada: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L3.73828 16.5938V6.73828L12 11.668Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L20.2617 16.5938H3.73828L12 11.668Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M20.2617 6.73828L12 11.668L3.73828 6.73828H20.2617Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M20.2617 6.73828V16.5938L12 11.668L20.2617 6.73828Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5.40625L12.1289 5.80469H12.5469L12.2109 6.05078L12.3398 6.44922L12 6.20313L11.6602 6.44922L11.7891 6.05078L11.4531 5.80469H11.8711L12 5.40625Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.64453 5.40625L8.77344 5.80469H9.19141L8.85547 6.05078L8.98437 6.44922L8.64453 6.20313L8.30469 6.44922L8.43359 6.05078L8.09766 5.80469H8.51562L8.64453 5.40625Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.3555 5.40625L15.4844 5.80469H15.9062L15.5664 6.05078L15.6953 6.44922L15.3555 6.20313L15.0156 6.44922L15.1445 6.05078L14.8086 5.80469H15.2266L15.3555 5.40625Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 16.8828L12.1289 17.2813H12.5469L12.2109 17.5274L12.3398 17.9258L12 17.6797L11.6602 17.9258L11.7891 17.5274L11.4531 17.2813H11.8711L12 16.8828Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.64453 16.8828L8.77344 17.2813H9.19141L8.85547 17.5274L8.98437 17.9258L8.64453 17.6797L8.30469 17.9258L8.43359 17.5274L8.09766 17.2813H8.51562L8.64453 16.8828Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.3555 16.8828L15.4844 17.2813H15.9062L15.5664 17.5274L15.6953 17.9258L15.3555 17.6797L15.0156 17.9258L15.1445 17.5274L14.8086 17.2813H15.2266L15.3555 16.8828Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.1524C12.8198 13.1524 13.4844 12.4878 13.4844 11.668C13.4844 10.8482 12.8198 10.1836 12 10.1836C11.1802 10.1836 10.5156 10.8482 10.5156 11.668C10.5156 12.4878 11.1802 13.1524 12 13.1524Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.1836L12.332 11.207H13.4102L12.5391 11.8399L12.8711 12.8633L12 12.2305L11.1289 12.8633L11.4609 11.8399L10.5898 11.207H11.668L12 10.1836Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.20704 11.5547C6.37892 11.8242 6.29688 12.1836 6.02735 12.3555C5.75782 12.5273 5.39845 12.4453 5.22657 12.1758C4.91798 11.6875 5.09767 10.8867 5.09767 10.8867C5.09767 10.8867 5.89454 11.0664 6.20704 11.5547Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.87109 12.3984C6.03074 12.3984 6.16016 12.269 6.16016 12.1094C6.16016 11.9497 6.03074 11.8203 5.87109 11.8203C5.71145 11.8203 5.58203 11.9497 5.58203 12.1094C5.58203 12.269 5.71145 12.3984 5.87109 12.3984Z",
      fill: "#A2001D"
    }
  ))),
  guadeloupe: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  guam: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M21.5625 5.43359H2.43359V17.8984H21.5625V5.43359Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.6211 15.875C11.5313 15.7969 9.39062 13.9375 9.39062 11.668C9.39062 9.39844 11.5313 7.53516 11.6211 7.45703L12 7.13281L12.3789 7.45703C12.4688 7.53516 14.6094 9.39453 14.6094 11.6641C14.6094 13.9336 12.4688 15.7969 12.3789 15.875L12 16.1992L11.6211 15.875Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0273 11.668C14.0273 9.64062 12 7.89844 12 7.89844C12 7.89844 9.97266 9.63672 9.97266 11.668C9.97266 12.2891 10.1641 12.8828 10.4258 13.4062H13.5781C13.8398 12.8789 14.0273 12.2891 14.0273 11.668Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0273 11.668C14.0273 12.2891 13.8359 12.8828 13.5742 13.4063L12 13.6953L10.4258 13.4063C10.1641 12.8828 9.97266 12.2891 9.97266 11.668H14.0273Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15.4336C12 15.4336 12.9766 14.5937 13.5742 13.4062H10.4219C11.0234 14.5976 12 15.4336 12 15.4336Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M10.6953 10.5078H13.3047L12 11.8125L10.6953 10.5078Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M12.4375 11.375H11.5664V13.9844H12.4375V11.375Z", fill: "#A2001D" }))),
  guatemala: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.8789 12.8672L12.6641 11.6523L13.8203 10.4961L13.7656 9.88281L13.4375 9.55469L12 10.9883L10.5625 9.55469L10.2344 9.88281L10.1797 10.4961L11.3359 11.6523L10.1211 12.8672L10.7852 13.5312L12 12.3164L13.2148 13.5312L13.8789 12.8672Z",
      fill: "#ACABB1"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7695 9.88281L13.1055 10.5469C13.3867 10.8281 13.5625 11.2188 13.5625 11.6523C13.5625 12.5156 12.8633 13.2149 12 13.2149C11.1367 13.2149 10.4375 12.5156 10.4375 11.6523C10.4375 11.2227 10.6133 10.832 10.8945 10.5469L10.2305 9.88281C9.77734 10.3359 9.5 10.9609 9.5 11.6523C9.5 13.0313 10.6211 14.1524 12 14.1524C13.3789 14.1524 14.5 13.0313 14.5 11.6523C14.5 10.9609 14.2187 10.3359 13.7695 9.88281Z",
      fill: "#6DA544"
    }
  ))),
  guinea: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H14.8984V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#D80027" }))),
  "guinea-bissau": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.83984 9.28906L6.42969 11.1055H8.33984L6.79688 12.2266L7.38672 14.043L5.83984 12.9219L4.29688 14.043L4.88672 12.2266L3.33984 11.1055H5.25L5.83984 9.28906Z",
      fill: "black"
    }
  ))),
  guyana: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M2 5H22V18.33H2V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5L22 11.665L2 18.33V5Z", fill: "white" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.57983L20.24 11.665L2 17.7501V5.57983Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5L12 11.665L2 18.33V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.77757L10.834 11.665L2 17.5524V5.77757Z", fill: "#D80027" }))),
  haiti: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.3203 13.4063L12 13.1172L9.67969 13.4063V9.92578H14.3203V13.4063Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.1172C12.6407 13.1172 13.1601 12.5978 13.1601 11.957C13.1601 11.3163 12.6407 10.7969 12 10.7969C11.3593 10.7969 10.8398 11.3163 10.8398 11.957C10.8398 12.5978 11.3593 13.1172 12 13.1172Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12.5352C12.3193 12.5352 12.5781 12.2763 12.5781 11.957C12.5781 11.6377 12.3193 11.3789 12 11.3789C11.6807 11.3789 11.4219 11.6377 11.4219 11.957C11.4219 12.2763 11.6807 12.5352 12 12.5352Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M11.1289 10.5078H12.8711L12 11.375L11.1289 10.5078Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M12.2891 11.0859H11.7109V12.8242H12.2891V11.0859Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9258 12.6523H11.0742L9.67969 13.4062H14.3203L12.9258 12.6523Z",
      fill: "#6DA544"
    }
  ))),
  honduras: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.94922 9.8125L10.1211 10.3438H10.6797L10.2266 10.6719L10.4023 11.2031L9.94922 10.875L9.49609 11.2031L9.66797 10.6719L9.21875 10.3438H9.77734L9.94922 9.8125Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.94922 12.1289L10.1211 12.6602H10.6797L10.2266 12.9883L10.4023 13.5234L9.94922 13.1914L9.49609 13.5234L9.66797 12.9883L9.21875 12.6602H9.77734L9.94922 12.1289Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0508 9.8125L14.2227 10.3438H14.7813L14.332 10.6719L14.5039 11.2031L14.0508 10.875L13.5977 11.2031L13.7734 10.6719L13.3203 10.3438H13.8789L14.0508 9.8125Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0508 12.1289L14.2227 12.6602H14.7813L14.332 12.9883L14.5039 13.5234L14.0508 13.1914L13.5977 13.5234L13.7734 12.9883L13.3203 12.6602H13.8789L14.0508 12.1289Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.9727L12.1719 11.5039H12.7305L12.2812 11.832L12.4531 12.3633L12 12.0352L11.5469 12.3633L11.7187 11.832L11.2695 11.5039H11.8281L12 10.9727Z",
      fill: "#338AF3"
    }
  ))),
  "hong kong": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.6875 10.043C12.5352 10.6719 12.2657 10.5547 12.1329 11.1016C11.3555 10.9141 10.875 10.1328 11.0625 9.35548C11.25 8.57813 12.0313 8.09766 12.8086 8.28516C12.5469 9.38282 12.8243 9.48048 12.6875 10.043Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.6681 10.5117C11.2189 10.8516 11.0235 11.0703 11.504 11.3633C11.086 12.0469 10.1915 12.2578 9.51182 11.8398C8.82823 11.4219 8.61729 10.5273 9.03526 9.84766C10.0001 10.4375 10.1759 10.207 10.6681 10.5117Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.4883 12.5742C10.9805 12.1524 11.1289 12.4102 11.5586 12.043C12.0781 12.6524 12.0078 13.5664 11.3984 14.086C10.7891 14.6055 9.875 14.5352 9.35547 13.9258C10.2148 13.1914 10.0469 12.9531 10.4883 12.5742Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.3984 13.3828C12.1523 12.7851 12.4375 12.7226 12.2227 12.1992C12.9609 11.8945 13.8086 12.2461 14.1172 12.9844C14.4219 13.7226 14.0703 14.5703 13.332 14.8789C12.8984 13.8359 12.6172 13.9219 12.3984 13.3828Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7579 11.8203C13.1134 11.8711 13.1446 11.5781 12.5782 11.6211C12.5157 10.8242 13.1134 10.125 13.9102 10.0625C14.7071 10 15.4063 10.5977 15.4688 11.3945C14.3399 11.4844 14.336 11.7734 13.7579 11.8203Z",
      fill: "#F0F0F0"
    }
  ))),
  hungary: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }))),
  iceland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 13.2266H9.89844V18.332H9.17578H7.50781H6.78125V13.2266H2V12.5V10.832V10.1094H6.78125V5H7.50781H9.17578H9.89844V10.1094H22V10.832V12.5V13.2266Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 10.832V12.5H9.17578V18.332H7.50781V12.5H2V10.832H7.50781V5H9.17578V10.832H22Z",
      fill: "#D80027"
    }
  ))),
  india: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.3828C12.9471 13.3828 13.7148 12.6151 13.7148 11.668C13.7148 10.7209 12.9471 9.95314 12 9.95314C11.0529 9.95314 10.2852 10.7209 10.2852 11.668C10.2852 12.6151 11.0529 13.3828 12 13.3828Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12.7383C12.5911 12.7383 13.0703 12.2591 13.0703 11.668C13.0703 11.0769 12.5911 10.5977 12 10.5977C11.4089 10.5977 10.9297 11.0769 10.9297 11.668C10.9297 12.2591 11.4089 12.7383 12 12.7383Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.3438L12.332 11.0938L13.1445 11.0039L12.6602 11.668L13.1445 12.3281L12.332 12.2383L12 12.9883L11.668 12.2383L10.8555 12.3281L11.3398 11.668L10.8555 11.0039L11.668 11.0938L12 10.3438Z",
      fill: "#0052B4"
    }
  ))),
  indonesia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#A2001D" }))),
  iran: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7305 10.2734H13.0312C13.0352 10.3516 13.0391 10.4258 13.0391 10.5039C13.0391 11.0195 12.9102 11.5195 12.6836 11.875C12.6133 11.9844 12.4961 12.1406 12.3398 12.2461V10.2734H11.6445V12.2461C11.4883 12.1406 11.3711 11.9883 11.3008 11.875C11.0742 11.5195 10.9453 11.0195 10.9453 10.5039C10.9453 10.4258 10.9492 10.3477 10.9531 10.2734H10.2539C10.25 10.3516 10.2461 10.4258 10.2461 10.5039C10.2461 11.9336 11.0117 13.0547 11.9844 13.0547C12.957 13.0547 13.7227 11.9336 13.7227 10.5039C13.7383 10.4297 13.7383 10.3516 13.7305 10.2734Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M4.60938 8.86328H3.73828V9.81641H4.60938V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M2.87109 8.86328H2V9.81641H2.87109V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M6.34766 8.86328H5.47656V9.81641H6.34766V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08984 8.86328H7.21875V9.81641H8.08984V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82812 8.86328H8.95703V9.81641H9.82812V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5664 8.86328H10.6953V9.81641H11.5664V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M13.3047 8.86328H12.4336V9.81641H13.3047V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M15.0469 8.86328H14.1758V9.81641H15.0469V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M16.7852 8.86328H15.9141V9.81641H16.7852V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M18.5234 8.86328H17.6523V9.81641H18.5234V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M20.2617 8.86328H19.3906V9.81641H20.2617V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.86328H21.1289V9.81641H22V8.86328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M4.60938 13.4727H3.73828V14.4687H4.60938V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M2.87109 13.4727H2V14.4687H2.87109V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M6.34766 13.4727H5.47656V14.4687H6.34766V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08984 13.4727H7.21875V14.4687H8.08984V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82812 13.4727H8.95703V14.4687H9.82812V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5664 13.4727H10.6953V14.4687H11.5664V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M13.3047 13.4727H12.4336V14.4687H13.3047V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M15.0469 13.4727H14.1758V14.4687H15.0469V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M16.7852 13.4727H15.9141V14.4687H16.7852V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M18.5234 13.4727H17.6523V14.4687H18.5234V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M20.2617 13.4727H19.3906V14.4687H20.2617V13.4727Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.4727H21.1289V14.4687H22V13.4727Z", fill: "#F0F0F0" }))),
  iraq: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5625 11.2773C10.5586 11.2773 10.5547 11.2773 10.5547 11.2773H9.41797C9.47656 11.0547 9.67578 10.8906 9.91797 10.8906V10.1133C9.20312 10.1133 8.625 10.6953 8.625 11.4063V12.0391V12.0508H10.5547C10.5586 12.0508 10.5625 12.0508 10.5625 12.0508C10.6328 12.0508 10.6914 12.1094 10.6914 12.1797V12.4375H8.10547V13.2148H11.4688V12.1797C11.4688 11.6836 11.0625 11.2773 10.5625 11.2773Z",
      fill: "#496E2D"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.5 12.4414V10.1133H11.7266V13.2188H13.0195V12.4414H12.5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.0859 12.4414V10.1133H14.3125V12.4414H14.0547V11.668H13.2773V13.2188H15.6055V12.4414H15.0859Z",
      fill: "#496E2D"
    }
  ))),
  ireland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#FF9811" }))),
  israel: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5 10.2227H12.832L12 8.77734L11.168 10.2188H9.5L10.332 11.6641L9.5 13.1094H11.168L12 14.5547L12.832 13.1094H14.5L13.668 11.6641L14.5 10.2227ZM13.0234 11.668L12.5117 12.5547H11.4883L10.9766 11.668L11.4883 10.7813H12.5117L13.0234 11.668ZM12 9.89453L12.1914 10.2227H11.8086L12 9.89453ZM10.4648 10.7813H10.8477L10.6563 11.1094L10.4648 10.7813ZM10.4648 12.5547L10.6563 12.2266L10.8477 12.5547H10.4648ZM12 13.4414L11.8086 13.1133H12.1914L12 13.4414ZM13.5352 12.5547H13.1523L13.3437 12.2266L13.5352 12.5547ZM13.1563 10.7813H13.5391L13.3477 11.1094L13.1563 10.7813Z",
      fill: "#2E52B2"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 5.83203H2V7.5H22V5.83203Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.832H2V17.5H22V15.832Z", fill: "#2E52B2" }))),
  italy: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M15.332 5H8.66797H2V18.332H8.66797H15.332H22V5H15.332Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  jamaica: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M10.4336 11.668L2 17.2891V6.04689L10.4336 11.668Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.04689V17.2891L13.5664 11.668L22 6.04689Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 6.04688L13.5664 11.668L22 17.2891V18.332H20.4336L12 12.7109L3.56641 18.332H2V17.2891L10.4336 11.668L2 6.04688V5H3.56641L12 10.6211L20.4336 5H22V6.04688Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 6.04688L13.5664 11.668L22 17.2891V18.332H20.4336L12 12.7109L3.56641 18.332H2V17.2891L10.4336 11.668L2 6.04688V5H3.56641L12 10.6211L20.4336 5H22V6.04688Z",
      fill: "#FFDA44"
    }
  ))),
  japan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15.418C14.0711 15.418 15.75 13.739 15.75 11.668C15.75 9.5969 14.0711 7.91797 12 7.91797C9.92893 7.91797 8.25 9.5969 8.25 11.668C8.25 13.739 9.92893 15.418 12 15.418Z",
      fill: "#D80027"
    }
  ))),
  jordan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.04297 10.4492L5.35156 11.0898L6.04688 10.9297L5.73437 11.5742L6.29297 12.0156L5.59766 12.1719L5.60156 12.8867L5.04297 12.4375L4.48828 12.8867V12.1719L3.79297 12.0156L4.35156 11.5742L4.04297 10.9297L4.73437 11.0898L5.04297 10.4492Z",
      fill: "#F0F0F0"
    }
  ))),
  kazakhstan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.75 12.0469H8.25C8.25 12.5664 8.69922 12.9844 9.21875 12.9844H9.1875C9.1875 13.5039 9.60547 13.9219 10.125 13.9219C10.125 14.4414 10.543 14.8594 11.0625 14.8594H12.9375C13.457 14.8594 13.875 14.4414 13.875 13.9219C14.3945 13.9219 14.8125 13.5039 14.8125 12.9844H14.7813C15.3008 12.9844 15.75 12.5664 15.75 12.0469Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5977 10.8242C14.5977 12.2578 13.4336 13.4219 12 13.4219C10.5664 13.4219 9.40234 12.2578 9.40234 10.8242",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5742 10.5781L13.5234 11.0039L14.082 11.8828L12.9414 11.6953L12.7969 12.6875L12 11.957L11.2031 12.6875L11.0586 11.6953L9.91797 11.8828L10.4766 11.0039L9.42578 10.5781L10.4766 10.1523L9.91797 9.27735L11.0586 9.46485L11.2031 8.47266L12 9.20313L12.7969 8.47266L12.9414 9.46485L14.082 9.27735L13.5234 10.1523L14.5742 10.5781Z",
      fill: "#FFDA44"
    }
  ))),
  kenya: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V8.53907H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.7969H2V18.3359H22V14.7969Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.4258H2V13.9102H22V9.4258Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6289 7.12889L13.6289 6.66795L12 10.3515L10.3711 6.66795L9.37109 7.12889L11.3945 11.668L9.37109 16.207L10.3711 16.668L12 12.9805L13.6289 16.668L14.6289 16.207L12.6055 11.668L14.6289 7.12889Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.6797 7.56249C12.293 7.14061 12 6.89842 12 6.89842C12 6.89842 11.707 7.14061 11.3203 7.56249V15.7695C11.707 16.1914 12 16.4336 12 16.4336C12 16.4336 12.293 16.1914 12.6797 15.7695V7.56249Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.1641 9.13672V14.1953C10.5742 14.918 11.0742 15.5117 11.4492 15.9063V7.42578C11.0742 7.82031 10.5742 8.41406 10.1641 9.13672Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.8359 9.13672C13.4258 8.41406 12.9258 7.82031 12.5508 7.42578V15.9102C12.9258 15.5156 13.4258 14.9219 13.8359 14.1992V9.13672Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.8359 9.13672V14.1953C14.25 13.4609 14.5703 12.5938 14.5703 11.6641C14.5703 10.7344 14.25 9.87109 13.8359 9.13672Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.1641 9.13672V14.1953C9.75 13.4609 9.42969 12.5938 9.42969 11.6641C9.42969 10.7344 9.75 9.87109 10.1641 9.13672Z",
      fill: "black"
    }
  ))),
  kiribati: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.0293 5V11.7041C21.4824 11.7432 20.5938 12.5342 20.0615 12.5342C19.5195 12.5342 18.5967 11.7041 18.0547 11.7041C17.5127 11.7041 16.5898 12.5342 16.0479 12.5342C15.5059 12.5342 14.583 11.7041 14.041 11.7041C13.499 11.7041 12.5762 12.5342 12.0342 12.5342C11.4922 12.5342 10.5693 11.7041 10.0273 11.7041C9.48535 11.7041 8.5625 12.5342 8.02051 12.5342C7.47852 12.5342 6.55566 11.7041 6.01367 11.7041C5.47168 11.7041 4.54883 12.5342 4.00684 12.5342C3.47949 12.5342 2.59082 11.7432 2.03906 11.7041V5H22.0293Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.3486 11.6357L13.4014 12.0801L13.9043 12.998L12.874 12.8027L12.7422 13.8428L12.0244 13.0762L11.3066 13.8428L11.1748 12.8027L10.1445 12.998L10.6475 12.0801L9.7002 11.6357L10.6475 11.1914L10.1543 10.2734L11.1846 10.4688L11.3164 9.42871L12.0342 10.1953L12.752 9.42871L12.8838 10.4688L13.9141 10.2734L13.4111 11.1914L14.3486 11.6357Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7676 7.60742H12.4639C12.4639 7.36816 12.2686 7.17285 12.0293 7.17285C11.79 7.17285 11.5947 7.36816 11.5947 7.60742H10.291C10.291 7.84668 10.501 8.04199 10.7402 8.04199H10.7256C10.7256 8.28125 10.9209 8.47656 11.1602 8.47656C11.1602 8.71582 11.3555 8.91113 11.5947 8.91113H12.4639C12.7031 8.91113 12.8984 8.71582 12.8984 8.47656C13.1377 8.47656 13.333 8.28125 13.333 8.04199H13.3184C13.5576 8.04199 13.7676 7.84668 13.7676 7.60742Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.0293 11.7041V18.3301H2.0293V11.7041C2.57617 11.7432 3.46484 12.5342 3.99707 12.5342C4.53906 12.5342 5.46191 11.7041 6.00391 11.7041C6.5459 11.7041 7.46875 12.5342 8.01074 12.5342C8.55273 12.5342 9.47559 11.7041 10.0176 11.7041C10.5596 11.7041 11.4824 12.5342 12.0244 12.5342C12.5664 12.5342 13.4893 11.7041 14.0312 11.7041C14.5732 11.7041 15.4961 12.5342 16.0381 12.5342C16.5801 12.5342 17.5029 11.7041 18.0449 11.7041C18.5869 11.7041 19.5098 12.5342 20.0518 12.5342C20.5938 12.5342 21.4824 11.748 22.0293 11.7041Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.0293 12.1436C2.20508 12.1729 2.53223 12.3584 2.77637 12.5C3.20605 12.7441 3.60645 12.9736 3.99707 12.9736C4.3877 12.9736 4.78809 12.7441 5.21777 12.5C5.48633 12.3486 5.85254 12.1387 6.00879 12.1387C6.16504 12.1387 6.53125 12.3486 6.7998 12.5C7.22949 12.7441 7.62988 12.9736 8.02051 12.9736C8.41113 12.9736 8.81152 12.7441 9.24121 12.5C9.50977 12.3486 9.87598 12.1387 10.0322 12.1387C10.1885 12.1387 10.5547 12.3486 10.8232 12.5C11.2529 12.7441 11.6533 12.9736 12.0439 12.9736C12.4297 12.9736 12.835 12.7441 13.2646 12.5C13.5332 12.3486 13.8994 12.1387 14.0557 12.1387C14.2119 12.1387 14.5781 12.3486 14.8467 12.5C15.2764 12.7441 15.6768 12.9736 16.0674 12.9736C16.4531 12.9736 16.8584 12.7441 17.2881 12.5C17.5566 12.3486 17.9229 12.1387 18.0791 12.1387C18.2354 12.1387 18.6016 12.3486 18.8701 12.5C19.2998 12.7441 19.7002 12.9736 20.0908 12.9736C20.4766 12.9736 20.8818 12.7441 21.3115 12.5C21.5557 12.3584 21.8877 12.1729 22.0586 12.1436V11.2695C21.6826 11.2842 21.292 11.5088 20.8818 11.7383C20.6133 11.8896 20.2471 12.0996 20.0908 12.0996C19.9346 12.0996 19.5684 11.8896 19.2998 11.7383C18.8701 11.4941 18.4697 11.2646 18.0791 11.2646C17.6934 11.2646 17.2881 11.4941 16.8584 11.7383C16.5898 11.8896 16.2236 12.0996 16.0674 12.0996C15.9111 12.0996 15.5449 11.8896 15.2764 11.7383C14.8467 11.4941 14.4463 11.2646 14.0557 11.2646C13.6699 11.2646 13.2646 11.4941 12.835 11.7383C12.5664 11.8896 12.2002 12.0996 12.0439 12.0996C11.8877 12.0996 11.5215 11.8896 11.2529 11.7383C10.8232 11.4941 10.4229 11.2646 10.0322 11.2646C9.64648 11.2646 9.24121 11.4941 8.81152 11.7383C8.54297 11.8896 8.17676 12.0996 8.02051 12.0996C7.86426 12.0996 7.49805 11.8896 7.22949 11.7383C6.7998 11.4941 6.39941 11.2646 6.00879 11.2646C5.62305 11.2646 5.21777 11.4941 4.78809 11.7383C4.51953 11.8896 4.15332 12.0996 3.99707 12.0996C3.84082 12.0996 3.47461 11.8896 3.20605 11.7383C2.7959 11.5039 2.40527 11.2842 2.0293 11.2695V12.1436H2.0293Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.0615 14.2773C19.9053 14.2773 19.5391 14.0674 19.2705 13.916C18.8408 13.6719 18.4404 13.4424 18.0498 13.4424C17.6641 13.4424 17.2588 13.6719 16.8291 13.916C16.5605 14.0674 16.1943 14.2773 16.0381 14.2773C15.8818 14.2773 15.5156 14.0674 15.2471 13.916C14.8174 13.6719 14.417 13.4424 14.0264 13.4424C13.6406 13.4424 13.2354 13.6719 12.8057 13.916C12.5371 14.0674 12.1709 14.2773 12.0146 14.2773C11.8584 14.2773 11.4922 14.0674 11.2236 13.916C10.7939 13.6719 10.3936 13.4424 10.0029 13.4424C9.61231 13.4424 9.21191 13.6719 8.78223 13.916C8.51367 14.0674 8.14746 14.2773 7.99121 14.2773C7.83496 14.2773 7.46875 14.0674 7.2002 13.916C6.77051 13.6719 6.37012 13.4424 5.97949 13.4424C5.59375 13.4424 5.18848 13.6719 4.75879 13.916C4.49023 14.0674 4.12402 14.2773 3.96777 14.2773C3.81152 14.2773 3.44531 14.0674 3.17676 13.916C2.76172 13.6816 2.37598 13.4619 2 13.4473V14.3213C2.17578 14.3506 2.50293 14.5361 2.74707 14.6777C3.17676 14.9219 3.57715 15.1514 3.96777 15.1514C4.3584 15.1514 4.75879 14.9219 5.18848 14.6777C5.45703 14.5264 5.82324 14.3164 5.97949 14.3164C6.13574 14.3164 6.50195 14.5264 6.77051 14.6777C7.2002 14.9219 7.60059 15.1514 7.99121 15.1514C8.38184 15.1514 8.78223 14.9219 9.21191 14.6777C9.48047 14.5264 9.84668 14.3164 10.0029 14.3164C10.1592 14.3164 10.5254 14.5264 10.7939 14.6777C11.2236 14.9219 11.624 15.1514 12.0146 15.1514C12.4004 15.1514 12.8057 14.9219 13.2354 14.6777C13.5039 14.5264 13.8701 14.3164 14.0264 14.3164C14.1826 14.3164 14.5488 14.5264 14.8174 14.6777C15.2471 14.9219 15.6475 15.1514 16.0381 15.1514C16.4238 15.1514 16.8291 14.9219 17.2588 14.6777C17.5273 14.5264 17.8936 14.3164 18.0498 14.3164C18.2061 14.3164 18.5723 14.5264 18.8408 14.6777C19.2705 14.9219 19.6709 15.1514 20.0615 15.1514C20.4473 15.1514 20.8525 14.9219 21.2822 14.6777C21.5264 14.5361 21.8584 14.3506 22.0293 14.3213V13.4473C21.6533 13.4619 21.2627 13.6816 20.8525 13.916C20.584 14.0674 20.2178 14.2773 20.0615 14.2773Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.0293 15.6201C21.6533 15.6348 21.2627 15.8594 20.8525 16.0889C20.584 16.2402 20.2178 16.4502 20.0615 16.4502C19.9053 16.4502 19.5391 16.2451 19.2705 16.0889C18.8408 15.8447 18.4404 15.6152 18.0498 15.6152C17.6641 15.6152 17.2588 15.8447 16.8291 16.0889C16.5605 16.2402 16.1943 16.4502 16.0381 16.4502C15.8818 16.4502 15.5156 16.2451 15.2471 16.0889C14.8174 15.8447 14.417 15.6152 14.0264 15.6152C13.6406 15.6152 13.2354 15.8447 12.8057 16.0889C12.5371 16.2402 12.1709 16.4502 12.0146 16.4502C11.8584 16.4502 11.4922 16.2451 11.2236 16.0889C10.7939 15.8447 10.3936 15.6152 10.0029 15.6152C9.61719 15.6152 9.21191 15.8447 8.78223 16.0889C8.51367 16.2402 8.14746 16.4502 7.99121 16.4502C7.83496 16.4502 7.46875 16.2451 7.2002 16.0889C6.77051 15.8447 6.37012 15.6152 5.97949 15.6152C5.59375 15.6152 5.18848 15.8447 4.75879 16.0889C4.49023 16.2402 4.12402 16.4502 3.96777 16.4502C3.81152 16.4502 3.44531 16.2451 3.17676 16.0889C2.7666 15.8545 2.37598 15.6348 2 15.6201V16.4941C2.17578 16.5234 2.50293 16.709 2.74707 16.8506C3.17676 17.0947 3.57715 17.3242 3.96777 17.3242C4.3584 17.3242 4.75879 17.0947 5.18848 16.8506C5.45703 16.6992 5.82324 16.4893 5.97949 16.4893C6.13574 16.4893 6.50195 16.6943 6.77051 16.8506C7.2002 17.0947 7.60059 17.3242 7.99121 17.3242C8.38184 17.3242 8.78223 17.0947 9.21191 16.8506C9.48047 16.6992 9.84668 16.4893 10.0029 16.4893C10.1592 16.4893 10.5254 16.6943 10.7939 16.8506C11.2236 17.0947 11.624 17.3242 12.0146 17.3242C12.4004 17.3242 12.8057 17.0947 13.2354 16.8506C13.5039 16.6992 13.8701 16.4893 14.0264 16.4893C14.1826 16.4893 14.5488 16.6943 14.8174 16.8506C15.2471 17.0947 15.6475 17.3242 16.0381 17.3242C16.4238 17.3242 16.8291 17.0947 17.2588 16.8506C17.5273 16.6992 17.8936 16.4893 18.0498 16.4893C18.2061 16.4893 18.5723 16.6943 18.8408 16.8506C19.2705 17.0947 19.6709 17.3242 20.0615 17.3242C20.4473 17.3242 20.8525 17.0947 21.2822 16.8506C21.5264 16.709 21.8584 16.5234 22.0293 16.4941V15.6201Z",
      fill: "#F0F0F0"
    }
  ))),
  "korea - north": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#91DC5A" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.23438H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.0977H2V18.332H22V16.0977Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.12109H2V15.2148H22V8.12109Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.43359 14.2344C10.851 14.2344 12 13.0853 12 11.668C12 10.2506 10.851 9.10156 9.43359 9.10156C8.01621 9.10156 6.86719 10.2506 6.86719 11.668C6.86719 13.0853 8.01621 14.2344 9.43359 14.2344Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.4336 9.10156L10.0117 10.8711H11.875L10.3672 11.9687L10.9453 13.7461L9.4336 12.6445L7.92578 13.7422L8.50391 11.9687L6.99609 10.8711H8.85938L9.4336 9.10156Z",
      fill: "#D80027"
    }
  ))),
  "korea - south": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "white" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.4336 11.668C14.4336 12.2773 13.3438 13.7969 12 13.7969C10.6563 13.7969 9.56641 12.2734 9.56641 11.668C9.56641 10.3242 10.6563 9.23438 12 9.23438C13.3438 9.23438 14.4336 10.3203 14.4336 11.668Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.4336 11.668C14.4336 13.0117 13.3438 14.1016 12 14.1016C10.6563 14.1016 9.56641 13.0117 9.56641 11.668",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2281 13.1721L14.5818 13.8184L15.0127 14.2493L15.659 13.603L15.2281 13.1721Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.1554 14.2482L13.509 14.8945L13.9399 15.3254L14.5863 14.6791L14.1554 14.2482Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.5226 14.4631L15.8762 15.1095L16.3071 15.5404L16.9534 14.894L16.5226 14.4631Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.4432 15.5394L14.7969 16.1857L15.2278 16.6166L15.8741 15.9703L15.4432 15.5394Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.8726 13.8176L15.2263 14.464L15.6572 14.8948L16.3035 14.2485L15.8726 13.8176Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.7994 14.8938L14.1531 15.5401L14.584 15.971L15.2303 15.3247L14.7994 14.8938Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5857 7.36193L14.1548 7.79282L15.8756 9.51361L16.3065 9.08272L14.5857 7.36193Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9389 8.0065L13.5081 8.43739L14.1544 9.08373L14.5853 8.65284L13.9389 8.0065Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.0122 9.08229L14.5813 9.51318L15.2276 10.1595L15.6585 9.72863L15.0122 9.08229Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2273 6.71506L14.7964 7.14595L15.4427 7.79228L15.8736 7.36139L15.2273 6.71506Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.3037 7.79424L15.8728 8.22513L16.5191 8.87146L16.95 8.44057L16.3037 7.79424Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.48118 14.4659L7.05029 14.8968L8.77108 16.6176L9.20197 16.1867L7.48118 14.4659Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.20164 14.8953L8.77075 15.3262L9.41708 15.9725L9.84797 15.5416L9.20164 14.8953Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.12547 13.8168L7.69458 14.2477L8.34091 14.894L8.7718 14.4631L8.12547 13.8168Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.77195 13.1723L8.34106 13.6032L10.0619 15.3239L10.4928 14.8931L8.77195 13.1723Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.77206 6.71666L7.05127 8.43745L7.48216 8.86834L9.20295 7.14755L8.77206 6.71666Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.41586 7.36189L7.69507 9.08269L8.12596 9.51358L9.84675 7.79278L9.41586 7.36189Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.0626 8.0103L8.3418 9.73109L8.77269 10.162L10.4935 8.44119L10.0626 8.0103Z",
      fill: "black"
    }
  ))),
  kuwait: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.52344 13.8906L2 18.332V5L8.52344 9.44531V13.8906Z", fill: "black" }))),
  kyrgyzstan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 18.3359C15.6826 18.3359 18.668 15.3506 18.668 11.668C18.668 7.98535 15.6826 5 12 5C8.31738 5 5.33203 7.98535 5.33203 11.668C5.33203 15.3506 8.31738 18.3359 12 18.3359Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2617 11.668L13.9297 12.293L14.6367 13.582L13.1914 13.3086L13.0078 14.7695L12 13.6914L10.9922 14.7695L10.8086 13.3086L9.36328 13.582L10.0703 12.293L8.73828 11.668L10.0703 11.0391L9.36328 9.75L10.8086 10.0273L10.9922 8.56641L12 9.64062L13.0078 8.56641L13.1914 10.0273L14.6367 9.75L13.9297 11.0391L15.2617 11.668Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.6953C13.1197 13.6953 14.0273 12.7877 14.0273 11.668C14.0273 10.5483 13.1197 9.64062 12 9.64062C10.8803 9.64062 9.97266 10.5483 9.97266 11.668C9.97266 12.7877 10.8803 13.6953 12 13.6953Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.9844 11.668C10.9336 11.668 10.8867 11.6719 10.8398 11.6758C10.8398 11.957 10.9414 12.2148 11.1094 12.4141C11.1992 12.1719 11.332 11.9531 11.5 11.7656C11.3437 11.6992 11.168 11.668 10.9844 11.668Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.6094 12.7578C11.7305 12.8008 11.8633 12.8242 12 12.8242C12.1367 12.8242 12.2695 12.8008 12.3906 12.7578C12.3242 12.4961 12.1875 12.2656 12 12.082C11.8125 12.2656 11.6758 12.4961 11.6094 12.7578Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.0039 11.0859C12.8047 10.7422 12.4297 10.5078 12 10.5078C11.5703 10.5078 11.1953 10.7422 10.9961 11.0859C11.3633 11.0859 11.7031 11.1875 12 11.3594C12.2969 11.1875 12.6367 11.0898 13.0039 11.0859Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.4961 11.7617C12.6641 11.9492 12.7969 12.168 12.8867 12.4102C13.0547 12.2109 13.1562 11.9531 13.1562 11.6719C13.1094 11.668 13.0586 11.6641 13.0117 11.6641C12.832 11.668 12.6563 11.6992 12.4961 11.7617Z",
      fill: "#FFDA44"
    }
  ))),
  laos: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.5234C13.0247 13.5234 13.8555 12.6927 13.8555 11.668C13.8555 10.6432 13.0247 9.8125 12 9.8125C10.9753 9.8125 10.1445 10.6432 10.1445 11.668C10.1445 12.6927 10.9753 13.5234 12 13.5234Z",
      fill: "#F0F0F0"
    }
  ))),
  latvia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#A2001D" }))),
  lebanon: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.3399 12.5586L12 10.1055L10.6602 12.5586H11.6641V13.2305H12.3359V12.5586H13.3399Z",
      fill: "#6DA544"
    }
  ))),
  lesotho: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.4336 11.5234V9.92969H11.5625V11.5234L10.5156 12.5703C10.8203 13.0703 11.3711 13.4024 12 13.4024C12.6289 13.4024 13.1797 13.0703 13.4844 12.5703L12.4336 11.5234Z",
      fill: "black"
    }
  ))),
  liberia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5.46368H2V18.33H22V5.46368Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V6.21075H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 7.4254H2V8.63614H22V7.4254Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.84691H2V11.0577H22V9.84691Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 12.2723H2V13.4831H22V12.2723Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.6977H2V15.9085H22V14.6977Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 17.1192H2V18.33H22V17.1192Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.3144H12V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 6.47775L7.42969 7.75948H8.82812L7.69922 8.55114L8.12891 9.83287L7 9.04121L5.87109 9.83287L6.30078 8.55114L5.17188 7.75948H6.56641L7 6.47775Z",
      fill: "#F0F0F0"
    }
  ))),
  libya: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9922 10.8867L13.3438 11.3672L13.9102 11.1836L13.5586 11.6679L13.9102 12.1484L13.3438 11.9648L12.9922 12.4453V11.8515L12.4258 11.6679L12.9922 11.4804V10.8867Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.0391 12.8711C11.375 12.8711 10.832 12.332 10.832 11.6641C10.832 10.9961 11.3711 10.457 12.0391 10.457C12.2461 10.457 12.4414 10.5078 12.6133 10.6016C12.3438 10.3398 11.9805 10.1797 11.5742 10.1797C10.7539 10.1797 10.0898 10.8437 10.0898 11.6641C10.0898 12.4844 10.7539 13.1484 11.5742 13.1484C11.9766 13.1484 12.3438 12.9883 12.6133 12.7266C12.4414 12.8203 12.2461 12.8711 12.0391 12.8711Z",
      fill: "#F0F0F0"
    }
  ))),
  liechtenstein: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.2617 9.63673C10.2617 9.15627 9.87109 8.76564 9.39062 8.76564C9.16797 8.76564 8.96484 8.84767 8.8125 8.9883V8.47658H9.10156V7.89845H8.8125V7.60939H8.23438V7.89845H7.94531V8.47658H8.23438V8.9883C8.08203 8.85158 7.87891 8.76564 7.65625 8.76564C7.17578 8.76564 6.78516 9.15627 6.78516 9.63673C6.78516 9.89455 6.89844 10.125 7.07422 10.2852V10.7969H9.97266V10.2852C10.1484 10.125 10.2617 9.89455 10.2617 9.63673Z",
      fill: "#FFDA44"
    }
  ))),
  lithuania: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }))),
  luxembourg: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#338AF3" }))),
  macao: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M20 5H0V18.332H20V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1602 11.3867C10.9961 11.3867 10.8399 11.418 10.6953 11.4726C10.7734 11.2969 10.8281 11.1015 10.8281 10.8906C10.8281 10.0625 10 9.44139 10 9.44139C10 9.44139 9.17188 10.0625 9.17188 10.8906C9.17188 11.1015 9.22657 11.2969 9.30469 11.4726C9.16016 11.4219 9.00391 11.3867 8.83985 11.3867C8.01172 11.3867 7.39062 12.2148 7.39062 12.2148C7.39062 12.2148 8.01172 13.043 8.83985 13.043C9.32422 13.043 9.73829 12.7578 10 12.5234C10.2578 12.7578 10.6758 13.043 11.1602 13.043C11.9883 13.043 12.6094 12.2148 12.6094 12.2148C12.6094 12.2148 11.9883 11.3867 11.1602 11.3867Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 7.60939L10.1719 8.13673H10.7266L10.2773 8.46095L10.4492 8.9883L10 8.66017L9.55078 8.9883L9.72266 8.46095L9.27344 8.13673H9.82813L10 7.60939Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.89453 8.53127L8.22266 8.82423L8.60937 8.60548L8.42578 9.00783L8.75781 9.3047L8.31641 9.25783L8.13672 9.66408L8.04297 9.23048L7.60156 9.18361L7.98828 8.96095L7.89453 8.53127Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.35547 10.0703L6.78906 10.1641L7.00781 9.77736L7.05469 10.2188L7.48828 10.3125L7.08203 10.4922L7.12891 10.9336L6.83203 10.6016L6.42969 10.7813L6.64844 10.3985L6.35547 10.0703Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.1055 8.53127L11.7773 8.82423L11.3906 8.60548L11.5742 9.00783L11.2422 9.3047L11.6836 9.25783L11.8633 9.66408L11.957 9.23048L12.3984 9.18361L12.0117 8.96095L12.1055 8.53127Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.6445 10.0703L13.2109 10.1641L12.9922 9.77736L12.9453 10.2188L12.5117 10.3125L12.918 10.4922L12.8711 10.9336L13.168 10.6016L13.5703 10.7813L13.3516 10.3985L13.6445 10.0703Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10 15.3633C10.6563 15.3633 11.2656 15.1446 11.75 14.7735H8.25C8.73438 15.1446 9.34375 15.3633 10 15.3633Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.34375 13.625C7.4375 13.8359 7.55078 14.0313 7.69141 14.2148H12.3125C12.4492 14.0352 12.5664 13.8359 12.6602 13.625H7.34375Z",
      fill: "#F0F0F0"
    }
  ))),
  macedonia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M16.9961 18.332L12 11.5234L13.0469 18.332H16.9961Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M7.21875 5L12 11.5234L10.9961 5H7.21875Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.9531 18.332L12 11.5234L7.00391 18.332H10.9531Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V9.98438L12 11.5234L3.10547 5H2Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332H2.71094L12 11.5234L2 13.0586V18.332Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.5234L22 9.98438V5H20.8945L12 11.5234Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M13.0039 5L12 11.5234L16.7812 5H13.0039Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 18.332V13.0586L12 11.5234L21.2891 18.332H22Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.8438C13.2815 13.8438 14.3203 12.8049 14.3203 11.5234C14.3203 10.242 13.2815 9.20312 12 9.20312C10.7185 9.20312 9.67969 10.242 9.67969 11.5234C9.67969 12.8049 10.7185 13.8438 12 13.8438Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.2617C12.96 13.2617 13.7383 12.4835 13.7383 11.5234C13.7383 10.5634 12.96 9.78516 12 9.78516C11.04 9.78516 10.2617 10.5634 10.2617 11.5234C10.2617 12.4835 11.04 13.2617 12 13.2617Z",
      fill: "#FFDA44"
    }
  ))),
  madagascar: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 18.332V5C12.6797 5 2 5 2 5V18.332H22Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668C2 11.668 12.6797 11.668 22 11.668V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#F0F0F0" }))),
  malawi: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9922 8.1875L13.1797 7.80469L13.6133 7.01562L12.7266 7.1875L12.6172 6.29297L12 6.94922L11.3828 6.29297L11.2734 7.1875L10.3867 7.01562L10.8203 7.80469L10.0078 8.1875H13.9922Z",
      fill: "#D80027"
    }
  ))),
  malaysia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.66797H2V8.33593H22V6.66797Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 10H2V11.668H22V10Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.332H2V15H22V13.332Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.668H2V18.3359H22V16.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V12.1797H12V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.50391 10.2383C6.59375 10.2383 5.85547 9.5 5.85547 8.58984C5.85547 7.67969 6.59375 6.94141 7.50391 6.94141C7.78906 6.94141 8.05469 7.01172 8.28906 7.14063C7.92188 6.78125 7.42188 6.5625 6.87109 6.5625C5.75 6.5625 4.83984 7.46875 4.83984 8.58984C4.83984 9.71094 5.75 10.6172 6.86719 10.6172C7.41797 10.6172 7.91797 10.3945 8.28516 10.0391C8.05469 10.168 7.78906 10.2383 7.50391 10.2383Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.96875 7.42969L8.26172 8.04297L8.92187 7.89062L8.625 8.5L9.16016 8.92187L8.49609 9.07031L8.5 9.75L7.96875 9.32422L7.44141 9.75V9.07031L6.78125 8.92187L7.3125 8.5L7.01562 7.89062L7.67578 8.04297L7.96875 7.42969Z",
      fill: "#FFDA44"
    }
  ))),
  maldives: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M16.3477 8.47656H7.65234V14.8516H16.3477V8.47656Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.0742 13.5508C12.0352 13.5508 11.1914 12.707 11.1914 11.668C11.1914 10.6289 12.0352 9.78516 13.0742 9.78516C13.3984 9.78516 13.7031 9.86719 13.9688 10.0117C13.5508 9.60156 12.9805 9.35156 12.3477 9.35156C11.0664 9.35156 10.0273 10.3906 10.0273 11.6719C10.0273 12.9531 11.0664 13.9922 12.3477 13.9922C12.9805 13.9922 13.5508 13.7383 13.9688 13.332C13.7031 13.4688 13.3984 13.5508 13.0742 13.5508Z",
      fill: "#F0F0F0"
    }
  ))),
  mali: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  malta: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H12V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.1328 7.08203V6.25H9.30078V7.08203H8.46875V7.91797H9.30078V8.75H10.1328V7.91797H10.9688V7.08203H10.1328Z",
      fill: "#ACABB1"
    }
  ))),
  "marshall islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1328 8.89844L10.3203 9.28125L10.7539 10.0703L9.87109 9.89844L9.75781 10.793L9.14062 10.1367L8.52734 10.793L8.41406 9.89844L7.53125 10.0703L7.96484 9.28125L7.14844 8.89844L7.96484 8.51562L7.53125 7.72656L8.41406 7.89453L8.52734 7.00391L9.14062 7.66016L9.75781 7.00391L9.87109 7.89453L10.7539 7.72656L10.3203 8.51562L11.1328 8.89844Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M18.6758 5L2 18.1328V18.2773L21.6797 5H18.6758Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H21.6797L2 18.2773V18.332H2.14453L22 7.01953V5Z", fill: "#FF9811" }))),
  martinique: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 10.7969V12.5352H12.8711V18.332H11.1289V12.5352H2V10.7969H11.1289V5H12.8711V10.7969H22Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1016 8.53906C17.1016 8.44922 17.1719 8.37891 17.2617 8.37891H17.6055C18.1484 8.37891 18.5938 7.9375 18.5938 7.39063C18.5938 6.84766 18.1523 6.40234 17.6055 6.40234H17.2773C17.1719 6.32031 17.0273 6.27344 16.8711 6.27344C16.543 6.27344 16.2734 6.48828 16.2734 6.75C16.2734 7.01172 16.5352 7.22266 16.8594 7.22656H17.6055C17.6953 7.22656 17.7656 7.29688 17.7656 7.38672C17.7656 7.47656 17.6953 7.54688 17.6055 7.54688H17.2617C16.7188 7.54688 16.2734 7.98828 16.2734 8.53516C16.2734 9.07813 16.7148 9.52344 17.2617 9.52344H18.5938V8.69922H17.2617C17.1758 8.69922 17.1016 8.625 17.1016 8.53906Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.23047 8.53906C6.23047 8.44922 6.30078 8.37891 6.39063 8.37891H6.73438C7.27735 8.37891 7.72266 7.9375 7.72266 7.39063C7.72266 6.84766 7.28126 6.40234 6.73438 6.40234H6.40625C6.30078 6.32031 6.15625 6.27344 6 6.27344C5.67188 6.27344 5.40234 6.48828 5.40234 6.75C5.40234 7.01172 5.66406 7.22266 5.98828 7.22656H6.73438C6.82422 7.22656 6.89454 7.29688 6.89454 7.38672C6.89454 7.47656 6.82422 7.54688 6.73438 7.54688H6.39063C5.84766 7.54688 5.40234 7.98828 5.40234 8.53516C5.40234 9.07813 5.84375 9.52344 6.39063 9.52344H7.72266V8.69922H6.39063C6.30469 8.69922 6.23047 8.625 6.23047 8.53906Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1016 16.0742C17.1016 15.9844 17.1719 15.9141 17.2617 15.9141H17.6055C18.1484 15.9141 18.5938 15.4727 18.5938 14.9258C18.5938 14.3828 18.1523 13.9375 17.6055 13.9375H17.2773C17.1719 13.8555 17.0273 13.8086 16.8711 13.8086C16.543 13.8086 16.2734 14.0234 16.2734 14.2852C16.2734 14.5469 16.5352 14.7578 16.8594 14.7617H17.6055C17.6953 14.7617 17.7656 14.832 17.7656 14.9219C17.7656 15.0117 17.6953 15.082 17.6055 15.082H17.2617C16.7188 15.082 16.2734 15.5234 16.2734 16.0703C16.2734 16.6133 16.7148 17.0586 17.2617 17.0586H18.5938V16.2305H17.2617C17.1758 16.2344 17.1016 16.1602 17.1016 16.0742Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.23047 16.0742C6.23047 15.9844 6.30078 15.9141 6.39063 15.9141H6.73438C7.27735 15.9141 7.72266 15.4727 7.72266 14.9258C7.72266 14.3828 7.28126 13.9375 6.73438 13.9375H6.40625C6.30078 13.8555 6.15625 13.8086 6 13.8086C5.67188 13.8086 5.40234 14.0234 5.40234 14.2852C5.40234 14.5469 5.66406 14.7578 5.98828 14.7617H6.73438C6.82422 14.7617 6.89454 14.832 6.89454 14.9219C6.89454 15.0117 6.82422 15.082 6.73438 15.082H6.39063C5.84766 15.082 5.40234 15.5234 5.40234 16.0703C5.40234 16.6133 5.84375 17.0586 6.39063 17.0586H7.72266V16.2305H6.39063C6.30469 16.2344 6.23047 16.1602 6.23047 16.0742Z",
      fill: "#F0F0F0"
    }
  ))),
  mauritania: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.3399C10.2031 13.3399 8.70703 12.0781 8.33594 10.3945C8.28125 10.6523 8.25 10.9219 8.25 11.1992C8.25 13.2695 9.92969 14.9492 12 14.9492C14.0703 14.9492 15.75 13.2695 15.75 11.1992C15.75 10.9219 15.7187 10.6563 15.6641 10.3945C15.293 12.0781 13.7969 13.3399 12 13.3399Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 8.38672L12.3477 9.46094H13.4805L12.5664 10.125L12.9141 11.1992L12 10.5352L11.0859 11.1992L11.4336 10.125L10.5195 9.46094H11.6523L12 8.38672Z",
      fill: "#FFDA44"
    }
  ))),
  mayotte: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  mexico: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M15.3335 5H2V18.3335H22V5H15.3335Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M8.6665 5H2V18.3335H8.6665V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M15.333 5H8.6665V18.3335H15.333V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.125 11.6665C10.125 12.7021 10.9648 13.5415 12 13.5415C13.0352 13.5415 13.875 12.7017 13.875 11.6665V11.0415H10.125V11.6665Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5 10.4165H12.625C12.625 10.0713 12.3452 9.7915 12 9.7915C11.6548 9.7915 11.375 10.0713 11.375 10.4165H9.5C9.5 10.7617 9.80078 11.0415 10.146 11.0415H10.125C10.125 11.3867 10.4053 11.6665 10.75 11.6665C10.75 12.0117 11.0298 12.2915 11.375 12.2915H12.625C12.9702 12.2915 13.25 12.0117 13.25 11.6665C13.5952 11.6665 13.875 11.3867 13.875 11.0415H13.854C14.1992 11.0415 14.5 10.7617 14.5 10.4165Z",
      fill: "#FF9811"
    }
  ))),
  micronesia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.89844L12.2891 8.78516H13.2187L12.4648 9.33203L12.7539 10.2188L12 9.66797L11.2461 10.2188L11.5352 9.33203L10.7812 8.78516H11.7109L12 7.89844Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.23047 11.668L9.11719 11.3789V10.4492L9.66406 11.1992L10.5508 10.9141L10.0039 11.668L10.5508 12.4219L9.66406 12.1328L9.11719 12.8867V11.9531L8.23047 11.668Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15.4336L11.7109 14.5508H10.7812L11.5352 14L11.2461 13.1172L12 13.6641L12.7539 13.1172L12.4648 14L13.2187 14.5508H12.2891L12 15.4336Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.7695 11.668L14.8828 11.9531V12.8867L14.3359 12.1328L13.4492 12.4219L13.9961 11.668L13.4492 10.9141L14.3359 11.1992L14.8828 10.4492V11.3789L15.7695 11.668Z",
      fill: "#F0F0F0"
    }
  ))),
  moldova: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H14.8984V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.3203 10.2461H12.7266C12.7266 9.84766 12.4023 9.51953 12 9.51953C11.6016 9.51953 11.2734 9.84375 11.2734 10.2461H9.67969C9.67969 10.6406 10.0234 10.9609 10.418 10.9609H10.3945C10.3945 11.3555 10.7148 11.6758 11.1094 11.6758C11.1094 12.0234 11.3594 12.3164 11.6914 12.375L11.1289 13.6445C11.3984 13.7539 11.6914 13.8164 12 13.8164C12.3086 13.8164 12.6016 13.7539 12.8711 13.6445L12.3086 12.375C12.6406 12.3125 12.8906 12.0234 12.8906 11.6758C13.2852 11.6758 13.6055 11.3555 13.6055 10.9609H13.582C13.9766 10.957 14.3203 10.6406 14.3203 10.2461Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 11.2305L11.0586 11.668V12.5352L12 13.1172L12.9414 12.5352V11.668L12 11.2305Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.9414 10.7969H11.0586V11.668H12.9414V10.7969Z", fill: "#D80027" }))),
  monaco: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#D80027" }))),
  mongolia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H14.8984V18.332H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M7 12.1016H6.42188V14.4219H7V12.1016Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M4.67968 12.1016H4.10156V14.4219H4.67968V12.1016Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.55078 13.5508C5.87007 13.5508 6.12891 13.292 6.12891 12.9727C6.12891 12.6534 5.87007 12.3945 5.55078 12.3945C5.23149 12.3945 4.97266 12.6534 4.97266 12.9727C4.97266 13.292 5.23149 13.5508 5.55078 13.5508Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.55078 11.2305C5.71043 11.2305 5.83984 11.1011 5.83984 10.9414C5.83984 10.7818 5.71043 10.6523 5.55078 10.6523C5.39114 10.6523 5.26172 10.7818 5.26172 10.9414C5.26172 11.1011 5.39114 11.2305 5.55078 11.2305Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M6.13281 13.8399H4.97266V14.418H6.13281V13.8399Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M6.13281 11.5234H4.97266V12.1016H6.13281V11.5234Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.55078 8.91406L5.75781 9.54297H6.42188L5.88281 9.93359L6.08984 10.5664L5.55078 10.1758L5.01172 10.5664L5.21875 9.93359L4.67969 9.54297H5.34375L5.55078 8.91406Z",
      fill: "#FFDA44"
    }
  ))),
  montenegro: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.335H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.15723H2V17.1729H22V6.15723Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5498 9.92676H13.4502V8.76953L12.8691 9.05762L12 8.18848L11.1309 9.05762L10.5498 8.76953V9.92676Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6074 11.665H13.1572C13.2158 11.5674 13.2451 11.4551 13.2451 11.333C13.2451 10.9619 12.9473 10.6641 12.5762 10.6641C12.3223 10.6641 12.0977 10.8057 11.9854 11.0156C11.8731 10.8057 11.6484 10.6641 11.3945 10.6641C11.0234 10.6641 10.7256 10.9619 10.7256 11.333C10.7256 11.4551 10.7598 11.5674 10.8135 11.665H9.38281C9.38281 12.1094 9.76856 12.4658 10.2129 12.4658H10.1885C10.1885 12.8271 10.4326 13.1348 10.7598 13.2373L10.1104 13.8867L10.7256 14.502L11.5996 13.6279C11.6338 13.6426 11.668 13.6523 11.707 13.6572L11.1797 14.8535C11.4336 14.9561 11.707 15.0146 12 15.0146C12.2881 15.0146 12.5664 14.9561 12.8203 14.8535L12.293 13.6621C12.3272 13.6572 12.3662 13.6475 12.4004 13.6328L13.2744 14.5068L13.8897 13.8916L13.2305 13.2373C13.5625 13.1396 13.8018 12.832 13.8018 12.4658H13.7774C14.2217 12.4707 14.6074 12.1094 14.6074 11.665Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12.0996L11.0576 12.5342V13.4033L12 13.9844L12.9424 13.4033V12.5342L12 12.0996Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M12.9424 11.665H11.0576V12.8223H12.9424V11.665Z", fill: "#0052B4" }))),
  montserrat: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.0547 9.16797V12.2227C15.0547 13.7109 17 14.168 17 14.168C17 14.168 18.9453 13.7109 18.9453 12.2227V9.16797H15.0547Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.0547 12.2227C15.0547 13.7109 17 14.168 17 14.168C17 14.168 18.9453 13.7109 18.9453 12.2227H15.0547Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.832 10.5547H17.2773V10H16.7227V10.5547H16.168V11.1094H16.7227V12.7773H17.2773V11.1094H17.832V10.5547Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7734V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }))),
  morocco: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M2 5V11.668V18.332H22V11.668V5H2Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.75 10.5117H12.8867L12 7.78906L11.1133 10.5117H8.25L10.5664 12.1953L9.68359 14.9219L12 13.2383L14.3164 14.9219L13.4297 12.1992L15.75 10.5117ZM11.2148 11.9883L11.5156 11.0664H12.4844L12.7852 11.9883L12 12.5547L11.2148 11.9883ZM12.3047 10.5117H11.6953L12 9.57422L12.3047 10.5117ZM13.2539 11.6445L13.0664 11.0625H14.0547L13.2539 11.6445ZM10.9336 11.0664L10.7461 11.6484L9.94922 11.0664H10.9336ZM10.7305 13.4766L11.0352 12.5391L11.5273 12.8984L10.7305 13.4766ZM12.4688 12.8984L12.9609 12.5391L13.2656 13.4766L12.4688 12.8984Z",
      fill: "#FFDA44"
    }
  ))),
  mozambique: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.2773H2V18.3359H22V14.2773Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.08203H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.90234H2V13.4062H22V9.90234Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.26172 9.28906L5.85156 11.1055H7.76172L6.21484 12.2266L6.80469 14.043L5.26172 12.9219L3.71484 14.043L4.30469 12.2266L2.76172 11.1055H4.67188L5.26172 9.28906Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M6.98828 11.668H3.53516V13.2539H6.98828V11.668Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.64062 9.84766L7.08203 9.28906L5.26172 11.1094L3.44141 9.28906L2.87891 9.84766L4.70312 11.668L2.87891 13.4922L3.44141 14.043L5.26172 12.2266L7.08203 14.043L7.64062 13.4922L5.82031 11.668L7.64062 9.84766Z",
      fill: "black"
    }
  ))),
  myanmar: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 10.543H13.1797L12 6.91016L10.8203 10.543H7L10.0898 12.7891L8.91016 16.4219L12 14.2031L15.0898 16.4219L13.9102 12.7891L17 10.543Z",
      fill: "#F0F0F0"
    }
  ))),
  namibia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332V5H22", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 7.61328V5H18.082L2 15.7188V18.332H5.91797L22 7.61328Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V6.56641L4.35156 18.332H2V16.7656L19.6484 5H22Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.33204 9.05859L8.44532 9.47656L8.91798 10.3359L7.95313 10.1523L7.83204 11.125L7.16016 10.4102L6.48828 11.125L6.36719 10.1523L5.40234 10.3359L5.875 9.47656L4.98438 9.05859L5.875 8.64062L5.40234 7.78125L6.36719 7.96484L6.48828 6.98828L7.16016 7.70703L7.83204 6.98828L7.95313 7.96484L8.91798 7.78125L8.44532 8.64062L9.33204 9.05859Z",
      fill: "#FFDA44"
    }
  ))),
  nauru: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.043H2V12.293H22V11.043Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.82812 15L8.08203 15.3516L8.48047 16.0742L7.66797 15.918L7.56641 16.7383L7 16.1367L6.43359 16.7383L6.33203 15.918L5.51953 16.0742L5.91797 15.3516L5.17188 15L5.91797 14.6484L5.51953 13.9258L6.33203 14.0781L6.43359 13.2617L7 13.8633L7.56641 13.2617L7.66797 14.0781L8.48047 13.9258L8.08203 14.6484L8.82812 15Z",
      fill: "#F0F0F0"
    }
  ))),
  nepal: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332V5L12.9531 11.8281H5.42188L12.5938 18.332H2Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.5625 11.4297L2.39844 5.71875V11.4297V17.9336H11.5625L4.39062 11.4297H11.5625Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.82812 14.3399L5.25781 14.0703L5.5625 13.5196L4.94141 13.6367L4.86328 13.0117L4.43359 13.4727L4.00391 13.0117L3.92578 13.6367L3.30469 13.5196L3.60938 14.0703L3.03906 14.3399L3.60938 14.6094L3.30469 15.1602L3.92578 15.043L4.00391 15.668L4.43359 15.207L4.86328 15.668L4.94141 15.043L5.5625 15.1602L5.25781 14.6094L5.82812 14.3399Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.44922 9.15234L5.03516 8.95703L5.25391 8.55859L4.80469 8.64453L4.7461 8.1875L4.4336 8.52344L4.1211 8.1875L4.0625 8.64453L3.61328 8.55859L3.83203 8.95703L3.41797 9.15234L4.4336 9.35547L5.44922 9.15234Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.65234 9.15234C5.65234 9.82422 5.10547 10.3711 4.43359 10.3711C3.76172 10.3711 3.21484 9.82422 3.21484 9.15234",
      fill: "#F0F0F0"
    }
  ))),
  netherlands: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }))),
  "new caledonia": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  "new zealand": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6135 10.7969L18.7463 11.2031H19.176L18.8284 11.457L18.9612 11.8633L18.6135 11.6133L18.2659 11.8633L18.3987 11.457L18.051 11.2031H18.4807L18.6135 10.7969Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.0825 13.7305L17.2817 14.3398H17.9224L17.4028 14.7188L17.6021 15.3281L17.0825 14.9531L16.563 15.3281L16.7622 14.7188L16.2427 14.3398H16.8833L17.0825 13.7305Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.1411 8.92969L17.3052 9.4414H17.8403L17.4067 9.7539L17.5747 10.2656L17.1411 9.94921L16.7075 10.2656L16.8716 9.7539L16.438 9.4414H16.9771L17.1411 8.92969Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.6682 10.7812L15.8674 11.3906H16.5081L15.9885 11.7695L16.1877 12.3789L15.6682 12L15.1487 12.3789L15.3479 11.7695L14.8245 11.3906H15.469L15.6682 10.7812Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7773V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }))),
  nicaragua: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.043C11.1055 10.043 10.375 10.7695 10.375 11.668C10.375 12.5664 11.1016 13.293 12 13.293C12.8945 13.293 13.625 12.5664 13.625 11.668C13.625 10.7695 12.8945 10.043 12 10.043ZM12 12.5937C11.4883 12.5937 11.0742 12.1797 11.0742 11.668C11.0742 11.1562 11.4883 10.7422 12 10.7422C12.5117 10.7422 12.9258 11.1562 12.9258 11.668C12.9258 12.1797 12.5117 12.5937 12 12.5937Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8047 11.8984L12 11.668L11.1953 11.8984L10.9297 12.3633H13.0703L12.8047 11.8984Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.5078L11.4648 11.4336L12 11.668L12.5351 11.4336L12 10.5078Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1953 11.8984H12.8047L12.5352 11.4336H11.4648L11.1953 11.8984Z",
      fill: "#6DA544"
    }
  ))),
  niger: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12.918C12.6904 12.918 13.25 12.3583 13.25 11.668C13.25 10.9776 12.6904 10.418 12 10.418C11.3096 10.418 10.75 10.9776 10.75 11.668C10.75 12.3583 11.3096 12.918 12 12.918Z",
      fill: "#FF9811"
    }
  ))),
  nigeria: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#6DA544" }))),
  niue: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5.88281V7.08203H3.80078L2 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 5V6.91016L2.88281 5H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 5V6.91016L11.1172 5H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 10.7812V9.58203H3.80078L2 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M5.75 11.668V9.75781L2.88281 11.668H5.75Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 10.7812V9.58203H10.1992L12 10.7812Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M8.25 11.668V9.75781L11.1172 11.668H8.25Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 9.21484C7.48756 9.21484 7.88281 8.81959 7.88281 8.33203C7.88281 7.84447 7.48756 7.44922 7 7.44922C6.51243 7.44922 6.11719 7.84447 6.11719 8.33203C6.11719 8.81959 6.51243 9.21484 7 9.21484Z",
      fill: "#2E52B2"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 7.70703L7.15625 8.1875H7.65625L7.25 8.48047L7.40625 8.95704L7 8.66407L6.59375 8.95704L6.75 8.48047L6.34375 8.1875H6.84375L7 7.70703Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 10.2539L7.09375 10.5391H7.39062L7.14844 10.7109L7.24219 10.9961L7 10.8203L6.75781 10.9961L6.85156 10.7109L6.60938 10.5391H6.90625L7 10.2539Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 5.66797L7.09375 5.95313H7.39062L7.14844 6.12891L7.24219 6.41406L7 6.23828L6.75781 6.41406L6.85156 6.12891L6.60938 5.95313H6.90625L7 5.66797Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.73047 7.96094L9.82422 8.24609H10.1211L9.88281 8.42187L9.97266 8.70703L9.73047 8.53125L9.48828 8.70703L9.58203 8.42187L9.33984 8.24609H9.64063L9.73047 7.96094Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.26953 7.96094L4.35938 8.24609H4.66016L4.41797 8.42187L4.51172 8.70703L4.26953 8.53125L4.02734 8.70703L4.11719 8.42187L3.87891 8.24609H4.17578L4.26953 7.96094Z",
      fill: "#FFDA44"
    }
  ))),
  "norfolk islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.875 13.8555L12 7.91797L10.125 13.8555H11.5312V15.418H12.4688V13.8555H13.875Z",
      fill: "#6DA544"
    }
  ))),
  "northern marianas": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.8244 15.2617C11.6721 15.2539 11.5471 15.1563 11.4963 15.0195C11.4103 15.1328 11.258 15.1914 11.1096 15.1523C10.9611 15.1133 10.8596 14.9922 10.8361 14.8477C10.7267 14.9414 10.5705 14.9688 10.4338 14.8984C10.2971 14.832 10.2189 14.6914 10.2267 14.5469C10.1017 14.6172 9.94159 14.6094 9.82049 14.5156C9.6994 14.4219 9.65253 14.2695 9.68768 14.1289C9.55096 14.1719 9.39471 14.1328 9.29706 14.0195C9.19549 13.9023 9.18378 13.7461 9.24628 13.6172C9.10174 13.6328 8.95721 13.5625 8.88299 13.4297C8.80878 13.2969 8.8244 13.1367 8.91424 13.0234C8.76971 13.0078 8.64471 12.9141 8.59784 12.7656C8.55096 12.6211 8.60174 12.4688 8.71112 12.375C8.5744 12.332 8.46893 12.2109 8.45331 12.0586C8.43768 11.9063 8.51581 11.7656 8.64081 11.6992C8.51581 11.6289 8.43768 11.4922 8.4494 11.3398C8.46503 11.1875 8.57049 11.0664 8.70721 11.0234C8.59784 10.9297 8.54706 10.7773 8.59393 10.6328C8.64081 10.4883 8.76581 10.3906 8.91034 10.375C8.82049 10.2617 8.80487 10.1016 8.87909 9.96875C8.95331 9.83594 9.09784 9.76563 9.24237 9.78125C9.17987 9.65235 9.19159 9.49219 9.29315 9.375C9.39081 9.25782 9.54706 9.21875 9.68378 9.26172C9.64862 9.1211 9.69549 8.96875 9.81268 8.875C9.93378 8.78125 10.0939 8.77344 10.2189 8.84375C10.2111 8.69922 10.2892 8.5586 10.426 8.49219C10.5627 8.42579 10.7228 8.44922 10.8322 8.54297C10.8517 8.40235 10.9572 8.27735 11.1057 8.23829C11.2541 8.19922 11.4025 8.25782 11.4924 8.3711C11.5432 8.23829 11.6682 8.13672 11.8205 8.12891C11.9728 8.1211 12.1096 8.20704 12.1721 8.33594C12.2463 8.21485 12.3908 8.14063 12.5432 8.16407C12.6955 8.1875 12.8088 8.29688 12.8478 8.4375C12.9455 8.33204 13.1017 8.29297 13.2463 8.34375C13.3908 8.39844 13.4807 8.52735 13.4885 8.67188C13.6057 8.58985 13.7658 8.57813 13.8947 8.66016C14.0236 8.74219 14.0861 8.88672 14.0627 9.03125C14.1955 8.97266 14.3517 8.9961 14.465 9.10157C14.5744 9.20704 14.6057 9.36329 14.5588 9.5C14.6994 9.46875 14.8517 9.52344 14.9377 9.64844C15.0236 9.77344 15.0236 9.9336 14.9494 10.0547C15.0939 10.0547 15.2307 10.1367 15.2892 10.2773C15.3478 10.418 15.3166 10.5742 15.2189 10.6797C15.3596 10.707 15.4767 10.8164 15.508 10.9688C15.5392 11.1172 15.4728 11.2656 15.3557 11.3477C15.4885 11.4023 15.5822 11.5352 15.5822 11.6875V11.6914V11.6953C15.5822 11.8477 15.4885 11.9805 15.3596 12.0352C15.4767 12.1172 15.5432 12.2617 15.5119 12.4141C15.4807 12.5625 15.3635 12.6719 15.2228 12.7031C15.3205 12.8086 15.3557 12.9648 15.2971 13.1055C15.2385 13.2461 15.0978 13.3281 14.9572 13.3281C15.0353 13.4492 15.0353 13.6094 14.9455 13.7344C14.8596 13.8594 14.7072 13.9141 14.5666 13.8828C14.6174 14.0156 14.5861 14.1758 14.4767 14.2813C14.3674 14.3867 14.2072 14.4102 14.0744 14.3516C14.0978 14.4922 14.0353 14.6406 13.9064 14.7227C13.7775 14.8047 13.6174 14.793 13.5002 14.7109C13.4924 14.8555 13.4025 14.9883 13.258 15.0391C13.1135 15.0938 12.9611 15.0508 12.8596 14.9453C12.8244 15.0859 12.7072 15.1953 12.5588 15.2188C12.4064 15.2422 12.2658 15.168 12.1877 15.0469C12.1291 15.1719 12.0002 15.2539 11.8557 15.2539C11.8361 15.2617 11.8283 15.2617 11.8244 15.2617Z",
      fill: "#F3F3F3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.1602C13.3591 14.1602 14.4609 13.0584 14.4609 11.6992C14.4609 10.3401 13.3591 9.23828 12 9.23828C10.6409 9.23828 9.53906 10.3401 9.53906 11.6992C9.53906 13.0584 10.6409 14.1602 12 14.1602Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.5391 10.8633C12.6601 10.7734 12.7383 10.6289 12.7383 10.4688V10.2227C12.7383 9.94922 12.5195 9.73047 12.2461 9.73047H11.7539C11.4805 9.73047 11.2617 9.94922 11.2617 10.2227V10.4688C11.2617 10.6289 11.3398 10.7734 11.4609 10.8633L11.0156 15.3906C11.0156 15.3906 11.2617 15.6367 12 15.6367C12.7383 15.6367 12.9844 15.3906 12.9844 15.3906L12.5391 10.8633Z",
      fill: "#BDBCC1"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.73047L12.4297 11.0469H13.8125L12.6914 11.8594L13.1211 13.1758L12 12.3633L10.8828 13.1758L11.3086 11.8594L10.1914 11.0469H11.5742L12 9.73047Z",
      fill: "#F0F0F0"
    }
  ))),
  norway: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 13.2266H9.89844V18.332H9.17578H7.50781H6.78125V13.2266H2V12.5V10.832V10.1094H6.78125V5H7.50781H9.17578H9.89844V10.1094H22V10.832V12.5V13.2266Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 10.832V12.5H9.17578V18.332H7.50781V12.5H2V10.832H7.50781V5H9.17578V10.832H22Z",
      fill: "#2E52B2"
    }
  ))),
  oman: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.41016 7.93359L8.79688 7.32031L8.38672 7.73047L7.97656 7.32031L7.36328 7.93359L7.77344 8.34375L7.36328 8.7539L7.97656 9.36718L8.38672 8.95703L8.79688 9.36718L9.41016 8.7539L9.00391 8.34375L9.41016 7.93359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 5H10.2617V9.34766H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.9844H10.2617V18.332H22V13.9844Z", fill: "#6DA544" }))),
  pakistan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.3711 8.32812L18.0547 9.06641L18.9688 8.64062L18.4766 9.51953L19.1641 10.2578L18.1758 10.0625L17.6875 10.9414L17.5664 9.94141L16.5781 9.75L17.4922 9.32422L17.3711 8.32812Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H7V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.1365 13.3399C14.9255 14.2149 13.2302 13.9414 12.3552 12.7305C11.4802 11.5195 11.7537 9.82423 12.9646 8.94923C13.3435 8.67579 13.7654 8.51563 14.199 8.45704C13.3669 8.33204 12.488 8.51954 11.7537 9.05079C10.2615 10.1289 9.92553 12.2109 11.0037 13.7031C12.0818 15.1953 14.1638 15.5313 15.656 14.4531C16.3904 13.9219 16.8435 13.1484 16.988 12.3164C16.8005 12.7109 16.5154 13.0664 16.1365 13.3399Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.0859 8.42188L16.7695 9.15625L17.6797 8.73438L17.1914 9.60938L17.875 10.3477L16.8867 10.1523L16.3984 11.0313L16.2773 10.0352L15.293 9.83985L16.2031 9.41797L16.0859 8.42188Z",
      fill: "#F0F0F0"
    }
  ))),
  palau: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5508 14.5664C12.1515 14.5664 13.4492 13.2687 13.4492 11.668C13.4492 10.0672 12.1515 8.76953 10.5508 8.76953C8.95001 8.76953 7.65234 10.0672 7.65234 11.668C7.65234 13.2687 8.95001 14.5664 10.5508 14.5664Z",
      fill: "#FFDA44"
    }
  ))),
  panama: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 11.668C12 11.668 12 15 12 18.3359H2V11.668H5.33203C8.51953 11.668 12 11.668 12 11.668Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22 5V11.668H18.668C15.1328 11.668 12 11.668 12 11.668C12 11.668 12 8.14062 12 5H22Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 6.47266L7.46093 7.89453H8.95702L7.74609 8.77344L8.21093 10.1953L7 9.31641L5.78906 10.1953L6.2539 8.77344L5.04297 7.89453H6.53906L7 6.47266Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 13.1406L17.4609 14.5586H18.957L17.7461 15.4375L18.2109 16.8594L17 15.9805L15.7891 16.8594L16.2539 15.4375L15.043 14.5586H16.5391L17 13.1406Z",
      fill: "#D80027"
    }
  ))),
  "papua new guinea": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5H22V18.332", fill: "#A2001D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.99219 14.4219L10.1016 14.7539H10.4492L10.168 14.957L10.2773 15.2891L9.99219 15.0859L9.71094 15.2891L9.82031 14.957L9.53516 14.7539H9.88672L9.99219 14.4219Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.10156 11.2305L9.28125 11.7852H9.86328L9.39062 12.1289L9.57422 12.6797L9.10156 12.3398L8.62891 12.6797L8.80859 12.1289L8.33984 11.7852H8.92187L9.10156 11.2305Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.10156 15.2891L9.28125 15.8438H9.86328L9.39062 16.1836L9.57422 16.7383L9.10156 16.3984L8.62891 16.7383L8.80859 16.1836L8.33984 15.8438H8.92187L9.10156 15.2891Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.8047 12.6797L10.9844 13.2344H11.5664L11.0938 13.5781L11.2734 14.1289L10.8047 13.789L10.332 14.1289L10.5117 13.5781L10.043 13.2344H10.625L10.8047 12.6797Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.39844 12.6797L7.57813 13.2344H8.16016L7.69141 13.5781L7.87109 14.1289L7.39844 13.789L6.92969 14.1289L7.10938 13.5781L6.63672 13.2344H7.21875L7.39844 12.6797Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.707 9.64063C16.4102 9.34375 16.0234 9.16797 15.6055 9.13672L16.8516 8.16797C16.3555 7.67188 15.6914 7.44922 15.043 7.49609C14.9648 7.21875 14.8164 6.95313 14.5977 6.73438L14.1055 7.71875C14.0742 7.66016 14.0312 7.60547 13.9844 7.55469C13.7031 7.27344 13.2422 7.27344 12.9609 7.55469C12.6797 7.83594 12.6797 8.29688 12.9609 8.57813C13.0117 8.62891 13.0664 8.66797 13.125 8.69922L12.1406 9.19141C12.3594 9.41016 12.625 9.5586 12.9023 9.63672C12.8555 10.2852 13.0781 10.9492 13.5742 11.4453L14.6641 10.0469C14.7461 9.96485 14.8555 9.92188 14.9687 9.92188C15.0859 9.92188 15.1953 9.96875 15.2773 10.0508C15.3594 10.1328 15.4063 10.2422 15.4063 10.3594C15.4063 10.4766 15.3594 10.5859 15.2773 10.668L15.6875 11.0781C15.8789 10.8867 15.9844 10.6328 15.9844 10.3594C15.9844 10.1367 15.9141 9.92578 15.7812 9.75391C15.9727 9.80469 16.1523 9.90235 16.3008 10.0547C16.7539 10.5078 16.7539 11.2422 16.3008 11.6953L16.7109 12.1055C17.0391 11.7773 17.2188 11.3398 17.2188 10.875C17.2188 10.4063 17.0352 9.96875 16.707 9.64063Z",
      fill: "#FFDA44"
    }
  ))),
  paraguay: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.3125 10.1328L12.8203 10.625C13.0312 10.8359 13.1602 11.125 13.1602 11.4453C13.1602 12.0859 12.6406 12.6055 12 12.6055C11.3594 12.6055 10.8398 12.0859 10.8398 11.4453C10.8398 11.125 10.9688 10.8359 11.1797 10.625L10.6875 10.1328C10.3516 10.4688 10.1445 10.9336 10.1445 11.4453C10.1445 12.4688 10.9766 13.3008 12 13.3008C13.0234 13.3008 13.8555 12.4688 13.8555 11.4453C13.8555 10.9336 13.6484 10.4688 13.3125 10.1328Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 10.75L12.1719 11.2812H12.7305L12.2812 11.6094L12.4531 12.1406L12 11.8125L11.5469 12.1406L11.7187 11.6094L11.2695 11.2812H11.8281L12 10.75Z",
      fill: "#FFDA44"
    }
  ))),
  peru: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  philippines: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.668H12L2 5H22Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668V18.332H2L12 11.668H22Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.32422 11.668L7.25781 11.1641L7.82812 10.1328L6.66797 10.3555L6.52344 9.18359L5.71484 10.043L4.91016 9.18359L4.76172 10.3555L3.60547 10.1328L4.17188 11.1641L3.10547 11.668L4.17188 12.168L3.60547 13.1992L4.76172 12.9805L4.91016 14.1484L5.71484 13.2891L6.52344 14.1484L6.66797 12.9805L7.82812 13.1992L7.25781 12.168L8.32422 11.668Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.85156 6.26172L3.20703 6.75781L3.78516 6.57422L3.42578 7.0625L3.78125 7.5586L3.20312 7.36719L2.83984 7.85547L2.84375 7.2461L2.26562 7.05469L2.84766 6.8711L2.85156 6.26172Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.85156 15.4766L3.20703 15.9727L3.78516 15.7891L3.42578 16.2773L3.78125 16.7734L3.20312 16.582L2.83984 17.0742L2.84375 16.4609L2.26562 16.2695L2.84766 16.0859L2.85156 15.4766Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.2188 10.8672L9.86328 11.3633L9.28125 11.1797L9.64453 11.6719L9.28906 12.168L9.86719 11.9727L10.2305 12.4648L10.2266 11.8555L10.8047 11.6641L10.2227 11.4766L10.2188 10.8672Z",
      fill: "#FFDA44"
    }
  ))),
  poland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H2V18.3359H22V11.668Z", fill: "#D80027" }))),
  portugal: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.67969 5V11.8828V18.332H2V5H9.67969Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.67969 14.168C11.0604 14.168 12.1797 13.0487 12.1797 11.668C12.1797 10.2873 11.0604 9.16797 9.67969 9.16797C8.29898 9.16797 7.17969 10.2873 7.17969 11.668C7.17969 13.0487 8.29898 14.168 9.67969 14.168Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.27344 10.418V11.9805C8.27344 12.7578 8.90234 13.3867 9.67969 13.3867C10.457 13.3867 11.0859 12.7578 11.0859 11.9805V10.418H8.27344Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.67969 12.4492C9.42188 12.4492 9.21094 12.2383 9.21094 11.9805V11.3555H10.1484V11.9805C10.1484 12.2383 9.94141 12.4492 9.67969 12.4492Z",
      fill: "#F0F0F0"
    }
  ))),
  "puerto rico": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.66797H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 10.332H2V13H22V10.332Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.668H2V18.3359H22V15.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668L2 18.332V5L12 11.668Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.26172 9.28906L5.85156 11.1055H7.76172L6.21484 12.2266L6.80469 14.043L5.26172 12.9219L3.71484 14.043L4.30469 12.2266L2.76172 11.1055H4.67188L5.26172 9.28906Z",
      fill: "#F0F0F0"
    }
  ))),
  qatar: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2.08594V18.2734H22V5Z", fill: "#751A46" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.1836 7.69141L8.21875 8.67969L10.1836 9.66406L8.21875 10.6523L10.1836 11.6367L8.21875 12.625L10.1836 13.6133L8.21875 14.5977L10.1836 15.5859L8.21875 16.5742L10.1836 17.5586L8.75781 18.2773H2V5H8.75391L10.1836 5.71875L8.21875 6.70312L10.1836 7.69141Z",
      fill: "#F0F0F0"
    }
  ))),
  reunion: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  romania: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  russia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M2 5V9.44531V13.8906V18.332H22V13.8906V9.44531V5H2Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }))),
  rwanda: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H2V14.8555H22V11.668Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.8555H2V18.3321H22V14.8555Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8711 8.90234L13.6836 9.28515L13.25 10.0742L14.1328 9.90234L14.2461 10.7969L14.8633 10.1406L15.4766 10.7969L15.5898 9.90234L16.4727 10.0742L16.0391 9.28515L16.8555 8.90234L16.0391 8.51953L16.4727 7.73047L15.5898 7.89844L15.4766 7.00781L14.8633 7.66406L14.2461 7.00781L14.1328 7.89844L13.25 7.73047L13.6836 8.51953L12.8711 8.90234Z",
      fill: "#FFDA44"
    }
  ))),
  "san marino": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.5117L2 11.6719V5H22Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6445 9.60156L12 12.2461L9.35547 9.60156C9.01172 10.1094 8.8125 10.7227 8.8125 11.3789V12.25C8.8125 13.6445 9.71484 14.8359 10.9648 15.2656C10.7969 15.5937 10.8242 16 11.0703 16.3086C11.3945 16.0469 11.7305 15.7773 12.0195 15.5508C12.3047 15.7812 12.6406 16.0508 12.9688 16.3086C13.2148 16 13.2422 15.5859 13.0703 15.2539C14.3047 14.8125 15.1914 13.6328 15.1914 12.25V11.3789C15.1875 10.7187 14.9883 10.1094 14.6445 9.60156Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 14.5664C10.7227 14.5664 9.67969 13.5273 9.67969 12.2461V11.375C9.67969 10.0977 10.7187 9.05469 12 9.05469C13.2812 9.05469 14.3203 10.0937 14.3203 11.375V12.2461C14.3203 13.5234 13.2773 14.5664 12 14.5664Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.4492 12.2461V11.375C13.4492 10.5742 12.8008 9.92578 12 9.92578C11.1992 9.92578 10.5508 10.5742 10.5508 11.375V12.2461L12 12.5352L13.4492 12.2461Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5508 12.2461C10.5508 13.0469 11.1992 13.6953 12 13.6953C12.8008 13.6953 13.4492 13.0469 13.4492 12.2461H10.5508Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.7383 9.05859C13.7383 8.57813 13.3477 8.1875 12.8672 8.1875C12.6445 8.1875 12.4414 8.26953 12.2891 8.41016V7.89844H12.5781V7.32031H12.2891V7.03125H11.7109V7.32031H11.4219V7.89844H11.7109V8.41016C11.5586 8.27344 11.3555 8.1875 11.1328 8.1875C10.6523 8.1875 10.2617 8.57813 10.2617 9.05859C10.2617 9.31641 10.375 9.54688 10.5508 9.70703V10.2188H13.4492V9.70703C13.6289 9.54688 13.7383 9.31641 13.7383 9.05859Z",
      fill: "#FFDA44"
    }
  ))),
  "sao tome & principe": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.33H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.80853H2V14.5214H22V8.80853Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V18.33L7 11.665", fill: "#D80027" }))),
  "saudi arabia": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.16797 12.9727C9.16797 13.4531 9.54687 13.8437 10.0156 13.8437H12.5625C12.5625 14.2422 12.8789 14.5703 13.2695 14.5703H14.1172C14.5078 14.5703 14.8242 14.2461 14.8242 13.8437V12.9727H9.16797Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9023 8.76953V10.7969C14.9023 11.1172 14.6484 11.375 14.3359 11.375V12.2461C15.1172 12.2461 15.75 11.5977 15.75 10.7969V8.76953H14.9023Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.81641 10.7969C8.81641 11.1172 8.5625 11.375 8.25 11.375V12.2461C9.03125 12.2461 9.66406 11.5977 9.66406 10.7969V8.76953H8.81641V10.7969Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.4766 8.76953H13.6289V10.7969H14.4766V8.76953Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.3555 9.92578C12.3555 10.0039 12.293 10.0703 12.2148 10.0703C12.1367 10.0703 12.0742 10.0039 12.0742 9.92578V8.76953H11.2266V9.92969C11.2266 10.0078 11.1641 10.0742 11.0859 10.0742C11.0078 10.0742 10.9453 10.0078 10.9453 9.92969V8.76953H10.0977V9.92969C10.0977 10.4883 10.543 10.9453 11.0898 10.9453C11.3008 10.9453 11.4961 10.8789 11.6562 10.7617C11.8164 10.875 12.0117 10.9453 12.2226 10.9453C12.2656 10.9453 12.3047 10.9414 12.3476 10.9375C12.2891 11.1914 12.0625 11.3789 11.7969 11.3789V12.25C12.5781 12.25 13.2109 11.6016 13.2109 10.8008V9.92969V8.76953H12.3633L12.3555 9.92578Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M11.3633 11.375H10.0898V12.2461H11.3633V11.375Z", fill: "#F0F0F0" }))),
  senegal: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H14.8984V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.10156 5H2V18.332H9.10156V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.34766L12.5742 11.1172H14.4375L12.9297 12.2148L13.5078 13.9844L12 12.8906L10.4922 13.9844L11.0703 12.2148L9.5625 11.1172H11.4258L12 9.34766Z",
      fill: "#496E2D"
    }
  ))),
  serbia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.05859 8.76953V12.0937C7.05859 13.9844 9.53125 14.5664 9.53125 14.5664C9.53125 14.5664 12 13.9844 12 12.0937V8.76953H7.05859Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.07812 9.34766H10.9766V8.1875L10.3984 8.47657L9.52734 7.60938L8.66016 8.47657L8.07812 8.1875V9.34766Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.4219 12.5586L9.53516 10.6719L7.65234 12.5586L8.26562 13.1719L9.53516 11.9023L10.8047 13.1719L11.4219 12.5586Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.4219 10.7969H10.543C10.5938 10.7109 10.6211 10.6133 10.6211 10.5078C10.6211 10.1875 10.3633 9.92969 10.043 9.92969C9.82031 9.92969 9.62891 10.0547 9.53125 10.2344C9.43359 10.0508 9.24219 9.92969 9.01953 9.92969C8.69922 9.92969 8.44141 10.1875 8.44141 10.5078C8.44141 10.6133 8.46875 10.7109 8.51953 10.7969H7.65625C7.65625 11.1172 7.93359 11.375 8.25391 11.375H8.23438C8.23438 11.6953 8.49219 11.9531 8.8125 11.9531C8.8125 12.2383 9.01562 12.4727 9.28516 12.5235L8.82813 13.5547C9.04688 13.6446 9.28516 13.6914 9.53516 13.6914C9.78516 13.6914 10.0234 13.6406 10.2422 13.5547L9.78516 12.5235C10.0547 12.4727 10.2578 12.2383 10.2578 11.9531C10.5781 11.9531 10.8359 11.6953 10.8359 11.375H10.8164C11.1406 11.375 11.4219 11.1172 11.4219 10.7969Z",
      fill: "#F0F0F0"
    }
  ))),
  seychelles: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M11.1992 5L2 18.332L18.6914 5H11.1992Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.5352L2 18.332H22V14.5352Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H18.6914L2 18.332L22 10.3438V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V18.332L11.1992 5H2Z", fill: "#0052B4" }))),
  "sierra leone": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#338AF3" }))),
  singapore: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.26172 8.33203C5.26172 7.35938 5.94532 6.55078 6.85547 6.35156C6.71485 6.32031 6.57032 6.30469 6.42188 6.30469C5.30078 6.30469 4.39453 7.21484 4.39453 8.33203C4.39453 9.44922 5.30469 10.3594 6.42188 10.3594C6.57032 10.3594 6.71485 10.3438 6.85547 10.3125C5.94532 10.1172 5.26172 9.30469 5.26172 8.33203Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.87109 6.44922L8.01172 6.89063H8.48047L8.10156 7.16406L8.24609 7.60938L7.87109 7.33594L7.49219 7.60938L7.63672 7.16406L7.26172 6.89063H7.72656L7.87109 6.44922Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.73828 7.32031L6.88281 7.76172H7.34766L6.97266 8.03516L7.11719 8.47656L6.73828 8.20312L6.36328 8.47656L6.50781 8.03516L6.12891 7.76172H6.59766L6.73828 7.32031Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 7.32031L9.14453 7.76172H9.60938L9.23047 8.03516L9.375 8.47656L9 8.20312L8.62109 8.47656L8.76562 8.03516L8.39062 7.76172H8.85547L9 7.32031Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.5625 8.625L8.70703 9.06641H9.17578L8.79688 9.33984L8.94141 9.78125L8.5625 9.50781L8.1875 9.78125L8.33203 9.33984L7.95312 9.06641H8.42187L8.5625 8.625Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.17578 8.625L7.32031 9.06641H7.78515L7.40624 9.33984L7.55078 9.78125L7.17578 9.50781L6.79687 9.78125L6.9414 9.33984L6.56641 9.06641H7.03125L7.17578 8.625Z",
      fill: "#F0F0F0"
    }
  ))),
  "slovak republic": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.34766H2V13.9844H22V9.34766Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.9844H2V18.332H22V13.9844Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.05859 8.76953V12.0938C7.05859 13.9844 9.53125 14.5664 9.53125 14.5664C9.53125 14.5664 12 13.9844 12 12.0938V8.76953H7.05859Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.70703 8.86719V12.0664C7.70703 12.2812 7.75391 12.4805 7.84766 12.6719C8.78125 12.6719 10.1758 12.6719 11.207 12.6719C11.3008 12.4844 11.3477 12.2812 11.3477 12.0664V8.86719H7.70703Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.6445 11.0976H9.80859V10.5391H10.3672V9.98046H9.80859V9.42188H9.25V9.98046H8.69141V10.5391H9.25V11.0976H8.41406V11.6562H9.25V12.2148H9.80859V11.6562H10.6445V11.0976Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.60938 13.4492C8.96875 13.6758 9.33984 13.8047 9.52734 13.8633C9.71484 13.8047 10.0859 13.6719 10.4453 13.4492C10.8086 13.2226 11.0625 12.9609 11.207 12.6719C11.0469 12.5586 10.8555 12.4922 10.6445 12.4922C10.5664 12.4922 10.4922 12.5 10.4219 12.5195C10.2695 12.1758 9.92578 11.9375 9.52734 11.9375C9.12891 11.9375 8.78516 12.1758 8.63281 12.5195C8.5625 12.5039 8.48828 12.4922 8.41016 12.4922C8.19922 12.4922 8.00781 12.5586 7.84766 12.6719C7.99219 12.9609 8.24609 13.2226 8.60938 13.4492Z",
      fill: "#0052B4"
    }
  ))),
  slovenia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.44531H2V13.8906H22V9.44531Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.125 9.34766V9.92578C11.125 11.2578 9.38672 11.6641 9.38672 11.6641C9.38672 11.6641 7.64844 11.2578 7.64844 9.92578V9.34766L7.64453 7.62109L11.1211 7.60938L11.125 9.34766Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.125 9.34766V9.92578C11.125 11.2578 9.38672 11.6641 9.38672 11.6641C9.38672 11.6641 7.64844 11.2578 7.64844 9.92578V9.34766L7.64453 7.62109L11.1211 7.60938L11.125 9.34766Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.125 9.34766V9.92578C11.125 11.2578 9.38672 11.6641 9.38672 11.6641C9.38672 11.6641 7.64844 11.2578 7.64844 9.92578V9.34766L8.22656 9.92578L9.38672 9.05469L10.5469 9.92578L11.125 9.34766Z",
      fill: "#F0F0F0"
    }
  ))),
  "solomon islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332V5H22", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M2 17.1562V18.332H3.76953L22 6.17969V5H20.2305L2 17.1562Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.34766 5.91797L5.54688 6.53125H6.19531L5.67188 6.91406L5.87109 7.52734L5.34766 7.14844L4.82422 7.52734L5.02344 6.91406L4.5 6.53125H5.14844L5.34766 5.91797Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.65234 5.91797L8.85156 6.53125H9.5L8.97656 6.91406L9.17578 7.52734L8.65234 7.14844L8.12891 7.52734L8.32812 6.91406L7.80469 6.53125H8.45312L8.65234 5.91797Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.34766 9.14062L5.54688 9.75391H6.19531L5.67188 10.1367L5.87109 10.75L5.34766 10.3711L4.82422 10.75L5.02344 10.1367L4.5 9.75391H5.14844L5.34766 9.14062Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.65234 9.14062L8.85156 9.75391H9.5L8.97656 10.1367L9.17578 10.75L8.65234 10.3711L8.12891 10.75L8.32812 10.1367L7.80469 9.75391H8.45312L8.65234 9.14062Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 7.52734L7.19922 8.14453H7.84766L7.32422 8.52344L7.52344 9.14062L7 8.75781L6.47656 9.14062L6.67578 8.52344L6.15234 8.14453H6.80078L7 7.52734Z",
      fill: "#F0F0F0"
    }
  ))),
  somalia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.80859L12.8867 10.5352H15.75L13.4336 12.2188L14.3164 14.9414L12 13.2578L9.68359 14.9414L10.5664 12.2188L8.25 10.5352H11.1133L12 7.80859Z",
      fill: "#F0F0F0"
    }
  ))),
  "south africa": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M6.45312 11.668L2 7.21094V16.125L6.45312 11.668Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.29688 11.668L2 5.36719V7.21094L6.45312 11.668L2 16.125V17.9649L8.29688 11.668Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.9141 12.9727C21.918 12.957 21.9453 12.9375 22 12.9219V11.668V10.3633H21.9141H10.6953L5.33203 5H2V5.36719L8.29688 11.668L2 17.9648V18.332H5.33203L10.6953 12.9688H21.9141V12.9727Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M21.6562 14.2734H11.2344L7.17969 18.332H22V14.2734H21.6562Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M21.6562 9.05859H22V5H7.17969L11.2344 9.05859H21.6562Z", fill: "#D80027" }))),
  spain: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#D80027" }))),
  "sri lanka": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 5V18.332H22V5H2ZM21.1289 17.4648H10.6953V5.87109H21.1289V17.4648Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M21.1289 5.87109H10.6953V17.4648H21.1289V5.87109Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M10.6953 5.87109H2.87109V17.4648H10.6953V5.87109Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M10.6953 5H9.82422V18.332H10.6953V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M6.34766 5.87109H2.87109V17.4648H6.34766V5.87109Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82422 5.87109H6.34766V17.4648H9.82422V5.87109Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.0117 11.4492V9.71094C16.0117 9.42188 15.5781 9.13281 15.5781 9.13281C15.5781 9.13281 15.1445 9.42188 15.1445 9.71094H13.4063V11.4492H14.2773V12.3203C14.2773 12.5117 14.3164 12.6914 14.3867 12.8594L13.9883 13.1914H12.8281V7.82422C12.3477 7.82422 11.957 8.21484 11.957 8.69531V12.4648C11.957 12.7227 12.0703 12.9531 12.2461 13.1133V14.4922H12.8242V13.7656H15.4336V14.9258H14.8516V15.5078H16.0117V14.3477L16.543 13.7695H18.2734V14.9297H17.6953V15.5078H18.8555V14.3477L19.3867 13.7695L19.8789 12.1953L19.4492 11.4492H17.9297C17.3672 11.4453 16.332 11.4531 16.0117 11.4492Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.4766 9.94141V10.9258H19.2695V11.4492H19.4414V10.7539H16.6484V10.1172H19.6172V9.94141H16.4766Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M11.5664 5.87109H10.6953V6.74219H11.5664V5.87109Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M21.1328 5.87109H20.2617V6.74219H21.1328V5.87109Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M11.5664 16.5938H10.6953V17.4649H11.5664V16.5938Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M21.1328 16.5938H20.2617V17.4649H21.1328V16.5938Z", fill: "#FFDA44" }))),
  "st. helena": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7773V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15 9.78125V12.1016C15 13.6562 17.0273 14.1289 17.0273 14.1289C17.0273 14.1289 19.0547 13.6523 19.0547 12.1016V9.78125L18.1243 9.51593C17.4073 9.31147 16.6474 9.31147 15.9304 9.51593L15 9.78125Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15 9.82481V11.1451H17.0273H19.0547V9.82481L18.1243 9.55949C17.4073 9.35503 16.6474 9.35503 15.9304 9.55949L15 9.82481Z",
      fill: "#FFDA44"
    }
  ))),
  "st. kitts": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332V5H22", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M23 7.61328L22 5L18.082 4L2 14.7188V18.332H6.91797L23 7.61328Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5L23 6.56641L5.35156 18.332H2V15.7656L19.6484 4L22 5Z", fill: "#16161A" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.77804 12.4962L8.64841 13.1521L9.54113 12.527L9.18632 13.5574L10.0567 14.2133L8.96704 14.1943L8.61223 15.2247L8.2936 14.1825L7.20395 14.1635L8.09668 13.5384L7.77804 12.4962Z",
      fill: "white"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.2287 8.13964L15.0991 8.7955L15.9918 8.17041L15.637 9.20085L16.5074 9.85672L15.4177 9.8377L15.0629 10.8681L14.7443 9.82594L13.6546 9.80692L14.5474 9.18183L14.2287 8.13964Z",
      fill: "white"
    }
  ))),
  "st. lucia": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M9.53516 13.9844H14.4648L12 8.1875L9.53516 13.9844Z", fill: "#F3F3F3" }), /* @__PURE__ */ e.createElement("path", { d: "M10.3906 13.4063L12 9.75L13.6094 13.4063H10.3906Z", fill: "#333333" }), /* @__PURE__ */ e.createElement("path", { d: "M9.53516 13.9844H14.4648L12 11.668L9.53516 13.9844Z", fill: "#FFDA44" }))),
  sudan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M2 18.332V5L12 11.668L2 18.332Z", fill: "#496E2D" }))),
  suriname: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.34766H2V13.9844H22V9.34766Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.4336H2V18.332H22V15.4336Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.89844H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.0273 10.1836L12.3984 11.3164H13.5898L12.625 12.0156L12.9922 13.1524L12.0273 12.4492L11.0664 13.1524L11.4336 12.0156L10.4688 11.3164H11.6602L12.0273 10.1836Z",
      fill: "#FFDA44"
    }
  ))),
  swaziland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.335H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V8.54004H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.7949H2V18.335H22V14.7949Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.42383H2V13.9063H22V9.42383Z", fill: "#A2001D" }), /* @__PURE__ */ e.createElement("path", { d: "M16.3506 11.377H7.6543V11.958H16.3506V11.377Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M15.1885 10.2197H8.81152V10.8008H15.1885V10.2197Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.2275 11.665C15.2275 11.665 13.7383 13.4033 12 13.4033C10.2617 13.4033 10.2617 11.665 10.2617 11.665C10.2617 11.665 10.2617 9.92676 12 9.92676C13.7383 9.92676 15.2275 11.665 15.2275 11.665Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.4033C10.2617 13.4033 8.77246 11.665 8.77246 11.665C8.77246 11.665 10.2617 9.92676 12 9.92676",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M11.4238 11.0889H10.8428V12.2461H11.4238V11.0889Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M13.1621 11.0889H12.5811V12.2461H13.1621V11.0889Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.23048 11.665C8.23048 11.9873 7.97169 12.2461 7.64942 12.2461C7.32715 12.2461 7.06836 11.9873 7.06836 11.665C7.06836 11.3428 7.32715 11.084 7.64942 11.084C7.97169 11.0889 8.23048 11.3477 8.23048 11.665Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.9268 11.665C16.9268 11.9873 16.668 12.2461 16.3457 12.2461C16.0234 12.2461 15.7646 11.9873 15.7646 11.665C15.7646 11.3428 16.0234 11.084 16.3457 11.084C16.668 11.0889 16.9268 11.3477 16.9268 11.665Z",
      fill: "#0052B4"
    }
  ))),
  sweden: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M9.5 5H7V10.418H2V12.918H7V18.332H9.5V12.918H22V10.418H9.5V5Z", fill: "#FFDA44" }))),
  switzerland: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.914 10.3633H13.3047V7.75391H10.6953V10.3633H8.08594V12.9727H10.6953V15.5781H13.3047V12.9727H15.914V10.3633Z",
      fill: "#F0F0F0"
    }
  ))),
  syria: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.31641 10.0742L9.67578 11.1797H10.8398L9.89844 11.8633L10.2578 12.9727L9.31641 12.2852L8.375 12.9727L8.73437 11.8633L7.79297 11.1797H8.95703L9.31641 10.0742Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.6836 10.0742L15.043 11.1797H16.207L15.2656 11.8633L15.625 12.9727L14.6836 12.2852L13.7422 12.9727L14.1016 11.8633L13.1602 11.1797H14.3242L14.6836 10.0742Z",
      fill: "#6DA544"
    }
  ))),
  taiwan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.28126 8.33203L8.35157 8.77344L8.84766 9.67578L7.83204 9.48047L7.70704 10.5039L7 9.75391L6.29297 10.5039L6.16797 9.48047L5.15234 9.67578L5.64844 8.77344L4.71875 8.33203L5.64844 7.89453L5.15234 6.99219L6.16797 7.18359L6.29297 6.16016L7 6.91406L7.70704 6.16016L7.83204 7.18359L8.84766 6.99219L8.35157 7.89453L9.28126 8.33203Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 9.46484C7.62564 9.46484 8.13281 8.95766 8.13281 8.33203C8.13281 7.70639 7.62564 7.19922 7 7.19922C6.37436 7.19922 5.86719 7.70639 5.86719 8.33203C5.86719 8.95766 6.37436 9.46484 7 9.46484Z",
      fill: "#0052B4"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7 9.08984C6.58203 9.08984 6.24219 8.75 6.24219 8.33203C6.24219 7.91406 6.58203 7.57422 7 7.57422C7.41797 7.57422 7.75782 7.91406 7.75782 8.33203C7.75782 8.75 7.41797 9.08984 7 9.08984Z",
      fill: "#F0F0F0"
    }
  ))),
  tajikistan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.8398 13.4062H13.1601V12.4219L12.6953 12.6523L12 11.957L11.3047 12.6523L10.8398 12.4219V13.4062Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.51562 12.2461L9.62109 12.5781H9.97266L9.6875 12.7852L9.79688 13.1172L9.51562 12.9102L9.23047 13.1172L9.33984 12.7852L9.05859 12.5781H9.40625L9.51562 12.2461Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.84766 11.086L9.95703 11.418H10.3047L10.0234 11.625L10.1328 11.957L9.84766 11.75L9.56641 11.957L9.67187 11.625L9.39062 11.418H9.74219L9.84766 11.086Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.8047 10.2188L10.9141 10.5508H11.2617L10.9805 10.7539L11.0859 11.0859L10.8047 10.8828L10.5234 11.0859L10.6289 10.7539L10.3477 10.5508H10.6953L10.8047 10.2188Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.4844 12.2461L14.3789 12.5781H14.0273L14.3125 12.7852L14.2031 13.1172L14.4844 12.9102L14.7695 13.1172L14.6602 12.7852L14.9414 12.5781H14.5938L14.4844 12.2461Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.1523 11.086L14.043 11.418H13.6953L13.9766 11.625L13.8672 11.957L14.1523 11.75L14.4336 11.957L14.3242 11.625L14.6094 11.418H14.2578L14.1523 11.086Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.1953 10.2188L13.0859 10.5508H12.7383L13.0195 10.7539L12.9141 11.0859L13.1953 10.8828L13.4766 11.0859L13.3711 10.7539L13.6523 10.5508H13.3047L13.1953 10.2188Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 9.78125L12.1094 10.1133H12.457L12.1758 10.3203L12.2812 10.6523L12 10.4453L11.7187 10.6523L11.8242 10.3203L11.543 10.1133H11.8906L12 9.78125Z",
      fill: "#FFDA44"
    }
  ))),
  thailand: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.333H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.24707H2V14.0859H22V9.24707Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.12988H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.2031H2V18.333H22V16.2031Z", fill: "#D80027" }))),
  togo: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V7.66797H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 15.668H2V18.3359H22V15.668Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M22 10.332H2V13H22V10.332Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement("path", { d: "M9.97266 5H2V12.9727H9.97266V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.98438 6.89844L6.50391 8.49219H8.17969L6.82422 9.47656L7.33985 11.0742L5.98438 10.0859L4.62891 11.0742L5.14844 9.47656L3.79297 8.49219H5.46875L5.98438 6.89844Z",
      fill: "#F0F0F0"
    }
  ))),
  tonga: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.668H12V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.52343 7.8125V6.76953H6.47656V7.8125H5.43359V8.85547H6.47656V9.89844H7.52343V8.85547H8.5664V7.8125H7.52343Z",
      fill: "#D80027"
    }
  ))),
  "trinidad & tobago": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.23828 5L10.3594 13.3047L15.5 18.332H21.7617L13.6406 10.0273L8.5 5H2.23828Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M3.69531 5L17.0273 18.332H20.3047L6.97266 5H3.69531Z", fill: "black" }))),
  tunisia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 15.418C14.0711 15.418 15.75 13.739 15.75 11.668C15.75 9.5969 14.0711 7.91797 12 7.91797C9.92893 7.91797 8.25 9.5969 8.25 11.668C8.25 13.739 9.92893 15.418 12 15.418Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.4609 10.2344L13.1055 11.1211L14.1484 10.7813L13.5039 11.668L14.1445 12.5547L13.1055 12.2149L12.4609 13.1016V12.0039L11.418 11.6641L12.4609 11.3281V10.2344Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8516 13.8828C11.6289 13.8828 10.6367 12.8906 10.6367 11.668C10.6367 10.4453 11.6289 9.45312 12.8516 9.45312C13.2344 9.45312 13.5938 9.55078 13.9063 9.71875C13.4141 9.23828 12.7422 8.94141 12 8.94141C10.4922 8.94141 9.27344 10.1641 9.27344 11.668C9.27344 13.1719 10.4961 14.3945 12 14.3945C12.7422 14.3945 13.4141 14.0977 13.9063 13.6172C13.5938 13.7852 13.2344 13.8828 12.8516 13.8828Z",
      fill: "#D80027"
    }
  ))),
  turkey: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.6563 10.1367L12.3438 11.082L13.457 10.7227L12.7695 11.668L13.457 12.6133L12.3438 12.2539L11.6563 13.1992V12.0274L10.543 11.6641L11.6563 11.3047V10.1367Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.78125 14.0352C8.47266 14.0352 7.41406 12.9766 7.41406 11.668C7.41406 10.3594 8.47266 9.30078 9.78125 9.30078C10.1875 9.30078 10.5742 9.40235 10.9062 9.58594C10.3828 9.07031 9.66406 8.75391 8.87109 8.75391C7.26172 8.75391 5.95703 10.0586 5.95703 11.668C5.95703 13.2774 7.26172 14.582 8.87109 14.582C9.66406 14.582 10.3828 14.2656 10.9062 13.75C10.5742 13.9297 10.1875 14.0352 9.78125 14.0352Z",
      fill: "#F0F0F0"
    }
  ))),
  turkmenistan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.9531 8.83984C16.2813 7.92578 15.9141 6.92969 15.1211 6.4375C15.2617 6.45703 15.4063 6.48828 15.5469 6.53906C16.6016 6.91797 17.1485 8.07812 16.7735 9.13281C16.3984 10.1875 15.2344 10.7344 14.1797 10.3555C14.0391 10.3047 13.9063 10.2422 13.7852 10.1641C14.707 10.2891 15.625 9.75391 15.9531 8.83984Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.1328 6.1875L13.8477 6.55469L13.4102 6.39844L13.6719 6.78125L13.3867 7.15235L13.8359 7.01953L14.0977 7.40625L14.1133 6.94141L14.5586 6.80859L14.1211 6.65234L14.1328 6.1875Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9023 7.38672L14.6172 7.75391L14.1797 7.59766L14.4414 7.98438L14.1562 8.35156L14.6055 8.22266L14.8672 8.60547L14.8828 8.14063L15.3281 8.00781L14.8906 7.85156L14.9023 7.38672Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7773 6.625L12.4922 6.99219L12.0547 6.83594L12.3164 7.21875L12.0312 7.58984L12.4766 7.45703L12.7422 7.84375L12.7539 7.37891L13.2031 7.24609L12.7617 7.08984L12.7773 6.625Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.7461 8L12.4609 8.36719L12.0234 8.21094L12.2852 8.59375L12 8.96094L12.4453 8.83203L12.7109 9.21875L12.7227 8.75L13.1719 8.62109L12.7305 8.46484L12.7461 8Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.0547 8.46875L13.7695 8.83593L13.332 8.67968L13.5937 9.06249L13.3086 9.43358L13.7539 9.30077L14.0156 9.68749L14.0313 9.22265L14.4766 9.08984L14.0391 8.93359L14.0547 8.46875Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.73828 5H5.26172V18.332H8.73828V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.58985 8.51173L6.00781 8.07422V7.46094L6.58985 7.02734H7.41016L7.99219 7.46094V8.07422L7.41016 8.51173H6.58985Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.00001 7.02734H6.58985L6.00781 7.46094V7.76172H7.00001V7.02734Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M7 8.51172H7.41016L7.99219 8.07422V7.76172H7V8.51172Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.58985 16.3047L6.00781 15.8711V15.2578L6.58985 14.8242H7.41016L7.99219 15.2578V15.8711L7.41016 16.3047H6.58985Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.00001 14.8242H6.58985L6.00781 15.2578V15.5586H7.00001V14.8242Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M7 16.3047H7.41016L7.99219 15.8711V15.5586H7V16.3047Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.58985 12.4063L6.00781 11.9727V11.3594L6.58985 10.9258H7.41016L7.99219 11.3594V11.9727L7.41016 12.4063H6.58985Z",
      fill: "#496E2D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.01562 13.3633H7.76172V13.1094H7.31641L7 12.793L6.68359 13.1094H6.23828V13.3633H5.98438V13.8672H6.23828V14.1211H6.68359L7 14.4375L7.31641 14.1211H7.76172V13.8672H8.01562V13.3633Z",
      fill: "#496E2D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.01562 9.46484H7.76172V9.21094H7.31641L7 8.89453L6.68359 9.21094H6.23828V9.46484H5.98438V9.97266H6.23828V10.2266H6.68359L7 10.5391L7.31641 10.2266H7.76172V9.97266H8.01562V9.46484Z",
      fill: "#496E2D"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M7.28956 11.375H6.71143V11.9531H7.28956V11.375Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.00049 10.0078C7.16014 10.0078 7.28956 9.8784 7.28956 9.71875C7.28956 9.55911 7.16014 9.42969 7.00049 9.42969C6.84085 9.42969 6.71143 9.55911 6.71143 9.71875C6.71143 9.8784 6.84085 10.0078 7.00049 10.0078Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.28662 13.6355C7.29794 13.4763 7.17802 13.338 7.01877 13.3267C6.85953 13.3154 6.72126 13.4353 6.70994 13.5945C6.69863 13.7538 6.81855 13.892 6.97779 13.9033C7.13704 13.9147 7.2753 13.7947 7.28662 13.6355Z",
      fill: "#D80027"
    }
  ))),
  "turks & caicos islands": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 9.16797V12.2227C14.9727 13.7109 17 14.168 17 14.168C17 14.168 19.0273 13.7109 19.0273 12.2227V9.16797H14.9727Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.7109 10.2773C16.7109 10.5859 16.4531 11.3867 16.1328 11.3867C15.8125 11.3867 15.5547 10.582 15.5547 10.2773C15.5547 9.97266 16.1328 9.72266 16.1328 9.72266C16.1328 9.72266 16.7109 9.97266 16.7109 10.2773Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.25 10.8828C18.3438 10.6641 18.418 10.3437 18.418 10.1836C18.418 9.92969 18.0703 9.71875 18.0703 9.71875C18.0703 9.71875 17.7227 9.92578 17.7227 10.1836C17.7227 10.3437 17.7969 10.6641 17.8906 10.8828L17.6914 11.3164C17.8086 11.3633 17.9375 11.3867 18.0742 11.3867C18.2109 11.3867 18.3398 11.3594 18.457 11.3164L18.25 10.8828Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.5664 12.2226C16.5664 12.2226 16.2773 12.7773 16.2773 13.332C16.2773 13.332 17.1484 13.332 17.7266 13.332C17.7266 12.7773 17.4375 12.2226 17.4375 12.2226L17.0039 11.9453L16.5664 12.2226Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.4336 12.2227V12.082C17.4336 11.8516 17.2383 11.6641 17 11.6641C16.7617 11.6641 16.5664 11.8516 16.5664 12.082V12.2227H17.4336Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7734V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }))),
  tuvalu: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#009CDE" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V11.65H12V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V6.19531L10.2344 7.17578H12V9.49219H9.69141L12 10.7734V11.668H10.957L8.08594 10.0703V11.668H5.91406V9.76953L2.49609 11.668H2V10.4727L3.76562 9.49219H2V7.17578H4.30859L2 5.89062V5H3.04297L5.91406 6.59375V5H8.08594V6.89844L11.5039 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.08594 9.49219L12 11.668V11.0508L9.19531 9.49219H8.08594Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M4.80469 9.49219L2 11.0508V11.668L5.91406 9.49219H4.80469Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M5.91406 7.17578L2 5V5.61328L4.80469 7.17578H5.91406Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M9.19531 7.17578L12 5.61328V5L8.08594 7.17578H9.19531Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8585 15.533L13.3431 17.0264L12.0723 16.1033H13.6431L12.3723 17.0264L12.8585 15.533Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.6951 15.0896L15.2105 16.583L14.7243 15.0896L15.9951 16.0127H14.4243L15.6951 15.0896Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.6951 13.0788L15.2105 14.5721L14.7243 13.0788L15.9951 14.0018H14.4243L15.6951 13.0788Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.7718 14.582L17.2872 16.0753L16.801 14.582L18.0718 15.505H16.501L17.7718 14.582Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.7718 10.2075L17.2872 11.7008L16.801 10.2075L18.0718 11.1305H16.501L17.7718 10.2075Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18.6455 13.0458L19.1301 14.5391L17.8594 13.6161H19.43L18.1593 14.5391L18.6455 13.0458Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.5173 9.61084L19.0327 11.1042L18.548 9.61084L19.8189 10.5339H18.248L19.5173 9.61084Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.3995 11.9168L20.8841 13.4101L19.6133 12.4871H21.1841L19.9133 13.4101L20.3995 11.9168Z",
      fill: "#FEDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.3995 8.05818L20.8841 9.55151L19.6133 8.62848H21.1841L19.9133 9.55151L20.3995 8.05818Z",
      fill: "#FEDD00"
    }
  ))),
  "united states": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.33", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.3335H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.6665H2V8.33301H22V6.6665Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 10H2V11.6665H22V10Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.333H2V14.9995H22V13.333Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.6665H2V18.333H22V16.6665Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V12.1797H12V5Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.89941 7.94092L5.73828 8.43652H5.21729L5.63867 8.74268L5.47754 9.23828L5.89893 8.93213L6.31982 9.23828L6.15869 8.74268L6.58008 8.43652H6.06006L5.89941 7.94092Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.06006 10.2246L5.89941 9.729L5.73828 10.2246H5.21729L5.63867 10.5308L5.47754 11.0259L5.89893 10.7197L6.31982 11.0259L6.15869 10.5308L6.58008 10.2246H6.06006Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.8584 10.2246L3.69775 9.729L3.53662 10.2246H3.01562L3.43701 10.5308L3.27588 11.0259L3.69727 10.7197L4.11816 11.0259L3.95703 10.5308L4.37842 10.2246H3.8584Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.69775 7.94092L3.53662 8.43652H3.01562L3.43701 8.74268L3.27588 9.23828L3.69727 8.93213L4.11816 9.23828L3.95703 8.74268L4.37842 8.43652H3.8584L3.69775 7.94092Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M5.89941 6.15283L5.73828 6.64844H5.21729L5.63867 6.95459L5.47754 7.4502L5.89893 7.14404L6.31982 7.4502L6.15869 6.95459L6.58008 6.64844H6.06006L5.89941 6.15283Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.69775 6.15283L3.53662 6.64844H3.01562L3.43701 6.95459L3.27588 7.4502L3.69727 7.14404L4.11816 7.4502L3.95703 6.95459L4.37842 6.64844H3.8584L3.69775 6.15283Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.10059 7.94092L7.93945 8.43652H7.41846L7.83984 8.74268L7.67871 9.23828L8.1001 8.93213L8.52148 9.23828L8.36035 8.74268L8.78174 8.43652H8.26074L8.10059 7.94092Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.26172 10.2246L8.10059 9.729L7.93945 10.2246H7.41846L7.83984 10.5308L7.67871 11.0259L8.1001 10.7197L8.52148 11.0259L8.36035 10.5308L8.78174 10.2246H8.26172Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.4634 10.2246L10.3022 9.729L10.1411 10.2246H9.62012L10.0415 10.5308L9.88037 11.0259L10.3018 10.7197L10.7231 11.0259L10.562 10.5308L10.9844 10.2246H10.4634Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.3022 7.94092L10.1411 8.43652H9.62012L10.0415 8.74268L9.88037 9.23828L10.3018 8.93213L10.7231 9.23828L10.562 8.74268L10.9834 8.43652H10.4624L10.3022 7.94092Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.10059 6.15283L7.93945 6.64844H7.41846L7.83984 6.95459L7.67871 7.4502L8.1001 7.14404L8.52148 7.4502L8.36035 6.95459L8.78174 6.64844H8.26074L8.10059 6.15283Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.3022 6.15283L10.1411 6.64844H9.62012L10.0415 6.95459L9.88037 7.4502L10.3018 7.14404L10.7231 7.4502L10.562 6.95459L10.9834 6.64844H10.4624L10.3022 6.15283Z",
      fill: "#F0F0F0"
    }
  ))),
  uk: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.25 5H10.75V10.418H2V12.918H10.75V18.332H13.25V12.918H22V10.418H13.25V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M17.3828 13.9844L22 16.5508V13.9844H17.3828Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M14.1758 13.9844L22 18.332V17.1055L16.3867 13.9844H14.1758Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M19.9141 18.332L14.1758 15.1445V18.332H19.9141Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M14.1758 13.9844L22 18.332V17.1055L16.3867 13.9844H14.1758Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M14.1758 13.9844L22 18.332V17.1055L16.3867 13.9844H14.1758Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M5.52734 13.9844L2 15.9453V13.9844H5.52734Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82422 14.539V18.332H2.99609L9.82422 14.539Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M7.61328 13.9844L2 17.1055V18.332L9.82422 13.9844H7.61328Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M6.61719 9.34766L2 6.78125V9.34766H6.61719Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82422 9.34766L2 5V6.23047L7.61328 9.34766H9.82422Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M4.08594 5L9.82422 8.19141V5H4.08594Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82422 9.34766L2 5V6.23047L7.61328 9.34766H9.82422Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M9.82422 9.34766L2 5V6.23047L7.61328 9.34766H9.82422Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M18.4727 9.34766L22 7.38672V9.34766H18.4727Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M14.1758 8.79688V5H21.0039L14.1758 8.79688Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M16.3867 9.34766L22 6.23047V5L14.1758 9.34766H16.3867Z", fill: "#D80027" }))),
  uganda: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 7.22266H2V9.44531H22V7.22266Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.44531H2V11.668H22V9.44531Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V16.1133H22V13.8906Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.1094H2V18.332H22V16.1094Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 13.8945C13.2297 13.8945 14.2266 12.8977 14.2266 11.668C14.2266 10.4383 13.2297 9.44141 12 9.44141C10.7703 9.44141 9.77344 10.4383 9.77344 11.668C9.77344 12.8977 10.7703 13.8945 12 13.8945Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8164 11.7813L12 11.4297C12 11.4297 12.1914 10.7969 12.1992 10.7539C12.207 10.7227 12.2109 10.6875 12.2109 10.6563C12.2109 10.5352 12.1641 10.4258 12.082 10.3477L12.2852 10.1445C12.1523 10.0117 11.9727 9.93359 11.7734 9.93359C11.5742 9.93359 11.3906 10.0156 11.2617 10.1445L11.4648 10.3477C11.3867 10.4258 11.3359 10.5352 11.3359 10.6563C11.3359 10.6992 11.3438 10.7422 11.3555 10.7813L11.0469 11.0898H11.6094C11.6094 11.0898 11.3789 11.4375 11.25 11.7227C11.125 12.0078 11.25 12.3594 11.543 12.4883L11.7109 12.5625L11.9922 12.8281V13.1172L11.7031 13.4063H12.2813V12.8281L12.5469 12.5625H13.0938C13.0977 12.5586 13.0977 12.5508 13.1016 12.5469C13.2383 12.2539 13.1094 11.9102 12.8164 11.7813Z",
      fill: "black"
    }
  ))),
  ukraine: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V11.668H22V5Z", fill: "#338AF3" }))),
  "united arab emirates": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#A2001D" }))),
  uruguay: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V6.90625H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.80859H2V10.7148H22V8.80859Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 12.6172H2V14.5234H22V12.6172Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.4297H2V18.3359H22V16.4297Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5H2V12.6172H12V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.5 8.80859L8.47656 9.28906L9.02344 10.2773L7.91406 10.0664L7.77344 11.1875L7 10.3633L6.22656 11.1875L6.08594 10.0664L4.97656 10.2773L5.52344 9.28906L4.5 8.80859L5.52344 8.32812L4.97656 7.33984L6.08594 7.55078L6.22656 6.42969L7 7.25391L7.77344 6.42969L7.91406 7.55078L9.02344 7.33984L8.47656 8.32812L9.5 8.80859Z",
      fill: "#FFDA44"
    }
  ))),
  uzbekistan: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.2734H2V18.332H22V14.2734Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.08203H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement("path", { d: "M22 9.90234H2V13.4062H22V9.90234Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.08203H22V5Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.37109 7.04297C9.37109 6.41797 9.80859 5.89844 10.3945 5.76953C10.3047 5.75 10.2109 5.73828 10.1133 5.73828C9.39453 5.73828 8.80859 6.32031 8.80859 7.04297C8.80859 7.76562 9.39062 8.34765 10.1133 8.34765C10.2109 8.34765 10.3047 8.33593 10.3945 8.3164C9.80859 8.18749 9.37109 7.66406 9.37109 7.04297Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.168 7.63281L11.2539 7.90625H11.5391L11.3086 8.07422L11.3984 8.34375L11.168 8.17578L10.9336 8.34375L11.0234 8.07422L10.793 7.90625H11.0781L11.168 7.63281Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.0781 7.63281L12.168 7.90625H12.4531L12.2227 8.07422L12.3086 8.34375L12.0781 8.17578L11.8477 8.34375L11.9336 8.07422L11.7031 7.90625H11.9883L12.0781 7.63281Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9922 7.63281L13.0781 7.90625H13.3633L13.1328 8.07422L13.2227 8.34375L12.9922 8.17578L12.7578 8.34375L12.8477 8.07422L12.6172 7.90625H12.9023L12.9922 7.63281Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9023 7.63281L13.9922 7.90625H14.2773L14.0469 8.07422L14.1328 8.34375L13.9023 8.17578L13.6719 8.34375L13.7578 8.07422L13.5273 7.90625H13.8125L13.9023 7.63281Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.8125 7.63281L14.9023 7.90625H15.1875L14.957 8.07422L15.0469 8.34375L14.8125 8.17578L14.582 8.34375L14.6719 8.07422L14.4414 7.90625H14.7266L14.8125 7.63281Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.0781 6.68359L12.168 6.95703H12.4531L12.2227 7.125L12.3086 7.39843L12.0781 7.23047L11.8477 7.39843L11.9336 7.125L11.7031 6.95703H11.9883L12.0781 6.68359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9922 6.68359L13.0781 6.95703H13.3633L13.1328 7.125L13.2227 7.39843L12.9922 7.23047L12.7578 7.39843L12.8477 7.125L12.6172 6.95703H12.9023L12.9922 6.68359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9023 6.68359L13.9922 6.95703H14.2773L14.0469 7.125L14.1328 7.39843L13.9023 7.23047L13.6719 7.39843L13.7578 7.125L13.5273 6.95703H13.8125L13.9023 6.68359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.8125 6.68359L14.9023 6.95703H15.1875L14.957 7.125L15.0469 7.39843L14.8125 7.23047L14.582 7.39843L14.6719 7.125L14.4414 6.95703H14.7266L14.8125 6.68359Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.9922 5.73828L13.0781 6.00781H13.3633L13.1328 6.17578L13.2227 6.44922L12.9922 6.28125L12.7578 6.44922L12.8477 6.17578L12.6172 6.00781H12.9023L12.9922 5.73828Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.9023 5.73828L13.9922 6.00781H14.2773L14.0469 6.17578L14.1328 6.44922L13.9023 6.28125L13.6719 6.44922L13.7578 6.17578L13.5273 6.00781H13.8125L13.9023 5.73828Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.8125 5.73828L14.9023 6.00781H15.1875L14.957 6.17578L15.0469 6.44922L14.8125 6.28125L14.582 6.44922L14.6719 6.17578L14.4414 6.00781H14.7266L14.8125 5.73828Z",
      fill: "#F0F0F0"
    }
  ))),
  vanuatu: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668V18.332H2L10.4062 11.668H22Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5V11.668H10.4062L2 5H22Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.6328 11.0156L3.05078 5H2.35156L10.4805 11.4492H22V11.0156H10.6328Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.35156 18.332H3.05078L10.6328 12.3203H22V11.8828H10.4805L2.35156 18.332Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2 5.27734V5.83203L9.35547 11.668L2 17.5V18.0547L10.0547 11.668L2 5.27734Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.35156 5H2V5.27734L10.0547 11.668L2 18.0547V18.332H2.35156L10.4805 11.8828H22V11.4492H10.4805L2.35156 5Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.48828 13.0859V12.5273C5.04688 12.5273 5.5 12.0742 5.5 11.5156C5.5 11.1211 5.17969 10.8008 4.78516 10.8008C4.51563 10.8008 4.29688 11.0195 4.29688 11.2891C4.29688 11.4609 4.4375 11.6016 4.60938 11.6016C4.70703 11.6016 4.78516 11.5234 4.78516 11.4258H5.34375C5.34375 11.832 5.01563 12.1602 4.60938 12.1602C4.12891 12.1602 3.73828 11.7695 3.73828 11.2891C3.73828 10.7109 4.20703 10.2422 4.78516 10.2422C5.48828 10.2422 6.05859 10.8125 6.05859 11.5156C6.05859 12.3828 5.35547 13.0859 4.48828 13.0859Z",
      fill: "#FFDA44"
    }
  ))),
  "vatican city": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H12V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.5547 10.8008L15.8086 12.457C15.6094 12.7578 15.6133 13.1602 15.8398 13.461C16.1289 13.8438 16.6758 13.918 17.0586 13.6289C17.4414 13.3399 17.5156 12.793 17.2266 12.4102C17 12.1094 16.6094 11.9961 16.2695 12.1055L14.3164 9.52344L13.8555 9.87109L13.1602 10.3945L13.8594 11.3203L14.5547 10.8008ZM16.3555 12.707C16.4844 12.6094 16.6641 12.6367 16.7617 12.7617C16.8594 12.8906 16.832 13.0703 16.707 13.168C16.5781 13.2656 16.3984 13.2383 16.3008 13.1133C16.2031 12.9844 16.2305 12.8047 16.3555 12.707Z",
      fill: "#ACABB1"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.7035 11.3242L17.4027 10.3984L16.7074 9.875L16.2464 9.52734L14.2933 12.1094C13.9535 12 13.5628 12.1133 13.3363 12.4141C13.0472 12.7969 13.1214 13.3438 13.5042 13.6328C13.8871 13.9219 14.4339 13.8477 14.723 13.4648C14.9496 13.1641 14.9535 12.7617 14.7542 12.4609L16.0081 10.8047L16.7035 11.3242ZM14.2621 13.1133C14.1644 13.2422 13.9847 13.2656 13.8558 13.168C13.7269 13.0703 13.7035 12.8906 13.8011 12.7617C13.8988 12.6328 14.0785 12.6094 14.2074 12.707C14.3324 12.8047 14.3558 12.9844 14.2621 13.1133Z",
      fill: "#FFDA44"
    }
  ))),
  venezuela: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.76953H2V14.5664H22V8.76953Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.3477 12.832L16.0352 13.0781L16.1719 13.4531L15.8398 13.2305L15.5273 13.4727L15.6367 13.0898L15.3047 12.8672L15.7031 12.8555L15.8125 12.4727L15.9492 12.8477L16.3477 12.832Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.543 11.4414L15.332 11.7774L15.5898 12.082L15.2031 11.9883L14.9922 12.3242L14.9648 11.9297L14.5781 11.832L14.9453 11.6836L14.918 11.2852L15.1758 11.5898L15.543 11.4414Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.3125 10.4062L14.2305 10.7969L14.5742 10.9961L14.1797 11.0391L14.0977 11.4297L13.9336 11.0625L13.5391 11.1055L13.8359 10.8398L13.6719 10.4766L14.0156 10.6758L14.3125 10.4062Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8047 9.85938L12.8594 10.2539L13.25 10.3203L12.8945 10.4961L12.9492 10.8906L12.6719 10.6055L12.3125 10.7774L12.5 10.4258L12.2227 10.1406L12.6172 10.2109L12.8047 9.85938Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1953 9.85938L11.3828 10.2109L11.7773 10.1406L11.5 10.4258L11.6875 10.7774L11.3281 10.6055L11.0508 10.8906L11.1055 10.4961L10.75 10.3203L11.1406 10.2539L11.1953 9.85938Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.6875 10.4062L9.98437 10.6758L10.3281 10.4766L10.1641 10.8398L10.4609 11.1055L10.0664 11.0625L9.90234 11.4297L9.82031 11.0391L9.42578 10.9961L9.76953 10.7969L9.6875 10.4062Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.45703 11.4414L8.82422 11.5898L9.08203 11.2852L9.05469 11.6836L9.42188 11.832L9.03516 11.9297L9.00781 12.3242L8.79687 11.9883L8.41016 12.082L8.66797 11.7774L8.45703 11.4414Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.65234 12.832L8.05078 12.8477L8.1875 12.4727L8.29688 12.8555L8.69531 12.8672L8.36328 13.0898L8.47266 13.4727L8.16016 13.2305L7.82813 13.4531L7.96484 13.0781L7.65234 12.832Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V8.76953H22V5Z", fill: "#FFDA44" }))),
  vietnam: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M9.67969 5H2V18.332H9.67969H22V5H9.67969Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 7.80859L12.8867 10.5352H15.75L13.4336 12.2188L14.3164 14.9414L12 13.2578L9.68359 14.9414L10.5664 12.2188L8.25 10.5352H11.1133L12 7.80859Z",
      fill: "#FFDA44"
    }
  ))),
  "virgin islands - british": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 5V9.58203H10.1992L12 10.7852V11.668H11.1172L8.25 9.75391V11.668H5.75V9.75391L2.88281 11.668H2V10.7852L3.80078 9.58203H2V7.08203H3.80078L2 5.88281V5H2.88281L5.75 6.91016V5H8.25V6.91016L11.1172 5H12Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.625 5H6.375V7.70703H2V8.95703H6.375V11.668H7.625V8.95703H12V7.70703H7.625V5Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 5V5.58984L4.24219 7.08203H5.125L2 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5V5.58984L9.75781 7.08203H8.875L12 5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 5.88281V7.08203H10.1992L12 5.88281Z", fill: "#2E52B2" }), /* @__PURE__ */ e.createElement("path", { d: "M2 11.668V11.0781L4.24219 9.58203H5.125L2 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M12 11.668V11.0781L9.75781 9.58203H8.875L12 11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 11.8125L15.1992 13.6133C15.5352 14.2656 16.2188 14.7109 17 14.7109C17.7812 14.7109 18.4648 14.2656 18.8008 13.6133L17 11.8125Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.9727 8.625V11.8125C14.9727 13.3672 17 13.8399 17 13.8399C17 13.8399 19.0273 13.3633 19.0273 11.8125V8.625H14.9727Z",
      fill: "#6DA544"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M17.4375 10.0742H16.5664V12.3945H17.4375V10.0742Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17 10.5078C17.2395 10.5078 17.4336 10.3137 17.4336 10.0742C17.4336 9.83475 17.2395 9.64062 17 9.64062C16.7605 9.64062 16.5664 9.83475 16.5664 10.0742C16.5664 10.3137 16.7605 10.5078 17 10.5078Z",
      fill: "#A2001D"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M16.1289 9.20312H15.5508V9.78124H16.1289V9.20312Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M16.1289 10.5078H15.5508V11.0859H16.1289V10.5078Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M16.1289 11.8125H15.5508V12.3906H16.1289V11.8125Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M18.4492 9.20312H17.8711V9.78124H18.4492V9.20312Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M18.4492 10.5078H17.8711V11.0859H18.4492V10.5078Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M18.4492 11.8125H17.8711V12.3906H18.4492V11.8125Z", fill: "#FFDA44" }))),
  "virgin islands - us": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.1328 9.65625C13.1328 9.03125 12.625 8.52344 12 8.52344C11.375 8.52344 10.8672 9.03125 10.8672 9.65625H8.375C8.375 10.2734 8.91016 10.7695 9.52735 10.7695H9.49219C9.49219 11.3867 9.99219 11.8828 10.6055 11.8828C10.6055 12.4297 10.9961 12.8828 11.5156 12.9766L11.5117 12.9844H12.4883L12.4844 12.9766C13 12.8789 13.3945 12.4258 13.3945 11.8828C14.0117 11.8828 14.5078 11.3828 14.5078 10.7695H14.4688C15.086 10.7695 15.6211 10.2695 15.6211 9.65625H13.1328Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.5039 12.8711L10.8008 14.457C11.1719 14.6094 11.5742 14.6914 12 14.6914C12.4258 14.6914 12.8281 14.6094 13.1992 14.457L12.4961 12.8711H11.5039Z",
      fill: "#FFDA44"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.5508 10.2148V12.1641C10.5508 13.2734 12 13.6133 12 13.6133C12 13.6133 13.4492 13.2734 13.4492 12.1641V10.2148H10.5508Z",
      fill: "#F0F0F0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.94922 11.7148L7.73438 13.9062L8.51172 11.7148H9.10547L7.97656 14.6133H7.50391L6.36328 11.7148H6.94922Z",
      fill: "#338AF3"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M16.0586 14.6133V11.7148H16.6211V14.6133H16.0586Z", fill: "#338AF3" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.1289 10.8438V13.207C11.3281 13.3555 11.543 13.4531 11.707 13.5195V10.8438H11.1289Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.8711 10.8438V13.207C12.6719 13.3555 12.457 13.4531 12.293 13.5195V10.8438H12.8711Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M13.4492 10.2148H10.5508V11.1328H13.4492V10.2148Z", fill: "#0052B4" }))),
  "wallis & futuna": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M8.66797 5H2V18.332H8.66797V5Z", fill: "#0052B4" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H15.332V18.332H22V5Z", fill: "#D80027" }))),
  "yemen - south": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }))),
  "yemen - north": /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V9.44532H22V5Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 13.8906H2V18.3359H22V13.8906Z", fill: "black" }))),
  zambia: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "#496E2D" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.168 9.30078H19.293C19.293 8.95703 19.0117 8.67578 18.668 8.67578C18.3242 8.67578 18.043 8.95703 18.043 9.30078H16.168C16.168 9.64453 16.4688 9.92578 16.8125 9.92578H16.793C16.793 10.2695 17.0742 10.5508 17.418 10.5508C17.418 10.8945 17.6992 11.1758 18.043 11.1758H19.293C19.6367 11.1758 19.918 10.8945 19.918 10.5508C20.2617 10.5508 20.543 10.2695 20.543 9.92578H20.5234C20.8672 9.92578 21.168 9.64844 21.168 9.30078Z",
      fill: "#FF9811"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M17.5547 11.668H15.332V18.3359H17.5547V11.668Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 11.668H19.7773V18.3359H22V11.668Z", fill: "#FF9811" }), /* @__PURE__ */ e.createElement("path", { d: "M19.7773 11.668H17.5547V18.3359H19.7773V11.668Z", fill: "black" }))),
  zimbabwe: /* @__PURE__ */ e.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "mask0",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "5",
      width: "20",
      height: "14"
    },
    /* @__PURE__ */ e.createElement("rect", { x: "2", y: "5", width: "20", height: "13.3333", rx: "0.5", fill: "#C4C4C4" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0)" }, /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V18.332H22V5Z", fill: "black" }), /* @__PURE__ */ e.createElement("path", { d: "M22 6.91016H2V8.82031H22V6.91016Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 14.543H2V16.4531H22V14.543Z", fill: "#FFDA44" }), /* @__PURE__ */ e.createElement("path", { d: "M22 5H2V6.91016H22V5Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M22 8.81641H2V10.7266H22V8.81641Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 12.6367H2V14.5469H22V12.6367Z", fill: "#D80027" }), /* @__PURE__ */ e.createElement("path", { d: "M22 16.4531H2V18.332H22V16.4531Z", fill: "#6DA544" }), /* @__PURE__ */ e.createElement("path", { d: "M12.8203 11.668L6.15234 18.332H2V5H6.15234L12.8203 11.668Z", fill: "#F0F0F0" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 11.668L5.33203 18.332H6.15234L12.8203 11.668L6.15234 5H5.33203L12 11.668Z",
      fill: "black"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.00391 9.57812L6.51953 11.1758H8.19531L6.83984 12.1602L7.35937 13.7539L6.00391 12.7695L4.64453 13.7539L5.16406 12.1602L3.80859 11.1758H5.48437L6.00391 9.57812Z",
      fill: "#D80027"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.42577 11.7969L6.07421 11.3203C6.07421 11.3203 5.97265 10.3828 5.96875 10.3516C5.92187 10.1094 5.71093 9.92578 5.45703 9.92578C5.16797 9.92578 4.93359 10.1602 4.93359 10.4492C4.93359 10.4961 4.94141 10.543 4.95312 10.5859L4.57422 10.9687C4.57422 10.9687 5.02344 10.9687 5.24609 10.9687C5.24609 11.668 4.72656 11.668 4.72656 12.3633L5.01562 13.0586H6.7539L7.04296 12.3633C7.07031 12.2969 7.08984 12.2266 7.09765 12.1602C7.35156 12.0586 7.42577 11.7969 7.42577 11.7969Z",
      fill: "#FFDA44"
    }
  )))
}, gr = {
  visa: /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45 35C45 37.209 43.209 39 41 39H7C4.791 39 3 37.209 3 35V13C3 10.791 4.791 9 7 9H41C43.209 9 45 10.791 45 13V35Z",
      fill: "#1565C0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.186 19L12.56 26.832C12.56 26.832 11.893 23.519 11.827 23.103C10.332 19.692 8.126 19.882 8.126 19.882L10.726 30V29.998H13.887L18.258 19H15.186ZM17.689 30H20.56L22.296 19H19.389L17.689 30ZM38.008 19H34.987L30.277 30H33.129L33.717 28.429H37.313L37.619 30H40.232L38.008 19ZM34.513 26.328L36.076 22.171L36.894 26.328H34.513ZM26.369 22.206C26.369 21.6 26.867 21.149 28.295 21.149C29.223 21.149 30.286 21.823 30.286 21.823L30.752 19.514C30.752 19.514 29.394 18.999 28.061 18.999C25.042 18.999 23.485 20.443 23.485 22.271C23.485 25.577 27.464 25.124 27.464 26.822C27.464 27.113 27.233 27.786 25.576 27.786C23.914 27.786 22.817 27.177 22.817 27.177L22.322 29.393C22.322 29.393 23.385 29.999 25.439 29.999C27.498 29.999 30.354 28.459 30.354 26.247C30.354 23.586 26.369 23.394 26.369 22.206Z",
      fill: "white"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.212 24.945L11.246 20.197C11.246 20.197 10.809 19.168 9.673 19.168C8.537 19.168 5.233 19.168 5.233 19.168C5.233 19.168 10.894 20.84 12.212 24.945Z",
      fill: "#FFC107"
    }
  )),
  "master-card": /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M32 10C30.1615 10 28.341 10.3621 26.6424 11.0657C24.9439 11.7693 23.4005 12.8005 22.1005 14.1005C20.8005 15.4005 19.7693 16.9439 19.0657 18.6424C18.3621 20.341 18 22.1615 18 24C18 25.8385 18.3621 27.659 19.0657 29.3576C19.7693 31.0561 20.8005 32.5995 22.1005 33.8995C23.4005 35.1995 24.9439 36.2307 26.6424 36.9343C28.341 37.6379 30.1615 38 32 38C33.8385 38 35.659 37.6379 37.3576 36.9343C39.0561 36.2307 40.5995 35.1995 41.8995 33.8995C43.1995 32.5995 44.2307 31.0561 44.9343 29.3576C45.6379 27.659 46 25.8385 46 24C46 22.1615 45.6379 20.341 44.9343 18.6424C44.2307 16.9439 43.1995 15.4005 41.8995 14.1005C40.5995 12.8005 39.0561 11.7693 37.3576 11.0657C35.659 10.3621 33.8385 10 32 10Z",
      fill: "#FF9800"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 10C14.1615 10 12.341 10.3621 10.6424 11.0657C8.94387 11.7693 7.40053 12.8005 6.1005 14.1005C4.80048 15.4005 3.76925 16.9439 3.06569 18.6424C2.36212 20.341 2 22.1615 2 24C2 25.8385 2.36212 27.659 3.06569 29.3576C3.76925 31.0561 4.80048 32.5995 6.1005 33.8995C7.40053 35.1995 8.94387 36.2307 10.6424 36.9343C12.341 37.6379 14.1615 38 16 38C17.8385 38 19.659 37.6379 21.3576 36.9343C23.0561 36.2307 24.5995 35.1995 25.8995 33.8995C27.1995 32.5995 28.2307 31.0561 28.9343 29.3576C29.6379 27.659 30 25.8385 30 24C30 22.1615 29.6379 20.341 28.9343 18.6424C28.2307 16.9439 27.1995 15.4005 25.8995 14.1005C24.5995 12.8005 23.0561 11.7693 21.3576 11.0657C19.659 10.3621 17.8385 10 16 10Z",
      fill: "#D50000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18 24C18 28.755 20.376 32.95 24 35.48C27.624 32.95 30 28.755 30 24C30 19.245 27.624 15.05 24 12.52C20.376 15.05 18 19.245 18 24Z",
      fill: "#FF3D00"
    }
  )),
  discover: /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45 35C45 37.2 43.2 39 41 39H7C4.8 39 3 37.2 3 35V13C3 10.8 4.8 9 7 9H41C43.2 9 45 10.8 45 13V35Z",
      fill: "#E1E7EA"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45 35C45 37.2 43.2 39 41 39H16C16 39 39.6 35.2 45 24V35ZM22 24C22 25.7 23.3 27 25 27C26.7 27 28 25.7 28 24C28 22.3 26.7 21 25 21C23.3 21 22 22.3 22 24Z",
      fill: "#FF6D00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.2 21H12.3V27H11.2V21ZM17.2 24C17.2 25.7 18.5 27 20.2 27C20.7 27 21.1 26.9 21.6 26.7V25.4C21.2 25.8 20.8 26 20.2 26C19.1 26 18.3 25.2 18.3 24C18.3 22.9 19.1 22 20.2 22C20.7 22 21.1 22.2 21.6 22.6V21.3C21.1 21.1 20.7 20.9 20.2 20.9C18.5 21 17.2 22.4 17.2 24ZM30.6 24.9L29 21H27.8L30.3 27H30.9L33.4 21H32.2L30.6 24.9ZM33.9 27H37.1V26H35V24.4H37V23.4H35V22H37.1V21H33.9V27ZM41.5 22.8C41.5 21.7 40.8 21 39.5 21H37.8V27H38.9V24.6H39L40.6 27H42L40.2 24.5C41 24.3 41.5 23.7 41.5 22.8ZM39.2 23.8H38.9V22H39.2C39.9 22 40.3 22.3 40.3 22.9C40.3 23.4 40 23.8 39.2 23.8ZM7.7 21H6V27H7.6C10.1 27 10.7 24.9 10.7 24C10.8 22.2 9.5 21 7.7 21ZM7.4 26H7.1V22H7.5C9 22 9.6 23 9.6 24C9.6 24.4 9.5 26 7.4 26ZM15.3 23.3C14.6 23 14.4 22.9 14.4 22.6C14.4 22.2 14.8 22 15.2 22C15.5 22 15.8 22.1 16.1 22.5L16.7 21.7C16.2 21.2 15.7 21 15 21C14 21 13.2 21.7 13.2 22.7C13.2 23.5 13.6 23.9 14.6 24.3C15.2 24.5 15.7 24.7 15.7 25.2C15.7 25.7 15.3 26 14.8 26C14.3 26 13.8 25.7 13.6 25.2L12.9 25.9C13.4 26.7 14 27 14.9 27C16.1 27 16.9 26.2 16.9 25.1C16.9 24.2 16.5 23.8 15.3 23.3Z",
      fill: "black"
    }
  )),
  pulse: /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45 35C45 37.2 43.2 39 41 39H7C4.8 39 3 37.2 3 35V13C3 10.8 4.8 9 7 9H41C43.2 9 45 10.8 45 13V35Z",
      fill: "#231F20"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.23711 30.0908L9.48529 28.3481H40.473L40.3279 29.3639C40.2506 29.8575 39.9957 30.0908 39.5983 30.0908H9.23711Z",
      fill: "#EE7623"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.811 27.4423H22.3604L23.9227 17H25.2897C26.2037 17.057 26.2525 17.8557 26.1603 18.3995L24.811 27.4423ZM21.5251 27.4423L22.5449 20.6114H20.112L19.442 25.1205H17.8147C17.4851 25.1205 17.2058 24.9076 17.2722 24.5021L17.6438 22.0245C17.7197 21.52 17.7645 20.6155 16.9291 20.6114H15.3885L14.7105 25.126C14.507 26.6353 15.2977 27.4314 16.2971 27.4314H21.5237L21.5251 27.4423ZM41.4779 27.4545C41.3656 27.4621 41.2536 27.4357 41.1565 27.3787C41.0594 27.3218 40.9817 27.2369 40.9336 27.1351C40.8855 27.0333 40.8691 26.9194 40.8867 26.8082C40.9043 26.697 40.955 26.5937 41.0321 26.5118C41.1093 26.4298 41.2093 26.373 41.3193 26.3487C41.4292 26.3245 41.5439 26.3339 41.6483 26.3758C41.7528 26.4177 41.8423 26.4901 41.905 26.5836C41.9677 26.677 42.0008 26.7872 42 26.8998C42.0051 27.0432 41.9532 27.1829 41.8556 27.2881C41.758 27.3933 41.6227 27.4556 41.4792 27.4612L41.4779 27.4545ZM41.9227 26.8998C41.9171 26.8132 41.8864 26.7301 41.8342 26.6608C41.782 26.5914 41.7107 26.5389 41.629 26.5096C41.5473 26.4803 41.4588 26.4755 41.3745 26.4959C41.2901 26.5162 41.2135 26.5608 41.1542 26.6241C41.0949 26.6875 41.0554 26.7668 41.0405 26.8523C41.0257 26.9378 41.0362 27.0258 41.0708 27.1054C41.1053 27.185 41.1624 27.2527 41.235 27.3003C41.3076 27.3479 41.3925 27.3732 41.4792 27.3731C41.6007 27.3688 41.7156 27.3167 41.7987 27.228C41.8818 27.1393 41.9264 27.0213 41.9227 26.8998ZM41.2595 26.6082H41.5308C41.553 26.6069 41.5752 26.6102 41.5961 26.618C41.6169 26.6258 41.6358 26.6379 41.6517 26.6535C41.6676 26.6691 41.68 26.6879 41.6881 26.7086C41.6962 26.7293 41.6999 26.7515 41.6989 26.7737C41.7012 26.8021 41.6944 26.8305 41.6795 26.8549C41.6647 26.8792 41.6425 26.8983 41.6162 26.9093C41.6596 26.9296 41.684 26.9486 41.684 27.0571C41.684 27.1425 41.684 27.1642 41.7071 27.1737V27.19H41.585C41.5751 27.1511 41.571 27.1108 41.5728 27.0707C41.5728 26.992 41.5728 26.9608 41.486 26.9608H41.3708V27.19H41.2595V26.6082ZM41.4996 26.8659C41.5565 26.8659 41.585 26.8442 41.585 26.7859C41.5861 26.7755 41.5849 26.765 41.5814 26.7552C41.5778 26.7454 41.5722 26.7365 41.5647 26.7292C41.5573 26.7219 41.5483 26.7164 41.5384 26.7131C41.5286 26.7097 41.5181 26.7087 41.5077 26.7099H41.3721V26.8659H41.4996ZM11.0177 27.4423C12.5691 27.4423 14.0175 26.158 14.2236 24.6079L14.408 23.4145C14.6128 21.8631 13.5225 20.6114 11.967 20.6114H7.41445L6 30.0908C6 30.0908 8.32713 30.0813 8.3529 30.0908L8.74889 27.4423H11.0177ZM9.45001 22.7514H11.3486C11.8219 22.7514 12.1975 23.1026 12.0904 23.6776L12.005 24.2513C11.9682 24.4864 11.8505 24.7013 11.6723 24.859C11.4941 25.0167 11.2664 25.1073 11.0286 25.1151H9.09606L9.45001 22.7514ZM35.104 27.4423H40.6072L40.7496 26.493C40.8297 25.8935 40.6235 25.328 40.0065 25.3348H36.0194L36.1198 24.6567H41.0236L41.368 22.3513C41.4942 21.421 40.8351 20.6209 39.8939 20.6209H36.0344C35.104 20.6209 34.2212 21.421 34.0951 22.3513L33.5865 25.762C33.4604 26.6828 34.1751 27.4423 35.104 27.4423ZM36.3571 23.047L36.3951 22.7758C36.4127 22.6647 36.4686 22.5633 36.553 22.489C36.6374 22.4148 36.7451 22.3723 36.8575 22.3689H38.7412C38.7926 22.3675 38.8436 22.3776 38.8906 22.3984C38.9376 22.4192 38.9794 22.4502 39.0129 22.4891C39.0464 22.5281 39.0708 22.5741 39.0844 22.6236C39.0979 22.6732 39.1002 22.7252 39.0911 22.7758L39.0531 23.047H36.3571ZM28.162 20.6114C27.29 20.6114 26.5767 21.3803 26.4383 22.3079L26.3109 23.1582C26.1929 24.0546 26.677 24.8086 27.507 24.8547H30.5813L30.5054 25.3267H27.1313C26.5251 25.3267 25.9352 25.3877 25.8593 26.0047L25.6382 27.4423H31.0628C31.9565 27.4423 32.7905 26.8483 32.9125 25.9234L33.0875 24.7571C33.2095 23.8309 32.5721 23.0579 31.6784 23.0579H28.5593L28.6163 22.6185H32.1734C33.0685 22.6185 33.3478 22.5073 33.4699 21.8414L33.653 20.6209L28.162 20.6114Z",
      fill: "white"
    }
  )),
  "marqeta-network": /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M45 35C45 37.2 43.2 39 41 39H7C4.8 39 3 37.2 3 35V13C3 10.8 4.8 9 7 9H41C43.2 9 45 10.8 45 13V35Z",
      fill: "#2A206A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.49023 14.4113L14.6925 23.6219L8.49023 32.8323H11.9591L18.1614 23.6219L13.4896 16.714H16.9585L21.6114 23.6219L15.428 32.8323H25.8346L32.018 23.6219L27.3891 16.714H30.8579L35.4869 23.6219L29.3034 32.8323H32.7535L38.9558 23.6219L32.7535 14.4113H22.3637L28.5492 23.6219L23.8961 30.5297H20.4461L25.0803 23.6219L18.8968 14.4113H8.49023Z",
      fill: "#EFEFF2"
    }
  ))
};
let d0 = !1;
class t2 extends N {
  getStrokeStyle(t, n) {
    return {
      stroke: t,
      className: `${we.svgStroke} ${we.voltIconStroke} ${n === "default" ? we.default : ""}`
    };
  }
  getFillStyle(t, n) {
    return {
      fill: t,
      className: `${we.svgFill} ${we.voltIconFill} ${n === "default" ? we.default : ""}`
    };
  }
  getSizeStyle(t = 24, n) {
    const a = t + (n - 1) * 8;
    return {
      width: a,
      height: a
    };
  }
  getSvgFillStyle(t, n, a) {
    if (!g1[t])
      return null;
    const l = this.fillBlacklist.includes(t), o = g1[t].props.children;
    let s = o;
    return l || (s = (Array.isArray(o) ? o : [o]).map((c, m) => (!d0 && c.type !== "path" && (d0 = !0, console.error("Invalid SVG children: The input SVG is not fillStyle only type")), e.cloneElement(c, { ...c.props, ...a, key: m })))), e.cloneElement(g1[t], {
      ...g1[t].props,
      children: s
    });
  }
  getCustomIcons(t, n) {
    const a = Ft[t];
    return a ? e.cloneElement(a, { ...this.getSizeStyle(24, n) }) : null;
  }
  getFlagIcon(t) {
    const n = Cr[t];
    return n ? e.cloneElement(n) : null;
  }
  getNetworkIcon(t, n) {
    const a = gr[t];
    return a ? e.cloneElement(a, { ...this.getSizeStyle(24, n) }) : null;
  }
  newPage(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(4.392090, 6.000000)",
        fillRule: "nonzero",
        ...n,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("path", { d: "M2.58913439,0.099989515 L11.8866515,0.099989515" }),
      /* @__PURE__ */ e.createElement("path", { d: "M0.617740572,11.6972557 L11.8866515,0.099989515" }),
      /* @__PURE__ */ e.createElement("path", { d: "M11.8866515,9.66841909 L11.8866515,0.099989515" })
    )));
  }
  newSite(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17,12.9713135 C17,15.4808757 17,17.9904378 17,20.5 C17,20.7761424 16.7761424,21 16.5,21 L3.5,21 C3.22385763,21 3,20.7761424 3,20.5 L3,7.5 C3,7.22385763 3.22385763,7 3.5,7 L10,7",
        id: "Path",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "polyline",
      {
        id: "Path",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero",
        points: "14 3 21 3 21 10"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M21,3 C14.3333333,9.66666667 11,13 11,13",
        id: "Path-23",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    )));
  }
  cardstock(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), viewBox: "0 0 16 16" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(0.000000, 1.500000)",
        fill: "#8E8E99",
        ...n,
        strokeWidth: "0.1"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.99014,3.97274866 L13.6423139,3.90318345 L13.5031834,4.94666171 L13.8510095,5.01622693 C13.9205748,5.01622693 13.99014,5.08579214 13.99014,5.22492258 L13.0857921,11.4857921 C13.0857921,11.5553574 13.0162269,11.6249226 12.8770965,11.6249226 L3.13796606,10.2336182 C3.06840084,10.2336182 3.06840084,10.2336182 2.99883562,10.164053 C2.9292704,10.0944878 2.9292704,10.0249226 2.99883562,10.0249226 L3.06840084,9.74666171 L2.02492258,9.60753127 L1.95535736,9.88579214 C1.88579214,10.5814443 2.30318345,11.1379661 2.99883562,11.2770965 L12.7379661,12.6684008 C13.4336182,12.7379661 13.99014,12.3205748 14.1292704,11.6249226 L15.0336182,5.36405301 C15.1031834,4.66840084 14.6857921,4.04231388 13.99014,3.97274866 Z M10.79014,10.0944878 L1.05100953,8.70318345 C0.35535736,8.63361823 -0.0620339444,8.00753127 0.00753127302,7.3118791 L0.911879099,1.05100953 C0.981444317,0.35535736 1.60753127,-0.0620339444 2.30318345,0.00753127302 L12.0423139,1.39883562 C12.7379661,1.46840084 13.1553574,2.09448779 13.0857921,2.79013997 L12.1814443,9.05100953 C12.1118791,9.74666171 11.4857921,10.164053 10.79014,10.0944878 Z M2.16405301,1.05100953 C2.09448779,1.05100953 1.95535736,1.12057475 1.95535736,1.25970519 L1.81622693,2.16405301 L11.9031834,3.61505127 L11.6326904,5.54455566 L1.53796606,4.18144432 L1.05100953,7.45100953 C1.05100953,7.45100953 1.05100953,7.52057475 1.05100953,7.59013997 C1.05100953,7.65970519 1.12057475,7.65970519 1.19013997,7.65970519 L10.9292704,9.05100953 C10.9988356,9.05100953 11.1379661,8.98144432 11.1379661,8.9118791 L12.0423139,2.65100953 C12.0423139,2.58144432 11.9727487,2.44231388 11.9031834,2.44231388 L2.16405301,1.05100953 Z",
          ...n,
          ...a
        }
      )
    )));
  }
  file(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), x: "0px", y: "0px", viewBox: "0 0 16 16" }, /* @__PURE__ */ e.createElement("g", { id: "questionnaire_duplicate" }, /* @__PURE__ */ e.createElement("g", { id: "duplicate_3_ARN_upload-error", transform: "translate(-567.000000, -1342.000000)" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: `M577.6,1343H572c-1.4,0-2.5,1.1-2.5,2.5v9c0,1.4,1.1,2.5,2.5,2.5h6c1.4,0,2.5-1.1,2.5-2.5v-7.5L577.6,1343z
			 M579,1346.5h-1c-0.3,0-0.5-0.2-0.5-0.5v-1.5L579,1346.5z M578,1356h-6c-0.8,0-1.5-0.7-1.5-1.5v-9c0-0.8,0.7-1.5,1.5-1.5h4.5v2
			c0,0.8,0.7,1.5,1.5,1.5h1h0.5v7C579.5,1355.3,578.8,1356,578,1356z`
      }
    ))));
  }
  jpg(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), x: "0px", y: "0px", viewBox: "0 0 14 14" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        id: "Shape",
        d: `M12,13.5H2c-0.8,0-1.5-0.7-1.5-1.5V2c0-0.8,0.7-1.5,1.5-1.5h10c0.8,0,1.5,0.7,1.5,1.5v10
	C13.5,12.8,12.8,13.5,12,13.5z M2,1.5C1.7,1.5,1.5,1.7,1.5,2v10c0,0.3,0.2,0.5,0.5,0.5h10c0.3,0,0.5-0.2,0.5-0.5V2
	c0-0.3-0.2-0.5-0.5-0.5H2z`
      }
    ), /* @__PURE__ */ e.createElement("polygon", { ...n, id: "Path", points: "8.8,6.8 6.3,10.6 4.5,8 2,11.8 12,11.8 " }));
  }
  success(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: "M15.9253346,3.89884511 C14.7390464,3.32297587 13.4072408,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 L12,21 C16.9705627,21 21,16.9705627 21,12",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "polyline",
      {
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        points: "8 11 12 15 22 5"
      }
    )));
  }
  marq(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), viewBox: "0 0 36 22" }, /* @__PURE__ */ e.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: "M0 .033L7.21 10.91 0 21.786h4.033l7.21-10.877-5.43-8.157h4.032l5.41 8.157-7.19 10.877h12.1l7.188-10.877-5.381-8.157h4.033l5.381 8.157-7.189 10.877h4.011l7.211-10.877L28.209.033h-12.08l7.192 10.876-5.41 8.158H13.9l5.387-8.158L12.1.033H0"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M0 .033L7.21 10.91 0 21.786h4.033l7.21-10.877-5.43-8.157h4.032l5.41 8.157-7.19 10.877h12.1l7.188-10.877-5.381-8.157h4.033l5.381 8.157-7.189 10.877h4.011l7.211-10.877L28.209.033h-12.08l7.192 10.876-5.41 8.158H13.9l5.387-8.158L12.1.033H0" })));
  }
  checkmarkMixed(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("path", { ...n, d: "M7,12.5 L15,12.5", strokeWidth: "1.5", fillRule: "nonzero" })));
  }
  list(t, n) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 10 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...this.getSizeStyle(16, t)
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M9 1H1V11H9V1ZM0 0V12H10V0H0Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 3.5C4 3.22386 4.22386 3 4.5 3H7.5C7.77614 3 8 3.22386 8 3.5C8 3.77614 7.77614 4 7.5 4H4.5C4.22386 4 4 3.77614 4 3.5Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 3.5C3 3.77614 2.77614 4 2.5 4C2.22386 4 2 3.77614 2 3.5C2 3.22386 2.22386 3 2.5 3C2.77614 3 3 3.22386 3 3.5Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 5.5C4 5.22386 4.22386 5 4.5 5H7.5C7.77614 5 8 5.22386 8 5.5C8 5.77614 7.77614 6 7.5 6H4.5C4.22386 6 4 5.77614 4 5.5Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5C2.77614 5 3 5.22386 3 5.5Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4 7.5C4 7.22386 4.22386 7 4.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H4.5C4.22386 8 4 7.77614 4 7.5Z",
          fill: "#666679",
          ...n
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 7.5C3 7.77614 2.77614 8 2.5 8C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7C2.77614 7 3 7.22386 3 7.5Z",
          fill: "#666679",
          ...n
        }
      )
    );
  }
  sparkle(t, n) {
    const a = 16 + t * 8 + "px";
    return /* @__PURE__ */ e.createElement("svg", { width: a, height: a, viewBox: "0 0 48 48", fill: "none" }, /* @__PURE__ */ e.createElement("path", { d: "M31 16L34 26L44 29L34 32L31 42L28 32L18 29L28 26L31 16Z", ...n }), /* @__PURE__ */ e.createElement(
      "path",
      {
        opacity: "0.75",
        d: "M11 30L12.6154 35.3846L18 37L12.6154 38.6154L11 44L9.38462 38.6154L4 37L9.38462 35.3846L11 30Z",
        ...n
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        opacity: "0.5",
        d: "M16 4L18.3077 11.6923L26 14L18.3077 16.3077L16 24L13.6923 16.3077L6 14L13.6923 11.6923L16 4Z",
        ...n
      }
    ));
  }
  hamburger(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M5,7 L19,7", ...n, strokeWidth: "1.5", fillRule: "nonzero" }), /* @__PURE__ */ e.createElement("path", { d: "M5,12 L19,12", ...n, strokeWidth: "1.5", fillRule: "nonzero" }), /* @__PURE__ */ e.createElement("path", { d: "M5,17 L19,17", ...n, strokeWidth: "1.5", fillRule: "nonzero" })));
  }
  oldHome(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19,13 L19,20.5 C19,20.7761424 18.7761424,21 18.5,21 L14.5,21 C14.2238576,21 14,20.7761424 14,20.5 L14,15.5 C14,15.2238576 13.7761424,15 13.5,15 L10.5,15 C10.2238576,15 10,15.2238576 10,15.5 L10,20.5 C10,20.7761424 9.77614237,21 9.5,21 L5.5,21 C5.22385763,21 5,20.7761424 5,20.5 L5,13 L2.20710678,13 C1.93096441,13 1.70710678,12.7761424 1.70710678,12.5 C1.70710678,12.3673918 1.7597852,12.2402148 1.85355339,12.1464466 L11.6464466,2.35355339 C11.8417088,2.15829124 12.1582912,2.15829124 12.3535534,2.35355339 L22.1464466,12.1464466 C22.3417088,12.3417088 22.3417088,12.6582912 22.1464466,12.8535534 C22.0526784,12.9473216 21.9255015,13 21.7928932,13 L19,13 Z",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    )));
  }
  loading(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M2,12 C2,17.5228475 6.4771525,22 12,22 L12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2",
        ...n,
        strokeWidth: "1.5",
        transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
      }
    )));
  }
  moon(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12.0342133,3.00006365 C10.2109775,4.15139063 9,6.18427584 9,8.5 C9,12.0898509 11.9101491,15 15.5,15 C17.8157242,15 19.8486094,13.7890225 20.9999363,11.9657867 C20.9999788,11.9771862 21,11.9885906 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C12.0114094,3 12.0228138,3.00002123 12.0342133,3.00006365 Z",
        ...n,
        strokeWidth: "1.5"
      }
    )));
  }
  number(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "rect",
      {
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        x: "3",
        y: "4",
        width: "9",
        height: "16",
        rx: "4.5"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15,7 L17.8535534,4.14644661 C17.9473216,4.05267842 18.0744985,4 18.2071068,4 L18.5,4 C18.7761424,4 19,4.22385763 19,4.5 L19,20",
        ...n,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        fillRule: "nonzero"
      }
    )));
  }
  phone(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement("rect", { fillRule: "nonzero", x: "-1", y: "0", width: "24", height: "24" }), /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(2.000000, 3.000000)",
        fillRule: "nonzero",
        ...n,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("path", { d: "M4.92023935,8.31553106 C5.94974069,10.7588328 8.35228182,13.1392983 10.7972012,14.1262659 C12.9233051,11.9007628 13.4793984,11.3570681 13.8180983,11.2723931 C14.2710247,11.1591615 18.1718812,12.111221 18.5303301,12.4696699 C19.0045575,12.9438974 19.0045575,18.0561026 18.5303301,18.5303301 C18.0926582,18.968002 15.5327102,19.041821 13.1937061,18.684394 C9.83350101,18.1709156 6.7925049,16.8531651 4.46966991,14.5303301 C2.14683493,12.2074951 0.829084408,9.16649899 0.315605995,5.80629391 C-0.0418210415,3.46728976 0.0319979924,0.907341836 0.469669914,0.469669914 C0.943897373,-0.0045575447 6.05610263,-0.0045575447 6.53033009,0.469669914 C6.88623295,0.82557278 7.81547267,5.66923588 7.73979544,6.12329924 C7.66266628,6.58607419 7.3109524,6.8472794 4.92023935,8.31553106 Z" })
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6.92023935,11.3155311 C7.94974069,13.7588328 10.3522818,16.1392983 12.7972012,17.1262659 C14.9233051,14.9007628 15.4793984,14.3570681 15.8180983,14.2723931 C16.2710247,14.1591615 20.1718812,15.111221 20.5303301,15.4696699 C21.0045575,15.9438974 21.0045575,21.0561026 20.5303301,21.5303301 C20.0926582,21.968002 17.5327102,22.041821 15.1937061,21.684394 C11.833501,21.1709156 8.7925049,19.8531651 6.46966991,17.5303301 C4.14683493,15.2074951 2.82908441,12.166499 2.315606,8.80629391 C1.95817896,6.46728976 2.03199799,3.90734184 2.46966991,3.46966991 C2.94389737,2.99544246 8.05610263,2.99544246 8.53033009,3.46966991 C8.88623295,3.82557278 9.81547267,8.66923588 9.73979544,9.12329924 C9.66266628,9.58607419 9.3109524,9.8472794 6.92023935,11.3155311 Z",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    )));
  }
  pivotTable(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.9083862,-1.59161377 L11.9083862,15.5916138",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(11.908386, 7.000000) rotate(-270.000000) translate(-11.908386, -7.000000) "
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7,2.86645508 L7,20.3664551",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(7.000000, 11.683228) rotate(-180.000000) translate(-7.000000, -11.683228) "
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17,11 L17,16.5 C17,16.7761424 16.7761424,17 16.5,17 L10.4190225,17",
        ...n,
        strokeWidth: "1.5"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M3.5,3 L20.5,3 C20.7761424,3 21,3.22385763 21,3.5 L21,20.5 C21,20.7761424 20.7761424,21 20.5,21 L3.5,21 C3.22385763,21 3,20.7761424 3,20.5 L3,3.5 C3,3.22385763 3.22385763,3 3.5,3 Z",
        ...n,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(11.000000, 17.000000) rotate(-90.000000) translate(-11.000000, -17.000000) translate(9.000000, 16.000000)",
        fillRule: "nonzero",
        ...n,
        strokeLinecap: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("path", { d: "M2,0 L4,2" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,0 L2,2",
          transform: "translate(1.000000, 1.000000) scale(-1, 1) translate(-1.000000, -1.000000) "
        }
      )
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M17,10 L19,12",
        ...n,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15,10 L17,12",
        ...n,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        fillRule: "nonzero",
        transform: "translate(16.000000, 11.000000) scale(-1, 1) translate(-16.000000, -11.000000) "
      }
    )));
  }
  starHalf(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        ...a,
        transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
        fillRule: "nonzero",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("polygon", { points: "18.2544125 11 21.5 17.1803399 14.6257354 16 9.75735421 21 8.75441253 14.0901699 2.5 11 8.75441253 7.90983006 9.75735421 1 14.6257354 6 21.5 4.81966011" })
    ), /* @__PURE__ */ e.createElement(
      "polygon",
      {
        ...n,
        fillRule: "nonzero",
        points: "13.1868896 18.2618588 13.1868896 3 10.0967197 8.76185882 3.5 9.84545898 8.18688965 14.6331817 7.18347168 21.1573486"
      }
    )));
  }
  sun(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement("g", { ...n, fillRule: "nonzero", strokeWidth: "1.5" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "5.25" })), /* @__PURE__ */ e.createElement(
      "g",
      {
        ...n,
        transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) translate(1.500000, 2.000000)",
        fillRule: "nonzero",
        strokeLinecap: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("g", { transform: "translate(10.000000, 0.000000)" }, /* @__PURE__ */ e.createElement("path", { d: "M0.5,2 L0.5,0" }), /* @__PURE__ */ e.createElement("path", { d: "M0.5,20 L0.5,18" })),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(10.500000, 10.000000) rotate(-270.000000) translate(-10.500000, -10.000000) translate(10.000000, 0.000000)" }, /* @__PURE__ */ e.createElement("path", { d: "M0.5,2 L0.5,0" }), /* @__PURE__ */ e.createElement("path", { d: "M0.5,20 L0.5,18" })),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(10.500000, 10.000000) rotate(-225.000000) translate(-10.500000, -10.000000) translate(10.000000, 0.000000)" }, /* @__PURE__ */ e.createElement("path", { d: "M0.5,2 L0.5,0" }), /* @__PURE__ */ e.createElement("path", { d: "M0.5,20 L0.5,18" })),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(10.500000, 10.000000) rotate(-135.000000) translate(-10.500000, -10.000000) translate(10.000000, 0.000000)" }, /* @__PURE__ */ e.createElement("path", { d: "M0.5,2 L0.5,0" }), /* @__PURE__ */ e.createElement("path", { d: "M0.5,20 L0.5,18" }))
    )));
  }
  oldUser(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "22px", height: "22px", viewBox: "0 0 22 22" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(-1.000000, -1.000000)",
        fillRule: "nonzero",
        stroke: "#8F8FA2",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("circle", { ...n, cx: "12", cy: "7", r: "5" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M21.8052803,21.3501345 C20.4749616,17.1167115 18.5398682,15 16,15 L8,15 C5.46015628,15 3.52507563,17.1166708 2.19475806,21.3500123 C2.11187054,21.6134739 2.25834721,21.8941971 2.52183608,21.9769979 C2.57035055,21.9922434 2.62090659,22 2.67176011,22 L21.328369,22 C21.6044584,21.9999041 21.8282731,21.7760894 21.8282731,21.5 C21.8282731,21.4491664 21.8205197,21.3986301 21.8052803,21.3501345 Z",
          strokeLinecap: "round"
        }
      )
    )));
  }
  chevronRight(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19.3964466,8.60355339 L12.75,15.25 C12.5547379,15.4452621 12.2381554,15.4452621 12.0428932,15.25 L5.39644661,8.60355339",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(12.396447, 12.000000) rotate(-90.000000) translate(-12.396447, -12.000000) "
      }
    )));
  }
  chevronDown(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19,9 L12.3535534,15.6464466 C12.1582912,15.8417088 11.8417088,15.8417088 11.6464466,15.6464466 L5,9",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    )));
  }
  chevronUp(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M19,9 L12.3535534,15.6464466 C12.1582912,15.8417088 11.8417088,15.8417088 11.6464466,15.6464466 L5,9",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(12.000000, 12.500000) rotate(-180.000000) translate(-12.000000, -12.500000) "
      }
    )));
  }
  chevronLeft(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18.6009189,8.60091889 L11.9544723,15.2473655 C11.7592101,15.4426276 11.4426276,15.4426276 11.2473655,15.2473655 L4.60091889,8.60091889",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(11.600919, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-11.600919, -12.000000) "
      }
    )));
  }
  chevronUpDown(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.76464994,4.75433944 L15.7499313,4.75433944 C16.0260737,4.75433944 16.2499313,4.97819706 16.2499313,5.25433944 L16.2499313,13.2396208",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        transform: "translate(12.007291, 9.007291) rotate(-45.000000) translate(-12.007291, -9.007291) "
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.75735931,10.7573593 L15.7426407,10.7573593 C16.0187831,10.7573593 16.2426407,10.9812169 16.2426407,11.2573593 C16.2426407,13.9191198 16.2426407,16.5808802 16.2426407,19.2426407",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero",
        transform: "translate(12.000000, 15.000000) rotate(-225.000000) translate(-12.000000, -15.000000) "
      }
    )));
  }
  feedback(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6,9 L18.5,9",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6,13 L12.5,13",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M13,17 L9.35355339,20.6464466 C9.15829124,20.8417088 8.84170876,20.8417088 8.64644661,20.6464466 L5,17 L2.5,17 C2.22385763,17 2,16.7761424 2,16.5 L2,4.5 C2,4.22385763 2.22385763,4 2.5,4 L21.5,4 C21.7761424,4 22,4.22385763 22,4.5 L22,16.5 C22,16.7761424 21.7761424,17 21.5,17 L13,17 Z",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero"
      }
    )));
  }
  hyperlink(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(11.964466, 11.654701) scale(-1, -1) translate(-11.964466, -11.654701) translate(1.464466, 1.154701)",
        fillRule: "nonzero",
        ...n,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("path", { d: "M9.46446609,12.1547005 C7.51184464,10.2020791 7.51184464,7.107322 9.46446609,5.15470054 C10.7662137,3.8529529 12.0995471,2.51961957 13.4644661,1.15470054 C14.4644661,0.154700538 17.4644661,-0.845299462 19.4644661,1.15470054 C21.4644661,3.15470054 20.4644661,6.15470054 19.4644661,7.15470054 C18.4644661,8.15470054 17.1146601,9.50450658 16.4432869,10.1758797" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M1.77423165,20.3094011 C-0.178389809,18.3567796 -0.178389809,15.2620225 1.77423165,13.3094011 C3.07597929,12.0076534 4.40931262,10.6743201 5.77423165,9.30940108 C6.77423165,8.30940108 9.77423165,7.30940108 11.7742316,9.30940108 C13.7742316,11.3094011 12.7742316,14.3094011 11.7742316,15.3094011 C10.7742316,16.3094011 9.42442561,17.6592071 8.75305245,18.3305803",
          transform: "translate(6.619349, 14.232051) rotate(-180.000000) translate(-6.619349, -14.232051) "
        }
      )
    )));
  }
  move(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(7.500000, 1.000000)",
        fillRule: "nonzero",
        ...n,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M-4,11 L13,11",
          transform: "translate(4.500000, 11.000000) rotate(-90.000000) translate(-4.500000, -11.000000) "
        }
      ),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(0.878680, -0.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3,2.5 L7.24264069,2.5",
          transform: "translate(5.121320, 2.500000) rotate(-675.000000) translate(-5.121320, -2.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M-1.01785247e-12,2.5 L4.24264069,2.5",
          transform: "translate(2.121320, 2.500000) scale(-1, 1) rotate(-675.000000) translate(-2.121320, -2.500000) "
        }
      )),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(0.878680, 17.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,2.5 L4.24264069,2.5",
          transform: "translate(2.121320, 2.500000) rotate(-855.000000) translate(-2.121320, -2.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3,2.5 C5.82842712,2.5 7.24264069,2.5 7.24264069,2.5",
          transform: "translate(5.121320, 2.500000) scale(-1, 1) rotate(-495.000000) translate(-5.121320, -2.500000) "
        }
      ))
    ), /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(12.000000, 11.500000) rotate(-270.000000) translate(-12.000000, -11.500000) translate(8.000000, 0.500000)",
        fillRule: "nonzero",
        ...n,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M-4,11 L13,11",
          transform: "translate(4.500000, 11.000000) rotate(-90.000000) translate(-4.500000, -11.000000) "
        }
      ),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(0.878680, -0.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3,2.5 L7.24264069,2.5",
          transform: "translate(5.121320, 2.500000) rotate(-675.000000) translate(-5.121320, -2.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M-1.08357767e-13,2.5 L4.24264069,2.5",
          transform: "translate(2.121320, 2.500000) scale(-1, 1) rotate(-675.000000) translate(-2.121320, -2.500000) "
        }
      )),
      /* @__PURE__ */ e.createElement("g", { transform: "translate(0.878680, 17.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,2.5 L4.24264069,2.5",
          transform: "translate(2.121320, 2.500000) rotate(-855.000000) translate(-2.121320, -2.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3,2.5 C5.82842712,2.5 7.24264069,2.5 7.24264069,2.5",
          transform: "translate(5.121320, 2.500000) scale(-1, 1) rotate(-495.000000) translate(-5.121320, -2.500000) "
        }
      ))
    ), /* @__PURE__ */ e.createElement("g", { transform: "translate(8.378680, 2.000000)" }), /* @__PURE__ */ e.createElement("g", { transform: "translate(12.000000, 19.500000) rotate(-180.000000) translate(-12.000000, -19.500000) translate(8.000000, 17.000000)" })));
  }
  note(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7,8 L17,8",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7,12 L17,12",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7,16 L13,16",
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero"
      }
    ), /* @__PURE__ */ e.createElement(
      "rect",
      {
        id: "Rectangle",
        ...n,
        strokeWidth: "1.5",
        fillRule: "nonzero",
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "0.5"
      }
    )));
  }
  note2(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(16, t), viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        ...n,
        d: "M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3ZM12 4H4V6H12V4ZM4 7H10V9H4V7ZM8 10H4V12H8V10Z"
      }
    ));
  }
  unlock(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(5.000000, 11.000000)",
        fillRule: "nonzero",
        ...n,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("rect", { x: "0", y: "0", width: "14", height: "10", rx: "0.43" })
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: "M17,7 C17,4.23857625 14.7614237,2 12,2 C9.23857625,2 7,4.23857625 7,7 C7,8.84094917 7,10.1742825 7,11",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        fillRule: "nonzero"
      }
    )));
  }
  drag(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(8.000000, 3.000000)", ...n }, /* @__PURE__ */ e.createElement("circle", { cx: "1.5", cy: "1.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "1.5", cy: "6.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "1.5", cy: "11.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "1.5", cy: "16.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "7.5", cy: "1.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "7.5", cy: "6.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "7.5", cy: "11.5", r: "1.5" }), /* @__PURE__ */ e.createElement("circle", { cx: "7.5", cy: "16.5", r: "1.5" })), /* @__PURE__ */ e.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })));
  }
  funnel(t, n) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "none"
      },
      /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M6,8 L18,8", ...n, strokeWidth: "1.5", fillRule: "nonzero" }), /* @__PURE__ */ e.createElement("path", { d: "M8,12 L16,12", ...n, strokeWidth: "1.5", fillRule: "nonzero" }), /* @__PURE__ */ e.createElement("path", { d: "M10,16 L14,16", ...n, strokeWidth: "1.5", fillRule: "nonzero" }))
    );
  }
  reset(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), width: "24px", height: "24px", viewBox: "0 0 16 16" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: "M7.49999277,2 L7.49999277,2.99999868 L2.49999934,2.99999868 C2.22385733,2.99999868 2,2.77614135 2,2.49999934 C2,2.22385733 2.22385733,2 2.49999934,2 L7.49999277,2 C10.8136969,2 13.4999849,3.68628797 13.4999849,6.99999211 C13.4999849,10.2883416 10.8546476,11.9740839 7.57594546,11.9996881 L7.57594546,11.9999842 L5.54030777,11.9999842 L6.4904285,13.1876351 C6.66293305,13.4032658 6.62797241,13.7179116 6.41234172,13.8904161 C6.19671104,14.0629207 5.88206526,14.02796 5.70956072,13.8123294 L3.85968513,11.4999849 L5.70956072,9.18764039 C5.88206526,8.97200971 6.19671104,8.93704907 6.41234172,9.10955362 C6.62797241,9.28205816 6.66293305,9.59670394 6.4904285,9.81233462 L5.54030777,10.9999855 L7.49999277,10.9999855 C10.2614129,10.9999855 12.4999862,9.76141223 12.4999862,6.99999211 C12.4999862,4.23857199 10.2614129,2.99999868 7.49999277,2.99999868 C7.17870413,2.99999868 7.49962656,2 7.49999277,2 Z"
      }
    ));
  }
  database(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), width: "24px", height: "24px", viewBox: "0 -2 25 28" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...n,
        d: "M12.258.001l.256.004.255.005.253.008.251.01.249.012.247.015.246.016.242.019.241.02.239.023.236.024.233.027.231.028.229.031.225.032.223.034.22.036.217.038.214.04.211.041.208.043.205.045.201.046.198.048.194.05.191.051.187.053.183.054.18.056.175.057.172.059.168.06.163.061.16.063.155.064.15.066.074.033.073.033.071.034.07.034.069.035.068.035.067.035.066.035.064.036.064.036.062.036.06.036.06.037.058.037.058.037.055.038.055.038.053.038.052.038.051.039.05.039.048.039.047.039.045.04.044.04.043.04.041.04.04.041.039.041.037.041.036.041.034.041.033.042.032.042.03.042.029.042.027.042.026.043.024.043.023.043.021.043.02.043.018.044.017.043.015.044.013.044.012.044.011.045.009.044.007.045.006.045.004.045.002.045.001.045v17l-.001.045-.002.045-.004.045-.006.045-.007.045-.009.044-.011.045-.012.044-.013.044-.015.044-.017.043-.018.044-.02.043-.021.043-.023.043-.024.043-.026.043-.027.042-.029.042-.03.042-.032.042-.033.042-.034.041-.036.041-.037.041-.039.041-.04.041-.041.04-.043.04-.044.04-.045.04-.047.039-.048.039-.05.039-.051.039-.052.038-.053.038-.055.038-.055.038-.058.037-.058.037-.06.037-.06.036-.062.036-.064.036-.064.036-.066.035-.067.035-.068.035-.069.035-.07.034-.071.034-.073.033-.074.033-.15.066-.155.064-.16.063-.163.061-.168.06-.172.059-.175.057-.18.056-.183.054-.187.053-.191.051-.194.05-.198.048-.201.046-.205.045-.208.043-.211.041-.214.04-.217.038-.22.036-.223.034-.225.032-.229.031-.231.028-.233.027-.236.024-.239.023-.241.02-.242.019-.246.016-.247.015-.249.012-.251.01-.253.008-.255.005-.256.004-.258.001-.258-.001-.256-.004-.255-.005-.253-.008-.251-.01-.249-.012-.247-.015-.245-.016-.243-.019-.241-.02-.238-.023-.236-.024-.234-.027-.231-.028-.228-.031-.226-.032-.223-.034-.22-.036-.217-.038-.214-.04-.211-.041-.208-.043-.204-.045-.201-.046-.198-.048-.195-.05-.19-.051-.187-.053-.184-.054-.179-.056-.176-.057-.172-.059-.167-.06-.164-.061-.159-.063-.155-.064-.151-.066-.074-.033-.072-.033-.072-.034-.07-.034-.069-.035-.068-.035-.067-.035-.066-.035-.064-.036-.063-.036-.062-.036-.061-.036-.06-.037-.058-.037-.057-.037-.056-.038-.055-.038-.053-.038-.052-.038-.051-.039-.049-.039-.049-.039-.046-.039-.046-.04-.044-.04-.043-.04-.041-.04-.04-.041-.039-.041-.037-.041-.036-.041-.034-.041-.033-.042-.032-.042-.03-.042-.029-.042-.027-.042-.026-.043-.024-.043-.023-.043-.021-.043-.02-.043-.018-.044-.017-.043-.015-.044-.013-.044-.012-.044-.011-.045-.009-.044-.007-.045-.006-.045-.004-.045-.002-.045-.001-.045v-17l.001-.045.002-.045.004-.045.006-.045.007-.045.009-.044.011-.045.012-.044.013-.044.015-.044.017-.043.018-.044.02-.043.021-.043.023-.043.024-.043.026-.043.027-.042.029-.042.03-.042.032-.042.033-.042.034-.041.036-.041.037-.041.039-.041.04-.041.041-.04.043-.04.044-.04.046-.04.046-.039.049-.039.049-.039.051-.039.052-.038.053-.038.055-.038.056-.038.057-.037.058-.037.06-.037.061-.036.062-.036.063-.036.064-.036.066-.035.067-.035.068-.035.069-.035.07-.034.072-.034.072-.033.074-.033.151-.066.155-.064.159-.063.164-.061.167-.06.172-.059.176-.057.179-.056.184-.054.187-.053.19-.051.195-.05.198-.048.201-.046.204-.045.208-.043.211-.041.214-.04.217-.038.22-.036.223-.034.226-.032.228-.031.231-.028.234-.027.236-.024.238-.023.241-.02.243-.019.245-.016.247-.015.249-.012.251-.01.253-.008.255-.005.256-.004.258-.001.258.001zm-9.258 20.499v.01l.001.021.003.021.004.022.005.021.006.022.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.023.018.024.019.024.021.024.022.025.023.024.024.025.052.049.056.05.061.051.066.051.07.051.075.051.079.052.084.052.088.052.092.052.097.052.102.051.105.052.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.048.144.049.147.047.152.047.155.047.16.045.163.045.167.043.171.043.176.041.178.041.183.039.187.039.19.037.194.035.197.035.202.033.204.031.209.03.212.029.216.027.219.025.222.024.226.021.23.02.233.018.236.016.24.015.243.012.246.01.249.008.253.005.256.004.259.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.021.224-.024.22-.026.216-.027.212-.028.21-.031.205-.031.202-.034.198-.034.194-.036.191-.037.187-.039.183-.04.179-.04.175-.042.172-.043.168-.044.163-.045.16-.046.155-.046.152-.047.148-.048.143-.049.139-.049.136-.05.131-.05.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.053.083-.051.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.05.023-.024.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.023.01-.022.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.127l-.077.055-.08.053-.083.054-.085.053-.087.052-.09.052-.093.051-.095.05-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.045-.118.044-.12.043-.122.042-.124.042-.126.041-.128.04-.13.04-.132.038-.134.038-.135.037-.138.037-.139.035-.142.035-.143.034-.144.033-.147.032-.148.031-.15.03-.151.03-.153.029-.154.027-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.01-.179.008-.179.008-.181.006-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.006-.179-.008-.179-.008-.178-.01-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.027-.153-.029-.151-.03-.15-.03-.148-.031-.146-.032-.145-.033-.143-.034-.141-.035-.14-.035-.137-.037-.136-.037-.134-.038-.132-.038-.13-.04-.128-.04-.126-.041-.124-.042-.122-.042-.12-.044-.117-.043-.116-.045-.113-.045-.112-.046-.109-.047-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.05-.093-.052-.09-.051-.087-.052-.085-.053-.083-.054-.08-.054-.077-.054v4.127zm0-5.654v.011l.001.021.003.021.004.021.005.022.006.022.007.022.009.022.01.022.011.023.012.023.013.023.015.024.016.023.017.024.018.024.019.024.021.024.022.024.023.025.024.024.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.052.11.051.114.051.119.052.123.05.127.051.131.05.135.049.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.044.171.042.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.022.23.02.233.018.236.016.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.012.241-.015.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.048.139-.05.136-.049.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.051.051-.049.023-.025.023-.024.021-.025.02-.024.019-.024.018-.024.017-.024.015-.023.014-.023.013-.024.012-.022.01-.023.01-.023.008-.022.006-.022.006-.022.004-.021.004-.022.001-.021.001-.021v-4.139l-.077.054-.08.054-.083.054-.085.052-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.044-.118.044-.12.044-.122.042-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.035-.143.033-.144.033-.147.033-.148.031-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.009-.179.009-.179.007-.181.007-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.007-.179-.007-.179-.009-.178-.009-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.031-.146-.033-.145-.033-.143-.033-.141-.035-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.04-.126-.041-.124-.042-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.051-.093-.051-.09-.051-.087-.053-.085-.052-.083-.054-.08-.054-.077-.054v4.139zm0-5.666v.011l.001.02.003.022.004.021.005.022.006.021.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.024.018.023.019.024.021.025.022.024.023.024.024.025.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.051.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.043.171.043.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.021.23.02.233.018.236.017.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.013.241-.014.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.049.139-.049.136-.049.131-.051.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.049.023-.025.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.022.01-.023.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.153l-.077.054-.08.054-.083.053-.085.053-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.048-.105.048-.106.048-.109.046-.111.046-.114.046-.115.044-.118.044-.12.043-.122.043-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.034-.143.034-.144.033-.147.032-.148.032-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.024-.161.024-.162.023-.163.023-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.01-.178.01-.179.009-.179.007-.181.006-.182.006-.182.004-.184.003-.184.001-.185.001-.185-.001-.184-.001-.184-.003-.182-.004-.182-.006-.181-.006-.179-.007-.179-.009-.178-.01-.176-.01-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.023-.162-.023-.161-.024-.159-.024-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.032-.146-.032-.145-.033-.143-.034-.141-.034-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.041-.126-.041-.124-.041-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.048-.105-.048-.102-.048-.1-.05-.097-.049-.095-.051-.093-.051-.09-.052-.087-.052-.085-.053-.083-.053-.08-.054-.077-.054v4.153zm8.74-8.179l-.257.004-.254.005-.25.008-.247.011-.244.012-.241.014-.237.016-.233.018-.231.021-.226.022-.224.023-.22.026-.216.027-.212.028-.21.031-.205.032-.202.033-.198.034-.194.036-.191.038-.187.038-.183.04-.179.041-.175.042-.172.043-.168.043-.163.045-.16.046-.155.046-.152.048-.148.048-.143.048-.139.049-.136.05-.131.05-.126.051-.123.051-.118.051-.114.052-.11.052-.106.052-.101.052-.096.052-.092.052-.088.052-.083.052-.079.052-.074.051-.07.052-.065.051-.06.05-.056.05-.051.05-.023.025-.023.024-.021.024-.02.025-.019.024-.018.024-.017.023-.015.024-.014.023-.013.023-.012.023-.01.023-.01.022-.008.022-.006.023-.006.021-.004.022-.004.021-.001.021-.001.021.001.021.001.021.004.021.004.022.006.021.006.023.008.022.01.022.01.023.012.023.013.023.014.023.015.024.017.023.018.024.019.024.02.025.021.024.023.024.023.025.051.05.056.05.06.05.065.051.07.052.074.051.079.052.083.052.088.052.092.052.096.052.101.052.106.052.11.052.114.052.118.051.123.051.126.051.131.05.136.05.139.049.143.048.148.048.152.048.155.046.16.046.163.045.168.043.172.043.175.042.179.041.183.04.187.038.191.038.194.036.198.034.202.033.205.032.21.031.212.028.216.027.22.026.224.023.226.022.231.021.233.018.237.016.241.014.244.012.247.011.25.008.254.005.257.004.26.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.022.224-.023.22-.026.216-.027.212-.028.21-.031.205-.032.202-.033.198-.034.194-.036.191-.038.187-.038.183-.04.179-.041.175-.042.172-.043.168-.043.163-.045.16-.046.155-.046.152-.048.148-.048.143-.048.139-.049.136-.05.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.05.051-.05.023-.025.023-.024.021-.024.02-.025.019-.024.018-.024.017-.023.015-.024.014-.023.013-.023.012-.023.01-.023.01-.022.008-.022.006-.023.006-.021.004-.022.004-.021.001-.021.001-.021-.001-.021-.001-.021-.004-.021-.004-.022-.006-.021-.006-.023-.008-.022-.01-.022-.01-.023-.012-.023-.013-.023-.014-.023-.015-.024-.017-.023-.018-.024-.019-.024-.02-.025-.021-.024-.023-.024-.023-.025-.051-.05-.056-.05-.06-.05-.065-.051-.07-.052-.074-.051-.079-.052-.083-.052-.088-.052-.092-.052-.096-.052-.101-.052-.106-.052-.11-.052-.114-.052-.118-.051-.123-.051-.126-.051-.131-.05-.136-.05-.139-.049-.143-.048-.148-.048-.152-.048-.155-.046-.16-.046-.163-.045-.168-.043-.172-.043-.175-.042-.179-.041-.183-.04-.187-.038-.191-.038-.194-.036-.198-.034-.202-.033-.205-.032-.21-.031-.212-.028-.216-.027-.22-.026-.224-.023-.226-.022-.231-.021-.233-.018-.237-.016-.241-.014-.244-.012-.247-.011-.25-.008-.254-.005-.257-.004-.26-.001-.26.001z"
      }
    ));
  }
  add(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement("rect", { x: "0", y: "0", width: "24", height: "24" }), /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(3.000000, 2.000000)",
        className: "svgFill svgStroke",
        ...n,
        ...a
      },
      /* @__PURE__ */ e.createElement("rect", { x: "0.5", y: "9.5", width: "17", height: "1", rx: "0.5" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0.75,9.5 C0.611928813,9.5 0.5,9.61192881 0.5,9.75 C0.5,9.88807119 0.611928813,10 0.75,10 L17.25,10 C17.3880712,10 17.5,9.88807119 17.5,9.75 C17.5,9.61192881 17.3880712,9.5 17.25,9.5 L0.75,9.5 Z",
          transform: "translate(9.000000, 9.750000) rotate(-270.000000) translate(-9.000000, -9.750000) "
        }
      )
    )));
  }
  question(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M11.6588393,14.3830918 L11.6588393,12.5588787 C13.8764885,12.1969332 14.9853132,11.0680179 14.9853132,9.17213304 C14.9853132,5.46915529 8.98531316,5.43770072 8.98531316,9.17213304",
          ...a,
          strokeWidth: "1.5",
          fillRule: "nonzero"
        }
      ),
      /* @__PURE__ */ e.createElement("circle", { ...a, strokeWidth: "1.5", fillRule: "nonzero", cx: "12", cy: "12", r: "10" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M11.25,17.5 C11.25,17.7761424 11.4738576,18 11.75,18 C12.0261424,18 12.25,17.7761424 12.25,17.5 C12.25,17.2238576 12.0261424,17 11.75,17 C11.4738576,17 11.25,17.2238576 11.25,17.5 Z",
          ...a,
          ...n
        }
      )
    ));
  }
  print(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7,18 C5.23529412,18 3.90196078,18 3,18 L3,9 L21,9 L21,18 L17,18",
          ...a,
          strokeWidth: "1.5",
          fillRule: "nonzero"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          ...a,
          strokeWidth: "1.5",
          fillRule: "nonzero",
          x: "7",
          y: "15",
          width: "10",
          height: "7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "rect",
        {
          ...a,
          strokeWidth: "1.5",
          fillRule: "nonzero",
          x: "7",
          y: "2",
          width: "10",
          height: "7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M18,11.5 C18,11.7761424 18.2238576,12 18.5,12 C18.7761424,12 19,11.7761424 19,11.5 C19,11.2238576 18.7761424,11 18.5,11 C18.2238576,11 18,11.2238576 18,11.5 Z",
          ...a,
          ...n
        }
      )
    ));
  }
  bracketEllipses(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(1.000000, 2.000000)",
        fillRule: "nonzero",
        ...a,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", { transform: "translate(0.000000, 0.000000)" }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", { transform: "translate(0.121704, 0.610284)" }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", { transform: "translate(0.378296, 0.000000)" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(0.500000, 0.000000)" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(0.000000, 0.389716)" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(-0.000000, 0.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,9 L2.5,9 C2.77614237,9 3,8.77614237 3,8.5 C3,6.66666667 3,4.83333333 3,3 C3,1.72294665 4,0.722946646 6,0",
          transform: "translate(3.000000, 4.500000) rotate(180.000000) translate(-3.000000, -4.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,18 L2.5,18 C2.77614237,18 3,17.7761424 3,17.5 C3,15.6666667 3,13.8333333 3,12 C3,10.7229466 4,9.72294665 6,9",
          transform: "translate(3.000000, 13.500000) scale(1, -1) rotate(180.000000) translate(-3.000000, -13.500000) "
        }
      )), /* @__PURE__ */ e.createElement("g", { transform: "translate(17.000000, 9.000000) scale(-1, 1) translate(-17.000000, -9.000000) translate(14.000000, 0.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,9 L2.5,9 C2.77614237,9 3,8.77614237 3,8.5 C3,6.66666667 3,4.83333333 3,3 C3,1.72294665 4,0.722946646 6,0",
          transform: "translate(3.000000, 4.500000) rotate(180.000000) translate(-3.000000, -4.500000) "
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0,18 L2.5,18 C2.77614237,18 3,17.7761424 3,17.5 C3,15.6666667 3,13.8333333 3,12 C3,10.7229466 4,9.72294665 6,9",
          transform: "translate(3.000000, 13.500000) scale(1, -1) rotate(180.000000) translate(-3.000000, -13.500000) "
        }
      )))))))))))
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.5,12 C7.5,12.2761424 7.72385763,12.5 8,12.5 C8.27614237,12.5 8.5,12.2761424 8.5,12 C8.5,11.7238576 8.27614237,11.5 8,11.5 C7.72385763,11.5 7.5,11.7238576 7.5,12 Z",
        ...a,
        ...n,
        strokeLinejoin: "round"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.5,12 C11.5,12.2761424 11.7238576,12.5 12,12.5 C12.2761424,12.5 12.5,12.2761424 12.5,12 C12.5,11.7238576 12.2761424,11.5 12,11.5 C11.7238576,11.5 11.5,11.7238576 11.5,12 Z",
        ...a,
        ...n,
        strokeLinejoin: "round"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.5,12 C15.5,12.2761424 15.7238576,12.5 16,12.5 C16.2761424,12.5 16.5,12.2761424 16.5,12 C16.5,11.7238576 16.2761424,11.5 16,11.5 C15.7238576,11.5 15.5,11.7238576 15.5,12 Z",
        ...a,
        ...n,
        strokeLinejoin: "round"
      }
    )));
  }
  copiedToClipboard(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 24 24" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(7.000000, 2.000000)",
        fillRule: "nonzero",
        ...n,
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("g", { transform: "translate(0.000000, 0.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M2,2 L2,0.5 C2,0.223857625 2.22385763,5.07265313e-17 2.5,0 L7.5,0 C7.77614237,-5.07265313e-17 8,0.223857625 8,0.5 L8,2 L10,2 L10,5 L0,5 L0,2 L2,2 Z",
          strokeLinejoin: "round"
        }
      ), /* @__PURE__ */ e.createElement("polyline", { points: "1 12.4890868 3.31559261 14.5576592 8.49413202 9" }))
    ), /* @__PURE__ */ e.createElement(
      "polyline",
      {
        ...n,
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fillRule: "nonzero",
        points: "17 5 20 5 20 21 4 21 4 5 7 5"
      }
    )));
  }
  stories(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "20px", height: "20px", viewBox: "0 0 20 20" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(-2.000000, -2.000000)",
        fillRule: "nonzero",
        stroke: "#8F8FA2",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement("path", { ...n, d: "M21,21 L3.5,21 C3.22385763,21 3,20.7761424 3,20.5 L3,3" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M3,18 L8.74878566,13.2093453 C8.90139198,13.0821733 9.11480766,13.0574038 9.29248466,13.1462423 L14.6267661,15.8133831 C14.8428982,15.9214491 15.1053871,15.8594839 15.2503729,15.6661695 L21,8"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { ...n, d: "M12,4 L12,10", strokeLinejoin: "round" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M12,4 L12,10",
          strokeLinejoin: "round",
          transform: "translate(12.000000, 7.000000) rotate(-270.000000) translate(-12.000000, -7.000000) "
        }
      )
    )));
  }
  document(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "19px", height: "22px", viewBox: "0 0 19 22" }, /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        transform: "translate(-3.000000, -1.000000)",
        fillRule: "nonzero",
        stroke: "#8F8FA2",
        strokeWidth: "1.5"
      },
      /* @__PURE__ */ e.createElement(
        "g",
        {
          transform: "translate(4.000000, 1.011475)",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        /* @__PURE__ */ e.createElement(
          "polygon",
          {
            ...n,
            points: "0 0.988525391 12.75 0.988525391 17 4.98852539 17 20.9885254 0 20.9885254"
          }
        )
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M7,13.5 L17,13.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M7,17 L11.6428571,17",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          ...n,
          d: "M7,10 L11.6428571,10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { ...n, d: "M16,2 L16,6.5 C16,6.77614237 16.2238576,7 16.5,7 L21,7" })
    )));
  }
  program(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "22px", height: "18px", viewBox: "0 0 22 18" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ e.createElement(
        "g",
        {
          transform: "translate(-1.000000, -3.000000)",
          fillRule: "nonzero",
          stroke: "#8F8FA2",
          strokeWidth: "1.5"
        },
        /* @__PURE__ */ e.createElement("rect", { ...n, x: "2", y: "4", width: "20", height: "16" }),
        /* @__PURE__ */ e.createElement("rect", { ...n, x: "5", y: "7", width: "4", height: "4" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M5,17 L11,17" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M5,14 L19,14" })
      )
    ));
  }
  auditLogs(t, n) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "21px", height: "21px", viewBox: "0 0 21 21" }, /* @__PURE__ */ e.createElement(
      "g",
      {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      },
      /* @__PURE__ */ e.createElement(
        "g",
        {
          transform: "translate(-2.000000, -2.000000)",
          fillRule: "nonzero",
          stroke: "#8F8FA2",
          strokeWidth: "1.5"
        },
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M22,22 L18.5,17.5" }),
        /* @__PURE__ */ e.createElement(
          "path",
          {
            ...n,
            d: "M15.5,17.5 C16.9404934,17.5 18.251645,16.9462221 19.2321762,16.039945 C20.3192894,15.035157 21,13.5970727 21,12 C21,8.96243388 18.5375661,6.5 15.5,6.5 C12.4624339,6.5 10,8.96243388 10,12 C10,15.0375661 12.4624339,17.5 15.5,17.5 Z"
          }
        ),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M3,3 C15,3 21,3 21,3" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M3,21 L15,21" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M3,12.5 C5.66666667,12.5 7,12.5 7,12.5" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M3,8 C5.66666667,8 7,8 7,8" }),
        /* @__PURE__ */ e.createElement("path", { ...n, d: "M3,17 C5.66666667,17 7,17 7,17" })
      )
    ));
  }
  pending(t, n) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none"
      },
      /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9.5", ...n, strokeDasharray: "3" })
    );
  }
  timeline(t, n, a) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(24, t), width: "24px", height: "24px", viewBox: "0 0 56.08 56" }, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
      "path",
      {
        ...a,
        d: "M16.08,28a7.978,7.978,0,0,0-6.12-7.76V15.76a7.957,7.957,0,1,0-4-.04v4.56a8.008,8.008,0,0,0,0,15.44v4.56a7.963,7.963,0,1,0,4-.04V35.76A7.978,7.978,0,0,0,16.08,28ZM4.08,8a4,4,0,1,1,4,4H7.96A4.014,4.014,0,0,1,4.08,8ZM12,48a4,4,0,1,1-4.04-4H8A4.012,4.012,0,0,1,12,48ZM8.08,32H7.96a4,4,0,0,1,0-8h.12a4,4,0,0,1,0,8ZM30.714,19.109h0M52.08,20V36H30.121l-5.334-8,5.334-8Zm2-4H29.05a2,2,0,0,0-1.664.891l-6.666,10a2,2,0,0,0,0,2.218l6.666,10A2,2,0,0,0,29.05,40H54.08a2,2,0,0,0,2-2V18a2,2,0,0,0-2-2Z"
      }
    ))));
  }
  invalidIcon(t) {
    return /* @__PURE__ */ e.createElement("svg", { ...this.getSizeStyle(20, t), viewBox: "0 0 20 20" }, /* @__PURE__ */ e.createElement("text", { x: "0", y: "15" }, "?"));
  }
  curvedArrow(t, n, a) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "24",
        height: "24",
        viewBox: "0 0 12 16",
        fill: "none"
      },
      /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
        "path",
        {
          ...a,
          d: "M0 0.5V5.5C0 8.53757 2.46243 11 5.5 11H10.2929L7.14645 14.1465C6.95118 14.3417 6.95118 14.6583 7.14645 14.8536C7.34171 15.0488 7.65829 15.0488 7.85355 14.8536L11.5 11.2071C11.8905 10.8166 11.8905 10.1834 11.5 9.7929L7.85355 6.14645C7.65829 5.95118 7.34171 5.95118 7.14645 6.14645C6.95118 6.34171 6.95118 6.65829 7.14645 6.85355L10.2929 10H5.5C3.01472 10 1 7.98528 1 5.5V0.5H0Z"
        }
      ))
    );
  }
  starHover(t, n, a) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8 12.5L13 15L11.5 10L15 6.5L10 6L8 1L6 6L1 6.5L4.5 10L3 15L8 12.5Z",
          fill: "#FFF4DE"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 11.382L11.3771 13.0705L10.3705 9.71525L12.8007 7.28506L9.29684 6.93467L8 3.69258L6.70316 6.93467L3.19927 7.28506L5.62946 9.71525L4.62287 13.0705L8 11.382ZM3 15L4.5 10L1 6.5L6 6L8 1L10 6L15 6.5L11.5 10L13 15L8 12.5L3 15Z",
          fill: "#FFC13B"
        }
      )
    );
  }
  filePdf(t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M23.6926 8C21.4573 8 19.6284 9.8 19.6284 12V68C19.6284 70.2 21.4573 72 23.6926 72H64.3347C66.57 72 68.3989 70.2 68.3989 68V24L52.1421 8H23.6926Z",
          fill: "#E2E5E7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M56.2063 24H68.3989L52.1421 8V20C52.1421 22.2 53.971 24 56.2063 24Z",
          fill: "#B0B7BD"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { d: "M68.3989 36L56.2063 24H68.3989V36Z", fill: "#CAD1D8" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M60.2705 60C60.2705 61.1 59.356 62 58.2384 62H13.5321C12.4144 62 11.5 61.1 11.5 60V40C11.5 38.9 12.4144 38 13.5321 38H58.2384C59.356 38 60.2705 38.9 60.2705 40V60Z",
          fill: "#BE0D15"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M58.2384 62H19.6284V64H58.2384C59.3561 64 60.2705 63.1 60.2705 62V60C60.2705 61.1 59.3561 62 58.2384 62Z",
          fill: "#CAD1D8"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M30.9884 48.16C30.9884 46.224 29.5804 44.608 27.2284 44.608H22.8124V56H25.0364V51.712H27.2284C29.5804 51.712 30.9884 50.096 30.9884 48.16ZM28.7644 48.16C28.7644 49.088 28.1244 49.712 27.1164 49.712H25.0364V46.592H27.1164C28.1244 46.592 28.7644 47.232 28.7644 48.16ZM41.1313 50.256C41.1313 48.544 41.2593 46.976 39.9792 45.696C39.2273 44.944 38.1553 44.608 36.9713 44.608H32.8593V56H36.9713C38.1553 56 39.2273 55.664 39.9792 54.912C41.2593 53.632 41.1313 51.968 41.1313 50.256ZM38.9073 50.256C38.9073 51.984 38.8433 52.8 38.4273 53.312C38.0433 53.776 37.5313 54.016 36.7633 54.016H35.0833V46.592H36.7633C37.5313 46.592 38.0433 46.832 38.4273 47.296C38.8433 47.808 38.9073 48.528 38.9073 50.256ZM50.9101 46.592V44.608H43.4061V56H45.6301V51.376H50.1261V49.392H45.6301V46.592H50.9101Z",
          fill: "white"
        }
      )
    );
  }
  fileJpeg(t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M23.6926 8C21.4573 8 19.6284 9.8 19.6284 12V68C19.6284 70.2 21.4573 72 23.6926 72H64.3347C66.57 72 68.3989 70.2 68.3989 68V24L52.1421 8H23.6926Z",
          fill: "#E2E5E7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M56.2063 24H68.3989L52.1421 8V20C52.1421 22.2 53.971 24 56.2063 24Z",
          fill: "#B0B7BD"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { d: "M68.3989 36L56.2063 24H68.3989V36Z", fill: "#CAD1D8" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M60.2705 60C60.2705 61.1 59.356 62 58.2384 62H13.5321C12.4144 62 11.5 61.1 11.5 60V40C11.5 38.9 12.4144 38 13.5321 38H58.2384C59.356 38 60.2705 38.9 60.2705 40V60Z",
          fill: "#002D9C"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M58.2384 62H19.6284V64H58.2384C59.3561 64 60.2705 63.1 60.2705 62V60C60.2705 61.1 59.3561 62 58.2384 62Z",
          fill: "#CAD1D8"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M24.4451 52.256V44.608H22.2211V52.16C22.2211 53.472 21.5171 54.112 20.4291 54.112C19.6931 54.112 19.3411 53.84 18.9731 53.472L17.5011 54.928C18.3491 55.776 19.1971 56.096 20.4291 56.096C22.5411 56.096 24.4451 54.768 24.4451 52.256ZM35.129 48.16C35.129 46.224 33.721 44.608 31.369 44.608H26.953V56H29.177V51.712H31.369C33.721 51.712 35.129 50.096 35.129 48.16ZM32.905 48.16C32.905 49.088 32.265 49.712 31.257 49.712H29.177V46.592H31.257C32.265 46.592 32.905 47.232 32.905 48.16ZM44.5039 56V54.016H39.2239V51.248H43.7199V49.264H39.2239V46.592H44.5039V44.608H36.9999V56H44.5039ZM54.7994 51.328V49.664H50.4954V51.52H52.5914V51.952C52.5914 52.576 52.4154 53.088 52.0794 53.472C51.6794 53.904 51.1514 54.112 50.4954 54.112C49.8874 54.112 49.4074 53.92 49.0714 53.52C48.6234 52.992 48.5274 52.544 48.5274 50.304C48.5274 48.048 48.6554 47.632 49.0714 47.104C49.4234 46.704 49.9034 46.496 50.4954 46.496C51.5994 46.496 52.2714 47.056 52.5434 48.16H54.7834C54.4794 46.176 53.0874 44.512 50.4954 44.512C49.2794 44.512 48.2554 44.928 47.4234 45.76C46.9274 46.256 46.6234 46.816 46.4954 47.472C46.3674 48.112 46.3034 49.056 46.3034 50.304C46.3034 51.552 46.3674 52.496 46.4954 53.136C46.6234 53.776 46.9274 54.352 47.4234 54.848C48.2554 55.68 49.2794 56.096 50.4954 56.096C51.7754 56.096 52.8314 55.696 53.7114 54.8C54.4954 53.968 54.7994 52.992 54.7994 51.328Z",
          fill: "white"
        }
      )
    );
  }
  fileTiff(t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M23.6926 8C21.4573 8 19.6284 9.8 19.6284 12V68C19.6284 70.2 21.4573 72 23.6926 72H64.3347C66.57 72 68.3989 70.2 68.3989 68V24L52.1421 8H23.6926Z",
          fill: "#E2E5E7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M56.2063 24H68.3989L52.1421 8V20C52.1421 22.2 53.971 24 56.2063 24Z",
          fill: "#B0B7BD"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { d: "M68.3989 36L56.2063 24H68.3989V36Z", fill: "#CAD1D8" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M60.2705 60C60.2705 61.1 59.356 62 58.2384 62H13.5321C12.4144 62 11.5 61.1 11.5 60V40C11.5 38.9 12.4144 38 13.5321 38H58.2384C59.356 38 60.2705 38.9 60.2705 40V60Z",
          fill: "#3DA3A9"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M58.2384 62H19.6284V64H58.2384C59.3561 64 60.2705 63.1 60.2705 62V60C60.2705 61.1 59.3561 62 58.2384 62Z",
          fill: "#CAD1D8"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M28.7107 46.592V44.608H20.5347V46.592H23.5107V56H25.7347V46.592H28.7107ZM32.7473 56V44.608H30.5233V56H32.7473ZM42.9023 46.592V44.608H35.3983V56H37.6223V51.376H42.1183V49.392H37.6223V46.592H42.9023ZM52.3398 46.592V44.608H44.8358V56H47.0598V51.376H51.5558V49.392H47.0598V46.592H52.3398Z",
          fill: "white"
        }
      )
    );
  }
  fileZip(t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ...this.getSizeStyle(24, t),
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M23.6926 8C21.4573 8 19.6284 9.8 19.6284 12V68C19.6284 70.2 21.4573 72 23.6926 72H64.3347C66.57 72 68.3989 70.2 68.3989 68V24L52.1421 8H23.6926Z",
          fill: "#E2E5E7"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M56.2063 24H68.3989L52.1421 8V20C52.1421 22.2 53.971 24 56.2063 24Z",
          fill: "#B0B7BD"
        }
      ),
      /* @__PURE__ */ e.createElement("path", { d: "M68.3989 36L56.2063 24H68.3989V36Z", fill: "#CAD1D8" }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M60.2705 60C60.2705 61.1 59.356 62 58.2384 62H13.5321C12.4144 62 11.5 61.1 11.5 60V40C11.5 38.9 12.4144 38 13.5321 38H58.2384C59.356 38 60.2705 38.9 60.2705 40V60Z",
          fill: "#434355"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M58.2384 62H19.6284V64H58.2384C59.3561 64 60.2705 63.1 60.2705 62V60C60.2705 61.1 59.3561 62 58.2384 62Z",
          fill: "#CAD1D8"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M32.2843 56V54.016H27.4043L32.2843 46.368V44.608H25.0043V46.592H29.6603L24.7963 54.208V56H32.2843ZM36.4739 56V44.608H34.2499V56H36.4739ZM47.3009 48.16C47.3009 46.224 45.8929 44.608 43.5409 44.608H39.1249V56H41.3489V51.712H43.5409C45.8929 51.712 47.3009 50.096 47.3009 48.16ZM45.0769 48.16C45.0769 49.088 44.4369 49.712 43.4289 49.712H41.3489V46.592H43.4289C44.4369 46.592 45.0769 47.232 45.0769 48.16Z",
          fill: "white"
        }
      )
    );
  }
  getIcon() {
    const { type: t, factor: n, overrideColor: a } = this.props;
    let { mod: l } = this.props, o;
    switch (l) {
      case "disabled":
        o = v.blackLighter5;
        break;
      case "error":
        o = v.statusErrorColor;
        break;
      case "reversed":
        o = "white";
        break;
      case "active":
        o = v.accentColor;
        break;
      case "active-blue":
        o = v.actionColorLighter1;
        break;
      case "warning":
        o = v.statusWarningColor;
        break;
      default:
        l = "default", o = v.blackLighter4;
    }
    a && (o = a);
    const s = this.getStrokeStyle(o, l), d = this.getFillStyle(o, l), c = { size: 16, factor: n };
    switch (t) {
      case "cardstock":
        return this.cardstock(n, s, d);
      case "chevron-down":
        return this.chevronDown(n, s);
      case "chevron-left":
        return this.chevronLeft(n, s);
      case "chevron-right":
        return this.chevronRight(n, s);
      case "chevron-up":
        return this.chevronUp(n, s);
      case "chevron-up-down":
        return this.chevronUpDown(n, s);
      case "marq":
        return this.marq(n, d);
      case "new-site":
        return this.newSite(n, s);
      case "success":
        return this.success(n, s);
      case "checkmark-mixed":
        return this.checkmarkMixed(n, s);
      case "list":
        return this.list(n, d);
      case "sparkle":
        return this.sparkle(n, d);
      case "hamburger":
        return this.hamburger(n, s);
      case "bracket-ellipses":
        return this.bracketEllipses(n, d, s);
      case "loading":
        return this.loading(n, s);
      case "moon":
        return this.moon(n, s);
      case "new-page":
        return this.newPage(n, s);
      case "number":
        return this.number(n, s);
      case "copied-to-clipboard":
        return this.copiedToClipboard(n, s);
      case "phone":
        return this.phone(n, s);
      case "pivot-table":
        return this.pivotTable(n, s);
      case "star-half":
        return this.starHalf(n, d, s);
      case "star-hover":
        return this.starHover(n, d, s);
      case "sun":
        return this.sun(n, s);
      case "feedback":
        return this.feedback(n, s);
      case "hyperlink":
        return this.hyperlink(n, s);
      case "move":
        return this.move(n, s);
      case "note":
        return this.note(n, s);
      case "note2":
        return this.note2(n, d);
      case "unlock":
        return this.unlock(n, s);
      case "question":
        return this.question(n, d, s);
      case "print":
        return this.print(n, d, s);
      case "drag":
        return this.drag(n, d);
      case "reset":
        return this.reset(n, d);
      case "database":
        return this.database(n, s);
      case "add":
        return this.add(n, d, s);
      case "stories":
        return this.stories(n, s);
      case "document":
        return this.document(n, s);
      case "program":
        return this.program(n, s);
      case "audit-logs":
        return this.auditLogs(n, s);
      case "file":
        return this.file(n, s);
      case "jpg":
        return this.jpg(n, s);
      case "pending":
        return this.pending(n, s);
      case "timeline":
        return this.timeline(n, s, d);
      case "curved-arrow":
        return this.curvedArrow(n, s, d);
      case "funnel":
        return this.funnel(n, s);
      case "old-user":
        return this.oldUser(n, s);
      case "old-home":
        return this.oldHome(n, s);
      case "file-pdf":
        return this.filePdf(n);
      case "file-jpeg":
        return this.fileJpeg(n);
      case "file-tiff":
        return this.fileTiff(n);
      case "file-zip":
        return this.fileZip(n);
      default:
        return this.getCustomIcons(t, n) || this.getSvgFillStyle(t, c, d) || this.getFlagIcon(t) || this.getNetworkIcon(t, n) || this.invalidIcon(n);
    }
  }
  get shouldRenderHoverEffect() {
    const { noHoverEffects: t, hasTooltip: n, onClick: a } = this.props;
    return !(t || !a && n);
  }
  get iconContainerBlackList() {
    return ["star-hover"];
  }
  get fillBlacklist() {
    return ["new-layer"];
  }
  render() {
    const { factor: t, mod: n, onClick: a, style: l, type: o, className: s, testId: d } = this.props, c = 24 + (t - 1) * 8, m = {};
    a && (m.cursor = "pointer");
    let h = this.getCustomIcons(o) || this.getSvgFillStyle(o, {}, {}) || this.iconContainerBlackList.includes(o) ? { ...l } : Object.assign(m, { width: c, height: c }, l);
    const p = M(
      we.container,
      s,
      { [we.disabled]: n === "disabled" },
      { [we.noHoverEffects]: !this.shouldRenderHoverEffect },
      { [we.customIcon]: !!Ft[o] }
    );
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: p,
        "data-testid": d || `volt-icon__${o}${n ? `-${n}` : ""}`,
        "data-size": c,
        style: h,
        onClick: a
      },
      this.getIcon()
    );
  }
}
t2.propTypes = {
  factor: i.number,
  hasTooltip: i.bool,
  mod: i.string,
  noHoverEffects: i.bool,
  onClick: i.func,
  overrideColor: i.string,
  // This is to be used VERY infrequently. Consult designers for exceptions to use this field.
  style: i.object,
  type: i.string
};
t2.defaultProps = {
  factor: 1,
  hasTooltip: !1,
  mod: "default",
  noHoverEffects: !1,
  onClick: null,
  style: {},
  type: "new-page"
};
const V = t2, fr = "_contentContainer_1hcxw_1", Er = "_active_1hcxw_16", Lr = "_additionalSpace_1hcxw_22", wr = "_defaultControl_1hcxw_37", vr = "_disabled_1hcxw_51", yr = "_controlActive_1hcxw_69", br = "_portal_1hcxw_78", Ar = "_rawContainer_1hcxw_89", Hr = "_controlContainer_1hcxw_94", xr = "_anchorRight_1hcxw_106", Mr = "_withCaret_1hcxw_110", ie = {
  contentContainer: fr,
  active: Er,
  additionalSpace: Lr,
  defaultControl: wr,
  disabled: vr,
  controlActive: yr,
  portal: br,
  rawContainer: Ar,
  controlContainer: Hr,
  anchorRight: xr,
  withCaret: Mr
};
class n2 extends N {
  // Spacer is factors of 8px
  render() {
    const { factor: t, inline: n, transition: a, testId: l } = this.props, o = n ? "span" : "div", s = n ? "inline-block" : "block";
    return /* @__PURE__ */ e.createElement(
      o,
      {
        "data-testid": l,
        style: {
          width: t * 8,
          transition: a ? "width .2s ease-out" : "",
          display: s
        }
      }
    );
  }
}
n2.propTypes = {
  factor: i.number,
  inline: i.bool,
  transition: i.bool,
  testId: i.string
};
n2.defaultProps = {
  factor: 1,
  inline: !1,
  transition: !1,
  testId: "volt-hspacer"
};
const B = n2;
class K1 extends e.PureComponent {
  constructor(t) {
    super(t), this.state = {
      contentPositionX: null,
      contentPositionTop: null
    }, this.toggleDropdown = this.toggleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.content = e.createRef(), this.control = e.createRef(), this.eventListenersSetup = !1, this.updateContentPosition = this.updateContentPosition.bind(this);
  }
  componentDidMount() {
    this.setupEventListeners();
  }
  componentWillUnmount() {
    this.tearDownEventListeners();
  }
  componentDidUpdate(t, n) {
    const { fixOverflow: a } = this.props;
    a && (this.updateContentPosition(), setTimeout(this.updateContentPosition, 100), this.eventListenersSetup || this.setupEventListeners());
  }
  setupEventListeners() {
    const { fixOverflow: t } = this.props;
    document.addEventListener("mousedown", this.handleClickOutside), typeof window < "u" && t && (window.addEventListener("resize", this.updateContentPosition), window.addEventListener("scroll", this.updateContentPosition)), this.eventListenersSetup = !0;
  }
  tearDownEventListeners() {
    document.removeEventListener("mousedown", this.handleClickOutside), typeof window < "u" && (window.removeEventListener("resize", this.updateContentPosition), window.removeEventListener("scroll", this.updateContentPosition));
  }
  updateContentPosition() {
    const { contentPositionX: t, contentPositionTop: n } = this.state;
    try {
      const a = this.content && this.content.current && this.content.current.getBoundingClientRect();
      if (a && a.left && a.right) {
        const { left: l, top: o } = a;
        (t !== l || n !== o) && this.setState({ contentPositionX: l, contentPositionTop: o });
      }
    } catch (a) {
      console.error(a);
    }
  }
  handleClickOutside(t) {
    const { closeDropdown: n, preventCloseClassList: a } = this.props;
    if (a && a.length && this.preventCloseFromClassList(t))
      return;
    const l = this.content && this.content.current && this.content.current.contains(t.target), o = this.control && this.control.current && this.control.current.contains(t.target);
    !l && !o && n();
  }
  preventCloseFromClassList(t) {
    const { preventCloseClassList: n } = this.props, l = this.getEventParentClassNames(t).map((o) => typeof o.className == "string" ? o.className : null).filter(Boolean);
    for (let o = 0; o < l.length; o++) {
      const s = l[o];
      for (let d = 0; d < n.length; d++) {
        const c = n[d];
        if (s.includes(c))
          return !0;
      }
    }
    return !1;
  }
  getEventParentClassNames(t) {
    let n = t.path;
    if (!n) {
      let a = [], l = t.target;
      for (; l; )
        a.push(l), l = l.parentElement;
      a.indexOf(window) === -1 && a.indexOf(document) === -1 && a.push(document), a.indexOf(window) === -1 && a.push(window), n = a;
    }
    return n;
  }
  toggleDropdown() {
    const { disabled: t, toggleDropdown: n } = this.props;
    t || n();
  }
  renderTooltipControl() {
    const { tooltipText: t, tooltipWidth: n, tooltipDirection: a, control: l } = this.props;
    return /* @__PURE__ */ e.createElement(Me, { content: t, width: n, direction: a }, this.renderControlContent());
  }
  renderControl() {
    const { active: t, tooltipText: n, control: a, disabled: l } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: this.control,
        "data-testid": "control-container",
        onClick: this.toggleDropdown,
        className: `${ie.controlContainer} ${l ? ie.disabled : ""}`
      },
      n && !t && !l ? this.renderTooltipControl() : this.renderControlContent()
    );
  }
  renderControlContent() {
    const { control: t, useDefaultControl: n, active: a, disabled: l } = this.props;
    return typeof t == "string" || n ? /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${ie.defaultControl} ${a ? ie.controlActive : ""} ${l ? ie.disabled : ""}`
      },
      /* @__PURE__ */ e.createElement(y, { mod: a ? "active" : "" }, t),
      /* @__PURE__ */ e.createElement(B, null),
      /* @__PURE__ */ e.createElement(
        V,
        {
          type: "caret-down",
          noHoverEffects: !0,
          mod: l ? "disabled" : "default",
          style: { width: 16, height: 16 }
        }
      )
    ) : t;
  }
  renderContent() {
    const {
      active: t,
      children: n,
      anchor: a,
      contentPadding: l,
      fixOverflow: o,
      withCaret: s,
      additionalSpace: d
    } = this.props;
    let { contentContainerStyle: c } = this.props;
    const m = t ? 1 : 0, h = t ? "auto" : "none", p = M(
      ie.contentContainer,
      { [ie.withCaret]: s },
      { [ie.active]: t },
      { [ie.anchorRight]: a === "right" },
      { [ie.additionalSpace]: d }
    );
    c = c || {};
    const u = { opacity: m, padding: l, pointerEvents: h, ...c };
    return o && (u.opacity = 0, u.visibility = "hidden", u.pointerEvents = "none"), /* @__PURE__ */ e.createElement(
      "div",
      {
        style: u,
        "data-testid": "content-container",
        className: p,
        ref: this.content
      },
      d ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", null, n), /* @__PURE__ */ e.createElement("div", null)) : n
    );
  }
  renderPortalContent() {
    const {
      active: t,
      children: n,
      anchor: a,
      contentPadding: l,
      fixOverflow: o,
      portalZIndex: s,
      useAbsolutePositioningForPortal: d
    } = this.props;
    let { contentContainerStyle: c } = this.props;
    const { contentPositionX: m, contentPositionTop: h } = this.state;
    if (!o)
      return null;
    const p = [ie.contentContainer, ie.portal], u = t ? 1 : 0, C = t ? "auto" : "none";
    c = c || {};
    const g = {
      opacity: u,
      padding: l,
      pointerEvents: C,
      ...c,
      ...d ? { position: "absolute" } : {}
    };
    return a === "right" && p.push(ie.anchorRight), g.left = m, g.top = h, typeof s < "u" && (g.zIndex = s), /* @__PURE__ */ e.createElement(b1, null, /* @__PURE__ */ e.createElement("div", { style: g, "data-testid": "content-container-portal", className: p.join(" ") }, n));
  }
  render() {
    const { active: t, testId: n } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: `${ie.rawContainer} ${t ? "vt-active" : ""}`, "data-testid": n }, this.renderControl(), this.renderContent(), this.renderPortalContent());
  }
}
K1.propTypes = {
  active: i.bool,
  closeDropdown: i.func,
  toggleDropdown: i.func,
  control: i.any,
  useDefaultControl: i.bool,
  contentPadding: i.number,
  disabled: i.bool,
  anchor: i.string,
  tooltipText: i.any,
  tooltipWidth: i.oneOfType([i.string, i.number]),
  tooltipDirection: i.string,
  fixOverflow: i.bool,
  preventCloseClassList: i.array,
  portalZIndex: i.number,
  testId: i.string,
  contentContainerStyle: i.object,
  useAbsolutePositioningForPortal: i.bool,
  withCaret: i.bool,
  additionalSpace: i.bool
};
K1.defaultProps = {
  active: !1,
  closeDropdown: () => {
  },
  toggleDropdown: () => {
  },
  control: "",
  useDefaultControl: !1,
  contentPadding: 16,
  disabled: !1,
  anchor: "left",
  tooltipText: null,
  tooltipDirection: "bottom",
  tooltipWidth: null,
  fixOverflow: !1,
  preventCloseClassList: [],
  portalZIndex: void 0,
  testId: "volt-controlled-raw-dropdown",
  contentContainerStyle: {},
  useAbsolutePositioningForPortal: !1,
  withCaret: !1,
  additionalSpace: !1
};
const Vr = "_itemContainer_133kc_1", Dr = "_active_133kc_20", Fr = "_contentContainer_133kc_23", kr = "_mainContentContainer_133kc_27", Zr = "_filterContainer_133kc_33", Br = "_childrenContainer_133kc_39", Or = "_open_133kc_45", Sr = "_anchorLeft_133kc_48", Ir = "_anchorRight_133kc_52", Pr = "_defaultItemIcon_133kc_60", He = {
  itemContainer: Vr,
  active: Dr,
  contentContainer: Fr,
  mainContentContainer: kr,
  filterContainer: Zr,
  childrenContainer: Br,
  open: Or,
  anchorLeft: Sr,
  anchorRight: Ir,
  defaultItemIcon: Pr
};
class J1 extends e.PureComponent {
  renderIcon() {
    const { hasChildren: t } = this.props;
    return t ? /* @__PURE__ */ e.createElement("div", { className: He.defaultItemIcon }, /* @__PURE__ */ e.createElement(V, { type: "view-more-horizontal" })) : /* @__PURE__ */ e.createElement("div", null);
  }
  renderText() {
    const { text: t, active: n, handleClick: a } = this.props;
    let l;
    return n === void 0 ? l = /* @__PURE__ */ e.createElement(y, null, t) : l = /* @__PURE__ */ e.createElement(s1, { active: n, onClick: a }, t), /* @__PURE__ */ e.createElement("div", { className: He.itemText }, l);
  }
  render() {
    const { hoverActive: t, handleClick: n, handleMouseOver: a, handleMouseOut: l, text: o } = this.props, s = [He.itemContainer];
    return t && s.push(He.active), /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": `action-drop-down-button_${o}`,
        onMouseOver: a,
        onMouseOut: l,
        className: s.join(" "),
        onClick: n
      },
      this.renderText(),
      this.renderIcon()
    );
  }
}
J1.propTypes = {
  hoverActive: i.bool,
  active: i.bool,
  hasChildren: i.bool,
  handleClick: i.func,
  handleMouseOut: i.func,
  handleMouseOver: i.func,
  text: i.string
};
J1.defaultProps = {
  hoverActive: !1,
  active: void 0,
  hasChildren: !1,
  handleClick: () => {
  },
  handleMouseOut: () => {
  },
  handleMouseOver: () => {
  },
  text: ""
};
class a2 extends e.PureComponent {
  constructor(t) {
    super(t), this.state = {
      searchVal: ""
    }, this.handleFilter = this.handleFilter.bind(this);
  }
  handleFilter(t) {
    this.setState({ searchVal: t.target.value });
  }
  renderFilter() {
    const { searchVal: t } = this.state, { filterable: n, childrenContainerWidth: a } = this.props;
    if (n) {
      const l = typeof a == "number" ? a - 32 : a;
      return /* @__PURE__ */ e.createElement("div", { className: He.filterContainer }, /* @__PURE__ */ e.createElement(me, { onChange: this.handleFilter, leftIcon: "search", width: l, value: t }));
    }
  }
  renderContent() {
    const { content: t, anchor: n, filterable: a } = this.props, { searchVal: l } = this.state, s = t && t.length && l && l.length && a && t.filter((c) => c.filterVal && typeof c.filterVal == "string" ? c.filterVal.toLowerCase().includes(l.toLowerCase()) : null);
    return (s || t).map((c, m) => typeof c.element == "string" ? /* @__PURE__ */ e.createElement(
      J1,
      {
        key: m,
        anchor: n,
        text: c.element,
        active: c.active,
        handleClick: c.onClick
      }
    ) : /* @__PURE__ */ e.createElement("div", { key: m, onClick: c.onClick }, c.element));
  }
  getStandardStyle() {
    const { content: t, childrenContainerWidth: n } = this.props, a = { width: "0px" };
    return t.length && (a.width = n), a;
  }
  getPortalStyle() {
    const { content: t, childrenContainerWidth: n } = this.props, a = {
      width: n,
      opacity: 0,
      visibility: "hidden",
      overflow: "none"
    };
    return t.length && (a.opacity = 1, a.visibility = "visible", a.overflow = "auto"), a;
  }
  getStyle() {
    const { fixOverflow: t } = this.props;
    return t ? this.getPortalStyle() : this.getStandardStyle();
  }
  render() {
    const { anchor: t, content: n, fixOverflow: a } = this.props, l = [He.childrenContainer];
    return n.length && (t === "left" ? l.push(He.anchorLeft) : l.push(He.anchorRight), l.push(He.open)), !n.length && a ? null : /* @__PURE__ */ e.createElement("div", { style: this.getStyle(), className: l.join(" ") }, this.renderFilter(), this.renderContent());
  }
}
a2.propTypes = {
  content: i.array,
  anchor: i.string,
  filterable: i.bool,
  fixOverflow: i.bool,
  childrenContainerWidth: i.number
};
a2.defaultProps = {
  content: [],
  anchor: "right",
  filterable: !1,
  fixOverflow: !1,
  childrenContainerWidth: 230
};
class r2 extends e.PureComponent {
  constructor(t) {
    super(t), this.state = {
      searchVal: "",
      activeIdx: null,
      active: !1
    }, this.hoverDelayTimeout = null, this.handleMouseOut = this.handleMouseOut.bind(this), this.handleMouseOver = this.handleMouseOver.bind(this), this.closeDropdown = this.closeDropdown.bind(this), this.toggleDropdown = this.toggleDropdown.bind(this);
  }
  closeDropdown() {
    this.setState({ ...this.state, active: !1, activeIdx: null });
  }
  toggleDropdown() {
    this.setState((t) => ({ ...t, active: !t.active }));
  }
  componentWillUnmount() {
    this.handleMouseOut();
  }
  handleMouseOver(t) {
    clearTimeout(this.hoverDelayFunc), this.hoverDelayTimeout = setTimeout(() => this.setState({ activeIdx: t }), 100);
  }
  handleMouseOut() {
    clearTimeout(this.hoverDelayTimeout);
  }
  renderControl() {
    const { control: t } = this.props;
    return t || /* @__PURE__ */ e.createElement(V, { type: "view-more-horizontal" });
  }
  renderChildren() {
    const { activeIdx: t } = this.state, { content: n, anchor: a, childrenContainerWidth: l, fixOverflow: o } = this.props, s = n[t] || {}, d = s.children || [];
    return /* @__PURE__ */ e.createElement(
      a2,
      {
        content: d,
        filterable: s.filterable,
        childrenContainerWidth: l,
        anchor: a,
        fixOverflow: o
      }
    );
  }
  renderContent() {
    const { content: t, anchor: n, contentMinHeight: a, maxHeight: l, tooltipWidth: o } = this.props, { activeIdx: s, active: d } = this.state, c = n === "left", m = t.map((p, u) => {
      const C = !!(p.children && p.children.length), E = u === s;
      return typeof p.element == "string" ? /* @__PURE__ */ e.createElement(
        J1,
        {
          hoverActive: E,
          key: u,
          anchor: n,
          hasChildren: C,
          text: p.element,
          active: p.active,
          handleClick: p.onClick,
          handleMouseOver: this.handleMouseOver.bind(this, u),
          handleMouseOut: this.handleMouseOut
        }
      ) : /* @__PURE__ */ e.createElement(
        "div",
        {
          key: u,
          onClick: p.onClick,
          onMouseOut: this.handleMouseOut,
          onMouseOver: this.handleMouseOver.bind(this, u)
        },
        p.element
      );
    }), h = { maxHeight: l, width: o };
    return a && (h.minHeight = a), /* @__PURE__ */ e.createElement("div", { className: `${He.contentContainer} action-dropdown-content`, style: h }, !c && this.renderChildren(), /* @__PURE__ */ e.createElement("div", null, m), c && this.renderChildren());
  }
  render() {
    const {
      tooltipText: t,
      tooltipWidth: n,
      tooltipDirection: a,
      anchor: l,
      fixOverflow: o,
      portalZIndex: s,
      testId: d
    } = this.props;
    return /* @__PURE__ */ e.createElement(
      K1,
      {
        control: this.renderControl(),
        anchor: l,
        tooltipText: t,
        tooltipWidth: n,
        tooltipDirection: a,
        contentPadding: 0,
        fixOverflow: o,
        preventCloseClassList: ["action-dropdown-content"],
        portalZIndex: s,
        testId: d,
        active: this.state.active,
        closeDropdown: this.closeDropdown,
        toggleDropdown: this.toggleDropdown
      },
      this.renderContent()
    );
  }
}
r2.propTypes = {
  content: i.array,
  control: i.any,
  anchor: i.string,
  childrenContainerWidth: i.number,
  tooltipText: i.any,
  tooltipWidth: i.oneOfType([i.string, i.number]),
  tooltipDirection: i.string,
  contentMinHeight: i.any,
  fixOverflow: i.bool,
  maxHeight: i.string,
  portalZIndex: i.number,
  testId: i.string
};
r2.defaultProps = {
  content: [],
  control: null,
  anchor: "right",
  tooltipText: null,
  tooltipDirection: "bottom",
  tooltipWidth: null,
  childrenContainerWidth: 240,
  contentMinHeight: null,
  fixOverflow: !1,
  maxHeight: "400px",
  portalZIndex: void 0,
  testId: "volt-action-dropdown"
};
function N1(r) {
  if (!r)
    return;
  const t = new Date(r);
  return `${t.getFullYear().toString().padStart(4, "0")}-${(t.getMonth() + 1).toString().padStart(2, "0")}-${t.getDate().toString().padStart(2, "0")}, ${t.getHours().toString().padStart(2, "0")}:${t.getMinutes().toString().padStart(2, "0")}`;
}
const Nr = "_flex_vezcj_1", Rr = "_flexColumn_vezcj_5", Tr = "_activityInput_vezcj_9", Ur = "_activityInputIcon_vezcj_14", Gr = "_activityInputIconText_vezcj_21", zr = "_activityText_vezcj_29", Wr = "_activityInputButtonsWrapper_vezcj_37", jr = "_activitiesList_vezcj_41", Xr = "_activityAction_vezcj_47", Yr = "_activityHeaderFourColumns_vezcj_54", Qr = "_activityHeaderEightColumns_vezcj_55", Kr = "_activityNote_vezcj_64", U = {
  flex: Nr,
  flexColumn: Rr,
  activityInput: Tr,
  activityInputIcon: Ur,
  activityInputIconText: Gr,
  activityText: zr,
  activityInputButtonsWrapper: Wr,
  activitiesList: jr,
  activityAction: Xr,
  activityHeaderFourColumns: Yr,
  activityHeaderEightColumns: Qr,
  activityNote: Kr
}, Jr = (r) => {
  const t = [
    "#602865",
    "#AE68C0",
    "#A6026C",
    "#1285F0",
    "#6256E9",
    "#2100D9",
    "#1E839A",
    "#2A206A"
  ], n = r.charCodeAt(0) + r.charCodeAt(1);
  return t[n % t.length];
}, W0 = (r) => /* @__PURE__ */ e.createElement("div", { "data-testid": "activity-wrapper" }, /* @__PURE__ */ e.createElement(qr, { ...r }), /* @__PURE__ */ e.createElement($r, { ...r }), /* @__PURE__ */ e.createElement(e4, { ...r }), /* @__PURE__ */ e.createElement(n4, { ...r })), qr = ({ header: r, id: t }) => r ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(y, { type: "h4", id: t }, r), /* @__PURE__ */ e.createElement(F, { factor: 2 })) : !1, $r = ({
  hideInput: r,
  addActivityHandler: t,
  userInitials: n,
  fourColumns: a,
  id: l,
  error: o,
  onInputChange: s,
  preventAppearButtons: d
}) => {
  if (r)
    return null;
  const [c, m] = z(""), [h, p] = z(!1), u = a ? 320 : 696, C = (A) => {
    const {
      target: { value: Z }
    } = A;
    m(Z), s && s(Z);
  }, E = () => {
    m(""), p(!1);
  }, g = async () => {
    c && (t && await t(c), E());
  }, L = h ? { marginTop: "-26px" } : { marginTop: "-2px" }, x = `
    ${U.flex}
    ${U.flexColumn}
  `;
  return /* @__PURE__ */ e.createElement("div", { className: x }, /* @__PURE__ */ e.createElement("div", { className: U.activityInput }, /* @__PURE__ */ e.createElement(
    j0,
    {
      userInitials: n,
      topMargin: L,
      fourColumns: a
    }
  ), /* @__PURE__ */ e.createElement(B, null), /* @__PURE__ */ e.createElement(
    b3,
    {
      error: o,
      noResize: !0,
      onChange: C,
      onFocus: p.bind(void 0, !0),
      placeholder: "Add a note",
      rows: h ? 2 : 1,
      testId: "activity-input",
      value: c,
      width: u
    }
  )), /* @__PURE__ */ e.createElement(F, { factor: 2 }), d ? null : /* @__PURE__ */ e.createElement(
    _r,
    {
      showButtons: h,
      cancelHandler: E,
      addNoteHandler: g
    }
  ));
}, _r = ({ showButtons: r, cancelHandler: t, addNoteHandler: n }) => r ? /* @__PURE__ */ e.createElement("div", { className: U.activityInputButtonsWrapper }, /* @__PURE__ */ e.createElement("div", { className: U.flex }, /* @__PURE__ */ e.createElement(J, { type: "tertiary", onClick: t, testId: "activity-cancel-btn" }, "Cancel"), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(J, { onClick: n, testId: "activity-addNote-btn" }, "Add note")), /* @__PURE__ */ e.createElement(F, { factor: 2 })) : null, j0 = e.memo(({ userInitials: r = "", topMargin: t = {}, fourColumns: n }) => {
  const a = `${U.activityInputIconText} ${U.activityText}`, l = Jr(r), s = {
    background: r ? l : "#2A206A",
    ...t,
    ...n ? { margin: "4px -1px 0 -1px" } : {}
  }, d = {
    width: "14px",
    height: "24px",
    marginLeft: "5px"
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: U.activityInputIcon,
      style: s,
      "data-testid": "activity-input-icon-wrapper"
    },
    r ? /* @__PURE__ */ e.createElement("span", { className: a }, r.toUpperCase()) : /* @__PURE__ */ e.createElement(V, { type: "marq", overrideColor: "#fff", noHoverEffects: !0, style: d })
  );
}), e4 = ({ activities: r, fourColumns: t, showAllActivities: n, id: a }) => {
  if (r.length < 1)
    return null;
  let l = n ? r : r.slice(0, 7);
  return /* @__PURE__ */ e.createElement("ol", { className: U.activitiesList, "data-testid": "activity-list", "aria-labelledby": a }, l.map((o, s) => {
    const d = s !== 0;
    return /* @__PURE__ */ e.createElement(
      t4,
      {
        notFirstItem: d,
        fourColumns: t,
        ...o,
        key: o.token
      }
    );
  }));
}, t4 = ({
  notFirstItem: r,
  fourColumns: t,
  userInitials: n,
  email: a,
  createdTime: l,
  description: o,
  note: s
}) => {
  const d = {
    fontWeight: 500,
    marginLeft: 3
  };
  let c = 728, m = 696, h = /* @__PURE__ */ e.createElement("div", { className: U.activityHeaderEightColumns }, /* @__PURE__ */ e.createElement("span", { className: `${U.activityText} ${U.activityAction}` }, o), a && /* @__PURE__ */ e.createElement("span", { className: U.activityText, style: d }, a), l && /* @__PURE__ */ e.createElement("span", { className: U.activityText, style: d }, N1(l)));
  if (t) {
    c = 352, m = 320;
    const p = `
      ${U.flex}
      ${U.flexColumn}
      ${U.activityHeaderFourColumns}
    `;
    h = /* @__PURE__ */ e.createElement("div", { className: p }, /* @__PURE__ */ e.createElement("span", { className: U.activityText }, o), /* @__PURE__ */ e.createElement("div", null, a && /* @__PURE__ */ e.createElement("span", { className: `${U.activityText} ${U.activityAction}`, style: d }, a), l && /* @__PURE__ */ e.createElement("span", { className: U.activityText, style: d }, N1(l))));
  }
  return /* @__PURE__ */ e.createElement(e.Fragment, null, r && /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement(
    "li",
    {
      className: U.flex,
      style: { width: c },
      "data-testid": "activity-listItem"
    },
    /* @__PURE__ */ e.createElement(j0, { userInitials: n, fourColumns: t }),
    /* @__PURE__ */ e.createElement(B, null),
    /* @__PURE__ */ e.createElement("div", { className: `${U.flex} ${U.flexColumn}`, style: { width: m } }, h, s && /* @__PURE__ */ e.createElement(y, { className: U.activityNote }, s))
  ));
}, n4 = ({ activities: r, viewAllHandler: t, showAllActivities: n }) => r.length < 8 || n ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement(Ne, { onClick: t, testId: "activity-viewAll-link" }, "View all"));
W0.propTypes = {
  activities: i.array,
  addActivityHandler: i.func,
  error: i.string,
  fourColumns: i.bool,
  header: i.string,
  hideInput: i.bool,
  id: i.string,
  showAllActivities: i.bool,
  userInitials: i.string.isRequired,
  viewAllHandler: i.func,
  preventAppearButtons: i.bool,
  onInputChange: i.func
};
W0.defaultProps = {
  preventAppearButtons: !1,
  activities: [],
  addActivityHandler: () => {
  },
  error: "",
  fourColumns: !1,
  header: "Activity",
  hideInput: !1,
  showAllActivities: !1,
  viewAllHandler: () => {
  }
};
const a4 = "_wrap_1nz6i_1", r4 = "_inputWrap_1nz6i_6", i4 = "_input_1nz6i_6", l4 = "_hasValue_1nz6i_28", o4 = "_disabledWrap_1nz6i_32", s4 = "_changed_1nz6i_33", d4 = "_completed_1nz6i_33", c4 = "_newActionCard_1nz6i_33", m4 = "_rightButton_1nz6i_34", h4 = "_clickable_1nz6i_34", p4 = "_focused_1nz6i_36", u4 = "_rightAddOnWrap_1nz6i_38", C4 = "_disabled_1nz6i_32", g4 = "_activeLeftIcon_1nz6i_50", f4 = "_activeRightIcon_1nz6i_54", E4 = "_errorWrap_1nz6i_67", L4 = "_labelWrap_1nz6i_79", w4 = "_labelTooltip_1nz6i_85", v4 = "_preventErrorPushdown_1nz6i_91", y4 = "_leftIcon_1nz6i_134", b4 = "_rightIcon_1nz6i_136", A4 = "_spinner_1nz6i_177", H4 = "_spinnerRotate_1nz6i_1", x4 = "_flexCenter_1nz6i_187", X = {
  wrap: a4,
  inputWrap: r4,
  input: i4,
  hasValue: l4,
  disabledWrap: o4,
  changed: s4,
  completed: d4,
  newActionCard: c4,
  rightButton: m4,
  clickable: h4,
  focused: p4,
  rightAddOnWrap: u4,
  disabled: C4,
  activeLeftIcon: g4,
  activeRightIcon: f4,
  errorWrap: E4,
  labelWrap: L4,
  labelTooltip: w4,
  preventErrorPushdown: v4,
  leftIcon: y4,
  rightIcon: b4,
  spinner: A4,
  spinnerRotate: H4,
  flexCenter: x4
};
let M4 = 0;
function Pe(r = "") {
  if (typeof r != "string")
    throw new Error(`uniqueId takes an argument of type String. It was passed ${typeof r}`);
  const t = ++M4;
  return r + t;
}
class i2 extends N {
  constructor(t) {
    super(t), this.state = {
      error: null,
      blurred: !1,
      focused: !1,
      previousValue: ""
    }, this.checkIsError = this.checkIsError.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleKeyPress = this.handleKeyPress.bind(this), this.handleChange = this.handleChange.bind(this), this.inputId = this.props.id || Pe("volt-input__");
  }
  // lifecycle & helpers
  componentDidMount() {
    const { runIsErrorOnLoad: t } = this.props;
    t && this.checkIsError();
  }
  componentDidUpdate(t) {
    t.id !== this.props.id && (this.inputId = this.props.id, this.forceUpdate());
  }
  checkIsError() {
    const { isError: t, value: n } = this.props;
    t && this.setState({ error: t(n) });
  }
  rightAddOnValid() {
    const { rightAddOn: t, rightIcon: n, loading: a } = this.props;
    return t && t.content && !n && !a;
  }
  // handlers
  handleChange(t) {
    const { onChange: n } = this.props;
    n && n(t);
  }
  handleBlur() {
    const { previousValue: t } = this.state, { value: n, onBlur: a } = this.props;
    this.setState({ focused: !1 }), t !== n && this.checkIsError(), a && a();
  }
  handleFocus() {
    const { value: t, disabled: n, hasChangedType: a } = this.props;
    a && n || this.setState({ focused: !0, previousValue: t });
  }
  handleKeyPress(t) {
    const { onEnterKeyPressed: n } = this.props;
    t.key === "Enter" && n && n();
  }
  // renders
  renderInput() {
    const {
      autoFocus: t,
      autoComplete: n,
      disabled: a,
      name: l,
      placeholder: o,
      type: s,
      value: d,
      testId: c,
      readOnly: m,
      maxLength: h,
      inputStyle: p,
      onKeyDown: u
    } = this.props;
    return /* @__PURE__ */ e.createElement(
      "input",
      {
        className: M(X.input, { [X.disabled]: a, [X.hasValue]: d }),
        "data-testid": c,
        autoFocus: t,
        disabled: a || m,
        id: this.inputId,
        name: l,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        onKeyDown: u,
        placeholder: o || "",
        readOnly: m,
        type: s,
        value: Ze(d) ? "" : d,
        autoComplete: n,
        maxLength: h,
        style: p
      }
    );
  }
  getError() {
    const { error: t } = this.state, { error: n, customErrorMessage: a } = this.props;
    if (t || n)
      return t || a || n;
  }
  renderRightAddOn() {
    if (!this.rightAddOnValid())
      return null;
    const { focused: t } = this.state, { rightAddOn: n, disabled: a, hasChangedType: l } = this.props, { onClick: o } = n, s = X[l], d = M(
      X.rightButton,
      X.flexCenter,
      { [X.clickable]: o },
      { [X.focused]: t },
      { [s]: s }
    );
    return /* @__PURE__ */ e.createElement("div", { className: d, onClick: o && !a ? o : null }, this.rightAddOnContent);
  }
  get rightAddOnContent() {
    const { disabled: t, rightAddOn: { content: n, onClick: a } = {}, hasChangedType: l } = this.props, { blackLighter3: o, blackLighter5: s } = v, d = !l && t;
    return typeof n == "string" ? /* @__PURE__ */ e.createElement(
      y,
      {
        type: a ? "link" : "body-sm",
        mod: d ? "disabled" : "",
        color: d ? s : o
      },
      n
    ) : n;
  }
  renderLeftIcon() {
    const { leftIcon: t, disabled: n } = this.props, { blackLighter7: a } = v;
    return t ? /* @__PURE__ */ e.createElement("div", { className: X.leftIcon }, typeof t != "string" ? t : /* @__PURE__ */ e.createElement(V, { type: t, overrideColor: n ? a : null, noHoverEffects: !0 })) : null;
  }
  renderRightIcon() {
    const { rightIcon: t, onRightIconClick: n, disabled: a, loading: l } = this.props, { blackLighter7: o } = v;
    if (!t || l)
      return null;
    const s = typeof t == "string" ? /* @__PURE__ */ e.createElement(V, { type: t, overrideColor: a ? o : null, noHoverEffects: !0 }) : t;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: M(X.rightIcon, { [X.clickable]: n }),
        onClick: a ? null : n
      },
      s
    );
  }
  renderLoading() {
    const { loading: t } = this.props;
    return t ? /* @__PURE__ */ e.createElement("div", { className: `${X.spinner} ${X.rightIcon}`, "data-testid": "input-loading-indicator" }, /* @__PURE__ */ e.createElement(
      "svg",
      {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      },
      /* @__PURE__ */ e.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(-254.000000, -10.000000)", stroke: "#3C33B2", strokeWidth: "1.5" }, /* @__PURE__ */ e.createElement("g", { transform: "translate(252.000000, 8.000000)" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3.33333333,10 C3.33333333,13.6818983 6.31810167,16.6666667 10,16.6666667 L10,16.6666667 C13.6818983,16.6666667 16.6666667,13.6818983 16.6666667,10 C16.6666667,6.31810167 13.6818983,3.33333333 10,3.33333333",
          transform: "translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "
        }
      ))))
    )) : null;
  }
  render() {
    const {
      width: t,
      leftIcon: n,
      rightIcon: a,
      disabled: l,
      testId: o,
      preventErrorPushdown: s,
      label: d,
      labelSize: c,
      labelOptional: m,
      sublabel: h,
      labelTooltip: p,
      className: u,
      hasChangedType: C
    } = this.props, E = this.getError(), g = X[C];
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: { width: Number(t) || t },
        className: `${M(
          X.wrap,
          { [X.errorWrap]: E },
          { [X.activeLeftIcon]: n },
          { [X.activeRightIcon]: a },
          { [X.disabledWrap]: l },
          { [g]: g }
        )} ${u && u}`,
        "data-testid": `${o}-container`
      },
      /* @__PURE__ */ e.createElement(
        ue,
        {
          labelFor: this.inputId,
          size: c,
          optional: m,
          subLabel: h,
          tooltip: p,
          hasChangedType: C
        },
        d
      ),
      /* @__PURE__ */ e.createElement("div", { className: M(X.inputWrap, { [X.rightAddOnWrap]: this.rightAddOnValid() }) }, this.renderLeftIcon(), this.renderInput(), this.renderRightIcon(), this.renderLoading(), this.renderRightAddOn()),
      /* @__PURE__ */ e.createElement(ae, { testId: `${d}-input-error`, preventErrorPushdown: s }, E)
    );
  }
}
i2.propTypes = {
  autoFocus: i.bool,
  autoComplete: i.string,
  disabled: i.bool,
  error: i.oneOfType([i.string, i.bool]),
  hasChangedType: i.oneOf(["changed", "completed"]),
  id: i.string,
  inputStyle: i.object,
  isError: i.func,
  label: i.any,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  labelTooltip: i.string,
  leftIcon: i.oneOfType([i.string, i.element]),
  // should be an icon
  loading: i.bool,
  maxLength: i.number,
  name: i.string,
  onBlur: i.func,
  onChange: i.func,
  onEnterKeyPressed: i.func,
  onKeyDown: i.func,
  onRightIconClick: i.func,
  placeholder: i.string,
  preventErrorPushdown: i.bool,
  readOnly: i.bool,
  rightAddOn: i.object,
  // { content: 'Button Text', onClick: () => {} }
  rightIcon: i.any,
  // can be an icon name or any content
  runIsErrorOnLoad: i.bool,
  sublabel: i.string,
  testId: i.string,
  type: i.string,
  value: i.any,
  width: i.any,
  customErrorMessage: i.string
};
i2.defaultProps = {
  autoFocus: !1,
  autoComplete: "off",
  disabled: !1,
  error: null,
  hasChangedType: null,
  id: null,
  inputStyle: {},
  isError: null,
  kind: "input",
  label: null,
  labelSize: "small",
  labelOptional: !1,
  labelTooltip: "",
  leftIcon: null,
  loading: !1,
  maxLength: null,
  onChange: null,
  onEnterKeyPressed: null,
  onKeyDown: null,
  onRightIconClick: null,
  placeholder: null,
  preventErrorPushdown: !1,
  readOnly: !1,
  rightAddOn: null,
  rightIcon: null,
  runIsErrorOnLoad: !1,
  sublabel: null,
  testId: W.input,
  type: "text",
  value: "",
  width: null,
  customErrorMessage: ""
};
const me = i2, V4 = "_row_1dw8h_1", D4 = {
  row: V4
};
class R1 extends N {
  render() {
    const { className: t, children: n, style: a, testId: l } = this.props;
    return /* @__PURE__ */ e.createElement("div", { "data-testid": l, style: a, className: `${D4.row} ${t}` }, n);
  }
}
R1.propTypes = {
  className: i.string,
  style: i.object,
  testId: i.string
};
R1.defaultProps = {
  className: "",
  style: {},
  testId: "volt-row"
};
class l2 extends N {
  // Spacer is factors of 8px
  render() {
    const { factor: t, transition: n, testId: a } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": a,
        style: {
          height: t * 8,
          width: "100%",
          transition: n ? "height .2s ease-out" : ""
        }
      }
    );
  }
}
l2.propTypes = {
  factor: i.number,
  transition: i.bool,
  testId: i.string
};
l2.defaultProps = {
  factor: 1,
  transition: !1,
  testId: "volt-vspacer"
};
const F = l2;
function X0({
  first_name: r,
  middle_name: t,
  last_name: n,
  address1: a,
  address2: l,
  city: o,
  state: s,
  postal_code: d,
  zip: c,
  country: m,
  testId: h,
  onChange: p,
  isEdit: u,
  isV2: C,
  renderWithoutAddress: E
}) {
  if (!a && !E && !u)
    return null;
  const L = ({ children: b }) => b ? /* @__PURE__ */ e.createElement(e.Fragment, null, b, /* @__PURE__ */ e.createElement("br", null)) : null, x = (b) => b || "", A = d || c, Z = `${x(r)} ${x(
    t
  )} ${x(n)}`.trim(), D = /* @__PURE__ */ e.createElement(y, null, /* @__PURE__ */ e.createElement(L, null, Z), /* @__PURE__ */ e.createElement(L, null, a), /* @__PURE__ */ e.createElement(L, null, l), /* @__PURE__ */ e.createElement(L, null, `${o}, ${s} ${A}`), /* @__PURE__ */ e.createElement(L, null, m)), f = (b) => (k) => {
    p(b, k.target.value);
  }, w = (b) => b ? !1 : "This value cannot be empty.", H = /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(R1, null, /* @__PURE__ */ e.createElement(
    me,
    {
      label: "First Name (Optional)",
      value: r,
      testId: "first_name",
      width: 300,
      onChange: f("first_name")
    }
  ), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Middle Name (Optional)",
      value: t,
      testId: "middle_name",
      width: 300,
      onChange: f("middle_name")
    }
  ), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Last Name (Optional)",
      value: n,
      testId: "last_name",
      width: 300,
      onChange: f("last_name")
    }
  )), /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Address 1",
      value: a,
      testId: "address1",
      width: 932,
      onChange: f("address1"),
      isError: w
    }
  ), /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Address 2 (Optional)",
      value: l,
      testId: "address2",
      width: 932,
      onChange: f("address2")
    }
  ), /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement(R1, null, /* @__PURE__ */ e.createElement(
    me,
    {
      label: "City",
      value: o,
      testId: "city",
      width: 300,
      onChange: f("city"),
      isError: w
    }
  ), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "State",
      value: s,
      testId: "state",
      width: 300,
      onChange: f("state"),
      isError: w
    }
  ), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Zip/Postal code",
      value: C ? d : c,
      testId: C ? "postal_code" : "zip",
      width: 300,
      onChange: f(C ? "postal_code" : "zip"),
      isError: w
    }
  )), /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement(
    me,
    {
      label: "Country",
      placeholder: "Default: USA",
      value: m,
      testId: "country",
      width: 300,
      onChange: f("country")
    }
  ));
  return /* @__PURE__ */ e.createElement("div", { "data-testid": h }, u ? H : D);
}
X0.propTypes = {
  testId: i.string,
  isV2: i.bool,
  renderWithoutAddress: i.bool
};
X0.defaultProps = {
  testId: "volt-address",
  isV2: !0,
  renderWithoutAddress: !1
};
const F4 = "_container_lwpau_1", k4 = "_colorStrip_lwpau_14", Z4 = "_content_lwpau_23", B4 = "_icon_lwpau_30", O4 = "_textContent_lwpau_36", m1 = {
  container: F4,
  colorStrip: k4,
  content: Z4,
  icon: B4,
  textContent: O4
};
class Y0 extends N {
  getTypes() {
    const { type: t } = this.props;
    let n, a;
    switch (t) {
      case "tip":
        n = v.statusSuccessColor, a = "confirmed";
        break;
      case "note":
        n = v.accentColor, a = "note2";
        break;
      case "warning":
        n = v.statusWarningColor, a = "info";
        break;
      case "danger":
        n = v.statusErrorColor, a = "danger";
        break;
      default:
        n = v.accentColor, a = "note2";
    }
    return {
      stripColor: n,
      iconType: a
    };
  }
  renderStrip(t) {
    return /* @__PURE__ */ e.createElement("div", { className: m1.colorStrip, style: { backgroundColor: t } });
  }
  renderIcon(t, n) {
    return /* @__PURE__ */ e.createElement("div", { className: m1.icon, style: { width: "16px", height: "24px" } }, /* @__PURE__ */ e.createElement(
      V,
      {
        type: t,
        mod: t === "warning" ? "default" : "reversed",
        factor: 1,
        noHoverEffects: !0,
        overrideColor: n
      }
    ));
  }
  renderHeading() {
    const { heading: t } = this.props;
    return t ? /* @__PURE__ */ e.createElement(y, { type: "h6" }, t) : null;
  }
  renderBody() {
    const { children: t } = this.props;
    return t ? typeof t == "string" ? /* @__PURE__ */ e.createElement(y, null, t) : t : null;
  }
  render() {
    const { testId: t } = this.props, { stripColor: n, iconType: a } = this.getTypes();
    return /* @__PURE__ */ e.createElement("div", { className: m1.container, "data-testid": t }, this.renderStrip(n), /* @__PURE__ */ e.createElement("div", { className: m1.content }, this.renderIcon(a, n), /* @__PURE__ */ e.createElement("div", { className: m1.textContent }, this.renderHeading(), this.renderBody())));
  }
}
Y0.propTypes = {
  type: i.string,
  heading: i.string,
  testId: i.string
};
Y0.defaultProps = {
  type: "note",
  heading: "",
  testId: "volt-admonition"
};
const S4 = "_root_4su4u_1", I4 = "_iconContainer_4su4u_15", ht = {
  root: S4,
  iconContainer: I4
};
class Q0 extends N {
  getIcon() {
    const { type: t, noIcon: n } = this.props;
    if (n)
      return null;
    switch (t) {
      case "error":
        return /* @__PURE__ */ e.createElement("div", { className: ht.iconContainer }, /* @__PURE__ */ e.createElement(V, { type: "danger", mod: "error", noHoverEffects: !0, factor: 0 }));
      case "info":
      default:
        return /* @__PURE__ */ e.createElement("div", { className: ht.iconContainer }, /* @__PURE__ */ e.createElement(V, { type: "info", mod: "active", noHoverEffects: !0, factor: 1 }));
    }
  }
  getBackgroundColor() {
    const { type: t } = this.props;
    switch (t) {
      case "error":
        return v.dangerColorLighter2;
      case "info":
      default:
        return v.washColor;
    }
  }
  render() {
    const { maxTextWidth: t, children: n, noRoundedCorners: a } = this.props, l = {
      borderRadius: a ? "0px" : "4px",
      background: this.getBackgroundColor()
    };
    return /* @__PURE__ */ e.createElement("div", { className: ht.root, style: l }, this.getIcon(), /* @__PURE__ */ e.createElement(B, { factor: 1 }), /* @__PURE__ */ e.createElement("div", { style: { maxWidth: t } }, n));
  }
}
Q0.propTypes = {
  noRoundedCorners: i.bool,
  children: i.any,
  maxTextWidth: i.string,
  type: i.oneOf(["error", "info"]),
  noIcon: i.bool
};
Q0.defaultProps = {
  noRoundedCorners: !1,
  maxTextWidth: "741px",
  type: "info",
  noIcon: !1
};
const P4 = "_container_jiod7_1", N4 = "_colorStrip_jiod7_14", R4 = "_content_jiod7_23", T4 = "_icon_jiod7_30", U4 = "_textWrapper_jiod7_38", G4 = "_textContent_jiod7_42", z4 = "_button_jiod7_49", W4 = "_heading_jiod7_53", j4 = "_sm_jiod7_59", X4 = "_lg_jiod7_65", Y4 = "_compact_jiod7_82", Q4 = "_disposeBtn_jiod7_95", K4 = "_animationContainer_jiod7_101", J4 = "_animationContainerHidden_jiod7_106", le = {
  container: P4,
  colorStrip: N4,
  content: R4,
  icon: T4,
  textWrapper: U4,
  textContent: G4,
  button: z4,
  heading: W4,
  sm: j4,
  lg: X4,
  compact: Y4,
  disposeBtn: Q4,
  animationContainer: K4,
  animationContainerHidden: J4
}, o2 = ({ ctaText: r, ctaType: t, deferText: n, onDefer: a, onSubmit: l }) => /* @__PURE__ */ e.createElement(P, { display: "flex" }, /* @__PURE__ */ e.createElement(J, { type: t, onClick: l }, r), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement(Ne, { onClick: a, type: "secondary" }, n));
o2.propTypes = {
  ctaText: i.string,
  ctaType: i.string,
  onSubmit: i.func,
  deferText: i.string,
  onDefer: i.func
};
o2.defaultProps = {
  ctaText: "Start guide",
  ctaType: "tertiary",
  deferText: "View later"
};
class K0 extends N {
  constructor() {
    super(...arguments);
    Le(this, "state", {
      isHidden: !1
    });
    Le(this, "hide", () => {
      const { onHidden: n, disposable: a } = this.props;
      a && (this.setState({ isHidden: !0 }), n && n());
    });
  }
  getTypes() {
    const { type: n } = this.props;
    let a, l;
    const o = {};
    switch (n) {
      case "tip":
      case "success":
        a = v.statusSuccessColor, l = "confirmed";
        break;
      case "cta":
      case "note":
      case "info":
        a = v.accentColor, l = "note2";
        break;
      case "warning":
        a = v.statusWarningColor, l = "info";
        break;
      case "error":
      case "danger":
        a = v.statusErrorColor, l = "danger";
        break;
      case "education":
        a = v.accentEducationColor, l = "sparkle", o.factor = 3;
        break;
      default:
        a = v.logoColor, l = "marq";
    }
    return {
      stripColor: a,
      iconType: l,
      iconProps: o
    };
  }
  renderStrip(n) {
    return /* @__PURE__ */ e.createElement("div", { className: le.colorStrip, style: { backgroundColor: n } });
  }
  renderIcon(n, a, l) {
    const { iconComponent: o } = this.props;
    return o || /* @__PURE__ */ e.createElement("div", { className: le.icon }, /* @__PURE__ */ e.createElement(
      V,
      {
        type: n,
        mod: n === "warning" ? "default" : "reversed",
        factor: 1,
        noHoverEffects: !0,
        overrideColor: a,
        ...l
      }
    ));
  }
  renderCTA() {
    const { linkComponent: n, type: a, primaryCta: l, secondaryCta: o } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: le.button }, a !== "education" || n ? n : /* @__PURE__ */ e.createElement(o2, { onSubmit: l, onDefer: o }));
  }
  renderHeading() {
    const { heading: n } = this.props;
    return n ? /* @__PURE__ */ e.createElement(y, { type: "body-sm", className: le.heading }, n) : null;
  }
  renderBody() {
    const { children: n } = this.props;
    return n ? typeof n == "string" ? /* @__PURE__ */ e.createElement(y, null, n) : n : null;
  }
  renderCloseButton() {
    return /* @__PURE__ */ e.createElement(
      "a",
      {
        className: le.disposeBtn,
        href: "#!",
        role: "button",
        "aria-label": "Close alert area",
        onClick: this.hide
      },
      /* @__PURE__ */ e.createElement(
        V,
        {
          type: "close",
          factor: 0.5
        }
      )
    );
  }
  render() {
    const { size: n, testId: a } = this.props, { stripColor: l, iconType: o, iconProps: s } = this.getTypes(), d = n === "compact", c = M({
      [le.animationContainer]: !0,
      [le.animationContainerHidden]: this.state.isHidden
    }), m = M(le.container, {
      [le[n]]: le[n],
      [le.compact]: d
    });
    return /* @__PURE__ */ e.createElement("div", { className: c }, /* @__PURE__ */ e.createElement("div", { className: m, "data-testid": a }, this.renderStrip(l), /* @__PURE__ */ e.createElement("div", { className: le.content }, !d && this.renderIcon(o, l, s), /* @__PURE__ */ e.createElement("div", { className: le.textWrapper }, /* @__PURE__ */ e.createElement("div", { className: le.textContent }, this.renderHeading(), this.renderBody()), this.renderCTA())), this.renderCloseButton()));
  }
}
K0.propTypes = {
  type: i.string,
  linkComponent: i.element,
  iconComponent: i.element,
  heading: i.string.isRequired,
  size: i.string,
  testId: i.string,
  primaryCta: i.func,
  secondaryCta: i.func
};
K0.defaultProps = {
  type: "info",
  heading: "",
  size: "md",
  testId: "volt-banner-alert"
};
const D1 = 8, J0 = (r) => {
  const {
    margin: t,
    padding: n,
    marginTop: a,
    marginRight: l,
    marginBottom: o,
    marginLeft: s,
    paddingTop: d,
    paddingRight: c,
    paddingBottom: m,
    paddingLeft: h,
    width: p,
    height: u,
    children: C
  } = r, E = (H, b) => !(typeof H[b] > "u"), g = (H, b, k) => E(H, b) ? `${H[b] * D1}px` : k ? `${k * D1}px` : void 0, L = () => ({
    marginTop: g(t, 0, a),
    marginRight: g(t, 1, l),
    marginBottom: g(t, 2, o),
    marginLeft: g(t, 3, s)
  }), x = () => ({
    paddingTop: g(n, 0, d),
    paddingRight: g(n, 1, c),
    paddingBottom: g(n, 2, m),
    paddingLeft: g(n, 3, h)
  }), A = Y(() => L(), [
    t,
    a,
    l,
    o,
    s
  ]), Z = Y(() => x(), [
    n,
    d,
    c,
    m,
    h
  ]), D = Y(
    () => ({
      ...u && {
        height: `${u * D1}px`
      }
    }),
    [u]
  ), f = Y(
    () => ({
      ...p && {
        width: `${p * D1}px`
      }
    }),
    [p]
  ), w = Y(
    () => ({ ...A, ...Z, ...D, ...f }),
    [A, Z, D, f]
  );
  return /* @__PURE__ */ e.createElement("div", { style: w, "data-testid": "box-container" }, C);
};
J0.propTypes = {
  height: i.number,
  width: i.number,
  margin: i.array,
  padding: i.array,
  marginTop: i.number,
  marginRight: i.number,
  marginBottom: i.number,
  marginLeft: i.number,
  paddingTop: i.number,
  paddingRight: i.number,
  paddingBottom: i.number,
  paddingLeft: i.number
};
J0.defaultProps = {
  margin: [],
  padding: [],
  kind: "box-container"
};
const q4 = "_breadcrumbs_12tq5_1", $4 = "_divider_12tq5_5", _4 = "_crumb_12tq5_6", e5 = "_active_12tq5_17", T1 = {
  breadcrumbs: q4,
  divider: $4,
  crumb: _4,
  active: e5
};
function s2({ children: r, href: t, onClick: n, disabled: a, testId: l }) {
  return /* @__PURE__ */ e.createElement(
    "a",
    {
      href: a || !t ? null : t,
      onClick: a ? null : n,
      onKeyPress: (o) => {
        o.code === "Enter" && !a && n(o);
      },
      className: M(T1.crumb, { [T1.active]: !a && (t || n) }),
      "data-testid": l
    },
    r || "..."
  );
}
s2.propTypes = {
  href: i.string,
  onClick: i.func,
  children: i.any,
  testId: i.string,
  disabled: i.bool
};
s2.defaultProps = {
  href: "",
  onClick: () => {
  },
  children: null,
  testId: "volt-crumb",
  disabled: !1
};
function q0({ testId: r, crumbs: t }) {
  return t && t.length > 1 ? /* @__PURE__ */ e.createElement("div", { className: T1.breadcrumbs, "data-testid": r }, t.map((n, a) => {
    const l = a < t.length - 1, o = !n.href && !n.onClick || !l;
    return /* @__PURE__ */ e.createElement(Wt, { key: a }, /* @__PURE__ */ e.createElement(s2, { ...n, key: a, disabled: o }), l && /* @__PURE__ */ e.createElement("span", { className: T1.divider }, "/"));
  })) : null;
}
q0.propTypes = {
  testId: i.string,
  crumbs: i.array
};
q0.defaultProps = {
  testId: "volt-breadcrumbs",
  crumbs: []
};
const t5 = "_list_rpzu5_1", n5 = "_listItem_rpzu5_7", $0 = {
  list: t5,
  listItem: n5
}, d2 = ({ testId: r, children: t }) => /* @__PURE__ */ e.createElement("ul", { "data-testid": r, className: $0.list }, t), a5 = ({ children: r }) => /* @__PURE__ */ e.createElement("li", { className: $0.listItem }, typeof r == "string" ? /* @__PURE__ */ e.createElement(y, { type: "body-sm", inline: !0 }, r) : r);
d2.propTypes = {
  testId: i.string
};
d2.defaultProps = {
  testId: "volt-bulleted-list"
};
d2.ListItem = a5;
const r5 = "_wrap_l6u5d_1", i5 = "_option_l6u5d_5", l5 = "_active_l6u5d_31", o5 = "_outline_l6u5d_36", s5 = "_label_l6u5d_46", h1 = {
  wrap: r5,
  option: i5,
  active: l5,
  outline: o5,
  label: s5
};
class _0 extends N {
  renderOptions() {
    const { options: t } = this.props;
    return t.map((n, a) => /* @__PURE__ */ e.createElement(
      "button",
      {
        key: a,
        className: `${h1.option} ${n.active ? h1.active : ""}`,
        "data-testid": n.active ? "active" : "inactive",
        style: n.style ? n.style : {},
        onClick: n.onClick
      },
      /* @__PURE__ */ e.createElement("div", { "data-testid": `${n.text}_button` }, n.text)
    ));
  }
  renderLabel() {
    const { label: t } = this.props;
    if (t)
      return /* @__PURE__ */ e.createElement("div", { className: h1.label }, t);
  }
  render() {
    const { type: t, wrapStyle: n, testId: a } = this.props;
    return /* @__PURE__ */ e.createElement(e.Fragment, null, this.renderLabel(), /* @__PURE__ */ e.createElement(
      "div",
      {
        style: n,
        className: `${h1.wrap} ${t === "outline" ? h1.outline : ""}`,
        "data-testid": a
      },
      this.renderOptions()
    ));
  }
}
_0.propTypes = {
  options: i.arrayOf(i.object),
  wrapStyle: i.object,
  type: i.string,
  testId: i.string
};
_0.defaultProps = {
  options: [{ text: "Light", active: !0, onClick: () => {
  } }],
  wrapStyle: {},
  type: "outline",
  testId: "volt-button-toggle"
};
const d5 = "_wrap_15nva_1", c5 = "_active_15nva_6", m5 = "_message_15nva_11", h5 = "_spinnerWrap_15nva_16", p5 = "_transparent_15nva_30", u5 = "_spinner_15nva_16", C5 = "_rotate_15nva_1", g5 = "_spinnerPath_15nva_38", f5 = "_dash_15nva_1", Xe = {
  wrap: d5,
  active: c5,
  message: m5,
  spinnerWrap: h5,
  transparent: p5,
  spinner: u5,
  rotate: C5,
  spinnerPath: g5,
  dash: f5
}, c0 = {
  "extra-small": 16,
  small: 32,
  medium: 48,
  large: 64
};
function ze({
  active: r,
  borderRadius: t,
  color: n,
  size: a,
  transparentBackground: l,
  message: o,
  style: s,
  children: d,
  testId: c
}) {
  const m = a || (t && c0[t] ? c0[t] : 48), h = {
    minWidth: `${m}px`,
    minHeight: `${m}px`
  };
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Xe.wrap,
      style: {
        ...s,
        ...h
      },
      "data-testid": `${c || ""}volt-loadingOverlay__${r ? "active" : "inactive"}`
    },
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        "data-testid": "volt-loadingOverlay__spinner",
        style: {
          color: n
        },
        className: `${Xe.spinnerWrap} ${r ? Xe.active : ""} ${l ? Xe.transparent : ""}`
      },
      /* @__PURE__ */ e.createElement(
        "svg",
        {
          className: Xe.spinner,
          width: `${m}px`,
          height: `${m}px`,
          viewBox: "0 0 66 66"
        },
        /* @__PURE__ */ e.createElement("circle", { className: Xe.spinnerPath, cx: "33", cy: "33", r: "30", strokeWidth: "6" })
      ),
      o && /* @__PURE__ */ e.createElement("span", { className: Xe.message, style: s }, typeof o == "string" ? /* @__PURE__ */ e.createElement(y, { type: "h5" }, o) : o)
    ),
    d && /* @__PURE__ */ e.createElement("span", null, d)
  );
}
ze.propTypes = {
  active: i.bool,
  size: i.number,
  color: i.string,
  message: i.string,
  borderRadius: i.oneOf(["extra-small", "small", "medium", "large"]),
  transparentBackground: i.bool,
  style: i.object,
  testId: i.string
};
ze.defaultProps = {
  active: !1,
  size: null,
  color: "#a7a8bd",
  message: "",
  borderRadius: "medium",
  transparentBackground: !1,
  style: null,
  testId: null
};
const E5 = "_wrap_rfa1f_2", L5 = "_button_rfa1f_7", w5 = "_disabledWrap_rfa1f_33", v5 = "_primary_rfa1f_39", y5 = "_loading_rfa1f_52", b5 = "_secondary_rfa1f_58", A5 = "_tertiary_rfa1f_76", H5 = "_danger_rfa1f_94", x5 = "_fullWidthWrap_rfa1f_113", M5 = "_fullWidthButton_rfa1f_117", V5 = "_content_rfa1f_130", D5 = "_loader_rfa1f_142", ve = {
  wrap: E5,
  button: L5,
  disabledWrap: w5,
  primary: v5,
  loading: y5,
  secondary: b5,
  tertiary: A5,
  danger: H5,
  fullWidthWrap: x5,
  fullWidthButton: M5,
  content: V5,
  loader: D5
};
class J extends j1 {
  constructor(t) {
    super(t), this.shouldComponentUpdate = _t.bind(this);
  }
  get validType() {
    const { type: t } = this.props, n = t === "outline" ? "tertiary" : "primary";
    return ["primary", "secondary", "tertiary", "danger"].includes(t) ? t : n;
  }
  render() {
    const {
      children: t,
      disabled: n,
      loading: a,
      style: l,
      onClick: o,
      ignoreTabbing: s,
      fullWidth: d,
      testId: c,
      autoFocus: m
    } = this.props, h = this.validType, p = h === "secondary" ? "#3b2ce3" : h === "tertiary" ? "#434355" : "#fff", u = !n && a;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `
          ${n ? ve.disabledWrap : ""}
          ${d ? ve.fullWidthWrap : ""}
          ${ve.wrap}
        `,
        "data-testid": c
      },
      /* @__PURE__ */ e.createElement(
        "button",
        {
          autoFocus: m,
          tabIndex: s ? "-1" : "0",
          className: `
            ${ve.button}
            ${ve[h] || ""}
            ${n ? ve.disabled : ""}
            ${u ? ve.loading : ""}
            ${d ? ve.fullWidthButton : ""}
            ${this.props.className ? this.props.className : ""}
          `,
          style: l,
          disabled: n,
          onClick: n || a ? null : o,
          "data-testid": `volt-button__${h}-${n ? "disabled" : "enabled"}`
        },
        /* @__PURE__ */ e.createElement("span", { className: ve.content }, t),
        /* @__PURE__ */ e.createElement("span", { className: ve.loader }, /* @__PURE__ */ e.createElement(
          ze,
          {
            testId: "volt-button",
            active: u,
            size: 20,
            color: p,
            transparentBackground: !0
          }
        ))
      )
    );
  }
}
J.propTypes = {
  type: i.string,
  disabled: i.bool,
  loading: i.bool,
  style: i.object,
  onClick: i.func,
  ignoreTabbing: i.bool,
  fullWidth: i.bool,
  testId: i.string,
  kind: i.string,
  autoFocus: i.bool
};
J.defaultProps = {
  type: "primary",
  disabled: !1,
  loading: !1,
  style: {},
  onClick: () => {
  },
  ignoreTabbing: !1,
  fullWidth: !1,
  testId: W.button,
  kind: "button",
  autoFocus: !1
};
const F5 = "_cardWrap_1fr2r_1", k5 = "_header_1fr2r_7", Z5 = "_content_1fr2r_16", B5 = "_actionDropdown_1fr2r_20", O5 = "_footer_1fr2r_26", De = {
  cardWrap: F5,
  header: k5,
  content: Z5,
  actionDropdown: B5,
  footer: O5
};
class en extends N {
  showHeader() {
    const { title: t, controls: n } = this.props;
    return t || n;
  }
  renderTitle() {
    const { title: t, testId: n } = this.props, a = typeof t == "string" ? /* @__PURE__ */ e.createElement(y, { testId: `${n}_title-text`, type: "h5" }, t) : t;
    return /* @__PURE__ */ e.createElement("div", { className: De.title, "data-testid": `${n}_title` }, a);
  }
  renderControls() {
    const { controls: t } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: De.title }, t);
  }
  renderHeader() {
    return this.showHeader() ? /* @__PURE__ */ e.createElement("div", { className: De.header }, this.renderTitle(), this.renderControls()) : null;
  }
  renderContent() {
    const { children: t, contentPadding: n } = this.props, a = {
      padding: n || "24px"
    };
    return /* @__PURE__ */ e.createElement("div", { className: De.content, style: a }, this.renderActionDropdown(), t);
  }
  renderActionDropdown() {
    const { actions: t, actionDropdownProps: n } = this.props;
    if (t)
      return /* @__PURE__ */ e.createElement("div", { className: De.actionDropdown }, /* @__PURE__ */ e.createElement(r2, { content: t, ...n }));
  }
  renderFooterButtons() {
    const { footerButtons: t } = this.props;
    return !t || t.length === 0 ? null : /* @__PURE__ */ e.createElement("div", { className: De.footer }, t.map((n, a) => /* @__PURE__ */ e.createElement(e.Fragment, { key: a }, /* @__PURE__ */ e.createElement(B, { factor: 2 }), n)));
  }
  render() {
    const { noBoxShadow: t, style: n, testId: a, className: l } = this.props, s = Object.assign({
      boxShadow: t ? null : `0px 0px 1px rgba(25, 25, 25, 0.2), 0px 0px 3px rgba(25, 25, 25, 0.12),
        0px 6px 8px rgba(25, 25, 25, 0.08)`
    }, n), d = this.showHeader();
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${De.cardWrap} ${d ? De.withHeader : ""} ${l}`,
        style: s,
        "data-testid": a
      },
      /* @__PURE__ */ e.createElement("div", { className: De.card }, this.renderHeader(), this.renderContent(), this.renderFooterButtons())
    );
  }
}
en.propTypes = {
  actions: i.array,
  actionDropdownProps: i.object,
  contentPadding: i.string,
  controls: i.any,
  noBoxShadow: i.bool,
  footerButtons: i.array,
  style: i.object,
  testId: i.string,
  title: i.any,
  className: i.string
};
en.defaultProps = {
  actions: null,
  actionDropdownProps: {},
  contentPadding: "24px",
  noBoxShadow: !0,
  controls: null,
  footerButtons: [],
  style: {},
  testId: "volt-card",
  title: null,
  className: ""
};
const S5 = "_changeIndicator_gvmmu_1", I5 = "_yellow_gvmmu_8", P5 = "_gray_gvmmu_12", N5 = "_noPadding_gvmmu_16", pt = {
  changeIndicator: S5,
  yellow: I5,
  gray: P5,
  noPadding: N5
}, R5 = {
  changed: "yellow",
  completed: "gray"
};
function c1({
  children: r,
  icon: t,
  hasChangedType: n,
  testId: a,
  iconColor: l,
  textType: o,
  textColor: s,
  style: d,
  noPadding: c
}) {
  const m = R5[n], h = M(pt.changeIndicator, { [pt[m]]: m }, { [pt.noPadding]: c });
  return /* @__PURE__ */ e.createElement(P, { alignItems: "center", flexDirection: "row", className: h, testId: a, style: d }, t && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: t, noHoverEffects: !0, overrideColor: l || v.blackLighter2 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 })), typeof r == "string" && r.length > 0 ? /* @__PURE__ */ e.createElement(y, { type: o, color: s || v.blackLighter2 }, r) : r);
}
c1.propTypes = {
  hasChangedType: i.oneOf(["changed", "completed", "default"]),
  icon: i.string,
  iconColor: i.string,
  children: i.oneOfType([i.string, i.node]),
  testId: i.string,
  style: i.object,
  textType: i.string,
  textColor: i.string,
  noPadding: i.bool
};
c1.defaultProps = {
  testId: "change-indicator",
  textType: "footnote"
};
const T5 = "_flexDiv_1q3o5_1", U5 = "_preventErrorPushdown_1q3o5_6", ut = {
  flexDiv: T5,
  preventErrorPushdown: U5
};
function ae({ testId: r, preventErrorPushdown: t, children: n }) {
  return !n || n === !0 ? null : /* @__PURE__ */ e.createElement("div", { className: ut.wrap, "data-testid": r }, !t && /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement("div", { className: `${ut.flexDiv} ${t ? ut.preventErrorPushdown : ""}` }, /* @__PURE__ */ e.createElement(V, { type: "danger", mod: "error", noHoverEffects: !0, factor: 0 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "footnote" }, n)));
}
ae.propTypes = {
  testId: i.string,
  preventErrorPushdown: i.bool
};
ae.defaultProps = {
  testId: "form-error",
  preventErrorPushdown: !1
};
const G5 = "_root_yxgnp_1", z5 = "_groupWrapper_yxgnp_7", W5 = "_groupItem_yxgnp_12", j5 = "_Checkbox_yxgnp_16", q1 = {
  root: G5,
  groupWrapper: z5,
  groupItem: W5,
  Checkbox: j5
};
function c2(r) {
  const { error: t, preventErrorPushdown: n } = r, a = tn(r);
  return /* @__PURE__ */ e.createElement("fieldset", { role: "group", className: q1.root }, a, t && /* @__PURE__ */ e.createElement(ae, { preventErrorPushdown: n }, t));
}
function tn({ children: r, error: t, disabled: n, hasChangedType: a }) {
  return e.Children.map(r, (l) => {
    if (typeof l == "object") {
      if (l && l.props) {
        if (l.props.kind === "form-label")
          return e.cloneElement(l, { ...l.props, as: "legend" });
        if (l.props.kind === "checkbox")
          return e.cloneElement(
            l,
            {
              ...l.props,
              className: q1.Checkbox,
              error: l.props.error || t,
              disabled: l.props.disabled || n,
              suppressErrorMessage: !!(l.props.error || t),
              hasChangedType: l.props.hasChangedType || a
            },
            l.props.description || l.props.children
          );
      }
      return l && l.props && l.props.children && l.props.children.length ? e.cloneElement(
        l,
        l.props,
        tn({ children: l.props.children, error: t, disabled: n, hasChangedType: a })
      ) : l;
    }
    return l;
  });
}
c2.propTypes = {
  disabled: i.bool,
  error: i.string,
  hasChangedType: i.oneOf(["completed", "changed", void 0]),
  preventErrorPushdown: i.bool
};
c2.defaultProps = {
  error: "",
  preventErrorPushdown: !1,
  disabled: !1
};
const X5 = "_labelTooltip_146q2_1", Y5 = "_disabledText_146q2_5", kt = {
  labelTooltip: X5,
  disabledText: Y5
}, Q5 = (r) => {
  try {
    return r.props.kind;
  } catch {
    return;
  }
}, m2 = ({ tooltip: r }) => {
  if (!r)
    return null;
  const t = Q5(r);
  return typeof r == "string" ? /* @__PURE__ */ e.createElement(Me, { content: r, direction: "top", className: kt.labelTooltip }, /* @__PURE__ */ e.createElement(V, { type: "info", hasTooltip: !0 })) : r && t === "tooltip" ? e.cloneElement(r, {
    ...r.props,
    children: r.props.children || /* @__PURE__ */ e.createElement(V, { type: "info", hasTooltip: !0 })
  }) : (console.error(
    "FormLabel: tooltip must be a String or a react Tooltip component but got ",
    t
  ), null);
}, m0 = ({ children: r, hasChangedType: t, isSublabel: n, ...a }) => {
  const o = typeof e.Children.toArray(r)[0] != "string" ? r : /* @__PURE__ */ e.createElement(y, { ...a }, r);
  return /* @__PURE__ */ e.createElement(e.Fragment, null, n ? /* @__PURE__ */ e.createElement(e.Fragment, null, o) : /* @__PURE__ */ e.createElement(c1, { noPadding: !0, hasChangedType: t }, o));
}, h2 = ({
  as: r,
  children: t,
  className: n,
  disabled: a,
  id: l,
  labelFor: o,
  optional: s,
  size: d,
  subLabel: c,
  testId: m,
  tooltip: h,
  isHorizontalLabel: p,
  hasChangedType: u
}) => {
  if (!t)
    return null;
  const C = s ? " (optional)" : "", E = d === "small" ? "h6" : "h5", g = { id: l, htmlFor: r === "label" ? o : void 0 }, L = r;
  return /* @__PURE__ */ e.createElement("div", { "data-testid": m, className: n }, /* @__PURE__ */ e.createElement(P, { display: "flex", flexDirection: "column" }, /* @__PURE__ */ e.createElement(P, { display: "flex" }, /* @__PURE__ */ e.createElement(L, { ...g }, t && /* @__PURE__ */ e.createElement(P, { alignItems: "center" }, /* @__PURE__ */ e.createElement(
    m0,
    {
      type: E,
      className: M({ [kt.disabledText]: a }),
      hasChangedType: u
    },
    t,
    C
  ))), h && /* @__PURE__ */ e.createElement(P, { display: "flex" }, /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(m2, { tooltip: h })))), c && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(
    m0,
    {
      isSublabel: !0,
      type: "body-sm",
      className: M({ [kt.disabledText]: a })
    },
    c
  ))), !p && /* @__PURE__ */ e.createElement(F, { factor: 1 }));
};
m2.propTypes = {
  tooltip: i.any
};
m2.defaultProps = {
  tooltip: null
};
h2.propTypes = {
  as: i.oneOf(["label", "legend"]),
  id: i.string,
  className: i.string,
  disabled: i.bool,
  labelFor: i.string,
  testId: i.string,
  size: i.oneOf(["small", "large"]),
  optional: i.bool,
  subLabel: i.any,
  tooltip: i.any,
  isHorizontalLabel: i.bool,
  hasChangedType: i.oneOf(["changed", "completed"])
};
h2.defaultProps = {
  as: "label",
  id: null,
  kind: "form-label",
  labelFor: "form-label",
  optional: !1,
  size: "small",
  subLabel: null,
  testId: "form-label",
  tooltip: null,
  isHorizontalLabel: !1,
  hasChangedType: null
};
const ue = h2, p2 = (r) => {
  const {
    error: t,
    testId: n,
    onChange: a,
    groupItems: l,
    groupClassname: o,
    onGroupItemChange: s,
    customErrorMessage: d,
    preventErrorPushdown: c
  } = r, [m, h] = z(l);
  if (ee(() => {
    const E = m.map((g, L) => ({
      ...g,
      hasChangedType: l[L].hasChangedType,
      disabled: l[L].disabled
    }));
    h(E);
  }, [l]), !l || !l.length)
    return null;
  const p = () => t ? /* @__PURE__ */ e.createElement(ae, { preventErrorPushdown: c }, d || t) : null, u = (E) => {
    const g = [...m], L = g.findIndex((A) => A.name === E);
    L >= 0 && g[L] && (g[L].active = !g[L].active);
    const x = g.filter((A) => A.active);
    h(g), a && a(x), s && s(x);
  }, C = `
    ${q1.groupWrapper},
    ${o && o}
  `;
  return /* @__PURE__ */ e.createElement("div", { className: C, "data-testid": n }, /* @__PURE__ */ e.createElement(K5, { ...r }), m.map((E, g, L) => {
    const x = g === L.length - 1 || L.length === 1;
    return /* @__PURE__ */ e.createElement(e.Fragment, { key: g }, /* @__PURE__ */ e.createElement(
      J5,
      {
        onClick: u.bind(void 0, E.name),
        error: t,
        ...E
      }
    ), !x && /* @__PURE__ */ e.createElement(F, null));
  }), p());
}, K5 = e.memo(
  ({
    groupLabel: r,
    groupSubLabel: t,
    groupLabelSize: n,
    groupLabelOptional: a,
    groupLabelTooltip: l,
    groupLabelId: o
  }) => r ? /* @__PURE__ */ e.createElement(
    ue,
    {
      subLabel: t,
      size: n,
      optional: a,
      tooltip: l,
      id: o
    },
    r
  ) : null
), J5 = ({
  active: r,
  error: t,
  name: n,
  label: a,
  description: l,
  groupItemClassname: o,
  ...s
}) => {
  if (!a)
    return null;
  const d = `
    ${o || ""},
    ${q1.groupItem}
  `, c = typeof a == "string" ? /* @__PURE__ */ e.createElement(y, null, a) : a, m = typeof l == "string" ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "footnote" }, l)) : l;
  return /* @__PURE__ */ e.createElement("div", { className: d }, /* @__PURE__ */ e.createElement(
    s1,
    {
      active: !!r,
      testId: n,
      label: c,
      error: t,
      suppressErrorMessage: !0,
      ...s
    },
    m && m
  ));
};
p2.propTypes = {
  kind: i.string,
  testId: i.string,
  groupClassname: i.string,
  groupItems: i.arrayOf(
    i.shape({
      active: i.bool,
      disabled: i.bool,
      name: i.string,
      groupItemClassname: i.string,
      hasChangedType: i.string
    })
  ),
  groupLabel: i.string,
  groupSubLabel: i.string,
  groupLabelSize: i.oneOf(["small", "large"]),
  groupLabelOptional: i.bool,
  groupLabelTooltip: i.any,
  onGroupItemChange: i.func
};
p2.defaultProps = {
  kind: "checkboxGroup",
  testId: "checkbox-group-testid",
  groupItems: [],
  groupLabel: "",
  groupSubLabel: "",
  groupLabelSize: "small",
  groupLabelOptional: !1,
  groupLabelTooltip: null,
  onGroupItemChange: null
};
const nn = ({ version: r, ...t }) => r === "v1" ? /* @__PURE__ */ e.createElement(p2, { ...t }) : /* @__PURE__ */ e.createElement(c2, { ...t });
nn.propTypes = {
  kind: i.string,
  testId: i.string,
  disabled: i.bool,
  error: i.string,
  groupClassname: i.string,
  groupItems: i.arrayOf(
    i.shape({
      active: i.bool,
      disabled: i.bool,
      name: i.string,
      groupItemClassname: i.string,
      hasChangedType: i.string
    })
  ),
  groupLabel: i.string,
  groupSubLabel: i.string,
  groupLabelSize: i.oneOf(["small", "large"]),
  groupLabelOptional: i.bool,
  groupLabelTooltip: i.any,
  hasChangedType: i.oneOf(["completed", "changed", void 0]),
  onGroupItemChange: i.func,
  version: i.oneOf(["v1", "v2"]),
  preventErrorPushdown: i.bool
};
nn.defaultProps = {
  disabled: !1,
  error: !1,
  groupItems: [],
  groupLabel: "",
  groupLabelOptional: !1,
  groupLabelSize: "small",
  groupLabelTooltip: null,
  groupSubLabel: "",
  kind: "checkboxGroup",
  onGroupItemChange: null,
  testId: "checkbox-group-testid",
  version: "v1",
  preventErrorPushdown: !1
};
const an = (r, t) => typeof r == "string" && r.length > 0 ? /* @__PURE__ */ e.createElement(y, { ...t }, r) : r, q5 = "_srOnly_z7nqv_50", $5 = {
  srOnly: q5
};
function A1({
  active: r,
  children: t,
  className: n,
  description: a,
  disabled: l,
  error: o,
  hasChangedType: s,
  headerLabel: d,
  headerLabelOptional: c,
  headerLabelSize: m,
  headerLabelTooltip: h,
  headerSubLabel: p,
  hideLabel: u,
  id: C,
  inputType: E,
  kind: g,
  label: L,
  mask: x,
  name: A,
  onClick: Z,
  suppressErrorMessage: D,
  readOnly: f,
  testId: w,
  textSpacingFactor: H,
  type: b,
  value: k,
  wrapPadding: O,
  bordered: I
}) {
  const T = C || Pe(`${w}-${g}__`), te = !!r, re = !!(a || t), qe = !!(L || re), j = (je) => {
    l || !Z || f || E === "radio" && te || Z(je);
  }, de = () => d ? /* @__PURE__ */ e.createElement(
    ue,
    {
      subLabel: p,
      optional: c,
      size: m,
      tooltip: h,
      hasChangedType: E === "radio" ? s : void 0
    },
    d
  ) : null, G = () => E === "checkbox" && !u ? /* @__PURE__ */ e.createElement(c1, { hasChangedType: s, style: { fontWeight: "normal" }, noPadding: !0 }, /* @__PURE__ */ e.createElement(y, { type: re ? "h6" : "body-sm" }, L)) : /* @__PURE__ */ e.createElement(y, { type: re || I && te ? "h6" : "body-sm" }, L), Ve = () => /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M("Control__content", {
        [$5.srOnly]: u
      })
    },
    /* @__PURE__ */ e.createElement(G, null),
    an(a ?? t, {
      className: "Control__description",
      testId: `${g === "radio" ? "Radio" : "Checkbox"}-text_${a ?? t}`,
      type: "body-sm"
    })
  ), We = () => D ? null : /* @__PURE__ */ e.createElement(ae, null, o);
  return /* @__PURE__ */ e.createElement("div", { className: n, "data-testid": `${w}-wrap` }, /* @__PURE__ */ e.createElement(de, null), /* @__PURE__ */ e.createElement(
    "label",
    {
      className: M("Control__wrap", {
        "Control--disabled": l,
        "Control--wrapNoContent": !qe,
        "Control--bordered": I,
        "Control--active": te
      }),
      "data-testid": w,
      onClick: (je) => je.stopPropagation()
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: M("Control__controlWrap", {
          "Control--disabled": l,
          "Control--noOnClick": l
        }),
        "data-testid": `${w}-control-wrap`,
        style: {
          padding: O,
          marginRight: H ? `${H * 8}px` : null
        }
      },
      /* @__PURE__ */ e.createElement(
        "input",
        {
          id: T,
          checked: te,
          className: "Control__controlInput",
          "data-testid": `${w}-input`,
          disabled: l,
          name: A,
          onChange: j,
          type: E,
          value: k
        }
      ),
      x instanceof Function ? x({ active: r, disabled: l, error: o, hasChangedType: s, readOnly: f, testId: w, type: b }) : x
    ),
    qe && /* @__PURE__ */ e.createElement(Ve, null)
  ), /* @__PURE__ */ e.createElement(We, null));
}
const $1 = {
  active: i.oneOf([!0, !1, "indeterminate"]),
  className: i.string,
  disabled: i.bool,
  error: i.string,
  hasChangedType: i.string,
  headerLabel: i.any,
  headerLabelOptional: i.bool,
  headerLabelSize: i.oneOf(["small", "large"]),
  headerLabelTooltip: i.any,
  headerSubLabel: i.any,
  hideLabel: i.bool,
  id: i.string,
  inputType: i.oneOf(["checkbox", "radio"]),
  name: i.string,
  onClick: i.func,
  suppressErrorMessage: i.bool,
  readOnly: i.bool,
  testId: i.string,
  textSpacingFactor: i.number,
  type: i.string,
  value: i.string,
  wrapPadding: i.string,
  bordered: i.bool
};
A1.propTypes = $1;
const _1 = {
  active: !1,
  // true, false, 'indeterminate' (for checkbox-type controls)
  disabled: !1,
  readOnly: !1,
  error: "",
  headerLabel: null,
  headerLabelOptional: !1,
  headerLabelSize: "small",
  headerLabelTooltip: null,
  headerSubLabel: null,
  hideLabel: !1,
  id: "",
  inputType: "checkbox",
  kind: "checkbox",
  name: null,
  onClick: null,
  suppressErrorMessage: !1,
  testId: "volt-control",
  textSpacingFactor: 1,
  type: "default",
  // [default, error]
  wrapPadding: "",
  bordered: !1
};
A1.defaultProps = _1;
const _5 = "_checkbox_14oe9_1", ei = "_errorWrap_14oe9_25", ti = "_error_14oe9_25", ni = "_active_14oe9_35", ai = "_disabled_14oe9_40", ri = "_noOnClick_14oe9_44", ii = "_iconCheck_14oe9_50", li = "_iconIndeterminate_14oe9_51", oi = "_activeIndeterminate_14oe9_68", Fe = {
  checkbox: _5,
  errorWrap: ei,
  error: ti,
  active: ni,
  disabled: ai,
  noOnClick: ri,
  iconCheck: ii,
  iconIndeterminate: li,
  activeIndeterminate: oi
};
function si({ active: r, disabled: t, error: n, readOnly: a, type: l }) {
  const o = `${r === "indeterminate" ? "indeterminate" : r ? "active" : "inactive"}${t ? "--disabled" : ""}`;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M(Fe.checkbox, Fe[l], {
        [Fe.active]: !!r,
        [Fe.activeIndeterminate]: r === "indeterminate",
        [Fe.disabled]: t,
        [Fe.noOnClick]: !t || a,
        [Fe.errorWrap]: n
      }),
      "data-testid": `checkbox-${o}`
    },
    /* @__PURE__ */ e.createElement(
      V,
      {
        noHoverEffects: !0,
        disabled: t,
        className: Fe.iconIndeterminate,
        type: "minus"
      }
    ),
    /* @__PURE__ */ e.createElement(V, { noHoverEffects: !0, disabled: t, className: Fe.iconCheck, type: "check" })
  );
}
function s1(r) {
  return /* @__PURE__ */ e.createElement(A1, { mask: si, ...r });
}
s1.propTypes = {
  ...$1,
  active: i.oneOf([!0, !1, "indeterminate"])
};
s1.defaultProps = {
  ..._1,
  inputType: "checkbox",
  kind: "checkbox",
  testId: W.checkbox
};
const rn = e.createContext(16);
class u2 extends N {
  render() {
    const { children: t, className: n, span: a, style: l, testId: o } = this.props;
    let s;
    const d = this.context;
    a ? s = { width: `calc(100% / 12 * ${a})` } : s = { flexGrow: 1 };
    let c = {
      ...s,
      maxWidth: "100%",
      paddingLeft: d,
      paddingTop: d
    };
    const m = Object.assign({}, c, l);
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: m,
        className: n,
        "data-testid": o,
        "data-gutter": d
      },
      t
    );
  }
}
u2.propTypes = {
  className: i.string,
  span: i.number,
  style: i.object,
  testId: i.string
};
u2.defaultProps = {
  className: "",
  span: null,
  // null is non-width flex
  style: {},
  testId: "volt-col"
};
u2.contextType = rn;
class ln extends N {
  render() {
    const { className: t, children: n, gutter: a, style: l, padding: o, testId: s } = this.props;
    let d = {
      marginTop: a * -1,
      marginLeft: a * -1,
      padding: o
    };
    const c = Object.assign({}, d, l);
    return /* @__PURE__ */ e.createElement(rn.Provider, { value: a }, /* @__PURE__ */ e.createElement("div", { style: c, className: t, "data-testid": s }, n));
  }
}
ln.propTypes = {
  className: i.string,
  gutter: i.number,
  padding: i.number,
  style: i.object,
  testId: i.string
};
ln.defaultProps = {
  className: "",
  gutter: 16,
  padding: null,
  style: {},
  testId: "volt-container"
};
const di = "_hWrap_kqyh1_1", ci = "_hTitle_kqyh1_6", mi = "_hContent_kqyh1_13", hi = "_contentInputSpacer_kqyh1_20", pi = "_headerWrap_kqyh1_26", ui = "_tooltipWrap_kqyh1_31", $e = {
  hWrap: di,
  hTitle: ci,
  hContent: mi,
  contentInputSpacer: hi,
  headerWrap: pi,
  tooltipWrap: ui
};
class on extends N {
  getInputValue() {
    const { children: t, inputValue: n } = this.props;
    let a;
    return typeof n < "u" ? a = n : typeof t == "string" && (a = t), a;
  }
  // renderers
  renderTitle() {
    const { title: t, tooltipContent: n, tooltipProps: a, testId: l } = this.props;
    let o;
    return typeof t == "string" ? o = /* @__PURE__ */ e.createElement(y, { testId: `${l}_title-text`, type: "h6" }, t) : o = t, n ? /* @__PURE__ */ e.createElement("div", { className: $e.headerWrap }, o, /* @__PURE__ */ e.createElement(B, null), /* @__PURE__ */ e.createElement(Me, { ...a, content: n, className: $e.tooltipWrap }, /* @__PURE__ */ e.createElement(V, { type: "info", mod: "default", hasTooltip: !0 }))) : o;
  }
  renderEdit() {
    const { inputType: t } = this.props;
    return t === "textarea" ? this.renderTextarea() : t === "select" ? this.renderSelect() : t === "toggle" ? this.renderToggle() : this.renderInput();
  }
  renderInput() {
    const { onChange: t, inputProps: n } = this.props;
    return /* @__PURE__ */ e.createElement(
      me,
      {
        value: this.getInputValue(),
        testId: "content-snippet-input",
        ...n,
        onChange: t
      }
    );
  }
  renderSelect() {
    const { onChange: t, inputProps: n } = this.props;
    return /* @__PURE__ */ e.createElement(dt, { value: this.getInputValue(), ...n, onChange: t });
  }
  renderToggle() {
    const { onChange: t, inputProps: n } = this.props, a = this.getInputValue();
    return /* @__PURE__ */ e.createElement(F3, { active: a, ...n, onClick: () => t(!a) });
  }
  renderTextarea() {
    const { onChange: t, inputProps: n } = this.props;
    return /* @__PURE__ */ e.createElement(b3, { value: this.getInputValue(), onChange: t, ...n });
  }
  renderContent() {
    const { children: t, lineUpContentWithInput: n } = this.props;
    let a;
    return typeof t == "string" ? a = /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, t) : a = t, n ? /* @__PURE__ */ e.createElement("div", { className: $e.contentInputSpacer }, a) : a;
  }
  renderVertical() {
    const { editActive: t, lineUpContentWithInput: n, testId: a, spacingFactor: l } = this.props;
    return /* @__PURE__ */ e.createElement("div", { "data-testid": a }, this.renderTitle(), /* @__PURE__ */ e.createElement(F, { factor: n ? 0.5 : l }), t ? this.renderEdit() : this.renderContent());
  }
  renderHorizontal() {
    const { editActive: t, testId: n, titleInline: a, contentInline: l } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: $e.hWrap, "data-testid": n }, /* @__PURE__ */ e.createElement("div", { style: { ...a }, className: $e.hTitle }, this.renderTitle()), /* @__PURE__ */ e.createElement("div", { style: { ...l }, className: $e.hContent }, t ? this.renderEdit() : this.renderContent()));
  }
  render() {
    const { horizontalLayout: t } = this.props;
    return t ? this.renderHorizontal() : this.renderVertical();
  }
}
on.propTypes = {
  title: i.any,
  editActive: i.bool,
  onChange: i.func,
  inputType: i.string,
  inputValue: i.any,
  inputProps: i.object,
  horizontalLayout: i.bool,
  lineUpContentWithInput: i.bool,
  tooltipContent: i.any,
  tooltipProps: i.object,
  testId: i.string,
  titleInline: i.object,
  contentInline: i.object
};
on.defaultProps = {
  title: "",
  editActive: !1,
  onChange: null,
  inputType: "input",
  inputValue: void 0,
  inputProps: {},
  horizontalLayout: !1,
  lineUpContentWithInput: !1,
  tooltipContent: null,
  tooltipProps: {},
  testId: "volt-content-snippet",
  titleInline: {},
  contentInline: {},
  spacingFactor: 1
};
const Ci = "_flexContainer_xvyxg_1", gi = "_button_xvyxg_6", fi = "_copyIcon_xvyxg_20", Zt = {
  flexContainer: Ci,
  button: gi,
  copyIcon: fi
};
function Ei({
  copied: r,
  onClick: t,
  tooltipDirection: n,
  tooltipUncopiedText: a,
  tooltipCopiedText: l,
  fixOverflow: o,
  largeIcon: s,
  verticalAlignment: d
}) {
  const c = { verticalAlign: d }, m = s ? "copy-large" : "copy";
  return /* @__PURE__ */ e.createElement(
    Me,
    {
      content: r ? l : a,
      direction: n,
      portalZIndex: 999,
      fixOverflow: o
    },
    /* @__PURE__ */ e.createElement(
      "button",
      {
        className: Zt.copyIcon,
        onKeyPress: (h) => {
          h.code === "Enter" && !disabled && t(h);
        }
      },
      /* @__PURE__ */ e.createElement(V, { type: m, style: c, onClick: t, noHoverEffects: !0 })
    )
  );
}
const v1 = class v1 extends N {
  constructor(t) {
    super(t), this.state = {
      copied: !1
    }, this.toggleCopied = this.toggleCopied.bind(this), this.setCopied = this.setCopied.bind(this), this.copyToClipboard = this.copyToClipboard.bind(this), this.handleCopyClick = this.handleCopyClick.bind(this), this.calculateChildrenText = this.calculateChildrenText.bind(this), this.copiedTimeout = null;
  }
  componentWillUnmount() {
    clearTimeout(this.copiedTimeout);
  }
  calculateChildrenText(t) {
    if (e.Children.count(t) === 1)
      return e.Children.toArray(t)[0];
    console.warn(
      "CopyToClipboard must have only 1 child. Otherwise, use the `overrideValue` prop."
    );
  }
  toggleCopied() {
    this.setState({ copied: !this.copied });
  }
  setCopied() {
    this.copiedTimeout = setTimeout(() => this.setState({ copied: !1 }), 8e3), this.setState({
      copied: !0
    });
  }
  getCopyValue() {
    const { children: t, overrideValue: n } = this.props;
    return [void 0, null].includes(n) ? this.calculateChildrenText(t) : n;
  }
  handleCopyClick(t) {
    const { copyCallback: n } = this.props, a = this.getCopyValue();
    this.copyToClipboard(a), this.setCopied(), n && n(t, a);
  }
  copyToClipboard(t) {
    if (typeof t != "string")
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", document.body.appendChild(n), n.select(), document.execCommand("copy"), document.body.removeChild(n), v1.clipboardVal = t;
  }
  static getCopiedStateShouldBeRefreshed(t) {
    return this.clipboardVal !== t;
  }
  render() {
    const { copied: t } = this.state, {
      children: n,
      overrideValue: a,
      style: l,
      tooltipDirection: o,
      tooltipUncopiedText: s,
      tooltipCopiedText: d,
      testId: c,
      type: m,
      fixOverflow: h,
      largeIcon: p,
      verticalAlignment: u
    } = this.props;
    if (!a && !n)
      return null;
    const C = m === "button";
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        onMouseEnter: () => {
          v1.getCopiedStateShouldBeRefreshed(this.getCopyValue()) && this.setState({ copied: !1 });
        },
        style: l,
        className: `${C && Zt.button} ${Zt.flexContainer}`,
        "data-testid": c,
        onClick: C ? this.handleCopyClick : void 0
      },
      n,
      n && /* @__PURE__ */ e.createElement(B, { factor: 0.5 }),
      /* @__PURE__ */ e.createElement(
        Ei,
        {
          copied: t,
          onClick: this.handleCopyClick,
          tooltipDirection: o,
          tooltipUncopiedText: s,
          tooltipCopiedText: d,
          fixOverflow: h,
          largeIcon: p,
          verticalAlignment: u
        }
      )
    );
  }
};
Le(v1, "clipboardVal");
let y1 = v1;
y1.propTypes = {
  children: i.any,
  overrideValue: i.string,
  copyCallback: i.func,
  style: i.object,
  tooltipDirection: i.string,
  tooltipUncopiedText: i.string,
  tooltipCopiedText: i.string,
  testId: i.string,
  type: i.string,
  fixOverflow: i.bool,
  verticalAlignment: i.string,
  largeIcon: i.bool
};
y1.defaultProps = {
  children: null,
  overrideValue: null,
  copyCallback: () => {
  },
  style: {},
  tooltipDirection: "top",
  tooltipUncopiedText: "Copy to clipboard",
  tooltipCopiedText: "Copied",
  testId: "volt-copy-to-clipboard",
  type: "default",
  fixOverflow: !1,
  verticalAlignment: "top",
  largeIcon: !1
};
const Ct = [
  {
    name: "Afghanistan",
    alpha2: "AF",
    alpha3: "AFG",
    countryCode: "004",
    iso3166Dash2: "ISO 3166-2:AF",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Åland Islands",
    alpha2: "AX",
    alpha3: "ALA",
    countryCode: 248,
    iso3166Dash2: "ISO 3166-2:AX",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Albania",
    alpha2: "AL",
    alpha3: "ALB",
    countryCode: "008",
    iso3166Dash2: "ISO 3166-2:AL",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Algeria",
    alpha2: "DZ",
    alpha3: "DZA",
    countryCode: "012",
    iso3166Dash2: "ISO 3166-2:DZ",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "American Samoa",
    alpha2: "AS",
    alpha3: "ASM",
    countryCode: "016",
    iso3166Dash2: "ISO 3166-2:AS",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Andorra",
    alpha2: "AD",
    alpha3: "AND",
    countryCode: "020",
    iso3166Dash2: "ISO 3166-2:AD",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Angola",
    alpha2: "AO",
    alpha3: "AGO",
    countryCode: "024",
    iso3166Dash2: "ISO 3166-2:AO",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Anguilla",
    alpha2: "AI",
    alpha3: "AIA",
    countryCode: 660,
    iso3166Dash2: "ISO 3166-2:AI",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Antarctica",
    alpha2: "AQ",
    alpha3: "ATA",
    countryCode: "010",
    iso3166Dash2: "ISO 3166-2:AQ",
    region: "",
    subRegion: "",
    intermediateRegion: "",
    regionCode: "",
    subregionCode: "",
    intermediateregionCode: ""
  },
  {
    name: "Antigua and Barbuda",
    alpha2: "AG",
    alpha3: "ATG",
    countryCode: "028",
    iso3166Dash2: "ISO 3166-2:AG",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Argentina",
    alpha2: "AR",
    alpha3: "ARG",
    countryCode: "032",
    iso3166Dash2: "ISO 3166-2:AR",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Armenia",
    alpha2: "AM",
    alpha3: "ARM",
    countryCode: "051",
    iso3166Dash2: "ISO 3166-2:AM",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Aruba",
    alpha2: "AW",
    alpha3: "ABW",
    countryCode: 533,
    iso3166Dash2: "ISO 3166-2:AW",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Australia",
    alpha2: "AU",
    alpha3: "AUS",
    countryCode: "036",
    iso3166Dash2: "ISO 3166-2:AU",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "Austria",
    alpha2: "AT",
    alpha3: "AUT",
    countryCode: "040",
    iso3166Dash2: "ISO 3166-2:AT",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Azerbaijan",
    alpha2: "AZ",
    alpha3: "AZE",
    countryCode: "031",
    iso3166Dash2: "ISO 3166-2:AZ",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Bahamas",
    alpha2: "BS",
    alpha3: "BHS",
    countryCode: "044",
    iso3166Dash2: "ISO 3166-2:BS",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Bahrain",
    alpha2: "BH",
    alpha3: "BHR",
    countryCode: "048",
    iso3166Dash2: "ISO 3166-2:BH",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Bangladesh",
    alpha2: "BD",
    alpha3: "BGD",
    countryCode: "050",
    iso3166Dash2: "ISO 3166-2:BD",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Barbados",
    alpha2: "BB",
    alpha3: "BRB",
    countryCode: "052",
    iso3166Dash2: "ISO 3166-2:BB",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Belarus",
    alpha2: "BY",
    alpha3: "BLR",
    countryCode: 112,
    iso3166Dash2: "ISO 3166-2:BY",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Belgium",
    alpha2: "BE",
    alpha3: "BEL",
    countryCode: "056",
    iso3166Dash2: "ISO 3166-2:BE",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Belize",
    alpha2: "BZ",
    alpha3: "BLZ",
    countryCode: "084",
    iso3166Dash2: "ISO 3166-2:BZ",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Benin",
    alpha2: "BJ",
    alpha3: "BEN",
    countryCode: 204,
    iso3166Dash2: "ISO 3166-2:BJ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Bermuda",
    alpha2: "BM",
    alpha3: "BMU",
    countryCode: "060",
    iso3166Dash2: "ISO 3166-2:BM",
    region: "Americas",
    subRegion: "Northern America",
    intermediateRegion: "",
    regionCode: "019",
    subregionCode: "021",
    intermediateregionCode: ""
  },
  {
    name: "Bhutan",
    alpha2: "BT",
    alpha3: "BTN",
    countryCode: "064",
    iso3166Dash2: "ISO 3166-2:BT",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Bolivia (Plurinational State of)",
    alpha2: "BO",
    alpha3: "BOL",
    countryCode: "068",
    iso3166Dash2: "ISO 3166-2:BO",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    alpha2: "BQ",
    alpha3: "BES",
    countryCode: 535,
    iso3166Dash2: "ISO 3166-2:BQ",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Bosnia and Herzegovina",
    alpha2: "BA",
    alpha3: "BIH",
    countryCode: "070",
    iso3166Dash2: "ISO 3166-2:BA",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Botswana",
    alpha2: "BW",
    alpha3: "BWA",
    countryCode: "072",
    iso3166Dash2: "ISO 3166-2:BW",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Southern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "018"
  },
  {
    name: "Bouvet Island",
    alpha2: "BV",
    alpha3: "BVT",
    countryCode: "074",
    iso3166Dash2: "ISO 3166-2:BV",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Brazil",
    alpha2: "BR",
    alpha3: "BRA",
    countryCode: "076",
    iso3166Dash2: "ISO 3166-2:BR",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "British Indian Ocean Territory",
    alpha2: "IO",
    alpha3: "IOT",
    countryCode: "086",
    iso3166Dash2: "ISO 3166-2:IO",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Brunei Darussalam",
    alpha2: "BN",
    alpha3: "BRN",
    countryCode: "096",
    iso3166Dash2: "ISO 3166-2:BN",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Bulgaria",
    alpha2: "BG",
    alpha3: "BGR",
    countryCode: 100,
    iso3166Dash2: "ISO 3166-2:BG",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Burkina Faso",
    alpha2: "BF",
    alpha3: "BFA",
    countryCode: 854,
    iso3166Dash2: "ISO 3166-2:BF",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Burundi",
    alpha2: "BI",
    alpha3: "BDI",
    countryCode: 108,
    iso3166Dash2: "ISO 3166-2:BI",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Cabo Verde",
    alpha2: "CV",
    alpha3: "CPV",
    countryCode: 132,
    iso3166Dash2: "ISO 3166-2:CV",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Cambodia",
    alpha2: "KH",
    alpha3: "KHM",
    countryCode: 116,
    iso3166Dash2: "ISO 3166-2:KH",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Cameroon",
    alpha2: "CM",
    alpha3: "CMR",
    countryCode: 120,
    iso3166Dash2: "ISO 3166-2:CM",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Canada",
    alpha2: "CA",
    alpha3: "CAN",
    countryCode: 124,
    iso3166Dash2: "ISO 3166-2:CA",
    region: "Americas",
    subRegion: "Northern America",
    intermediateRegion: "",
    regionCode: "019",
    subregionCode: "021",
    intermediateregionCode: ""
  },
  {
    name: "Cayman Islands",
    alpha2: "KY",
    alpha3: "CYM",
    countryCode: 136,
    iso3166Dash2: "ISO 3166-2:KY",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Central African Republic",
    alpha2: "CF",
    alpha3: "CAF",
    countryCode: 140,
    iso3166Dash2: "ISO 3166-2:CF",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Chad",
    alpha2: "TD",
    alpha3: "TCD",
    countryCode: 148,
    iso3166Dash2: "ISO 3166-2:TD",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Chile",
    alpha2: "CL",
    alpha3: "CHL",
    countryCode: 152,
    iso3166Dash2: "ISO 3166-2:CL",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "China",
    alpha2: "CN",
    alpha3: "CHN",
    countryCode: 156,
    iso3166Dash2: "ISO 3166-2:CN",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Christmas Island",
    alpha2: "CX",
    alpha3: "CXR",
    countryCode: 162,
    iso3166Dash2: "ISO 3166-2:CX",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "Cocos (Keeling) Islands",
    alpha2: "CC",
    alpha3: "CCK",
    countryCode: 166,
    iso3166Dash2: "ISO 3166-2:CC",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "Colombia",
    alpha2: "CO",
    alpha3: "COL",
    countryCode: 170,
    iso3166Dash2: "ISO 3166-2:CO",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Comoros",
    alpha2: "KM",
    alpha3: "COM",
    countryCode: 174,
    iso3166Dash2: "ISO 3166-2:KM",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Congo",
    alpha2: "CG",
    alpha3: "COG",
    countryCode: 178,
    iso3166Dash2: "ISO 3166-2:CG",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Congo, Democratic Republic of the",
    alpha2: "CD",
    alpha3: "COD",
    countryCode: 180,
    iso3166Dash2: "ISO 3166-2:CD",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Cook Islands",
    alpha2: "CK",
    alpha3: "COK",
    countryCode: 184,
    iso3166Dash2: "ISO 3166-2:CK",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Costa Rica",
    alpha2: "CR",
    alpha3: "CRI",
    countryCode: 188,
    iso3166Dash2: "ISO 3166-2:CR",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Côte d'Ivoire",
    alpha2: "CI",
    alpha3: "CIV",
    countryCode: 384,
    iso3166Dash2: "ISO 3166-2:CI",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Croatia",
    alpha2: "HR",
    alpha3: "HRV",
    countryCode: 191,
    iso3166Dash2: "ISO 3166-2:HR",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Cuba",
    alpha2: "CU",
    alpha3: "CUB",
    countryCode: 192,
    iso3166Dash2: "ISO 3166-2:CU",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Curaçao",
    alpha2: "CW",
    alpha3: "CUW",
    countryCode: 531,
    iso3166Dash2: "ISO 3166-2:CW",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Cyprus",
    alpha2: "CY",
    alpha3: "CYP",
    countryCode: 196,
    iso3166Dash2: "ISO 3166-2:CY",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Czechia",
    alpha2: "CZ",
    alpha3: "CZE",
    countryCode: 203,
    iso3166Dash2: "ISO 3166-2:CZ",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Denmark",
    alpha2: "DK",
    alpha3: "DNK",
    countryCode: 208,
    iso3166Dash2: "ISO 3166-2:DK",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Djibouti",
    alpha2: "DJ",
    alpha3: "DJI",
    countryCode: 262,
    iso3166Dash2: "ISO 3166-2:DJ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Dominica",
    alpha2: "DM",
    alpha3: "DMA",
    countryCode: 212,
    iso3166Dash2: "ISO 3166-2:DM",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Dominican Republic",
    alpha2: "DO",
    alpha3: "DOM",
    countryCode: 214,
    iso3166Dash2: "ISO 3166-2:DO",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Ecuador",
    alpha2: "EC",
    alpha3: "ECU",
    countryCode: 218,
    iso3166Dash2: "ISO 3166-2:EC",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Egypt",
    alpha2: "EG",
    alpha3: "EGY",
    countryCode: 818,
    iso3166Dash2: "ISO 3166-2:EG",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "El Salvador",
    alpha2: "SV",
    alpha3: "SLV",
    countryCode: 222,
    iso3166Dash2: "ISO 3166-2:SV",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Equatorial Guinea",
    alpha2: "GQ",
    alpha3: "GNQ",
    countryCode: 226,
    iso3166Dash2: "ISO 3166-2:GQ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Eritrea",
    alpha2: "ER",
    alpha3: "ERI",
    countryCode: 232,
    iso3166Dash2: "ISO 3166-2:ER",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Estonia",
    alpha2: "EE",
    alpha3: "EST",
    countryCode: 233,
    iso3166Dash2: "ISO 3166-2:EE",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Eswatini",
    alpha2: "SZ",
    alpha3: "SWZ",
    countryCode: 748,
    iso3166Dash2: "ISO 3166-2:SZ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Southern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "018"
  },
  {
    name: "Ethiopia",
    alpha2: "ET",
    alpha3: "ETH",
    countryCode: 231,
    iso3166Dash2: "ISO 3166-2:ET",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Falkland Islands (Malvinas)",
    alpha2: "FK",
    alpha3: "FLK",
    countryCode: 238,
    iso3166Dash2: "ISO 3166-2:FK",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Faroe Islands",
    alpha2: "FO",
    alpha3: "FRO",
    countryCode: 234,
    iso3166Dash2: "ISO 3166-2:FO",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Fiji",
    alpha2: "FJ",
    alpha3: "FJI",
    countryCode: 242,
    iso3166Dash2: "ISO 3166-2:FJ",
    region: "Oceania",
    subRegion: "Melanesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "054",
    intermediateregionCode: ""
  },
  {
    name: "Finland",
    alpha2: "FI",
    alpha3: "FIN",
    countryCode: 246,
    iso3166Dash2: "ISO 3166-2:FI",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "France",
    alpha2: "FR",
    alpha3: "FRA",
    countryCode: 250,
    iso3166Dash2: "ISO 3166-2:FR",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "French Guiana",
    alpha2: "GF",
    alpha3: "GUF",
    countryCode: 254,
    iso3166Dash2: "ISO 3166-2:GF",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "French Polynesia",
    alpha2: "PF",
    alpha3: "PYF",
    countryCode: 258,
    iso3166Dash2: "ISO 3166-2:PF",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "French Southern Territories",
    alpha2: "TF",
    alpha3: "ATF",
    countryCode: 260,
    iso3166Dash2: "ISO 3166-2:TF",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Gabon",
    alpha2: "GA",
    alpha3: "GAB",
    countryCode: 266,
    iso3166Dash2: "ISO 3166-2:GA",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Gambia",
    alpha2: "GM",
    alpha3: "GMB",
    countryCode: 270,
    iso3166Dash2: "ISO 3166-2:GM",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Georgia",
    alpha2: "GE",
    alpha3: "GEO",
    countryCode: 268,
    iso3166Dash2: "ISO 3166-2:GE",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Germany",
    alpha2: "DE",
    alpha3: "DEU",
    countryCode: 276,
    iso3166Dash2: "ISO 3166-2:DE",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Ghana",
    alpha2: "GH",
    alpha3: "GHA",
    countryCode: 288,
    iso3166Dash2: "ISO 3166-2:GH",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Gibraltar",
    alpha2: "GI",
    alpha3: "GIB",
    countryCode: 292,
    iso3166Dash2: "ISO 3166-2:GI",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Greece",
    alpha2: "GR",
    alpha3: "GRC",
    countryCode: 300,
    iso3166Dash2: "ISO 3166-2:GR",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Greenland",
    alpha2: "GL",
    alpha3: "GRL",
    countryCode: 304,
    iso3166Dash2: "ISO 3166-2:GL",
    region: "Americas",
    subRegion: "Northern America",
    intermediateRegion: "",
    regionCode: "019",
    subregionCode: "021",
    intermediateregionCode: ""
  },
  {
    name: "Grenada",
    alpha2: "GD",
    alpha3: "GRD",
    countryCode: 308,
    iso3166Dash2: "ISO 3166-2:GD",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Guadeloupe",
    alpha2: "GP",
    alpha3: "GLP",
    countryCode: 312,
    iso3166Dash2: "ISO 3166-2:GP",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Guam",
    alpha2: "GU",
    alpha3: "GUM",
    countryCode: 316,
    iso3166Dash2: "ISO 3166-2:GU",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Guatemala",
    alpha2: "GT",
    alpha3: "GTM",
    countryCode: 320,
    iso3166Dash2: "ISO 3166-2:GT",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Guernsey",
    alpha2: "GG",
    alpha3: "GGY",
    countryCode: 831,
    iso3166Dash2: "ISO 3166-2:GG",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "Channel Islands",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: 830
  },
  {
    name: "Guinea",
    alpha2: "GN",
    alpha3: "GIN",
    countryCode: 324,
    iso3166Dash2: "ISO 3166-2:GN",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Guinea-Bissau",
    alpha2: "GW",
    alpha3: "GNB",
    countryCode: 624,
    iso3166Dash2: "ISO 3166-2:GW",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Guyana",
    alpha2: "GY",
    alpha3: "GUY",
    countryCode: 328,
    iso3166Dash2: "ISO 3166-2:GY",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Haiti",
    alpha2: "HT",
    alpha3: "HTI",
    countryCode: 332,
    iso3166Dash2: "ISO 3166-2:HT",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Heard Island and McDonald Islands",
    alpha2: "HM",
    alpha3: "HMD",
    countryCode: 334,
    iso3166Dash2: "ISO 3166-2:HM",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "Holy See",
    alpha2: "VA",
    alpha3: "VAT",
    countryCode: 336,
    iso3166Dash2: "ISO 3166-2:VA",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Honduras",
    alpha2: "HN",
    alpha3: "HND",
    countryCode: 340,
    iso3166Dash2: "ISO 3166-2:HN",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Hong Kong",
    alpha2: "HK",
    alpha3: "HKG",
    countryCode: 344,
    iso3166Dash2: "ISO 3166-2:HK",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Hungary",
    alpha2: "HU",
    alpha3: "HUN",
    countryCode: 348,
    iso3166Dash2: "ISO 3166-2:HU",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Iceland",
    alpha2: "IS",
    alpha3: "ISL",
    countryCode: 352,
    iso3166Dash2: "ISO 3166-2:IS",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "India",
    alpha2: "IN",
    alpha3: "IND",
    countryCode: 356,
    iso3166Dash2: "ISO 3166-2:IN",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Indonesia",
    alpha2: "ID",
    alpha3: "IDN",
    countryCode: 360,
    iso3166Dash2: "ISO 3166-2:ID",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Iran (Islamic Republic of)",
    alpha2: "IR",
    alpha3: "IRN",
    countryCode: 364,
    iso3166Dash2: "ISO 3166-2:IR",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Iraq",
    alpha2: "IQ",
    alpha3: "IRQ",
    countryCode: 368,
    iso3166Dash2: "ISO 3166-2:IQ",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Ireland",
    alpha2: "IE",
    alpha3: "IRL",
    countryCode: 372,
    iso3166Dash2: "ISO 3166-2:IE",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Isle of Man",
    alpha2: "IM",
    alpha3: "IMN",
    countryCode: 833,
    iso3166Dash2: "ISO 3166-2:IM",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Israel",
    alpha2: "IL",
    alpha3: "ISR",
    countryCode: 376,
    iso3166Dash2: "ISO 3166-2:IL",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Italy",
    alpha2: "IT",
    alpha3: "ITA",
    countryCode: 380,
    iso3166Dash2: "ISO 3166-2:IT",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Jamaica",
    alpha2: "JM",
    alpha3: "JAM",
    countryCode: 388,
    iso3166Dash2: "ISO 3166-2:JM",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Japan",
    alpha2: "JP",
    alpha3: "JPN",
    countryCode: 392,
    iso3166Dash2: "ISO 3166-2:JP",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Jersey",
    alpha2: "JE",
    alpha3: "JEY",
    countryCode: 832,
    iso3166Dash2: "ISO 3166-2:JE",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "Channel Islands",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: 830
  },
  {
    name: "Jordan",
    alpha2: "JO",
    alpha3: "JOR",
    countryCode: 400,
    iso3166Dash2: "ISO 3166-2:JO",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Kazakhstan",
    alpha2: "KZ",
    alpha3: "KAZ",
    countryCode: 398,
    iso3166Dash2: "ISO 3166-2:KZ",
    region: "Asia",
    subRegion: "Central Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 143,
    intermediateregionCode: ""
  },
  {
    name: "Kenya",
    alpha2: "KE",
    alpha3: "KEN",
    countryCode: 404,
    iso3166Dash2: "ISO 3166-2:KE",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Kiribati",
    alpha2: "KI",
    alpha3: "KIR",
    countryCode: 296,
    iso3166Dash2: "ISO 3166-2:KI",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha2: "KP",
    alpha3: "PRK",
    countryCode: 408,
    iso3166Dash2: "ISO 3166-2:KP",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Korea, Republic of",
    alpha2: "KR",
    alpha3: "KOR",
    countryCode: 410,
    iso3166Dash2: "ISO 3166-2:KR",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Kuwait",
    alpha2: "KW",
    alpha3: "KWT",
    countryCode: 414,
    iso3166Dash2: "ISO 3166-2:KW",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Kyrgyzstan",
    alpha2: "KG",
    alpha3: "KGZ",
    countryCode: 417,
    iso3166Dash2: "ISO 3166-2:KG",
    region: "Asia",
    subRegion: "Central Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 143,
    intermediateregionCode: ""
  },
  {
    name: "Lao People's Democratic Republic",
    alpha2: "LA",
    alpha3: "LAO",
    countryCode: 418,
    iso3166Dash2: "ISO 3166-2:LA",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Latvia",
    alpha2: "LV",
    alpha3: "LVA",
    countryCode: 428,
    iso3166Dash2: "ISO 3166-2:LV",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Lebanon",
    alpha2: "LB",
    alpha3: "LBN",
    countryCode: 422,
    iso3166Dash2: "ISO 3166-2:LB",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Lesotho",
    alpha2: "LS",
    alpha3: "LSO",
    countryCode: 426,
    iso3166Dash2: "ISO 3166-2:LS",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Southern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "018"
  },
  {
    name: "Liberia",
    alpha2: "LR",
    alpha3: "LBR",
    countryCode: 430,
    iso3166Dash2: "ISO 3166-2:LR",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Libya",
    alpha2: "LY",
    alpha3: "LBY",
    countryCode: 434,
    iso3166Dash2: "ISO 3166-2:LY",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "Liechtenstein",
    alpha2: "LI",
    alpha3: "LIE",
    countryCode: 438,
    iso3166Dash2: "ISO 3166-2:LI",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Lithuania",
    alpha2: "LT",
    alpha3: "LTU",
    countryCode: 440,
    iso3166Dash2: "ISO 3166-2:LT",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Luxembourg",
    alpha2: "LU",
    alpha3: "LUX",
    countryCode: 442,
    iso3166Dash2: "ISO 3166-2:LU",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Macao",
    alpha2: "MO",
    alpha3: "MAC",
    countryCode: 446,
    iso3166Dash2: "ISO 3166-2:MO",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Madagascar",
    alpha2: "MG",
    alpha3: "MDG",
    countryCode: 450,
    iso3166Dash2: "ISO 3166-2:MG",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Malawi",
    alpha2: "MW",
    alpha3: "MWI",
    countryCode: 454,
    iso3166Dash2: "ISO 3166-2:MW",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Malaysia",
    alpha2: "MY",
    alpha3: "MYS",
    countryCode: 458,
    iso3166Dash2: "ISO 3166-2:MY",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Maldives",
    alpha2: "MV",
    alpha3: "MDV",
    countryCode: 462,
    iso3166Dash2: "ISO 3166-2:MV",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Mali",
    alpha2: "ML",
    alpha3: "MLI",
    countryCode: 466,
    iso3166Dash2: "ISO 3166-2:ML",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Malta",
    alpha2: "MT",
    alpha3: "MLT",
    countryCode: 470,
    iso3166Dash2: "ISO 3166-2:MT",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Marshall Islands",
    alpha2: "MH",
    alpha3: "MHL",
    countryCode: 584,
    iso3166Dash2: "ISO 3166-2:MH",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Martinique",
    alpha2: "MQ",
    alpha3: "MTQ",
    countryCode: 474,
    iso3166Dash2: "ISO 3166-2:MQ",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Mauritania",
    alpha2: "MR",
    alpha3: "MRT",
    countryCode: 478,
    iso3166Dash2: "ISO 3166-2:MR",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Mauritius",
    alpha2: "MU",
    alpha3: "MUS",
    countryCode: 480,
    iso3166Dash2: "ISO 3166-2:MU",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Mayotte",
    alpha2: "YT",
    alpha3: "MYT",
    countryCode: 175,
    iso3166Dash2: "ISO 3166-2:YT",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Mexico",
    alpha2: "MX",
    alpha3: "MEX",
    countryCode: 484,
    iso3166Dash2: "ISO 3166-2:MX",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Micronesia (Federated States of)",
    alpha2: "FM",
    alpha3: "FSM",
    countryCode: 583,
    iso3166Dash2: "ISO 3166-2:FM",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Moldova, Republic of",
    alpha2: "MD",
    alpha3: "MDA",
    countryCode: 498,
    iso3166Dash2: "ISO 3166-2:MD",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Monaco",
    alpha2: "MC",
    alpha3: "MCO",
    countryCode: 492,
    iso3166Dash2: "ISO 3166-2:MC",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Mongolia",
    alpha2: "MN",
    alpha3: "MNG",
    countryCode: 496,
    iso3166Dash2: "ISO 3166-2:MN",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Montenegro",
    alpha2: "ME",
    alpha3: "MNE",
    countryCode: 499,
    iso3166Dash2: "ISO 3166-2:ME",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Montserrat",
    alpha2: "MS",
    alpha3: "MSR",
    countryCode: 500,
    iso3166Dash2: "ISO 3166-2:MS",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Morocco",
    alpha2: "MA",
    alpha3: "MAR",
    countryCode: 504,
    iso3166Dash2: "ISO 3166-2:MA",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "Mozambique",
    alpha2: "MZ",
    alpha3: "MOZ",
    countryCode: 508,
    iso3166Dash2: "ISO 3166-2:MZ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Myanmar",
    alpha2: "MM",
    alpha3: "MMR",
    countryCode: 104,
    iso3166Dash2: "ISO 3166-2:MM",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Namibia",
    alpha2: "NA",
    alpha3: "NAM",
    countryCode: 516,
    iso3166Dash2: "ISO 3166-2:NA",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Southern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "018"
  },
  {
    name: "Nauru",
    alpha2: "NR",
    alpha3: "NRU",
    countryCode: 520,
    iso3166Dash2: "ISO 3166-2:NR",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Nepal",
    alpha2: "NP",
    alpha3: "NPL",
    countryCode: 524,
    iso3166Dash2: "ISO 3166-2:NP",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Netherlands",
    alpha2: "NL",
    alpha3: "NLD",
    countryCode: 528,
    iso3166Dash2: "ISO 3166-2:NL",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "New Caledonia",
    alpha2: "NC",
    alpha3: "NCL",
    countryCode: 540,
    iso3166Dash2: "ISO 3166-2:NC",
    region: "Oceania",
    subRegion: "Melanesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "054",
    intermediateregionCode: ""
  },
  {
    name: "New Zealand",
    alpha2: "NZ",
    alpha3: "NZL",
    countryCode: 554,
    iso3166Dash2: "ISO 3166-2:NZ",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "Nicaragua",
    alpha2: "NI",
    alpha3: "NIC",
    countryCode: 558,
    iso3166Dash2: "ISO 3166-2:NI",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Niger",
    alpha2: "NE",
    alpha3: "NER",
    countryCode: 562,
    iso3166Dash2: "ISO 3166-2:NE",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Nigeria",
    alpha2: "NG",
    alpha3: "NGA",
    countryCode: 566,
    iso3166Dash2: "ISO 3166-2:NG",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Niue",
    alpha2: "NU",
    alpha3: "NIU",
    countryCode: 570,
    iso3166Dash2: "ISO 3166-2:NU",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Norfolk Island",
    alpha2: "NF",
    alpha3: "NFK",
    countryCode: 574,
    iso3166Dash2: "ISO 3166-2:NF",
    region: "Oceania",
    subRegion: "Australia and New Zealand",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "053",
    intermediateregionCode: ""
  },
  {
    name: "North Macedonia",
    alpha2: "MK",
    alpha3: "MKD",
    countryCode: 807,
    iso3166Dash2: "ISO 3166-2:MK",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Northern Mariana Islands",
    alpha2: "MP",
    alpha3: "MNP",
    countryCode: 580,
    iso3166Dash2: "ISO 3166-2:MP",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Norway",
    alpha2: "NO",
    alpha3: "NOR",
    countryCode: 578,
    iso3166Dash2: "ISO 3166-2:NO",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Oman",
    alpha2: "OM",
    alpha3: "OMN",
    countryCode: 512,
    iso3166Dash2: "ISO 3166-2:OM",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Pakistan",
    alpha2: "PK",
    alpha3: "PAK",
    countryCode: 586,
    iso3166Dash2: "ISO 3166-2:PK",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Palau",
    alpha2: "PW",
    alpha3: "PLW",
    countryCode: 585,
    iso3166Dash2: "ISO 3166-2:PW",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Palestine, State of",
    alpha2: "PS",
    alpha3: "PSE",
    countryCode: 275,
    iso3166Dash2: "ISO 3166-2:PS",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Panama",
    alpha2: "PA",
    alpha3: "PAN",
    countryCode: 591,
    iso3166Dash2: "ISO 3166-2:PA",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Central America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "013"
  },
  {
    name: "Papua New Guinea",
    alpha2: "PG",
    alpha3: "PNG",
    countryCode: 598,
    iso3166Dash2: "ISO 3166-2:PG",
    region: "Oceania",
    subRegion: "Melanesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "054",
    intermediateregionCode: ""
  },
  {
    name: "Paraguay",
    alpha2: "PY",
    alpha3: "PRY",
    countryCode: 600,
    iso3166Dash2: "ISO 3166-2:PY",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Peru",
    alpha2: "PE",
    alpha3: "PER",
    countryCode: 604,
    iso3166Dash2: "ISO 3166-2:PE",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Philippines",
    alpha2: "PH",
    alpha3: "PHL",
    countryCode: 608,
    iso3166Dash2: "ISO 3166-2:PH",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Pitcairn",
    alpha2: "PN",
    alpha3: "PCN",
    countryCode: 612,
    iso3166Dash2: "ISO 3166-2:PN",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Poland",
    alpha2: "PL",
    alpha3: "POL",
    countryCode: 616,
    iso3166Dash2: "ISO 3166-2:PL",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Portugal",
    alpha2: "PT",
    alpha3: "PRT",
    countryCode: 620,
    iso3166Dash2: "ISO 3166-2:PT",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Puerto Rico",
    alpha2: "PR",
    alpha3: "PRI",
    countryCode: 630,
    iso3166Dash2: "ISO 3166-2:PR",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Qatar",
    alpha2: "QA",
    alpha3: "QAT",
    countryCode: 634,
    iso3166Dash2: "ISO 3166-2:QA",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Réunion",
    alpha2: "RE",
    alpha3: "REU",
    countryCode: 638,
    iso3166Dash2: "ISO 3166-2:RE",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Romania",
    alpha2: "RO",
    alpha3: "ROU",
    countryCode: 642,
    iso3166Dash2: "ISO 3166-2:RO",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Russian Federation",
    alpha2: "RU",
    alpha3: "RUS",
    countryCode: 643,
    iso3166Dash2: "ISO 3166-2:RU",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Rwanda",
    alpha2: "RW",
    alpha3: "RWA",
    countryCode: 646,
    iso3166Dash2: "ISO 3166-2:RW",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Saint Barthélemy",
    alpha2: "BL",
    alpha3: "BLM",
    countryCode: 652,
    iso3166Dash2: "ISO 3166-2:BL",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    alpha2: "SH",
    alpha3: "SHN",
    countryCode: 654,
    iso3166Dash2: "ISO 3166-2:SH",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Saint Kitts and Nevis",
    alpha2: "KN",
    alpha3: "KNA",
    countryCode: 659,
    iso3166Dash2: "ISO 3166-2:KN",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Saint Lucia",
    alpha2: "LC",
    alpha3: "LCA",
    countryCode: 662,
    iso3166Dash2: "ISO 3166-2:LC",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Saint Martin (French part)",
    alpha2: "MF",
    alpha3: "MAF",
    countryCode: 663,
    iso3166Dash2: "ISO 3166-2:MF",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Saint Pierre and Miquelon",
    alpha2: "PM",
    alpha3: "SPM",
    countryCode: 666,
    iso3166Dash2: "ISO 3166-2:PM",
    region: "Americas",
    subRegion: "Northern America",
    intermediateRegion: "",
    regionCode: "019",
    subregionCode: "021",
    intermediateregionCode: ""
  },
  {
    name: "Saint Vincent and the Grenadines",
    alpha2: "VC",
    alpha3: "VCT",
    countryCode: 670,
    iso3166Dash2: "ISO 3166-2:VC",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Samoa",
    alpha2: "WS",
    alpha3: "WSM",
    countryCode: 882,
    iso3166Dash2: "ISO 3166-2:WS",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "San Marino",
    alpha2: "SM",
    alpha3: "SMR",
    countryCode: 674,
    iso3166Dash2: "ISO 3166-2:SM",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Sao Tome and Principe",
    alpha2: "ST",
    alpha3: "STP",
    countryCode: 678,
    iso3166Dash2: "ISO 3166-2:ST",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Middle Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "017"
  },
  {
    name: "Saudi Arabia",
    alpha2: "SA",
    alpha3: "SAU",
    countryCode: 682,
    iso3166Dash2: "ISO 3166-2:SA",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Senegal",
    alpha2: "SN",
    alpha3: "SEN",
    countryCode: 686,
    iso3166Dash2: "ISO 3166-2:SN",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Serbia",
    alpha2: "RS",
    alpha3: "SRB",
    countryCode: 688,
    iso3166Dash2: "ISO 3166-2:RS",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Seychelles",
    alpha2: "SC",
    alpha3: "SYC",
    countryCode: 690,
    iso3166Dash2: "ISO 3166-2:SC",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Sierra Leone",
    alpha2: "SL",
    alpha3: "SLE",
    countryCode: 694,
    iso3166Dash2: "ISO 3166-2:SL",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Singapore",
    alpha2: "SG",
    alpha3: "SGP",
    countryCode: 702,
    iso3166Dash2: "ISO 3166-2:SG",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Sint Maarten (Dutch part)",
    alpha2: "SX",
    alpha3: "SXM",
    countryCode: 534,
    iso3166Dash2: "ISO 3166-2:SX",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Slovakia",
    alpha2: "SK",
    alpha3: "SVK",
    countryCode: 703,
    iso3166Dash2: "ISO 3166-2:SK",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "Slovenia",
    alpha2: "SI",
    alpha3: "SVN",
    countryCode: 705,
    iso3166Dash2: "ISO 3166-2:SI",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Solomon Islands",
    alpha2: "SB",
    alpha3: "SLB",
    countryCode: "090",
    iso3166Dash2: "ISO 3166-2:SB",
    region: "Oceania",
    subRegion: "Melanesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "054",
    intermediateregionCode: ""
  },
  {
    name: "Somalia",
    alpha2: "SO",
    alpha3: "SOM",
    countryCode: 706,
    iso3166Dash2: "ISO 3166-2:SO",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "South Africa",
    alpha2: "ZA",
    alpha3: "ZAF",
    countryCode: 710,
    iso3166Dash2: "ISO 3166-2:ZA",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Southern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "018"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    alpha2: "GS",
    alpha3: "SGS",
    countryCode: 239,
    iso3166Dash2: "ISO 3166-2:GS",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "South Sudan",
    alpha2: "SS",
    alpha3: "SSD",
    countryCode: 728,
    iso3166Dash2: "ISO 3166-2:SS",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Spain",
    alpha2: "ES",
    alpha3: "ESP",
    countryCode: 724,
    iso3166Dash2: "ISO 3166-2:ES",
    region: "Europe",
    subRegion: "Southern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: "039",
    intermediateregionCode: ""
  },
  {
    name: "Sri Lanka",
    alpha2: "LK",
    alpha3: "LKA",
    countryCode: 144,
    iso3166Dash2: "ISO 3166-2:LK",
    region: "Asia",
    subRegion: "Southern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "034",
    intermediateregionCode: ""
  },
  {
    name: "Sudan",
    alpha2: "SD",
    alpha3: "SDN",
    countryCode: 729,
    iso3166Dash2: "ISO 3166-2:SD",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "Suriname",
    alpha2: "SR",
    alpha3: "SUR",
    countryCode: 740,
    iso3166Dash2: "ISO 3166-2:SR",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Svalbard and Jan Mayen",
    alpha2: "SJ",
    alpha3: "SJM",
    countryCode: 744,
    iso3166Dash2: "ISO 3166-2:SJ",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Sweden",
    alpha2: "SE",
    alpha3: "SWE",
    countryCode: 752,
    iso3166Dash2: "ISO 3166-2:SE",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "Switzerland",
    alpha2: "CH",
    alpha3: "CHE",
    countryCode: 756,
    iso3166Dash2: "ISO 3166-2:CH",
    region: "Europe",
    subRegion: "Western Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 155,
    intermediateregionCode: ""
  },
  {
    name: "Syrian Arab Republic",
    alpha2: "SY",
    alpha3: "SYR",
    countryCode: 760,
    iso3166Dash2: "ISO 3166-2:SY",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Taiwan, Province of China",
    alpha2: "TW",
    alpha3: "TWN",
    countryCode: 158,
    iso3166Dash2: "ISO 3166-2:TW",
    region: "Asia",
    subRegion: "Eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "030",
    intermediateregionCode: ""
  },
  {
    name: "Tajikistan",
    alpha2: "TJ",
    alpha3: "TJK",
    countryCode: 762,
    iso3166Dash2: "ISO 3166-2:TJ",
    region: "Asia",
    subRegion: "Central Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 143,
    intermediateregionCode: ""
  },
  {
    name: "Tanzania, United Republic of",
    alpha2: "TZ",
    alpha3: "TZA",
    countryCode: 834,
    iso3166Dash2: "ISO 3166-2:TZ",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Thailand",
    alpha2: "TH",
    alpha3: "THA",
    countryCode: 764,
    iso3166Dash2: "ISO 3166-2:TH",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Timor-Leste",
    alpha2: "TL",
    alpha3: "TLS",
    countryCode: 626,
    iso3166Dash2: "ISO 3166-2:TL",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Togo",
    alpha2: "TG",
    alpha3: "TGO",
    countryCode: 768,
    iso3166Dash2: "ISO 3166-2:TG",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Western Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "011"
  },
  {
    name: "Tokelau",
    alpha2: "TK",
    alpha3: "TKL",
    countryCode: 772,
    iso3166Dash2: "ISO 3166-2:TK",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Tonga",
    alpha2: "TO",
    alpha3: "TON",
    countryCode: 776,
    iso3166Dash2: "ISO 3166-2:TO",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Trinidad and Tobago",
    alpha2: "TT",
    alpha3: "TTO",
    countryCode: 780,
    iso3166Dash2: "ISO 3166-2:TT",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Tunisia",
    alpha2: "TN",
    alpha3: "TUN",
    countryCode: 788,
    iso3166Dash2: "ISO 3166-2:TN",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "Turkey",
    alpha2: "TR",
    alpha3: "TUR",
    countryCode: 792,
    iso3166Dash2: "ISO 3166-2:TR",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Turkmenistan",
    alpha2: "TM",
    alpha3: "TKM",
    countryCode: 795,
    iso3166Dash2: "ISO 3166-2:TM",
    region: "Asia",
    subRegion: "Central Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 143,
    intermediateregionCode: ""
  },
  {
    name: "Turks and Caicos Islands",
    alpha2: "TC",
    alpha3: "TCA",
    countryCode: 796,
    iso3166Dash2: "ISO 3166-2:TC",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Tuvalu",
    alpha2: "TV",
    alpha3: "TUV",
    countryCode: 798,
    iso3166Dash2: "ISO 3166-2:TV",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Uganda",
    alpha2: "UG",
    alpha3: "UGA",
    countryCode: 800,
    iso3166Dash2: "ISO 3166-2:UG",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Ukraine",
    alpha2: "UA",
    alpha3: "UKR",
    countryCode: 804,
    iso3166Dash2: "ISO 3166-2:UA",
    region: "Europe",
    subRegion: "Eastern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 151,
    intermediateregionCode: ""
  },
  {
    name: "United Arab Emirates",
    alpha2: "AE",
    alpha3: "ARE",
    countryCode: 784,
    iso3166Dash2: "ISO 3166-2:AE",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    alpha2: "GB",
    alpha3: "GBR",
    countryCode: 826,
    iso3166Dash2: "ISO 3166-2:GB",
    region: "Europe",
    subRegion: "Northern Europe",
    intermediateRegion: "",
    regionCode: 150,
    subregionCode: 154,
    intermediateregionCode: ""
  },
  {
    name: "United States of America",
    alpha2: "US",
    alpha3: "USA",
    countryCode: 840,
    iso3166Dash2: "ISO 3166-2:US",
    region: "Americas",
    subRegion: "Northern America",
    intermediateRegion: "",
    regionCode: "019",
    subregionCode: "021",
    intermediateregionCode: ""
  },
  {
    name: "United States Minor Outlying Islands",
    alpha2: "UM",
    alpha3: "UMI",
    countryCode: 581,
    iso3166Dash2: "ISO 3166-2:UM",
    region: "Oceania",
    subRegion: "Micronesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "057",
    intermediateregionCode: ""
  },
  {
    name: "Uruguay",
    alpha2: "UY",
    alpha3: "URY",
    countryCode: 858,
    iso3166Dash2: "ISO 3166-2:UY",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Uzbekistan",
    alpha2: "UZ",
    alpha3: "UZB",
    countryCode: 860,
    iso3166Dash2: "ISO 3166-2:UZ",
    region: "Asia",
    subRegion: "Central Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 143,
    intermediateregionCode: ""
  },
  {
    name: "Vanuatu",
    alpha2: "VU",
    alpha3: "VUT",
    countryCode: 548,
    iso3166Dash2: "ISO 3166-2:VU",
    region: "Oceania",
    subRegion: "Melanesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "054",
    intermediateregionCode: ""
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    alpha2: "VE",
    alpha3: "VEN",
    countryCode: 862,
    iso3166Dash2: "ISO 3166-2:VE",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "South America",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "005"
  },
  {
    name: "Viet Nam",
    alpha2: "VN",
    alpha3: "VNM",
    countryCode: 704,
    iso3166Dash2: "ISO 3166-2:VN",
    region: "Asia",
    subRegion: "South-eastern Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: "035",
    intermediateregionCode: ""
  },
  {
    name: "Virgin Islands (British)",
    alpha2: "VG",
    alpha3: "VGB",
    countryCode: "092",
    iso3166Dash2: "ISO 3166-2:VG",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Virgin Islands (U.S.)",
    alpha2: "VI",
    alpha3: "VIR",
    countryCode: 850,
    iso3166Dash2: "ISO 3166-2:VI",
    region: "Americas",
    subRegion: "Latin America and the Caribbean",
    intermediateRegion: "Caribbean",
    regionCode: "019",
    subregionCode: 419,
    intermediateregionCode: "029"
  },
  {
    name: "Wallis and Futuna",
    alpha2: "WF",
    alpha3: "WLF",
    countryCode: 876,
    iso3166Dash2: "ISO 3166-2:WF",
    region: "Oceania",
    subRegion: "Polynesia",
    intermediateRegion: "",
    regionCode: "009",
    subregionCode: "061",
    intermediateregionCode: ""
  },
  {
    name: "Western Sahara",
    alpha2: "EH",
    alpha3: "ESH",
    countryCode: 732,
    iso3166Dash2: "ISO 3166-2:EH",
    region: "Africa",
    subRegion: "Northern Africa",
    intermediateRegion: "",
    regionCode: "002",
    subregionCode: "015",
    intermediateregionCode: ""
  },
  {
    name: "Yemen",
    alpha2: "YE",
    alpha3: "YEM",
    countryCode: 887,
    iso3166Dash2: "ISO 3166-2:YE",
    region: "Asia",
    subRegion: "Western Asia",
    intermediateRegion: "",
    regionCode: 142,
    subregionCode: 145,
    intermediateregionCode: ""
  },
  {
    name: "Zambia",
    alpha2: "ZM",
    alpha3: "ZMB",
    countryCode: 894,
    iso3166Dash2: "ISO 3166-2:ZM",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  },
  {
    name: "Zimbabwe",
    alpha2: "ZW",
    alpha3: "ZWE",
    countryCode: 716,
    iso3166Dash2: "ISO 3166-2:ZW",
    region: "Africa",
    subRegion: "Sub-Saharan Africa",
    intermediateRegion: "Eastern Africa",
    regionCode: "002",
    subregionCode: 202,
    intermediateregionCode: "014"
  }
], Li = {
  "Åland Islands": null,
  "American Samoa": null,
  Antarctica: null,
  "Antigua and Barbuda": "antigua & barbuda",
  "Bolivia (Plurinational State of)": "bolivia",
  "Bonaire, Sint Eustatius and Saba": null,
  "Bosnia and Herzegovina": "bosnia herzegovina",
  "Bouvet Island": null,
  "Brunei Darussalam": null,
  "Cabo Verde": "cape verde islands",
  Chad: null,
  "Christmas Island": null,
  "Cocos (Keeling) Islands": null,
  Congo: "none",
  // icon called 'congo' is flag of Democratic Republic of the Congo
  "Congo, Democratic Republic of the": "congo",
  "Côte d'Ivoire": null,
  Curaçao: null,
  Cyprus: null,
  Czechia: "czech republic",
  Eswatini: null,
  "Falkland Islands (Malvinas)": null,
  "French Southern Territories": null,
  "Heard Island and McDonald Islands": null,
  "Holy See": "vatican city",
  "Iran (Islamic Republic of)": "iran",
  "Isle of Man": null,
  Jersey: null,
  "Korea (Democratic People's Republic of)": "korea - north",
  "Korea, Republic of": "korea - south",
  "Lao People's Democratic Republic": "laos",
  Mauritius: null,
  "Micronesia (Federated States of)": "micronesia",
  "Moldova, Republic of": "moldova",
  "Norfolk Island": null,
  "North Macedonia": "macedonia",
  "Northern Mariana Islands": null,
  "Palestine, State of": null,
  Pitcairn: null,
  Réunion: "reunion",
  "Russian Federation": "russia",
  "Saint Barthélemy": null,
  "Saint Helena, Ascension and Tristan da Cunha": null,
  "Saint Kitts and Nevis": null,
  "Saint Lucia": null,
  "Saint Martin (French part)": null,
  "Saint Pierre and Miquelon": null,
  "Saint Vincent and the Grenadines": null,
  Samoa: null,
  "Sao Tome and Principe": null,
  "Sint Maarten (Dutch part)": null,
  Slovakia: "slovak republic",
  "South Georgia and the South Sandwich Islands": null,
  "South Sudan": null,
  "Svalbard and Jan Mayen": null,
  "Syrian Arab Republic": "syria",
  "Taiwan, Province of China": "taiwan",
  "Tanzania, United Republic of": null,
  "Timor-Leste": null,
  Tokelau: null,
  "Trinidad and Tobago": null,
  "Turks and Caicos Islands": null,
  "United Kingdom of Great Britain and Northern Ireland": "uk",
  "United States Minor Outlying Islands": null,
  "United States of America": "united states",
  "Venezuela (Bolivarian Republic of)": "venezuela",
  "Viet Nam": "vietnam",
  "Virgin Islands (British)": "virgin islands - british",
  "Virgin Islands (U.S.)": "virgin islands - us",
  "Wallis and Futuna": null,
  "Western Sahara": null,
  Yemen: null
}, Bt = ({ name: r, ...t }) => {
  if (!r || r.length === 0)
    throw new Error("name prop is required for CountryRender component");
  return /* @__PURE__ */ e.createElement(P, { alignItems: "center", justifyContent: "flex-start", flexDirection: "row", ...t }, /* @__PURE__ */ e.createElement(V, { noHoverEffects: !0, type: Li[r] || r.toLowerCase() }), /* @__PURE__ */ e.createElement(B, { factor: 0.75 }), r);
};
Bt.propTypes = {
  name: i.string.isRequired
};
function sn({
  label: r,
  width: t,
  initialValue: n,
  value: a,
  onChange: l,
  testId: o,
  name: s,
  disabled: d,
  hasChangedType: c,
  placeholder: m,
  error: h,
  isError: p
}) {
  const u = (A) => {
    if (isNaN(Number(A))) {
      const D = Ct.find(({ alpha2: f }) => String(f) === A);
      return D && String(D.countryCode);
    }
    return String(A);
  }, [C, E] = z(u(n)), g = Ct.map(({ countryCode: A, name: Z }) => {
    const D = String(A);
    return {
      id: A,
      val: D,
      render: /* @__PURE__ */ e.createElement(Bt, { name: Z }),
      renderSelected: /* @__PURE__ */ e.createElement(Bt, { name: Z }),
      searchString: Z
    };
  }), L = ({ val: A }) => {
    E(A);
    const Z = Ct.find(
      ({ countryCode: D }) => String(D) === String(A)
    );
    l(Z);
  }, x = Y(
    () => g.find(({ val: A }) => A === C),
    [g, C]
  );
  return /* @__PURE__ */ e.createElement(
    dt,
    {
      label: r,
      testId: o,
      width: t,
      onChange: L,
      value: x,
      options: g,
      showSearch: !0,
      name: s,
      disabled: d,
      hasChangedType: c,
      placeholder: m,
      error: h,
      isError: p
    }
  );
}
sn.propTypes = {
  label: i.string,
  width: i.string,
  initialValue: i.oneOfType([i.string, i.number]),
  onChange: i.func,
  testId: i.string,
  name: i.string,
  disabled: i.bool,
  hasChangedType: i.string,
  kind: i.string,
  placeholder: i.string,
  error: i.oneOfType([i.string, i.bool]),
  isError: i.func
};
sn.defaultProps = {
  label: "Select a country",
  width: "100px",
  initialValue: null,
  onChange: () => {
  },
  testId: "country-select",
  name: "",
  disabled: !1,
  kind: "select"
};
function wi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var vi = [
  {
    code: "AED",
    number: "784",
    digits: 2,
    currency: "UAE Dirham",
    countries: [
      "United Arab Emirates (The)"
    ]
  },
  {
    code: "AFN",
    number: "971",
    digits: 2,
    currency: "Afghani",
    countries: [
      "Afghanistan"
    ]
  },
  {
    code: "ALL",
    number: "008",
    digits: 2,
    currency: "Lek",
    countries: [
      "Albania"
    ]
  },
  {
    code: "AMD",
    number: "051",
    digits: 2,
    currency: "Armenian Dram",
    countries: [
      "Armenia"
    ]
  },
  {
    code: "ANG",
    number: "532",
    digits: 2,
    currency: "Netherlands Antillean Guilder",
    countries: [
      "Curaçao",
      "Sint Maarten (Dutch Part)"
    ]
  },
  {
    code: "AOA",
    number: "973",
    digits: 2,
    currency: "Kwanza",
    countries: [
      "Angola"
    ]
  },
  {
    code: "ARS",
    number: "032",
    digits: 2,
    currency: "Argentine Peso",
    countries: [
      "Argentina"
    ]
  },
  {
    code: "AUD",
    number: "036",
    digits: 2,
    currency: "Australian Dollar",
    countries: [
      "Australia",
      "Christmas Island",
      "Cocos (Keeling) Islands (The)",
      "Heard Island and Mcdonald Islands",
      "Kiribati",
      "Nauru",
      "Norfolk Island",
      "Tuvalu"
    ]
  },
  {
    code: "AWG",
    number: "533",
    digits: 2,
    currency: "Aruban Florin",
    countries: [
      "Aruba"
    ]
  },
  {
    code: "AZN",
    number: "944",
    digits: 2,
    currency: "Azerbaijan Manat",
    countries: [
      "Azerbaijan"
    ]
  },
  {
    code: "BAM",
    number: "977",
    digits: 2,
    currency: "Convertible Mark",
    countries: [
      "Bosnia and Herzegovina"
    ]
  },
  {
    code: "BBD",
    number: "052",
    digits: 2,
    currency: "Barbados Dollar",
    countries: [
      "Barbados"
    ]
  },
  {
    code: "BDT",
    number: "050",
    digits: 2,
    currency: "Taka",
    countries: [
      "Bangladesh"
    ]
  },
  {
    code: "BGN",
    number: "975",
    digits: 2,
    currency: "Bulgarian Lev",
    countries: [
      "Bulgaria"
    ]
  },
  {
    code: "BHD",
    number: "048",
    digits: 3,
    currency: "Bahraini Dinar",
    countries: [
      "Bahrain"
    ]
  },
  {
    code: "BIF",
    number: "108",
    digits: 0,
    currency: "Burundi Franc",
    countries: [
      "Burundi"
    ]
  },
  {
    code: "BMD",
    number: "060",
    digits: 2,
    currency: "Bermudian Dollar",
    countries: [
      "Bermuda"
    ]
  },
  {
    code: "BND",
    number: "096",
    digits: 2,
    currency: "Brunei Dollar",
    countries: [
      "Brunei Darussalam"
    ]
  },
  {
    code: "BOB",
    number: "068",
    digits: 2,
    currency: "Boliviano",
    countries: [
      "Bolivia (Plurinational State Of)"
    ]
  },
  {
    code: "BOV",
    number: "984",
    digits: 2,
    currency: "Mvdol",
    countries: [
      "Bolivia (Plurinational State Of)"
    ]
  },
  {
    code: "BRL",
    number: "986",
    digits: 2,
    currency: "Brazilian Real",
    countries: [
      "Brazil"
    ]
  },
  {
    code: "BSD",
    number: "044",
    digits: 2,
    currency: "Bahamian Dollar",
    countries: [
      "Bahamas (The)"
    ]
  },
  {
    code: "BTN",
    number: "064",
    digits: 2,
    currency: "Ngultrum",
    countries: [
      "Bhutan"
    ]
  },
  {
    code: "BWP",
    number: "072",
    digits: 2,
    currency: "Pula",
    countries: [
      "Botswana"
    ]
  },
  {
    code: "BYN",
    number: "933",
    digits: 2,
    currency: "Belarusian Ruble",
    countries: [
      "Belarus"
    ]
  },
  {
    code: "BZD",
    number: "084",
    digits: 2,
    currency: "Belize Dollar",
    countries: [
      "Belize"
    ]
  },
  {
    code: "CAD",
    number: "124",
    digits: 2,
    currency: "Canadian Dollar",
    countries: [
      "Canada"
    ]
  },
  {
    code: "CDF",
    number: "976",
    digits: 2,
    currency: "Congolese Franc",
    countries: [
      "Congo (The Democratic Republic of The)"
    ]
  },
  {
    code: "CHE",
    number: "947",
    digits: 2,
    currency: "WIR Euro",
    countries: [
      "Switzerland"
    ]
  },
  {
    code: "CHF",
    number: "756",
    digits: 2,
    currency: "Swiss Franc",
    countries: [
      "Liechtenstein",
      "Switzerland"
    ]
  },
  {
    code: "CHW",
    number: "948",
    digits: 2,
    currency: "WIR Franc",
    countries: [
      "Switzerland"
    ]
  },
  {
    code: "CLF",
    number: "990",
    digits: 4,
    currency: "Unidad de Fomento",
    countries: [
      "Chile"
    ]
  },
  {
    code: "CLP",
    number: "152",
    digits: 0,
    currency: "Chilean Peso",
    countries: [
      "Chile"
    ]
  },
  {
    code: "CNY",
    number: "156",
    digits: 2,
    currency: "Yuan Renminbi",
    countries: [
      "China"
    ]
  },
  {
    code: "COP",
    number: "170",
    digits: 2,
    currency: "Colombian Peso",
    countries: [
      "Colombia"
    ]
  },
  {
    code: "COU",
    number: "970",
    digits: 2,
    currency: "Unidad de Valor Real",
    countries: [
      "Colombia"
    ]
  },
  {
    code: "CRC",
    number: "188",
    digits: 2,
    currency: "Costa Rican Colon",
    countries: [
      "Costa Rica"
    ]
  },
  {
    code: "CUC",
    number: "931",
    digits: 2,
    currency: "Peso Convertible",
    countries: [
      "Cuba"
    ]
  },
  {
    code: "CUP",
    number: "192",
    digits: 2,
    currency: "Cuban Peso",
    countries: [
      "Cuba"
    ]
  },
  {
    code: "CVE",
    number: "132",
    digits: 2,
    currency: "Cabo Verde Escudo",
    countries: [
      "Cabo Verde"
    ]
  },
  {
    code: "CZK",
    number: "203",
    digits: 2,
    currency: "Czech Koruna",
    countries: [
      "Czechia"
    ]
  },
  {
    code: "DJF",
    number: "262",
    digits: 0,
    currency: "Djibouti Franc",
    countries: [
      "Djibouti"
    ]
  },
  {
    code: "DKK",
    number: "208",
    digits: 2,
    currency: "Danish Krone",
    countries: [
      "Denmark",
      "Faroe Islands (The)",
      "Greenland"
    ]
  },
  {
    code: "DOP",
    number: "214",
    digits: 2,
    currency: "Dominican Peso",
    countries: [
      "Dominican Republic (The)"
    ]
  },
  {
    code: "DZD",
    number: "012",
    digits: 2,
    currency: "Algerian Dinar",
    countries: [
      "Algeria"
    ]
  },
  {
    code: "EGP",
    number: "818",
    digits: 2,
    currency: "Egyptian Pound",
    countries: [
      "Egypt"
    ]
  },
  {
    code: "ERN",
    number: "232",
    digits: 2,
    currency: "Nakfa",
    countries: [
      "Eritrea"
    ]
  },
  {
    code: "ETB",
    number: "230",
    digits: 2,
    currency: "Ethiopian Birr",
    countries: [
      "Ethiopia"
    ]
  },
  {
    code: "EUR",
    number: "978",
    digits: 2,
    currency: "Euro",
    countries: [
      "Åland Islands",
      "Andorra",
      "Austria",
      "Belgium",
      "Cyprus",
      "Estonia",
      "European Union",
      "Finland",
      "France",
      "French Guiana",
      "French Southern Territories (The)",
      "Germany",
      "Greece",
      "Guadeloupe",
      "Holy See (The)",
      "Ireland",
      "Italy",
      "Latvia",
      "Lithuania",
      "Luxembourg",
      "Malta",
      "Martinique",
      "Mayotte",
      "Monaco",
      "Montenegro",
      "Netherlands (The)",
      "Portugal",
      "Réunion",
      "Saint Barthélemy",
      "Saint Martin (French Part)",
      "Saint Pierre and Miquelon",
      "San Marino",
      "Slovakia",
      "Slovenia",
      "Spain"
    ]
  },
  {
    code: "FJD",
    number: "242",
    digits: 2,
    currency: "Fiji Dollar",
    countries: [
      "Fiji"
    ]
  },
  {
    code: "FKP",
    number: "238",
    digits: 2,
    currency: "Falkland Islands Pound",
    countries: [
      "Falkland Islands (The) [Malvinas]"
    ]
  },
  {
    code: "GBP",
    number: "826",
    digits: 2,
    currency: "Pound Sterling",
    countries: [
      "Guernsey",
      "Isle of Man",
      "Jersey",
      "United Kingdom of Great Britain and Northern Ireland (The)"
    ]
  },
  {
    code: "GEL",
    number: "981",
    digits: 2,
    currency: "Lari",
    countries: [
      "Georgia"
    ]
  },
  {
    code: "GHS",
    number: "936",
    digits: 2,
    currency: "Ghana Cedi",
    countries: [
      "Ghana"
    ]
  },
  {
    code: "GIP",
    number: "292",
    digits: 2,
    currency: "Gibraltar Pound",
    countries: [
      "Gibraltar"
    ]
  },
  {
    code: "GMD",
    number: "270",
    digits: 2,
    currency: "Dalasi",
    countries: [
      "Gambia (The)"
    ]
  },
  {
    code: "GNF",
    number: "324",
    digits: 0,
    currency: "Guinean Franc",
    countries: [
      "Guinea"
    ]
  },
  {
    code: "GTQ",
    number: "320",
    digits: 2,
    currency: "Quetzal",
    countries: [
      "Guatemala"
    ]
  },
  {
    code: "GYD",
    number: "328",
    digits: 2,
    currency: "Guyana Dollar",
    countries: [
      "Guyana"
    ]
  },
  {
    code: "HKD",
    number: "344",
    digits: 2,
    currency: "Hong Kong Dollar",
    countries: [
      "Hong Kong"
    ]
  },
  {
    code: "HNL",
    number: "340",
    digits: 2,
    currency: "Lempira",
    countries: [
      "Honduras"
    ]
  },
  {
    code: "HRK",
    number: "191",
    digits: 2,
    currency: "Kuna",
    countries: [
      "Croatia"
    ]
  },
  {
    code: "HTG",
    number: "332",
    digits: 2,
    currency: "Gourde",
    countries: [
      "Haiti"
    ]
  },
  {
    code: "HUF",
    number: "348",
    digits: 2,
    currency: "Forint",
    countries: [
      "Hungary"
    ]
  },
  {
    code: "IDR",
    number: "360",
    digits: 2,
    currency: "Rupiah",
    countries: [
      "Indonesia"
    ]
  },
  {
    code: "ILS",
    number: "376",
    digits: 2,
    currency: "New Israeli Sheqel",
    countries: [
      "Israel"
    ]
  },
  {
    code: "INR",
    number: "356",
    digits: 2,
    currency: "Indian Rupee",
    countries: [
      "Bhutan",
      "India"
    ]
  },
  {
    code: "IQD",
    number: "368",
    digits: 3,
    currency: "Iraqi Dinar",
    countries: [
      "Iraq"
    ]
  },
  {
    code: "IRR",
    number: "364",
    digits: 2,
    currency: "Iranian Rial",
    countries: [
      "Iran (Islamic Republic Of)"
    ]
  },
  {
    code: "ISK",
    number: "352",
    digits: 0,
    currency: "Iceland Krona",
    countries: [
      "Iceland"
    ]
  },
  {
    code: "JMD",
    number: "388",
    digits: 2,
    currency: "Jamaican Dollar",
    countries: [
      "Jamaica"
    ]
  },
  {
    code: "JOD",
    number: "400",
    digits: 3,
    currency: "Jordanian Dinar",
    countries: [
      "Jordan"
    ]
  },
  {
    code: "JPY",
    number: "392",
    digits: 0,
    currency: "Yen",
    countries: [
      "Japan"
    ]
  },
  {
    code: "KES",
    number: "404",
    digits: 2,
    currency: "Kenyan Shilling",
    countries: [
      "Kenya"
    ]
  },
  {
    code: "KGS",
    number: "417",
    digits: 2,
    currency: "Som",
    countries: [
      "Kyrgyzstan"
    ]
  },
  {
    code: "KHR",
    number: "116",
    digits: 2,
    currency: "Riel",
    countries: [
      "Cambodia"
    ]
  },
  {
    code: "KMF",
    number: "174",
    digits: 0,
    currency: "Comorian Franc ",
    countries: [
      "Comoros (The)"
    ]
  },
  {
    code: "KPW",
    number: "408",
    digits: 2,
    currency: "North Korean Won",
    countries: [
      "Korea (The Democratic People’s Republic Of)"
    ]
  },
  {
    code: "KRW",
    number: "410",
    digits: 0,
    currency: "Won",
    countries: [
      "Korea (The Republic Of)"
    ]
  },
  {
    code: "KWD",
    number: "414",
    digits: 3,
    currency: "Kuwaiti Dinar",
    countries: [
      "Kuwait"
    ]
  },
  {
    code: "KYD",
    number: "136",
    digits: 2,
    currency: "Cayman Islands Dollar",
    countries: [
      "Cayman Islands (The)"
    ]
  },
  {
    code: "KZT",
    number: "398",
    digits: 2,
    currency: "Tenge",
    countries: [
      "Kazakhstan"
    ]
  },
  {
    code: "LAK",
    number: "418",
    digits: 2,
    currency: "Lao Kip",
    countries: [
      "Lao People’s Democratic Republic (The)"
    ]
  },
  {
    code: "LBP",
    number: "422",
    digits: 2,
    currency: "Lebanese Pound",
    countries: [
      "Lebanon"
    ]
  },
  {
    code: "LKR",
    number: "144",
    digits: 2,
    currency: "Sri Lanka Rupee",
    countries: [
      "Sri Lanka"
    ]
  },
  {
    code: "LRD",
    number: "430",
    digits: 2,
    currency: "Liberian Dollar",
    countries: [
      "Liberia"
    ]
  },
  {
    code: "LSL",
    number: "426",
    digits: 2,
    currency: "Loti",
    countries: [
      "Lesotho"
    ]
  },
  {
    code: "LYD",
    number: "434",
    digits: 3,
    currency: "Libyan Dinar",
    countries: [
      "Libya"
    ]
  },
  {
    code: "MAD",
    number: "504",
    digits: 2,
    currency: "Moroccan Dirham",
    countries: [
      "Morocco",
      "Western Sahara"
    ]
  },
  {
    code: "MDL",
    number: "498",
    digits: 2,
    currency: "Moldovan Leu",
    countries: [
      "Moldova (The Republic Of)"
    ]
  },
  {
    code: "MGA",
    number: "969",
    digits: 2,
    currency: "Malagasy Ariary",
    countries: [
      "Madagascar"
    ]
  },
  {
    code: "MKD",
    number: "807",
    digits: 2,
    currency: "Denar",
    countries: [
      "Macedonia (The Former Yugoslav Republic Of)"
    ]
  },
  {
    code: "MMK",
    number: "104",
    digits: 2,
    currency: "Kyat",
    countries: [
      "Myanmar"
    ]
  },
  {
    code: "MNT",
    number: "496",
    digits: 2,
    currency: "Tugrik",
    countries: [
      "Mongolia"
    ]
  },
  {
    code: "MOP",
    number: "446",
    digits: 2,
    currency: "Pataca",
    countries: [
      "Macao"
    ]
  },
  {
    code: "MRU",
    number: "929",
    digits: 2,
    currency: "Ouguiya",
    countries: [
      "Mauritania"
    ]
  },
  {
    code: "MUR",
    number: "480",
    digits: 2,
    currency: "Mauritius Rupee",
    countries: [
      "Mauritius"
    ]
  },
  {
    code: "MVR",
    number: "462",
    digits: 2,
    currency: "Rufiyaa",
    countries: [
      "Maldives"
    ]
  },
  {
    code: "MWK",
    number: "454",
    digits: 2,
    currency: "Malawi Kwacha",
    countries: [
      "Malawi"
    ]
  },
  {
    code: "MXN",
    number: "484",
    digits: 2,
    currency: "Mexican Peso",
    countries: [
      "Mexico"
    ]
  },
  {
    code: "MXV",
    number: "979",
    digits: 2,
    currency: "Mexican Unidad de Inversion (UDI)",
    countries: [
      "Mexico"
    ]
  },
  {
    code: "MYR",
    number: "458",
    digits: 2,
    currency: "Malaysian Ringgit",
    countries: [
      "Malaysia"
    ]
  },
  {
    code: "MZN",
    number: "943",
    digits: 2,
    currency: "Mozambique Metical",
    countries: [
      "Mozambique"
    ]
  },
  {
    code: "NAD",
    number: "516",
    digits: 2,
    currency: "Namibia Dollar",
    countries: [
      "Namibia"
    ]
  },
  {
    code: "NGN",
    number: "566",
    digits: 2,
    currency: "Naira",
    countries: [
      "Nigeria"
    ]
  },
  {
    code: "NIO",
    number: "558",
    digits: 2,
    currency: "Cordoba Oro",
    countries: [
      "Nicaragua"
    ]
  },
  {
    code: "NOK",
    number: "578",
    digits: 2,
    currency: "Norwegian Krone",
    countries: [
      "Bouvet Island",
      "Norway",
      "Svalbard and Jan Mayen"
    ]
  },
  {
    code: "NPR",
    number: "524",
    digits: 2,
    currency: "Nepalese Rupee",
    countries: [
      "Nepal"
    ]
  },
  {
    code: "NZD",
    number: "554",
    digits: 2,
    currency: "New Zealand Dollar",
    countries: [
      "Cook Islands (The)",
      "New Zealand",
      "Niue",
      "Pitcairn",
      "Tokelau"
    ]
  },
  {
    code: "OMR",
    number: "512",
    digits: 3,
    currency: "Rial Omani",
    countries: [
      "Oman"
    ]
  },
  {
    code: "PAB",
    number: "590",
    digits: 2,
    currency: "Balboa",
    countries: [
      "Panama"
    ]
  },
  {
    code: "PEN",
    number: "604",
    digits: 2,
    currency: "Sol",
    countries: [
      "Peru"
    ]
  },
  {
    code: "PGK",
    number: "598",
    digits: 2,
    currency: "Kina",
    countries: [
      "Papua New Guinea"
    ]
  },
  {
    code: "PHP",
    number: "608",
    digits: 2,
    currency: "Philippine Peso",
    countries: [
      "Philippines (The)"
    ]
  },
  {
    code: "PKR",
    number: "586",
    digits: 2,
    currency: "Pakistan Rupee",
    countries: [
      "Pakistan"
    ]
  },
  {
    code: "PLN",
    number: "985",
    digits: 2,
    currency: "Zloty",
    countries: [
      "Poland"
    ]
  },
  {
    code: "PYG",
    number: "600",
    digits: 0,
    currency: "Guarani",
    countries: [
      "Paraguay"
    ]
  },
  {
    code: "QAR",
    number: "634",
    digits: 2,
    currency: "Qatari Rial",
    countries: [
      "Qatar"
    ]
  },
  {
    code: "RON",
    number: "946",
    digits: 2,
    currency: "Romanian Leu",
    countries: [
      "Romania"
    ]
  },
  {
    code: "RSD",
    number: "941",
    digits: 2,
    currency: "Serbian Dinar",
    countries: [
      "Serbia"
    ]
  },
  {
    code: "RUB",
    number: "643",
    digits: 2,
    currency: "Russian Ruble",
    countries: [
      "Russian Federation (The)"
    ]
  },
  {
    code: "RWF",
    number: "646",
    digits: 0,
    currency: "Rwanda Franc",
    countries: [
      "Rwanda"
    ]
  },
  {
    code: "SAR",
    number: "682",
    digits: 2,
    currency: "Saudi Riyal",
    countries: [
      "Saudi Arabia"
    ]
  },
  {
    code: "SBD",
    number: "090",
    digits: 2,
    currency: "Solomon Islands Dollar",
    countries: [
      "Solomon Islands"
    ]
  },
  {
    code: "SCR",
    number: "690",
    digits: 2,
    currency: "Seychelles Rupee",
    countries: [
      "Seychelles"
    ]
  },
  {
    code: "SDG",
    number: "938",
    digits: 2,
    currency: "Sudanese Pound",
    countries: [
      "Sudan (The)"
    ]
  },
  {
    code: "SEK",
    number: "752",
    digits: 2,
    currency: "Swedish Krona",
    countries: [
      "Sweden"
    ]
  },
  {
    code: "SGD",
    number: "702",
    digits: 2,
    currency: "Singapore Dollar",
    countries: [
      "Singapore"
    ]
  },
  {
    code: "SHP",
    number: "654",
    digits: 2,
    currency: "Saint Helena Pound",
    countries: [
      "Saint Helena, Ascension and Tristan Da Cunha"
    ]
  },
  {
    code: "SLL",
    number: "694",
    digits: 2,
    currency: "Leone",
    countries: [
      "Sierra Leone"
    ]
  },
  {
    code: "SOS",
    number: "706",
    digits: 2,
    currency: "Somali Shilling",
    countries: [
      "Somalia"
    ]
  },
  {
    code: "SRD",
    number: "968",
    digits: 2,
    currency: "Surinam Dollar",
    countries: [
      "Suriname"
    ]
  },
  {
    code: "SSP",
    number: "728",
    digits: 2,
    currency: "South Sudanese Pound",
    countries: [
      "South Sudan"
    ]
  },
  {
    code: "STN",
    number: "930",
    digits: 2,
    currency: "Dobra",
    countries: [
      "Sao Tome and Principe"
    ]
  },
  {
    code: "SVC",
    number: "222",
    digits: 2,
    currency: "El Salvador Colon",
    countries: [
      "El Salvador"
    ]
  },
  {
    code: "SYP",
    number: "760",
    digits: 2,
    currency: "Syrian Pound",
    countries: [
      "Syrian Arab Republic"
    ]
  },
  {
    code: "SZL",
    number: "748",
    digits: 2,
    currency: "Lilangeni",
    countries: [
      "Eswatini"
    ]
  },
  {
    code: "THB",
    number: "764",
    digits: 2,
    currency: "Baht",
    countries: [
      "Thailand"
    ]
  },
  {
    code: "TJS",
    number: "972",
    digits: 2,
    currency: "Somoni",
    countries: [
      "Tajikistan"
    ]
  },
  {
    code: "TMT",
    number: "934",
    digits: 2,
    currency: "Turkmenistan New Manat",
    countries: [
      "Turkmenistan"
    ]
  },
  {
    code: "TND",
    number: "788",
    digits: 3,
    currency: "Tunisian Dinar",
    countries: [
      "Tunisia"
    ]
  },
  {
    code: "TOP",
    number: "776",
    digits: 2,
    currency: "Pa’anga",
    countries: [
      "Tonga"
    ]
  },
  {
    code: "TRY",
    number: "949",
    digits: 2,
    currency: "Turkish Lira",
    countries: [
      "Turkey"
    ]
  },
  {
    code: "TTD",
    number: "780",
    digits: 2,
    currency: "Trinidad and Tobago Dollar",
    countries: [
      "Trinidad and Tobago"
    ]
  },
  {
    code: "TWD",
    number: "901",
    digits: 2,
    currency: "New Taiwan Dollar",
    countries: [
      "Taiwan (Province of China)"
    ]
  },
  {
    code: "TZS",
    number: "834",
    digits: 2,
    currency: "Tanzanian Shilling",
    countries: [
      "Tanzania, United Republic Of"
    ]
  },
  {
    code: "UAH",
    number: "980",
    digits: 2,
    currency: "Hryvnia",
    countries: [
      "Ukraine"
    ]
  },
  {
    code: "UGX",
    number: "800",
    digits: 0,
    currency: "Uganda Shilling",
    countries: [
      "Uganda"
    ]
  },
  {
    code: "USD",
    number: "840",
    digits: 2,
    currency: "US Dollar",
    countries: [
      "American Samoa",
      "Bonaire, Sint Eustatius and Saba",
      "British Indian Ocean Territory (The)",
      "Ecuador",
      "El Salvador",
      "Guam",
      "Haiti",
      "Marshall Islands (The)",
      "Micronesia (Federated States Of)",
      "Northern Mariana Islands (The)",
      "Palau",
      "Panama",
      "Puerto Rico",
      "Timor-Leste",
      "Turks and Caicos Islands (The)",
      "United States Minor Outlying Islands (The)",
      "United States of America (The)",
      "Virgin Islands (British)",
      "Virgin Islands (U.S.)"
    ]
  },
  {
    code: "USN",
    number: "997",
    digits: 2,
    currency: "US Dollar (Next day)",
    countries: [
      "United States of America (The)"
    ]
  },
  {
    code: "UYI",
    number: "940",
    digits: 0,
    currency: "Uruguay Peso en Unidades Indexadas (UI)",
    countries: [
      "Uruguay"
    ]
  },
  {
    code: "UYU",
    number: "858",
    digits: 2,
    currency: "Peso Uruguayo",
    countries: [
      "Uruguay"
    ]
  },
  {
    code: "UYW",
    number: "927",
    digits: 4,
    currency: "Unidad Previsional",
    countries: [
      "Uruguay"
    ]
  },
  {
    code: "UZS",
    number: "860",
    digits: 2,
    currency: "Uzbekistan Sum",
    countries: [
      "Uzbekistan"
    ]
  },
  {
    code: "VES",
    number: "928",
    digits: 2,
    currency: "Bolívar Soberano",
    countries: [
      "Venezuela (Bolivarian Republic Of)"
    ]
  },
  {
    code: "VND",
    number: "704",
    digits: 0,
    currency: "Dong",
    countries: [
      "Viet Nam"
    ]
  },
  {
    code: "VUV",
    number: "548",
    digits: 0,
    currency: "Vatu",
    countries: [
      "Vanuatu"
    ]
  },
  {
    code: "WST",
    number: "882",
    digits: 2,
    currency: "Tala",
    countries: [
      "Samoa"
    ]
  },
  {
    code: "XAF",
    number: "950",
    digits: 0,
    currency: "CFA Franc BEAC",
    countries: [
      "Cameroon",
      "Central African Republic (The)",
      "Chad",
      "Congo (The)",
      "Equatorial Guinea",
      "Gabon"
    ]
  },
  {
    code: "XAG",
    number: "961",
    digits: 0,
    currency: "Silver",
    countries: [
      "Zz11_silver"
    ]
  },
  {
    code: "XAU",
    number: "959",
    digits: 0,
    currency: "Gold",
    countries: [
      "Zz08_gold"
    ]
  },
  {
    code: "XBA",
    number: "955",
    digits: 0,
    currency: "Bond Markets Unit European Composite Unit (EURCO)",
    countries: [
      "Zz01_bond Markets Unit European_eurco"
    ]
  },
  {
    code: "XBB",
    number: "956",
    digits: 0,
    currency: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
    countries: [
      "Zz02_bond Markets Unit European_emu-6"
    ]
  },
  {
    code: "XBC",
    number: "957",
    digits: 0,
    currency: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
    countries: [
      "Zz03_bond Markets Unit European_eua-9"
    ]
  },
  {
    code: "XBD",
    number: "958",
    digits: 0,
    currency: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
    countries: [
      "Zz04_bond Markets Unit European_eua-17"
    ]
  },
  {
    code: "XCD",
    number: "951",
    digits: 2,
    currency: "East Caribbean Dollar",
    countries: [
      "Anguilla",
      "Antigua and Barbuda",
      "Dominica",
      "Grenada",
      "Montserrat",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines"
    ]
  },
  {
    code: "XDR",
    number: "960",
    digits: 0,
    currency: "SDR (Special Drawing Right)",
    countries: [
      "International Monetary Fund (Imf) "
    ]
  },
  {
    code: "XOF",
    number: "952",
    digits: 0,
    currency: "CFA Franc BCEAO",
    countries: [
      "Benin",
      "Burkina Faso",
      "Côte d'Ivoire",
      "Guinea-Bissau",
      "Mali",
      "Niger (The)",
      "Senegal",
      "Togo"
    ]
  },
  {
    code: "XPD",
    number: "964",
    digits: 0,
    currency: "Palladium",
    countries: [
      "Zz09_palladium"
    ]
  },
  {
    code: "XPF",
    number: "953",
    digits: 0,
    currency: "CFP Franc",
    countries: [
      "French Polynesia",
      "New Caledonia",
      "Wallis and Futuna"
    ]
  },
  {
    code: "XPT",
    number: "962",
    digits: 0,
    currency: "Platinum",
    countries: [
      "Zz10_platinum"
    ]
  },
  {
    code: "XSU",
    number: "994",
    digits: 0,
    currency: "Sucre",
    countries: [
      'Sistema Unitario De Compensacion Regional De Pagos "Sucre"'
    ]
  },
  {
    code: "XTS",
    number: "963",
    digits: 0,
    currency: "Codes specifically reserved for testing purposes",
    countries: [
      "Zz06_testing_code"
    ]
  },
  {
    code: "XUA",
    number: "965",
    digits: 0,
    currency: "ADB Unit of Account",
    countries: [
      "Member Countries of the African Development Bank Group"
    ]
  },
  {
    code: "XXX",
    number: "999",
    digits: 0,
    currency: "The codes assigned for transactions where no currency is involved",
    countries: [
      "Zz07_no_currency"
    ]
  },
  {
    code: "YER",
    number: "886",
    digits: 2,
    currency: "Yemeni Rial",
    countries: [
      "Yemen"
    ]
  },
  {
    code: "ZAR",
    number: "710",
    digits: 2,
    currency: "Rand",
    countries: [
      "Lesotho",
      "Namibia",
      "South Africa"
    ]
  },
  {
    code: "ZMW",
    number: "967",
    digits: 2,
    currency: "Zambian Kwacha",
    countries: [
      "Zambia"
    ]
  },
  {
    code: "ZWL",
    number: "932",
    digits: 2,
    currency: "Zimbabwe Dollar",
    countries: [
      "Zimbabwe"
    ]
  }
];
const yi = /* @__PURE__ */ wi(vi), C2 = N3(R3(["code", "number"]), yi), h0 = (r) => {
  if (!isNaN(Number(r))) {
    const t = C2.find(({ number: n }) => String(n) === String(r));
    return t == null ? void 0 : t.code;
  }
  return (r == null ? void 0 : r.code) ?? r;
}, bi = (r) => (t, n) => {
  const a = r.includes(t), l = r.includes(n);
  return a && l ? r.indexOf(t) - r.indexOf(n) : a ? -1 : l ? 1 : t.localeCompare(n);
}, Ai = {
  AED: "united arab emirates",
  AFN: "afghanistan",
  ALL: "albania",
  AMD: "armenia",
  AOA: "angola",
  ARS: "argentina",
  AUD: "australia",
  AWG: "aruba",
  AZN: "azerbaijan",
  BAM: "bosnia herzegovina",
  BBD: "barbados",
  BDT: "bangladesh",
  BGN: "bulgaria",
  BHD: "bahrain",
  BIF: "burundi",
  BMD: "bermuda",
  BND: "brunei",
  BOB: "bolivia",
  BOV: "bolivia",
  BRL: "brazil",
  BSD: "bahamas",
  BTN: "bhutan",
  BWP: "botswana",
  BYN: "belarus",
  BZD: "belize",
  CAD: "canada",
  CDF: "congo",
  CHE: "switzerland",
  CHF: "liechtenstein",
  CHW: "switzerland",
  CLF: "chile",
  CLP: "chile",
  CNY: "china",
  COP: "colombia",
  COU: "colombia",
  CRC: "costa rica",
  CUC: "cuba",
  CUP: "cuba",
  CVE: "cape verde islands",
  CZK: "czech republic",
  DJF: "djibouti",
  DKK: "denmark",
  DOP: "dominican republic",
  DZD: "algeria",
  EGP: "egypt",
  ERN: "eritrea",
  ETB: "ethiopia",
  EUR: "european union.svg",
  FJD: "fiji",
  FKP: "falkland islands",
  GBP: "uk",
  GEL: "georgia",
  GHS: "ghana",
  GIP: "gibraltar",
  GMD: "gambia",
  GNF: "guinea",
  GTQ: "guatemala",
  GYD: "guyana",
  HKD: "hong kong",
  HNL: "honduras",
  HRK: "croatia",
  HTG: "haiti",
  HUF: "hungary",
  IDR: "indonesia",
  ILS: "israel",
  INR: "bhutan",
  IQD: "iraq",
  IRR: "iran",
  ISK: "iceland",
  JMD: "jamaica",
  JOD: "jordan",
  JPY: "japan",
  KES: "kenya",
  KGS: "kyrgyzstan",
  KHR: "cambodia",
  KMF: "comoros",
  KPW: "korea - north",
  KRW: "korea - south",
  KWD: "kuwait",
  KYD: "cayman islands",
  KZT: "kazakhstan",
  LAK: "laos",
  LBP: "lebanon",
  LKR: "sri lanka",
  LRD: "liberia",
  LSL: "lesotho",
  LYD: "libya",
  MAD: "morocco",
  MDL: "moldova",
  MGA: "madagascar",
  MKD: "macedonia",
  MMK: "myanmar",
  MNT: "mongolia",
  MOP: "macao",
  MRU: "mauritania",
  MVR: "maldives",
  MWK: "malawi",
  MXN: "mexico",
  MXV: "mexico",
  MYR: "malaysia",
  MZN: "mozambique",
  NAD: "namibia",
  NGN: "nigeria",
  NIO: "nicaragua",
  NOK: "norway",
  NPR: "nepal",
  NZD: "new zealand",
  OMR: "oman",
  PAB: "panama",
  PEN: "peru",
  PGK: "papua new guinea",
  PHP: "philippines",
  PKR: "pakistan",
  PLN: "poland",
  PYG: "paraguay",
  QAR: "qatar",
  RON: "romania",
  RSD: "serbia",
  RUB: "russia",
  RWF: "rwanda",
  SAR: "saudi arabia",
  SBD: "solomon islands",
  SCR: "seychelles",
  SDG: "sudan",
  SEK: "sweden",
  SGD: "singapore",
  SHP: "st. helena",
  SLL: "sierra leone",
  SOS: "somalia",
  SRD: "suriname",
  STN: "sao tome & principe",
  SVC: "el salvador",
  SYP: "syria",
  SZL: "swaziland",
  THB: "thailand",
  TJS: "tajikistan",
  TMT: "turkmenistan",
  TND: "tunisia",
  TOP: "tonga",
  TRY: "turkey",
  TTD: "trinidad & tobago",
  TWD: "taiwan",
  UAH: "ukraine",
  UGX: "uganda",
  USD: "united states",
  USN: "united states",
  UYI: "uruguay",
  UYU: "uruguay",
  UYW: "uruguay",
  UZS: "uzbekistan",
  VES: "venezuela",
  VND: "vietnam",
  VUV: "vanuatu",
  XAF: "cameroon",
  XCD: "anguilla",
  XOF: "benin",
  XPF: "french polynesia",
  XSU: "venezuela",
  YER: "yemen - north",
  ZAR: "lesotho",
  ZMW: "zambia",
  ZWL: "zimbabwe"
};
function Hi({ code: r, ...t }) {
  return /* @__PURE__ */ e.createElement(P, { alignItems: "center", ...t, testId: "currency-option" }, /* @__PURE__ */ e.createElement(V, { type: Ai[r], factor: 1, noHoverEffects: !0 }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, r));
}
const xi = (r, t) => Y(() => {
  const n = C2.map((a) => a.code);
  return t.length && n.sort(bi(t)), n.map((a) => ({
    id: a,
    val: a,
    render: r ? /* @__PURE__ */ e.createElement(Hi, { code: a }) : a
  }));
}, [r, t]);
function dn({
  label: r,
  width: t,
  onChange: n,
  value: a,
  testId: l,
  name: o,
  withFlags: s,
  primaryCodes: d,
  ...c
}) {
  const [m, h] = z(h0(a)), p = xi(s, d), u = Y(
    () => p.find((E) => E.val === m),
    [p, m]
  );
  ee(() => {
    h(h0(a));
  }, [a]);
  const C = ({ val: E }) => {
    h(E);
    const g = C2.find(({ code: L }) => L === E);
    n(g);
  };
  return /* @__PURE__ */ e.createElement(
    dt,
    {
      testId: l,
      label: r,
      width: t,
      onChange: C,
      value: u,
      options: p,
      showSearch: !0,
      name: o,
      ...c
    }
  );
}
dn.propTypes = {
  label: i.string,
  width: i.number,
  value: i.string,
  onChange: i.func,
  testId: i.string,
  name: i.string,
  kind: i.string,
  disabled: i.bool,
  hasChangedType: i.string,
  withFlags: i.bool,
  primaryCodes: i.arrayOf(i.string)
};
dn.defaultProps = {
  width: 100,
  value: "",
  onChange: () => {
  },
  testId: "currency-select",
  name: "",
  disabled: !1,
  kind: "select",
  withFlags: !1,
  primaryCodes: []
};
const Mi = [
  { display: "M", label: "Monday", value: "monday" },
  { display: "Tu", label: "Tuesday", value: "tuesday" },
  { display: "W", label: "Wednesday", value: "wednesday" },
  { display: "Th", label: "Thursday", value: "thursday" },
  { display: "F", label: "Friday", value: "friday" },
  { display: "Sa", label: "Saturday", value: "saturday" },
  { display: "Su", label: "Sunday", value: "sunday" }
], Vi = "_dayControl_rmiou_1", Di = "_active_rmiou_29", Fi = "_error_rmiou_36", ki = "_disabled_rmiou_47", Zi = "_noOnClick_rmiou_47", _e = {
  dayControl: Vi,
  active: Di,
  error: Fi,
  disabled: ki,
  noOnClick: Zi
};
function Bi({ active: r, disabled: t, display: n, error: a, readOnly: l, testId: o, type: s }) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M(_e.dayControl, _e[s], {
        [_e.active]: !!r,
        [_e.disabled]: t,
        [_e.noOnClick]: !t || l,
        [_e.error]: a
      }),
      "data-testid": `${o}-${r}`
    },
    /* @__PURE__ */ e.createElement("span", { "aria-hidden": "true" }, n)
  );
}
function g2({ display: r, ...t }) {
  const n = (a) => /* @__PURE__ */ e.createElement(Bi, { display: r, ...a });
  return /* @__PURE__ */ e.createElement(A1, { mask: n, ...t, textSpacingFactor: 0, hideLabel: !0 });
}
g2.propTypes = {
  ...$1,
  active: i.bool,
  display: i.string
};
g2.defaultProps = {
  ..._1,
  display: "",
  inputType: "checkbox",
  kind: "dayControl",
  testId: W.dayControl
};
const Oi = "_root_f4os9_1", Si = "_dayPicker_f4os9_8", p0 = {
  root: Oi,
  dayPicker: Si
};
function cn({
  disabled: r,
  error: t,
  hasChangedType: n,
  id: a,
  label: l,
  labelOptional: o,
  labelSize: s,
  labelTooltip: d,
  name: c,
  onChange: m,
  preventErrorPushdown: h,
  selected: p,
  subLabel: u,
  testId: C
}) {
  return /* @__PURE__ */ e.createElement("fieldset", { role: "group", className: p0.root, "data-testid": C }, /* @__PURE__ */ e.createElement(
    ue,
    {
      as: "legend",
      hasChangedType: n,
      id: a,
      optional: o,
      size: s,
      subLabel: u,
      tooltip: d
    },
    l
  ), /* @__PURE__ */ e.createElement("div", { className: p0.dayPicker }, Mi.map(({ display: E, label: g, value: L }) => /* @__PURE__ */ e.createElement(
    g2,
    {
      key: L,
      display: E,
      active: p == null ? void 0 : p.includes(L),
      disabled: r,
      error: t,
      label: g,
      name: `${c ? `${c}-` : ""}${L}`,
      onClick: () => m(L),
      suppressErrorMessage: !0
    }
  ))), /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), t && /* @__PURE__ */ e.createElement(ae, { preventErrorPushdown: h }, t));
}
cn.propTypes = {
  disabled: i.bool,
  error: i.string,
  hasChangedType: i.oneOf(["completed", "changed", void 0]),
  id: i.string,
  label: i.string,
  labelOptional: i.bool,
  labelSize: i.oneOf(["small", "large"]),
  labelTooltip: i.any,
  name: i.string,
  onChange: i.func,
  preventErrorPushdown: i.bool,
  selected: i.arrayOf(i.string),
  subLabel: i.string,
  testId: i.string
};
cn.defaultProps = {
  disabled: !1,
  error: "",
  kind: "dayPicker",
  label: "",
  labelOptional: !1,
  labelSize: "small",
  labelTooltip: null,
  name: "day-picker",
  preventErrorPushdown: !1,
  subLabel: "",
  testId: "volt-day-picker"
};
const Ii = "_indicator_qewmm_1", Pi = {
  indicator: Ii
}, f2 = zt(({ color: r, size: t, ringColor: n, ringWidth: a }, l) => {
  const o = v[r] ?? r, s = v[n] ?? n;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: l,
      className: Pi.indicator,
      style: {
        backgroundColor: o,
        width: t,
        height: t,
        borderColor: s,
        borderWidth: a
      }
    }
  );
});
f2.propTypes = {
  color: i.string.isRequired,
  ringColor: i.string.isRequired,
  size: i.string,
  ringWidth: i.string
};
f2.defaultProps = {
  color: v.secondaryColor,
  ringColor: v.white,
  size: "8px",
  ringWidth: "2px"
};
f2.displayName = "DotIndicator";
function E2(r, t, n) {
  return n || `${t ? `${t}-` : ""}${Ni(r)}`;
}
function Ni(r = "", t) {
  const n = {
    fromSnake: !1,
    fromWord: !0,
    ...t
  };
  let a;
  return n.fromSnake ? a = r.split("_") : a = r.split(" "), a.reduce((l, o, s) => `${l}${s === 0 ? o : Ri(o)}`);
}
function Ri(r = "") {
  return `${r.substr(0, 1).toUpperCase()}${r.substr(1).toLowerCase()}`;
}
const Ti = "_detailPane_e0l4c_1", Ui = "_contentWrapper_e0l4c_9", Gi = "_section_e0l4c_13", zi = "_tooltip_e0l4c_18", mn = {
  detailPane: Ti,
  contentWrapper: Ui,
  section: Gi,
  tooltip: zi
};
function Ot({ header: r, children: t, layout: n, width: a }) {
  const l = E2(r), o = un({ children: t, layout: n, id: l, width: a });
  return /* @__PURE__ */ e.createElement("section", { "aria-labelledby": l }, r && /* @__PURE__ */ e.createElement(y, { id: l, type: "h4" }, r), o);
}
Ot.defaultProps = {
  layout: "row",
  width: "half"
};
function hn({ header: r, children: t, idPrefix: n, flexDirection: a, width: l }) {
  const o = E2(r, n), s = e.Children.map(t, (d) => {
    if (d && d.props && d.props.kind === "content")
      return e.cloneElement(
        d,
        {
          ...d.props,
          idPrefix: n,
          flexDirection: a
        },
        d.props.children
      );
  });
  return /* @__PURE__ */ e.createElement("div", { className: mn.section }, /* @__PURE__ */ e.createElement("section", { "aria-labelledby": o }, r && /* @__PURE__ */ e.createElement(y, { id: o, type: "h5" }, r), s));
}
hn.defaultProps = {
  kind: "section"
};
function pn(r) {
  return /* @__PURE__ */ e.createElement(T2, { className: mn.contentWrapper, ...r });
}
pn.defaultProps = {
  kind: "content"
};
function un({ children: r, layout: t, id: n }) {
  return e.Children.map(r, (a) => {
    const l = a && a.props && a.props.children && un({ children: a.props.children, id: n, layout: t });
    if (a && a.props && a.props.kind) {
      const {
        props: { kind: o }
      } = a;
      if (o === "section" || o === "content")
        return e.cloneElement(
          a,
          {
            ...a.props,
            idPrefix: n,
            flexDirection: t
          },
          l
        );
    }
    return l ? e.cloneElement(a, a.props, l) : a;
  });
}
const Eh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Container: Ot,
  Content: pn,
  Section: hn,
  default: Ot
}, Symbol.toStringTag, { value: "Module" })), Wi = "_drawer_1o55u_1", ji = "_drawer__fixedWidth_1o55u_18", Xi = "_drawer__right_1o55u_22", Yi = "_drawer__left_1o55u_27", Qi = "_drawer__right__opened_1o55u_32", Ki = "_drawer__left__opened_1o55u_38", Ji = "_content_1o55u_44", qi = "_backdrop_1o55u_50", $i = "_headerContainer_1o55u_69", _i = "_headerNode_1o55u_73", el = "_footerContainer_1o55u_77", tl = "_closeButton_1o55u_82", oe = {
  drawer: Wi,
  drawer__fixedWidth: ji,
  drawer__right: Xi,
  drawer__left: Yi,
  drawer__right__opened: Qi,
  drawer__left__opened: Ki,
  content: Ji,
  backdrop: qi,
  "background--transparent": "_background--transparent_1o55u_61",
  "backdrop--visible": "_backdrop--visible_1o55u_65",
  headerContainer: $i,
  headerNode: _i,
  footerContainer: el,
  closeButton: tl
};
class Cn extends N {
  constructor(t) {
    super(t), this.previouslyFocused = null, this.drawerRef = e.createRef(), this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidUpdate(t, n, a) {
    this.props.isOpened !== t.isOpened && this.returnToPreviouslyFocused();
  }
  returnToPreviouslyFocused() {
    var t;
    if (this.props.isOpened) {
      this.previouslyFocused = document.activeElement;
      const n = this.drawerRef.current.querySelector($t);
      n == null || n.focus();
    } else
      (t = this.previouslyFocused) == null || t.focus(), this.previouslyFocused = null;
  }
  handleClickOutside() {
    const { isOpened: t, closeDrawer: n, keepOpen: a } = this.props;
    t && !a && n();
  }
  getDrawerClassnames() {
    const { isOpened: t, orientation: n, dynamicWidth: a } = this.props;
    let l = `${oe.drawer}`;
    return a || (l = `${l} ${oe.drawer__fixedWidth}`), n === "right" && (l = `${l} ${oe.drawer__right} ${t && oe.drawer__right__opened}`), n === "left" && (l = `${l} ${oe.drawer__left} ${t && oe.drawer__left__opened}`), l;
  }
  getDrawerBackdropClassnames() {
    const { isOpened: t, backdrop: n } = this.props;
    return M(oe.backdrop, {
      [oe["background--transparent"]]: !n,
      [oe["backdrop--visible"]]: t
    });
  }
  checkHeaderType() {
    const { header: t } = this.props, n = typeof t == "string", a = t && e.isValidElement(t);
    return {
      headerIsValidType: n || a,
      headerType: n ? "string" : a ? "node" : void 0
    };
  }
  renderHeader() {
    const { header: t, closeDrawer: n, showCloseButton: a } = this.props, { headerIsValidType: l, headerType: o } = this.checkHeaderType();
    if (!t || !l)
      return;
    const s = a && /* @__PURE__ */ e.createElement("button", { "aria-label": "Close", className: oe.closeButton, onClick: n }, /* @__PURE__ */ e.createElement(V, { type: "close", factor: 1 })), d = {
      string: /* @__PURE__ */ e.createElement(y, { type: "h4" }, t),
      node: /* @__PURE__ */ e.createElement("div", { className: oe.headerNode }, t)
    }[o] || null;
    return /* @__PURE__ */ e.createElement("div", { className: oe.headerContainer }, /* @__PURE__ */ e.createElement(P, { justifyContent: "space-between", style: { alignItems: "baseline" } }, d, s));
  }
  renderFooter() {
    const { footer: t } = this.props;
    if (t) {
      if (Array.isArray(t))
        if (t.length > 2)
          console.warn("There should be two or less footer buttons.");
        else {
          const n = t.length === 1 ? "center" : "space-between";
          return /* @__PURE__ */ e.createElement("div", { className: oe.footerContainer }, /* @__PURE__ */ e.createElement(P, { justifyContent: n }, t.map((a) => {
            const { text: l, ...o } = a;
            return /* @__PURE__ */ e.createElement(J, { ...o }, l);
          })));
        }
      if (e.isValidElement(t))
        return /* @__PURE__ */ e.createElement("div", null, " ", t);
    }
  }
  render() {
    const { children: t, testId: n, minWidth: a } = this.props;
    return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: this.getDrawerBackdropClassnames(), onClick: this.handleClickOutside }), /* @__PURE__ */ e.createElement(
      Y1,
      {
        className: this.getDrawerClassnames(),
        ref: this.drawerRef,
        "data-testid": n,
        style: { minWidth: a || 0 }
      },
      this.renderHeader(),
      t && /* @__PURE__ */ e.createElement("div", { className: oe.content }, t),
      this.renderFooter()
    ));
  }
}
Cn.propTypes = {
  backdrop: i.bool,
  keepOpen: i.bool,
  children: i.any,
  closeDrawer: i.func,
  dynamicWidth: i.bool,
  footer: i.oneOfType([i.arrayOf(i.object), i.node]),
  header: i.oneOfType([i.string, i.node]),
  isOpened: i.bool,
  minWidth: i.number,
  orientation: i.string,
  showCloseButton: i.bool,
  testId: i.string
};
Cn.defaultProps = {
  backdrop: !1,
  keepOpen: !1,
  children: null,
  closeDrawer: () => {
  },
  dynamicWidth: !1,
  footer: null,
  header: null,
  isOpened: !1,
  minWidth: 0,
  orientation: "right",
  showCloseButton: !1,
  testId: "volt-drawer"
};
const nl = "_wrap_1env6_1", al = "_container_1env6_9", rl = "_link_1env6_15", il = "_active_1env6_22", F1 = {
  wrap: nl,
  container: al,
  link: rl,
  active: il
}, L2 = ({ links: r, minWidth: t, numOptions: n, testId: a }) => (n = n || 5, /* @__PURE__ */ e.createElement("div", { className: F1.wrap, style: { minWidth: t || 0 }, "data-testid": a }, /* @__PURE__ */ e.createElement(
  "div",
  {
    className: F1.container,
    style: {
      height: n >= r.length ? "fit-content" : n * 36 + 28
    }
  },
  r.map((l, o) => /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${F1.link} ${l.active ? F1.active : ""}`,
      key: o,
      onClick: l.onClick
    },
    typeof l.content == "string" ? /* @__PURE__ */ e.createElement(y, null, l.content) : l.content
  ))
)));
L2.propTypes = {
  links: i.array,
  testId: i.string
};
L2.defaultProps = {
  links: [],
  testId: "volt-dropdown"
};
const Lh = e.memo(L2), ll = "_container_1tpq6_1", ol = {
  container: ll
};
class w2 extends N {
  render() {
    const { testId: t, text: n, subText: a, postContent: l, iconType: o, type: s } = this.props;
    return s === "large" ? /* @__PURE__ */ e.createElement("div", { "data-testid": t, className: ol.container }, /* @__PURE__ */ e.createElement(V, { type: o, noHoverEffects: !0, overrideColor: v.blackLighter8 }), /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement(y, { color: v.blackLighter3, type: "h5" }, n), a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { color: v.blackLighter3, type: "body" }, a)), l && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 2 }), l)) : /* @__PURE__ */ e.createElement("div", { "data-testid": t }, n, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), a && /* @__PURE__ */ e.createElement("div", null, a), l && /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(F, { factor: 1 }), l));
  }
}
w2.propTypes = {
  iconType: i.string,
  type: i.string.isRequired,
  text: i.string.isRequired,
  subText: i.string,
  postContent: i.object,
  testId: i.string
};
w2.defaultProps = {
  iconType: "empty-state-folder",
  testId: "volt-EmptyState"
};
const sl = "_iconWrap_1f1z6_1", dl = "_textCenter_1f1z6_11", cl = "_flexHorizontalCenter_1f1z6_15", S1 = {
  iconWrap: sl,
  textCenter: dl,
  flexHorizontalCenter: cl
};
function gn({ children: r, heading: t, hideModal: n, buttonText: a, testId: l }) {
  return t || console.warn("ErrorModal component: header attribute is required."), /* @__PURE__ */ e.createElement("div", { "data-testid": l }, /* @__PURE__ */ e.createElement(ot, { showHideModalButton: !1, type: "sm" }, /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { "data-testid": `${l}_icon`, className: S1.iconWrap }, /* @__PURE__ */ e.createElement(V, { type: "danger", noHoverEffects: !0, mod: "error" })), /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement(y, { type: "h5", className: S1.textCenter, testId: `error-modal-heading_${t}` }, t || "Error"), /* @__PURE__ */ e.createElement(ml, { testId: l }, r), /* @__PURE__ */ e.createElement(F, { factor: 3 }), /* @__PURE__ */ e.createElement("div", { className: S1.flexHorizontalCenter }, /* @__PURE__ */ e.createElement(J, { onClick: n, testId: `error-modal-button_${a}` }, a)))));
}
function ml({ children: r, testId: t }) {
  if (!r)
    return null;
  const n = typeof r == "string" ? /* @__PURE__ */ e.createElement(y, { testid: `${t}_content` }, r) : r;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement("div", { className: S1.textCenter, "data-testid": `${t}_content-wrapper` }, n));
}
gn.propTypes = {
  heading: i.string.isRequired,
  hideModal: i.func,
  buttonText: i.string,
  testId: i.string
};
gn.defaultProps = {
  heading: "Error",
  hideModal: () => {
  },
  buttonText: "Dismiss",
  testId: "error-modal"
};
const hl = "_headerWrap_1t617_1", pl = "_footerWrap_1t617_5", ul = "_nameContainer_1t617_12", Cl = "_nameWrap_1t617_17", gl = "_previewContainer_1t617_22", fl = "_errorWrap_1t617_27", d1 = {
  headerWrap: hl,
  footerWrap: pl,
  nameContainer: ul,
  nameWrap: Cl,
  previewContainer: gl,
  errorWrap: fl
};
function fn({ children: r, error: t, testId: n, classes: a, className: l }) {
  return r && r.length > 2 ? (console.warn("FilePreview can only accept 2 children"), null) : /* @__PURE__ */ e.createElement("div", { "data-testid": n, className: M(l, a.root) }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M(d1.previewContainer, a.container, { [d1.errorWrap]: t })
    },
    r
  ), t && /* @__PURE__ */ e.createElement("div", { "data-testid": `${n}-error`, className: a.errorContainer }, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "small", mod: "error semi-bold" }, t)));
}
fn.propTypes = {
  error: i.string,
  children: i.array,
  className: i.string,
  classes: i.shape({
    root: i.string,
    container: i.string,
    errorContainer: i.string
  })
};
fn.defaultProps = {
  error: "",
  classes: {},
  children: [],
  testId: "FilePreview"
};
class v2 extends e.PureComponent {
  constructor(t) {
    super(t), this.state = {
      active: !1
    }, this.closeDropdown = this.closeDropdown.bind(this), this.toggleDropdown = this.toggleDropdown.bind(this);
  }
  closeDropdown() {
    this.setState({ active: !1 });
  }
  toggleDropdown() {
    this.setState((t) => ({ active: !t.active }));
  }
  render() {
    const { active: t } = this.state;
    return /* @__PURE__ */ e.createElement(
      K1,
      {
        ...this.props,
        active: t,
        closeDropdown: this.closeDropdown,
        toggleDropdown: this.toggleDropdown
      }
    );
  }
}
v2.propTypes = {
  control: i.any,
  contentPadding: i.number,
  disabled: i.bool,
  anchor: i.string,
  tooltipText: i.any,
  tooltipWidth: i.oneOfType([i.string, i.number]),
  tooltipDirection: i.string,
  fixOverflow: i.bool,
  preventCloseClassList: i.array,
  portalZIndex: i.number,
  testId: i.string,
  contentContainerStyle: i.object
};
v2.defaultProps = {
  control: "",
  contentPadding: 16,
  disabled: !1,
  anchor: "left",
  tooltipText: null,
  tooltipDirection: "bottom",
  tooltipWidth: null,
  fixOverflow: !1,
  preventCloseClassList: [],
  portalZIndex: void 0,
  testId: "volt-raw-dropdown",
  contentContainerStyle: {}
};
function En({ children: r }) {
  return /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(
    v2,
    {
      contentPadding: 0,
      anchor: "right",
      control: /* @__PURE__ */ e.createElement(V, { type: "view-more-vertical", factor: 0.5 })
    },
    r
  ));
}
En.propTypes = {
  children: i.any
};
En.defaultProps = {
  children: null
};
function Ln({ children: r }) {
  return /* @__PURE__ */ e.createElement("div", { className: d1.footerWrap }, r);
}
Ln.propTypes = {
  children: i.any
};
Ln.defaultProps = {
  children: null
};
function wn({ children: r }) {
  return /* @__PURE__ */ e.createElement("div", { className: d1.headerWrap }, r);
}
wn.propTypes = {
  children: i.any
};
wn.defaultProps = {
  children: null
};
function vn({ name: r, children: t, icon: n }) {
  const a = e.useMemo(() => /* @__PURE__ */ e.createElement(V, { type: "file", factor: 0.5 }), []);
  return /* @__PURE__ */ e.createElement("div", { className: d1.nameContainer }, /* @__PURE__ */ e.createElement("div", { className: d1.nameWrap }, n || a, n && /* @__PURE__ */ e.createElement(B, null), typeof r == "string" || typeof r == "number" ? /* @__PURE__ */ e.createElement(y, null, r) : r), t);
}
vn.propTypes = {
  name: i.node,
  icon: i.node
};
vn.defaultProps = {
  name: "",
  icon: void 0
};
class yn extends e.Component {
  constructor(t) {
    super(t), this.fileInputRef = e.createRef(), this.handleFilesInputChange = this.handleFilesInputChange.bind(this), this.openFilePicker = this.openFilePicker.bind(this), this.resetFile = this.resetFile.bind(this), this.state = {
      file: null
    };
  }
  handleFilesInputChange() {
    const { handleFiles: t } = this.props, n = typeof t;
    if (n === "function") {
      const l = this.fileInputRef.current.files[0];
      t(l), this.setState({ file: l });
    } else
      console.warn(
        `handleFiles needs to be of type function but was passed type: ${n}`
      );
  }
  resetFile() {
    this.setState({ file: null }), this.fileInputRef.current.value = null;
  }
  validFileType(t) {
    const { acceptedFileTypes: n } = this.props, a = t.type, [l] = t.name.match(/\.([A-z0-9]+)$/);
    return n.includes(a) || n.includes(l);
  }
  openFilePicker() {
    const { disabled: t } = this.props;
    !t && this.fileInputRef.current.click();
  }
  render() {
    const {
      children: t,
      id: n,
      acceptedFileTypes: a,
      placeholder: l,
      label: o,
      subLabel: s,
      labelOptional: d,
      labelSize: c,
      labelTooltip: m,
      width: h
    } = this.props, { file: p } = this.state, u = p && p.name || l;
    return /* @__PURE__ */ e.createElement("div", { onClick: this.openFilePicker, "data-testid": "fileInputWrap" }, t || /* @__PURE__ */ e.createElement(
      me,
      {
        rightAddOn: {
          content: "Browse",
          onClick: () => {
          }
          // This property is needed to apply .clickable class
        },
        error: p && !this.validFileType(p) ? "File type is not supported" : null,
        onChange: () => {
        },
        label: o,
        sublabel: s,
        labelOptional: d,
        labelSize: c,
        labelTooltip: m,
        value: u,
        width: h,
        readOnly: !0,
        "data-testid": "fileInputDisplay"
      }
    ), /* @__PURE__ */ e.createElement(
      "input",
      {
        "data-testid": "fileInput",
        id: n,
        ref: this.fileInputRef,
        hidden: !0,
        accept: a,
        type: "file",
        onChange: this.handleFilesInputChange
      }
    ));
  }
}
yn.propTypes = {
  handleFiles: i.func,
  children: i.any,
  acceptedFileTypes: i.string,
  id: i.string,
  disabled: i.bool,
  label: i.string,
  subLabel: i.any,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  labelTooltip: i.any,
  placeholder: i.string,
  displayValue: i.string,
  width: i.any
};
yn.defaultProps = {
  handleFiles: () => {
  },
  children: null,
  acceptedFileTypes: "image/png, image/jpeg, .csv",
  disabled: !1,
  id: "fileInput",
  label: null,
  subLabel: null,
  labelSize: "small",
  labelOptional: !1,
  labelTooltip: null,
  placeholder: "Select a file",
  displayValue: "",
  width: null
};
const El = "_editCard_1g2vf_1", Ll = "_viewCard_1g2vf_10", wl = "_link_1g2vf_18", gt = {
  editCard: El,
  viewCard: Ll,
  link: wl
}, bn = (r) => {
  const {
    cardType: t,
    editTemplate: n,
    data: a,
    viewTemplate: l,
    onAddCard: o,
    onUpdateCard: s,
    onCancelCard: d,
    onDeleteCard: c,
    overrideIsFlat: m,
    canEdit: h,
    onEdit: p
  } = r, u = n, C = l, E = {}, [g, L] = z(a || E), [x, A] = z(!1), [Z, D] = z(!1), f = (O) => {
    L({ ...g, ...O });
  }, w = () => {
    try {
      o(g), A(!0);
    } catch {
    }
  }, H = () => {
    try {
      s(g), A(!0);
    } catch {
    }
  }, b = () => {
    try {
      L(a), a && A(!0), !a && d();
    } catch {
    }
  }, k = () => {
    try {
      D(!1), L(null), c();
    } catch {
    }
  };
  return x || m || !h ? /* @__PURE__ */ e.createElement("div", { className: `${gt.viewCard}` }, /* @__PURE__ */ e.createElement(
    C,
    {
      formState: a,
      editButton: h ? /* @__PURE__ */ e.createElement(
        y,
        {
          type: "footnote",
          className: `${gt.link}`,
          onClick: () => {
            A(!1), typeof p == "function" && p();
          }
        },
        "Edit"
      ) : null
    }
  )) : /* @__PURE__ */ e.createElement("div", { className: `${gt.editCard}` }, /* @__PURE__ */ e.createElement(u, { formState: g, handleFormChange: f }, /* @__PURE__ */ e.createElement(F, { factor: 3 }), !Z && /* @__PURE__ */ e.createElement(P, { justifyContent: "space-between" }, !a && /* @__PURE__ */ e.createElement(J, { submit: !0, onClick: w }, `Add ${t}`), a && /* @__PURE__ */ e.createElement(P, { justifyContent: "flex-start" }, /* @__PURE__ */ e.createElement(J, { submit: !0, onClick: H }, `Update ${t}`), /* @__PURE__ */ e.createElement(B, { factor: 1 }), /* @__PURE__ */ e.createElement(J, { type: "tertiary", onClick: () => D(!0) }, "Delete")), /* @__PURE__ */ e.createElement(Ne, { onClick: b }, /* @__PURE__ */ e.createElement(y, { type: "h6", color: v.blackLighter3 }, "Cancel"))), a && Z && /* @__PURE__ */ e.createElement(P, { justifyContent: "space-between", alignItems: "center" }, /* @__PURE__ */ e.createElement(y, { type: "body-lg", color: v.blackLighter3 }, "Delete ", t, "?"), /* @__PURE__ */ e.createElement(P, { justifyContent: "flex-end" }, /* @__PURE__ */ e.createElement(J, { type: "tertiary", onClick: () => D(!1) }, "Cancel"), /* @__PURE__ */ e.createElement(B, { factor: 1 }), /* @__PURE__ */ e.createElement(J, { type: "danger", onClick: k }, "Delete ", t)))));
};
bn.propTypes = {
  cardType: i.string,
  editTemplate: i.func.isRequired,
  viewTemplate: i.func.isRequired,
  data: i.object.isRequired,
  onAddCard: i.func.isRequired,
  onUpdateCard: i.func.isRequired,
  onCancelCard: i.func.isRequired,
  onDeleteCard: i.func.isRequired,
  overrideIsFlat: i.bool,
  canEdit: i.bool,
  onEdit: i.func
};
const u0 = ({ children: r }) => /* @__PURE__ */ e.createElement("section", null, /* @__PURE__ */ e.createElement(st, { type: "sm", testId: "on-page-error-screen" }, "Oops! Something went wrong."), r);
bn.defaultProps = {
  cardType: "card",
  editTemplate: u0,
  viewTemplate: u0,
  overrideIsFlat: !1,
  canEdit: !0
};
const vl = "_flex_1d1ea_1", I1 = {
  flex: vl,
  "inline-flex": "_inline-flex_1d1ea_5",
  "flex-direction-row": "_flex-direction-row_1d1ea_12",
  "flex-direction-column": "_flex-direction-column_1d1ea_16",
  "justify-content-center": "_justify-content-center_1d1ea_23",
  "justify-content-flex-start": "_justify-content-flex-start_1d1ea_27",
  "justify-content-flex-end": "_justify-content-flex-end_1d1ea_31",
  "justify-content-space-between": "_justify-content-space-between_1d1ea_35",
  "justify-content-space-evenly": "_justify-content-space-evenly_1d1ea_39",
  "justify-content-space-around": "_justify-content-space-around_1d1ea_43",
  "justify-self-center": "_justify-self-center_1d1ea_50",
  "justify-self-flex-start": "_justify-self-flex-start_1d1ea_54",
  "justify-self-flex-end": "_justify-self-flex-end_1d1ea_58",
  "justify-self-self-start": "_justify-self-self-start_1d1ea_62",
  "justify-self-self-end": "_justify-self-self-end_1d1ea_66",
  "justify-self-end": "_justify-self-end_1d1ea_70",
  "justify-self-start": "_justify-self-start_1d1ea_74",
  "align-items-center": "_align-items-center_1d1ea_81",
  "align-items-flex-start": "_align-items-flex-start_1d1ea_85",
  "align-items-flex-end": "_align-items-flex-end_1d1ea_89",
  "align-items-start": "_align-items-start_1d1ea_93",
  "align-items-end": "_align-items-end_1d1ea_97",
  "align-self-center": "_align-self-center_1d1ea_104",
  "align-self-flex-start": "_align-self-flex-start_1d1ea_108",
  "align-self-flex-end": "_align-self-flex-end_1d1ea_112",
  "align-self-self-start": "_align-self-self-start_1d1ea_116",
  "align-self-self-end": "_align-self-self-end_1d1ea_120",
  "align-self-end": "_align-self-end_1d1ea_124",
  "align-self-start": "_align-self-start_1d1ea_128",
  "flex-wrap-nowrap": "_flex-wrap-nowrap_1d1ea_135",
  "flex-wrap-wrap": "_flex-wrap-wrap_1d1ea_139",
  "flex-wrap-wrap-reverse": "_flex-wrap-wrap-reverse_1d1ea_143",
  "flex-grow-1": "_flex-grow-1_1d1ea_150"
}, yl = {
  alignItems: "align-items",
  alignSelf: "align-self",
  flexDirection: "flex-direction",
  flexGrow: "flex-grow",
  flexWrap: "flex-wrap",
  justifyContent: "justify-content",
  justifySelf: "justify-self"
}, bl = (r) => [
  "alignItems",
  "alignSelf",
  "flexDirection",
  "flexGrow",
  "flexWrap",
  "justifyContent",
  "justifySelf"
].reduce((t, n) => {
  const a = r[n];
  if (a) {
    const l = `${yl[n]}-${a}`;
    return `${t} ${I1[l]}`;
  }
  return t;
}, ""), y2 = ({
  alignItems: r,
  alignSelf: t,
  children: n,
  display: a,
  flex: l,
  flexDirection: o,
  flexGrow: s,
  flexWrap: d,
  justifyContent: c,
  justifySelf: m,
  type: h,
  testId: p,
  ...u
}) => {
  const C = Y(() => bl({
    alignItems: r,
    alignSelf: t,
    flexDirection: o,
    flexGrow: s,
    flexWrap: d,
    justifyContent: c,
    justifySelf: m
  }), [c, m, o, r, d, t]), E = Y(() => a ? I1[a] ? I1[a] : (console.warn(
    `Flex "display" property must be either "flex" or "inline-flex" but it was passed: ${a}`
  ), "") : r || c || d || o ? I1.flex : "", [a]);
  return e.createElement(
    h,
    {
      ...u,
      "data-testid": p,
      className: `${E}${C ? ` ${C}` : ""}${u.className ? ` ${u.className}` : ""}`,
      style: { flex: l, ...u.style }
    },
    n
  );
};
y2.propTypes = {
  alignItems: i.string,
  alignSelf: i.string,
  display: i.string,
  flex: i.string,
  flexDirection: i.string,
  flexWrap: i.string,
  justifyContent: i.string,
  justifySelf: i.string,
  testId: i.string,
  type: i.string
};
y2.defaultProps = {
  type: "div"
};
const P = y2, ce = "CLEAR_ERROR", ke = "ERROR_FORM", Al = "INITIALIZE_STATE", An = "SHOW_ERROR", Hn = "SUBMIT", _ = "UPDATE_FORM", xn = "UPDATE_ERROR_VALIDATORS", Mn = "UPDATE_REQUIRED_FIELDS", Re = "This field is required.", Vn = "button", b2 = "input", A2 = "multiselect", Dn = "radio", H2 = "select", Fn = "textarea", kn = "toggle", et = "checkboxGroup", x2 = "dayPicker", M2 = "radioGroup", V2 = "phoneInput", tt = "checkbox", Hl = "segmentedButtons", nt = "actionCardGroup", Zn = "grouper", D2 = "maskedInput", xl = [
  Vn,
  et,
  x2,
  M2,
  b2,
  A2,
  V2,
  Dn,
  H2,
  Fn,
  kn,
  tt,
  Hl,
  nt,
  Zn,
  D2
], ft = {
  [et]: [],
  [x2]: [],
  [M2]: [],
  [b2]: "",
  [A2]: [],
  [V2]: "",
  [H2]: null,
  [Fn]: "",
  [nt]: [],
  [D2]: ""
}, Bn = jt({}), On = jt(), F2 = () => Xt(On), Sn = () => Xt(Bn), Ml = "_inputWrap_hxc3u_36", Vl = "_input_hxc3u_36", Dl = "_wrap_hxc3u_50", Fl = "_disabledWrap_hxc3u_50", kl = "_errorWrap_hxc3u_51", Zl = "_rightButton_hxc3u_52", Bl = "_clickable_hxc3u_52", Ol = "_focused_hxc3u_54", Sl = "_rightAddOnWrap_hxc3u_55", Il = "_disabled_hxc3u_50", Pl = "_activeLeftIcon_hxc3u_71", Nl = "_activeRightIcon_hxc3u_75", Rl = "_renderSelected_hxc3u_120", Tl = "_optionContainer_hxc3u_125", Ul = "_leftIcon_hxc3u_143", Gl = "_rightIcon_hxc3u_145", zl = "_rightButto_hxc3u_52", Wl = "_flexCenter_hxc3u_186", jl = "_codeTextOption_hxc3u_191", Be = {
  inputWrap: Ml,
  input: Vl,
  wrap: Dl,
  disabledWrap: Fl,
  errorWrap: kl,
  rightButton: Zl,
  clickable: Bl,
  focused: Ol,
  rightAddOnWrap: Sl,
  disabled: Il,
  activeLeftIcon: Pl,
  activeRightIcon: Nl,
  renderSelected: Rl,
  optionContainer: Tl,
  leftIcon: Ul,
  rightIcon: Gl,
  rightButto: zl,
  flexCenter: Wl,
  codeTextOption: jl
}, U1 = [
  {
    name: "United States",
    dial_code: "+1",
    code: "US"
  },
  {
    name: "UK",
    dial_code: "+44",
    code: "GB"
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ"
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD"
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO"
  },
  {
    name: "Anguilla",
    dial_code: "+1",
    code: "AI"
  },
  {
    name: "Antigua & Barbuda",
    dial_code: "+1",
    code: "AG"
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR"
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM"
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW"
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU"
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ"
  },
  {
    name: "Bahamas",
    dial_code: "+1",
    code: "BS"
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH"
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD"
  },
  {
    name: "Barbados",
    dial_code: "+1",
    code: "BB"
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY"
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE"
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ"
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ"
  },
  {
    name: "Bermuda",
    dial_code: "+1",
    code: "BM"
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT"
  },
  {
    name: "Bolivia",
    dial_code: "+591",
    code: "BO"
  },
  {
    name: "Bosnia Herzegovina",
    dial_code: "+387",
    code: "BA"
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW"
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO"
  },
  {
    name: "Brunei",
    dial_code: "+673",
    code: "BN"
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF"
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI"
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH"
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM"
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA"
  },
  {
    name: "Cape Verde Islands",
    dial_code: "+238",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY"
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF"
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL"
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN"
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO"
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM"
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG"
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK"
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR"
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR"
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU"
  },
  {
    name: "Cyprus - North",
    dial_code: "+90",
    code: "CYN"
  },
  {
    name: "Cyprus - South",
    dial_code: "+357",
    code: "CY"
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ"
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK"
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ"
  },
  {
    name: "Dominica",
    dial_code: "+1",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    dial_code: "+1",
    code: "DO"
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC"
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG"
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ"
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER"
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE"
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET"
  },
  {
    name: "Falkland Islands",
    dial_code: "+500",
    code: "FK"
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO"
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ"
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI"
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR"
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF"
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF"
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA"
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM"
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE"
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE"
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH"
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI"
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR"
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL"
  },
  {
    name: "Grenada",
    dial_code: "+1",
    code: "GD"
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP"
  },
  {
    name: "Guam",
    dial_code: "+1",
    code: "GU"
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT"
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW"
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY"
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT"
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN"
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK"
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU"
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS"
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN"
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID"
  },
  {
    name: "Iran",
    dial_code: "+98",
    code: "IR"
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ"
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE"
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL"
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT"
  },
  {
    name: "Jamaica",
    dial_code: "+1",
    code: "JM"
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP"
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    dial_code: "+77",
    code: "KZ"
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE"
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI"
  },
  {
    name: "Korea - North",
    dial_code: "+850",
    code: "KP"
  },
  {
    name: "Korea - South",
    dial_code: "+82",
    code: "KR"
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG"
  },
  {
    name: "Laos",
    dial_code: "+856",
    code: "LA"
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV"
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB"
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS"
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR"
  },
  {
    name: "Libya",
    dial_code: "+218",
    code: "LY"
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI"
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT"
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU"
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO"
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    code: "MK"
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG"
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW"
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY"
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV"
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML"
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH"
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ"
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR"
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT"
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX"
  },
  {
    name: "Micronesia",
    dial_code: "+691",
    code: "FM"
  },
  {
    name: "Moldova",
    dial_code: "+373",
    code: "MD"
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC"
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN"
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME"
  },
  {
    name: "Montserrat",
    dial_code: "+1",
    code: "MS"
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA"
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ"
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM"
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA"
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR"
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP"
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL"
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC"
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI"
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE"
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG"
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU"
  },
  {
    name: "Norfolk Islands",
    dial_code: "+672",
    code: "NF"
  },
  {
    name: "Northern Marianas",
    dial_code: "+1",
    code: "MP"
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO"
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM"
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK"
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW"
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG"
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY"
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE"
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH"
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL"
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    dial_code: "+1",
    code: "PR"
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA"
  },
  {
    name: "Reunion",
    dial_code: "+262",
    code: "RE"
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO"
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU"
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW"
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM"
  },
  {
    name: "Sao Tome & Principe",
    dial_code: "+239",
    code: "ST"
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA"
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN"
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS"
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL"
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG"
  },
  {
    name: "Slovak Republic",
    dial_code: "+421",
    code: "SK"
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB"
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO"
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA"
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK"
  },
  {
    name: "St. Helena",
    dial_code: "+290",
    code: "SH"
  },
  {
    name: "St. Kitts",
    dial_code: "+1",
    code: "KN"
  },
  {
    name: "St. Lucia",
    dial_code: "+1",
    code: "LC"
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD"
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR"
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ"
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE"
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH"
  },
  {
    name: "Syria",
    dial_code: "+963",
    code: "SY"
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    code: "TW"
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ"
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH"
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG"
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO"
  },
  {
    name: "Trinidad & Tobago",
    dial_code: "+1",
    code: "TT"
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN"
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM"
  },
  {
    name: "Turks & Caicos Islands",
    dial_code: "+1",
    code: "TC"
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV"
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG"
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE"
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU"
  },
  {
    name: "Vatican City",
    dial_code: "+379",
    code: "VA"
  },
  {
    name: "Venezuela",
    dial_code: "+58",
    code: "VE"
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN"
  },
  {
    name: "Virgin Islands - British",
    dial_code: "+1",
    code: "VG"
  },
  {
    name: "Virgin Islands - US",
    dial_code: "+1",
    code: "VI"
  },
  {
    name: "Wallis & Futuna",
    dial_code: "+681",
    code: "WF"
  },
  {
    name: "Yemen - North",
    dial_code: "+969",
    code: "YEN"
  },
  {
    name: "Yemen - South",
    dial_code: "+967",
    code: "YES"
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW"
  }
], Xl = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "11\\d{8}|(?:[2368]|9\\d)\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-7]|3[2-4]|[4-6]\\d))|91(?:[0-57-9]\\d|6[0135-9])\\d)\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365|46", "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"], BD: ["880", "00", "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:[2689]\\d|51)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]]], BL: ["590", "00", "(?:590|69\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"], 0, 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}", [10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[57])|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"], 0, 0, 0, ["600[2-9]\\d{6}"]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[02-9]"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "(?:[26]\\d\\d|88)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:1\\d|3)\\d{9}|[124-8]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1 $2", ["[14][2-9]|[25-8]"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|235)|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-59]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], 0, 0, "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590|69\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"], 0, 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|(?:[2689]\\d|70)\\d{8}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]]]], GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([5-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "(?:18|[2569]\\d\\d)\\d{5}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[25]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"], KZ: ["7", "810", "33622\\d{5}|(?:7\\d|80)\\d{8}", [10], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[7-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"], LI: ["423", "00", "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[0-8]|6[1267]|7[0-37]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], MC: ["377", "00", "870\\d{5}|(?:[349]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590|69\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"], 0, 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[57-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "(?:28|[68]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"], MQ: ["596", "00", "69\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[2-468]|5\\d)\\d{6}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "[2-57-9]\\d{5}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|5[89]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, 0, " Anexo "], PF: ["689", "00", "[48]\\d{7}|4\\d{5}", [6, 8], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[48]"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]], RE: ["262", "00", "9769\\d{5}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"], RO: ["40", "00", "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "[347-9]\\d{9}", [10], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", 1]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "8000\\d{3}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-3]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[4589]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[2378]\\d|66|99)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d{4}|93330)\\d{4}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[1-35-9]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "(?:[02]0|11|[3-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"], 0, 1], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], 0, 1], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3"], 0, 1], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02457-9]|11"], 0, 1]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|[5-8]\\d{3})\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-8]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[0589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}", [10], [["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "55501\\d{4}|(?:33|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "(?:[23]\\d|[48]8)\\d{3}|(?:[57]\\d|90)\\d{5}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]]], WF: ["681", "00", "(?:[45]0|68|72|8\\d)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[4-8]"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["[1-9]\\d{7}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|[19]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["3(?:37\\d\\d|42)\\d{4}|3(?:2|47|7\\d{3})\\d{7}", [7, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]], 883: ["883", 0, "51\\d{7}(?:\\d{3})?", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["51[013]0\\d{8}|5100\\d{5}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function Yl(r, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Xl), r.apply(this, n);
}
function Ql(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Oe = function r(t) {
  Ql(this, r), this.name = this.constructor.name, this.message = t, this.stack = new Error(t).stack;
};
Oe.prototype = Object.create(Error.prototype);
Oe.prototype.constructor = Oe;
var k2 = 2, Kl = 17, Jl = 3, Je = "0-9０-９٠-٩۰-۹", ql = "-‐-―−ー－", $l = "／/", _l = "．.", e6 = "  ­​⁠　", t6 = "()（）［］\\[\\]", n6 = "~⁓∼～", St = "".concat(ql).concat($l).concat(_l).concat(e6).concat(t6).concat(n6), In = "+＋";
function C0(r, t) {
  r = r.split("-"), t = t.split("-");
  for (var n = r[0].split("."), a = t[0].split("."), l = 0; l < 3; l++) {
    var o = Number(n[l]), s = Number(a[l]);
    if (o > s)
      return 1;
    if (s > o)
      return -1;
    if (!isNaN(o) && isNaN(s))
      return 1;
    if (isNaN(o) && !isNaN(s))
      return -1;
  }
  return r[1] && t[1] ? r[1] > t[1] ? 1 : r[1] < t[1] ? -1 : 0 : !r[1] && t[1] ? 1 : r[1] && !t[1] ? -1 : 0;
}
function L1(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? L1 = function(n) {
    return typeof n;
  } : L1 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, L1(r);
}
function at(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function g0(r, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(r, a.key, a);
  }
}
function rt(r, t, n) {
  return t && g0(r.prototype, t), n && g0(r, n), r;
}
var a6 = "1.2.0", r6 = "1.7.35", f0 = " ext. ", i6 = /^\d+$/, pe = /* @__PURE__ */ function() {
  function r(t) {
    at(this, r), d6(t), this.metadata = t, Pn.call(this, t);
  }
  return rt(r, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var a = this.countryCallingCodes()[n];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, a) {
      if (n && i6.test(n) && (a = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new E0(this.getCountryMetadata(n), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new E0(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var a = this.countryCallingCodes()[n];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var a = this.getCountryCodesForCallingCode(n);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var a = this.getCountryCodeForCallingCode(n);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var l = this.nonGeographic()[n];
        if (l)
          return l;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), r;
}(), E0 = /* @__PURE__ */ function() {
  function r(t, n) {
    at(this, r), this.globalMetadataObject = n, this.metadata = t, Pn.call(this, n.metadata);
  }
  return rt(r, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(l) {
        return new l6(l, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && L0(this.types(), n))
        return new s6(L0(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? f0 : this.metadata[13] || f0;
    }
  }]), r;
}(), l6 = /* @__PURE__ */ function() {
  function r(t, n) {
    at(this, r), this._format = t, this.metadata = n;
  }
  return rt(r, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !o6.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), r;
}(), o6 = /^\(?\$1\)?$/, s6 = /* @__PURE__ */ function() {
  function r(t, n) {
    at(this, r), this.type = t, this.metadata = n;
  }
  return rt(r, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), r;
}();
function L0(r, t) {
  switch (t) {
    case "FIXED_LINE":
      return r[0];
    case "MOBILE":
      return r[1];
    case "TOLL_FREE":
      return r[2];
    case "PREMIUM_RATE":
      return r[3];
    case "PERSONAL_NUMBER":
      return r[4];
    case "VOICEMAIL":
      return r[5];
    case "UAN":
      return r[6];
    case "PAGER":
      return r[7];
    case "VOIP":
      return r[8];
    case "SHARED_COST":
      return r[9];
  }
}
function d6(r) {
  if (!r)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Et(r) || !Et(r.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Et(r) ? "an object of shape: { " + Object.keys(r).join(", ") + " }" : "a " + c6(r) + ": " + r, "."));
}
var Et = function(t) {
  return L1(t) === "object";
}, c6 = function(t) {
  return L1(t);
};
function Z2(r, t) {
  if (t = new pe(t), t.hasCountry(r))
    return t.country(r).countryCallingCode();
  throw new Error("Unknown country: ".concat(r));
}
function Pn(r) {
  var t = r.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? C0(t, a6) === -1 ? this.v2 = !0 : C0(t, r6) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var m6 = ";ext=", e1 = function(t) {
  return "([".concat(Je, "]{1,").concat(t, "})");
};
function Nn(r) {
  var t = "20", n = "15", a = "9", l = "6", o = "[  \\t,]*", s = "[:\\.．]?[  \\t,-]*", d = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", m = "(?:[xｘ#＃~～]|int|ｉｎｔ)", h = "[- ]+", p = "[  \\t]*", u = "(?:,{2}|;)", C = m6 + e1(t), E = o + c + s + e1(t) + d, g = o + m + s + e1(a) + d, L = h + e1(l) + "#", x = p + u + s + e1(n) + d, A = p + "(?:,)+" + s + e1(a) + d;
  return C + "|" + E + "|" + g + "|" + L + "|" + x + "|" + A;
}
var h6 = "[" + Je + "]{" + k2 + "}", p6 = "[" + In + "]{0,1}(?:[" + St + "]*[" + Je + "]){3,}[" + St + Je + "]*", u6 = p6 + // Phone number extensions
"(?:" + Nn() + ")?", C6 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + h6 + "$|^" + u6 + "$",
  "i"
);
function Rn(r) {
  return r.length >= k2 && C6.test(r);
}
var w0 = new RegExp("(?:" + Nn() + ")$", "i");
function g6(r) {
  var t = r.search(w0);
  if (t < 0)
    return {};
  for (var n = r.slice(0, t), a = r.match(w0), l = 1; l < a.length; ) {
    if (a[l])
      return {
        number: n,
        ext: a[l]
      };
    l++;
  }
}
var f6 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function E6(r) {
  return f6[r];
}
function v0(r) {
  for (var t = "", l = r.split(""), n = Array.isArray(l), a = 0, l = n ? l : l[Symbol.iterator](); ; ) {
    var o;
    if (n) {
      if (a >= l.length)
        break;
      o = l[a++];
    } else {
      if (a = l.next(), a.done)
        break;
      o = a.value;
    }
    var s = o;
    t += L6(s, t) || "";
  }
  return t;
}
function L6(r, t) {
  return r === "+" ? t ? void 0 : "+" : E6(r);
}
function w6(r, t) {
  for (var n = r.slice(), o = t, a = Array.isArray(o), l = 0, o = a ? o : o[Symbol.iterator](); ; ) {
    var s;
    if (a) {
      if (l >= o.length)
        break;
      s = o[l++];
    } else {
      if (l = o.next(), l.done)
        break;
      s = l.value;
    }
    var d = s;
    r.indexOf(d) < 0 && n.push(d);
  }
  return n.sort(function(c, m) {
    return c - m;
  });
}
function B2(r, t) {
  return Tn(r, void 0, t);
}
function Tn(r, t, n) {
  var a = n.type(t), l = a && a.possibleLengths() || n.possibleLengths();
  if (!l)
    return "IS_POSSIBLE";
  if (t === "FIXED_LINE_OR_MOBILE") {
    if (!n.type("FIXED_LINE"))
      return Tn(r, "MOBILE", n);
    var o = n.type("MOBILE");
    o && (l = w6(l, o.possibleLengths()));
  } else if (t && !a)
    return "INVALID_LENGTH";
  var s = r.length, d = l[0];
  return d === s ? "IS_POSSIBLE" : d > s ? "TOO_SHORT" : l[l.length - 1] < s ? "TOO_LONG" : l.indexOf(s, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function v6(r, t, n) {
  if (t === void 0 && (t = {}), n = new pe(n), t.v2) {
    if (!r.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(r.countryCallingCode);
  } else {
    if (!r.phone)
      return !1;
    if (r.country) {
      if (!n.hasCountry(r.country))
        throw new Error("Unknown country: ".concat(r.country));
      n.country(r.country);
    } else {
      if (!r.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(r.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Un(r.phone || r.nationalNumber, n);
  if (r.countryCallingCode && n.isNonGeographicCallingCode(r.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Un(r, t) {
  switch (B2(r, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function y6(r, t) {
  return H6(r) || A6(r, t) || b6();
}
function b6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function A6(r, t) {
  var n = [], a = !0, l = !1, o = void 0;
  try {
    for (var s = r[Symbol.iterator](), d; !(a = (d = s.next()).done) && (n.push(d.value), !(t && n.length === t)); a = !0)
      ;
  } catch (c) {
    l = !0, o = c;
  } finally {
    try {
      !a && s.return != null && s.return();
    } finally {
      if (l)
        throw o;
    }
  }
  return n;
}
function H6(r) {
  if (Array.isArray(r))
    return r;
}
function x6(r) {
  var t, n;
  r = r.replace(/^tel:/, "tel=");
  for (var o = r.split(";"), a = Array.isArray(o), l = 0, o = a ? o : o[Symbol.iterator](); ; ) {
    var s;
    if (a) {
      if (l >= o.length)
        break;
      s = o[l++];
    } else {
      if (l = o.next(), l.done)
        break;
      s = l.value;
    }
    var d = s, c = d.split("="), m = y6(c, 2), h = m[0], p = m[1];
    switch (h) {
      case "tel":
        t = p;
        break;
      case "ext":
        n = p;
        break;
      case "phone-context":
        p[0] === "+" && (t = p + t);
        break;
    }
  }
  if (!Rn(t))
    return {};
  var u = {
    number: t
  };
  return n && (u.ext = n), u;
}
function M6(r) {
  var t = r.number, n = r.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function Ie(r, t) {
  return r = r || "", new RegExp("^(?:" + t + ")$").test(r);
}
var V6 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function O2(r, t, n) {
  if (t = t || {}, !!r.country) {
    n = new pe(n), n.selectNumberingPlan(r.country, r.countryCallingCode);
    var a = t.v2 ? r.nationalNumber : r.phone;
    if (Ie(a, n.nationalNumberPattern())) {
      if (Lt(a, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Lt(a, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var l = 0, o = V6; l < o.length; l++) {
        var s = o[l];
        if (Lt(a, s, n))
          return s;
      }
    }
  }
}
function Lt(r, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(r.length) < 0 ? !1 : Ie(r, t.pattern());
}
function D6(r, t, n) {
  if (t = t || {}, n = new pe(n), !r.country)
    return !1;
  if (n.selectNumberingPlan(r.country, r.countryCallingCode), n.hasTypes())
    return O2(r, t, n.metadata) !== void 0;
  var a = t.v2 ? r.nationalNumber : r.phone;
  return Ie(a, n.nationalNumberPattern());
}
function F6(r) {
  return r.replace(new RegExp("[".concat(St, "]+"), "g"), " ").trim();
}
var k6 = /(\$\d)/;
function Z6(r, t, n) {
  var a = n.useInternationalFormat, l = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var o = r.replace(new RegExp(t.pattern()), a ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    l && t.nationalPrefixFormattingRule() ? t.format().replace(k6, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return a ? F6(o) : o;
}
var B6 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function O6(r, t, n) {
  var a = new pe(n);
  return a.selectNumberingPlan(r, t), B6.test(a.IDDPrefix()) ? a.IDDPrefix() : a.defaultIDDPrefix();
}
function S6(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, a = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(n).filter(function(l) {
      return Object.getOwnPropertyDescriptor(n, l).enumerable;
    }))), a.forEach(function(l) {
      I6(r, l, n[l]);
    });
  }
  return r;
}
function I6(r, t, n) {
  return t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
var y0 = {
  formatExtension: function(t, n, a) {
    return "".concat(t).concat(a.ext()).concat(n);
  }
  // Formats a phone number
  //
  // Example use cases:
  //
  // ```js
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL')
  // formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
  // formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
  // formatNumber('+78005553535', 'NATIONAL')
  // formatNumber('+78005553535', 'NATIONAL', metadata)
  // ```
  //
};
function P6(r, t, n, a) {
  if (n ? n = S6({}, y0, n) : n = y0, a = new pe(a), r.country && r.country !== "001") {
    if (!a.hasCountry(r.country))
      throw new Error("Unknown country: ".concat(r.country));
    a.country(r.country);
  } else if (r.countryCallingCode)
    a.selectNumberingPlan(r.countryCallingCode);
  else
    return r.phone || "";
  var l = a.countryCallingCode(), o = n.v2 ? r.nationalNumber : r.phone, s;
  switch (t) {
    case "NATIONAL":
      return o ? (s = G1(o, r.carrierCode, "NATIONAL", a, n), wt(s, r.ext, a, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (s = G1(o, null, "INTERNATIONAL", a, n), s = "+".concat(l, " ").concat(s), wt(s, r.ext, a, n.formatExtension)) : "+".concat(l);
    case "E.164":
      return "+".concat(l).concat(o);
    case "RFC3966":
      return M6({
        number: "+".concat(l).concat(o),
        ext: r.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var d = R6(o, r.carrierCode, l, n.fromCountry, a);
      return wt(d, r.ext, a, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function G1(r, t, n, a, l) {
  var o = N6(a.formats(), r);
  return o ? Z6(r, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && l && l.nationalPrefix === !1),
    carrierCode: t,
    metadata: a
  }) : r;
}
function N6(r, t) {
  for (var l = r, n = Array.isArray(l), a = 0, l = n ? l : l[Symbol.iterator](); ; ) {
    var o;
    if (n) {
      if (a >= l.length)
        break;
      o = l[a++];
    } else {
      if (a = l.next(), a.done)
        break;
      o = a.value;
    }
    var s = o;
    if (s.leadingDigitsPatterns().length > 0) {
      var d = s.leadingDigitsPatterns()[s.leadingDigitsPatterns().length - 1];
      if (t.search(d) !== 0)
        continue;
    }
    if (Ie(t, s.pattern()))
      return s;
  }
}
function wt(r, t, n, a) {
  return t ? a(r, t, n) : r;
}
function R6(r, t, n, a, l) {
  var o = Z2(a, l.metadata);
  if (o === n) {
    var s = G1(r, t, "NATIONAL", l);
    return n === "1" ? n + " " + s : s;
  }
  var d = O6(a, void 0, l.metadata);
  if (d)
    return "".concat(d, " ").concat(n, " ").concat(G1(r, null, "INTERNATIONAL", l));
}
function T6(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, a = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(n).filter(function(l) {
      return Object.getOwnPropertyDescriptor(n, l).enumerable;
    }))), a.forEach(function(l) {
      U6(r, l, n[l]);
    });
  }
  return r;
}
function U6(r, t, n) {
  return t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function G6(r, t) {
  if (!(r instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function b0(r, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(r, a.key, a);
  }
}
function z6(r, t, n) {
  return t && b0(r.prototype, t), n && b0(r, n), r;
}
var W6 = /* @__PURE__ */ function() {
  function r(t, n, a) {
    if (G6(this, r), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    var l = new pe(a);
    j6(t) && (this.country = t, l.country(t), t = l.countryCallingCode()), this.countryCallingCode = t, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.metadata = a;
  }
  return z6(r, [{
    key: "isPossible",
    value: function() {
      return v6(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isValid",
    value: function() {
      return D6(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new pe(this.metadata);
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // // Is just an alias for `this.isValid() && this.country === country`.
    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
    // isValidForRegion(country) {
    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
    // }
  }, {
    key: "getType",
    value: function() {
      return O2(this, {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "format",
    value: function(n, a) {
      return P6(this, n, a ? T6({}, a, {
        v2: !0
      }) : {
        v2: !0
      }, this.metadata);
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), r;
}(), j6 = function(t) {
  return /^[A-Z]{2}$/.test(t);
}, X6 = new RegExp("([" + Je + "])");
function Y6(r, t, n, a) {
  if (t) {
    var l = new pe(a);
    l.selectNumberingPlan(t, n);
    var o = new RegExp(l.IDDPrefix());
    if (r.search(o) === 0) {
      r = r.slice(r.match(o)[0].length);
      var s = r.match(X6);
      if (!(s && s[1] != null && s[1].length > 0 && s[1] === "0"))
        return r;
    }
  }
}
function Q6(r, t) {
  if (r && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), a = n.exec(r);
    if (a) {
      var l, o, s = a.length - 1, d = s > 0 && a[s];
      if (t.nationalPrefixTransformRule() && d)
        l = r.replace(n, t.nationalPrefixTransformRule()), s > 1 && (o = a[1]);
      else {
        var c = a[0];
        l = r.slice(c.length), d && (o = a[1]);
      }
      var m;
      if (d) {
        var h = r.indexOf(a[1]), p = r.slice(0, h);
        p === t.numberingPlan.nationalPrefix() && (m = t.numberingPlan.nationalPrefix());
      } else
        m = a[0];
      return {
        nationalNumber: l,
        nationalPrefix: m,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: r
  };
}
function It(r, t) {
  var n = Q6(r, t), a = n.nationalNumber, l = n.carrierCode;
  if (!K6(r, a, t))
    return {
      nationalNumber: r
    };
  if (r.length !== a.length + (l ? l.length : 0) && t.possibleLengths())
    switch (B2(a, t)) {
      case "TOO_SHORT":
      case "INVALID_LENGTH":
        return {
          nationalNumber: r
        };
    }
  return {
    nationalNumber: a,
    carrierCode: l
  };
}
function K6(r, t, n) {
  return !(Ie(r, n.nationalNumberPattern()) && !Ie(t, n.nationalNumberPattern()));
}
function J6(r, t, n, a) {
  var l = t ? Z2(t, a) : n;
  if (r.indexOf(l) === 0) {
    a = new pe(a), a.selectNumberingPlan(t, n);
    var o = r.slice(l.length), s = It(o, a), d = s.nationalNumber, c = It(r, a), m = c.nationalNumber;
    if (!Ie(m, a.nationalNumberPattern()) && Ie(d, a.nationalNumberPattern()) || B2(m, a) === "TOO_LONG")
      return {
        countryCallingCode: l,
        number: o
      };
  }
  return {
    number: r
  };
}
function q6(r, t, n, a) {
  if (!r)
    return {};
  if (r[0] !== "+") {
    var l = Y6(r, t, n, a);
    if (l && l !== r)
      r = "+" + l;
    else {
      if (t || n) {
        var o = J6(r, t, n, a), s = o.countryCallingCode, d = o.number;
        if (s)
          return {
            countryCallingCode: s,
            number: d
          };
      }
      return {
        number: r
      };
    }
  }
  if (r[1] === "0")
    return {};
  a = new pe(a);
  for (var c = 2; c - 1 <= Jl && c <= r.length; ) {
    var m = r.slice(1, c);
    if (a.hasCallingCode(m))
      return a.selectNumberingPlan(m), {
        countryCallingCode: m,
        number: r.slice(c)
      };
    c++;
  }
  return {};
}
function $6(r, t, n) {
  var a = n.getCountryCodesForCallingCode(r);
  if (a)
    return a.length === 1 ? a[0] : _6(a, t, n.metadata);
}
function _6(r, t, n) {
  n = new pe(n);
  for (var o = r, a = Array.isArray(o), l = 0, o = a ? o : o[Symbol.iterator](); ; ) {
    var s;
    if (a) {
      if (l >= o.length)
        break;
      s = o[l++];
    } else {
      if (l = o.next(), l.done)
        break;
      s = l.value;
    }
    var d = s;
    if (n.country(d), n.leadingDigits()) {
      if (t && t.search(n.leadingDigits()) === 0)
        return d;
    } else if (O2({
      phone: t,
      country: d
    }, void 0, n.metadata))
      return d;
  }
}
var e7 = 250, t7 = new RegExp("[" + In + Je + "]"), n7 = new RegExp("[^" + Je + "#]+$");
function a7(r, t, n) {
  if (t = t || {}, n = new pe(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Oe("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var a = i7(r, t.v2), l = a.number, o = a.ext;
  if (!l) {
    if (t.v2)
      throw new Oe("NOT_A_NUMBER");
    return {};
  }
  var s = o7(l, t.defaultCountry, t.defaultCallingCode, n), d = s.country, c = s.nationalNumber, m = s.countryCallingCode, h = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Oe("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < k2) {
    if (t.v2)
      throw new Oe("TOO_SHORT");
    return {};
  }
  if (c.length > Kl) {
    if (t.v2)
      throw new Oe("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var p = new W6(m, c, n.metadata);
    return d && (p.country = d), h && (p.carrierCode = h), o && (p.ext = o), p;
  }
  var u = (t.extended ? n.hasSelectedNumberingPlan() : d) ? Ie(c, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: d,
    countryCallingCode: m,
    carrierCode: h,
    valid: u,
    possible: u ? !0 : !!(t.extended === !0 && n.possibleLengths() && Un(c, n)),
    phone: c,
    ext: o
  } : u ? l7(d, c, o) : {};
}
function r7(r, t) {
  if (r) {
    if (r.length > e7) {
      if (t)
        throw new Oe("TOO_LONG");
      return;
    }
    var n = r.search(t7);
    if (!(n < 0))
      return r.slice(n).replace(n7, "");
  }
}
function i7(r, t) {
  if (r && r.indexOf("tel:") === 0)
    return x6(r);
  var n = r7(r, t);
  if (!n || !Rn(n))
    return {};
  var a = g6(n);
  return a.ext ? a : {
    number: n
  };
}
function l7(r, t, n) {
  var a = {
    country: r,
    phone: t
  };
  return n && (a.ext = n), a;
}
function o7(r, t, n, a) {
  var l = q6(v0(r), t, n, a.metadata), o = l.countryCallingCode, s = l.number, d;
  if (o)
    a.selectNumberingPlan(o);
  else if (s && (t || n))
    a.selectNumberingPlan(t, n), t && (d = t), o = n || Z2(t, a.metadata);
  else
    return {};
  if (!s)
    return {
      countryCallingCode: o
    };
  var c = It(v0(s), a), m = c.nationalNumber, h = c.carrierCode, p = $6(o, m, a);
  return p && (d = p, p === "001" || a.country(d)), {
    country: d,
    countryCallingCode: o,
    nationalNumber: m,
    carrierCode: h
  };
}
function s7(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, a = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(n).filter(function(l) {
      return Object.getOwnPropertyDescriptor(n, l).enumerable;
    }))), a.forEach(function(l) {
      d7(r, l, n[l]);
    });
  }
  return r;
}
function d7(r, t, n) {
  return t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function c7(r, t, n) {
  return a7(r, s7({}, t, {
    v2: !0
  }), n);
}
function P1(r) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? P1 = function(n) {
    return typeof n;
  } : P1 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, P1(r);
}
function m7(r) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, a = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (a = a.concat(Object.getOwnPropertySymbols(n).filter(function(l) {
      return Object.getOwnPropertyDescriptor(n, l).enumerable;
    }))), a.forEach(function(l) {
      h7(r, l, n[l]);
    });
  }
  return r;
}
function h7(r, t, n) {
  return t in r ? Object.defineProperty(r, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = n, r;
}
function p7(r, t) {
  return g7(r) || C7(r, t) || u7();
}
function u7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function C7(r, t) {
  var n = [], a = !0, l = !1, o = void 0;
  try {
    for (var s = r[Symbol.iterator](), d; !(a = (d = s.next()).done) && (n.push(d.value), !(t && n.length === t)); a = !0)
      ;
  } catch (c) {
    l = !0, o = c;
  } finally {
    try {
      !a && s.return != null && s.return();
    } finally {
      if (l)
        throw o;
    }
  }
  return n;
}
function g7(r) {
  if (Array.isArray(r))
    return r;
}
function f7() {
  var r = E7(arguments), t = r.text, n = r.options, a = r.metadata;
  return c7(t, n, a);
}
function E7(r) {
  var t = Array.prototype.slice.call(r), n = p7(t, 4), a = n[0], l = n[1], o = n[2], s = n[3], d, c, m;
  if (typeof a == "string")
    d = a;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!l || typeof l == "string")
    s ? (c = o, m = s) : (c = void 0, m = o), l && (c = m7({
      defaultCountry: l
    }, c));
  else if (L7(l))
    o ? (c = l, m = o) : m = l;
  else
    throw new Error("Invalid second argument: ".concat(l));
  return {
    text: d,
    options: c,
    metadata: m
  };
}
var L7 = function(t) {
  return P1(t) === "object";
};
function w7() {
  return Yl(f7, arguments);
}
const v7 = ({ chosen: r, dialCode: t, name: n, ...a }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: Be.optionContainer,
    style: { borderBottom: r ? `1px solid ${v.blackLighter6}` : "none" },
    ...a
  },
  /* @__PURE__ */ e.createElement(V, { noHoverEffects: !0, type: n.toLowerCase() }),
  /* @__PURE__ */ e.createElement(B, { factor: 0.5 }),
  /* @__PURE__ */ e.createElement(y, { className: Be.codeTextOption, type: "body-sm" }, t),
  /* @__PURE__ */ e.createElement(B, { factor: 0.5 }),
  /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, n)
), y7 = ({ name: r, dialCode: t, ...n }) => /* @__PURE__ */ e.createElement("div", { className: Be.renderSelected, ...n }, /* @__PURE__ */ e.createElement(V, { type: r.toLowerCase() }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, t)), A0 = ({ country: r, val: t, id: n }) => {
  if (!r)
    return null;
  const { dial_code: a, name: l } = r, o = t === a && n === l;
  return {
    id: l,
    val: a,
    render: /* @__PURE__ */ e.createElement(v7, { chosen: o, dialCode: a, name: l }),
    renderSelected: /* @__PURE__ */ e.createElement(y7, { name: l, dialCode: a }),
    searchString: a + " " + l
  };
}, b7 = (r) => r && (r.country ? U1.find(({ code: t }) => t === r.country) : U1.find(
  ({ dial_code: t }) => "+" + r.countryCallingCode === t
)), H0 = (r) => r.replace(/ /gi, ""), A7 = (r) => r && r.startsWith("+") ? r : `+${r}`, S2 = (r) => {
  try {
    return w7(A7(r));
  } catch (t) {
    console.error(t);
    return;
  }
}, H7 = (r) => !!S2(r), x7 = (...r) => Array.from(r).filter((t) => t[0]).map((t) => t[1]).join(" "), vt = ({ selectedCountry: r, nationalNumber: t }) => {
  if (r && t) {
    const n = S2(
      r + t
    );
    if (n) {
      const a = n.formatInternational().split(" ");
      return a.slice(
        1,
        a.length
      ).join(" ");
    }
  }
  return t;
}, Gn = Yt(
  ({
    countryCodeTestId: r,
    disabled: t,
    error: n,
    id: a,
    label: l,
    subLabel: o,
    labelSize: s,
    labelOptional: d,
    labelTooltip: c,
    onBlur: m,
    onChange: h,
    nationalNumberTestId: p,
    showSearch: u,
    value: C,
    width: E
  }) => {
    const [g, L] = z({}), [x, A] = z(), Z = (w) => {
      const H = vt({
        selectedCountry: g.val,
        nationalNumber: w.target.value
      }), b = H0(H);
      A(H), h((g.val || "") + b);
    }, D = (w) => {
      let H = "";
      if (x) {
        const b = vt({
          selectedCountry: w.val,
          nationalNumber: x
        });
        H = H0(b), A(b);
      }
      L(w), h(w.val + H);
    };
    ee(() => {
      if (C) {
        const w = S2(C);
        if (w) {
          const H = b7(w), b = A0({ country: H });
          L(b);
          const k = vt({
            selectedCountry: b.val,
            nationalNumber: w.nationalNumber
          });
          A(k);
        }
      }
    }, []);
    const f = Y(() => U1.map((w) => A0({
      country: w,
      val: g.val,
      id: g.id
    })), [U1, g]);
    return /* @__PURE__ */ e.createElement("div", { style: { width: E } }, /* @__PURE__ */ e.createElement(
      ue,
      {
        labelFor: a,
        subLabel: o,
        size: s,
        optional: d,
        tooltip: c
      },
      l
    ), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${Be.inputWrap} ${x7(
          [t, Be.disabled],
          [n, Be.errorWrap]
        )}`
      },
      /* @__PURE__ */ e.createElement("div", { id: "countryInp", className: `${Be.rightButton} ${Be.flexCenter}` }, /* @__PURE__ */ e.createElement(
        dt,
        {
          disabled: t,
          dropDownWrap: {
            width: E
          },
          fixOverflow: !1,
          numOptions: 6,
          options: f,
          onChange: D,
          placeholder: "",
          value: g,
          width: "96px",
          showSearch: u,
          testId: r
        }
      )),
      /* @__PURE__ */ e.createElement("div", { className: Be.input }, /* @__PURE__ */ e.createElement(
        me,
        {
          disabled: t,
          id: a,
          inputStyle: {
            border: 0
          },
          onBlur: m,
          onChange: Z,
          testId: p,
          value: x,
          width: "100%"
        }
      ))
    ), n && /* @__PURE__ */ e.createElement(ae, null, n));
  }
);
Gn.propTypes = {
  countryCodeTestId: i.string,
  disabled: i.bool,
  error: i.string,
  id: function(r, t, n) {
    return r.label ? i.checkPropTypes(i.string.isRequired, r, t, n) : i.checkPropTypes(i.string, r, t, n);
  },
  label: i.string,
  sublabel: i.string,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  labelTooltip: i.any,
  onBlur: i.func,
  onChange: i.func,
  nationalNumberTestId: i.string,
  showSearch: i.bool,
  value: i.string,
  width: i.string
};
Gn.defaultProps = {
  disabled: !1,
  error: "",
  kind: "phoneInput",
  label: "",
  sublabel: "",
  labelSize: "small",
  labelOptional: !1,
  labelTooltip: null,
  showSearch: !1,
  value: "",
  width: "540px"
};
const q = (r, t, n, a, l) => {
  if (r[t]) {
    if (r[t][n]) {
      const o = r[t][n], s = o.args;
      return G0(s, l) || (o.args = l, o.cb = a(l)), o.cb;
    }
    return r[t][n] = {
      args: l,
      cb: a(l)
    }, r[t][n].cb;
  }
  return r[t] = {
    [n]: {
      args: l,
      cb: a(l)
    }
  }, r[t][n].cb;
}, x0 = {
  validator: (r) => !H7(r),
  message: "Phone number is invalid."
}, I2 = (r, t = { required: [], errorValidators: [] }) => e.Children.toArray(r).reduce((a, l) => {
  if (typeof l == "object" && l !== null) {
    const {
      props: {
        children: o,
        defaultValue: s,
        name: d,
        required: c,
        errorValidators: m,
        validationDisabled: h,
        kind: p,
        value: u,
        active: C,
        selected: E,
        data: g
      }
    } = l;
    if (P2(l) && (Ze(s) ? typeof a[d] > "u" && (Ze(C) ? Ze(u) ? Ze(E) ? Ze(g) ? typeof ft[p] < "u" && (a[d] = ft[p]) : a[d] = g : a[d] = E : a[d] = u : a[d] = C) : a[d] = s, c && (typeof c == "function" ? a.required.push({ field: d, cb: c }) : a.required.push({ field: d })), p === nt && (Ze(g) ? a.actionCardGroupsInitialState[d] = ft[p] : a.actionCardGroupsInitialState[d] = a[d]), h || (p === "phoneInput" ? a.errorValidators.push({
      field: d,
      errorValidators: m ? [...m, x0] : [x0]
    }) : m && a.errorValidators.push({
      field: d,
      errorValidators: m
    }))), o && p !== "form")
      return I2(o, a);
  }
  return a;
}, t), P2 = (r) => {
  const {
    props: { name: t, onChange: n, isError: a, kind: l, submit: o }
  } = r, s = [];
  return xl.find((d) => d === l) ? (!t && l !== Vn && l !== et && s.push(`Form component requires name prop to be passed for component: ${r.type}`), s.length && console.warn(JSON.stringify(s, null, 4)), !0) : !1;
}, Ee = ({ kind: r, name: t, value: n }) => `volt-${r}-${t}${r === "radio" || r === "toggle" ? `-${String(n)}` : ""}`, M7 = ({ child: r, handlers: t, state: n }) => {
  const { handleSubmit: a } = t, {
    props: l,
    props: { kind: o, name: s, onClick: d, disabled: c, submit: m, testId: h }
  } = r, p = `${Ee({ kind: o, name: s, value: n[s] })}-${c ? "disabled" : "enabled"}`;
  return {
    ...l,
    onClick: q(
      n.cache,
      s || m && "submit",
      "handleSubmit",
      a,
      {
        cb: d,
        state: n
      }
    ),
    testId: h !== W.button ? h : p
  };
}, M0 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleChange: l, handleBlur: o } = t, {
    props: { errorValidators: s, kind: d, onChangeValidator: c, name: m, onChange: h, value: p, required: u, testId: C },
    props: E
  } = r;
  return {
    ...E,
    error: a,
    onChange: q(n.cache, m, "handleChange", l, {
      field: m,
      cb: h,
      errorValidators: s,
      required: u,
      value: n[m],
      submitted: n.submitted
    }),
    onBlur: q(n.cache, m, "handleBlur", o, {
      field: m,
      error: a,
      errorValidators: s,
      value: n[m],
      submitted: n.submitted
    }),
    value: n[m],
    testId: C !== W.input && C !== W.textarea ? C : Ee({ kind: d, name: m, value: n[m] })
  };
}, V7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handlePhoneInputChange: l, handleBlur: o } = t, {
    props: { errorValidators: s, kind: d, onChangeValidator: c, name: m, onChange: h, value: p, required: u, testId: C },
    props: E
  } = r;
  return {
    ...E,
    error: a,
    onChange: q(
      n.cache,
      m,
      "handlePhoneInputChange",
      l,
      {
        field: m,
        cb: h,
        errorValidators: s,
        required: u,
        submitted: n.submitted
      }
    ),
    onBlur: q(n.cache, m, "handleBlur", o, {
      field: m,
      error: a,
      errorValidators: s,
      value: n[m],
      submitted: n.submitted
    }),
    value: n[m],
    testId: C !== W.input && C !== W.textarea ? C : Ee({ kind: d, name: m, value: n[m] })
  };
}, D7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleMaskedInputChange: l, handleBlur: o } = t, {
    props: { errorValidators: s, kind: d, name: c, onChange: m, required: h },
    props: p
  } = r;
  return {
    ...p,
    error: a,
    onValueChange: q(
      n.cache,
      c,
      "handleMaskedInputChange",
      l,
      {
        field: c,
        cb: m,
        errorValidators: s,
        required: h,
        value: n[c],
        submitted: n.submitted
      }
    ),
    onBlur: q(n.cache, c, "handleBlur", o, {
      field: c,
      error: a,
      errorValidators: s,
      value: n[c],
      submitted: n.submitted
    }),
    value: n[c],
    testId: Ee({ kind: d, name: c, value: n[c] })
  };
}, F7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleMultiselectChange: l, handleMultiselectOnBulkChange: o } = t, {
    props: { kind: s, name: d, onOptionClick: c, onBulkToggleClick: m, selected: h, testId: p, required: u },
    props: C
  } = r;
  return {
    ...C,
    onOptionClick: q(
      n.cache,
      d,
      "handleMultiselectChange",
      l,
      {
        field: d,
        cb: c,
        selected: n[d],
        required: u
      }
    ),
    onBulkToggleClick: q(
      n.cache,
      d,
      "handleMultiselectOnBulkChange",
      o,
      {
        field: d,
        cb: m,
        selected: n[d],
        required: u
      }
    ),
    selected: n[d],
    testId: p !== W.multiselect ? p : Ee({ kind: s, name: d, value: n[d] }),
    error: a
  };
}, yt = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleClick: l } = t, {
    props: { kind: o, name: s, onClick: d, active: c, value: m, required: h, testId: p },
    props: u
  } = r;
  return {
    ...u,
    onClick: q(n.cache, s, "handleClick", l, {
      field: s,
      cb: d,
      required: h,
      submitted: n.submitted,
      value: n[s]
    }),
    active: n[s],
    testId: p !== W.radio && p !== W.toggle ? p : Ee({ kind: o, name: s, value: n[s] }),
    error: a
  };
}, k7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleSelectChange: l } = t, {
    props: { kind: o, name: s, onChange: d, value: c, testId: m },
    props: h
  } = r;
  return {
    ...h,
    error: a,
    onChange: q(n.cache, s, "handleSelectChange", l, {
      field: s,
      cb: d
    }),
    value: n[s],
    testId: m !== W.select ? m : Ee({ kind: o, name: s, value: n[s] })
  };
}, Z7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleGroupChange: l } = t, {
    props: { errorValidators: o, kind: s, name: d, onChange: c, value: m, required: h, testId: p },
    props: u
  } = r;
  return {
    ...u,
    error: a,
    onChange: q(n.cache, d, "handleGroupChange", l, {
      field: d,
      cb: c,
      errorValidators: o,
      value: m,
      required: h,
      submitted: n.submitted
    }),
    value: n[d],
    testId: p !== W.select ? p : Ee({ kind: s, name: d, value: n[d] })
  };
}, B7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleDayPickerChange: l } = t, {
    props: { kind: o, name: s, onChange: d, selected: c, required: m, testId: h },
    props: p
  } = r;
  return {
    ...p,
    onChange: q(n.cache, s, "handleDayPickerChange", l, {
      field: s,
      cb: d,
      selected: n[s],
      required: m,
      submitted: n.submitted
    }),
    selected: n[s],
    testId: h !== W.dayPicker ? h : Ee({ kind: o, name: s, value: n[s] }),
    error: a
  };
}, O7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleRadioGroupChange: l } = t, {
    props: { errorValidators: o, kind: s, name: d, onChange: c, value: m, required: h, testId: p },
    props: u
  } = r;
  return {
    ...u,
    error: a,
    onChange: q(
      n.cache,
      d,
      "handleRadioGroupChange",
      l,
      {
        field: d,
        cb: c,
        errorValidators: o,
        value: m,
        required: h,
        submitted: n.submitted
      }
    ),
    value: n[d],
    testId: p !== W.select ? p : Ee({ kind: s, name: d, value: n[d] })
  };
}, S7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleSegmentedButtonsClick: l } = t, {
    props: { errorValidators: o, kind: s, name: d, onClick: c, value: m, required: h, testId: p },
    props: u
  } = r;
  return {
    ...u,
    error: a,
    onClick: q(
      n.cache,
      d,
      "handleSegmentedButtonsClick",
      l,
      {
        field: d,
        cb: c,
        errorValidators: o,
        value: m,
        required: h,
        submitted: n.submitted
      }
    ),
    value: n[d],
    testId: p || Ee({ kind: s, name: d, value: n[d] })
  };
}, I7 = ({ child: r, handlers: t, state: n }) => {
  const {
    handleActionCardGroupOnCreateCard: a,
    handleActionCardGroupOnUpdateCard: l,
    handleActionCardGroupOnDeleteCard: o
  } = t, {
    props: { name: s },
    props: d
  } = r;
  return {
    ...d,
    data: n[s],
    onCreateNewCard: q(
      n.cache,
      s,
      "handleActionCardGroupOnCreateCard",
      a,
      {
        field: s,
        data: n[s]
      }
    ),
    onUpdateCard: q(
      n.cache,
      s,
      "handleActionCardGroupOnUpdateCard",
      l,
      {
        field: s,
        data: n[s]
      }
    ),
    onDeleteCard: q(
      n.cache,
      s,
      "handleActionCardGroupOnDeleteCard",
      o,
      {
        field: s,
        data: n[s]
      }
    )
  };
}, P7 = ({ child: r, handlers: t, state: n, error: a }) => {
  const { handleGrouperChange: l } = t, {
    props: { kind: o, name: s, onChange: d },
    props: c
  } = r;
  return {
    ...c,
    onChange: q(n.cache, s, "handleGrouperChange", l, {
      field: s
    }),
    data: n[s]
  };
}, N7 = ({ state: r, name: t }) => {
  const n = r.errors.find(({ accessor: a }) => a === t);
  return n && n.showError ? n.message : "";
}, R7 = {
  button: M7,
  checkboxGroup: Z7,
  dayPicker: B7,
  radioGroup: O7,
  input: M0,
  phoneInput: V7,
  multiselect: F7,
  radio: yt,
  select: k7,
  textarea: M0,
  toggle: yt,
  checkbox: yt,
  segmentedButtons: S7,
  actionCardGroup: I7,
  grouper: P7,
  maskedInput: D7
}, T7 = ({ child: r, handlers: t, state: n }) => {
  const {
    props: { kind: a, name: l, error: o }
  } = r;
  return {
    ...R7[a]({
      error: o || N7({ state: n, name: l }),
      child: r,
      handlers: t,
      state: n
    })
  };
}, Pt = ({ children: r, handlers: t, state: n }) => e.Children.map(r, (a) => {
  if (typeof a == "object" && a !== null) {
    const l = P2(a), {
      props: { kind: o, submit: s, children: d }
    } = a;
    if (l) {
      if (o === "button" && !s)
        return a;
      const c = T7({
        child: a,
        handlers: t,
        state: n
      });
      return e.cloneElement(
        a,
        c,
        Pt({
          children: d,
          handlers: t,
          state: n
        })
      );
    }
    if (d && o !== "form")
      return e.cloneElement(
        a,
        a.props,
        Pt({
          children: d,
          handlers: t,
          state: n
        })
      );
  }
  return a;
}), V0 = (r, t) => T3(r, t) ? U3(o1(r), t) : [...t, r], ye = (r, t, ...n) => typeof r == "function" ? r(...n) : t, Nt = (r, t) => e.Children.map(r, (n) => {
  if (typeof n != "object" || !n)
    return n;
  let a = {};
  return P2(n) ? t({ child: n, injectPropsToChildrenRecursively: Nt }) : (a.children = Nt(n.props.children, t), e.cloneElement(n, a));
}), U7 = () => {
  const r = F2(), t = Sn(), n = ({ field: f, cb: w }) => function(b) {
    const k = t[f];
    r({
      type: _,
      payload: { [f]: ye(w, !k, b, t) }
    });
  }, a = ({ cb: f }) => function(H) {
    const {
      required: b,
      errorValidators: k,
      errors: O,
      cache: I,
      actionCardGroupsInitialState: T,
      ...te
    } = t, re = { ...te, errors: O }, qe = k.map((G) => {
      const Ve = G.errorValidators.find(
        ({ validator: We }) => We(t[G.field], t)
      );
      if (Ve) {
        const { message: We } = Ve;
        return {
          accessor: G.field,
          message: We,
          showError: !0
        };
      }
    }).filter((G) => G), de = [...b.filter(({ field: G, cb: Ve }) => Ve ? Ve(re) : Array.isArray(t[G]) ? !t[G].length : !t[G]).map(({ field: G }) => ({
      accessor: G,
      message: Re,
      showError: !0
    })), ...qe];
    r({ type: Hn, payload: de }), !de.length && !O.length && f(re);
  }, l = ({ field: f, cb: w, value: H }) => function() {
    const { submitted: k } = t;
    k || (H == null || H === "" ? r({ type: ce, payload: f }) : o(f, H)), w && w();
  }, o = (f, w) => {
    const { required: H, errorValidators: b } = t, k = b.find((T) => T.field === f);
    if (!k)
      return;
    const O = k.errorValidators;
    if (!O || !O.length)
      return;
    const I = O.find(
      ({ validator: T }) => T(w, t)
    );
    if (I) {
      const { message: T } = I, te = typeof T == "function" ? T(w, t) : T;
      r({
        type: ke,
        payload: { accessor: f, message: te, showError: !0 }
      }), r({ type: An, payload: f });
    } else
      r({ type: ce, payload: f });
  }, s = ({ field: f, cb: w, required: H, value: b, e: k }) => {
    const { submitted: O } = t;
    if (r({
      type: _,
      payload: { [f]: ye(w, b, k, t) }
    }), O) {
      if (H)
        if (b)
          r({ type: ce, payload: f });
        else {
          r({
            type: ke,
            payload: { accessor: f, message: Re, showError: !0 }
          });
          return;
        }
      o(f, b);
    }
  };
  return {
    handleBlur: l,
    handleChange: ({ field: f, cb: w, errorValidators: H, required: b }) => function(O) {
      const {
        currentTarget: { value: I }
      } = O;
      s({ field: f, cb: w, errorValidators: H, required: b, value: I, e: O });
    },
    handleClick: n,
    handleGroupChange: ({ field: f, cb: w, required: H }) => function(k) {
      const { submitted: O } = t, I = Array.isArray(k) && k.filter((T) => T.active) || [];
      if (r({
        type: _,
        payload: {
          [f]: ye(w, k, I, t)
        }
      }), O && H)
        if (I.length)
          r({ type: ce, payload: f });
        else {
          r({
            type: ke,
            payload: { accessor: f, message: Re, showError: !0 }
          });
          return;
        }
      o(f, I);
    },
    handleGrouperChange: ({ field: f }) => function(H) {
      r({
        type: _,
        payload: {
          [f]: H.data
        }
      });
    },
    handleDayPickerChange: ({ field: f, cb: w, required: H }) => function(k) {
      var te;
      const { submitted: O } = t, I = r0(f, t) ? (te = t[f]) == null ? void 0 : te.slice() : [], T = V0(k, I);
      if (r({
        type: _,
        payload: { [f]: ye(w, T, k, t) }
      }), O) {
        if (H)
          if (T.length)
            r({ type: ce, payload: f });
          else {
            r({
              type: ke,
              payload: { accessor: f, message: Re, showError: !0 }
            });
            return;
          }
        o(f, T);
      }
    },
    handleRadioGroupChange: ({ field: f, cb: w, required: H }) => function(k) {
      const { submitted: O } = t, I = k;
      if (r({
        type: _,
        payload: {
          [f]: ye(w, k, I, t)
        }
      }), O && H)
        if (!I && !I.length) {
          r({
            type: ke,
            payload: { accessor: f, message: Re, showError: !0 }
          });
          return;
        } else
          r({ type: ce, payload: f });
      o(f, I);
    },
    handleMultiselectChange: ({ field: f, cb: w, required: H }) => function(k) {
      const { submitted: O } = t, I = r0(f, t) ? t[f].slice() : [], T = V0(k, I);
      if (r({
        type: _,
        payload: { [f]: ye(w, T, k, t) }
      }), O && H)
        if (T.length)
          r({ type: ce, payload: f });
        else {
          r({
            type: ke,
            payload: { accessor: f, message: Re, showError: !0 }
          });
          return;
        }
      o(f, T);
    },
    handleMultiselectOnBulkChange: ({ field: f, cb: w, required: H }) => function(k, O) {
      const { submitted: I } = t;
      if (k) {
        const T = O.slice();
        r({
          type: _,
          payload: {
            [f]: ye(
              w,
              T,
              k,
              O,
              t
            )
          }
        }), I && H && (r({ type: ce, payload: f }), o(f, T));
      } else
        r({
          type: _,
          payload: { [f]: ye(w, [], k, O, t) }
        }), I && H && (r({
          type: ke,
          payload: { accessor: f, message: Re, showError: !0 }
        }), o(f, []));
    },
    handlePhoneInputChange: ({ field: f, cb: w, errorValidators: H, required: b }) => function(O) {
      s({ field: f, cb: w, errorValidators: H, required: b, value: O });
    },
    handleSelectChange: ({ field: f, cb: w }) => function(b) {
      r({ type: ce, payload: f }), r({
        type: _,
        payload: { [f]: ye(w, b, b, t) }
      });
    },
    handleSubmit: a,
    handleSegmentedButtonsClick: ({ field: f, cb: w, required: H }) => function(k) {
      const { submitted: O } = t, I = k;
      if (r({
        type: _,
        payload: {
          [f]: ye(w, k, I, t)
        }
      }), O && H)
        if (!I && !I.length) {
          r({
            type: ke,
            payload: { accessor: f, message: Re, showError: !0 }
          });
          return;
        } else
          r({ type: ce, payload: f });
      o(f, I);
    },
    handleActionCardGroupOnCreateCard: ({ field: f }) => function({ cardData: H, id: b }) {
      const k = t[f];
      r({
        type: _,
        payload: {
          [f]: k.concat({ ...H, id: b })
        }
      });
    },
    handleActionCardGroupOnUpdateCard: ({ field: f }) => function({ cardData: H, id: b }) {
      const k = t[f], O = t.actionCardGroupsInitialState[f], I = {
        ...H,
        id: b
      }, T = O.find(({ id: re }) => re === b), te = k.map((re) => re.id === b ? T && o1(I, T) ? {
        ...I,
        updated: void 0
      } : {
        ...I,
        updated: re.new ? void 0 : !0
      } : re);
      r({
        type: _,
        payload: {
          [f]: te
        }
      });
    },
    handleActionCardGroupOnDeleteCard: ({ field: f }) => function({ id: H }) {
      const b = t[f];
      r({
        type: _,
        payload: {
          [f]: b.filter((k) => k.id !== H)
        }
      });
    },
    handleMaskedInputChange: ({ field: f, cb: w, errorValidators: H, required: b }) => function({ floatValue: O }) {
      s({ field: f, cb: w, errorValidators: H, required: b, value: O });
    }
  };
}, zn = ({ children: r }) => {
  const t = U7(), n = Sn();
  return Pt({ children: r, handlers: t, state: n });
}, G7 = () => ({
  errors: [],
  stateHasChanged: !1,
  submitted: !1,
  required: [],
  errorValidators: [],
  cache: {},
  actionCardGroupsInitialState: {}
});
function z7(r, t) {
  const n = W7(r, t);
  return {
    ...n,
    allFieldsAreValid: n.errors.length < 1
  };
}
function W7(r, t) {
  const { type: n, payload: a } = t;
  switch (console.info(n, a), n) {
    case Al:
      return {
        ...r,
        ...a
      };
    case Hn:
      return {
        ...r,
        submitted: !0,
        errors: [...r.errors, ...a]
      };
    case ce:
      return {
        ...r,
        errors: r.errors.filter(({ accessor: l }) => l !== a)
      };
    case ke:
      return {
        ...r,
        errors: [a, ...r.errors]
      };
    case _:
      return {
        ...r,
        ...a,
        stateHasChanged: !0
      };
    case An:
      return {
        ...r,
        errors: [...r.errors].map(
          (l) => l.accessor === a ? { ...l, showError: !0 } : l
        )
      };
    case Mn:
      return {
        ...r,
        required: a
      };
    case xn:
      return {
        ...r,
        errorValidators: a
      };
    default:
      return r;
  }
}
const j7 = (r, ...t) => N0(r, ...t), X7 = (...r) => R0(...r);
function Wn(r) {
  const t = F2(), n = xe(r.required);
  xe(r.errorValidators), Y(() => {
  }, [r.required]), ee(
    function() {
      const { required: l } = r, o = n.current;
      if (X7(l, o).length) {
        t({ type: Mn, payload: l });
        const c = j7(
          (m, h) => m.field === h.field,
          o,
          l
        );
        c.length && c.forEach(({ field: m }) => {
          t({ type: ce, payload: m });
        });
      }
      n.current = l;
    },
    [r.required]
  );
}
const Y7 = (r, ...t) => N0(r, ...t), Q7 = (...r) => R0(...r);
function K7(r) {
  const t = F2(), n = xe(r.errorValidators);
  ee(
    function() {
      const { errorValidators: l } = r, o = n.current;
      if (Q7(l, o).length) {
        t({ type: xn, payload: l });
        const c = Y7(
          (m, h) => m.field === h.field,
          o,
          l
        );
        c.length && c.forEach(({ field: m }) => {
          t({ type: ce, payload: m });
        });
      }
      n.current = l;
    },
    [r.errorValidators]
  );
}
function D0(r, t, n) {
  var a;
  return function() {
    var l = this, o = arguments, s = function() {
      a = null, n || r.apply(l, o);
    }, d = n && !a;
    clearTimeout(a), a = setTimeout(s, t), d && r.apply(l, o);
  };
}
const J7 = ({ formState: r, updatedFormState: t }) => t ? Object.keys(t).some((n) => t[n] !== r[n]) : !1, q7 = ({ children: r, required: t, errorValidators: n }) => (Wn({ required: t }), K7({ errorValidators: n }), zn({ children: r })), jn = Yt(({ children: r, onFormChange: t, initialState: n, enableOnFormChangeDebounce: a, name: l }) => {
  const o = E1(D0(t, 200), [D0, t]), s = xe(process.env.NODE_ENV === "development"), d = n || {};
  ee(() => {
    s.current && (console.warn(
      `<Form> for ${l} has detected that prop intialState has changed. This is a no-op, as initialState is only checked on component mount. Please only mount <Form> after you have collected initialState.`
    ), s.current = !1);
  }, [n, s]);
  const c = I2(r, {
    ...d,
    required: [],
    errorValidators: [],
    actionCardGroupsInitialState: {}
  }), [m, h] = I3(z7, {
    ...G7(),
    ...c
  });
  return ee(() => {
    if ((m.stateHasChanged || m.submitted) && typeof t == "function") {
      const { cache: p, ...u } = m, C = a ? o(u) : t(u);
      J7({ formState: u, updatedFormState: C }) && h({ type: _, payload: C });
    }
  }, [m]), /* @__PURE__ */ e.createElement(On.Provider, { value: h }, /* @__PURE__ */ e.createElement(Bn.Provider, { value: m }, /* @__PURE__ */ e.createElement(
    q7,
    {
      required: c.required,
      errorValidators: c.errorValidators
    },
    r
  )));
});
jn.propTypes = {
  onFormChange: i.func,
  initialState: i.object,
  enableOnFormChangeDebounce: i.bool,
  name: i.string
};
jn.defaultProps = {
  kind: "form"
};
const $7 = {
  [b2]: ({ value: r }) => r,
  [H2]: (r) => {
    const { value: t } = r;
    return ["string", "number"].includes(typeof t) ? t : t && t.val;
  },
  [tt]: ({ active: r }) => r,
  [x2]: ({ selected: r }) => r,
  [A2]: ({ selected: r }) => r,
  [kn]: ({ active: r }) => r,
  [Dn]: ({ active: r }) => r,
  [V2]: ({ value: r }) => r,
  [M2]: ({ value: r }) => r,
  [Zn]: ({ data: r }) => r,
  [D2]: ({ value: r }) => r
}, _7 = () => {
}, F0 = ({ props: r }) => {
  const { kind: t, name: n } = r;
  return {
    value: ($7[t] || _7)(r),
    name: n
  };
}, Xn = ({ child: r, formerValue: t, hideFormerValue: n }) => {
  const a = typeof t == "string" && !n, l = r.props.kind === tt;
  return /* @__PURE__ */ e.createElement("div", null, r, a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement("div", { style: { display: "flex" } }, l && /* @__PURE__ */ e.createElement(B, { inline: !0, factor: 3 }), /* @__PURE__ */ e.createElement(y, { type: "footnote", testId: "former-value" }, `Former value: ${t}`))));
}, e8 = (r, t, n, a, l, o) => {
  const s = Yn({
    children: r.props.children,
    generateProps: t,
    statusHidesElement: n,
    hasValueChanged: a,
    statusShouldDisableElement: l,
    hideFormerValue: o
  });
  return s && e.cloneElement(r, r.props, s);
};
function Yn({
  children: r,
  generateProps: t,
  statusHidesElement: n,
  hasValueChanged: a,
  statusShouldDisableElement: l,
  hideFormerValue: o
}) {
  let s = !1;
  const d = e.Children.map(r, (c) => {
    if (typeof c == "object") {
      const m = a(c);
      if (c.props.kind === tt) {
        let h = {};
        m ? (s = !0, h = t(c)) : l && (h.readOnly = !0, h.disabled = !0);
        const p = e.cloneElement(
          c,
          {
            ...c.props,
            ...h
          },
          // Checkboxes cannot be children of other Checkboxes
          // so no need to recurse here
          c.props.children
        );
        return Xn({
          hideFormerValue: o,
          formerValue: m,
          child: p
        });
      } else if (c.props.children && c.props.length)
        return e.cloneElement(
          c,
          c.props,
          Yn({
            children: c.props.children,
            generateProps: t,
            statusHidesElement: n,
            hasValueChanged: a
          })
        );
    }
    return c;
  });
  if (!(!s && n))
    return d;
}
const Qn = "in-progress", N2 = "changed-review", H1 = "approval-review", x1 = "approved-review", t8 = [Qn, N2, H1, x1], n8 = {
  [N2]: "changed",
  [H1]: "changed",
  [x1]: "completed"
}, a8 = /* @__PURE__ */ new Set([H1, x1]), r8 = /* @__PURE__ */ new Set([H1, x1]), i8 = /* @__PURE__ */ new Set([N2, H1, x1]);
function Kn({ compareState: r, status: t, formType: n, cardIsNew: a, children: l }) {
  const o = Y(() => a8.has(t), [t]), s = E1(
    (u) => {
      const { value: C, name: E } = F0(u);
      if (!r)
        return {};
      if (!E || !r.hasOwnProperty(E))
        return a && n === "actionCard" ? {
          hasChangedType: "newActionCard",
          disabled: o
        } : {};
      const g = r[E];
      if (Ze(g) && (Ze(C) || Qt(C)))
        return {};
      let L;
      Array.isArray(C) ? C.length !== (g == null ? void 0 : g.length) ? L = !0 : L = !!G3(C, g).length : L = !o1(String(g), String(C));
      const { disabled: x } = u.props;
      return {
        hasChangedType: !x && n8[L && t],
        disabled: x || o,
        formerValue: g
      };
    },
    [r, t, o, a, n]
  ), d = Y(() => n === "actionCard" ? !1 : r8.has(t), [t]), c = Y(() => !i8.has(t), [t]), m = E1(
    (u) => {
      if (!r)
        return;
      const { value: C, name: E } = F0(u), g = r[E];
      if (a && n === "actionCard" && !g)
        return;
      const L = ![void 0, ""].includes(C), x = Array.isArray(C) && C.length === 0;
      return L && !x && r.hasOwnProperty(E) && !o1(String(g), String(C)) && String(g);
    },
    [r, t]
  ), h = E1(
    ({ child: u, injectPropsToChildrenRecursively: C }) => {
      if (u.props.kind === et)
        return e8(
          u,
          s,
          d,
          m,
          o,
          c
        );
      if (u.props.kind === nt)
        return u;
      const E = m(u), { childHasChanged: g } = u.props;
      if (d && typeof m == "function" && !E && !g)
        return;
      const L = s(u);
      L.children = C(
        u.props.children,
        h
      );
      const x = e.cloneElement(u, L);
      return Xn({
        hideFormerValue: c,
        formerValue: E,
        child: x
      });
    },
    [s, d, m]
  );
  return Y(() => Nt(l, h), [l, h]);
}
Kn.propTypes = {
  status: i.oneOf(t8),
  compareState: i.object,
  formType: i.string.isRequired,
  cardIsNew: i.bool
};
Kn.defaultProps = {
  status: Qn,
  formType: "",
  cardIsNew: !1
};
const wh = Yt(({ children: r, initialState: t }) => {
  const a = I2(r, {
    ...t || {},
    required: [],
    errorValidators: []
  });
  return /* @__PURE__ */ e.createElement(l8, { required: a.required }, r);
}), l8 = ({ children: r, required: t }) => (Wn({ required: t }), zn({ children: r })), o8 = "_container_i5f3m_1", s8 = "_top_i5f3m_12", d8 = "_slidedown_i5f3m_1", c8 = "_bottom_i5f3m_17", m8 = "_slideup_i5f3m_1", h8 = "_confirmText_i5f3m_26", p8 = "_colorStrip_i5f3m_30", u8 = "_content_i5f3m_36", C8 = "_dismiss_i5f3m_45", g8 = "_text_i5f3m_51", Ye = {
  container: o8,
  top: s8,
  slidedown: d8,
  bottom: c8,
  slideup: m8,
  confirmText: h8,
  colorStrip: p8,
  content: u8,
  dismiss: C8,
  text: g8
};
class Jn extends N {
  constructor(t) {
    super(t), this.showTimer = null;
  }
  componentDidMount() {
    const { dismiss: t, showTime: n, confirmText: a } = this.props;
    !a && typeof n == "number" && n > 0 && (this.showTimer = setTimeout(() => t(), n * 1e3));
  }
  componentWillUnmount() {
    clearTimeout(this.showTimer);
  }
  renderStrip() {
    const { type: t } = this.props;
    let n;
    switch (t) {
      case "success":
        n = v.statusSuccessColor;
        break;
      case "info":
        n = v.statusPendingColor;
        break;
      case "warning":
        n = v.statusWarningColor;
        break;
      case "danger":
        n = v.statusErrorColor;
        break;
      default:
        n = v.statusPendingColor;
    }
    return /* @__PURE__ */ e.createElement("div", { className: Ye.colorStrip, style: { backgroundColor: n } });
  }
  renderConfirmButton() {
    const { type: t, confirmText: n, dismiss: a } = this.props;
    let l;
    switch (t) {
      case "success":
        l = "success";
        break;
      case "info":
        l = "tip";
        break;
      case "warning":
        l = "caution";
        break;
      case "danger":
        l = "error";
        break;
      default:
        l = "tip";
    }
    return /* @__PURE__ */ e.createElement("div", { className: Ye.confirmText }, /* @__PURE__ */ e.createElement(J, { type: l, size: "sm", onClick: a }, n));
  }
  renderText() {
    const { children: t } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: Ye.text }, /* @__PURE__ */ e.createElement(y, null, t));
  }
  renderIcon() {
    const { type: t } = this.props;
    let n = t, a;
    switch (t) {
      case "success":
        a = v.statusSuccessColor;
        break;
      case "note":
      case "info":
        n = "note", a = v.statusPendingColor;
        break;
      case "warning":
        a = v.statusWarningColor;
        break;
      case "danger":
        a = v.statusErrorColor;
        break;
      default:
        a = v.statusPendingColor;
    }
    return /* @__PURE__ */ e.createElement("span", { style: { pointerEvents: "none" } }, /* @__PURE__ */ e.createElement(V, { type: n, overrideColor: a }));
  }
  render() {
    const { dismiss: t, confirmText: n, position: a, testId: l } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: `${Ye.container} ${Ye[a]}`, "data-testid": l }, this.renderStrip(), /* @__PURE__ */ e.createElement("main", { className: Ye.content }, this.renderIcon(), this.renderText(), n && this.renderConfirmButton(), !n && t && /* @__PURE__ */ e.createElement("div", { className: Ye.dismiss, onClick: t, "data-testid": "global-alert__close" }, /* @__PURE__ */ e.createElement(V, { type: "close", factor: 0.666 }))));
  }
}
Jn.propTypes = {
  type: i.string,
  content: i.string,
  dismiss: i.func,
  showTime: i.number,
  confirmText: i.string,
  position: i.string,
  testId: i.string
};
Jn.defaultProps = {
  type: "tip",
  dismiss: () => {
  },
  position: "top",
  testId: "volt-global-alert"
};
const f8 = "_container_1xkhj_1", E8 = "_iconWrapper_1xkhj_13", L8 = "_infoIconWrapper_1xkhj_17", w8 = "_dangerIconWrapper_1xkhj_22", v8 = "_top_1xkhj_26", y8 = "_confirmText_1xkhj_30", b8 = "_colorStrip_1xkhj_35", A8 = "_content_1xkhj_41", H8 = "_dismiss_1xkhj_50", x8 = "_text_1xkhj_55", M8 = "_fullHeight_1xkhj_62", V8 = "_zeroHeight_1xkhj_66", be = {
  container: f8,
  iconWrapper: E8,
  infoIconWrapper: L8,
  dangerIconWrapper: w8,
  top: v8,
  confirmText: y8,
  colorStrip: b8,
  content: A8,
  dismiss: H8,
  text: x8,
  fullHeight: M8,
  zeroHeight: V8
}, D8 = "danger", k0 = "info";
class qn extends N {
  constructor(t) {
    super(t), this.showTimer = null;
  }
  /* eslint-disable-next-line react/no-deprecated */
  componentWillReceiveProps(t) {
    const { mounted: n, confirmText: a, showTime: l, dismiss: o } = this.props;
    t.mounted && !n && !a && typeof l == "number" && l > 0 ? this.showTimer = setTimeout(() => o(), l * 1e3) : !t.mounted && n && clearTimeout(this.showTimer);
  }
  componentWillUnmount() {
    clearTimeout(this.showTimer);
  }
  getIcon() {
    const { type: t } = this.props;
    switch (t) {
      case D8:
        return /* @__PURE__ */ e.createElement("span", { className: `${be.iconWrapper} ${be.dangerIconWrapper}` }, /* @__PURE__ */ e.createElement(V, { type: "danger", mod: "error", noHoverEffects: !0, factor: 0 }));
      case k0:
      default:
        return /* @__PURE__ */ e.createElement("span", { className: `${be.iconWrapper} ${be.infoIconWrapper}` }, /* @__PURE__ */ e.createElement(V, { type: "infoUpsideDown", mod: "active-blue", noHoverEffects: !0, factor: 1 }));
    }
  }
  renderConfirmButton() {
    const { confirmText: t, dismiss: n, type: a } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: `${be.confirmText} ${be.dismiss}` }, a === k0 && /* @__PURE__ */ e.createElement(y, { onClick: n, color: v.actionColorLighter1 }, t));
  }
  renderText() {
    const { children: t } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: be.text }, /* @__PURE__ */ e.createElement(y, { color: v.blackLighter8 }, t));
  }
  render() {
    const { confirmText: t, testId: n, mounted: a } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${be.container} ${be.top}`,
        style: { backgroundColor: v.blackLighter2, maxHeight: a ? "100px" : 0 },
        "data-testid": n
      },
      /* @__PURE__ */ e.createElement("main", { className: be.content }, this.getIcon(), this.renderText(), t && this.renderConfirmButton())
    );
  }
}
qn.propTypes = {
  type: i.string,
  content: i.string,
  dismiss: i.func,
  showTime: i.number,
  confirmText: i.string,
  testId: i.string,
  mounted: i.bool
};
qn.defaultProps = {
  type: "tip",
  dismiss: () => {
  },
  testId: "volt-global-alert",
  mounted: !1
};
const F8 = "_nodeContainer_19hbv_1", k8 = "_nodeLine_19hbv_6", Z8 = "_nodeConnectorWrapper_19hbv_17", B8 = "_nodeConnector_19hbv_17", O8 = "_nodePoint_19hbv_39", p1 = {
  nodeContainer: F8,
  nodeLine: k8,
  nodeConnectorWrapper: Z8,
  nodeConnector: B8,
  nodePoint: O8
};
function it({
  children: r,
  testId: t,
  nodePointBorderColor: n,
  dotClassName: a,
  vlineClassName: l,
  vspace: o
}) {
  const s = {
    border: `1px solid ${n}`
  }, d = `${a} ${p1.nodePoint}`, c = `${l} ${p1.nodeConnectorWrapper}`;
  return /* @__PURE__ */ e.createElement("div", { "data-testid": t, className: p1.nodeContainer }, /* @__PURE__ */ e.createElement("div", { className: p1.nodeLine }, /* @__PURE__ */ e.createElement("div", { className: d, style: s }), /* @__PURE__ */ e.createElement("div", { className: c, "data-testid": `timelinenode-line-${t}` })), /* @__PURE__ */ e.createElement(B, { factor: 1.25 }), /* @__PURE__ */ e.createElement("div", { className: p1.childrenContainer }, r, /* @__PURE__ */ e.createElement(F, { factor: o })));
}
it.propTypes = {
  children: i.oneOfType([i.element, i.array]),
  testId: i.string,
  nodePointBorderColor: i.string,
  dotClassName: i.string,
  vlineClassName: i.string,
  vspace: i.number
};
it.defaultProps = {
  children: /* @__PURE__ */ e.createElement(e.Fragment, null),
  nodePointBorderColor: "#fff",
  testId: "base-timeline",
  dotClassName: "",
  vlineClassName: "",
  vspace: 2.75
};
const S8 = {
  label: i.string,
  description: i.string,
  email: i.string,
  timestamp: i.string
}, fe = {
  SMALL: "small",
  LARGE: "large"
}, I8 = "View full history", P8 = "History", N8 = 3, R8 = 2, T8 = 1, U8 = "_historyWrapper_11ayn_1", G8 = "_historyContent_11ayn_2", z8 = "_historyItem_11ayn_3", W8 = "_historyItemLabel_11ayn_14", j8 = "_historyItemDescription_11ayn_15", X8 = "_historyItemAdditionalInfo_11ayn_27", Y8 = "_separartedTimestamp_11ayn_33", Q8 = "_firstHistoryDot_11ayn_46", K8 = "_fullHistoryLink_11ayn_86", J8 = "_verticalLine_11ayn_90", q8 = "_largeHistory_11ayn_101", he = {
  historyWrapper: U8,
  historyContent: G8,
  historyItem: z8,
  historyItemLabel: W8,
  historyItemDescription: j8,
  historyItemAdditionalInfo: X8,
  separartedTimestamp: Y8,
  firstHistoryDot: Q8,
  fullHistoryLink: K8,
  verticalLine: J8,
  largeHistory: q8
}, $8 = (r, t) => r === fe.SMALL && {
  wordWrap: "break-word",
  maxWidth: t ? "none" : "316px"
}, l1 = ({ data: r, className: t, vspacer: n = !0 }) => r ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t && t }, r), n && /* @__PURE__ */ e.createElement(F, { factor: 0.5 })) : null, _8 = ({ email: r, timestamp: t }) => /* @__PURE__ */ e.createElement("div", { className: he.historyItemAdditionalInfo }, /* @__PURE__ */ e.createElement(l1, { data: r, vspacer: !1 }), r && t && /* @__PURE__ */ e.createElement("div", { style: { padding: "0 3px" } }, "•"), /* @__PURE__ */ e.createElement(l1, { data: N1(t), vspacer: !1 })), e9 = ({ label: r, description: t, email: n, timestamp: a, testId: l, mode: o, fullWidth: s }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: he.historyItem,
    "data-testid": `${l}-historyItem`,
    style: { ...$8(o, s) }
  },
  r ? /* @__PURE__ */ e.createElement(l1, { data: r, className: he.historyItemLabel }) : null,
  t ? /* @__PURE__ */ e.createElement(l1, { data: t, className: he.historyItemDescription }) : null,
  o === fe.LARGE ? /* @__PURE__ */ e.createElement(l1, { data: n, vspacer: !1, className: he.historyItemAdditionalInfo }) : /* @__PURE__ */ e.createElement(_8, { email: n, timestamp: a })
), t9 = ({ testId: r, dataItem: t, mode: n, i: a, fullWidth: l }) => {
  const o = (d) => n === fe.LARGE ? N8 : d.description ? R8 : T8, s = a === 0 ? he.firstHistoryDot : "";
  return /* @__PURE__ */ e.createElement("div", { style: { display: "flex" }, "data-testid": `${r}-historyItemWrapper-${a}` }, n === fe.LARGE && /* @__PURE__ */ e.createElement(
    l1,
    {
      className: he.separartedTimestamp,
      data: N1(t.timestamp),
      vspacer: !1
    }
  ), /* @__PURE__ */ e.createElement(
    it,
    {
      testId: `${r}-timelineNode`,
      key: `${t.label}-node-${a}`,
      dotClassName: s,
      vlineClassName: he.verticalLine,
      vspace: o(t)
    },
    /* @__PURE__ */ e.createElement(e9, { mode: n, testId: r, ...t, fullWidth: l })
  ));
}, n9 = ({ label: r, mode: t, testId: n }) => {
  let a = P8, l = 2, o = he.labelPadding, s = "h5";
  return r && (a = `${r}`), t === fe.LARGE && (l = 3, o = "", s = "h3"), /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(y, { className: o, type: s, testId: `${n}-label` }, a), /* @__PURE__ */ e.createElement(F, { factor: l }));
}, a9 = ({ testId: r, data: t, mode: n, fullWidth: a }) => /* @__PURE__ */ e.createElement("div", { className: he.historyContent, "data-testid": `${r}-content` }, t.map((l, o) => /* @__PURE__ */ e.createElement(
  t9,
  {
    key: o,
    i: o,
    dataItem: l,
    mode: n,
    testId: r,
    fullWidth: a
  }
))), r9 = ({ mode: r, data: t, viewFullHistoryHandler: n, showFullHistory: a, viewAllText: l }) => {
  let o = r === fe.SMALL && t.length > 7;
  return a !== void 0 && (o = r === fe.SMALL && a), o && /* @__PURE__ */ e.createElement(Ne, { onClick: n, className: he.fullHistoryLink }, l || I8);
}, $n = (r) => {
  const { data: t, testId: n, mode: a, hideHeader: l } = r;
  if (t.length === 0)
    return null;
  let o = he.historyWrapper;
  return a === fe.LARGE && (o += " " + he.largeHistory), /* @__PURE__ */ e.createElement("div", { className: o, "data-testid": n }, !l && /* @__PURE__ */ e.createElement(n9, { ...r }), /* @__PURE__ */ e.createElement(a9, { ...r }), /* @__PURE__ */ e.createElement(r9, { ...r }));
};
$n.propTypes = {
  data: i.arrayOf(
    i.shape({
      ...S8
    })
  ),
  hideHeader: i.bool,
  testId: i.string,
  label: i.string,
  mode: i.oneOf([fe.SMALL, fe.LARGE]),
  showFullHistory: i.bool,
  viewFullHistoryHandler: i.func,
  viewAllText: i.string,
  fullWidth: i.bool
};
$n.defaultProps = {
  data: [],
  testId: "volt-history-component",
  label: "",
  hideHeader: !1,
  mode: fe.SMALL,
  viewAllText: "",
  fullWidth: !1
};
const i9 = "_tooltip_r39mc_1", l9 = "_tooltipBubble_r39mc_6", o9 = "_fixedRight_r39mc_18", s9 = "_tooltipContent_r39mc_23", d9 = "_topSection__wrapper_r39mc_28", c9 = "_topSection_r39mc_28", m9 = "_topSection__content_r39mc_39", h9 = "_topSection__content__item_r39mc_43", p9 = "_bottomSection_r39mc_49", Ae = {
  tooltip: i9,
  tooltipBubble: l9,
  fixedRight: o9,
  tooltipContent: s9,
  topSection__wrapper: d9,
  topSection: c9,
  topSection__content: m9,
  topSection__content__item: h9,
  bottomSection: p9
}, _n = ({ body: r, children: t, fixedDirection: n }) => {
  const [a, l] = z(!1);
  return /* @__PURE__ */ e.createElement("div", { className: Ae.tooltip, onMouseLeave: () => l(!1), "data-testid": "hover-card" }, a && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: M(Ae.tooltipBubble, { [Ae.fixedRight]: n === "right" }),
      "data-testid": "hover-card-body"
    },
    r
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: Ae.tooltipContent,
      onMouseEnter: () => l(!0),
      "data-testid": "hover-card-children"
    },
    t
  ));
};
_n.propTypes = {
  body: i.any,
  children: i.any,
  fixedDirection: i.string
};
_n.defaultProps = {
  body: null,
  children: null,
  fixedDirection: "left"
};
const lt = ({
  label: r,
  leftPart: t,
  rightPart: n,
  bottomLabel: a,
  bottomLabelHandler: l,
  type: o
}) => {
  const s = o === "card" ? { minWidth: 352 } : {};
  return /* @__PURE__ */ e.createElement("div", { className: Ae.topSection__wrapper, style: s }, /* @__PURE__ */ e.createElement("section", { className: Ae.topSection }, /* @__PURE__ */ e.createElement("span", { className: "topSection__label" }, /* @__PURE__ */ e.createElement(y, { type: "h5", testId: "hovercard-label" }, r)), /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement("div", { className: Ae.topSection__content, style: { justifyContent: "space-between" } }, t && /* @__PURE__ */ e.createElement("span", { className: Ae.topSection__content__item, "data-testid": "hovercard-leftPart" }, t), /* @__PURE__ */ e.createElement("span", { className: Ae.topSection__content__item, "data-testid": "hovercard-rightPart" }, n))), /* @__PURE__ */ e.createElement("section", { className: Ae.bottomSection }, /* @__PURE__ */ e.createElement(Ne, { onClick: l, testId: "hovercard-bottomLink" }, a)));
};
lt.propTypes = {
  links: i.array,
  testId: i.string,
  label: i.string,
  leftPart: i.any,
  rightPart: i.any,
  bottomLabel: i.string,
  bottomLabelHandler: i.func,
  type: i.oneOf(["card", "profile"])
};
lt.defaultProps = {
  bottomLabelHandler: () => {
  },
  type: "card"
};
const e3 = ({
  last_four: r,
  status: t,
  cvv: n,
  expiration_date: a,
  bottomLabel: l,
  bottomLabelHandler: o
}) => {
  const s = `Card ••${r}`, d = /* @__PURE__ */ e.createElement(ct, { status: t }), c = /* @__PURE__ */ e.createElement(e.Fragment, null, n && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(y, null, `CVV: ${n || "•••"}`), /* @__PURE__ */ e.createElement(B, { factor: 2 })), /* @__PURE__ */ e.createElement(y, null, `Exp: ${a}`));
  return /* @__PURE__ */ e.createElement(
    lt,
    {
      label: s,
      leftPart: d,
      rightPart: c,
      bottomLabel: l,
      bottomLabelHandler: o,
      type: "card"
    }
  );
};
e3.propTypes = {
  last_four: i.string,
  status: i.string,
  cvv: i.string,
  expiration_date: i.string,
  bottomLabel: i.string,
  bottomLabelHandler: i.func
};
e3.defaultProps = {
  last_four: "••••",
  bottomLabel: "View card",
  bottomLabelHandler: () => {
  }
};
const u9 = (r) => {
  if (!r)
    return r;
  const t = r.toString().replace(/\D+/g, "");
  if (t && t.length === 11 && t[0] === "1") {
    const n = t.slice(0, 1), a = t.slice(1, 4), l = t.slice(4, 7), o = t.slice(7, 11);
    return `+${n} ${a} ${l} ${o}`;
  }
  return r;
}, t3 = ({ cardholder: r, phone: t, location: n, bottomLabel: a, bottomLabelHandler: l }) => {
  const o = t && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: "cellphone", noHoverEffects: !0, style: { paddingLeft: 3 } }), /* @__PURE__ */ e.createElement(B, { factor: 0.875 }), /* @__PURE__ */ e.createElement(y, { testId: "cardhover-phone" }, u9(t))), s = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: "location", noHoverEffects: !0, factor: 1, style: { marginLeft: -3 } }), /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { testId: "cardhover-location" }, n));
  return /* @__PURE__ */ e.createElement(
    lt,
    {
      label: r,
      leftPart: o,
      rightPart: s,
      bottomLabel: a,
      bottomLabelHandler: l,
      type: "profile"
    }
  );
};
t3.propTypes = {
  cardholder: i.string,
  phone: i.string,
  location: i.string,
  bottomLabel: i.string,
  bottomLabelHandler: i.func
};
t3.defaultProps = {
  cardholder: "",
  bottomLabel: "View profile",
  bottomLabelHandler: () => {
  }
};
class R2 extends N {
  // Hr margin is factors of 8px
  render() {
    const { blackLighter6: t } = v, { factor: n, testId: a } = this.props, l = {
      margin: `${n * 8}px 0px`,
      border: "none",
      borderTop: `1px solid ${t}`
    };
    return /* @__PURE__ */ e.createElement("hr", { "data-testid": a, style: l });
  }
}
R2.propTypes = {
  factor: i.number,
  testId: i.string
};
R2.defaultProps = {
  factor: 1,
  testId: "volt-hr"
};
const C9 = R2, vh = {
  fillStyleIcons: [...Object.keys(g1)],
  customStyleIcons: [...Object.keys(Ft)]
}, g9 = {
  emptyError: "data:image/png;base64,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",
  generalError: "data:image/png;base64,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"
}, n3 = ({ alt: r, type: t, height: n, width: a }) => /* @__PURE__ */ e.createElement("img", { src: g9[t], width: a, height: n, alt: r || t });
n3.propTypes = {
  height: i.number,
  width: i.number,
  alt: i.string.isRequired,
  type: i.string.isRequired
};
n3.defaultProps = {
  height: "auto",
  width: "auto"
};
const f9 = "_wrap_1qy7z_33", E9 = "_disabled_1qy7z_43", L9 = "_inputFirst_1qy7z_47", w9 = "_selectWrap_1qy7z_47", v9 = "_selectFirst_1qy7z_53", y9 = "_inputWrap_1qy7z_59", t1 = {
  wrap: f9,
  disabled: E9,
  inputFirst: L9,
  selectWrap: w9,
  selectFirst: v9,
  inputWrap: y9
}, b9 = {
  width: "100%",
  left: 0
}, a3 = ({
  classes: r,
  className: t,
  disabled: n,
  error: a,
  id: l,
  label: o,
  labelProps: s,
  onChange: d,
  selectWidth: c,
  testId: m,
  children: h
}) => {
  const p = [], u = [], C = {
    input: "",
    select: ""
  };
  let E = null, g = null, L = a, x = !1;
  const A = (w) => ["input", "maskedInput"].includes(w), Z = (w, H) => (b) => {
    const k = A(w) ? b.target.value : b;
    d({
      ...C,
      [w]: k
    }), typeof H == "function" && H(b);
  }, D = e.Children.map(h, (w) => {
    if (!e.isValidElement(w))
      return w;
    p.push(w.props.kind);
    const H = w.props.error;
    H && u.push(H), L = L || u[0];
    const { kind: b } = w.props;
    return !E && A(b) ? (E = w, C.input = w.props.value, x = w.props.disabled, /* @__PURE__ */ e.createElement("div", { className: M(t1.inputWrap, r.inputWrap) }, e.cloneElement(w, {
      ...w.props,
      onChange: Z(b, w.props.onChange),
      testId: `${m}-inputText`,
      disabled: n || w.props.disabled,
      error: L,
      id: l
    }))) : !g && b === "select" ? (g = w, C.select = w.props.value, /* @__PURE__ */ e.createElement(
      "div",
      {
        id: "inputAdditionalSelect",
        className: M(t1.selectWrap, r.selectWrap),
        style: { width: c }
      },
      e.cloneElement(w, {
        ...w.props,
        onChange: Z(b, w.props.onChange),
        testId: `${m}-select`,
        dropDownWrap: Qt(w.props.dropDownWrap) ? b9 : w.props.dropDownWrap,
        disabled: n || w.props.disabled,
        error: L
      })
    )) : w;
  }), [f] = p;
  return /* @__PURE__ */ e.createElement("div", { className: t, "data-testid": m }, o && /* @__PURE__ */ e.createElement(
    ue,
    {
      className: r.formLabel,
      disabled: n,
      labelFor: l,
      testId: `${m}-label`,
      error: L,
      ...s
    },
    o
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M(
        t1.wrap,
        { [t1.disabled]: n || x },
        { [t1.inputFirst]: A(f) },
        { [t1.selectFirst]: f === "select" },
        r.wrap
      )
    },
    D
  ), L && /* @__PURE__ */ e.createElement(ae, { testId: `${m}-error` }, L));
};
a3.propTypes = {
  label: i.string,
  labelProps: i.shape(),
  classes: i.shape({
    error: i.string,
    formLabel: i.string,
    selectWrap: i.string,
    inputWrap: i.string,
    wrap: i.string
  }),
  className: i.string,
  id: i.string,
  onChange: i.func,
  selectWidth: i.oneOfType([i.string, i.number]),
  testId: i.string,
  children: i.arrayOf((r, t, n, a, l) => {
    if (!/input|select/.test(r[t].props.kind))
      return new Error(`
        Invalid prop ${l} supplied to ${n}.
        Available children components: Input and Select
      `);
  }).isRequired
};
a3.defaultProps = {
  classes: {},
  disabled: !1,
  id: "InputSelectGroup",
  onChange: () => {
  },
  testId: "InputSelectGroup",
  selectWidth: "90px"
};
const A9 = "_label_1y6fb_1", H9 = "_primary_1y6fb_14", x9 = "_error_1y6fb_19", M9 = "_disabled_1y6fb_24", V9 = "_success_1y6fb_31", D9 = "_outline_1y6fb_36", F9 = "_gray_1y6fb_43", Z0 = {
  label: A9,
  primary: H9,
  error: x9,
  disabled: M9,
  success: V9,
  outline: D9,
  gray: F9
};
class r3 extends N {
  render() {
    const { children: t, type: n, style: a, testId: l } = this.props;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${Z0.label} ${Z0[n] || ""}`,
        style: a,
        "data-testid": l
      },
      t
    );
  }
}
r3.propTypes = {
  type: i.string,
  style: i.object,
  testId: i.string
};
r3.defaultProps = {
  type: "primary",
  style: {},
  testId: "volt-label"
};
const k9 = "_tooltipWrapper_5lxb9_1", Z9 = "_content_5lxb9_9", B9 = "_rowItem_5lxb9_13", O9 = "_label_5lxb9_13", S9 = "_columnItem_5lxb9_18", u1 = {
  tooltipWrapper: k9,
  content: Z9,
  rowItem: B9,
  label: O9,
  columnItem: S9
}, T2 = (r) => {
  const {
    tooltip: t,
    idPrefix: n,
    label: a,
    className: l,
    flexDirection: o,
    formElementId: s,
    children: d,
    testId: c,
    htmlId: m
  } = r, h = E2(a, n, m), p = e.Children.map(d, (E) => typeof E == "string" ? /* @__PURE__ */ e.createElement(y, { labelledBy: h }, E) : e.cloneElement(
    E,
    {
      ...E.props,
      labelledBy: h
    },
    E.props.children
  )), u = o === "row" && s ? "center" : "flex-start", C = M(
    l,
    o === "row" ? u1.rowItem : u1.columnItem
  );
  return /* @__PURE__ */ e.createElement(P, { flexDirection: o, className: C, testId: c }, /* @__PURE__ */ e.createElement("div", { className: u1.label, style: { alignSelf: u } }, /* @__PURE__ */ e.createElement(P, { display: "flex" }, s ? /* @__PURE__ */ e.createElement(
    ue,
    {
      testId: `form-label-${h}`,
      labelFor: s,
      isHorizontalLabel: o === "row"
    },
    a
  ) : /* @__PURE__ */ e.createElement(y, { id: h, type: "h6", inline: !0 }, a), t && /* @__PURE__ */ e.createElement("span", { className: u1.tooltipWrapper }, /* @__PURE__ */ e.createElement(Me, { content: t, direction: "topRight", textWrap: !0 }, /* @__PURE__ */ e.createElement(V, { type: "info", hasTooltip: !0 }))))), o === "column" && /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement("div", { className: u1.content }, p));
};
T2.defaultProps = {
  className: "",
  flexDirection: "row",
  idPrefix: "",
  testId: "volt-labeled-content"
};
T2.propTypes = {
  tooltip: i.any,
  className: i.string,
  flexDirection: i.string,
  formElementId: i.string,
  testId: i.string,
  children: i.any,
  label: i.string,
  idPrefix: i.string
};
const I9 = "_link_1ulrr_1", P9 = "_right_1ulrr_13", N9 = "_left_1ulrr_17", R9 = "_primary_1ulrr_21", T9 = "_secondary_1ulrr_25", U9 = "_pillHover_1ulrr_29", G9 = "_inheritParentFont_1ulrr_34", z9 = "_inline_1ulrr_40", W9 = "_disabled_1ulrr_88", Qe = {
  link: I9,
  right: P9,
  left: N9,
  primary: R9,
  secondary: T9,
  pillHover: U9,
  inheritParentFont: G9,
  inline: z9,
  disabled: W9
}, j9 = {
  primary: {
    default: v.actionColor,
    hover: v.actionColorDarker1,
    disabled: v.blackLighter5
  },
  secondary: {
    default: v.blackLighter3,
    hover: v.blackLighter4,
    disabled: v.blackLighter5
  }
}, U2 = (r) => {
  const {
    disabled: t,
    children: n,
    className: a,
    external: l,
    href: o,
    iconType: s,
    iconDirection: d,
    inheritParentFont: c,
    inline: m,
    newTab: h,
    onClick: p,
    pillHover: u,
    tabIndex: C,
    testId: E,
    type: g
  } = r, [L, x] = z(!1), A = () => {
    t || p && p();
  }, Z = () => {
    if (!l && !s)
      return null;
    const f = j9[g][t ? "disabled" : L ? "hover" : "default"];
    return /* @__PURE__ */ e.createElement(V, { type: s || "new-tab", overrideColor: f, noHoverEffects: !0 });
  }, D = M(Qe.link, Qe[g], Qe[d], a, {
    [Qe.inline]: m,
    [Qe.disabled]: t,
    [Qe.inheritParentFont]: c,
    [Qe.pillHover]: u
  });
  return /* @__PURE__ */ e.createElement(
    "a",
    {
      tabIndex: C,
      href: o && !t ? o : null,
      target: h || l ? "_blank" : null,
      rel: h || l ? "noopener noreferrer" : null,
      onClick: A,
      className: D,
      "data-testid": E,
      disabled: t,
      onMouseOver: () => x(!0),
      onMouseOut: () => x(!1)
    },
    n,
    n && /* @__PURE__ */ e.createElement(B, { factor: 0.5, inline: !0 }),
    Z()
  );
};
U2.propTypes = {
  type: i.oneOf(["primary", "secondary"]),
  className: i.string,
  external: i.bool,
  disabled: i.bool,
  href: i.string,
  iconType: i.string,
  newTab: i.bool,
  inline: i.bool,
  onClick: i.func,
  testId: i.string,
  inheritParentFont: i.bool,
  tabIndex: i.number,
  iconDirection: i.string,
  pillHover: i.bool
};
U2.defaultProps = {
  type: "primary",
  className: "",
  disabled: !1,
  external: !1,
  href: "",
  iconType: "",
  inline: !1,
  onClick: () => {
  },
  newTab: !1,
  testId: "volt-link",
  inheritParentFont: !1,
  tabIndex: 0,
  iconDirection: "right",
  pillHover: !1
};
const Ne = e.memo(U2), bt = (r) => ({ ...r, voltRowId: Pe("volt-list-expanded-row") }), X9 = (r) => {
  const t = { ...r };
  return delete t.voltRowId, t;
}, Y9 = (r, t) => ({
  id: "expandable",
  caret: !0,
  width: 32,
  minWidth: 32,
  maxWidth: 32,
  renderer: ({ rowData: n }) => {
    const { row: a } = n || {}, l = t(a) ? "caret-down" : "caret-right";
    return /* @__PURE__ */ e.createElement(V, { type: l, onClick: () => r(a) });
  }
}), Ke = (r) => r && r.val ? r.val : typeof r == "number" || typeof r == "string" ? r : "", At = (r = {}, t = "width", n) => r[t] ? r[t] : r.renderer === "amount" ? "1%" : n, B0 = (r = {}, t = 1) => {
  const n = `${100 / t}%`;
  return {
    width: At(r, "width", n),
    minWidth: At(r, "minWidth"),
    maxWidth: At(r, "maxWidth")
  };
}, Q9 = "_fullWidth_rtkpg_1", K9 = "_scrollableContainer_rtkpg_5", J9 = "_listContainer_rtkpg_9", q9 = "_listHeader_rtkpg_15", $9 = "_stickyHeader_rtkpg_27", _9 = "_listHeaderCell_rtkpg_41", eo = "_listCaretCell_rtkpg_42", to = "_listRowHoverable_rtkpg_47", no = "_listRow_rtkpg_47", ao = "_listSummaryRow_rtkpg_56", ro = "_expandedListRow_rtkpg_64", io = "_expandedCaretCell_rtkpg_71", lo = "_listCell_rtkpg_76", oo = "_expandedListCell_rtkpg_83", so = "_tooltip_rtkpg_110", co = "_overflowEllipsis_rtkpg_115", $ = {
  fullWidth: Q9,
  scrollableContainer: K9,
  listContainer: J9,
  listHeader: q9,
  stickyHeader: $9,
  listHeaderCell: _9,
  listCaretCell: eo,
  listRowHoverable: to,
  listRow: no,
  listSummaryRow: ao,
  expandedListRow: ro,
  expandedCaretCell: io,
  listCell: lo,
  expandedListCell: oo,
  tooltip: so,
  overflowEllipsis: co
}, i3 = ({
  className: r,
  columns: t,
  orderBy: n,
  sortDirection: a,
  sorter: l,
  rows: o,
  expandedRows: s,
  toggleExpand: d
}) => {
  const c = (m) => {
    const { id: h, sort: p, label: u, caret: C, tooltip: E, renderer: g } = m, L = n === h, x = {
      ...B0(m, t.length),
      cursor: p ? "pointer" : "default"
    }, Z = o.length !== 0 && o.length === s.length ? "caret-down" : "caret-right", D = typeof g == "string" || typeof g == "number" ? g : "custom";
    return /* @__PURE__ */ e.createElement(
      "th",
      {
        key: h,
        style: x,
        "data-component-renderer": D,
        className: M(`column-${h}`, C ? $.listCaretCell : $.listHeaderCell),
        onClick: p ? () => l(m) : null
      },
      C ? /* @__PURE__ */ e.createElement(V, { type: Z, onClick: d }) : /* @__PURE__ */ e.createElement(y, { type: "label", inline: !0 }, u, E && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(Me, { direction: "topLeft", className: $.tooltip, ...E }, /* @__PURE__ */ e.createElement(V, { type: "info", noHoverEffects: !0 }))), L && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(B, { factor: 0.5 }), /* @__PURE__ */ e.createElement(V, { type: a === "ASC" ? "caret-up" : "caret-down", noHoverEffects: !0 })))
    );
  };
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("colgroup", null, t.map((m) => /* @__PURE__ */ e.createElement("col", { key: Pe("vol-list-col"), style: B0(m, t.length) }))), /* @__PURE__ */ e.createElement("thead", { className: M($.listHeader, r) }, /* @__PURE__ */ e.createElement("tr", null, t.map(c))));
};
i3.propTypes = {
  className: i.string,
  columns: i.arrayOf(
    i.shape({
      id: i.string,
      sort: i.bool,
      label: i.string,
      caret: i.bool,
      width: i.oneOfType([i.string, i.number]),
      minWidth: i.oneOfType([i.string, i.number]),
      tooltip: i.object
    })
  ),
  orderBy: i.string,
  sortDirection: i.string,
  sorter: i.func,
  rows: i.arrayOf(i.object),
  expandedRows: i.arrayOf(i.string),
  toggleExpand: i.func
};
const l3 = e.memo(() => /* @__PURE__ */ e.createElement(y, { type: "body-sm", color: v.blackLighter5 }, "None")), Ht = ({ children: r, className: t, cellOverflowEllipsis: n, ...a }) => {
  if (!r && r !== 0)
    return /* @__PURE__ */ e.createElement(l3, null);
  const l = M(n ? $.overflowEllipsis : void 0, t);
  return /* @__PURE__ */ e.createElement(y, { ...a, className: l }, r);
}, mo = (r) => {
  const { children: t } = r;
  return !t && t !== 0 ? /* @__PURE__ */ e.createElement(l3, null) : /* @__PURE__ */ e.createElement(y1, { fixOverflow: !0, ...r });
}, ho = ["toggle", "link", "copy", "custom", "custom-cell"], o3 = ({ cell: r = {}, column: t = {}, rowData: n = {}, cellOverflowEllipsis: a }) => {
  const l = {
    value: Ht,
    amount: Ht,
    icon: V,
    toggle: F3,
    link: Ne,
    copy: mo
  }, o = r && r.props || {}, s = Ke(r);
  t.onClick && (o.onClick = (m) => t.onClick(n, m));
  const d = (r || {}).renderer || t.renderer;
  if (typeof d == "function") {
    const m = d({ val: s, props: o, rowData: n });
    return m === void 0 ? null : m;
  }
  o.cellOverflowEllipsis = a;
  const c = l[d] || Ht;
  return /* @__PURE__ */ e.createElement(c, { ...o }, s);
};
o3.propTypes = {
  cell: i.oneOfType([i.object, i.string, i.number]),
  column: i.object,
  rowData: i.object,
  cellOverflowEllipsis: i.bool
};
const po = ({ onRowClick: r, rowIndex: t, row: n, columns: a, expandable: l, cellOverflowEllipsis: o }) => {
  const s = M($.listRow, {
    [$.listRowHoverable]: !!r && !l
  }), d = (c, m) => {
    if (l)
      return;
    const h = c.target.closest("td"), p = ho.includes(h.dataset.componentRenderer);
    typeof r == "function" && (!p || c.target.tagName === "TD") && r({ e: c, rowIndex: m });
  };
  return /* @__PURE__ */ e.createElement("tr", { className: s, onClick: (c) => d(c, t) }, a.map((c, m) => {
    const { id: h, caret: p, renderer: u } = c, C = n[h], E = { row: n, columnIndex: m, rowIndex: t }, g = C && C.renderer ? "custom-cell" : typeof u == "string" || typeof u == "number" ? u : "custom", L = M(`cell-${h}`, p ? $.listCaretCell : $.listCell, {
      [$.expandedListCell]: l
    });
    return /* @__PURE__ */ e.createElement(
      "td",
      {
        key: `volt-list-cell-${m}-${t}`,
        className: L,
        "data-component-renderer": g
      },
      /* @__PURE__ */ e.createElement(
        o3,
        {
          cell: C,
          rowData: E,
          column: c,
          cellOverflowEllipsis: o
        }
      )
    );
  }));
}, uo = ({ row: r, expandedContent: t, colSpan: n }) => /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: $.expandedCaretCell }), /* @__PURE__ */ e.createElement("td", { className: $.expandedListRow, colSpan: n - 1 }, t(r))), G2 = ({
  columns: r,
  onRowClick: t,
  rows: n,
  expandedRows: a,
  expandedContent: l,
  cellOverflowEllipsis: o
}) => {
  const s = typeof l == "function";
  return /* @__PURE__ */ e.createElement("tbody", null, n.map((d, c) => {
    const m = s && a.indexOf(d.voltRowId) > -1;
    return /* @__PURE__ */ e.createElement(Wt, { key: `volt-list-row-${c}` }, /* @__PURE__ */ e.createElement(
      po,
      {
        row: d,
        rowIndex: c,
        columns: r,
        onRowClick: t,
        expandable: s,
        cellOverflowEllipsis: o
      }
    ), m && /* @__PURE__ */ e.createElement(uo, { row: d, colSpan: r.length, expandedContent: l }));
  }));
};
G2.propTypes = {
  columns: i.arrayOf(i.object),
  onRowClick: i.func,
  rows: i.arrayOf(i.object),
  expandedRows: i.arrayOf(i.string),
  cellOverflowEllipsis: i.bool
};
G2.defaultProps = {
  rows: [],
  columns: []
};
const Co = e.memo(({ active: r, colSpan: t }) => r ? /* @__PURE__ */ e.createElement("tbody", null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { colSpan: t }, /* @__PURE__ */ e.createElement(F, { factor: 7 }), /* @__PURE__ */ e.createElement(ze, { active: !0 }), /* @__PURE__ */ e.createElement(F, { factor: 7 })))) : null), go = ({ isFiltered: r, onClick: t }) => typeof t != "function" ? null : /* @__PURE__ */ e.createElement(J, { onClick: t, type: "tertiary" }, r ? "Clear filters" : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(V, { type: "plus" }), /* @__PURE__ */ e.createElement(B, null), "Create")), fo = ({ active: r, onResetList: t, colSpan: n, isFiltered: a, onCreateItem: l, ...o }) => {
  if (!r)
    return null;
  const s = a ? "No results found" : "No blank for this section yet", d = /* @__PURE__ */ e.createElement(go, { isFiltered: a, onClick: a ? t : l });
  return /* @__PURE__ */ e.createElement("tbody", null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { colSpan: n }, /* @__PURE__ */ e.createElement(F, { factor: 7 }), /* @__PURE__ */ e.createElement(w2, { type: "large", text: s, postContent: d, ...o }), /* @__PURE__ */ e.createElement(F, { factor: 7 }))));
};
class s3 extends N {
  constructor(t) {
    super(t), this.state = {
      sortDirection: null,
      orderBy: null,
      rows: [...t.rows.map(bt)],
      expandedRows: []
    };
  }
  static getDerivedStateFromProps(t, n) {
    const a = t.columns.find((s) => s.id === n.orderBy) || t.columns.find((s) => s.sort) || t.columns.find((s) => !["custom", "toggle"].includes(s.renderer)), l = [...n.rows].sort(
      (s, d) => Ke(s[a.id]) > Ke(d[a.id]) ? 1 : -1
    ), o = [...t.rows].sort(
      (s, d) => Ke(s[a.id]) > Ke(d[a.id]) ? 1 : -1
    );
    return o1(o, l.map(X9)) ? null : {
      rows: t.rows.map(bt),
      orderBy: null,
      sortDirection: null
    };
  }
  toggleRowExpandState(t) {
    const { expandedRows: n } = this.state, a = n.findIndex((l) => l === t.voltRowId);
    if (a !== -1) {
      const l = [...n];
      l.splice(a, 1), this.setState({ expandedRows: l });
    } else
      this.setState({ expandedRows: [...n, t.voltRowId] });
  }
  toggleRowsExpandState() {
    const { expandedRows: t, rows: n } = this.state;
    t.length && n.length && t.length === n.length ? this.setState({ expandedRows: [] }) : this.setState({ expandedRows: n.map((l) => l.voltRowId) });
  }
  sort(t) {
    const { orderBy: n, sortDirection: a, rows: l } = this.state;
    let o, s = [...l], d = t.id, c = a;
    switch (n !== null && d !== null && n !== d && (c = null), c) {
      case "ASC":
        o = "DESC";
        break;
      case "DESC":
        o = null, d = null;
        break;
      default:
        o = "ASC";
    }
    s.length && d && o !== null ? s.sort((m, h) => {
      const p = Ke(m[d]), u = Ke(h[d]);
      return u < p ? o === "ASC" ? 1 : -1 : u > p ? o === "ASC" ? -1 : 1 : 0;
    }) : s = [...this.props.rows.map(bt)], this.setState({
      sortDirection: o,
      orderBy: d,
      rows: s
    });
  }
  render() {
    const {
      columns: t,
      testId: n,
      onRowClick: a,
      expandedContent: l,
      summaryRow: o,
      height: s,
      cellOverflowEllipsis: d,
      loading: c,
      emptyStateProps: m
    } = this.props, { rows: h, expandedRows: p, orderBy: u, sortDirection: C } = this.state;
    if (!t && !h && console.warn("List: can not render without columns prop"), t && !Array.isArray(t) || h && !Array.isArray(t))
      throw "List: columns or rows are not valid array. Check the props format.";
    const E = typeof l == "function", g = E && typeof o == "function" && !c, L = [...t];
    if (E) {
      const f = Y9(
        (w) => this.toggleRowExpandState(w),
        (w) => p.indexOf(w.voltRowId) > -1
      );
      L.unshift(f);
    }
    const x = d ? { tableLayout: "fixed" } : {}, A = !c && (!h || !h.length), Z = L.length, D = s && s !== "auto";
    return /* @__PURE__ */ e.createElement("div", { className: $.fullWidth }, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: c || A || !D ? void 0 : $.scrollableContainer,
        style: { height: s }
      },
      /* @__PURE__ */ e.createElement("table", { "data-testid": n, className: $.listContainer, style: x }, /* @__PURE__ */ e.createElement(
        i3,
        {
          className: D ? $.stickyHeader : $.listHeader,
          columns: L,
          rows: h,
          expandedRows: p,
          orderBy: u,
          sortDirection: C,
          sorter: (f) => this.sort(f),
          toggleExpand: () => this.toggleRowsExpandState()
        }
      ), !!h.length && !c && /* @__PURE__ */ e.createElement(
        G2,
        {
          rows: h,
          columns: L,
          expandedRows: p,
          expandedContent: l,
          onRowClick: a,
          summaryRow: o,
          cellOverflowEllipsis: d
        }
      ), /* @__PURE__ */ e.createElement(Co, { colSpan: Z, active: c }), /* @__PURE__ */ e.createElement(fo, { colSpan: Z, active: A, ...m }))
    ), g && /* @__PURE__ */ e.createElement(P, { display: "flex", className: $.listSummaryRow }, o(h)));
  }
}
s3.propTypes = {
  height: i.oneOfType([i.string, i.number]),
  columns: i.array,
  rows: i.array,
  testId: i.string,
  onRowClick: i.func,
  expandedContent: i.func,
  summaryRow: i.func,
  cellOverflowEllipsis: i.bool,
  loading: i.bool,
  emptyStateProps: i.shape({
    onResetList: i.func,
    onCreateItem: i.func,
    isFiltered: i.bool,
    text: i.string,
    subText: i.string,
    postContent: i.node
  })
};
s3.defaultProps = {
  columns: [],
  rows: [],
  testId: "volt-list",
  onRowClick: null,
  expandedContent: null,
  summaryRow: null,
  cellOverflowEllipsis: !1,
  emptyStateProps: {},
  height: void 0
};
class z2 extends N {
  full(t) {
    const n = this.getWidth(), a = n * 3 / 20;
    return /* @__PURE__ */ e.createElement("svg", { width: n, height: a, viewBox: "0 0 155 22", "data-testid": "full-logo" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M54.5554 19.2322V7.96604L51.3528 15.1879H49.4965L46.2939 7.99113V19.2322H43.4816V2.75383H46.712L50.4776 10.8871L54.1791 2.75383H57.3817V19.2322H54.5554ZM68.5838 6.46649L66.3373 12.9831H70.7969L68.5838 6.46649ZM73.0434 19.2322L71.8226 15.7314H65.5262L64.3081 19.2322H61.2031L66.9978 2.75383H70.3788L76.1457 19.2322H73.0434ZM88.1812 6.58355C88.1812 6.58355 88.1812 6.4191 88.1533 6.39123C87.9916 6.08742 87.5596 5.53553 87.292 5.50766H82.4143V9.93386H87.1527C87.3952 9.93386 87.9359 9.37641 88.1505 8.99455C88.1671 8.96058 88.1766 8.92359 88.1784 8.88585L88.1812 6.58355ZM88.7107 19.2322L85.1012 12.6961H82.5035V19.2322H79.6855V2.75383H87.2558C87.9521 2.75782 88.6314 2.96938 89.2069 3.36146C89.7375 3.81325 90.2162 4.32275 90.634 4.88052C90.9507 5.38082 91.1189 5.96076 91.119 6.55289V8.92765C91.1223 9.52027 90.9539 10.1012 90.634 10.6C90.2121 11.1496 89.7286 11.649 89.193 12.0884C88.8909 12.2912 88.5518 12.4324 88.1951 12.5037L92.0527 19.2322H88.7107ZM98.391 15.2799C98.3899 15.3177 98.3985 15.3551 98.4161 15.3886C98.7367 15.8786 99.1426 16.3072 99.6146 16.654C99.6572 16.6741 99.7041 16.6837 99.7512 16.6819H100.378L99.9714 15.7203L102.572 14.8395L103.358 16.6819H103.712C103.759 16.6815 103.805 16.672 103.848 16.654C104.302 16.3041 104.689 15.8755 104.991 15.3886C105.008 15.3548 105.018 15.3177 105.019 15.2799V6.7926C105.019 6.7926 105.019 6.70898 104.991 6.68111C104.69 6.22477 104.302 5.83258 103.848 5.52717C103.806 5.50702 103.759 5.49746 103.712 5.4993H99.7456C99.7456 5.4993 99.6369 5.4993 99.609 5.52717C99.1376 5.8294 98.7304 6.2215 98.4105 6.68111C98.3952 6.71635 98.3866 6.75418 98.3854 6.7926L98.391 15.2799ZM104.403 19.4273L105.465 21.8188H102.444L101.435 19.4273H99.6369C99.0404 19.4134 98.458 19.2433 97.9478 18.934C97.3764 18.6023 96.2754 17.4233 95.9605 16.955C95.6631 16.4877 95.5117 15.9423 95.5257 15.3886V6.7926C95.5117 6.23884 95.6631 5.69349 95.9605 5.22615C96.2866 4.75788 97.3764 3.57886 97.9478 3.24718C98.458 2.93786 99.0404 2.76775 99.6369 2.75383H103.779C104.374 2.77127 104.954 2.94114 105.465 3.24718C106.039 3.57886 107.101 4.75788 107.455 5.22615C107.753 5.69349 107.904 6.23884 107.89 6.7926V15.3886C107.904 15.9423 107.753 16.4877 107.455 16.955C107.101 17.4233 106.039 18.6023 105.465 18.934C105.135 19.1505 104.766 19.2993 104.378 19.3716L104.403 19.4273ZM112.726 19.2322V2.75383H123.131V5.51045H115.46V9.67464H122.707V12.4313H115.46V16.484H123.131V19.2322H112.726ZM134.436 5.50209V19.2322H131.535V5.51045H127.058V2.75383H138.91V5.51045L134.436 5.50209ZM146.787 6.46649L144.54 12.9748H149L146.787 6.46649ZM151.137 19.2322L149.919 15.7314H143.626L142.405 19.2322H139.3L145.095 2.75383H148.478L154.242 19.2322H151.137Z",
        fill: t
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 0H12.5846L20.0601 11.0014L14.4576 19.2517H18.6302L24.2577 11.0014L16.7766 0H29.3417L36.8395 11.0014L29.3417 22H25.1691L32.6446 11.0014L27.0478 2.75105H22.8529L28.4526 11.0014L20.9743 22H8.38971L15.868 11.0014L10.2405 2.75105H6.04561L11.6954 11.0014L4.19486 22H0L7.50057 11.0014L0 0Z",
        fill: t
      }
    ));
  }
  marq(t) {
    const n = this.getWidth(), a = n * 3 / 4;
    return /* @__PURE__ */ e.createElement("svg", { width: n, height: a, viewBox: "0 0 37 22", "data-testid": "marq-logo" }, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 0H12.5846L20.0601 11.0014L14.4576 19.2517H18.6302L24.2577 11.0014L16.7766 0H29.3417L36.8395 11.0014L29.3417 22H25.1691L32.6446 11.0014L27.0478 2.75105H22.8529L28.4526 11.0014L20.9743 22H8.38971L15.868 11.0014L10.2405 2.75105H6.04561L11.6954 11.0014L4.19486 22H0L7.50057 11.0014L0 0Z",
        fill: t
      }
    ));
  }
  getLogo() {
    const { type: t } = this.props;
    switch (t) {
      case "full light":
        return this.full("white");
      case "full dark":
        return this.full(v.logoColor);
      case "marq light":
        return this.marq("white");
      case "marq dark":
        return this.marq(v.logoColor);
      default:
        return this.marq(v.logoColor);
    }
  }
  getWidth() {
    const { type: t, width: n } = this.props, a = Number(n);
    switch (t) {
      case "full light":
      case "full dark":
        return isNaN(a) ? 160 : a;
      case "marq light":
      case "marq dark":
        return isNaN(a) ? 32 : a;
      default:
        return isNaN(a) ? 32 : a;
    }
  }
  render() {
    return this.getLogo();
  }
}
z2.propTypes = {
  type: i.string,
  width: i.number
};
z2.defaultProps = {
  type: "marq dark"
};
const Eo = /* @__PURE__ */ e.createElement("svg", { width: "56", height: "68", viewBox: "0 0 56 68", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement("g", { filter: "url(#filter0_ddd)" }, /* @__PURE__ */ e.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1669 16.5714V22H35.9733V16.5714C35.9733 11.93 32.1738 8.15714 27.4995 8.15714C22.8253 8.15714 19.0257 11.93 19.0257 16.5714V22H13.8321V16.5714C13.8321 9.08 19.9551 3 27.4995 3C35.0439 3 41.1669 9.08 41.1669 16.5714ZM7.99951 24C7.99951 22.8954 8.89494 22 9.99951 22H45.9995C47.1041 22 47.9995 22.8954 47.9995 24V52C47.9995 53.1046 47.1041 54 45.9995 54H9.99951C8.89494 54 7.99951 53.1046 7.99951 52V24ZM33.9993 38C33.9993 41.3137 31.313 44 27.9993 44C24.6855 44 21.9993 41.3137 21.9993 38C21.9993 34.6863 24.6855 32 27.9993 32C31.313 32 33.9993 34.6863 33.9993 38Z",
    fill: "#1E1672"
  }
)), /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
  "filter",
  {
    id: "filter0_ddd",
    x: "-0.000488281",
    y: "0",
    width: "56",
    height: "68",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  },
  /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feOffset", { dy: "6" }),
  /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "4" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      type: "matrix",
      values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.08 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feOffset", null),
  /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "1.5" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      type: "matrix",
      values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.12 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow", result: "effect2_dropShadow" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feOffset", null),
  /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
  /* @__PURE__ */ e.createElement(
    "feColorMatrix",
    {
      type: "matrix",
      values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.2 0"
    }
  ),
  /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in2: "effect2_dropShadow", result: "effect3_dropShadow" }),
  /* @__PURE__ */ e.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect3_dropShadow", result: "shape" })
))), Lo = "_marqetaCard_5cfni_1", wo = "_lockedCard_5cfni_14", vo = "_pan_5cfni_29", yo = "_panGroup_5cfni_43", bo = "_reveal_5cfni_52", Ao = "_text_5cfni_58", Ho = "_contentTitle_5cfni_69", xo = "_content_5cfni_69", Mo = "_flexContainer_5cfni_80", Vo = "_logoContainer_5cfni_87", Do = "_nameContainer_5cfni_91", Fo = "_cvvContainer_5cfni_95", ko = "_expContainer_5cfni_100", ne = {
  marqetaCard: Lo,
  lockedCard: wo,
  pan: vo,
  panGroup: yo,
  reveal: bo,
  text: Ao,
  contentTitle: Ho,
  content: xo,
  flexContainer: Mo,
  logoContainer: Vo,
  nameContainer: Do,
  cvvContainer: Fo,
  expContainer: ko
};
function d3({
  testId: r,
  style: t,
  pan: n,
  firstName: a,
  middleName: l,
  lastName: o,
  fullName: s,
  cvv: d,
  exp: c,
  revealPan: m,
  locked: h,
  displayLogo: p
}) {
  function C({ children: D, ...f }) {
    return /* @__PURE__ */ e.createElement("p", { className: `${ne.contentTitle} ${ne.text}` }, D);
  }
  function E({ children: D, ...f }) {
    return /* @__PURE__ */ e.createElement("p", { className: `${ne.content} ${ne.text}` }, D);
  }
  function g(D) {
    return D || "";
  }
  const L = () => {
    let D = n;
    isNaN(n) && (D = "____________" + D.substring(12, 16));
    const w = (D ? D.replace(/ /g, "").replace(/\D/g, "•").substring(0, 16) : "").match(/.{1,4}/g);
    return w ? w.map((H, b) => /* @__PURE__ */ e.createElement("div", { className: ne.panGroup, key: b }, H)) : "";
  }, x = () => d ? d.substring(0, 4) : "•••", A = () => {
    let D = c;
    return c ? (D.length >= 4 && !D.includes("/") && (D = `${c.substring(0, 2)}/${c.substring(2, 4)}`), D.substring(0, 5)) : "";
  }, Z = () => {
    const D = g;
    return s = (s || `${D(a)} ${D(l)} ${D(o)}`).trim(), s.length > 21 ? s.substring(0, 21) : s;
  };
  return /* @__PURE__ */ e.createElement("div", { className: ne.marqetaCard, "data-testid": r, style: t }, h && /* @__PURE__ */ e.createElement("div", { className: ne.lockedCard, "data-testid": "marqeta-card-locked" }, /* @__PURE__ */ e.createElement("div", null, Eo)), /* @__PURE__ */ e.createElement(F, { factor: 2 }), /* @__PURE__ */ e.createElement("div", { className: ne.logoContainer }, p && /* @__PURE__ */ e.createElement(z2, { type: "full light", width: 95 })), /* @__PURE__ */ e.createElement(F, { factor: 5 }), /* @__PURE__ */ e.createElement("div", { className: ne.flexContainer, style: { height: "24px" } }, /* @__PURE__ */ e.createElement("div", { className: ne.pan, "data-testid": "card-pan" }, L()), m && /* @__PURE__ */ e.createElement("div", { className: ne.reveal, "data-testid": "marqeta-card-reveal-pan", onClick: m }, /* @__PURE__ */ e.createElement(V, { type: "show", factor: 0.5, mod: "reversed" }))), /* @__PURE__ */ e.createElement(F, { factor: 3.5 }), /* @__PURE__ */ e.createElement("div", { className: ne.flexContainer, style: { height: "48px" } }, /* @__PURE__ */ e.createElement("div", { className: ne.nameContainer }, /* @__PURE__ */ e.createElement(C, null, "NAME"), /* @__PURE__ */ e.createElement(E, null, Z())), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement("div", { className: ne.cvvContainer }, /* @__PURE__ */ e.createElement(C, null, "CVV"), /* @__PURE__ */ e.createElement(E, null, x())), /* @__PURE__ */ e.createElement(B, { factor: 2 }), /* @__PURE__ */ e.createElement("div", { className: ne.expContainer }, /* @__PURE__ */ e.createElement(C, null, "EXP"), /* @__PURE__ */ e.createElement(E, null, A()))), /* @__PURE__ */ e.createElement(F, { factor: 3 }));
}
d3.propTypes = {
  testId: i.string,
  style: i.object,
  pan: i.string,
  firstName: i.string,
  middleName: i.string,
  lastName: i.string,
  cvv: i.string,
  exp: i.string,
  revealPan: i.func,
  locked: i.bool,
  displayLogo: i.bool
};
d3.defaultProps = {
  testId: "volt-marqeta-card",
  style: {},
  pan: "************1234",
  firstName: "Example card",
  middleName: "",
  lastName: "",
  cvv: "123",
  exp: "01/23",
  revealPan: null,
  locked: !1,
  displayLogo: !0
};
const Zo = 4, c3 = jt(Zo), m3 = () => {
  const r = Xt(c3);
  if (!r)
    throw new Error("Metric compound components cannot be rendered outside the Metrics component");
  return r;
}, Bo = "_container_1pvkw_1", Oo = "_fixedContainerWidth_1pvkw_7", So = "_heading_1pvkw_38", Io = "_unit_1pvkw_43", Po = "_textOverflow_1pvkw_49", No = "_textGrow_1pvkw_55", Ro = "_tooltip_1pvkw_59", To = "_icon_1pvkw_63", ge = {
  container: Bo,
  fixedContainerWidth: Oo,
  heading: So,
  unit: Io,
  textOverflow: Po,
  textGrow: No,
  tooltip: Ro,
  icon: To
}, W2 = (r) => {
  const {
    content: t,
    heading: n,
    textType: a,
    unit: l,
    linkOnClick: o,
    linkActive: s,
    description: d,
    className: c,
    tooltip: m
  } = r, { shouldDisplayDescription: h } = m3(), p = s ? "primary" : "secondary", u = o ? /* @__PURE__ */ e.createElement(Ne, { className: ge.textOverflow, type: p, inheritParentFont: !0, onClick: o }, t) : t, C = M(ge.container, c);
  return /* @__PURE__ */ e.createElement("div", { className: C, "data-testid": "volt-metric" }, n && /* @__PURE__ */ e.createElement("div", { "data-testid": "volt-metric-heading", className: ge.heading }, /* @__PURE__ */ e.createElement(y, { className: `${ge.textOverflow} ${ge.textGrow}`, type: "label" }, n.toLocaleUpperCase()), m ? /* @__PURE__ */ e.createElement(Me, { className: ge.tooltip, ...m }, /* @__PURE__ */ e.createElement(V, { type: "info", className: ge.icon })) : null, /* @__PURE__ */ e.createElement(F, null)), /* @__PURE__ */ e.createElement(P, { alignItems: "center" }, /* @__PURE__ */ e.createElement(y, { className: ge.textOverflow, type: a }, u), l && /* @__PURE__ */ e.createElement(y, { testId: "volt-metric-unit", type: "footnote", className: ge.unit }, l)), h && d && /* @__PURE__ */ e.createElement("div", { "data-testid": "volt-metric-description" }, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { className: ge.textOverflow, type: "h6" }, d.toLocaleUpperCase())));
};
W2.defaultProps = {
  textType: "h3",
  tooltip: void 0
};
W2.propTypes = {
  heading: i.string,
  content: i.string,
  unit: i.string,
  textType: i.string,
  linkOnClick: i.func,
  linkActive: i.bool,
  description: i.string,
  className: i.string,
  tooltip: i.object
};
const j2 = (r) => {
  const { children: t, testId: n, inheritParentWidth: a, className: l } = r, o = m3(), s = z3(0, o, e.Children.toArray(t)), d = s.length === 1, c = Y(() => ({ shouldDisplayDescription: d }), [t]), m = M(
    {
      [ge.fixedContainerWidth]: a
    },
    l
  );
  return /* @__PURE__ */ e.createElement(c3.Provider, { value: c }, /* @__PURE__ */ e.createElement(P, { className: m, alignItems: "center", testId: n }, s));
};
j2.MetricItem = W2;
j2.propTypes = {
  testId: i.string,
  className: i.string,
  inheritParentWidth: i.bool
};
j2.defaultProps = {
  testId: "volt-metrics",
  inheritParentWidth: !1
};
const Uo = "_icon_8y49m_1", Go = "_contentWrap_8y49m_10", zo = "_content_8y49m_10", Wo = "_button_8y49m_21", jo = "_title_8y49m_27", C1 = {
  icon: Uo,
  contentWrap: Go,
  content: zo,
  button: Wo,
  title: jo
};
class h3 extends N {
  renderIcon() {
    const { type: t, testId: n } = this.props;
    let a, l, o = "reversed";
    switch (t) {
      case "success":
        a = v.statusSuccessColor, l = "success";
        break;
      case "info":
        a = v.statusPendingColor, l = "info";
        break;
      case "warning":
        a = v.statusWarningColor, o = null, l = "warning";
        break;
      case "danger":
        a = v.statusErrorColor, l = "danger";
        break;
      default:
        a = v.statusPendingColor, l = "info";
    }
    return /* @__PURE__ */ e.createElement("div", { "data-testid": `${n}_icon`, className: C1.icon, style: { backgroundColor: a } }, /* @__PURE__ */ e.createElement(V, { type: l, mod: o, factor: 2, noHoverEffects: !0 }));
  }
  renderTitle() {
    const { title: t, testId: n } = this.props;
    return t ? /* @__PURE__ */ e.createElement(y, { type: "h4", testId: `${n}_title-text` }, /* @__PURE__ */ e.createElement("span", { className: C1.title }, t)) : null;
  }
  renderButton() {
    const { buttonText: t, hideModal: n, testId: a } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: C1.button, "data-testid": `${a}_button` }, /* @__PURE__ */ e.createElement(
      J,
      {
        type: "outline",
        onClick: n,
        testId: "modal-alert-button",
        style: { width: "100%" }
      },
      t
    ));
  }
  renderContent() {
    const { children: t, testId: n } = this.props, a = typeof t == "string" ? /* @__PURE__ */ e.createElement(y, { testId: `${n}_content` }, t) : t;
    return /* @__PURE__ */ e.createElement("div", { className: C1.content, "data-testid": `${n}_content-wrapper` }, a);
  }
  render() {
    console.warn("ModalAlert component is no longer supported; please use ErrorModal.");
    const { type: t, testId: n } = this.props;
    return /* @__PURE__ */ e.createElement("div", { "data-testid": n }, /* @__PURE__ */ e.createElement(ot, null, /* @__PURE__ */ e.createElement("div", { className: C1.contentWrap }, /* @__PURE__ */ e.createElement(F, null), t !== "text" && this.renderIcon(), t !== "text" && /* @__PURE__ */ e.createElement(F, { factor: 2 }), this.renderTitle(), /* @__PURE__ */ e.createElement(F, null), this.renderContent(), /* @__PURE__ */ e.createElement(F, { factor: 3 }), this.renderButton())));
  }
}
h3.propTypes = {
  type: i.string,
  title: i.string,
  hideModal: i.func,
  buttonText: i.string,
  testId: i.string
};
h3.defaultProps = {
  type: "info",
  title: "",
  hideModal: () => {
  },
  buttonText: "OK",
  testId: "volt-modal-alert"
};
const Xo = "_modalWrap_1bph8_1", Yo = "_modal_1bph8_1", Qo = "_slidein_1bph8_1", Ko = "_overlay_1bph8_26", Jo = "_heading_1bph8_34", qo = "_body_1bph8_38", $o = "_footer_1bph8_44", _o = "_close_1bph8_51", n1 = {
  modalWrap: Xo,
  modal: Yo,
  slidein: Qo,
  overlay: Ko,
  heading: Jo,
  body: qo,
  footer: $o,
  close: _o
}, es = 84, ts = 588, ns = 400, xt = 300;
function ot({
  children: r,
  description: t,
  disableOverFlow: n,
  error: a,
  footerButtons: l,
  heading: o,
  hideModal: s,
  hideModalButtonText: d,
  maxHeightVh: c,
  showHideModalButton: m,
  testId: h,
  type: p
}) {
  const u = xe(null), C = p === "sm", E = document.activeElement, g = () => {
    E != null && E.focus && E.focus(), s ? s() : console.warn("Modal Component: hideModal cannot be undefined");
  };
  ee(() => {
    if (u.current) {
      const A = u.current.querySelector($t);
      setTimeout(() => A == null ? void 0 : A.focus(), xt);
    }
  }, []), ee(() => {
    const A = (Z) => Z.key === qt.Escape && g();
    return window.addEventListener("keydown", A), () => window.removeEventListener("keydown", A);
  }, []);
  const L = () => (o || console.warn("Modal Component: heading is required"), /* @__PURE__ */ e.createElement("header", { className: n1.heading }, /* @__PURE__ */ e.createElement(y, { type: "h5", testId: `${h}__heading` }, o), t && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 0.5 }), /* @__PURE__ */ e.createElement(y, { testId: `${h}__description` }, t)), a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 3 }), /* @__PURE__ */ e.createElement(st, { type: "lg", testId: `${h}__error` }, a)))), x = () => !m && !(l && l.length) || !l.length && !s ? null : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(F, { factor: 3 }), /* @__PURE__ */ e.createElement("div", { className: n1.footer, "data-testid": `${h}__footer-buttons` }, m && s && /* @__PURE__ */ e.createElement(
    J,
    {
      key: "cancel",
      type: "outline",
      onClick: g,
      testId: `${h}__hide-modal-button`
    },
    d
  ), l && l.map((Z, D) => /* @__PURE__ */ e.createElement(e.Fragment, { key: D }, /* @__PURE__ */ e.createElement(B, { factor: 2 }), Z))));
  return /* @__PURE__ */ e.createElement("div", { className: n1.modalWrap, "data-testid": `${h}__${o}` }, /* @__PURE__ */ e.createElement(Y1, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: n1.modal,
      ref: u,
      style: {
        animationDuration: `${xt}ms`,
        maxHeight: `${c}vh`,
        transitionDuration: `${xt}ms`,
        width: `${C ? ns : ts}px`
      }
    },
    o && /* @__PURE__ */ e.createElement(L, null),
    r && /* @__PURE__ */ e.createElement(e.Fragment, null, o && /* @__PURE__ */ e.createElement(F, { factor: 3 }), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: n1.body,
        style: {
          maxHeight: `calc(${c}vh - ${es}px - ${o ? 80 : 0}px)`,
          overflow: n ? "unset" : "auto"
        }
      },
      r
    )),
    /* @__PURE__ */ e.createElement(x, null)
  )), /* @__PURE__ */ e.createElement("div", { className: n1.overlay, "data-testid": "modal-overlay", onClick: s ? g : null }));
}
ot.propTypes = {
  heading: i.string,
  description: i.string,
  error: i.string,
  hideModal: i.func,
  width: i.any,
  footerButtons: i.array,
  maxHeightVh: i.number,
  testId: i.string,
  type: i.oneOf(["sm", "lg"]),
  hideModalButtonText: i.any,
  showHideModalButton: i.bool,
  disableOverFlow: i.bool
};
ot.defaultProps = {
  heading: "",
  description: "",
  error: "",
  width: "360px",
  footerButtons: [],
  maxHeightVh: 80,
  testId: "volt-modal",
  type: "lg",
  hideModalButtonText: "Cancel",
  showHideModalButton: !0,
  disableOverFlow: !1
};
const as = "_wrap_1woei_1", rs = "_selectWrap_1woei_12", is = "_focused_1woei_29", ls = "_changed_1woei_35", os = "_completed_1woei_35", ss = "_inputWrap_1woei_42", ds = "_collapseWrap_1woei_52", cs = "_inputContainer_1woei_56", ms = "_input_1woei_42", hs = "_errorWrap_1woei_70", ps = "_chevron_1woei_75", us = "_placeholder_1woei_79", Cs = "_disabledWrap_1woei_85", gs = "_text_1woei_97", fs = "_label_1woei_110", Es = "_instructions_1woei_118", Ls = "_error_1woei_70", ws = "_disabled_1woei_85", vs = "_option_1woei_139", ys = "_selectCandidate_1woei_168", bs = "_selected_1woei_172", As = "_optionsWrap_1woei_176", Hs = "_optionsScroll_1woei_189", xs = "_bulkToggle_1woei_194", Ms = "_toggleBlock_1woei_220", Vs = "_dummyOptions_1woei_233", Ds = "_tooltipOptions_1woei_241", Fs = "_textOption_1woei_248", ks = "_searchContainer_1woei_269", Zs = "_searchInput_1woei_280", Bs = "_noHover_1woei_296", Os = "_searchIcon_1woei_303", Ss = "_cancelSearchIcon_1woei_309", Is = "_focusedWrap_1woei_323", Ps = "_noOnchange_1woei_327", S = {
  wrap: as,
  selectWrap: rs,
  focused: is,
  changed: ls,
  completed: os,
  inputWrap: ss,
  collapseWrap: ds,
  inputContainer: cs,
  input: ms,
  errorWrap: hs,
  chevron: ps,
  placeholder: us,
  disabledWrap: Cs,
  text: gs,
  label: fs,
  instructions: Es,
  error: Ls,
  disabled: ws,
  option: vs,
  selectCandidate: ys,
  selected: bs,
  optionsWrap: As,
  optionsScroll: Hs,
  bulkToggle: xs,
  toggleBlock: Ms,
  dummyOptions: Vs,
  tooltipOptions: Ds,
  textOption: Fs,
  searchContainer: ks,
  searchInput: Zs,
  noHover: Bs,
  searchIcon: Os,
  cancelSearchIcon: Ss,
  focusedWrap: Is,
  noOnchange: Ps
};
class p3 extends N {
  constructor(t) {
    super(t), this.state = {
      focused: !1,
      selectCandidate: "",
      search: "",
      error: "",
      optionsPositionLeft: null,
      optionsPositionTop: null,
      selectedFirstFlags: t.selected
    }, this.handleOptionClick = this.handleOptionClick.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleBlurFocus = this.handleBlurFocus.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleInputChange = this.handleInputChange.bind(this), this.getPlaceholderText = this.getPlaceholderText.bind(this), this.updateOptionsPosition = this.updateOptionsPosition.bind(this), this.selectedFirst = this.selectedFirst.bind(this), this.sortSelected = this.sortSelected.bind(this), this.optionsWrap = e.createRef(), this.optionsScroll = e.createRef(), this.selectedOption = e.createRef(), this.wrap = e.createRef(), this.dummyOptions = e.createRef(), this.input = e.createRef(), this.searchTimerRunner = null, this.searchTimer = 0, this.initialFocus = !1, this.inputId = this.props.id || Pe("volt-multiselect__");
  }
  componentDidMount() {
    const { runValidatorOnLoad: t, fixOverflow: n } = this.props;
    t && this.checkIsError(), n && (this.updateOptionsPosition(), this.setupPortalEventListeners()), document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    this.teardownPortalEventListeners(), document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(t, n) {
    const { fixOverflow: a } = this.props, { error: l, selectCandidate: o } = this.state;
    l && this.checkIsError(), o !== n.selectCandidate && this.scrollToSelectCandidate(), a && this.updateOptionsPosition();
  }
  // helpers
  updateOptionsPosition() {
    const { optionsPositionLeft: t, optionsPositionTop: n } = this.state;
    try {
      const { left: a, top: l } = this.dummyOptions.current.querySelector(".volt-options-wrap-hook").getBoundingClientRect();
      (t !== a || n !== l) && this.setState({ optionsPositionLeft: a, optionsPositionTop: l });
    } catch (a) {
      console.error("Select portal options position calc failed:", a);
    }
  }
  setupPortalEventListeners() {
    typeof window < "u" && (window.addEventListener("resize", this.updateOptionsPosition), window.addEventListener("scroll", this.updateOptionsPosition));
  }
  teardownPortalEventListeners() {
    typeof window < "u" && (window.removeEventListener("resize", this.updateOptionsPosition), window.removeEventListener("scroll", this.updateOptionsPosition));
  }
  checkIsError() {
    const { isError: t, selected: n, fixOverflow: a, runValidatorOnLoad: l } = this.props;
    if (!l && !this.initialFocus)
      return;
    const o = Array.isArray(n) ? n : [], s = t ? t(o) : "";
    this.setState({ error: s || "" }, () => {
      a && this.updateOptionsPosition();
    });
  }
  selectedFirst() {
    const { options: t, sortOptions: n, selectedToTop: a } = this.props, { selectedFirstFlags: l } = this.state;
    return n && a ? this.sortSelected() : [...new Set(l.concat(t))];
  }
  sortSelected() {
    const { options: t } = this.props, { selectedFirstFlags: n } = this.state, a = new Set(n);
    return t.sort((l, o) => a.has(l) && a.has(o) ? l < o ? -1 : 1 : a.has(l) || a.has(o) ? a.has(l) ? -1 : 1 : l < o ? -1 : 1);
  }
  getSortedOptions() {
    const { options: t, sortOptions: n, selectedToTop: a } = this.props;
    return a ? t ? this.selectedFirst() : [] : n ? t ? t.sort() : [] : t || [];
  }
  getOptions() {
    const { search: t } = this.state, n = t ? t.toUpperCase() : "";
    if (!t)
      return this.getSortedOptions();
    const { options: a, searchableOptions: l, searchableOptionsMaxDisplayNum: o } = this.props, s = (d) => d.filter((c) => c.searchString ? c.searchString.toUpperCase().includes(n) : typeof c == "string" ? c.toUpperCase().includes(n) : c.val ? c.val.toUpperCase().includes(n) : !0);
    if (l.length > 0) {
      const d = [.../* @__PURE__ */ new Set([...a, ...l])];
      return s(d).slice(0, o);
    }
    return s(this.props.options);
  }
  acceptSelectOptionCandidate() {
    const { onOptionClick: t } = this.props, { selectCandidate: n } = this.state;
    t && n && t(n);
  }
  scrollToSelectCandidate() {
    try {
      const t = this.optionsScroll.current, n = this.selectedOption.current, a = t.getBoundingClientRect(), l = {
        height: t.clientHeight,
        width: t.clientWidth
      }, o = n.getBoundingClientRect();
      o.top >= a.top && o.top <= a.top + l.height || (t.scrollTop = o.top + t.scrollTop - a.top);
    } catch {
    }
  }
  selectedIndex() {
    const { selectCandidate: t } = this.state;
    return this.getOptions().indexOf(t);
  }
  selectNext() {
    const { focused: t } = this.state, n = this.getOptions();
    if (t) {
      const a = this.selectedIndex();
      a === -1 ? this.setState({ selectCandidate: n[0] }) : a + 1 < n.length ? this.setState({
        selectCandidate: n[a + 1]
      }) : this.setState({ selectCandidate: n[0] });
    }
  }
  selectPrevious() {
    const { focused: t } = this.state, n = this.getOptions();
    if (t) {
      const a = this.selectedIndex();
      a === -1 ? this.setState({ selectCandidate: n[0] }) : a !== 0 ? this.setState({
        selectCandidate: n[a - 1]
      }) : this.setState({ selectCandidate: n[n.length - 1] });
    }
  }
  deleteLastSelected() {
    const { onOptionClick: t, selected: n, collapseSelected: a } = this.props, { search: l } = this.state;
    if (a || l || !t)
      return null;
    const o = n[n.length - 1];
    o && t(o);
  }
  get calculatedMaxHeight() {
    const { numOptions: t } = this.props;
    return t * 40 + 28;
  }
  // handlers
  handleFocus(t) {
    const { disabled: n, hasChangedType: a, selected: l } = this.props;
    a && n || (this.input && this.input.current ? document && this.input.current !== document.activeElement && this.input.current.focus() : setTimeout(() => this.handleEmptyFocus(), 0), this.initialFocus = !0, this.setState({
      selectedFirstFlags: [...l],
      focused: !0
    }));
  }
  handleEmptyFocus() {
    this.input && this.input.current && document && this.input.current !== document.activeElement && this.input.current.focus();
  }
  handleBlur() {
    this.setState({ focused: !1, search: "" }), this.checkIsError();
  }
  handleKeyDown(t) {
    const n = t && t.key;
    n === "ArrowDown" ? this.selectNext() : n === "ArrowUp" ? this.selectPrevious() : n === "Backspace" ? this.deleteLastSelected() : n === "Tab" ? this.handleBlur() : n === "Enter" && this.acceptSelectOptionCandidate();
  }
  handleBlurFocus(t) {
    if (document.activeElement !== this.input.current)
      return this.state.focused ? this.handleBlur(t) : this.handleFocus(t);
  }
  handleOptionClick(t) {
    const { onOptionClick: n } = this.props;
    n && n(t);
  }
  handleClickOutside(t) {
    const n = this.wrap && this.wrap.current && this.wrap.current.contains(t.target), a = this.optionsWrap && this.optionsWrap.current && this.optionsWrap.current.contains(t.target);
    !n && !a && this.handleBlur();
  }
  handleInputChange(t) {
    this.setState({ search: t.target.value }, () => {
      const n = this.getOptions();
      this.setState({
        selectCandidate: this.state.search.length && n && n[0] ? n[0] : null
      });
    });
  }
  // renderers
  renderLabel() {
    const { label: t, labelSize: n, labelOptional: a, sublabel: l, labelTooltip: o, hasChangedType: s } = this.props;
    return /* @__PURE__ */ e.createElement(
      ue,
      {
        id: this.inputId,
        size: n,
        optional: a,
        subLabel: l,
        tooltip: o,
        hasChangedType: s
      },
      t
    );
  }
  renderSelectedOptions(t = !1) {
    const { selected: n, disabled: a, hasChangedType: l } = this.props, o = !l && a, s = Array.isArray(n) && n.length, d = this.getPlaceholderText();
    return s ? n.map((c, m) => {
      const p = m === n.length - 1 ? c : `${c}, `, u = t ? p : /* @__PURE__ */ e.createElement(
        y,
        {
          className: S.text,
          ...o ? { color: v.blackLighter5 } : { color: v.blacklighter3 }
        },
        p
      );
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          className: S.textOption,
          key: `multiselect-option-${m}`,
          "data-testid": "multiselect-selected-option"
        },
        u
      );
    }) : d;
  }
  getPlaceholderText() {
    const { placeholder: t } = this.props, { focused: n } = this.state;
    return t ? /* @__PURE__ */ e.createElement("div", { className: `${S.placeholder} ${n ? S.focused : ""}` }, t) : /* @__PURE__ */ e.createElement("div", { className: `${S.placeholder} ${n ? S.focused : ""}` }, "Please select an option");
  }
  renderSelectCount() {
    const {
      selected: t,
      width: n,
      tooltipWidth: a,
      showSelectionTooltip: l,
      disabled: o,
      itemsSelected: s,
      hasChangedType: d
    } = this.props, { focused: c } = this.state, m = Array.isArray(t) && t.length, h = this.getPlaceholderText(), p = !d && o;
    if (!m)
      return h;
    const u = /* @__PURE__ */ e.createElement("div", { className: S.tooltipOptions, style: { maxWidth: a || n } }, this.renderSelectedOptions(!0)), C = /* @__PURE__ */ e.createElement(
      y,
      {
        color: p ? v.blackLighter5 : v.blackLighter1,
        className: `${S.optionText}`
      },
      m,
      " ",
      s
    );
    return c || !l ? C : /* @__PURE__ */ e.createElement("div", { id: "tooltip-wrap" }, /* @__PURE__ */ e.createElement(
      Me,
      {
        pointerEvents: !0,
        direction: "bottomRight",
        content: u,
        width: a
      },
      C
    ));
  }
  renderSelected() {
    const { collapseSelected: t, selected: n, collapseSelectedLimit: a } = this.props;
    return t && n.length > a ? this.renderSelectCount() : this.renderSelectedOptions();
  }
  renderChevron() {
    const { disabled: t, hasChangedType: n } = this.props, a = !n && t;
    return /* @__PURE__ */ e.createElement("div", { className: `${S.chevron} ${a ? S.disabled : ""}` }, /* @__PURE__ */ e.createElement(
      V,
      {
        type: "caret-down",
        mod: a ? "disabled" : "default",
        noHoverEffects: !0,
        onClick: this.handleBlurFocus
      }
    ));
  }
  getError() {
    const { error: t } = this.state, { error: n } = this.props;
    return t || n;
  }
  renderError() {
    const { preventErrorPushdown: t } = this.props, n = this.getError();
    return /* @__PURE__ */ e.createElement(ae, { preventErrorPushdown: t }, n);
  }
  renderSearch() {
    const { disabled: t, showSearch: n } = this.props, { search: a } = this.state;
    if (!n)
      return null;
    const l = () => {
      const s = { target: { value: "" } };
      this.handleInputChange(s);
    }, o = (s) => s.stopPropagation();
    return /* @__PURE__ */ e.createElement("div", { className: S.searchContainer, onClick: o }, /* @__PURE__ */ e.createElement("div", { className: S.searchIcon }, /* @__PURE__ */ e.createElement(V, { type: "search", factor: 0.3, noHoverEffects: !0 })), /* @__PURE__ */ e.createElement(
      "input",
      {
        className: S.searchInput,
        disabled: t,
        onChange: this.handleInputChange,
        onKeyDown: this.handleKeyDown,
        placeholder: "Search",
        ref: this.input,
        "data-testid": "multiselect-input",
        value: a,
        spellCheck: !1,
        tabIndex: 0
      }
    ), a && /* @__PURE__ */ e.createElement("div", { className: S.cancelSearchIcon, onClick: l }, /* @__PURE__ */ e.createElement(V, { type: "clear", factor: 0.3, noHoverEffects: !0 })));
  }
  renderBulkToggle() {
    const { onBulkToggleClick: t, options: n, selected: a, testId: l } = this.props, o = this.getOptions();
    if (!t || !Array.isArray(n) || !Array.isArray(a) || !o.length)
      return null;
    const s = new Set(a), d = o.length ? o.every((m) => s.has(m)) : !1, c = (m) => {
      m.stopPropagation(), o.length && t(!d, o);
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${S.bulkToggle} ${S.option}`,
        "data-testid": `${l}-bulk-toggle`,
        onClick: c
      },
      /* @__PURE__ */ e.createElement(s1, { active: d, onClick: c, textSpacingFactor: 1 }, /* @__PURE__ */ e.createElement(
        y,
        {
          className: S.text,
          testId: `Checkbox-text_${d ? "Deselect all" : "Select all"}`,
          type: "h6"
        },
        "Select all"
      ))
    );
  }
  renderOptions(t = {}, n = !1) {
    const { selected: a, dropDownWrap: l, numOptions: o, onBulkToggleClick: s, showSearch: d } = this.props, { focused: c, selectCandidate: m } = this.state;
    if (!c && !n)
      return null;
    const h = this.getOptions(), p = h.map((L, x) => {
      const A = a.includes(L), Z = m === L, D = Z ? { ref: this.selectedOption } : {}, f = (w) => {
        w.stopPropagation(), this.handleOptionClick(L);
      };
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${S.option} ${Z ? S.selectCandidate : ""}`,
          "data-testid": Z ? "is-select-candidate" : "not-select-candidate",
          key: x,
          ...D,
          onClick: f
        },
        /* @__PURE__ */ e.createElement(s1, { active: A, onClick: f, textSpacingFactor: 1 }, /* @__PURE__ */ e.createElement(y, { className: S.text, testId: `Checkbox-text_${L}`, type: "body-sm" }, L))
      );
    }), C = !!s ? h.length + 1 : h.length, E = (h.length ? C >= o - 1 ? o * 40 - 20 : C * 40 : 40) + (d ? 1 : 0), g = {
      maxHeight: this.calculatedMaxHeight,
      ...l,
      height: l.height || `${E}px`,
      width: "100%"
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: `${S.optionsWrap} volt-options-wrap-hook`,
        ref: this.optionsWrap,
        style: {
          ...t,
          width: l.width,
          maxWidth: l.maxWidth,
          minWidth: l.minWidth
        }
      },
      this.renderSearch(),
      /* @__PURE__ */ e.createElement("div", { className: S.optionsScroll, style: g, ref: this.optionsScroll }, this.renderBulkToggle(), p.length ? /* @__PURE__ */ e.createElement("div", { className: S.options, "data-testid": "volt-select-options" }, p) : /* @__PURE__ */ e.createElement("div", { className: `${S.option} ${S.noHover}`, "data-testid": "volt-select-no-results" }, /* @__PURE__ */ e.createElement(y, { color: v.blackLighter5 }, "No results found")))
    );
  }
  renderPortalOptions() {
    const { fixOverflow: t, width: n, optionsWrap: a } = this.props, { optionsPositionLeft: l, optionsPositionTop: o } = this.state;
    if (!t)
      return null;
    const s = {
      ...a,
      left: l,
      top: o,
      width: n,
      position: "fixed"
    };
    return /* @__PURE__ */ e.createElement(b1, null, this.renderOptions(s));
  }
  renderDummyOptions() {
    const { fixOverflow: t } = this.props;
    return t ? /* @__PURE__ */ e.createElement("div", { className: S.dummyOptions, ref: this.dummyOptions }, /* @__PURE__ */ e.createElement("div", { className: "volt-options-wrap-hook" })) : null;
  }
  render() {
    const { width: t, disabled: n, fixOverflow: a, collapseSelected: l, testId: o, hasChangedType: s } = this.props, d = !s && n, { focused: c } = this.state, m = this.getError(), h = l ? "40px" : "";
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: t ? { width: t } : {},
        className: `
          ${S.wrap}
          ${d ? S.disabledWrap : ""}
          ${c ? S.focusedWrap : ""}
          ${m ? S.errorWrap : ""}
          ${l ? S.collapseWrap : ""}
          ${n ? S.noOnchange : ""}
        `,
        "aria-labelledby": this.inputId,
        ref: this.wrap,
        "data-testid": o
      },
      this.renderLabel(),
      /* @__PURE__ */ e.createElement(
        "button",
        {
          className: `${S.selectWrap} ${c ? S.focused : ""} ${s ? S[s] : ""} `,
          "data-testid": "volt-multiselect-wrap",
          style: l ? { maxHeight: h } : {},
          onClick: this.handleBlurFocus
        },
        /* @__PURE__ */ e.createElement("div", { className: S.inputWrap, "data-testid": "volt-multiselect-input-wrap" }, this.renderSelected()),
        this.renderChevron(),
        a ? this.renderPortalOptions() : this.renderOptions(),
        this.renderDummyOptions()
      ),
      this.renderError()
    );
  }
}
p3.propTypes = {
  id: i.string,
  label: i.string,
  sublabel: i.string,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  selected: i.array,
  options: i.any,
  width: i.any,
  onOptionClick: i.func,
  onBulkToggleClick: i.func,
  isError: i.func,
  collapseSelected: i.bool,
  disabled: i.bool,
  runValidatorOnLoad: i.bool,
  selectedToTop: i.bool,
  sortOptions: i.bool,
  numOptions: i.number,
  showSearch: i.bool,
  fixOverflow: i.bool,
  preventErrorPushdown: i.bool,
  tooltipWidth: i.oneOfType([i.string, i.number]),
  showSelectionTooltip: i.bool,
  testId: i.string,
  placeholder: i.string,
  dropDownWrap: i.object,
  optionsWrap: i.object,
  error: i.string,
  collapseSelectedLimit: i.number,
  itemsSelected: i.string,
  searchableOptions: i.array,
  hasChangedType: i.string,
  searchableOptionsMaxDisplayNum: i.number
};
p3.defaultProps = {
  id: null,
  label: "",
  sublabel: "",
  labelSize: "small",
  labelOptional: !1,
  selected: [],
  options: [],
  width: null,
  onBulkToggleClick: null,
  isError: () => {
  },
  kind: "multiselect",
  collapseSelected: !0,
  disabled: !1,
  runValidatorOnLoad: !1,
  selectedToTop: !0,
  sortOptions: !1,
  numOptions: 6,
  showSearch: !0,
  fixOverflow: !1,
  preventErrorPushdown: !1,
  tooltipWidth: null,
  testId: W.multiselect,
  placeholder: "Select from options",
  dropDownWrap: {},
  optionsWrap: {},
  error: "",
  showSelectionTooltip: !0,
  collapseSelectedLimit: 1,
  itemsSelected: "items selected",
  searchableOptions: [],
  searchableOptionsMaxDisplayNum: U0
};
const Ns = "_tabsContainer_17pbd_1", Rs = "_actionToggleContainer_17pbd_6", Ts = "_vtActive_17pbd_12", Us = "_toggleSelect_17pbd_19", k1 = {
  tabsContainer: Ns,
  actionToggleContainer: Rs,
  vtActive: Ts,
  toggleSelect: Us
};
class u3 extends N {
  getActiveTab(t, n) {
    const a = t.find((l) => l.route.includes(n));
    if (a)
      return a.label;
  }
  render() {
    const { activeRoute: t, tabs: n, onTabChange: a, testId: l, children: o } = this.props;
    let s;
    return Array.isArray(n) && n.length && t && (s = this.getActiveTab(n, t)), /* @__PURE__ */ e.createElement("div", { className: k1.tabsContainer }, /* @__PURE__ */ e.createElement("div", { className: k1.actionToggleContainer }, n.length && n.map(({ label: d, route: c }) => {
      const m = M(k1.toggleSelect, { [k1.vtActive]: d === s });
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          "data-testid": `${l}__${d}${c === t ? "-active" : ""}`,
          key: d,
          onClick: () => a(c),
          className: m
        },
        d
      );
    })), o);
  }
}
u3.propTypes = {
  activeRoute: i.string,
  tabs: i.arrayOf(i.oneOfType([i.string, i.object])),
  onTabChange: i.func,
  testId: i.string
};
u3.defaultProps = {
  onTabChange: () => {
  },
  testId: "volt-tab",
  tabs: [],
  activeRoute: ""
};
const Gs = "_list_gc6y1_1", zs = "_listItem_gc6y1_7", C3 = {
  list: Gs,
  listItem: zs
}, X2 = ({ testId: r, children: t }) => /* @__PURE__ */ e.createElement("ul", { "data-testid": r, className: C3.list }, t), Ws = ({ children: r }) => /* @__PURE__ */ e.createElement("li", { className: C3.listItem }, typeof r == "string" ? /* @__PURE__ */ e.createElement(y, { type: "body-sm", inline: !0 }, r) : r);
X2.propTypes = {
  testId: i.string
};
X2.defaultProps = {
  testId: "volt-numbered-list"
};
X2.ListItem = Ws;
const js = "_errorContainer_xmz0f_1", Xs = "_errorIcon_xmz0f_6", Ys = "_largeError_xmz0f_17", Mt = {
  errorContainer: js,
  errorIcon: Xs,
  largeError: Ys
}, st = ({ type: r, testId: t, children: n }) => {
  const a = Y(() => r === "lg", [r]);
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: Mt.errorContainer, "data-testid": t }, /* @__PURE__ */ e.createElement("div", { className: M(Mt.errorIcon, { [Mt.largeError]: a }) }, /* @__PURE__ */ e.createElement(V, { type: "danger", mod: "error", noHoverEffects: !0 })), /* @__PURE__ */ e.createElement(y, { type: a ? "body-lg" : "body-sm" }, n)));
};
st.propTypes = {
  type: i.oneOf(["lg", "sm"]),
  testId: i.string
};
st.defaultProps = {
  type: "sm",
  testId: "on-page-error"
};
const Qs = "_pageLoadingWrapper_1dsy7_1", Ks = "_loadingOverlayWrapper_1dsy7_7", O0 = {
  pageLoadingWrapper: Qs,
  loadingOverlayWrapper: Ks
}, g3 = ({ active: r, height: t, heightUnit: n }) => /* @__PURE__ */ e.createElement("div", { className: O0.pageLoadingWrapper, style: { height: `${t}${n}` } }, /* @__PURE__ */ e.createElement("div", { className: O0.loadingOverlayWrapper }, /* @__PURE__ */ e.createElement(ze, { active: r, borderRadius: "large" })));
g3.defaultProps = {
  active: !1,
  height: "540",
  heightUnit: "px"
};
g3.propTypes = {
  active: i.bool,
  height: i.string,
  heightUnit: i.oneOf(["em", "px", "%"])
};
const Js = "_pill_2sf17_1", qs = "_footnote_2sf17_16", $s = "_draft_2sf17_31", _s = "_success_2sf17_36", ed = "_pending_2sf17_40", td = "_warning_2sf17_44", nd = "_error_2sf17_48", ad = "_light_2sf17_56", rd = "_dark_2sf17_60", Vt = {
  pill: Js,
  "body-sm": "_body-sm_2sf17_10",
  footnote: qs,
  draft: $s,
  success: _s,
  pending: ed,
  warning: td,
  error: nd,
  light: ad,
  dark: rd
}, Y2 = (r) => {
  const { children: t, className: n, size: a, type: l, style: o, testId: s, withIcon: d } = r, c = M(Vt.pill, Vt[a], Vt[l], n);
  return /* @__PURE__ */ e.createElement(P, { alignItems: "center", className: c, style: o, testId: s }, d && O1[l] && /* @__PURE__ */ e.createElement(
    V,
    {
      noHoverEffects: !0,
      type: O1[l].icon,
      overrideColor: O1[l].color
    }
  ), t);
};
Y2.propTypes = {
  className: i.string,
  type: i.oneOf(["success", "warning", "pending", "error", "draft", "dark", "light"]),
  size: i.oneOf(["body-sm", "footnote"]),
  style: i.object,
  testId: i.string,
  withIcon: i.bool
};
Y2.defaultProps = {
  className: "",
  type: "success",
  style: {},
  testId: "volt-pill",
  size: "body-sm",
  withIcon: !1
};
const id = e.memo(Y2), ld = "_popoverContent_1j8zw_1", od = "_popoverCaretDefault_1j8zw_8", sd = "_popoverCaretEducation_1j8zw_12", w1 = {
  popoverContent: ld,
  popoverCaretDefault: od,
  popoverCaretEducation: sd
}, Rt = {
  default: {
    header: {
      backgroundColor: v.white,
      color: v.blackLighter3
    },
    caret: {}
  },
  education: {
    header: {
      backgroundColor: v.accentEducationColor,
      color: v.white
    },
    caret: {
      bottom: w1.popoverCaretEducation,
      bottomLeft: w1.popoverCaretEducation,
      bottomRight: w1.popoverCaretEducation
    }
  }
}, dd = "_container_1nnk5_1", cd = "_header_1nnk5_11", md = "_footer_1nnk5_17", z1 = {
  container: dd,
  header: cd,
  footer: md
}, hd = ({ iconComponent: r, type: t }) => r || (t === "education" ? /* @__PURE__ */ e.createElement(V, { type: "sparkle", mod: "reversed", factor: 2, noHoverEffects: !0 }) : null), pd = ({ iconComponent: r, heading: t, type: n }) => /* @__PURE__ */ e.createElement(
  P,
  {
    className: z1.header,
    style: { backgroundColor: Rt[n].header.backgroundColor },
    alignSelf: "stretch",
    alignItems: "center"
  },
  /* @__PURE__ */ e.createElement(hd, { iconComponent: r, type: n }),
  /* @__PURE__ */ e.createElement(B, null),
  /* @__PURE__ */ e.createElement(y, { type: "h5", color: Rt[n].header.color }, t)
), ud = ({ step: r, stepCount: t, onClose: n, onSubmit: a }) => {
  const l = typeof n == "function" && r && t && r !== t, o = r && t ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(y, { type: "body-sm", color: v.blackLighter4 }, r, " of ", t), /* @__PURE__ */ e.createElement(B, null)) : null;
  return l ? /* @__PURE__ */ e.createElement(P, { className: z1.footer, justifyContent: "space-between" }, /* @__PURE__ */ e.createElement(Ne, { type: "secondary", onClick: n }, "Close"), /* @__PURE__ */ e.createElement(P, { alignItems: "center" }, o, /* @__PURE__ */ e.createElement(J, { type: "tertiary", onClick: a }, "Next"))) : /* @__PURE__ */ e.createElement(P, { className: z1.footer, justifyContent: "flex-end", alignItems: "center" }, o, /* @__PURE__ */ e.createElement(J, { type: "tertiary", onClick: a }, "Done"));
}, Q2 = ({
  testId: r,
  type: t,
  step: n,
  stepCount: a,
  heading: l,
  message: o,
  onClose: s,
  onSubmit: d,
  iconComponent: c
}) => /* @__PURE__ */ e.createElement(P, { className: z1.container, flexDirection: "column", testId: r }, /* @__PURE__ */ e.createElement(pd, { type: t, heading: l, iconComponent: c }), /* @__PURE__ */ e.createElement(F, { factor: 1 }), /* @__PURE__ */ e.createElement(y, { type: "body-sm" }, o), /* @__PURE__ */ e.createElement(F, { factor: 3 }), /* @__PURE__ */ e.createElement(
  ud,
  {
    step: n,
    stepCount: a,
    onClose: s,
    onSubmit: d
  }
));
Q2.propTypes = {
  testId: i.string,
  type: i.oneOf(["default", "education"]),
  iconComponent: i.node,
  step: i.number,
  stepCount: i.number,
  heading: i.string,
  message: i.oneOfType([i.string, i.node]),
  onClose: i.func,
  onSubmit: i.func
};
Q2.defaultProps = {
  testId: "volt-popover-content",
  type: "default",
  step: 0,
  stepCount: 0
};
const Cd = (r) => {
  const t = {
    container: {},
    dummyChild: {}
  };
  if (!r)
    return t;
  const n = window.pageYOffset ? r.top + window.pageYOffset : r.top, a = window.pageXOffset ? r.left + window.pageXOffset : r.left, l = {
    position: "absolute",
    pointerEvents: "none",
    top: n,
    left: a
  }, o = {
    height: r.height,
    width: r.width
  };
  return { container: l, dummyChild: o };
}, gd = (r) => {
  const [t, n] = z(r ? r.getBoundingClientRect() : null), a = E1(() => {
    !r || !r.getBoundingClientRect || n(r.getBoundingClientRect());
  }, [r]);
  return P0(() => {
    if (r)
      if (a(), typeof ResizeObserver == "function") {
        let l = new ResizeObserver(() => a());
        return l.observe(r), () => {
          l && (l.disconnect(), l = null);
        };
      } else
        return window.addEventListener("resize", a), () => {
          window.removeEventListener("resize", a);
        };
  }, [r, a]), Cd(t);
}, f3 = ({
  children: r,
  type: t,
  selector: n,
  content: a,
  contentClassName: l,
  caretClassName: o,
  direction: s,
  testId: d,
  ...c
}) => {
  const m = document.querySelector(n), { container: h, dummyChild: p } = gd(m);
  if (n && !m)
    return r || null;
  const u = ({ children: C }) => /* @__PURE__ */ e.createElement(
    Q1,
    {
      testId: d,
      content: a || /* @__PURE__ */ e.createElement(Q2, { type: t, ...c }),
      direction: s,
      contentClassName: l || w1.popoverContent,
      caretClassName: o || Rt[t].caret[s] || w1.popoverCaretDefault,
      hasActionableContent: !0,
      pointerEvents: !0,
      ...c
    },
    C
  );
  return n && m ? /* @__PURE__ */ e.createElement(b1, null, /* @__PURE__ */ e.createElement("div", { style: h }, /* @__PURE__ */ e.createElement(u, null, /* @__PURE__ */ e.createElement("div", { style: p })))) : /* @__PURE__ */ e.createElement(u, null, r);
};
f3.propTypes = {
  selector: i.string,
  // This is EXPERIMENTAL feature, please use it sparingly
  type: i.oneOf(["default", "education"]),
  step: i.number,
  stepCount: i.number,
  heading: i.string,
  message: i.oneOfType([i.string, i.node]),
  onClose: i.func,
  onSubmit: i.func,
  content: i.any,
  direction: i.string,
  width: i.number,
  defaultActive: i.bool,
  pointerEvents: i.bool,
  fixOverflow: i.bool,
  textWrap: i.bool,
  disabled: i.bool,
  testId: i.string,
  clickOnly: i.bool,
  portalZIndex: i.number,
  zIndex: i.number,
  className: i.string,
  preventAnimation: i.bool,
  hasActionableContent: i.bool
};
f3.defaultProps = {
  type: "default",
  direction: "bottom",
  defaultActive: !1,
  pointerEvents: !0,
  fixOverflow: !1,
  textWrap: !0,
  disabled: !1,
  testId: "volt-popover",
  clickOnly: !1,
  portalZIndex: void 0,
  zIndex: void 0,
  className: "",
  preventAnimation: !0,
  hasActionableContent: !0
};
const fd = "_barGraph_3k0kw_1", Ed = "_progressBar_3k0kw_7", Ld = "_stripes_3k0kw_15", W1 = {
  barGraph: fd,
  progressBar: Ed,
  stripes: Ld,
  "animate-stripes": "_animate-stripes_3k0kw_1"
};
function K2({ currentCount: r, height: t, totalCount: n, foregroundColor: a }) {
  const l = {
    backgroundColor: a,
    width: `${r / n * 100}%`,
    borderRadius: t
  };
  return /* @__PURE__ */ e.createElement("div", { className: W1.bar, style: l });
}
K2.propTypes = {
  currentCount: i.number,
  height: i.string,
  foregroundColor: i.string,
  totalCount: i.number
};
K2.defaultProps = {
  currentCount: 0,
  height: "24px",
  foregroundColor: "#3C33B2",
  totalCount: 1
};
function wd({ style: r }) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${W1.progressBar} ${W1.stripes}`,
      style: { height: r.height }
    },
    /* @__PURE__ */ e.createElement("span", { style: { borderRadius: r.borderRadius } })
  );
}
function E3({
  height: r,
  backgroundColor: t,
  currentCount: n,
  foregroundColor: a,
  loading: l,
  totalCount: o
}) {
  const s = { backgroundColor: t, height: r, borderRadius: r };
  if (l)
    return /* @__PURE__ */ e.createElement(wd, { style: s });
  const d = { currentCount: n, totalCount: o, foregroundColor: a, height: r };
  return /* @__PURE__ */ e.createElement("div", { className: W1.barGraph, style: s }, /* @__PURE__ */ e.createElement(K2, { ...d }));
}
E3.propTypes = {
  backgroundColor: i.string,
  currentCount: i.number,
  foregroundColor: i.string,
  height: i.any,
  loading: i.bool,
  totalCount: i.number
};
E3.defaultProps = {
  backgroundColor: "#efeff2",
  currentCount: 0,
  foregroundColor: "#2100d9",
  height: "24px",
  loading: !1,
  totalCount: 1
};
const vd = "_root_r7wvz_1", yd = "_leftSpacing_r7wvz_7", bd = "_errorWrap_r7wvz_11", Ad = "_container_r7wvz_15", Hd = "_inline_r7wvz_20", xd = "_stretch_r7wvz_24", a1 = {
  root: vd,
  leftSpacing: yd,
  errorWrap: bd,
  container: Ad,
  inline: Hd,
  stretch: xd
};
function J2({
  name: r,
  value: t,
  label: n,
  error: a,
  testId: l,
  active: o,
  disabled: s,
  onChange: d,
  className: c,
  hasChangedType: m,
  bordered: h
}) {
  const p = e.useCallback(() => {
    d && d(t);
  }, [d, t]);
  return /* @__PURE__ */ e.createElement(
    q2,
    {
      testId: l,
      type: a ? "error" : "default",
      label: n,
      name: r,
      value: t,
      active: o,
      disabled: s,
      onClick: p,
      className: c,
      hasChangedType: m,
      bordered: h
    }
  );
}
J2.propTypes = {
  error: i.bool,
  active: i.bool,
  testId: i.string,
  name: i.string,
  value: i.oneOfType([i.string, i.array]).isRequired,
  label: i.string.isRequired,
  disabled: i.bool,
  className: i.string,
  onChange: i.func,
  hasChangedType: i.string,
  bordered: i.bool
};
J2.defaultProps = {
  testId: "voltron-radio-group-item",
  name: "",
  label: "",
  onChange: null,
  disabled: !1,
  bordered: !1
};
const Md = e.memo(J2);
function L3({
  groupName: r,
  groupItems: t,
  label: n,
  subLabel: a,
  disabled: l,
  error: o,
  value: s,
  onChange: d,
  className: c,
  testId: m,
  renderRadioItem: h,
  customErrorMessage: p,
  hasChangedType: u,
  id: C,
  inline: E,
  bordered: g
}) {
  return C || (C = Pe("radio-group-")), /* @__PURE__ */ e.createElement(
    "fieldset",
    {
      role: "radiogroup",
      className: M(a1.root, c),
      "data-testid": m,
      "aria-labelledby": C
    },
    /* @__PURE__ */ e.createElement(ue, { as: "legend", subLabel: a, hasChangedType: u, id: C }, n),
    /* @__PURE__ */ e.createElement("div", { className: M({ [a1.leftSpacing]: !g }) }, /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": `${m}-items`,
        className: M(a1.container, { [a1.inline]: E })
      },
      t.map((L, x) => /* @__PURE__ */ e.createElement(e.Fragment, { key: `${x}` }, h({
        onChange: d,
        name: r,
        value: L.value,
        label: L.label,
        error: !!o,
        testId: W3(Array, L.value) ? `${m}-array-item-${x}` : `${m}-item-${L.value}`,
        active: o1(s, L.value),
        disabled: l || L.disabled,
        className: M(L.className, { [a1.stretch]: g }),
        hasChangedType: u,
        bordered: g
      }), t.length - 1 > x && (E ? /* @__PURE__ */ e.createElement(B, { factor: g ? 1 : 4 }) : /* @__PURE__ */ e.createElement(F, null))))
    ), o && /* @__PURE__ */ e.createElement("div", { className: a1.errorWrap }, /* @__PURE__ */ e.createElement(ae, { testId: `${m}-error` }, p || o)))
  );
}
L3.propTypes = {
  id: i.string,
  testId: i.string,
  className: i.string,
  label: i.node,
  subLabel: i.string,
  onChange: i.func,
  disabled: i.bool,
  error: i.string,
  value: i.oneOfType([i.string, i.array, i.bool]),
  groupName: i.string,
  renderRadioItem: i.func,
  groupItems: i.arrayOf(
    i.shape({
      value: i.oneOfType([i.string, i.bool]),
      label: i.oneOfType([i.string, i.node]),
      disabled: i.bool,
      className: i.string
    })
  ),
  customErrorMessage: i.string,
  hasChangedType: i.string,
  inline: i.bool,
  bordered: i.bool
};
L3.defaultProps = {
  kind: "radioGroup",
  testId: "voltron-radio-group",
  groupName: "radio-group",
  groupItems: [],
  label: "",
  onChange: null,
  disabled: !1,
  renderRadioItem: (r) => /* @__PURE__ */ e.createElement(Md, { ...r }),
  customErrorMessage: "",
  inline: !1,
  bordered: !1
};
const Vd = "_radioOuter_ypi2h_1", Dd = "_errorWrap_ypi2h_26", Fd = "_active_ypi2h_31", kd = "_disabled_ypi2h_41", Zd = "_noOnClick_ypi2h_45", Bd = "_radioInner_ypi2h_50", r1 = {
  radioOuter: Vd,
  errorWrap: Dd,
  active: Fd,
  disabled: kd,
  noOnClick: Zd,
  radioInner: Bd
};
function Od({ active: r, disabled: t, error: n, hasChangedType: a }) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: M(r1.radioOuter, {
        [r1.active]: r,
        [r1.disabled]: !a && t,
        [r1.errorWrap]: n
      })
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: M(r1.radioInner, {
          [r1.disabled]: !a && t && r
        })
      }
    )
  );
}
function q2(r) {
  return /* @__PURE__ */ e.createElement(A1, { mask: Od, ...r });
}
q2.propTypes = {
  ...$1,
  active: i.bool
};
q2.defaultProps = {
  ..._1,
  inputType: "radio",
  kind: "radio",
  name: "radio-group",
  testId: W.radio
};
const Sd = "_wrap_1i4yi_1", Id = "_labelWrap_1i4yi_6", Pd = "_options_1i4yi_10", Nd = "_option_1i4yi_10", Rd = "_optionButton_1i4yi_25", Td = "_active_1i4yi_50", Ud = "_disabled_1i4yi_63", Gd = "_error_1i4yi_79", Te = {
  wrap: Sd,
  labelWrap: Id,
  options: Pd,
  option: Nd,
  optionButton: Rd,
  active: Td,
  disabled: Ud,
  error: Gd
};
class w3 extends N {
  constructor(n) {
    super(n);
    // TODO:
    // Need to change: set to state NOT index, but option.name
    // Need to remove calling option.onClick, but leave props.onClick
    Le(this, "selectOption", (n) => {
      const { options: a, onClick: l } = this.props, o = a[n];
      l && l(o.name), o.onClick && o.onClick(), this.setState({ activeIndex: n });
    });
    Le(this, "isOptionSelected", (n, a) => n.active || this.state.activeIndex === a);
    this.state = {
      error: null,
      activeIndex: n.options.findIndex(
        (a) => a.name && n.value ? a.name === n.value : a.active
      )
    }, this.controlId = Pe("volt-segmentedbuttons_");
  }
  // lifecycle & helpers
  componentDidMount() {
    const { runIsErrorOnLoad: n } = this.props;
    n && this.checkIsError();
  }
  checkIsError() {
    const { isError: n, value: a } = this.props;
    n && this.setState({ error: n(a) });
  }
  renderOptions() {
    const { options: n, disabled: a, error: l } = this.props, o = M(Te.options, { [Te.disabled]: a });
    return /* @__PURE__ */ e.createElement("div", { className: o, "data-testid": "options-container", id: this.controlId }, n.map((s, d) => {
      const c = this.isOptionSelected(s, d), m = M(Te.option, {
        [Te.active]: c,
        [Te.error]: !!l
      });
      return /* @__PURE__ */ e.createElement("div", { key: d, className: m }, /* @__PURE__ */ e.createElement(
        "button",
        {
          className: M(Te.optionButton, { [Te.active]: c }),
          onClick: () => this.selectOption(d),
          disabled: a,
          "data-testid": c ? "active" : "inactive"
        },
        s.text
      ));
    }));
  }
  renderLabel() {
    const { label: n, sublabel: a, labelSize: l, labelOptional: o, labelTooltip: s } = this.props;
    if (n)
      return /* @__PURE__ */ e.createElement(
        ue,
        {
          subLabel: a,
          size: l,
          optional: o,
          tooltip: s
        },
        n
      );
  }
  getError() {
    const { error: n } = this.state, { error: a, customErrorMessage: l } = this.props;
    if (n || a)
      return n || l || a;
  }
  render() {
    const { width: n, testId: a, preventErrorPushdown: l, label: o } = this.props, s = this.getError();
    return /* @__PURE__ */ e.createElement("div", { style: n ? { width: n } : {}, className: Te.wrap, "data-testid": a }, this.renderLabel(), this.renderOptions(), /* @__PURE__ */ e.createElement(ae, { testId: `${o}-segmented-error`, preventErrorPushdown: l }, s));
  }
}
w3.propTypes = {
  options: i.arrayOf(i.object).isRequired,
  label: i.any,
  kind: i.string,
  sublabel: i.string,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  labelTooltip: i.any,
  disabled: i.bool,
  width: i.any,
  testId: i.string,
  onClick: i.func,
  value: i.any
};
w3.defaultProps = {
  options: [],
  label: null,
  kind: "segmentedButtons",
  sublabel: null,
  labelSize: "small",
  labelOptional: !1,
  labelTooltip: null,
  disabled: !1,
  width: "100%",
  testId: "volt-segmented-buttons",
  onClick: null
};
const zd = "_wrap_23yjl_1", Wd = "_inputWrap_23yjl_12", jd = "_input_23yjl_12", Xd = "_valueSelected_23yjl_36", Yd = "_disabled_23yjl_40", Qd = "_errorWrap_23yjl_40", Kd = "_changed_23yjl_40", Jd = "_completed_23yjl_40", qd = "_noOnchange_23yjl_40", $d = "_focused_23yjl_50", _d = "_disabledWrap_23yjl_65", ec = "_focusedWrap_23yjl_79", tc = "_label_23yjl_84", nc = "_instructions_23yjl_93", ac = "_error_23yjl_40", rc = "_option_23yjl_114", ic = "_optionLastChild_23yjl_130", lc = "_optionText_23yjl_135", oc = "_noHover_23yjl_139", sc = "_selectCandidate_23yjl_152", dc = "_selected_23yjl_156", cc = "_optionsWrap_23yjl_160", mc = "_optionsScroll_23yjl_172", hc = "_chevron_23yjl_177", pc = "_portal_23yjl_195", uc = "_dummyOptions_23yjl_199", Cc = "_selectedOptionRender_23yjl_205", gc = "_searchContainer_23yjl_226", fc = "_searchInput_23yjl_237", Ec = "_searchIcon_23yjl_261", Lc = "_cancelSearchIcon_23yjl_267", wc = "_loadingWrapper_23yjl_274", vc = "_noOption_23yjl_282", R = {
  wrap: zd,
  inputWrap: Wd,
  input: jd,
  valueSelected: Xd,
  disabled: Yd,
  errorWrap: Qd,
  changed: Kd,
  completed: Jd,
  noOnchange: qd,
  focused: $d,
  disabledWrap: _d,
  focusedWrap: ec,
  label: tc,
  instructions: nc,
  error: ac,
  option: rc,
  optionLastChild: ic,
  optionText: lc,
  noHover: oc,
  selectCandidate: sc,
  selected: dc,
  optionsWrap: cc,
  optionsScroll: mc,
  chevron: hc,
  portal: pc,
  dummyOptions: uc,
  selectedOptionRender: Cc,
  searchContainer: gc,
  searchInput: fc,
  searchIcon: Ec,
  cancelSearchIcon: Lc,
  loadingWrapper: wc,
  noOption: vc
};
class $2 extends N {
  constructor(t) {
    super(t), this.state = {
      focused: !1,
      selectCandidate: "",
      search: "",
      error: "",
      optionsPositionLeft: null,
      optionsPositionTop: null,
      optionsPositionRight: null,
      style: {}
    }, this.handleOptionClick = this.handleOptionClick.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.updateOptionsPosition = this.updateOptionsPosition.bind(this), this.optionsWrap = e.createRef(), this.selectedOption = e.createRef(), this.wrap = e.createRef(), this.dummyOptions = e.createRef(), this.searchTimerRunner = null, this.searchTimer = 0, this.eventListenersSetup = !1, this.initialFocus = !1, this.inputId = this.props.id || Pe("volt-select__"), this.input = e.createRef();
  }
  componentDidMount() {
    const { runValidatorOnLoad: t, fixOverflow: n, backgroundColor: a } = this.props;
    t && this.checkIsError(), n && (this.updateOptionsPosition(), this.setupPortalEventListeners()), a && this.setState({
      style: {
        ...this.state.style,
        backgroundColor: a
      }
    }), document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    this.teardownPortalEventListeners(), document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(t, n) {
    const { fixOverflow: a, backgroundColor: l } = this.props, { error: o, search: s, selectCandidate: d } = this.state;
    o && this.checkIsError(), s !== n.search && this.pickSelectCandidateBasedOnSearch(), d !== n.selectCandidate && this.scrollToSelectCandidate(), a && (this.updateOptionsPosition(), this.eventListenersSetup || this.setupPortalEventListeners()), l !== t.backgroundColor && this.setState({
      style: {
        ...this.state.style,
        backgroundColor: l
      }
    });
  }
  // helpers
  updateOptionsPosition() {
    const { optionsPositionLeft: t, optionsPositionTop: n, optionsPositionRight: a } = this.state;
    try {
      const { left: l, right: o, top: s } = this.dummyOptions.current.querySelector(".volt-options-wrap-hook").getBoundingClientRect();
      (t !== l || n !== s || a !== o) && this.setState({
        optionsPositionLeft: l,
        optionsPositionTop: s,
        optionsPositionRight: o
      });
    } catch (l) {
      console.error("Select portal options position calc failed:", l);
    }
  }
  setupPortalEventListeners() {
    typeof window < "u" && (window.addEventListener("resize", this.updateOptionsPosition), window.addEventListener("scroll", this.updateOptionsPosition)), this.eventListenersSetup = !0;
  }
  teardownPortalEventListeners() {
    typeof window < "u" && (window.removeEventListener("resize", this.updateOptionsPosition), window.removeEventListener("scroll", this.updateOptionsPosition));
  }
  checkIsError() {
    const { isError: t, value: n, fixOverflow: a, runValidatorOnLoad: l } = this.props;
    if (!l && !this.initialFocus)
      return;
    const o = t ? t(n) : "";
    this.state.error !== o && this.setState({ error: o || "" }, () => {
      a && this.updateOptionsPosition();
    });
  }
  getOptionVal(t) {
    if (typeof t == "string")
      return t;
    if (typeof t == "object" && typeof t.val < "u")
      return t.val;
  }
  getUpperOptionValString(t) {
    const n = this.getOptionVal(t);
    return typeof n == "string" ? n.toUpperCase() : "";
  }
  getSortedOptions() {
    const { options: t, sortOptions: n } = this.props;
    return n ? t ? t.sort((a, l) => {
      const o = this.getUpperOptionValString(a), s = this.getUpperOptionValString(l);
      return o > s ? 1 : -1;
    }) : [] : t || [];
  }
  getFilteredOptions() {
    const { search: t } = this.state, { searchableOptions: n, searchableOptionsMaxDisplayNum: a } = this.props;
    let l = this.getSortedOptions();
    if (!t)
      return l;
    n && (l = [.../* @__PURE__ */ new Set([...l, ...n])]);
    const o = l.filter((s) => s.searchString ? s.searchString.toUpperCase().includes(t.toUpperCase()) : typeof s == "string" ? s.toUpperCase().includes(t.toUpperCase()) : s.val ? s.val.toUpperCase().includes(t.toUpperCase()) : !0);
    return n ? o.slice(0, a) : o;
  }
  pickSelectCandidateBasedOnSearch() {
    const t = this.getSortedOptions(), { search: n } = this.state;
    let a = [];
    const l = n.toUpperCase(), o = t.filter((s) => {
      const d = this.getUpperOptionValString(s);
      return d === l && a.push(s), l ? d.startsWith(l) : !0;
    });
    a && a[0] ? this.setState({ selectCandidate: a[0] }) : o && o[0] && this.setState({ selectCandidate: o[0] });
  }
  acceptSelectOptionCandidate() {
    const { onChange: t } = this.props, { selectCandidate: n } = this.state;
    t && n && (t(n), this.setState({ search: "" }), this.handleBlur());
  }
  scrollToSelectCandidate() {
    try {
      const t = this.optionsWrap.current, n = this.selectedOption.current, a = t.getBoundingClientRect(), l = {
        height: t.clientHeight,
        width: t.clientWidth
      }, o = n.getBoundingClientRect();
      o.top >= a.top && o.top <= a.top + l.height || (t.scrollTop = o.top + t.scrollTop - a.top);
    } catch {
    }
  }
  selectedIndex() {
    const { selectCandidate: t } = this.state;
    return this.getSortedOptions().indexOf(t);
  }
  selectNext() {
    const { focused: t } = this.state, n = this.getSortedOptions();
    if (t) {
      const a = this.selectedIndex();
      a === -1 ? this.setState({ selectCandidate: n[0] }) : a + 1 < n.length ? this.setState({
        selectCandidate: n[a + 1]
      }) : this.setState({ selectCandidate: n[0] });
    }
  }
  selectPrevious() {
    const { focused: t } = this.state, n = this.getSortedOptions();
    if (t) {
      const a = this.selectedIndex();
      a === -1 ? this.setState({ selectCandidate: n[0] }) : a !== 0 ? this.setState({
        selectCandidate: n[a - 1]
      }) : this.setState({ selectCandidate: n[n.length - 1] });
    }
  }
  clearValue() {
    const { onChange: t } = this.props, { search: n } = this.state;
    if (t && t(""), this.searchTimerRunner && this.searchTimer < 1) {
      clearTimeout(this.searchTimerRunner);
      const a = n ? n.slice(0, -1) : "";
      this.setSearchTimeout(a);
    } else
      this.searchTimer = 0, this.setState({ search: "" });
  }
  get calculatedMaxHeight() {
    const { numOptions: t } = this.props;
    return t * 36 + 28;
  }
  // handlers
  handleFocus() {
    const { disabled: t, hasChangedType: n } = this.props;
    n && t || (this.input && this.input.current && document && this.input.current !== document.activeElement && this.input.current.focus(), this.initialFocus = !0, this.setState({ focused: !0 }));
  }
  handleBlur() {
    this.setState({ focused: !1 }), this.checkIsError();
  }
  setSearchTimeout(t) {
    this.searchTimerRunner = setTimeout(() => this.searchTimer += 1, 1e3), this.setState({ search: t });
  }
  handleKeyDown(t) {
    const n = t && t.key;
    n === "ArrowDown" ? this.selectNext() : n === "ArrowUp" ? this.selectPrevious() : n === "Tab" ? (this.handleBlur(), this.resetPlaceholder()) : n === "Enter" && this.acceptSelectOptionCandidate();
  }
  resetPlaceholder() {
    this.setState({
      selectCandidate: ""
    });
  }
  handleOptionClick(t) {
    const { onChange: n, disableOptionHandleBlur: a, disableOptionSearchClear: l } = this.props;
    n && n(t), l || this.setState({ search: "" }), a || this.handleBlur();
  }
  handleClickOutside(t) {
    const { focused: n } = this.state;
    if (n) {
      const a = this.wrap && this.wrap.current && this.wrap.current.contains(t.target), l = this.optionsWrap && this.optionsWrap.current && this.optionsWrap.current.contains(t.target);
      !a && !l && this.handleBlur();
    }
  }
  // renderers
  renderLabel() {
    const { label: t, labelSize: n, labelOptional: a, sublabel: l, labelTooltip: o, hasChangedType: s, disabled: d } = this.props;
    return /* @__PURE__ */ e.createElement(
      ue,
      {
        labelFor: this.inputId,
        size: n,
        optional: a,
        subLabel: l,
        tooltip: o,
        hasChangedType: s
      },
      t
    );
  }
  renderSelectedOptionRender() {
    const { value: t } = this.props, n = t !== null && typeof t == "object";
    if (!n && t && t.renderSelected && typeof t.renderSelected != "string" && console.error("Select option renderSelected only accepts string as a value"), n && (t.render || t.renderSelected))
      return /* @__PURE__ */ e.createElement("div", { className: R.selectedOptionRender }, t.renderSelected || t.render);
  }
  renderDropdownToggleInput() {
    const {
      placeholder: t,
      disabled: n,
      value: a,
      label: l,
      dropdownToggleInputOverride: o,
      hasChangedType: s,
      options: d
    } = this.props, { focused: c, selectCandidate: m, style: h } = this.state, p = a !== null && typeof a == "object", u = d.find((w) => typeof w == "object" ? w.val === a : w === a), E = (typeof u == "object" ? u.render : u) || a || "", g = p ? "" : E, L = c ? this.handleBlur : this.handleFocus, x = this.getError(), A = R[s], Z = !s && n, D = {
      id: this.inputId,
      disabled: Z,
      onFocus: this.handleFocus,
      onKeyDown: this.handleKeyDown,
      onMouseDown: L,
      // if value is an object, there is different logic for rendering it other than
      // just passing it to the input as "value". therefore, the placeholder text
      // needs to be hidden
      placeholder: (!p || p && !a.render && !a.renderSelected) && t ? t : "",
      value: g,
      focused: c
    }, f = M(R.input, {
      [A]: A,
      [R.disabled]: Z,
      [R.focused]: c,
      [R.errorWrap]: x,
      [R.valueSelected]: g,
      [R.noOnchange]: n
    });
    return o ? e.cloneElement(o, {
      ...D
    }) : /* @__PURE__ */ e.createElement(
      "input",
      {
        className: f,
        "data-testid": `volt-select__${typeof l == "string" ? l : ""}-${Z ? "disabled" : "enabled"}`,
        onChange: () => {
        },
        spellCheck: "false",
        style: h,
        ...D
      }
    );
  }
  renderChevron() {
    const { disabled: t, dropdownToggleInputOverride: n } = this.props;
    return n ? null : /* @__PURE__ */ e.createElement("div", { className: `${R.chevron}` }, /* @__PURE__ */ e.createElement(V, { type: "caret-down", mod: t ? "disabled" : "default" }));
  }
  getError() {
    const { error: t } = this.state, { error: n } = this.props;
    return t || n;
  }
  renderError() {
    const { preventErrorPushdown: t } = this.props, n = this.getError();
    return /* @__PURE__ */ e.createElement(ae, { preventErrorPushdown: t }, n);
  }
  renderOption(t, n, a, l, o) {
    const s = this.getOptionVal(t), d = n === s, c = a === t, m = c ? { ref: this.selectedOption } : {}, h = typeof t == "string", p = h ? /* @__PURE__ */ e.createElement(y, { className: R.optionText }, t) : t.render, u = !h && t.id, C = {
      className: M(R.option, {
        [R.selected]: d,
        [R.selectCandidate]: c,
        [R.optionLastChild]: o
      }),
      "data-testid": c ? "is-select-candidate" : "not-select-candidate",
      key: u || l,
      onClick: this.handleOptionClick.bind(this, t),
      onKeyDown: this.handleKeyDown
    };
    if (!h && e.isValidElement(t.render)) {
      const E = {
        ...C,
        ...t.render.props
      }, g = e.cloneElement(t.render, E);
      return /* @__PURE__ */ e.createElement("div", { ...m }, g);
    }
    return /* @__PURE__ */ e.createElement("div", { ...C, ...m }, /* @__PURE__ */ e.createElement(y, { className: R.optionText }, p));
  }
  /**
    This is custom made for program selector
    <Select /> currently doesn't have loading design
    Working with design team to create a select loading design
    Since this is not an official design
    <Select /> loading state will not be added to baseSelectScreen
    it should be avoid outside of the use case of programSelector until it's official
    Tracked here: https://marqeta.atlassian.net/browse/PS-13653
  */
  renderLoading() {
    return /* @__PURE__ */ e.createElement("div", { className: R.loadingWrapper, "data-testid": "select-v2-loading" }, /* @__PURE__ */ e.createElement(ze, { active: !0 }));
  }
  renderOptions(t = {}, n = !1) {
    const { value: a, dropDownWrap: l, anchor: o, width: s, showSearch: d, loading: c, numOptions: m } = this.props, { focused: h, selectCandidate: p, search: u } = this.state;
    if (!h && !n)
      return null;
    const C = this.getFilteredOptions(), E = C.map((Z, D) => {
      const f = C.length - 1 === D;
      return /* @__PURE__ */ e.createElement(Wt, { key: `select-option-${D}` }, this.renderOption(Z, a, p, D, f));
    });
    Object.assign(
      {},
      { maxHeight: this.calculatedMaxHeight },
      o === "right" ? { right: "0" } : {},
      t
    );
    const g = {
      ...l,
      width: l.width || s
    }, L = C.length ? C.length >= m - 1 ? m * 40 - 20 : C.length * 40 : 40, x = {
      ...l,
      margin: 0,
      // the margin should always depend on it's parent wrap
      maxHeight: this.calculatedMaxHeight,
      width: l.width || s,
      height: c ? "200px" : l.height || `${L}px`
    }, A = () => c ? this.renderLoading() : E.length ? /* @__PURE__ */ e.createElement("div", { className: R.options, "data-testid": "volt-select-options" }, E) : /* @__PURE__ */ e.createElement("div", { className: `${R.noOption}`, "data-testid": "volt-select-no-results" }, /* @__PURE__ */ e.createElement(y, { mod: "disabled" }, "No results found"));
    return /* @__PURE__ */ e.createElement("div", { className: `${R.optionsWrap} volt-options-wrap-hook`, style: g }, this.renderSearch(), /* @__PURE__ */ e.createElement("div", { className: R.optionsScroll, style: x, ref: this.optionsWrap }, A()));
  }
  renderPortalOptions() {
    const { fixOverflow: t, width: n, anchor: a } = this.props, { optionsPositionLeft: l, optionsPositionTop: o, optionsPositionRight: s } = this.state;
    if (!t)
      return null;
    const d = a === "right" ? {
      left: 0,
      right: s,
      minWidth: 0,
      width: `calc(${s}px + ${n})`
    } : { left: l }, c = { width: n, ...d, top: o };
    return /* @__PURE__ */ e.createElement(b1, null, this.renderOptions(c));
  }
  renderDummyOptions() {
    const { fixOverflow: t } = this.props;
    return t ? /* @__PURE__ */ e.createElement("div", { className: R.dummyOptions, ref: this.dummyOptions }, this.renderOptions({}, !0)) : null;
  }
  renderSearch() {
    const { disabled: t, showSearch: n } = this.props, { search: a } = this.state;
    return n ? /* @__PURE__ */ e.createElement("div", { className: R.searchContainer }, /* @__PURE__ */ e.createElement("div", { className: R.searchIcon }, /* @__PURE__ */ e.createElement(V, { type: "search", factor: 0, noHoverEffects: !0 })), /* @__PURE__ */ e.createElement(
      "input",
      {
        className: R.searchInput,
        disabled: t,
        onChange: (l) => this.setState({ search: l.target.value }),
        onKeyDown: this.handleKeyDown,
        placeholder: "Search",
        ref: this.input,
        "data-testid": "select-input",
        value: a,
        spellCheck: !1,
        tabIndex: 0
      }
    ), a && /* @__PURE__ */ e.createElement("div", { className: R.cancelSearchIcon, onClick: (l) => this.setState({ search: "" }) }, /* @__PURE__ */ e.createElement(V, { type: "clear", factor: 0, noHoverEffects: !0 }))) : null;
  }
  render() {
    const { width: t, disabled: n, testId: a, hasChangedType: l } = this.props, { focused: o } = this.state, s = !l && n;
    return /* @__PURE__ */ e.createElement("form", { "data-testid": a, autoComplete: "off", onSubmit: (d) => d.preventDefault() }, /* @__PURE__ */ e.createElement(
      "div",
      {
        style: t ? { width: t } : {},
        className: `
            ${R.wrap}
            ${s ? R.disabledWrap : ""}
            ${o ? R.focusedWrap : ""}
          `,
        id: this.id,
        ref: this.wrap
      },
      this.renderLabel(),
      /* @__PURE__ */ e.createElement("div", { className: R.inputWrap }, this.renderDropdownToggleInput(), this.renderSelectedOptionRender(), this.renderChevron(), this.renderOptions(), this.renderDummyOptions(), this.renderPortalOptions()),
      this.renderError()
    ));
  }
}
$2.propTypes = {
  id: i.string,
  label: i.any,
  sublabel: i.any,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  value: i.any,
  options: i.any,
  searchableOptions: i.array,
  width: i.any,
  onChange: i.func,
  isError: i.func,
  disabled: i.bool,
  runValidatorOnLoad: i.bool,
  anchor: i.string,
  sortOptions: i.bool,
  numOptions: i.number,
  fixOverflow: i.bool,
  preventErrorPushdown: i.bool,
  dropDownWrap: i.object,
  testId: i.string,
  kind: i.string,
  labelIcon: i.any,
  showSearch: i.bool,
  placeholder: i.string,
  labelTooltip: i.node,
  error: i.oneOfType([i.string, i.bool]),
  dropdownToggleInputOverride: i.node,
  loading: i.bool,
  disableOptionSearchClear: i.bool,
  hasChangedType: i.string,
  searchableOptionsMaxDisplayNum: i.number,
  backgroundColor: i.string
};
$2.defaultProps = {
  id: null,
  label: "",
  sublabel: "",
  labelSize: "small",
  labelOptional: !1,
  options: [],
  searchableOptions: [],
  width: null,
  runValidatorOnLoad: !1,
  anchor: "left",
  sortOptions: !1,
  numOptions: 6,
  fixOverflow: !1,
  preventErrorPushdown: !1,
  dropDownWrap: {},
  testId: W.select,
  kind: "select",
  labelIcon: null,
  showSearch: !1,
  placeholder: "Select from options",
  labelTooltip: null,
  error: "",
  dropdownToggleInputOverride: null,
  loading: null,
  disableOptionSearchClear: !1,
  searchableOptionsMaxDisplayNum: U0,
  backgroundColor: null
};
const dt = $2, yc = "_wrap_lx2ob_2", bc = "_button_lx2ob_9", Ac = "_disabledWrap_lx2ob_34", Hc = "_primary_lx2ob_40", xc = "_loading_lx2ob_45", Mc = "_secondary_lx2ob_60", Vc = "_mainButton_lx2ob_66", Dc = "_dropdownButton_lx2ob_70", Fc = "_tertiary_lx2ob_86", kc = "_content_lx2ob_126", Zc = "_loader_lx2ob_140", Bc = "_dropdownContainer_lx2ob_166", Oc = "_dropdownContent_lx2ob_174", Sc = "_below_lx2ob_184", Ic = "_above_lx2ob_189", Pc = "_chevron_lx2ob_200", Nc = "_isDropdownShown_lx2ob_211", Rc = "_option_lx2ob_215", Tc = "_selectedOption_lx2ob_233", K = {
  wrap: yc,
  button: bc,
  disabledWrap: Ac,
  primary: Hc,
  loading: xc,
  secondary: Mc,
  mainButton: Vc,
  dropdownButton: Dc,
  tertiary: Fc,
  content: kc,
  loader: Zc,
  dropdownContainer: Bc,
  dropdownContent: Oc,
  below: Sc,
  above: Ic,
  chevron: Pc,
  isDropdownShown: Nc,
  option: Rc,
  selectedOption: Tc
};
class v3 extends j1 {
  constructor(t) {
    super(t), this.state = {
      isDropdownShown: !1,
      selectedOption: ""
    }, this.dropdownWrap = e.createRef(), this.dropdownOptionsWrap = e.createRef(), this.splitButtonWrap = e.createRef(), this.toggleDropdown = this.toggleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleOptionClick = this.handleOptionClick.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  get validType() {
    const { type: t } = this.props, n = t === "outline" ? "tertiary" : "primary";
    return ["primary", "secondary", "tertiary"].includes(t) ? t : n;
  }
  toggleDropdown() {
    this.setState({ isDropdownShown: !this.state.isDropdownShown });
  }
  handleBlur() {
    this.setState({ isDropdownShown: !1 });
  }
  handleClickOutside(t) {
    const { isDropdownShown: n } = this.state;
    if (!n)
      return;
    ![this.dropdownWrap, this.dropdownOptionsWrap].filter(
      (l) => {
        var o;
        return (o = l == null ? void 0 : l.current) == null ? void 0 : o.contains(t.target);
      }
    ).length && this.handleBlur();
  }
  handleKeyDown(t) {
    const n = t == null ? void 0 : t.key, a = {
      ArrowDown: () => {
        t.preventDefault(), this.selectNext();
      },
      ArrowUp: () => {
        t.preventDefault(), this.selectPrevious();
      },
      Tab: () => {
        this.handleBlur();
      },
      Enter: () => {
        this.executeSelectedOption();
      },
      Escape: () => {
        this.handleBlur(), this.setState({ selectedOption: "" });
      }
    };
    a[n] && a[n]();
  }
  selectNext() {
    const { isDropdownShown: t } = this.state, { options: n } = this.props;
    if (!t)
      return;
    const a = this.getSelectedOptionIndex();
    if (a === -1) {
      this.setState({ selectedOption: n[0] });
      return;
    }
    if (a + 1 < n.length) {
      this.setState({
        selectedOption: n[a + 1]
      });
      return;
    }
    this.setState({ selectedOption: n[0] });
  }
  selectPrevious() {
    const { isDropdownShown: t } = this.state, { options: n } = this.props;
    if (!t)
      return;
    const a = this.getSelectedOptionIndex();
    if (a === -1) {
      this.setState({ selectedOption: n[0] });
      return;
    }
    if (a !== 0) {
      this.setState({
        selectedOption: n[a - 1]
      });
      return;
    }
    this.setState({ selectedOption: n[n.length - 1] });
  }
  executeSelectedOption() {
    const { selectedOption: t } = this.state, { onOptionClick: n } = t;
    n && (n(), this.setState({ selectedOption: "" }));
  }
  getSelectedOptionIndex() {
    const { selectedOption: t } = this.state, { options: n } = this.props;
    return n.findIndex((a) => a.text === t.text);
  }
  handleOptionClick(t) {
    const { onOptionClick: n } = t;
    n && n(), this.handleBlur();
  }
  renderOptions() {
    var d, c;
    const t = {
      minWidth: (c = (d = this.splitButtonWrap) == null ? void 0 : d.current) == null ? void 0 : c.offsetWidth
    }, { options: n, dropdownPosition: a, dropdownCustomStyle: l } = this.props, { selectedOption: o, isDropdownShown: s } = this.state;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: this.dropdownOptionsWrap,
        className: M(K.dropdownContent, K[a], {
          [K.isDropdownShown]: s
        }),
        style: { dropDownStyle: t, ...l },
        "data-testid": "dropdown-container"
      },
      n.map((m) => {
        const h = o && o.text === m.text;
        return /* @__PURE__ */ e.createElement(
          y,
          {
            type: "body-sm",
            key: m.text,
            className: M(K.option, {
              [K.selectedOption]: h
            }),
            onClick: () => this.handleOptionClick(m),
            testId: `dropdown-item-${m.text}-${h ? "selected" : "not-selected"}`
          },
          m.text
        );
      })
    );
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  render() {
    const { children: t, disabled: n, loading: a, style: l, onClick: o, ignoreTabbing: s, testId: d, dropdownPosition: c } = this.props, { isDropdownShown: m } = this.state, h = this.validType, u = {
      secondary: v.actionColor,
      tertiary: v.blackLighter3,
      primary: v.white
    }[h], C = !n && a, E = `caret-${c === "above" && m ? "up" : "down"}`;
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: M(K.wrap, {
          [K.disabledWrap]: n
        }),
        "data-testid": d,
        ref: this.splitButtonWrap
      },
      /* @__PURE__ */ e.createElement(
        "button",
        {
          tabIndex: s ? "-1" : "0",
          className: M(
            K.button,
            K.mainButton,
            K[h] || "",
            this.props.className ? this.props.className : "",
            { [K.loading]: C }
          ),
          style: l,
          disabled: n,
          onClick: n || a ? null : o,
          "data-testid": `volt-button__${h}-${n ? "disabled" : "enabled"}`
        },
        /* @__PURE__ */ e.createElement("span", { className: K.content }, t),
        /* @__PURE__ */ e.createElement("span", { className: K.loader }, /* @__PURE__ */ e.createElement(
          ze,
          {
            testId: "volt-button",
            active: C,
            size: 20,
            color: u,
            transparentBackground: !0
          }
        ))
      ),
      this.renderOptions(),
      /* @__PURE__ */ e.createElement("div", { className: K.dropdownContainer, ref: this.dropdownWrap }, /* @__PURE__ */ e.createElement(
        "button",
        {
          onClick: this.toggleDropdown,
          onKeyDown: (g) => this.handleKeyDown(g),
          className: M(
            K.button,
            K.dropdownButton,
            K[h] || "",
            this.props.className ? this.props.className : "",
            { [K.loading]: C }
          ),
          "data-testid": `volt-button-dropdown__${h}-${n ? "disabled" : "enabled"}`
        },
        /* @__PURE__ */ e.createElement("div", { className: `${K.chevron}`, "data-testid": `split-button-caret-${c}` }, /* @__PURE__ */ e.createElement(V, { type: E, overrideColor: n ? v.blackLighter5 : u }))
      ))
    );
  }
}
v3.propTypes = {
  type: i.string,
  disabled: i.bool,
  loading: i.bool,
  style: i.object,
  testId: i.string,
  onClick: i.func,
  options: i.array,
  ignoreTabbing: i.bool,
  dropdownPosition: i.string,
  dropdownCustomStyle: i.object,
  children: i.any,
  className: i.any
};
v3.defaultProps = {
  type: "primary",
  disabled: !1,
  loading: !1,
  style: {},
  testId: W.button,
  onClick: () => {
  },
  options: [{ text: "", onOptionClick: () => {
  } }],
  ignoreTabbing: !1,
  dropdownPosition: "below",
  dropdownCustomStyle: {}
};
const Uc = "_statusbadge_58oa1_1", Gc = "_ring_58oa1_10", zc = "_success_58oa1_20", Wc = "_pending_58oa1_24", jc = "_warning_58oa1_28", Xc = "_error_58oa1_32", Yc = "_draft_58oa1_36", Dt = {
  statusbadge: Uc,
  ring: Gc,
  success: zc,
  pending: Wc,
  warning: jc,
  error: Xc,
  draft: Yc
}, _2 = (r) => {
  const { children: t, className: n, type: a, testId: l } = r, o = M(Dt.statusbadge, n), s = M(Dt.ring, Dt[a]);
  return /* @__PURE__ */ e.createElement(P, { alignItems: "center", className: o, testId: l }, /* @__PURE__ */ e.createElement("div", { className: s }), t);
};
_2.propTypes = {
  className: i.string,
  type: i.oneOf(["success", "pending", "draft", "error", "warning"]),
  testId: i.string,
  children: i.any
};
_2.defaultProps = {
  className: "",
  type: "success",
  testId: "volt-status-badge"
};
const yh = e.memo(_2), Qc = "_controlContainer_j4932_1", Kc = "_dropdown_j4932_8", Jc = "_active_j4932_20", qc = "_indicator_j4932_24", $c = "_customIcon_j4932_32", _c = "_contentContainer_j4932_42", em = "_container_j4932_67", tm = "_action_j4932_72", Ge = {
  controlContainer: Qc,
  dropdown: Kc,
  active: Jc,
  indicator: qc,
  customIcon: $c,
  contentContainer: _c,
  container: em,
  action: tm
}, nm = {
  Active: "success",
  Cleared: "success",
  Enabled: "success",
  Success: "success",
  Verified: "success",
  Provisioned: "success",
  "Decision green": "success",
  Completion: "success",
  Limited: "warning",
  Partial: "warning",
  Suspended: "warning",
  "Decision yellow": "warning",
  Pending: "pending",
  Error: "error",
  Declined: "error",
  Terminated: "error",
  Rejected: "error",
  Archived: "error",
  "Request declined": "error",
  "Decision red": "error",
  Requested: "draft",
  Closed: "draft",
  Inactive: "draft",
  Disabled: "draft",
  Unactivated: "draft",
  Unverified: "draft"
}, Tt = (r) => {
  const t = typeof r == "string" ? r.toLowerCase() : "";
  return t && t.charAt(0).toUpperCase() + t.slice(1).replace(/_/g, " ");
}, Ut = (r) => nm[Tt(r)], am = (r) => O1[Ut(r)] || {}, ct = (r) => {
  const {
    status: t,
    children: n,
    dropdownDisabled: a,
    className: l,
    testId: o,
    colorOverride: s,
    icon: d,
    type: c,
    withIcon: m
  } = r, [h, p] = z(), [u, C] = z(), [E, g] = z(), L = !!n, { color: x, icon: A } = Y(
    () => am(t),
    [t]
  ), Z = () => {
    p(!1);
  }, D = () => {
    p(!h);
  }, f = xe(null), w = xe(null), H = (j) => {
    const de = f && f.current && f.current.contains(j.target), G = w && w.current && w.current.contains(j.target);
    !de && !G && Z();
  }, b = () => {
    try {
      const j = f && f.current && f.current.getBoundingClientRect();
      if (j && j.left && j.right) {
        const { left: de, top: G } = j;
        (u !== de || E !== G) && (C(de), g(G));
      }
    } catch (j) {
      console.error(j);
    }
  };
  ee(() => (document.addEventListener("mousedown", H), typeof window < "u" && (window.addEventListener("resize", b), window.addEventListener("scroll", b)), function() {
    document.removeEventListener("mousedown", H), typeof window < "u" && (window.removeEventListener("resize", b), window.removeEventListener("scroll", b));
  }), []);
  const k = () => {
    if (!x && !s)
      return null;
    const j = {
      backgroundColor: s || x
    };
    return /* @__PURE__ */ e.createElement("div", { className: Ge.indicator, style: j });
  }, O = () => {
    if (!L || a)
      return null;
    const j = {
      marginLeft: 4
    };
    return /* @__PURE__ */ e.createElement(V, { type: "caret-down", style: j, noHoverEffects: !0 });
  }, I = () => d ? /* @__PURE__ */ e.createElement("div", { className: Ge.customIcon }, d) : c === "dot" && m && Ut(t) ? /* @__PURE__ */ e.createElement("div", { className: Ge.customIcon }, /* @__PURE__ */ e.createElement(
    V,
    {
      noHoverEffects: !0,
      type: A,
      overrideColor: x
    }
  )) : k(), T = () => {
    const j = M(Ge.controlContainer, {
      [Ge.active]: h,
      [Ge.dropdown]: L && !a
    });
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: w,
        className: j,
        "data-testid": "volt-status-indicator-control",
        onClick: !a && L ? D : void 0
      },
      I(),
      /* @__PURE__ */ e.createElement(y, null, Tt(t)),
      O()
    );
  }, te = () => {
    if (!L)
      return null;
    const G = { opacity: h ? 1 : 0, pointerEvents: h ? "auto" : "none" }, Ve = M(Ge.contentContainer, { active: h }), We = e.Children.map(
      n,
      (je) => {
        const Z3 = { closeDropdown: Z };
        return e.isValidElement(je) ? e.cloneElement(je, Z3) : je;
      }
    );
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: G,
        "data-testid": "volt-status-indicator-content",
        className: Ve,
        ref: f
      },
      We
    );
  }, re = () => {
    if (c === "dot")
      return /* @__PURE__ */ e.createElement(e.Fragment, null, T(), te());
  }, qe = () => {
    const [j, de] = c.split("pill-"), G = Ut(t) || t;
    if (de)
      return /* @__PURE__ */ e.createElement(id, { size: de, type: G, withIcon: m }, Tt(t));
  };
  return /* @__PURE__ */ e.createElement("div", { className: l, "data-testid": o }, re(), qe());
}, e0 = ({ children: r, onClick: t, closeDropdown: n }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: Ge.action,
    onClick: () => {
      t(), n && n();
    }
  },
  r
);
e0.propTypes = {
  children: i.any,
  closeDropdown: i.bool,
  onClick: i.func
};
e0.defaultProps = {
  onClick: () => {
  }
};
ct.propTypes = {
  children: i.any,
  status: i.string,
  className: i.string,
  dropdownDisabled: i.bool,
  colorOverride: i.oneOfType([i.bool, i.string]),
  icon: i.oneOfType([i.bool, i.node]),
  testId: i.string,
  type: i.oneOf(["pill-footnote", "pill-body-sm", "dot"]),
  withIcon: i.bool
};
ct.defaultProps = {
  status: "",
  className: "",
  dropdownDisabled: !1,
  colorOverride: !1,
  icon: !1,
  testId: "volt-status-indicator",
  type: "dot",
  withIcon: !1
};
ct.Action = e0;
const rm = "_tabsContainer_8ybla_1", im = "_actionToggleContainer_8ybla_6", lm = "_vtActive_8ybla_12", om = "_toggleSelect_8ybla_18", Z1 = {
  tabsContainer: rm,
  actionToggleContainer: im,
  vtActive: lm,
  toggleSelect: om
};
class y3 extends N {
  render() {
    const { activeTab: t, tabs: n, children: a, onTabChange: l, testId: o } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: Z1.tabsContainer, "data-testid": o }, /* @__PURE__ */ e.createElement("div", { className: Z1.actionToggleContainer }, n.map((s) => {
      const d = typeof s == "object" ? s.render : s, c = typeof s == "object" ? s.value : s, m = M(Z1.toggleSelect, {
        [Z1.vtActive]: d === t || t === c
      });
      return /* @__PURE__ */ e.createElement(
        "div",
        {
          "data-testid": `${o}__${d}${c === t ? "-active" : ""}`,
          key: d,
          onClick: () => l(c),
          className: m
        },
        d
      );
    })), a);
  }
}
y3.propTypes = {
  activeTab: i.string,
  tabs: i.arrayOf(i.oneOfType([i.string, i.object])),
  onTabChange: i.func,
  testId: i.string
};
y3.defaultProps = {
  onTabChange: () => {
  },
  testId: "volt-tab",
  tabs: ["Tab"],
  activeTab: "Tab"
};
const sm = "_wrap_enr8b_1", dm = "_labelWrap_enr8b_6", cm = "_textarea_enr8b_10", mm = "_noResize_enr8b_28", hm = "_errorWrap_enr8b_38", pm = "_disabled_enr8b_38", um = "_error_enr8b_38", Cm = "_errorMessage_enr8b_58", gm = "_preventErrorPushdown_enr8b_62", i1 = {
  wrap: sm,
  labelWrap: dm,
  textarea: cm,
  noResize: mm,
  errorWrap: hm,
  disabled: pm,
  error: um,
  errorMessage: Cm,
  preventErrorPushdown: gm
};
class t0 extends N {
  constructor(t) {
    super(t), this.state = {
      error: null,
      focused: !1,
      blurred: !1,
      previousValue: null
    }, this.checkIsError = this.checkIsError.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleFocus = this.handleFocus.bind(this), this.handleChange = this.handleChange.bind(this), this.controlId = this.props.id || Pe("volt-textarea_");
  }
  // lifecycle & helpers
  componentDidMount() {
    const { runIsErrorOnLoad: t } = this.props;
    t && this.checkIsError();
  }
  checkIsError() {
    const { isError: t, value: n } = this.props;
    t && this.setState({ error: t(n) });
  }
  // handlers
  handleChange(t) {
    const { onChange: n } = this.props;
    n && n(t);
  }
  handleBlur() {
    const { previousValue: t } = this.state, { value: n, onBlur: a } = this.props;
    this.setState({ focused: !1 }), t !== n && this.checkIsError(), a && a();
  }
  handleFocus() {
    const { value: t, onFocus: n } = this.props;
    this.setState({ focused: !0, previousValue: t }), n && n();
  }
  // renders
  renderTextarea() {
    const { value: t, maxLength: n, placeholder: a, disabled: l, rows: o, noResize: s, testId: d, name: c } = this.props;
    return /* @__PURE__ */ e.createElement(
      "textarea",
      {
        id: this.controlId,
        "data-testid": d,
        className: `${i1.textarea} ${l ? i1.disabled : ""} ${s ? i1.noResize : ""}`,
        name: c,
        maxLength: n,
        placeholder: a || "",
        rows: o,
        value: t || "",
        disabled: l,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onChange: this.handleChange,
        spellCheck: !1
      }
    );
  }
  getError() {
    const { error: t } = this.state, { error: n } = this.props;
    return t || n;
  }
  render() {
    const {
      width: t,
      disabled: n,
      testId: a,
      preventErrorPushdown: l,
      label: o,
      labelTooltip: s,
      sublabel: d,
      labelSize: c,
      labelOptional: m
    } = this.props, h = this.getError();
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        style: t ? { width: t } : {},
        className: `${i1.wrap} ${h ? i1.errorWrap : ""} ${n ? i1.disabledWrap : ""}`,
        "data-testid": `${a}-container`
      },
      /* @__PURE__ */ e.createElement(
        ue,
        {
          labelFor: this.controlId,
          subLabel: d,
          size: c,
          optional: m,
          tooltip: s
        },
        o
      ),
      this.renderTextarea(),
      /* @__PURE__ */ e.createElement(ae, { testId: `${a}-input-error`, preventErrorPushdown: l }, h)
    );
  }
}
t0.propTypes = {
  id: i.string,
  disabled: i.bool,
  error: i.string,
  isError: i.func,
  label: i.any,
  labelTooltip: i.node,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  maxLength: i.number,
  name: i.string,
  noResize: i.bool,
  onBlur: i.func,
  onFocus: i.func,
  onChange: i.func,
  placeholder: i.string,
  preventErrorPushdown: i.bool,
  rows: i.number,
  runIsErrorOnLoad: i.bool,
  sublabel: i.any,
  testId: i.string,
  value: i.any,
  width: i.any
};
t0.defaultProps = {
  id: null,
  label: null,
  labelTooltip: null,
  labelSize: "small",
  labelOptional: !1,
  sublabel: null,
  placeholder: null,
  value: "",
  maxLength: null,
  onChange: null,
  width: null,
  error: null,
  isError: null,
  runIsErrorOnLoad: !1,
  disabled: !1,
  rows: 4,
  noResize: !1,
  preventErrorPushdown: !1,
  testId: W.textarea,
  kind: "textarea"
};
const b3 = t0;
function A3({ children: r, testId: t, nodePointBorderColor: n }) {
  return /* @__PURE__ */ e.createElement(e.Fragment, null, r.map((a, l) => /* @__PURE__ */ e.createElement(
    it,
    {
      nodePointBorderColor: n,
      testId: t,
      key: `${t}-node-${l}`
    },
    a
  )));
}
A3.propTypes = {
  testId: i.string,
  nodePointBorderColor: i.string
};
A3.defaultProps = {
  testId: "base-timeline",
  nodePointBorderColor: "#ffffff"
};
const fm = "_toastsWrapper_1yajs_1", Em = "_toast_1yajs_1", Lm = "_showToast_1yajs_1", wm = "_hideToast_1yajs_50", vm = "_content_1yajs_54", ym = "_icon_1yajs_60", bm = "_contentText_1yajs_64", Am = "_additionalHandlerSection_1yajs_74", Hm = "_additionalHandlerSectionBtn_1yajs_78", Ue = {
  toastsWrapper: fm,
  toast: Em,
  showToast: Lm,
  hideToast: wm,
  content: vm,
  icon: ym,
  contentText: bm,
  additionalHandlerSection: Am,
  additionalHandlerSectionBtn: Hm
}, H3 = {
  ERROR: "error",
  SUCCESS: "success"
};
class x3 extends N {
  constructor(n) {
    super(n);
    Le(this, "detouch", () => {
      const { remove: n } = this.props;
      this.toastRef.current.classList.add(Ue.hideToast), this.detouchAnimationTimeoutId = setTimeout(() => n && n(), 400);
    });
    Le(this, "getIcon", () => {
      const { icon: n } = this.props;
      if (n) {
        if (typeof n == "string")
          return H3.ERROR === n ? /* @__PURE__ */ e.createElement(V, { type: "close", mod: "error", noHoverEffects: !0 }) : /* @__PURE__ */ e.createElement(V, { type: "check", overrideColor: "#3DB65C", noHoverEffects: !0 });
        if (typeof n == "object")
          return n;
      }
    });
    this.toastRef = e.createRef();
    const a = n.dismissTime * 1e3 || 6e3;
    this.detouchTimeoutId = setTimeout(() => this.detouch(), a);
  }
  componentWillUnmount() {
    this.detouchTimeoutId && clearTimeout(this.detouchTimeoutId), this.detouchAnimationTimeoutId && clearTimeout(this.detouchAnimationTimeoutId);
  }
  render() {
    const { testId: n, children: a, actionHandler: l, action: o } = this.props;
    return /* @__PURE__ */ e.createElement("div", { className: Ue.toastsWrapper }, /* @__PURE__ */ e.createElement("div", { className: Ue.toast, "data-testid": n, ref: this.toastRef }, /* @__PURE__ */ e.createElement("div", { className: Ue.content }, /* @__PURE__ */ e.createElement("div", { className: Ue.icon }, this.getIcon()), /* @__PURE__ */ e.createElement("div", { className: Ue.contentText, "data-testid": `toast-${n}-text` }, a), o === "" && !l && /* @__PURE__ */ e.createElement(B, { factor: 2 })), l && (o || o === "") && /* @__PURE__ */ e.createElement("div", { className: Ue.additionalHandlerSection }, /* @__PURE__ */ e.createElement(
      "button",
      {
        className: Ue.additionalHandlerSectionBtn,
        onClick: l,
        "data-testid": `toast-${n}-button`
      },
      o
    ))));
  }
}
x3.propTypes = {
  icon: i.oneOfType([i.string, i.node]),
  actionHandler: i.func,
  action: i.oneOfType([i.string, i.node]),
  remove: i.func,
  dismissTime: i.number,
  testId: i.string,
  children: i.string
};
x3.defaultProps = {
  icon: H3.SUCCESS,
  actionHandler: null,
  action: "Undo",
  remove: null,
  dismissTime: 6,
  testId: "volt-toastid",
  children: ""
};
const xm = {
  pan: "•••• •••• •••• ••••",
  ssn: "•••-••-••••",
  sin: "•••-•••-•••",
  tin: "•••-••-••••",
  nin: "•• •• •• •• •",
  expiryDate: "••/••"
}, M3 = (r) => r.replace("/D/g", ""), V3 = (r) => r.match(/.{1,4}/g).join(" "), Mm = (r) => r.replace(/^(.{3})(.{2})(.{4})$/, "$1-$2-$3"), Vm = (r) => r.replace(/^(.{3})(.{3})(.{3})$/, "$1-$2-$3"), Dm = (r) => r.replace(/^(.{3})(.{2})(.{4})$/, "$1-$2-$3"), Fm = (r) => r.replace(/^(.{2})(.{2})(.{2})(.{2})(.{1})$/, "$1 $2 $3 $4 $5"), km = (r) => r.replace(/^(.{2})(.{2})$/, "$1/$2"), Zm = (r) => r.replace(/./g, "•"), Bm = ({ formatting: r, text: t = "" }) => {
  const n = M3(t);
  switch (r) {
    case "pan":
      return V3(n);
    case "ssn":
      return Mm(n);
    case "sin":
      return Vm(n);
    case "tin":
      return Dm(n);
    case "nin":
      return Fm(n);
    case "expiryDate":
      return km(n);
    default:
      return t;
  }
}, Om = ({ formatting: r, text: t = "", abbreviate: n }) => {
  if (r === "pan") {
    if (n)
      return Im({ text: t, abbreviate: n });
  } else {
    if (r === "ssn" && n)
      return Gt(t);
    if (n === "lastFour")
      return Gt(t);
  }
  return xm[r] || Zm(t);
};
function Sm(r) {
  const [t, n] = z(r), [a, l] = z(), o = xe(r);
  return ee(() => {
    if (r && !o.current) {
      n(!0);
      const s = setTimeout(() => {
        n(!1);
      }, 2e3);
      l(s);
    }
    return () => clearTimeout(a);
  }, [r, t, o]), ee(() => {
    o.current = r;
  }, [o, r]), t;
}
function Im({ text: r, abbreviate: t }) {
  if (t === "min" || t === "lastFour")
    return Gt(r);
  const n = M3(r), a = `${n.substr(0, 6)}••••••${n.substr(
    n.length - 4,
    n.length - 1
  )}`;
  return V3(a);
}
function Gt(r) {
  return `••${r.substr(r.length - 4, Math.max(r.length, r.length - 1))}`;
}
const Pm = ({ show: r, value: t, formatting: n, abbreviate: a, labelledBy: l }) => {
  const o = Y(() => r ? Bm({ formatting: n, text: t }) : Om({ formatting: n, text: t, abbreviate: a }), [r, t, n, a]);
  return /* @__PURE__ */ e.createElement(y, { labelledBy: l }, o);
}, D3 = ({
  abbreviate: r,
  async: t,
  error: n,
  formatting: a,
  id: l,
  labelledBy: o,
  loading: s,
  onClick: d,
  readOnly: c,
  value: m
}) => {
  const [h, p] = z(t), [u, C] = z("show"), E = xe(s), g = Sm(n), L = Y(() => u === "hide", [u]);
  ee(() => {
    p(t);
  }, [t, p]), P0(() => {
    C(g ? "danger" : "show");
  }, [g, C]), ee(() => {
    !s && E.current && !n && (p(!1), C("hide")), E.current = s;
  }, [s, E, p, g]);
  const x = (A) => {
    h || C(u === "show" ? "hide" : "show"), d && d(A);
  };
  return /* @__PURE__ */ e.createElement(P, { flexDirection: "row", alignItems: "center" }, !c && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(ze, { active: s, borderRadius: "extra-small" }, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", alignItems: "center" }, /* @__PURE__ */ e.createElement(
    V,
    {
      type: u,
      onClick: x,
      mod: u === "danger" ? "error" : "default",
      noHoverEffects: u === "danger"
    }
  ))), /* @__PURE__ */ e.createElement(B, { factor: 1 })), /* @__PURE__ */ e.createElement(
    Pm,
    {
      abbreviate: r,
      formatting: a,
      show: L,
      value: m,
      id: l,
      labelledBy: o
    }
  ));
};
D3.propTypes = {
  abbreviate: i.oneOf(["max", "min", "lastFour", ""]),
  async: i.bool,
  error: i.bool,
  formatting: i.oneOf([
    "pan",
    "ssn",
    "sin",
    "tin",
    "nin",
    "expiryDate",
    void 0
  ]),
  id: i.string,
  labelledBy: i.string,
  loading: i.bool,
  onClick: i.func,
  readOnly: i.bool,
  value: i.string
};
D3.defaultProps = {
  abbreviate: "",
  async: !1,
  error: !1,
  loading: !1,
  value: ""
};
const Nm = "_toggle_18fvm_1", Rm = "_disabled_18fvm_11", Tm = "_activeError_18fvm_15", Um = "_inactiveError_18fvm_19", Gm = "_toggleKnob_18fvm_23", zm = "_shadow_18fvm_34", Wm = "_changed_18fvm_40", jm = "_completed_18fvm_40", Xm = "_newActionCard_18fvm_40", Ym = "_activeDisabled_18fvm_44", Qm = "_active_18fvm_15", Km = "_verticalAlign_18fvm_60", Jm = "_wrap_18fvm_65", qm = "_errorMessage_18fvm_75", se = {
  toggle: Nm,
  disabled: Rm,
  activeError: Tm,
  inactiveError: Um,
  toggleKnob: Gm,
  shadow: zm,
  changed: Wm,
  completed: jm,
  newActionCard: Xm,
  activeDisabled: Ym,
  active: Qm,
  verticalAlign: Km,
  wrap: Jm,
  errorMessage: qm
};
class n0 extends j1 {
  constructor(n) {
    super(n);
    Le(this, "handleClick", (n) => {
      const { disabled: a, onClick: l } = this.props;
      a || l(n);
    });
    Le(this, "handleKeyPress", (n) => {
      n.key === qt.Space && (n.preventDefault(), this.handleClick(n));
    });
    this.shouldComponentUpdate = _t.bind(this);
  }
  renderLabel() {
    const { label: n, subLabel: a, labelSize: l, labelOptional: o, labelTooltip: s, testId: d, onClick: c, disabled: m } = this.props;
    return n ? /* @__PURE__ */ e.createElement("div", { onClick: m ? void 0 : c, "data-testid": `${d}-toggle-label-wrapper` }, /* @__PURE__ */ e.createElement(
      ue,
      {
        labelFor: `${d}-toggle`,
        subLabel: a,
        size: l,
        optional: o,
        tooltip: s
      },
      n
    ), /* @__PURE__ */ e.createElement(F, { factor: 0.5 })) : null;
  }
  renderErrorMessage() {
    const { error: n } = this.props;
    return /* @__PURE__ */ e.createElement(ae, null, n);
  }
  render() {
    const { active: n, color: a, label: l, testId: o, type: s, children: d, disabled: c, hasChangedType: m } = this.props, h = s === "error", p = {
      backgroundColor: a || v.actionColorDarker2
    }, u = d.length === 1 ? d[0] : d;
    return /* @__PURE__ */ e.createElement("div", { className: se.verticalAlign }, this.renderLabel(), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: M(se.wrap, { [se.disabled]: c }),
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          id: `${o}-toggle`,
          style: n && !h ? p : null,
          className: `${se.toggle} ${c ? se.disabled : ""}
              ${m ? se[m] : ""} ${!c && n ? se.active : c && n ? se.activeDisabled : ""} ${h ? c ? "" : n ? se.activeError : se.inactiveError : ""}`,
          "data-testid": o,
          role: "checkbox",
          "aria-checked": n,
          "aria-label": l
        },
        /* @__PURE__ */ e.createElement(
          "div",
          {
            className: `${se.toggleKnob} ${c ? se.disabled : ""} ${m ? se[m] : ""} ${!c && se.shadow}`,
            tabIndex: c ? void 0 : 0
          }
        )
      ),
      /* @__PURE__ */ e.createElement(B, { factor: 1 }),
      /* @__PURE__ */ e.createElement(
        c1,
        {
          noPadding: !0,
          testId: "toggle-change-indicator",
          hasChangedType: m,
          style: { fontWeight: "normal" },
          textType: "body-sm",
          textColor: v.blackLighter3
        },
        an(u, { color: v.blackLighter3 })
      )
    ), this.renderErrorMessage());
  }
}
n0.propTypes = {
  active: i.bool,
  children: i.node,
  color: i.string,
  disabled: i.bool,
  error: i.string,
  hasChangedType: i.oneOf(["changed", "completed"]),
  label: i.node,
  subLabel: i.any,
  labelSize: i.oneOf(["small", "large"]),
  labelOptional: i.bool,
  labelTooltip: i.any,
  onClick: i.func,
  testId: i.string,
  type: i.string
};
n0.defaultProps = {
  active: !1,
  children: "",
  color: v.actionColorDarker2,
  disabled: !1,
  error: "",
  hasChangedType: null,
  kind: "toggle",
  label: "",
  subLabel: null,
  labelSize: "small",
  labelOptional: !1,
  labelTooltip: null,
  testId: W.toggle,
  type: "default"
};
const F3 = n0, $m = "_list_1mgxc_1", _m = "_item_1mgxc_8", eh = "_itemTime_1mgxc_14", th = "_itemAction_1mgxc_22", nh = "_itemActive_1mgxc_29", f1 = {
  list: $m,
  item: _m,
  itemTime: eh,
  itemAction: th,
  itemActive: nh
}, ah = ({ item: r, isActive: t = !1, onClick: n }) => {
  const { time: a, action: l } = r;
  let o = M({
    [f1.item]: !0,
    [f1.itemActive]: t
  }), s = () => {
    t || n(r);
  };
  return /* @__PURE__ */ e.createElement("li", { className: o, role: "option", onClick: s }, /* @__PURE__ */ e.createElement("div", { className: f1.itemTime }, a), /* @__PURE__ */ e.createElement("div", { className: f1.itemAction }, l));
}, rh = ({
  versions: r = [],
  activeVersion: t,
  onItemClick: n,
  style: a = {},
  testId: l = "version-history"
}) => /* @__PURE__ */ e.createElement("ol", { className: f1.list, role: "listbox", style: a, "data-testid": l }, r.map((o, s) => {
  const d = o === t, c = o.id || s;
  return /* @__PURE__ */ e.createElement(ah, { item: o, key: c, isActive: d, onClick: n });
})), S0 = i.shape({
  id: i.oneOf([i.string, i.number]),
  time: i.string.isRequired,
  action: i.string.isRequired
});
rh.propTypes = {
  versions: i.arrayOf(S0),
  activeVersion: S0,
  style: i.object,
  testId: i.string
};
const ih = "_wrap_1nn4p_1", lh = "_titleElement_1nn4p_14", oh = "_actionButtons_1nn4p_18", sh = "_onCloseIcon_1nn4p_23", B1 = {
  wrap: ih,
  titleElement: lh,
  actionButtons: oh,
  onCloseIcon: sh
}, dh = {
  OPEN: "pending",
  CANCELLED: "incomplete",
  REJECTED: "rejected",
  APPROVED: "approved"
}, I0 = {
  OPEN: "lock",
  CANCELLED: "warning",
  REJECTED: "clear",
  APPROVED: "confirmed"
}, ch = ({ workspaceTitle: r, subTitle: t, hasChangedType: n, requestState: a }) => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", alignItems: "center" }, typeof r == "string" ? /* @__PURE__ */ e.createElement(y, { type: "h5" }, r) : r, a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(B, { factor: 1 }), /* @__PURE__ */ e.createElement(
  c1,
  {
    style: { textTransform: "capitalize" },
    icon: I0[a] && `${I0[a]}`,
    hasChangedType: n
  },
  dh[a]
))), /* @__PURE__ */ e.createElement(y, { type: "footnote" }, t)), k3 = ({
  actionButtons: r,
  onClose: t,
  leftOffset: n,
  workspaceTitle: a,
  subTitle: l,
  hasChangedType: o,
  requestState: s,
  testId: d
}) => {
  const c = /* @__PURE__ */ e.createElement(V, { type: "close" }), m = r.length > 1 ? "tertiary" : "primary", h = r.map(
    ({ text: u, onClick: C, highlight: E, type: g, disabled: L }, x) => {
      const A = E ? "secondary" : m;
      return /* @__PURE__ */ e.createElement(e.Fragment, { key: u }, /* @__PURE__ */ e.createElement(
        J,
        {
          type: g || A,
          disabled: L,
          onClick: C,
          testId: "action-button",
          autoFocus: x === 0
        },
        u
      ), x < r.length - 1 ? /* @__PURE__ */ e.createElement(B, { factor: 2 }) : null);
    }
  ), p = {
    left: n,
    width: `calc(100% - ${n}px)`
  };
  return /* @__PURE__ */ e.createElement("div", { className: B1.wrap, style: p, "data-testid": d }, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", justifyContent: "space-between" }, /* @__PURE__ */ e.createElement("div", { className: B1.titleElement }, /* @__PURE__ */ e.createElement(
    ch,
    {
      requestState: s,
      workspaceTitle: a,
      subTitle: l,
      hasChangedType: o
    }
  )), /* @__PURE__ */ e.createElement("div", { className: B1.actionButtons }, /* @__PURE__ */ e.createElement(P, { flexDirection: "row", testId: `${d}-actionButtons` }, h, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: B1.onCloseIcon,
      onClick: t,
      onKeyPress: (u) => {
        u.preventDefault(), t();
      },
      tabIndex: 0,
      "aria-label": "Close"
    },
    c
  )))), /* @__PURE__ */ e.createElement(B, { factor: 1 }));
};
k3.propTypes = {
  workspaceTitle: i.any,
  subTitle: i.string,
  actionButtons: i.array,
  leftOffset: i.number,
  onClose: i.func.isRequired,
  hasChangedType: i.oneOf(["changed", "completed"]),
  requestState: i.string,
  testId: i.string
};
k3.defaultProps = {
  subTitle: "",
  actionButtons: [],
  leftOffset: 0,
  hasChangedType: null,
  testId: "workspaceHeader"
};
export {
  T0 as Accordion,
  fh as ActionCard,
  r2 as ActionDropdown,
  W0 as Activity,
  X0 as Address,
  Y0 as Admonition,
  Q0 as Alert,
  K0 as BannerAlert,
  J0 as BoxContainer,
  q0 as Breadcrumbs,
  d2 as BulletedList,
  J as Button,
  _0 as ButtonToggle,
  en as Card,
  e3 as CardHoverCard,
  c1 as ChangeIndicator,
  s1 as Checkbox,
  nn as CheckboxGroup,
  u2 as Col,
  Hh as Colors,
  ln as Container,
  rn as ContainerContext,
  on as ContentSnippet,
  K1 as ControlledRawDropdown,
  y1 as CopyToClipboard,
  sn as CountrySelect,
  dn as CurrencySelect,
  cn as DayPicker,
  Eh as DetailPane,
  f2 as DotIndicator,
  Cn as Drawer,
  Lh as Dropdown,
  w2 as EmptyState,
  gn as ErrorModal,
  fn as FilePreview,
  En as FilePreviewActions,
  Ln as FilePreviewFooter,
  wn as FilePreviewHeader,
  vn as FilePreviewName,
  yn as FileUpload,
  bn as FlatCard,
  P as Flex,
  Y1 as FocusTrap,
  jn as Form,
  Kn as FormChangeSummary,
  ae as FormError,
  ue as FormLabel,
  qn as GlobalAlert,
  Jn as GlobalAlertDeprecated,
  B as HSpacer,
  $n as History,
  _n as HoverCard,
  C9 as Hr,
  V as Icon,
  vh as IconOptions,
  n3 as ImageAsset,
  me as Input,
  a3 as InputSelectGroup,
  r3 as Label,
  T2 as LabeledContent,
  Ne as Link,
  s3 as List,
  ze as LoadingOverlay,
  z2 as Logo,
  d3 as MarqetaCard,
  j2 as Metrics,
  ot as Modal,
  h3 as ModalAlert,
  p3 as Multiselect,
  u3 as NavTabs,
  X2 as NumberedList,
  st as OnPageError,
  g3 as PageLoader,
  Gn as PhoneInput,
  id as Pill,
  f3 as Popover,
  b1 as Portal,
  t3 as ProfileHoverCard,
  E3 as ProgressBar,
  q2 as Radio,
  L3 as RadioGroup,
  Md as RadioGroupItem,
  v2 as RawDropdown,
  wh as RegisterFormChildren,
  R1 as Row,
  w3 as SegmentedButtons,
  dt as Select,
  v3 as SplitButton,
  yh as StatusBadge,
  ct as StatusIndicator,
  y3 as Tabs,
  y as Text,
  b3 as Textarea,
  A3 as Timeline,
  x3 as ToastAlert,
  F3 as Toggle,
  D3 as ToggleVisibility,
  Me as Tooltip,
  F as VSpacer,
  rh as VersionHistory,
  k3 as WorkspaceHeader,
  H7 as checkValidInternationalPhoneNumber,
  M as classUtil,
  Ct as countryCodeList,
  g9 as imagesList,
  V0 as toggleValue
};
